import '@oneclick/react-lemonade-editor/dist/index.css';
import 'react-medium-image-zoom/dist/styles.css';
import 'swiper/swiper-bundle.min.css';
import React__default, { useState, useEffect, createElement, useRef, useCallback, useReducer, useMemo, forwardRef, useImperativeHandle, Component } from 'react';
import { useTranslation as useTranslation$1, initReactI18next, I18nextProvider } from 'react-i18next';
import ReactDOM, { createPortal } from 'react-dom';
import { usePopper } from 'react-popper';
import { Navigation, Pagination, Controller } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import rangy from 'rangy';
import { v4 } from 'uuid';
import { Controlled } from 'react-medium-image-zoom';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player/lazy';
import { renderToString } from 'react-dom/server';
import { getDefaultData, observer, setConfig, useLemonadeQuestion, getConfig, Lemonade, types, isFeedbackQuestionType } from '@oneclick/react-lemonade-editor';
import classNames from 'classnames';
import VisibilitySensor from 'react-visibility-sensor';
import { CircularProgressbar } from 'react-circular-progressbar';
import { useNavigate, useParams, HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { Element as Element$1, scroller } from 'react-scroll';
import { useToasts, ToastProvider } from 'react-toast-notifications';
import ReactSelect, { components } from 'react-select';
import makeAnimated from 'react-select/animated';
import { useDropzone } from 'react-dropzone';
import 'font-awesome/css/font-awesome.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/js/languages/es.js';
import 'froala-editor/js/plugins/align.min.js';
import 'froala-editor/js/plugins/char_counter.min.js';
import 'froala-editor/js/plugins/code_beautifier.min.js';
import 'froala-editor/js/plugins/code_view.min.js';
import 'froala-editor/js/plugins/colors.min.js';
import 'froala-editor/js/plugins/draggable.min.js';
import 'froala-editor/js/plugins/font_size.min.js';
import 'froala-editor/js/plugins/image.min.js';
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/plugins/paragraph_style.min.js';
import 'froala-editor/js/plugins/quick_insert.min.js';
import 'froala-editor/js/plugins/table.min.js';
import 'froala-editor/js/plugins/video.min.js';
import FroalaEditorInput from 'react-froala-wysiwyg';
import FroalaEditor from 'froala-editor';
import reactCSS from 'reactcss';
import { SketchPicker } from 'react-color';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Draggable$1 from 'react-draggable';
import Dropdown from 'react-multilevel-dropdown';
import posed, { PoseGroup } from 'react-pose';

function ignoreSomeWarning() {
  var backup = console.warn;
  console.warn = function filterWarnings(msg) {
    try {
      // == TODO: En un futuro intentar solventar estos warning de raiz
      var supressedWarnings = ['[MobX] Since strict-mode is enabled, changing (observed)', './src/_mint/services/readJsonData.services.ts' // == Critical dependency: the request of a dependency is an expression
      ];

      if (!supressedWarnings.some(function (entry) {
        return msg.includes(entry);
      })) {
        console.log(msg);
        // @ts-ignore
        backup.apply(console, arguments);
      }
    } catch (error) {
      backup.apply(console, arguments);
    }
  };
}
function parse(str) {
  var args = [].slice.call(arguments, 1),
    i = 0;
  return str.replace(/%s/g, function () {
    return args[i++];
  });
}
function ignoreSomeError() {
  var backup = console.error;
  console.error = function filterErrors(msg) {
    try {
      // == TODO: En un futuro intentar solventar estos errores de raiz
      var supressedErrors = ['Warning: findDOMNode is deprecated in StrictMode. findDOMNode was passed an instance of VisibilitySensor', 'Warning: Cannot update a component (`FileUploaderStore`) while rendering a different component (`LemonadeQuestion`)', 'at ObservableObject@1470.instance.Question' // == index.js:1 Warning: Can't perform a React state update on an unmounted component. This is a no-op, but it indicates a memory leak in your application. To fix, cancel all subscriptions and asynchronous tasks in a useEffect cleanup function.
      ];

      var msgWithArguments = parse.apply(msg, arguments);
      if (!supressedErrors.some(function (entry) {
        return msgWithArguments.includes(entry);
      })) {
        // @ts-ignore
        backup.apply(console, arguments);
      }
    } catch (error) {
      backup.apply(console, arguments);
    }
  };
}
function ignoreSomeErrorAndWarning() {
  ignoreSomeWarning();
  ignoreSomeError();
}

var currentVersion = '1.3.85 - 2025-08-21T07:31:48.751Z';

/* eslint-disable */
function printMintVersion() {
  var message = "MINT v" + currentVersion + "       ~ OneClick.es";
  console.log(message);
}

/**
 * Devuelve true si el nameFile tiene la ruta entera del fichero
 * @param nameFile
 */
function isFileNamePathFull(nameFile) {
  return nameFile && /^(f|ht)tps?:\/\//i.test(nameFile);
}
/**
 * Devuelve el src que establecer a la imagen
 * @param nameFile Nombre del fichero, por ejemplo pluma.jpg
 */
function getSrcParam(nameFile, pathAssets) {
  if (!nameFile) return nameFile;
  if (nameFile.startsWith('data:')) return nameFile;
  if (!isFileNamePathFull(nameFile)) {
    return pathAssets + nameFile;
  } else return nameFile;
}
/**
 * Devuelve el src que establecer a la imagen
 * @param nameFile Nombre del fichero, por ejemplo pluma.jpg
 * @param pathAssets Ruta de los assets.
 * @param prefixFilePrivate Prefijo de los ficheros privados. Ejemplo: 'files-storage/open'
 * @param pathPrivateAssets Ruta de los assets privados. Ejemplo 'https://edelvivesdigital-dev.oneclicklabs.es' + '/'
 * @param token Token de autenticación
 */
function getSrcParamTangerine(nameFile, pathAssets, prefixFilePrivate, pathPrivateAssets, token) {
  if (!nameFile) return nameFile;
  if (nameFile.startsWith(prefixFilePrivate)) {
    // == Es privado
    return pathPrivateAssets + nameFile + '?token=' + token;
  } else {
    return getSrcParam(nameFile, pathAssets);
  }
}

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return {
          value: void 0,
          done: !0
        };
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable || "" === iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    throw new TypeError(typeof iterable + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var IMathRenderEngine;
(function (IMathRenderEngine) {
  IMathRenderEngine["MATHJAX"] = "mathjax";
  IMathRenderEngine["KATEX"] = "katex";
})(IMathRenderEngine || (IMathRenderEngine = {}));

var FROALA3_LECENSE_KEY = 'lSA3D-17C1E1F2H2F2I1rXYb1VPUGRHYZNRJd1JVOOb1HAc1zG2B1A2B2D6B1B2C4F1D3==';
var MULTIPLIER_FACTOR_PADDING = 10;
var ASSETS_DEFAULT_DOMAIN = 'https://mint-assets.oneclick.es';
var MINT_WRAPPER_CLASS = 'mint-lesson';
var ID_LESSON_VISOR = 'mint-lesson-visor';
var LANGS_SUPPORT = ['en', 'es', 'ca', 'gl', 'eu', 'vl', 'pt'];
var MATH_RENDER_ENGINE_DEFAUT = IMathRenderEngine.MATHJAX;
var MAX_COLUMNS_ALLOWED = 4;

var IStyleTypesItemBlockOptions;
(function (IStyleTypesItemBlockOptions) {
  /** DEFAULT: es el estilo original, donde estan las opciones flotando a izquierda y derecha y los signos más arriba y abajo del item */
  IStyleTypesItemBlockOptions["DEFAULT"] = "default";
  /** INLINE: es el estilo notion, tiene a la izquierda el botón de más y al lado tienes otro boton de menú donde se encuentran el resto de opciones del item */
  IStyleTypesItemBlockOptions["INLINE"] = "inline";
})(IStyleTypesItemBlockOptions || (IStyleTypesItemBlockOptions = {}));

var KEY_LOCAL_STORAGE_FAVORITE_COLORS = 'favoriteColors';
function getDefaultConfigFavoriteColors() {
  function setPersistFavoriteColors(colors) {
    if (isLocalStorageAvailable()) {
      localStorage.setItem(KEY_LOCAL_STORAGE_FAVORITE_COLORS, JSON.stringify(colors));
    }
  }
  function getPersistFavoriteColors() {
    var storedColors = [];
    if (isLocalStorageAvailable()) {
      var itemString = localStorage.getItem(KEY_LOCAL_STORAGE_FAVORITE_COLORS);
      if (itemString) {
        storedColors = JSON.parse(itemString);
      }
    }
    return storedColors;
  }
  function isLocalStorageAvailable() {
    var test = 'test_-_';
    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  }
  return {
    getFavoriteColors: function getFavoriteColors(success, error) {
      var storedFavoriteColors = getPersistFavoriteColors();
      success(storedFavoriteColors);
    },
    setFavoriteColors: function setFavoriteColors(colors, success, error) {
      setPersistFavoriteColors(colors);
      success(colors);
    }
  };
}

var SubjectConfigGlobal = /*#__PURE__*/function () {
  function SubjectConfigGlobal() {
    this.observers = new Set();
  }
  var _proto = SubjectConfigGlobal.prototype;
  _proto.subscribe = function subscribe(observer) {
    this.observers.add(observer);
  };
  _proto.unsubscribe = function unsubscribe(observer) {
    this.observers.delete(observer);
  };
  _proto.notify = function notify(propertiesChanged) {
    this.observers.forEach(function (observer) {
      observer.update(propertiesChanged);
    });
  };
  return SubjectConfigGlobal;
}();

/** Configuracion global que la puede inicializar por parte host */
var ConfigGlobalSingleton = /*#__PURE__*/function (_SubjectConfigGlobal) {
  function ConfigGlobalSingleton() {
    var _this;
    _this = _SubjectConfigGlobal.apply(this, arguments) || this;
    _this.pathAssets = ''; // Acabada en / o puede ser cadena vacia
    _this.folderBlockDefault = 'mintcontent/assets/block-defaults';
    _this.lang = 'es';
    _this.langsSupport = LANGS_SUPPORT;
    _this.pathEmbedApi = 'https://metascraper-mint.oneclick.es/api/metadata?url=';
    _this.configFavoriteColors = getDefaultConfigFavoriteColors();
    _this.favoriteColors = [];
    _this.showLessonTitles = false;
    _this.assetsEditorApi = '';
    _this.repeatActivityEnabled = true;
    _this.scormEnabled = false;
    _this.mathRenderEngine = MATH_RENDER_ENGINE_DEFAUT;
    _this.hideWaitingResponseOfflineActivity = true;
    _this.styleTypeItemBlockOptions = IStyleTypesItemBlockOptions.DEFAULT;
    _this.addClassSpanBackgroundsEditor = undefined;
    _this.addClassSpanBackgroundsVisor = undefined;
    _this.showAdditionalContentsSubItemEditor = false;
    _this.showAdditionalContentsSubItemVisor = false;
    _this.getSrc = undefined;
    _this.backgroundVisor = undefined;
    _this.uiStyles = undefined;
    _this.enableRowColumnLayout = false;
    _this.isSinglePost = false;
    _this.enablePopups = false;
    _this.enableTextTooltips = false;
    _this.version = undefined;
    _this.enableBackgroundGradient = false;
    _this.canCreateFeedbackActivities = false;
    _this.showSettingsActivity = false;
    _this.showSettingsActivityIntelligeTag = false;
    return _this;
  }
  /**
   * @returns {ConfigGlobalSingleton}
   */
  _inheritsLoose(ConfigGlobalSingleton, _SubjectConfigGlobal);
  ConfigGlobalSingleton.getInstance = function getInstance() {
    if (ConfigGlobalSingleton.myInstance == null) {
      // @ts-ignore
      ConfigGlobalSingleton.myInstance = new ConfigGlobalSingleton();
    }
    // @ts-ignore
    return this.myInstance;
  }
  /**
   * Sin la barra del final
   */;
  var _proto = ConfigGlobalSingleton.prototype;
  _proto.getPathAssets = function getPathAssets() {
    return this.pathAssets;
  }
  /**
   *
   * @param pathAssets
   */;
  _proto.setPathAssets = function setPathAssets(pathAssets) {
    this.pathAssets = pathAssets;
    this.notify({
      pathAssets: pathAssets
    });
  };
  _proto.getAssetsEditorApi = function getAssetsEditorApi() {
    return this.assetsEditorApi;
  }
  /**
   *
   * @param pathAssets
   */;
  _proto.setAssetsEditorApi = function setAssetsEditorApi(assetsEditorApi) {
    this.assetsEditorApi = assetsEditorApi;
    this.notify({
      assetsEditorApi: assetsEditorApi
    });
  };
  _proto.getPathEmbedApi = function getPathEmbedApi() {
    return this.pathEmbedApi;
  }
  /**
   *
   * @param pathEmbedApi
   */;
  _proto.setPathEmbedApi = function setPathEmbedApi(pathEmbedApi) {
    if (pathEmbedApi) {
      this.pathEmbedApi = pathEmbedApi;
      this.notify({
        pathEmbedApi: pathEmbedApi
      });
    }
  };
  _proto.getFolderBlockDefault = function getFolderBlockDefault() {
    return this.folderBlockDefault;
  };
  _proto.setFolderBlockDefault = function setFolderBlockDefault(folderBlockDefault) {
    this.folderBlockDefault = folderBlockDefault;
    this.notify({
      folderBlockDefault: folderBlockDefault
    });
  };
  _proto.getLang = function getLang() {
    return this.lang;
  };
  _proto.setLang = function setLang(lang) {
    if (this.langsSupport.indexOf(lang) > -1) {
      this.lang = lang;
      this.notify({
        lang: lang
      });
    }
  };
  _proto.getEventsVisor = function getEventsVisor() {
    return this.eventsVisor;
  };
  _proto.setEventsVisor = function setEventsVisor(eventsVisor) {
    this.eventsVisor = eventsVisor;
    this.notify({
      eventsVisor: eventsVisor
    });
  };
  _proto.getEventsEditor = function getEventsEditor() {
    return this.eventsEditor;
  };
  _proto.setEventsEditor = function setEventsEditor(eventsEditor) {
    this.eventsEditor = eventsEditor;
    this.notify({
      eventsEditor: eventsEditor
    });
  };
  _proto.getOffsetVisibilityPost = function getOffsetVisibilityPost() {
    return this.offsetVisibilityPost;
  };
  _proto.setOffsetVisibilityPost = function setOffsetVisibilityPost(offsetVisibilityPost) {
    this.offsetVisibilityPost = offsetVisibilityPost;
    this.notify({
      offsetVisibilityPost: offsetVisibilityPost
    });
  };
  _proto.getOffsetVisibilityItemBlock = function getOffsetVisibilityItemBlock() {
    return this.offsetVisibilityItemBlock;
  };
  _proto.setOffsetVisibilityItemBlock = function setOffsetVisibilityItemBlock(offsetVisibilityItemBlock) {
    this.offsetVisibilityItemBlock = offsetVisibilityItemBlock;
    this.notify({
      offsetVisibilityItemBlock: offsetVisibilityItemBlock
    });
  };
  _proto.getGoogleApi = function getGoogleApi() {
    return this.googleApi;
  };
  _proto.setGoogleApi = function setGoogleApi(googleApi) {
    this.googleApi = googleApi;
    this.notify({
      googleApi: googleApi
    });
  };
  _proto.getConfigFavoriteColors = function getConfigFavoriteColors() {
    return this.configFavoriteColors;
  };
  _proto.setConfigFavoriteColors = function setConfigFavoriteColors(configFavoriteColors) {
    this.configFavoriteColors = configFavoriteColors;
    this.notify({
      configFavoriteColors: configFavoriteColors
    });
  };
  _proto.getFavoriteColors = function getFavoriteColors() {
    return this.favoriteColors;
  };
  _proto.setFavoriteColors = function setFavoriteColors(colors) {
    this.favoriteColors = colors;
    this.notify({
      favoriteColors: colors
    });
  };
  _proto.isShowLessonTitles = function isShowLessonTitles() {
    return this.showLessonTitles;
  };
  _proto.setShowLessonTitles = function setShowLessonTitles(showLessonTitles) {
    this.showLessonTitles = showLessonTitles;
    this.notify({
      showLessonTitles: showLessonTitles
    });
  };
  _proto.isRepeatActivityEnabled = function isRepeatActivityEnabled() {
    return this.repeatActivityEnabled;
  };
  _proto.setRepeatActivityEnabled = function setRepeatActivityEnabled(repeatActivityEnabled) {
    this.repeatActivityEnabled = repeatActivityEnabled;
    this.notify({
      repeatActivityEnabled: repeatActivityEnabled
    });
  };
  _proto.isScormEnabled = function isScormEnabled() {
    return this.scormEnabled;
  };
  _proto.setScormEnabled = function setScormEnabled(scormEnabled) {
    this.scormEnabled = scormEnabled;
    this.notify({
      scormEnabled: scormEnabled
    });
  };
  _proto.getMathRenderEngine = function getMathRenderEngine() {
    return this.mathRenderEngine;
  };
  _proto.setMathRenderEngine = function setMathRenderEngine(mathRenderEngine) {
    this.mathRenderEngine = mathRenderEngine;
    this.notify({
      mathRenderEngine: mathRenderEngine
    });
  };
  _proto.isHideWaitingResponseOfflineActivity = function isHideWaitingResponseOfflineActivity() {
    return this.hideWaitingResponseOfflineActivity;
  };
  _proto.setHideWaitingResponseOfflineActivity = function setHideWaitingResponseOfflineActivity(hideWaitingResponseOfflineActivity) {
    this.hideWaitingResponseOfflineActivity = hideWaitingResponseOfflineActivity;
    this.notify({
      hideWaitingResponseOfflineActivity: hideWaitingResponseOfflineActivity
    });
  };
  _proto.getStyleTypeItemBlockOptions = function getStyleTypeItemBlockOptions() {
    return this.styleTypeItemBlockOptions;
  };
  _proto.setStyleTypeItemBlockOptions = function setStyleTypeItemBlockOptions(styleTypeItemBlockOptions) {
    this.styleTypeItemBlockOptions = styleTypeItemBlockOptions;
    this.notify({
      styleTypeItemBlockOptions: styleTypeItemBlockOptions
    });
  };
  _proto.getAddClassSpanBackgroundsEditor = function getAddClassSpanBackgroundsEditor() {
    return this.addClassSpanBackgroundsEditor;
  };
  _proto.setAddClassSpanBackgroundsEditor = function setAddClassSpanBackgroundsEditor(addClassSpanBackgroundsEditor) {
    this.addClassSpanBackgroundsEditor = addClassSpanBackgroundsEditor;
    this.notify({
      addClassSpanBackgroundsEditor: addClassSpanBackgroundsEditor
    });
  };
  _proto.getAddClassSpanBackgroundsVisor = function getAddClassSpanBackgroundsVisor() {
    return this.addClassSpanBackgroundsVisor;
  };
  _proto.setAddClassSpanBackgroundsVisor = function setAddClassSpanBackgroundsVisor(addClassSpanBackgroundsVisor) {
    this.addClassSpanBackgroundsVisor = addClassSpanBackgroundsVisor;
    this.notify({
      addClassSpanBackgroundsVisor: addClassSpanBackgroundsVisor
    });
  };
  _proto.getActivityConfig = function getActivityConfig() {
    return this.activityConfig;
  };
  _proto.setActivityConfig = function setActivityConfig(activityConfig) {
    this.activityConfig = activityConfig;
    this.notify({
      activityConfig: activityConfig
    });
  };
  _proto.isShowAdditionalContentsSubItemEditor = function isShowAdditionalContentsSubItemEditor() {
    return this.showAdditionalContentsSubItemEditor;
  };
  _proto.setShowAdditionalContentsSubItemEditor = function setShowAdditionalContentsSubItemEditor(showAdditionalContentsSubItemEditor) {
    this.showAdditionalContentsSubItemEditor = showAdditionalContentsSubItemEditor;
    this.notify({
      showAdditionalContentsSubItemEditor: showAdditionalContentsSubItemEditor
    });
  };
  _proto.isShowAdditionalContentsSubItemVisor = function isShowAdditionalContentsSubItemVisor() {
    return this.showAdditionalContentsSubItemVisor;
  };
  _proto.setShowAdditionalContentsSubItemVisor = function setShowAdditionalContentsSubItemVisor(showAdditionalContentsSubItemVisor) {
    this.showAdditionalContentsSubItemVisor = showAdditionalContentsSubItemVisor;
    this.notify({
      showAdditionalContentsSubItemVisor: showAdditionalContentsSubItemVisor
    });
  };
  _proto.getGetSrc = function getGetSrc() {
    return this.getSrc;
  };
  _proto.setGetSrc = function setGetSrc(getSrc) {
    this.getSrc = getSrc;
    this.notify({
      getSrc: getSrc
    });
  };
  _proto.getBackgroundVisor = function getBackgroundVisor() {
    return this.backgroundVisor;
  };
  _proto.setBackgroundVisor = function setBackgroundVisor(backgroundVisor) {
    this.backgroundVisor = backgroundVisor;
    this.notify({
      backgroundVisor: backgroundVisor
    });
  };
  _proto.getUiStyles = function getUiStyles() {
    return this.uiStyles;
  };
  _proto.setUiStyles = function setUiStyles(uiStyles) {
    this.uiStyles = uiStyles;
    this.notify({
      uiStyles: uiStyles
    });
  };
  _proto.getEnableRowColumnLayout = function getEnableRowColumnLayout() {
    return this.enableRowColumnLayout;
  };
  _proto.setEnableRowColumnLayout = function setEnableRowColumnLayout(enableRowColumnLayout) {
    this.enableRowColumnLayout = enableRowColumnLayout;
    this.notify({
      enableRowColumnLayout: enableRowColumnLayout
    });
  };
  _proto.getIsSinglePost = function getIsSinglePost() {
    return this.isSinglePost;
  };
  _proto.setIsSinglePost = function setIsSinglePost(isSinglePost) {
    this.isSinglePost = isSinglePost;
    this.notify({
      isSinglePost: isSinglePost
    });
  };
  _proto.getEnablePopup = function getEnablePopup() {
    return this.enablePopups;
  };
  _proto.setEnablePopup = function setEnablePopup(enablePopups) {
    this.enablePopups = enablePopups;
    this.notify({
      enablePopups: enablePopups
    });
  };
  _proto.getEnableTextTooltip = function getEnableTextTooltip() {
    return this.enableTextTooltips;
  };
  _proto.setEnableTextTooltip = function setEnableTextTooltip(enableTextTooltips) {
    this.enableTextTooltips = enableTextTooltips;
    this.notify({
      enableTextTooltips: enableTextTooltips
    });
  };
  _proto.getVersion = function getVersion() {
    return this.version;
  };
  _proto.setVersion = function setVersion(version) {
    this.version = version;
    this.notify({
      version: version
    });
  };
  _proto.getEnableBackgroundGradient = function getEnableBackgroundGradient() {
    return this.enableBackgroundGradient;
  };
  _proto.setEnableBackgroundGradient = function setEnableBackgroundGradient(enableBackgroundGradient) {
    this.enableBackgroundGradient = enableBackgroundGradient;
    this.notify({
      enableBackgroundGradient: enableBackgroundGradient
    });
  };
  _proto.isCanCreateFeedbackActivities = function isCanCreateFeedbackActivities() {
    return this.canCreateFeedbackActivities;
  };
  _proto.setCanCreateFeedbackActivities = function setCanCreateFeedbackActivities(canCreateFeedbackActivities) {
    this.canCreateFeedbackActivities = canCreateFeedbackActivities;
    this.notify({
      canCreateFeedbackActivities: canCreateFeedbackActivities
    });
  };
  _proto.isShowSettingsActivity = function isShowSettingsActivity() {
    return this.showSettingsActivity;
  };
  _proto.setShowSettingsActivity = function setShowSettingsActivity(showSettingsActivity) {
    this.showSettingsActivity = showSettingsActivity;
    this.notify({
      showSettingsActivity: showSettingsActivity
    });
  };
  _proto.isShowSettingsActivityIntelligeTag = function isShowSettingsActivityIntelligeTag() {
    return this.showSettingsActivityIntelligeTag;
  };
  _proto.setShowSettingsActivityIntelligeTag = function setShowSettingsActivityIntelligeTag(showSettingsActivityIntelligeTag) {
    this.showSettingsActivityIntelligeTag = showSettingsActivityIntelligeTag;
    this.notify({
      showSettingsActivityIntelligeTag: showSettingsActivityIntelligeTag
    });
  };
  return ConfigGlobalSingleton;
}(SubjectConfigGlobal);
ConfigGlobalSingleton.myInstance = null;

var ObserverConfigGlobal = /*#__PURE__*/function () {
  function ObserverConfigGlobal(onUndate) {
    this.onUndate = onUndate;
  }
  var _proto = ObserverConfigGlobal.prototype;
  _proto.update = function update(propertiesChanged) {
    var _this$onUndate;
    (_this$onUndate = this.onUndate) == null || _this$onUndate.call(this, propertiesChanged);
  };
  return ObserverConfigGlobal;
}();

/**
 * No usar este hook directamente en los compomentes, usar el useGeneral que dentro tiene llamada a este hook, asi si hay que poner mas cosas de forma general para varios componentes seria tocar el useGeneral
 * @returns
 */
function useApplicationConfig() {
  // TODO: en un futuro refactorizar la implementación del singleton y usar esto
  // https://github.com/Oneclickdys/lemonade-generator-ui/blob/82a78e57eae801cdc9e76d22a22023673b4e7a8d/src/state/LemonadeConfigContext.js
  var _useState = useState({
      pathAssets: ConfigGlobalSingleton.getInstance().getPathAssets(),
      folderBlockDefault: ConfigGlobalSingleton.getInstance().getFolderBlockDefault(),
      lang: ConfigGlobalSingleton.getInstance().getLang(),
      eventsVisor: ConfigGlobalSingleton.getInstance().getEventsVisor(),
      eventsEditor: ConfigGlobalSingleton.getInstance().getEventsEditor(),
      offsetVisibilityPost: ConfigGlobalSingleton.getInstance().getOffsetVisibilityPost(),
      offsetVisibilityItemBlock: ConfigGlobalSingleton.getInstance().getOffsetVisibilityItemBlock(),
      pathEmbedApi: ConfigGlobalSingleton.getInstance().getPathEmbedApi(),
      googleApi: ConfigGlobalSingleton.getInstance().getGoogleApi(),
      configFavoriteColors: ConfigGlobalSingleton.getInstance().getConfigFavoriteColors(),
      favoriteColors: ConfigGlobalSingleton.getInstance().getFavoriteColors(),
      showLessonTitles: ConfigGlobalSingleton.getInstance().isShowLessonTitles(),
      assetsEditorApi: ConfigGlobalSingleton.getInstance().getAssetsEditorApi(),
      repeatActivityEnabled: ConfigGlobalSingleton.getInstance().isRepeatActivityEnabled(),
      scormEnabled: ConfigGlobalSingleton.getInstance().isScormEnabled(),
      mathRenderEngine: ConfigGlobalSingleton.getInstance().getMathRenderEngine(),
      hideWaitingResponseOfflineActivity: ConfigGlobalSingleton.getInstance().isHideWaitingResponseOfflineActivity(),
      styleTypeItemBlockOptions: ConfigGlobalSingleton.getInstance().getStyleTypeItemBlockOptions(),
      addClassSpanBackgroundsEditor: ConfigGlobalSingleton.getInstance().getAddClassSpanBackgroundsEditor(),
      addClassSpanBackgroundsVisor: ConfigGlobalSingleton.getInstance().getAddClassSpanBackgroundsVisor(),
      activityConfig: ConfigGlobalSingleton.getInstance().getActivityConfig(),
      getSrc: ConfigGlobalSingleton.getInstance().getGetSrc(),
      backgroundVisor: ConfigGlobalSingleton.getInstance().getBackgroundVisor(),
      uiStyles: ConfigGlobalSingleton.getInstance().getUiStyles(),
      enableRowColumnLayout: ConfigGlobalSingleton.getInstance().getEnableRowColumnLayout(),
      isSinglePost: ConfigGlobalSingleton.getInstance().getIsSinglePost(),
      enablePopups: ConfigGlobalSingleton.getInstance().getEnablePopup(),
      enableTextTooltips: ConfigGlobalSingleton.getInstance().getEnableTextTooltip(),
      version: ConfigGlobalSingleton.getInstance().getVersion(),
      enableBackgroundGradient: ConfigGlobalSingleton.getInstance().getEnableBackgroundGradient(),
      canCreateFeedbackActivities: ConfigGlobalSingleton.getInstance().isCanCreateFeedbackActivities(),
      showSettingsActivity: ConfigGlobalSingleton.getInstance().isShowSettingsActivity(),
      showSettingsActivityIntelligeTag: ConfigGlobalSingleton.getInstance().isShowSettingsActivityIntelligeTag()
    }),
    state = _useState[0],
    dispatch = _useState[1];
  useEffect(function () {
    var observer = new ObserverConfigGlobal(function (propertiesChanged) {
      dispatch(function (prevState) {
        return _extends({}, prevState, propertiesChanged);
      });
    });
    ConfigGlobalSingleton.getInstance().subscribe(observer);
    return function () {
      ConfigGlobalSingleton.getInstance().unsubscribe(observer);
    };
  }, []);
  // Para que en el return siempre de valores actualizados hace falta hacer lo del observador de arriba y el state
  return {
    pathAssets: state.pathAssets,
    folderBlockDefault: state.folderBlockDefault,
    lang: state.lang,
    eventsVisor: state.eventsVisor,
    eventsEditor: state.eventsEditor,
    offsetVisibilityPost: state.offsetVisibilityPost,
    offsetVisibilityItemBlock: state.offsetVisibilityItemBlock,
    pathEmbedApi: state.pathEmbedApi,
    googleApi: state.googleApi,
    configFavoriteColors: state.configFavoriteColors,
    favoriteColors: state.favoriteColors,
    showLessonTitles: state.showLessonTitles,
    assetsEditorApi: state.assetsEditorApi,
    repeatActivityEnabled: state.repeatActivityEnabled,
    scormEnabled: state.scormEnabled,
    mathRenderEngine: state.mathRenderEngine,
    hideWaitingResponseOfflineActivity: state.hideWaitingResponseOfflineActivity,
    styleTypeItemBlockOptions: state.styleTypeItemBlockOptions,
    addClassSpanBackgroundsEditor: state.addClassSpanBackgroundsEditor,
    addClassSpanBackgroundsVisor: state.addClassSpanBackgroundsVisor,
    activityConfig: state.activityConfig,
    getSrc: state.getSrc,
    backgroundVisor: state.backgroundVisor,
    uiStyles: state.uiStyles,
    enableRowColumnLayout: state.enableRowColumnLayout,
    isSinglePost: state.isSinglePost,
    enablePopups: state.enablePopups,
    enableTextTooltips: state.enableTextTooltips,
    version: state.version,
    enableBackgroundGradient: state.enableBackgroundGradient,
    canCreateFeedbackActivities: state.canCreateFeedbackActivities,
    showSettingsActivity: state.showSettingsActivity,
    showSettingsActivityIntelligeTag: state.showSettingsActivityIntelligeTag
  };
}

/**
 * No usar este hook directamente en los compomentes, usar el useGeneral que dentro tiene llamada a este hook, asi si hay que poner mas cosas de forma general para varios componentes seria tocar el useGeneral
 * @returns
 */
function useTranslation() {
  var _useTranslation2 = useTranslation$1(['visor', 'editor']),
    t = _useTranslation2.t;
  return {
    t: t
  };
}

/**
 * Hook que irá de forma general en cualquier componente, y que entre otras cosas proveerá de la función de traducción
 * Ponerle este hook a cualquier componente que no tenga hook y que le haga falta la función de traducción y tambien llamarlo dentro de los hook particulares de componentes
 * @returns
 */
function useGeneral() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useApplicationConfig = useApplicationConfig(),
    pathAssets = _useApplicationConfig.pathAssets,
    folderBlockDefault = _useApplicationConfig.folderBlockDefault,
    offsetVisibilityPost = _useApplicationConfig.offsetVisibilityPost,
    offsetVisibilityItemBlock = _useApplicationConfig.offsetVisibilityItemBlock,
    lang = _useApplicationConfig.lang,
    eventsVisor = _useApplicationConfig.eventsVisor,
    eventsEditor = _useApplicationConfig.eventsEditor,
    pathEmbedApi = _useApplicationConfig.pathEmbedApi,
    googleApi = _useApplicationConfig.googleApi,
    configFavoriteColors = _useApplicationConfig.configFavoriteColors,
    favoriteColors = _useApplicationConfig.favoriteColors,
    showLessonTitles = _useApplicationConfig.showLessonTitles,
    assetsEditorApi = _useApplicationConfig.assetsEditorApi,
    repeatActivityEnabled = _useApplicationConfig.repeatActivityEnabled,
    scormEnabled = _useApplicationConfig.scormEnabled,
    mathRenderEngine = _useApplicationConfig.mathRenderEngine,
    hideWaitingResponseOfflineActivity = _useApplicationConfig.hideWaitingResponseOfflineActivity,
    styleTypeItemBlockOptions = _useApplicationConfig.styleTypeItemBlockOptions,
    addClassSpanBackgroundsEditor = _useApplicationConfig.addClassSpanBackgroundsEditor,
    addClassSpanBackgroundsVisor = _useApplicationConfig.addClassSpanBackgroundsVisor,
    activityConfig = _useApplicationConfig.activityConfig,
    _getSrc = _useApplicationConfig.getSrc,
    backgroundVisor = _useApplicationConfig.backgroundVisor,
    uiStyles = _useApplicationConfig.uiStyles,
    enableRowColumnLayout = _useApplicationConfig.enableRowColumnLayout,
    isSinglePost = _useApplicationConfig.isSinglePost,
    enablePopups = _useApplicationConfig.enablePopups,
    enableTextTooltips = _useApplicationConfig.enableTextTooltips,
    version = _useApplicationConfig.version,
    enableBackgroundGradient = _useApplicationConfig.enableBackgroundGradient,
    canCreateFeedbackActivities = _useApplicationConfig.canCreateFeedbackActivities,
    showSettingsActivity = _useApplicationConfig.showSettingsActivity,
    showSettingsActivityIntelligeTag = _useApplicationConfig.showSettingsActivityIntelligeTag;
  return {
    t: t,
    getSrc: function getSrc(src) {
      return _getSrc ? _getSrc(src) : getSrcParam(src, pathAssets);
    },
    pathAssets: pathAssets,
    folderBlockDefault: folderBlockDefault,
    lang: lang,
    eventsVisor: eventsVisor,
    eventsEditor: eventsEditor,
    offsetVisibilityPost: offsetVisibilityPost,
    offsetVisibilityItemBlock: offsetVisibilityItemBlock,
    pathEmbedApi: pathEmbedApi,
    googleApi: googleApi,
    configFavoriteColors: configFavoriteColors,
    favoriteColors: favoriteColors,
    showLessonTitles: showLessonTitles,
    assetsEditorApi: assetsEditorApi,
    repeatActivityEnabled: repeatActivityEnabled,
    scormEnabled: scormEnabled,
    mathRenderEngine: mathRenderEngine,
    hideWaitingResponseOfflineActivity: hideWaitingResponseOfflineActivity,
    styleTypeItemBlockOptions: styleTypeItemBlockOptions,
    addClassSpanBackgroundsEditor: addClassSpanBackgroundsEditor,
    addClassSpanBackgroundsVisor: addClassSpanBackgroundsVisor,
    activityConfig: activityConfig,
    backgroundVisor: backgroundVisor,
    uiStyles: uiStyles,
    enableRowColumnLayout: enableRowColumnLayout,
    isSinglePost: isSinglePost,
    enablePopups: enablePopups,
    enableTextTooltips: enableTextTooltips,
    version: version,
    enableBackgroundGradient: enableBackgroundGradient,
    canCreateFeedbackActivities: canCreateFeedbackActivities,
    showSettingsActivity: showSettingsActivity,
    showSettingsActivityIntelligeTag: showSettingsActivityIntelligeTag
  };
}

function useLessonCoursePageType1(props) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useState = useState({});
  return {
    t: t
  };
}

function LessonCoursePageType1(props) {
  var _useLessonCoursePageT = useLessonCoursePageType1();
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'lesson-course-page-type1'
  }, /*#__PURE__*/React__default.createElement("p", null, "TODO: Hacer lesson course page type 1"));
}

function LessonActiveEmpty(props) {
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-lesson-active-empty'
  }, "No tiene leccion activa"));
}

function renderKatex(element, callBack) {
  if (callBack === void 0) {
    callBack = function callBack() {
      console.log('renderKatex:: callback not defined');
    };
  }
  var processMath = function processMath() {
    // console.log(element)
    try {
      window.renderMathInElement(element, {
        throwOnError: false
      });
      callBack(element);
    } catch (e) {
      console.log(e);
    }
  };
  if (window && window.renderMathInElement) {
    processMath();
  }
}

function renderMathJax(element, onRenderElements, onMathJaxReady) {
  if (onRenderElements === void 0) {
    onRenderElements = function onRenderElements() {
      console.log('MathJaxQueue:: callback not defined');
    };
  }
  var processMath = function processMath(nodes) {
    try {
      window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub, nodes, function () {
        // console.log(nodes)
        onRenderElements(nodes);
      }]);
    } catch (e) {
      console.log(e);
    }
  };
  if (window.MathJax) {
    processMath(element);
  }
}

var mathClass = '.fr-math, .fr-math-v2, .fr-math-v3';
function renderMath(element, onRender) {
  if (onRender === void 0) {
    onRender = function onRender() {};
  }
  if (element) {
    var mathRenderEngine = ConfigGlobalSingleton.getInstance().getMathRenderEngine();
    if (mathRenderEngine === IMathRenderEngine.KATEX) renderKatex(element, onRender);else renderMathJax(element, onRender);
  }
}
function useMathRender(rootElement, rules, onSuccess, init, onBegin) {
  if (rules === void 0) {
    rules = [];
  }
  if (onSuccess === void 0) {
    onSuccess = null;
  }
  if (init === void 0) {
    init = false;
  }
  if (onBegin === void 0) {
    onBegin = null;
  }
  var _useState = useState(0),
    isUpdated = _useState[0],
    setUpdate = _useState[1]; // TODO: Ver si se usa
  useEffect(function () {
    var _rootElement$current;
    onBegin && onBegin();
    var hasMath = rootElement == null || (_rootElement$current = rootElement.current) == null ? void 0 : _rootElement$current.querySelector(mathClass);
    if (hasMath || init) {
      // Al cargar la lib en la config, perdemos el poder de ocultar y mostrar el elemento mientras está render
      renderMath(rootElement == null ? void 0 : rootElement.current, function (nodes) {
        setUpdate(1);
        setTimeout(function () {
          onSuccess && onSuccess();
        }, 100);
      });
    } else {
      onSuccess && onSuccess();
    }
  }, rules);
  return {
    isUpdated: isUpdated
  };
}

var _g;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var SvgX = function SvgX(props) {
  return /*#__PURE__*/createElement("svg", _extends$1({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/createElement("g", {
    id: "Icon/Solid/x"
  }, /*#__PURE__*/createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L10 8.58579L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L11.4142 10L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L10 11.4142L5.70711 15.7071C5.31658 16.0976 4.68342 16.0976 4.29289 15.7071C3.90237 15.3166 3.90237 14.6834 4.29289 14.2929L8.58579 10L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
    fill: "#4F4F4F"
  }))));
};

function useOnClickOutside(ref, handler) {
  useEffect(function () {
    var listener = function listener(event) {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  },
  // Add ref and handler to effect dependencies
  // It's worth noting that because passed in handler is a new ...
  // ... function on every render that will cause this effect ...
  // ... callback/cleanup to run every render. It's not a big deal ...
  // ... but to optimize you can wrap handler in useCallback before ...
  // ... passing it into this hook.
  [ref, handler]);
}

var ITooltipContentType;
(function (ITooltipContentType) {
  ITooltipContentType["TEXT"] = "text";
  //Para futuro por ejemplo que pueda tambien ser de tipo: MEDIA = 'media',
})(ITooltipContentType || (ITooltipContentType = {}));

var TextTooltip = function TextTooltip(_ref) {
  var tooltip = _ref.tooltip,
    isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    referenceElement = _ref.referenceElement,
    _ref$closeOnClickOuts = _ref.closeOnClickOutside,
    closeOnClickOutside = _ref$closeOnClickOuts === void 0 ? true : _ref$closeOnClickOuts;
  var tooltipRef = useRef(null);
  var _React$useState = React__default.useState(null),
    popperElement = _React$useState[0],
    setPopperElement = _React$useState[1];
  var _usePopper = usePopper(referenceElement, popperElement, {
      placement: 'top',
      modifiers: [{
        name: 'offset',
        options: {
          offset: [0, 8]
        }
      }, {
        name: 'arrow',
        options: {
          element: '.mint-text-tooltip__arrow',
          padding: 5
        }
      }]
    }),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes;
  useOnClickOutside(tooltipRef, function () {
    if (closeOnClickOutside) {
      onClose();
    }
  });
  if (!isOpen) return null;
  return /*#__PURE__*/createPortal( /*#__PURE__*/React__default.createElement("div", Object.assign({
    ref: function ref(node) {
      tooltipRef.current = node;
      setPopperElement(node);
    },
    className: 'mint-text-tooltip mint-text-tooltip-portal',
    style: styles.popper
  }, attributes.popper), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-text-tooltip__content'
  }, tooltip.contents.map(function (content) {
    return content.type === ITooltipContentType.TEXT && /*#__PURE__*/React__default.createElement("span", {
      key: content.guid
    }, content.text);
  }), /*#__PURE__*/React__default.createElement("button", {
    className: 'mint-text-tooltip__close',
    onClick: onClose,
    "aria-label": 'Cerrar tooltip'
  }, /*#__PURE__*/React__default.createElement(SvgX, null))), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-text-tooltip__arrow',
    "data-popper-arrow": true,
    style: styles.arrow
  })), document.body);
};

var tooltipClass = '.fr-mintTooltip-text[data-tooltip-guid]';
// Creamos un componente wrapper para manejar el estado del tooltip
var TooltipRenderer = function TooltipRenderer(_ref) {
  var tooltip = _ref.tooltip,
    tooltipElement = _ref.tooltipElement;
  var _React$useState = React__default.useState(false),
    isOpen = _React$useState[0],
    setIsOpen = _React$useState[1];
  var _React$useState2 = React__default.useState(null),
    referenceElement = _React$useState2[0],
    setReferenceElement = _React$useState2[1];
  React__default.useEffect(function () {
    var handleClick = function handleClick(e) {
      // Prevenir que el evento se propague a otros tooltips
      e.stopPropagation();
      setReferenceElement(tooltipElement);
      setIsOpen(true);
    };
    tooltipElement.addEventListener('click', handleClick);
    return function () {
      return tooltipElement.removeEventListener('click', handleClick);
    };
  }, [tooltipElement]);
  React__default.useEffect(function () {
    if (isOpen) {
      tooltipElement.classList.add('fr-mintTooltip-text--active');
    } else {
      tooltipElement.classList.remove('fr-mintTooltip-text--active');
    }
  }, [isOpen, tooltipElement]);
  var handleClose = function handleClose() {
    setIsOpen(false);
  };
  return /*#__PURE__*/React__default.createElement(TextTooltip, {
    tooltip: tooltip,
    isOpen: isOpen,
    onClose: handleClose,
    referenceElement: referenceElement,
    closeOnClickOutside: true
  });
};
function renderTooltips(element, tooltips, onRender) {
  if (onRender === void 0) {
    onRender = function onRender() {};
  }
  if (element) {
    var tooltipElements = element.querySelectorAll(tooltipClass);
    tooltipElements.forEach(function (tooltipElement) {
      var tooltipGuid = tooltipElement.getAttribute('data-tooltip-guid');
      if (tooltipGuid) {
        var tooltip = tooltips.find(function (t) {
          return t.guid === tooltipGuid;
        });
        if (tooltip) {
          // Creamos un div contenedor para el portal con un ID único
          var portalContainer = document.createElement('div');
          portalContainer.id = "tooltip-portal-" + tooltipGuid;
          document.body.appendChild(portalContainer);
          ReactDOM.render( /*#__PURE__*/React__default.createElement(TooltipRenderer, {
            tooltip: tooltip,
            tooltipElement: tooltipElement
          }), portalContainer);
        }
      }
    });
    onRender();
  }
}
function useTextTooltipRender(rootElement, rules, tooltips, onSuccess, onBegin) {
  if (rules === void 0) {
    rules = [];
  }
  if (tooltips === void 0) {
    tooltips = [];
  }
  if (onSuccess === void 0) {
    onSuccess = null;
  }
  if (onBegin === void 0) {
    onBegin = null;
  }
  var _useGeneral = useGeneral(),
    enableTextTooltips = _useGeneral.enableTextTooltips;
  useEffect(function () {
    var _rootElement$current;
    onBegin == null || onBegin();
    var hasTooltips = rootElement == null || (_rootElement$current = rootElement.current) == null ? void 0 : _rootElement$current.querySelector(tooltipClass);
    if (hasTooltips && enableTextTooltips) {
      renderTooltips(rootElement == null ? void 0 : rootElement.current, tooltips, function () {
        setTimeout(function () {
          onSuccess == null || onSuccess();
        }, 100);
      });
    } else {
      onSuccess == null || onSuccess();
    }
    // Cleanup function para remover los portales cuando se desmonte
    return function () {
      var tooltips = document.querySelectorAll('.mint-text-tooltip-portal');
      tooltips.forEach(function (tooltip) {
        return tooltip.remove();
      });
    };
  }, rules);
}

function TextHtmlVisor(props) {
  var text = props.text,
    _props$classAdd = props.classAdd,
    classAdd = _props$classAdd === void 0 ? '' : _props$classAdd,
    id = props.id,
    tooltips = props.tooltips,
    onReady = props.onReady,
    onBegin = props.onBegin;
  var rootNode = useRef(null);
  // @ts-ignore
  useMathRender(rootNode, [text], onSuccessMathRender, undefined, onBeginMathRender);
  useTextTooltipRender(rootNode, [text], tooltips);
  var spaceNecessary = classAdd && classAdd.length > 0 && classAdd.charAt(0) !== ' ';
  function onSuccessMathRender() {
    onReady && onReady();
  }
  function onBeginMathRender() {
    onBegin && onBegin();
  }
  return /*#__PURE__*/React__default.createElement("div", {
    ref: rootNode,
    className: 'fr-view brand--link' + (spaceNecessary ? ' ' : '') + classAdd,
    id: id,
    dangerouslySetInnerHTML: {
      __html: text || ''
    }
  });
}

var roleTypes;
(function (roleTypes) {
  roleTypes["STUDENT"] = "STUDENT";
  roleTypes["TEACHER"] = "TEACHER";
  roleTypes["EDITORIAL"] = "EDITORIAL";
})(roleTypes || (roleTypes = {}));

function getSuspendData(lessonId) {
  var _window$sco_instance2, _window;
  // Dummy data
  /* const suspendDataDummyOriginal = [
    { '32f30ef0-b8d8-11ed-b149-531b36cd376b': { '1': ['múltiplo', 'fotosfera', 'atmosfera', 'corona'] } },
    { '2e02e8b0-b8d9-11ed-aef9-f9a5adb5442b': { '1': [0, 1, 2, 3] } },
  ]; */
  /* const suspendDataDummySimplificado = {
    '32f30ef0-b8d8-11ed-b149-531b36cd376b': [['múltiplo', 'fotosfera', 'atmosfera', 'corona']],
    '2e02e8b0-b8d9-11ed-aef9-f9a5adb5442b': [[0, 1, 2, 3]],
  }; */
  /* const sd = {
    'b933675b-ef4c-4c98-854f-c5661f064f74': [['2']],
    'e8459ab2-3582-4d9b-8517-4c3ae78e2c28': [['<p>hola</p>']],
    '798cb8e2-5c4a-48db-aa26-9768b1047297': [[['1']]],
    '9e98c3da-7a08-4d0e-a423-46a7e6f748f6': [[['0']]],
    'f28a3a95-d368-4a53-a6bf-39f86fe5bcea': [[['2']]],
    '6bf6b8ed-0449-4d21-88db-c22067bd62e2': [[['1']]],
    'aad9420b-1487-4ac3-b2b9-f105e32f73b2': [[['1']]],
  }; */

  /* const sd_o = {
    'd5489138-7fb0-4b4a-8b53-8f02c3fc6b4e': [['0']],
    '68bc6c1c-3793-47fb-892c-74fca79218be': [['aaaa', 'bbbb', 'cccc', 'dddd']],
  }; */

  if (lessonId && (_window$sco_instance2 = window.sco_instance) != null && _window$sco_instance2[lessonId]) {
    return window.sco_instance[lessonId].get();
  }
  var sd = (_window = window) == null || _window.getSuspendData == null ? void 0 : _window.getSuspendData();
  return sd;
}
function getSuspendDataByReference(reference, lessonId) {
  var _suspendData$referenc;
  var suspendData = getSuspendData(lessonId);
  return suspendData == null || (_suspendData$referenc = suspendData[reference]) == null ? void 0 : _suspendData$referenc[0]; // ?.[0]; // En la lib de SCORM hay que arreglar esto de que sea [0][0] con uno es suficiente
  // Este caso era para el dummy original que Esteban cambiará, dejar comentado cuando esté listo
  /* const suspendDataReferenceOriginal = suspendData?.find(obj => obj.hasOwnProperty(reference));
  console.log('getSuspendDataByReference', suspendDataReferenceOriginal?.[reference]?.['1']);
  return suspendDataReferenceOriginal?.[reference]?.['1']; */
}

function getResponseFromLemonadeItem(item, isScormEnabled) {
  var _item$lms;
  if (isScormEnabled === void 0) {
    isScormEnabled = false;
  }
  if (isScormEnabled) {
    var _item$items;
    var reference = item == null || (_item$items = item.items) == null || (_item$items = _item$items[0]) == null || (_item$items = _item$items.data) == null ? void 0 : _item$items.reference;
    var suspendData = getSuspendDataByReference(reference);
    return suspendData;
  }
  if ((item == null || (_item$lms = item.lms) == null || (_item$lms = _item$lms.job) == null || (_item$lms = _item$lms.metadata) == null || (_item$lms = _item$lms.answers) == null ? void 0 : _item$lms.length) > 0) {
    var responseString = item.lms.job.metadata.answers[0].answer;
    try {
      return JSON.parse(responseString);
    } catch (err) {
      console.log(err);
      return undefined;
    }
  }
  return undefined;
}
// Devuelve el score del objeto lms en caso de existir y estar el ejercicio evaluado
function getScoreLemonadeItem(item) {
  var _item$lms2;
  if ((item == null || (_item$lms2 = item.lms) == null || (_item$lms2 = _item$lms2.job) == null ? void 0 : _item$lms2.status) === 'evaluated') {
    return item.lms.job.score;
  }
  return undefined;
}
function getStatusLemonadeItem(item) {
  var _item$lms3;
  return item == null || (_item$lms3 = item.lms) == null || (_item$lms3 = _item$lms3.job) == null ? void 0 : _item$lms3.status;
}

var IVariantsGalleryColumns;
(function (IVariantsGalleryColumns) {
  IVariantsGalleryColumns["twocol"] = "twocol";
  IVariantsGalleryColumns["threecol"] = "threecol";
  IVariantsGalleryColumns["fourcol"] = "fourcol";
})(IVariantsGalleryColumns || (IVariantsGalleryColumns = {}));

function SectionItemBlock(_ref) {
  var _ref2;
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    backgroundColor = _ref.backgroundColor,
    _ref$paddingBottom = _ref.paddingBottom,
    paddingBottom = _ref$paddingBottom === void 0 ? 0 : _ref$paddingBottom,
    _ref$paddingTop = _ref.paddingTop,
    paddingTop = _ref$paddingTop === void 0 ? 0 : _ref$paddingTop;
  return /*#__PURE__*/React__default.createElement("section", Object.assign({
    className: 'lesson__section ' + className
  }, backgroundColor && (_ref2 = {}, _ref2[DATA_ATRIBUTE_BACKGROUND_SECTION] = backgroundColor, _ref2), {
    style: {
      background: backgroundColor,
      paddingTop: paddingTop * MULTIPLIER_FACTOR_PADDING + 'px',
      paddingBottom: paddingBottom * MULTIPLIER_FACTOR_PADDING + 'px'
    }
  }), children);
}

var Button = function Button(props) {
  var children = props.children,
    onClick = props.onClick,
    variant = props.variant,
    className = props.className;
  var _useGeneral = useGeneral();
  return /*#__PURE__*/React__default.createElement("button", {
    className: "button" + (variant ? " button--" + variant : '') + (className ? " " + className : ''),
    onClick: onClick
  }, children);
};

var _path;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var SvgInterrogation = function SvgInterrogation(props) {
  return /*#__PURE__*/createElement("svg", _extends$2({
    width: 15,
    height: 27,
    viewBox: "0 0 15 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/createElement("path", {
    d: "M0.316895 3.54489C0.738969 3.19126 1.19526 2.86044 1.68578 2.55244C2.18771 2.24444 2.72386 1.97637 3.29423 1.74822C3.8646 1.50866 4.47489 1.32615 5.12512 1.20066C5.78675 1.06378 6.49971 0.995331 7.26401 0.995331C8.3363 0.995331 9.30023 1.13792 10.1558 1.42311C11.0227 1.70829 11.7585 2.11896 12.3631 2.65511C12.9677 3.17985 13.4297 3.81866 13.7491 4.57155C14.0799 5.31304 14.2453 6.14007 14.2453 7.05266C14.2453 7.93103 14.1256 8.68392 13.886 9.31133C13.6465 9.93874 13.3385 10.4863 12.962 10.954C12.597 11.4217 12.192 11.8267 11.7471 12.1689C11.3136 12.4997 10.8973 12.8134 10.498 13.11C10.1102 13.4066 9.76793 13.6975 9.47134 13.9827C9.18615 14.2679 9.00934 14.5873 8.9409 14.9409L8.46178 17.3364H4.83423L4.45778 14.5816C4.44638 14.5131 4.43497 14.4447 4.42356 14.3762C4.42356 14.3078 4.42356 14.2393 4.42356 14.1709C4.42356 13.669 4.54334 13.2298 4.7829 12.8533C5.02245 12.4769 5.32475 12.1347 5.68978 11.8267C6.05482 11.5073 6.44838 11.205 6.87045 10.9198C7.29252 10.6232 7.68608 10.3095 8.05112 9.97866C8.41615 9.63644 8.71845 9.26 8.95801 8.84933C9.19756 8.42726 9.31734 7.93104 9.31734 7.36066C9.31734 6.67622 9.08919 6.13437 8.6329 5.73511C8.18801 5.32444 7.57201 5.11911 6.78489 5.11911C6.1803 5.11911 5.67267 5.18185 5.26201 5.30733C4.86275 5.43281 4.51482 5.5754 4.21823 5.73511C3.93304 5.8834 3.68208 6.02029 3.46534 6.14578C3.2486 6.27126 3.03186 6.334 2.81512 6.334C2.3246 6.334 1.95956 6.12296 1.72001 5.70089L0.316895 3.54489ZM3.46534 23.5136C3.46534 23.1029 3.53949 22.7207 3.68778 22.3671C3.84749 22.0135 4.05852 21.7055 4.32089 21.4431C4.59467 21.1807 4.91408 20.9754 5.27912 20.8271C5.64415 20.6674 6.04341 20.5876 6.4769 20.5876C6.89897 20.5876 7.29253 20.6674 7.65756 20.8271C8.0226 20.9754 8.34201 21.1807 8.61578 21.4431C8.88956 21.7055 9.1006 22.0135 9.24889 22.3671C9.4086 22.7207 9.48845 23.1029 9.48845 23.5136C9.48845 23.9242 9.4086 24.3121 9.24889 24.6771C9.1006 25.0307 8.88956 25.3387 8.61578 25.6011C8.34201 25.8635 8.0226 26.0688 7.65756 26.2171C7.29253 26.3654 6.89897 26.4396 6.4769 26.4396C6.04341 26.4396 5.64415 26.3654 5.27912 26.2171C4.91408 26.0688 4.59467 25.8635 4.32089 25.6011C4.05852 25.3387 3.84749 25.0307 3.68778 24.6771C3.53949 24.3121 3.46534 23.9242 3.46534 23.5136Z",
    fill: "white"
  })));
};

function WrapperItemBlockOptionsVisor(_ref) {
  var children = _ref.children,
    onNeedHelp = _ref.onNeedHelp,
    needHelpText = _ref.needHelpText;
  var _useState = useState(false),
    controls = _useState[0],
    showControls = _useState[1];
  return onNeedHelp ? /*#__PURE__*/React__default.createElement("div", {
    className: 'item-block-visor',
    onMouseLeave: function onMouseLeave() {
      showControls(false);
    },
    onMouseEnter: function onMouseEnter() {
      showControls(true);
    },
    onMouseOver: function onMouseOver() {
      showControls(true);
    }
  }, children, /*#__PURE__*/React__default.createElement("div", {
    className: "item-block-visor__controls-wrapper " + (controls ? 'item-block-visor__controls-wrapper--show' : '')
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'item-block-visor__left-controls'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: 'item-block-visor__right-controls'
  }, onNeedHelp && /*#__PURE__*/React__default.createElement(Button, {
    onClick: onNeedHelp
  }, /*#__PURE__*/React__default.createElement(SvgInterrogation, {
    title: needHelpText
  }))))) : children;
}

function useItemBlockComponent(props) {
  var numComponentsTextHtml = props.numComponentsTextHtml,
    onReady = props.onReady;
  var numComponentsTextHtmlReady = useRef(0);
  useEffect(function () {
    if (numComponentsTextHtml !== undefined && numComponentsTextHtml > 0) ; else {
      // En otro caso puedo notificar ya que está ready
      onReady && onReady();
    }
  }, []);
  function onReadyGetTextHtml() {
    numComponentsTextHtmlReady.current = numComponentsTextHtmlReady.current + 1;
    if (numComponentsTextHtml && numComponentsTextHtmlReady.current >= numComponentsTextHtml) {
      onReady && onReady();
    }
  }
  return {
    onReadyGetTextHtml: onReadyGetTextHtml
  };
}

var Divider = function Divider(_ref) {
  var onReady = _ref.onReady,
    item = _ref.item;
  useItemBlockComponent({
    numComponentsTextHtml: undefined,
    onReady: onReady,
    item: item
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-divider'
  });
};

var SpacingDivider = function SpacingDivider(_ref) {
  var onReady = _ref.onReady,
    item = _ref.item;
  useItemBlockComponent({
    numComponentsTextHtml: undefined,
    onReady: onReady,
    item: item
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-spacing-divider'
  });
};

var _path$1;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var SvgFormSelectArrow = function SvgFormSelectArrow(props) {
  return /*#__PURE__*/createElement("svg", _extends$3({
    width: "10px",
    height: "6px"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/createElement("path", {
    d: "M5.000,6.000 L-0.000,1.134 L1.166,-0.002 L5.000,3.729 L8.833,-0.002 L10.000,1.134 L5.000,6.000 Z"
  })));
};

var ModifiersFormSelect;
(function (ModifiersFormSelect) {
  ModifiersFormSelect["PRIMARY"] = "primary";
})(ModifiersFormSelect || (ModifiersFormSelect = {}));
var FormSelect = function FormSelect(props) {
  var _props$modifier = props.modifier,
    modifier = _props$modifier === void 0 ? 'primary' : _props$modifier,
    _props$selected = props.selected,
    selected = _props$selected === void 0 ? '' : _props$selected,
    onChange = props.onChange,
    children = props.children;
  return !children || children.length === 0 ? null : /*#__PURE__*/React__default.createElement("div", {
    className: "form-select form-select--" + modifier
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'form-select__icon'
  }, /*#__PURE__*/React__default.createElement(SvgFormSelectArrow, null)), /*#__PURE__*/React__default.createElement("select", {
    className: 'form-select__select',
    value: selected,
    onChange: onChange
  }, children.map(function (item) {
    var name = item.name,
      value = item.value;
    return /*#__PURE__*/React__default.createElement("option", {
      key: name,
      value: value
    }, name);
  })));
};

var SettingsDropdown = function SettingsDropdown(_ref) {
  var valueSelected = _ref.valueSelected,
    label = _ref.label,
    _onChange = _ref.onChange,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-dropdown'
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'settings-dropdown__label'
  }, label), /*#__PURE__*/React__default.createElement(FormSelect, {
    selected: valueSelected,
    onChange: function onChange(event) {
      return _onChange(event.target.value);
    }
  }, children));
};

var SETTINGS_IMAGE_POSITION = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};
var SettingImagePosition = function SettingImagePosition(_ref) {
  var valueSelected = _ref.valueSelected,
    onChange = _ref.onChange;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var options = [{
    value: SETTINGS_IMAGE_POSITION.LEFT,
    name: t('Left', {
      ns: 'editor'
    })
  }, {
    value: SETTINGS_IMAGE_POSITION.CENTER,
    name: t('Center', {
      ns: 'editor'
    })
  }, {
    value: SETTINGS_IMAGE_POSITION.RIGHT,
    name: t('Right', {
      ns: 'editor'
    })
  }];
  return /*#__PURE__*/React__default.createElement(SettingsDropdown, {
    valueSelected: valueSelected,
    onChange: onChange,
    label: t('Image position', {
      ns: 'editor'
    })
  }, options);
};

// == Importante: Si actualizas algun valor aqui actualizar tambien en _image-sizes.scss
var SETTINGS_IMAGE_SIZE = {
  SIZE_5: 'size-5',
  SIZE_10: 'size-10',
  SIZE_15: 'size-15',
  SIZE_20: 'size-20',
  SMALL: 'small',
  SIZE_30: 'size-30',
  MEDIUM_SMALL: 'medium-small',
  SIZE_40: 'size-40',
  SIZE_45: 'size-45',
  MEDIUM: 'medium',
  SIZE_55: 'size-55',
  SIZE_60: 'size-60',
  SIZE_65: 'size-65',
  SIZE_70: 'size-70',
  LARGE: 'large',
  SIZE_80: 'size-80',
  SIZE_85: 'size-85',
  SIZE_90: 'size-90',
  SIZE_95: 'size-95',
  EXTRA_LARGE: 'extra-large'
};
// == Importante: Si actualizas algun valor aqui actualizar tambien en _image-sizes.scss
var OPTIONS_IMAGE_SIZES = [{
  value: SETTINGS_IMAGE_SIZE.SIZE_5,
  name: '5%'
}, {
  value: SETTINGS_IMAGE_SIZE.SIZE_10,
  name: '10%'
}, {
  value: SETTINGS_IMAGE_SIZE.SIZE_15,
  name: '15%'
}, {
  value: SETTINGS_IMAGE_SIZE.SIZE_20,
  name: '20%'
}, {
  value: SETTINGS_IMAGE_SIZE.SMALL,
  name: '25%'
}, {
  value: SETTINGS_IMAGE_SIZE.SIZE_30,
  name: '30%'
}, {
  value: SETTINGS_IMAGE_SIZE.MEDIUM_SMALL,
  name: '35%'
}, {
  value: SETTINGS_IMAGE_SIZE.SIZE_40,
  name: '40%'
}, {
  value: SETTINGS_IMAGE_SIZE.SIZE_45,
  name: '45%'
}, {
  value: SETTINGS_IMAGE_SIZE.MEDIUM,
  name: '50%'
}, {
  value: SETTINGS_IMAGE_SIZE.SIZE_55,
  name: '55%'
}, {
  value: SETTINGS_IMAGE_SIZE.SIZE_60,
  name: '60%'
}, {
  value: SETTINGS_IMAGE_SIZE.SIZE_65,
  name: '65%'
}, {
  value: SETTINGS_IMAGE_SIZE.SIZE_70,
  name: '70%'
}, {
  value: SETTINGS_IMAGE_SIZE.LARGE,
  name: '75%'
}, {
  value: SETTINGS_IMAGE_SIZE.SIZE_80,
  name: '80%'
}, {
  value: SETTINGS_IMAGE_SIZE.SIZE_85,
  name: '85%'
}, {
  value: SETTINGS_IMAGE_SIZE.SIZE_90,
  name: '90%'
}, {
  value: SETTINGS_IMAGE_SIZE.SIZE_95,
  name: '95%'
}, {
  value: SETTINGS_IMAGE_SIZE.EXTRA_LARGE,
  name: '100%'
}];
var SettingImageSize = function SettingImageSize(_ref) {
  var valueSelected = _ref.valueSelected,
    onChange = _ref.onChange,
    optionsImageSizes = _ref.optionsImageSizes;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var options = optionsImageSizes ? optionsImageSizes : OPTIONS_IMAGE_SIZES;
  return /*#__PURE__*/React__default.createElement(SettingsDropdown, {
    valueSelected: valueSelected,
    onChange: onChange,
    label: t('Image size', {
      ns: 'editor'
    })
  }, options);
};

var ISettingsImageWidth;
(function (ISettingsImageWidth) {
  ISettingsImageWidth["SMALL"] = "0";
  ISettingsImageWidth["MEDIUM"] = "1";
  ISettingsImageWidth["FULL_WIDTH"] = "2";
})(ISettingsImageWidth || (ISettingsImageWidth = {}));

/**
 * Selectores para obtener partes del elemento item, concretamente de su parte settings
 */
var SETTINGS_ALIGN_IMAGES = {
  UNSPECIFIED: 'Unspecified',
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};
function getItemSettingIsShowBorder(item) {
  return item && item.settings && Object.prototype.hasOwnProperty.call(item.settings, 'showBorder') ? item.settings.showBorder : true;
}
function getItemSettingIsZoomOnClick(item) {
  return item && item.settings && Object.prototype.hasOwnProperty.call(item.settings, 'zoomOnClick') ? item.settings.zoomOnClick : true;
}
function getItemSettingMediaWidth(item) {
  return item && item.settings && Object.prototype.hasOwnProperty.call(item.settings, 'mediaWidth') ? item.settings.mediaWidth : ISettingsImageWidth.SMALL;
}
function getItemSettingAlignImages(item) {
  return item && item.settings && Object.prototype.hasOwnProperty.call(item.settings, 'alignImages') ? item.settings.alignImages : SETTINGS_ALIGN_IMAGES.LEFT;
}
function getItemSettingAlignImage(item) {
  return item && item.settings && Object.prototype.hasOwnProperty.call(item.settings, 'alignImage') ? item.settings.alignImage : SETTINGS_ALIGN_IMAGES.UNSPECIFIED;
}
function getItemSettingMintTitle(item) {
  return item && item.settings && Object.prototype.hasOwnProperty.call(item.settings, 'title') ? item.settings.title : '';
}
function getItemSettingAudios(item) {
  return item && item.settings && Object.prototype.hasOwnProperty.call(item.settings, 'audios') ? item.settings.audios : '';
}
function getItemSettingHiddenContent(item) {
  return item && item.settings && Object.prototype.hasOwnProperty.call(item.settings, 'hiddenContent') ? item.settings.hiddenContent : false;
}
function getItemSettingHiddenMultimedia(item) {
  return item && item.settings && Object.prototype.hasOwnProperty.call(item.settings, 'hiddenMultimedia') ? item.settings.hiddenMultimedia : false;
}
function getItemSettingStepLabel(item) {
  return item && item.settings && Object.prototype.hasOwnProperty.call(item.settings, 'stepLabel') ? item.settings.stepLabel : '';
}
function getItemSettingIsShowMetaData(item) {
  return item && item.settings && Object.prototype.hasOwnProperty.call(item.settings, 'showMetaData') ? item.settings.showMetaData : true;
}
function getItemSettingImagePosition(item) {
  return item && item.settings && Object.prototype.hasOwnProperty.call(item.settings, 'imagePosition') ? item.settings.imagePosition : SETTINGS_IMAGE_POSITION.LEFT;
}
function getItemSettingImageSize(item) {
  return item && item.settings && Object.prototype.hasOwnProperty.call(item.settings, 'imageSize') ? item.settings.imageSize : Object.prototype.hasOwnProperty.call(item, 'variant') ? item.variant == 'hero' ? SETTINGS_IMAGE_SIZE.EXTRA_LARGE : SETTINGS_IMAGE_SIZE.MEDIUM : SETTINGS_IMAGE_SIZE.EXTRA_LARGE;
}

var IModesItemBlock;
(function (IModesItemBlock) {
  IModesItemBlock["MODE_VISOR"] = "MODE_VISOR";
  IModesItemBlock["MODE_PREVIEW"] = "MODE_PREVIEW";
  IModesItemBlock["MODE_EDITOR"] = "MODE_EDITOR";
  IModesItemBlock["MODE_EDITOR_FLOATING_SIDEBAR"] = "MODE_EDITOR_FLOATING_SIDEBAR";
  IModesItemBlock["MODE_EDITOR_SETTINGS_SIDEBAR"] = "MODE_EDITOR_SETTINGS_SIDEBAR";
})(IModesItemBlock || (IModesItemBlock = {}));

function getWidthByNode(node, defaultWidth) {
  var width = node && node.offsetWidth ? node.offsetWidth : defaultWidth;
  return width;
}
function getWidthById(id, defaultWidth) {
  var width = getWidthByNode(document.getElementById(id), defaultWidth);
  return width;
}
function getHeightById(id, defaultHeight) {
  var _document$getElementB, _document$getElementB2, _document$getElementB3, _document$getElementB4;
  var height = document.getElementById(id) && ((_document$getElementB = document.getElementById(id)) == null ? void 0 : _document$getElementB.offsetHeight) !== undefined && ((_document$getElementB2 = document.getElementById(id)) == null ? void 0 : _document$getElementB2.offsetHeight) !== null && ((_document$getElementB3 = document.getElementById(id)) == null ? void 0 : _document$getElementB3.offsetHeight) >= 0 ? (_document$getElementB4 = document.getElementById(id)) == null ? void 0 : _document$getElementB4.offsetHeight : defaultHeight;
  return height;
}
/**
 *

 * @fuente http://stackoverflow.com/a/6847328
 * @xEventTouch Coordenada x del evento touch si existe
 * @yEventTouch Coordenada y del evento touch si existe
 * @isXLeft Para  UtilsHighliAndAnotation.getSelectionCoords este valor seria true. Si es false podemos decir que el bocadillo va a salir al final del texto resaltado.
 * @isXLeft Para  UtilsHighliAndAnotation.getSelectionCoords este valor seria true. Si es false podemos decir que el bocadillo va a salir al final del texto resaltado.
 */
/**
 * import {
  ID_CONTEXTUAL_HIGHLIGHT_MENU,
  ID_DIV_LESSON_LINK_BACK,
  ID_DIV_LESSON_MENU_SHOW,
  ID_DIV_LESSON_MENU__MENU,
  ID_DIV_SCROLL,
  ID_WRAP_LESSON,
} from '../../config';
 * @fuente http://stackoverflow.com/a/6847328
 * @param win
 * @param {*} win
 * @param {*} xEventTouch Coordenada x del evento touch si existe
 * @param {*} yEventTouch Coordenada y del evento touch si existe
 * @param {*} isXLeft Para  UtilsHighliAndAnotation.getSelectionCoords este valor seria true. Si es false podemos decir que el bocadillo va a salir al final del texto resaltado.
 * @param {*} collapse
 * @param {*} idMenu Id del menu contextual
 * @param {*} idWrapContent Identificador del div que envuelve al contenido y al menu
 * @returns
 */
function getSelectionCoords(props) {
  var win = props.win,
    xEventTouch = props.xEventTouch,
    yEventTouch = props.yEventTouch,
    _props$isXLeft = props.isXLeft,
    isXLeft = _props$isXLeft === void 0 ? false : _props$isXLeft,
    _props$collapse = props.collapse,
    collapse = _props$collapse === void 0 ? false : _props$collapse,
    idMenu = props.idMenu,
    idWrapContent = props.idWrapContent;
  var widthMenu = getWidthById(idMenu, 283); // == Anchura del menu contextual con las opciones del texto seleccionado
  var heightWrapContent = getHeightById(idWrapContent, null);
  var xy = getSelectionCoordsOriginal(win, xEventTouch, yEventTouch, isXLeft, collapse, idWrapContent);
  var x = xy.x;
  var y = xy.y;
  var xToRet = x - widthMenu / 2;
  if (!isXLeft) xToRet = xToRet - 5; // == Lo desplazo un poco hacia la derecha para que se quede justo encima del final del texto resaltado
  // == Si se sale por la derecha el cuadro de dialogo lo pongo dentro de la pantalla pegado lo maximo a la derecha
  var widthWindow = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  widthWindow = widthWindow - 18; // Le resto 18 para que me de una anchura correcta ya que la que devolvia widthWindow era un poco mas de la 'realidad'
  var widthwrapContent = getWidthById(idWrapContent, 1519);
  if (xToRet + widthMenu > widthWindow) {
    xToRet = widthWindow - widthMenu;
  }
  // == Si se sale por la izquierda el cuadro de dialogo lo pongo dentro de la pantalla pegado lo maximo a la izquierda
  if (xToRet < 0) {
    xToRet = widthwrapContent && widthwrapContent > 0 ? widthwrapContent / 2 - widthMenu / 2 : 1; // == Lo pongo en la mitad de la pantalla
  }
  // https://javascript.info/coordinates
  var yToRet = y;
  // La coordenada y no puede ser mayor que lo que mide el wrapper de la leccion, si es asi le pongo como coordenada el tamaño del wrapper
  if (heightWrapContent && yToRet > heightWrapContent) yToRet = heightWrapContent;
  // Si me hiciera falta la posicion y relativa a la pantalla actual no le sumaria scrollTopLessonPageActive
  return {
    x: xToRet,
    y: yToRet
  };
}
function getSelectionText() {
  var text = '';
  if (window.getSelection) {
    // @ts-ignore
    text = window.getSelection().toString();
    // @ts-ignore
  } else if (document.selection && document.selection.type != 'Control') {
    // @ts-ignore
    text = document.selection.createRange().text;
  }
  return text;
}
/**
 * Insertata un nodo span al final del range
 * @param range
 * @param nodeSpan
 */
function insertNodeAtRangeEnd(range, nodeSpan) {
  var myRange2 = range.cloneRange();
  myRange2.collapse(false); // collapse the range to the end of selection
  myRange2.insertNode(nodeSpan);
}
/**
 *
 * @param win
 * @param {*} idWrapContent Identificador del div que envuelve al contenido y al menu
 * @fuente http://stackoverflow.com/a/6847328
 */
function getSelectionCoordsOriginal(win, xEventTouch, yEventTouch, isXLeft, collapse, idWrapContent) {
  if (isXLeft === void 0) {
    isXLeft = false;
  }
  if (collapse === void 0) {
    collapse = false;
  }
  win = win || window;
  var doc = win.document;
  var sel = doc.selection;
  var range;
  var rects;
  var rect;
  var x = 0;
  var y = 0;
  if (sel) {
    if (sel.type != 'Control') {
      range = sel.createRange();
      range.collapse(collapse);
      x = range.boundingLeft;
      y = range.boundingTop;
    }
  } else if (win.getSelection) {
    sel = win.getSelection();
    if (sel.rangeCount) {
      range = sel.getRangeAt(0).cloneRange();
      var wrapContent = document.getElementById(idWrapContent);
      if (range.getClientRects) {
        range.collapse(collapse);
        rects = range.getClientRects();
        if (rects) {
          if (rects.length > 0) {
            rect = rects[rects.length - 1]; // == Cojo la ultima para que el popup me lo situe alfinal del todo
          }

          if (!rect) {
            // == Aqui suele entrar cuando seleccionas con doble click el bloque
            var selection = window.getSelection();
            if (selection && selection.rangeCount > 0) {
              range = selection.getRangeAt(0);
              rects = range.getClientRects();
              if (rects) {
                if (rects.length > 0) {
                  rect = rects[rects.length - 1]; // == Cojo la ultima para que el popup me lo situe alfinal del todo
                }
              }
            }
          }

          if (rect) {
            if (wrapContent) {
              var wrapContentRect = wrapContent.getBoundingClientRect();
              x = isXLeft ? rect.left - wrapContentRect.left : rect.right - wrapContentRect.left;
              y = rect.bottom - wrapContentRect.top;
            } else {
              // == Cálculo que habia anteriormente antes del 16-08-2023
              x = isXLeft ? rect.left : rect.right;
              y = rect.bottom;
            }
          }
        }
      }
      // Fall back to inserting a temporary element
      if (x == 0 && y == 0) {
        var span = doc.createElement('span');
        if (span.getClientRects) {
          // Ensure span has dimensions and position by
          // adding a zero-width space character
          span.appendChild(doc.createTextNode("\u200B"));
          var _selection = window.getSelection();
          if (_selection && _selection.rangeCount > 0) {
            range = _selection.getRangeAt(0);
          }
          insertNodeAtRangeEnd(range, span);
          rects = span.getClientRects();
          if (rects) {
            if (rects.length > 0) {
              rect = rects[rects.length - 1]; // == Cojo la ultima para que el popup me lo situe alfinal del todo
            }
          }

          if (rect) {
            if (wrapContent) {
              var _wrapContentRect = wrapContent.getBoundingClientRect();
              x = isXLeft ? rect.left - _wrapContentRect.left : rect.right - _wrapContentRect.left;
              y = rect.bottom - _wrapContentRect.top;
            } else {
              // == Cálculo que habia anteriormente antes del 16-08-2023
              x = isXLeft ? rect.left : rect.right;
              y = rect.bottom;
            }
            var spanParent = span.parentNode;
            spanParent.removeChild(span);
            // Glue any broken text nodes back together
            spanParent.normalize();
          }
        }
      }
    }
  }
  if (x == 0 && y == 0) {
    if (xEventTouch && yEventTouch) {
      x = xEventTouch;
      y = yEventTouch + 10; // 10 es para ajustar un poco y que se baje algo mas el cartel y no tape el texto
    }
  }

  return {
    x: x,
    y: y
  };
}

/**
 * Funciones utiles para saber en que dispositivo estamos
 */
/**
 * Devuelve true si estamos en ios
 */
function isIos() {
  // var standalone = window.navigator.standalone,
  //Detecta Safari, Firefox y Chrome en iPad
  var userAgent = window.navigator.userAgent.toLowerCase();
  var isIpad = /macintosh/.test(userAgent) && navigator.maxTouchPoints > 0 || /ipad/.test(userAgent);
  var safari = /safari/.test(userAgent),
    ios = /iphone|ipod|ipad|edelvives-ios-player-wkwebview/.test(userAgent);
  return ios || isIpad ? true : false;
}
/**
 * Devuelve true si estamos en IE11
 */
function isIE11() {
  //@ts-ignore
  var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  return isIE11;
}

/**
 * Funciones utiles relacionadas con el dom
 */
/**
 * Recorrer desde un elemento hasta la raíz buscando el elemento cuya findFunction devuelva true
 * @param {number} min
 * @param {number} max
 * @param {number} num
 * @returns {boolean}
 * @doc https://stackoverflow.com/questions/7332179/how-to-recursively-search-all-parentnodes
 */
function findUpFunction(el, findFunction) {
  while (el.parentNode) {
    el = el.parentNode;
    if (findFunction(el)) return el;
  }
  return null;
}

/**
 * Funciones utiles comunes para cualquier archivo js
 */
/**
 * Elimina la clase del parametro del elememento el
 * @param {*} el
 * @param {*} className
 */
function removeClass(el, className) {
  if (el.classList) el.classList.remove(className);else if (hasClass(el, className)) {
    var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
    el.className = el.className.replace(reg, ' ');
  }
}
/**
 * Devuelve true si tiene el elemento el la clase className
 * @param {*} el
 * @param {*} className
 */
function hasClass(el, className) {
  if (el.classList) return el.classList.contains(className);
  if (el.className) {
    return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
  } else return false;
}
/**
 * Añade una clase a un elemento
 * @param {} el
 * @param {*} className
 */
function addClass(el, className) {
  if (el.classList) el.classList.add(className);else if (!hasClass(el, className)) el.className += ' ' + className;
}
/**
 * Remove wrapper (parent element) without removing the child
 * @fuente https://stackoverflow.com/questions/19261197/how-can-i-remove-wrapper-parent-element-without-removing-the-child
 */
function unwrap(node) {
  // Preservar todos los nodos hijos, incluyendo nodos de texto
  var fragment = document.createDocumentFragment();
  while (node.firstChild) {
    fragment.appendChild(node.firstChild);
  }
  node.replaceWith(fragment);
}
/**
 * https://stackoverflow.com/questions/2161634/how-to-check-if-element-has-any-children-in-javascript
 * @param node
 * @returns
 */
function hasChildElement(node) {
  var child, rv;
  if (node.children) {
    // Supports `children`
    rv = node.children.length !== 0;
  } else {
    // The hard way...
    rv = false;
    for (child = node.firstChild; !rv && child; child = child.nextSibling) {
      if (child.nodeType == 1) {
        // 1 == Element
        rv = true;
      }
    }
  }
  return rv;
}

//@ts-nocheck
var UtilsHighlightAndAnotation = /*#__PURE__*/function () {
  function UtilsHighlightAndAnotation(idMenu, idWrapContent, nameAttributeBackgroundColor, isNodeCanHighlighted) {
    this.getDataToSaveSelection = function (element) {};
    this.restoreSelection = function (selectors) {
      return {};
    };
    this.idMenu = '';
    this.idWrapContent = '';
    this.nameAttributeBackgroundColor = 'data-background-color';
    this.CLASS_ID_BEGIN = 'id-_-';
    this.CLASS_ID_END = '-_-end';
    this.CLASS_CLICK = 'hl-class-click';
    this.idMenu = idMenu;
    this.idWrapContent = idWrapContent;
    this.nameAttributeBackgroundColor = nameAttributeBackgroundColor;
    this.isNodeCanHighlighted = isNodeCanHighlighted;
    this.initSaveAndRestoreSelectionVars();
  }
  /**
   *
   * @param  id
   * @param  listenerClick funcion invocada cuando se hace click en el elemento y se le pasará como unico parametro la id del elemento
   * @param  colourHighlight es el color de los resaltes que se van hacer temporalmente, por defecto es yellow
   * @param  otherClassToAddList es un array de string de otras clases a añadir a todas las ocurrencias que tengamos en el dom
   * @param  otherClassToAddOnlyFirst es un array de string de otras clases a añadir a la primera ocurrencia que tengamos en el dom
   * @param {*} selectionUse Si nos dan esta variable va a ser la que usemos y sino lo va a calcular
   * @param {*} rangeUse  Si nos dan esta variable va a ser la que usemos y sino lo va a calcular
   * @param {*} enableDisableDesignMode Si es true dentro de esta funcion se habilita y desabilita el designedMode cuando corresponda
   */
  var _proto = UtilsHighlightAndAnotation.prototype;
  _proto.highlightUse = function highlightUse(id, listenerClick, colourHighlight, classHighlight, otherClassToAddList, otherClassToAddOnlyFirst, selectionUse, rangeUse, enableDisableDesignMode) {
    if (selectionUse === void 0) {
      selectionUse = null;
    }
    if (rangeUse === void 0) {
      rangeUse = null;
    }
    if (enableDisableDesignMode === void 0) {
      enableDisableDesignMode = true;
    }
    this.highlight(colourHighlight, selectionUse, rangeUse, enableDisableDesignMode);
    this.addAttributesToHighlight(colourHighlight, id, listenerClick, classHighlight, otherClassToAddList, otherClassToAddOnlyFirst);
    this.restoreBackgroundSections();
    this.clearTextSelection(); // == Deselecciono
  }
  /**
   * Resalta el texto seleccionado
   * @param {} colourHighlight
   * @param {*} selectionUse Si nos dan esta variable va a ser la que usemos y sino lo va a calcular
   * @param {*} rangeUse  Si nos dan esta variable va a ser la que usemos y sino lo va a calcular
   * @param {*} enableDisableDesignMode Si es true dentro de esta funcion se habilita y desabilita el designedMode cuando corresponda
   */;
  _proto.highlight = function highlight(colourHighlight, selectionUse, rangeUse, enableDisableDesignMode) {
    if (selectionUse === void 0) {
      selectionUse = null;
    }
    if (rangeUse === void 0) {
      rangeUse = null;
    }
    if (enableDisableDesignMode === void 0) {
      enableDisableDesignMode = true;
    }
    var range;
    // @ts-ignore
    if (window.getSelection) {
      // IE9 and non-IE
      try {
        if (!document.execCommand('BackColor', false, colourHighlight)) {
          this.makeEditableAndHighlight(colourHighlight, selectionUse, rangeUse, enableDisableDesignMode);
        } else {
          // == Aqui CREO que entra en los casos que hemos hecho una seleccion no valida, porque se haya pasado el intervalo de end
        }
      } catch (ex) {
        this.makeEditableAndHighlight(colourHighlight, selectionUse, rangeUse, enableDisableDesignMode);
      }
      // @ts-ignore
    } else if (document.selection && document.selection.createRange) {
      // IE <= 8 case
      // @ts-ignore
      range = document.selection.createRange();
      range.execCommand('BackColor', false, colourHighlight);
    }
  }
  //https://stackoverflow.com/questions/2582831/how-can-i-highlight-the-text-of-the-dom-range-object
  //https://stackoverflow.com/a/8106283/96100
  /**
   *
   * @param {*} colour
   * @param {*} selectionUse Si nos dan esta variable va a ser la que usemos y sino lo va a calcular
   * @param {*} rangeUse  Si nos dan esta variable va a ser la que usemos y sino lo va a calcular
   * @param {*} enableDisableDesignMode Si es true dentro de esta funcion se habilita y desabilita el designedMode cuando corresponda
   */;
  _proto.makeEditableAndHighlight = function makeEditableAndHighlight(colour, selectionUse, rangeUse, enableDisableDesignMode) {
    if (selectionUse === void 0) {
      selectionUse = null;
    }
    if (rangeUse === void 0) {
      rangeUse = null;
    }
    if (enableDisableDesignMode === void 0) {
      enableDisableDesignMode = true;
    }
    var range, sel;
    if (selectionUse && rangeUse) {
      range = rangeUse;
      sel = selectionUse;
      if (enableDisableDesignMode === true) document.designMode = 'on';
    } else {
      var _sel;
      sel = window.getSelection();
      if ((_sel = sel) != null && _sel.rangeCount && sel.getRangeAt) {
        range = sel.getRangeAt(0);
      }
      document.designMode = 'on';
      if (range) {
        var _sel2, _sel3;
        (_sel2 = sel) == null || _sel2.removeAllRanges();
        (_sel3 = sel) == null || _sel3.addRange(range);
      }
    }
    // Use HiliteColor since some browsers apply BackColor to the whole block
    if (!document.execCommand('HiliteColor', false, colour)) {
      document.execCommand('BackColor', false, colour);
    }
    if (enableDisableDesignMode === true) document.designMode = 'off';
  }
  /**
   *
   * @param  colourHighlight Color del resalte, por defecto yellow
   * @param  id
   * @param listenerClick funcion invocada cuando se hace click en el elemento y se le pasará como unico parametro la id del elemento
   * @param  otherClassToAddList es un array de string de otras clases a eliminar
   * @param  otherClassToAddOnlyFirst es un array de string de otras clases a añadir a la primera ocurrencia que tengamos en el dom
   */;
  _proto.addAttributesToHighlight = function addAttributesToHighlight(colourHighlight, id, listenerClick, classHighlight, otherClassToAddList, otherClassToAddOnlyFirst) {
    var _this = this;
    var nodes = this.getSelectedNodesSpanHighlight(colourHighlight);
    if (nodes) {
      var father = this;
      var counter = 0;
      nodes.filter(function (node) {
        addClass(node, classHighlight);
        if (counter === 0 && otherClassToAddOnlyFirst) {
          // Si es el primer elemento le añadimos lo que nos han indicado en otherClassToAddOnlyFirst
          var arrayLength = otherClassToAddOnlyFirst.length;
          for (var i = 0; i < arrayLength; i++) {
            addClass(node, otherClassToAddOnlyFirst[i]);
          }
        }
        if (otherClassToAddList) {
          var arrayLength = otherClassToAddList.length;
          for (var i = 0; i < arrayLength; i++) {
            addClass(node, otherClassToAddList[i]);
          }
        }
        addClass(node, father.getClassIdFromId(id));
        node.setAttribute('id', id);
        addClass(node, _this.CLASS_CLICK);
        counter++;
      });
    }
    this.addClickToAllHighlight(listenerClick, classHighlight);
  };
  _proto.getClassId = function getClassId(el) {
    var _this2 = this;
    var classId = null;
    var allClass = [];
    if (el.classList) {
      allClass = el.classList;
    } else {
      allClass = el.className.split(' ');
    }
    allClass.forEach(function (myClass) {
      if (myClass.startsWith(_this2.CLASS_ID_BEGIN)) {
        classId = myClass;
      }
    });
    return classId;
  };
  _proto.getClassIdFromId = function getClassIdFromId(id) {
    return this.CLASS_ID_BEGIN + id + this.CLASS_ID_END;
  };
  _proto.getIdElement = function getIdElement(el) {
    var id = '';
    if (el.id) {
      id = el.id;
    } else {
      var classId = this.getClassId(el);
      if (classId) {
        id = classId.substring(this.CLASS_ID_BEGIN.length, classId.length - this.CLASS_ID_END.length); // Le quito el ultimo caracter que es
      }
    }

    return id;
  }
  /**
   *
   * @param id
   * @param listenerClick funcion invocada cuando se hace click en el elemento y se le pasará como unico parametro la id del elemento
   */;
  _proto.addClickToAllHighlight = function addClickToAllHighlight(listenerClick, classHighlight) {
    var els = document.getElementsByClassName(classHighlight);
    var father = this;
    Array.prototype.forEach.call(els, function (el) {
      function handleAction(event, xEventTouch, yEventTouch) {
        event.stopPropagation();
        if (listenerClick) {
          var fatherId = father.getIdElement(el);
          var selectionCoords = father.getSelectionCoords(null, xEventTouch, yEventTouch);
          listenerClick(father.getIdElement(el), selectionCoords.x, selectionCoords.y);
        }
      }
      if (isIos() && 'ontouchstart' in document.documentElement) {
        el.addEventListener('touchstart', function (e) {
          handleAction(e, e.changedTouches[0].pageX, e.changedTouches[0].pageY);
        }, false);
      } else {
        el.onclick = function (event) {
          handleAction(event, null, null);
        };
      }
    });
  };
  _proto.isNodeCanHighlightedUse = function isNodeCanHighlightedUse(node) {
    return this.isNodeCanHighlighted ? this.isNodeCanHighlighted(node) : false;
  }
  /**
   *
   * @param  colourHighlight Por defecto yellow
   * @param  id  puede ser null
   * @param listenerClick funcion invocada cuando se hace click en el elemento y se le pasará como unico parametro la id del elemento
   * @param  otherClassToRemoveList es un array de string de otras clases a eliminar, ejemplo ["Hello","World"];
   */;
  _proto.removeAttributesToHighlight = function removeAttributesToHighlight(id, colourHighlight, classHighlight, otherClassToRemoveList) {
    var _this3 = this;
    var removeAttributesNode = function removeAttributesNode(node) {
      node.style.backgroundColor = '';
      node.removeAttribute('id');
      var classId = _this3.getClassId(node);
      if (classId) removeClass(node, classId);
      removeClass(node, classHighlight);
      removeClass(node, _this3.CLASS_CLICK);
      if (otherClassToRemoveList) {
        var arrayLength = otherClassToRemoveList.length;
        for (var i = 0; i < arrayLength; i++) {
          removeClass(node, otherClassToRemoveList[i]);
        }
      }
      node.onclick = function () {
        return false;
      };
      // This will also remove listeners on element's children.: https://stackoverflow.com/questions/19469881/remove-all-event-listeners-of-specific-type
      // Si no hay mas hijos que tengan la clase CLASS_CLICK una copia para eliminar los listener de los elementos hijos
      if (node.getElementsByClassName(_this3.CLASS_CLICK).length == 0) {
        var elClone = node.cloneNode(true);
        node.parentNode.replaceChild(elClone, node);
      } // En otro caso no le quito los listener a los hijos ya que haran falta para que sean clickables
    };
    /* Elimina los atributos buscando los nodos por classId */
    var removeAttibutesClassId = function removeAttibutesClassId() {
      var nodes = document.querySelectorAll(' .' + _this3.getClassIdFromId(id));
      if (nodes && nodes.length > 0) {
        for (var i in Object.keys(nodes)) {
          var node = nodes[i];
          removeAttributesNode(node);
        }
      }
    };
    if (id) {
      removeAttibutesClassId();
      removeAttibutesClassId(); // Lo hago una segunda vez por si ha quedado algo
    } else {
      var nodes = this.getSelectedNodesSpanHighlight(colourHighlight);
      if (nodes) {
        nodes.filter(function (node) {
          removeAttributesNode(node);
        });
      }
    }
  };
  _proto.getSelectedNodes = function getSelectedNodes() {
    if (window.getSelection) {
      var sel = window.getSelection();
      if (sel && !sel.isCollapsed) {
        return this.getRangeSelectedNodes(sel.getRangeAt(0));
      }
    }
    return [];
  };
  _proto.getSelectedNodesRangy = function getSelectedNodesRangy() {
    var selectedNodes = [];
    var sel = rangy.getSelection();
    for (var i = 0; i < sel.rangeCount; ++i) {
      selectedNodes = selectedNodes.concat(sel.getRangeAt(i).getNodes());
    }
    return selectedNodes;
  };
  _proto.getRangeSelectedNodes = function getRangeSelectedNodes(range) {
    var node = range.startContainer;
    var endNode = range.endContainer;
    // Special case for a range that is contained within a single node
    if (node == endNode) {
      return [node];
    }
    // Iterate nodes until we hit the end container
    var rangeNodes = [];
    while (node && node != endNode) {
      rangeNodes.push(node = this.nextNode(node));
    }
    // Add partially selected nodes at the start of the range
    node = range.startContainer;
    while (node && node != range.commonAncestorContainer) {
      rangeNodes.unshift(node);
      node = node.parentNode;
    }
    return rangeNodes;
  }
  /**
   * Devuelve true si todos sus hijos se permiten que esten subrayados
   * @param  node
   */;
  _proto.haveChildrenAlllowedHighlight = function haveChildrenAlllowedHighlight(node) {
    var invalidLocalNames = ['iframe', 'path', 'button', 'a'];
    var invalidClass = ['mint-video', 'mint-embed__video-wrapper'];
    if (node) {
      // ===============================
      // == Compruebo hijos de este nodo
      // ==============================
      var children = node.children;
      if (children) {
        var haveChildrenAllowed = true;
        for (var i = 0; i < children.length; i++) {
          var child = children[i];
          if (hasClass(child, 'icon-hamburger')) {
            // no se puede señalar el menu hamburguesa
            haveChildrenAllowed = false;
          }
          // no se puede señalar los localNames invalidos
          if (child && child.localName && invalidLocalNames.indexOf(child.localName) >= 0) {
            haveChildrenAllowed = false;
          }
          // no se pueden señalar las clases invalidas
          for (var indexInvalidClass = 0; indexInvalidClass < invalidClass.length; indexInvalidClass++) {
            var classInvalid = invalidClass[indexInvalidClass];
            if (hasClass(child, classInvalid)) {
              haveChildrenAllowed = false;
            }
          }
        }
        if (!haveChildrenAllowed) return false;
      }
      // ==================================
      // == Compruebo este nodo en cuestion
      // =================================
      // == No se puede resaltar lesson-intaractive-tabs__tab
      if (hasClass(node, 'lesson-intaractive-tabs__tab')) {
        // no se puede señalar las pestañas de un tab porque sino no nos va a dejar cambiar de pestaña y ademas te echa para fuera ya que al resaltar se le quitan los onclick que tenian que hacia que abriera el tab y se queda solo en un <a href="" ...
        return false;
      }
      // == No se puede resaltar los localNames invalidos
      if (node.localName && invalidLocalNames.indexOf(node.localName) >= 0) {
        return false;
      }
      // == No se pueden señalar las clases invalidas
      var haveClassInvalid = false;
      for (var _indexInvalidClass = 0; _indexInvalidClass < invalidClass.length; _indexInvalidClass++) {
        var _classInvalid = invalidClass[_indexInvalidClass];
        if (hasClass(node, _classInvalid)) {
          haveClassInvalid = true;
        }
      }
      if (haveClassInvalid) return false;
      // =================================
      // == Compruebo padres de este nodo
      // ================================
      var findUpIsNodeCanHighlighted = findUpFunction(node, this.isNodeCanHighlightedUse.bind(this));
      if (!findUpIsNodeCanHighlighted) {
        // Si no existe un padre que permite resaltes entonces no permito que este nodo esté subrayado
        return false;
      }
      // == No se puede señalar los nodos que tienen por encima localNames invalidos
      var findUpInvalidElement = findUpFunction(node, function (nodeUp) {
        if (nodeUp) {
          if (invalidLocalNames.indexOf(nodeUp.localName) >= 0) {
            return true;
          } else return false;
        } else return false;
      });
      if (findUpInvalidElement) {
        // Si existe un padre que tiene localNames invalidos entonce no permito que este nodo esté subrayado
        return false;
      }
      // == No se puede señalar los nodos que tienen por encima classNames invalidos
      var findUpInvalidClassName = findUpFunction(node, function (nodeUp) {
        if (nodeUp) {
          var haveClassInvalid = false;
          for (var _indexInvalidClass2 = 0; _indexInvalidClass2 < invalidClass.length; _indexInvalidClass2++) {
            var _classInvalid2 = invalidClass[_indexInvalidClass2];
            if (hasClass(nodeUp, _classInvalid2)) {
              haveClassInvalid = true;
            }
          }
          return haveClassInvalid;
        } else return false;
      });
      if (findUpInvalidClassName) {
        // Si existe un padre que tiene claseInvalida invalida entonce no permito que este nodo esté subrayado
        return false;
      }
    }
    return true;
  };
  _proto.isNodeHighlight = function isNodeHighlight(node, colourHighlight) {
    if (node && node.nodeType == 1) {
      var bg = node.style && node.style.backgroundColor ? node.style.backgroundColor : null;
      if (bg && (colourHighlight == bg || this.hex2rgb(colourHighlight) == bg)) {
        // https://stackoverflow.com/questions/8076341/remove-highlight-added-to-selected-text-using-javascript/8106283#8106283
        if (this.haveChildrenAlllowedHighlight(node)) {
          return true;
        } else {
          // Elimino su bakcground
          node.style.backgroundColor = '';
          if (node.outerHTML && node.outerHTML.lastIndexOf("<span style=\"\">", 0) === 0) {
            // Empieza por <span style=\"\">
            if (hasChildElement(node)) {
              // console.log('unwrap', node);
              // Elimino el nodo <span style> https://stackoverflow.com/questions/19261197/how-can-i-remove-wrapper-parent-element-without-removing-the-child
              unwrap(node);
            }
          }
          return false;
        }
      }
    }
    return false;
  }
  /**
   *
   * @param win
   * @fuente http://stackoverflow.com/a/6847328
   * @xEventTouch Coordenada x del evento touch si existe
   * @yEventTouch Coordenada y del evento touch si existe
   * @param {*} idMenu Id del menu contextua
   * @param {*} idWrapContent Identificador del div que envuelve al contenido y al menu
   */;
  _proto.getSelectionCoords = function getSelectionCoords$1(win, xEventTouch, yEventTouch) {
    return getSelectionCoords({
      // == ISelectionCoords / IConfigSelectionCoords
      nameAttributeBackgroundColor: this.nameAttributeBackgroundColor,
      isNodeCanHighlighted: this.isNodeCanHighlighted ? this.isNodeCanHighlighted : function (node) {
        return false;
      },
      // == ISelectionCoords / Resto
      win: win,
      xEventTouch: xEventTouch,
      yEventTouch: yEventTouch,
      isXLeft: true,
      collapse: true,
      idMenu: this.idMenu,
      idWrapContent: this.idWrapContent
    });
  };
  _proto.nextNode = function nextNode(node) {
    if (node.hasChildNodes()) {
      return node.firstChild;
    } else {
      while (node && !node.nextSibling) {
        node = node.parentNode;
      }
      if (!node) {
        return null;
      }
      return node.nextSibling;
    }
  };
  _proto.hex2rgb = function hex2rgb(colour) {
    var r, g, b;
    if (colour.charAt(0) == '#') {
      colour = colour.substr(1);
    }
    if (colour.length == 3) {
      colour = colour.substr(0, 1) + colour.substr(0, 1) + colour.substr(1, 2) + colour.substr(1, 2) + colour.substr(2, 3) + colour.substr(2, 3);
    }
    r = colour.charAt(0) + '' + colour.charAt(1);
    g = colour.charAt(2) + '' + colour.charAt(3);
    b = colour.charAt(4) + '' + colour.charAt(5);
    r = parseInt(r, 16);
    g = parseInt(g, 16);
    b = parseInt(b, 16);
    return 'rgb(' + r + ', ' + g + ', ' + b + ')';
  }
  /**
   * Mira todas las section y si hay alguna que debe de tener background y no lo tiene se lo pone
   */;
  _proto.restoreBackgroundSections = function restoreBackgroundSections() {
    var els = document.getElementsByClassName('lesson__section');
    var father = this;
    Array.prototype.forEach.call(els, function (el) {
      if (el.hasAttribute(father.nameAttributeBackgroundColor)) {
        var dataBackgroundColor = el.getAttribute(father.nameAttributeBackgroundColor);
        if (father.nameAttributeBackgroundColor === 'data-background') {
          // == Entonces va a ser background
          var bg = el.style.background;
          if (dataBackgroundColor && !bg) {
            el.style.background = dataBackgroundColor;
          }
        } else {
          // == Entonces va a ser backgroundColor
          var bg = el.style.backgroundColor;
          if (dataBackgroundColor && !bg) {
            el.style.backgroundColor = dataBackgroundColor;
          }
        }
      }
    });
  };
  _proto.clearTextSelection = function clearTextSelection() {
    if (window.getSelection) {
      var _window$getSelection, _window$getSelection3;
      if ((_window$getSelection = window.getSelection()) != null && _window$getSelection.empty) {
        var _window$getSelection2;
        // Chrome
        (_window$getSelection2 = window.getSelection()) == null || _window$getSelection2.empty();
      } else if ((_window$getSelection3 = window.getSelection()) != null && _window$getSelection3.removeAllRanges) {
        var _window$getSelection4;
        // Firefox
        (_window$getSelection4 = window.getSelection()) == null || _window$getSelection4.removeAllRanges();
      }
    } else if (document.selection) {
      // IE?
      document.selection.empty();
    }
  }
  /**
   *
   * @param  id
   * @param colourHighlight Por defecto yellow
   * @param  listenerClick funcion invocada cuando se hace click en el elemento y se le pasará como unico parametro la id del elemento
   * @param  otherClassToRemoveList es un array de string de otras clases a eliminar
   * @param clearTextSelectionWhenFinish si es true cuando termine la operacion de unhighligh va a limpiar el texto seleccionado por el usuario (this.clearTextSelection();)
   */;
  _proto.unhighlightUse = function unhighlightUse(id, colourHighlight, classHighlight, otherClassToRemoveList, clearTextSelectionWhenFinish) {
    this.removeAttributesToHighlight(id, colourHighlight, classHighlight, otherClassToRemoveList);
    // == Deselecciono
    if (clearTextSelectionWhenFinish) this.clearTextSelection();
  };
  _proto.getRange = function getRange(containerEl, savedSel, idDivSelectText) {
    if (containerEl) {
      var charIndex = 0,
        range = document.createRange();
      range.setStart(containerEl, 0);
      range.collapse(true);
      var nodeStack = [containerEl],
        node,
        foundStart = false,
        stop = false;
      while (!stop && (node = nodeStack.pop())) {
        if (node.nodeType == 3) {
          var nextCharIndex = charIndex + node.length;
          if (!foundStart && savedSel.start >= charIndex && savedSel.start <= nextCharIndex) {
            range.setStart(node, savedSel.start - charIndex);
            foundStart = true;
          }
          if (foundStart && savedSel.end >= charIndex && savedSel.end <= nextCharIndex) {
            range.setEnd(node, savedSel.end - charIndex);
            stop = true;
          }
          charIndex = nextCharIndex;
        } else {
          var i = node.childNodes.length;
          while (i--) {
            nodeStack.push(node.childNodes[i]);
          }
        }
      }
      return range;
    } else return null;
  };
  _proto.initSaveAndRestoreSelectionVars = function initSaveAndRestoreSelectionVars() {
    if (window.getSelection) {
      this.getDataToSaveSelection = function (containerEl) {
        var range = window.getSelection().getRangeAt(0);
        var preSelectionRange = range.cloneRange();
        preSelectionRange.selectNodeContents(containerEl);
        preSelectionRange.setEnd(range.startContainer, range.startOffset);
        var start = preSelectionRange.toString().length;
        return {
          start: start,
          end: start + range.toString().length
        };
      };
      var father = this;
      this.restoreSelection = function (containerEl, savedSel, idDivSelectText) {
        var range = father.getRange(containerEl, savedSel, idDivSelectText);
        if (range) {
          var sel = window.getSelection();
          sel == null || sel.removeAllRanges();
          sel == null || sel.addRange(range);
          return {
            selectionUse: sel,
            rangeUse: range
          };
        } else {
          // if (savedSel)
          //  console.log('Problema al cargar, no existe el nodo ' + idDivSelectText + ' ' + JSON.stringify(savedSel));
          return {};
        }
      };
    } else if (document.selection) {
      this.getDataToSaveSelection = function (containerEl) {
        var selectedTextRange = document.selection.createRange();
        var preSelectionTextRange = document.body.createTextRange();
        preSelectionTextRange.moveToElementText(containerEl);
        preSelectionTextRange.setEndPoint('EndToStart', selectedTextRange);
        var start = preSelectionTextRange.text.length;
        return {
          start: start,
          end: start + selectedTextRange.text.length
        };
      };
      this.restoreSelection = function (containerEl, savedSel, idDivSelectText) {
        if (containerEl) {
          var textRange = document.body.createTextRange();
          textRange.moveToElementText(containerEl);
          textRange.collapse(true);
          textRange.moveEnd('character', savedSel.end);
          textRange.moveStart('character', savedSel.start);
          textRange.select();
          return {};
        } else {
          // if (savedSel)
          //   console.log('Problema al cargar, no existe el nodo ' + idDivSelectText + ' ' + JSON.stringify(savedSel));
          return {};
        }
      };
    }
  }
  /**
   * Comprueba si no hay texto seleccionado lo vuelve a seleccionar con los parametros pasados
   * @param {*} idDivSelectText
   * @param {*} start
   * @param {*} end
   */;
  _proto.restoreSelectionIfNotSelected = function restoreSelectionIfNotSelected(idDivSelectText, start, end) {
    var selectionText = getSelectionText();
    if (selectionText != null && selectionText.length == 0) {
      // == Antes era new UtilsHighlightAndAnotation().restoreSelection...
      // TODO: adaptar
      return this.restoreSelection(document.getElementById(idDivSelectText), {
        start: start,
        end: end
      }, idDivSelectText);
    } else {
      return {};
    }
  };
  _proto.getSelectedTextWithin = function getSelectedTextWithin(el) {
    var selectedText = '';
    if (typeof window.getSelection != 'undefined') {
      var sel = window.getSelection(),
        rangeCount;
      if (sel && (rangeCount = sel.rangeCount) > 0) {
        var range = document.createRange();
        for (var i = 0, selRange; i < rangeCount; ++i) {
          range.selectNodeContents(el);
          selRange = sel.getRangeAt(i);
          if (selRange.compareBoundaryPoints(range.START_TO_END, range) == 1 && selRange.compareBoundaryPoints(range.END_TO_START, range) == -1) {
            if (selRange.compareBoundaryPoints(range.START_TO_START, range) == 1) {
              range.setStart(selRange.startContainer, selRange.startOffset);
            }
            if (selRange.compareBoundaryPoints(range.END_TO_END, range) == -1) {
              range.setEnd(selRange.endContainer, selRange.endOffset);
            }
            var start = range.toString().length;
            var pos = {
              start: start,
              end: start + selRange.toString().length
            };
            selectedText += range.toString();
          }
        }
      }
    } else if (typeof document.selection != 'undefined' && document.selection.type == 'Text') {
      var selTextRange = document.selection.createRange();
      var textRange = selTextRange.duplicate();
      textRange.moveToElementText(el);
      if (selTextRange.compareEndPoints('EndToStart', textRange) == 1 && selTextRange.compareEndPoints('StartToEnd', textRange) == -1) {
        if (selTextRange.compareEndPoints('StartToStart', textRange) == 1) {
          textRange.setEndPoint('StartToStart', selTextRange);
        }
        if (selTextRange.compareEndPoints('EndToEnd', textRange) == -1) {
          textRange.setEndPoint('EndToEnd', selTextRange);
        }
        selectedText = textRange.text;
      }
    }
    return selectedText;
  };
  _proto.getSelectedTextWithinRangy = function getSelectedTextWithinRangy(el) {
    var selectedText = '';
    var sel = rangy.getSelection(),
      rangeCount = sel.rangeCount;
    var range = rangy.createRange();
    range.selectNodeContents(el);
    for (var i = 0; i < rangeCount; ++i) {
      selectedText += sel.getRangeAt(i).intersection(range);
    }
    return selectedText;
  };
  _proto.getStartEndWithinRangy = function getStartEndWithinRangy(el) {
    var sel = rangy.getSelection(),
      rangeCount = sel.rangeCount;
    var range = rangy.createRange();
    range.selectNodeContents(el);
    var toRet = undefined;
    for (var i = 0; i < rangeCount; ++i) {
      var intersection = sel.getRangeAt(i).intersection(range);
      if (intersection) {
        var start = intersection.startOffset;
        toRet = {
          start: start,
          end: start + intersection.toString().length
        };
      }
    }
    return toRet;
  }
  /**
   * https://stackoverflow.com/questions/4811822/get-a-ranges-start-and-end-offsets-relative-to-its-parent-container
   * @param element
   * @returns
   */;
  _proto.getCaretCharacterOffsetWithin = function getCaretCharacterOffsetWithin(element) {
    var caretOffset = 0;
    var doc = element.ownerDocument || element.document;
    var win = doc.defaultView || doc.parentWindow;
    var sel;
    if (typeof win.getSelection != 'undefined') {
      sel = win.getSelection();
      if (sel.rangeCount > 0) {
        var range = win.getSelection().getRangeAt(0);
        var preCaretRange = range.cloneRange();
        preCaretRange.selectNodeContents(element);
        preCaretRange.setEnd(range.endContainer, range.endOffset);
        caretOffset = preCaretRange.toString().length;
      }
    } else if ((sel = doc.selection) && sel.type != 'Control') {
      var textRange = sel.createRange();
      var preCaretTextRange = doc.body.createTextRange();
      preCaretTextRange.moveToElementText(element);
      preCaretTextRange.setEndPoint('EndToEnd', textRange);
      caretOffset = preCaretTextRange.text.length;
    }
    return caretOffset;
  }
  /**
   * https://stackoverflow.com/questions/4811822/get-a-ranges-start-and-end-offsets-relative-to-its-parent-container
   * @param element
   * @returns
   */;
  _proto.getStartEndRespectElement = function getStartEndRespectElement(element, selectText) {
    var start = 0;
    var end = 0;
    var doc = element.ownerDocument || element.document;
    var win = doc.defaultView || doc.parentWindow;
    var sel;
    if (typeof win.getSelection != 'undefined') {
      sel = win.getSelection();
      if (sel.rangeCount > 0) {
        var range = win.getSelection().getRangeAt(0);
        var preCaretRange = range.cloneRange();
        preCaretRange.selectNodeContents(element);
        preCaretRange.setEnd(range.startContainer, range.startOffset);
        start = preCaretRange.toString().length;
        // end = preCaretRange.toString().length;
        end = start + selectText.length; // == Con esto no lo hace bien cuando hay varios intervalos => preCaretRange.toString().length;
      }
    } else if ((sel = doc.selection) && sel.type != 'Control') {
      var textRange = sel.createRange();
      var preCaretTextRange = doc.body.createTextRange();
      preCaretTextRange.moveToElementText(element);
      preCaretTextRange.setEndPoint('EndToStart', textRange);
      start = preCaretTextRange.text.length;
      preCaretTextRange.setEndPoint('EndToEnd', textRange);
      // end = preCaretTextRange.text.length;
      end = start + selectText.length; // == Con esto no lo hace bien cuando hay varios intervalos => preCaretTextRange.text.length;
    }

    return {
      start: start,
      end: end
    };
  };
  _proto.getInputSelection = function getInputSelection(el) {
    var start = 0,
      end = 0,
      normalizedValue,
      range,
      textInputRange,
      len,
      endRange;
    if (typeof el.selectionStart == 'number' && typeof el.selectionEnd == 'number') {
      start = el.selectionStart;
      end = el.selectionEnd;
    } else {
      range = document.selection.createRange();
      if (range && range.parentElement() == el) {
        len = el.value.length;
        normalizedValue = el.value.replace(/\r\n/g, '\n');
        // Create a working TextRange that lives only in the input
        textInputRange = el.createTextRange();
        textInputRange.moveToBookmark(range.getBookmark());
        // Check if the start and end of the selection are at the very end
        // of the input, since moveStart/moveEnd doesn't return what we want
        // in those cases
        endRange = el.createTextRange();
        endRange.collapse(false);
        if (textInputRange.compareEndPoints('StartToEnd', endRange) > -1) {
          start = end = len;
        } else {
          start = -textInputRange.moveStart('character', -len);
          start += normalizedValue.slice(0, start).split('\n').length - 1;
          if (textInputRange.compareEndPoints('EndToEnd', endRange) > -1) {
            end = len;
          } else {
            end = -textInputRange.moveEnd('character', -len);
            end += normalizedValue.slice(0, end).split('\n').length - 1;
          }
        }
      }
    }
    return {
      start: start,
      end: end
    };
  };
  _proto.getSelectedNodesCanHighlighted = function getSelectedNodesCanHighlighted() {
    var toRet = [];
    var selectedNodes = this.getSelectedNodes();
    if (selectedNodes) {
      var father = this;
      // Verifico los nodos raiz
      toRet = selectedNodes.filter(function (node) {
        return father.isNodeCanHighlighted(node);
      });
      // Verifico sus padres
      selectedNodes.forEach(function (node) {
        // == Mira en los padres hasta que encuentre un padre que cumpla la funcion isNodeCanHighlighted
        if (node) {
          var findUp = findUpFunction(node, father.isNodeCanHighlighted);
          if (findUp && !toRet.includes(findUp)) {
            toRet.push(findUp);
          }
        }
      });
    }
    return toRet;
  };
  _proto.getSelectedNodesSpanHighlight = function getSelectedNodesSpanHighlight(colourHighlight) {
    var toRet = [];
    var selectedNodes = this.getSelectedNodes();
    if (selectedNodes) {
      var father = this;
      toRet = selectedNodes.filter(function (node) {
        return father.isNodeHighlight(node, colourHighlight);
      });
      // verifico sus padres
      selectedNodes.forEach(function (node) {
        // == Mira en los padres hasta que encuentre un padre que cumpla la funcion
        if (node) {
          var findUp = findUpFunction(node, function (nodeInside) {
            return father.isNodeHighlight(nodeInside, colourHighlight);
          });
          if (findUp && !toRet.includes(findUp)) {
            toRet.push(findUp);
          }
        }
      });
    }
    return toRet;
  };
  return UtilsHighlightAndAnotation;
}();

function useSelectText(props) {
  var idDivSelectText = props.idDivSelectText,
    hasSelectedText = props.hasSelectedText,
    hasNotSelectedText = props.hasNotSelectedText,
    selectedTextMenuVisible = props.selectedTextMenuVisible,
    removeSelectedTextMenuVisible = props.removeSelectedTextMenuVisible,
    selectionCoords = props.selectionCoords,
    idMenu = props.idMenu,
    idWrapContent = props.idWrapContent;
  var timeWaitLauncherSelectionEnd = 500;
  var isEnabledSelectedText = useRef(true); // Antes estaba en un singleton
  var isEnabledHasNotSelectedText = useRef(true); // Antes estaba en un singleton
  var _handleUserSelectionChanged = useRef(userSelectionChanged);
  var _handleSelectionEnd = useRef(selectionEnd);
  var _isProcessHighlightState = useRef(false);
  var _selectionEndTimeout = useRef(undefined);
  var _dataToSaveSelection = useRef(undefined);
  var _utilsHighlightAndAnotation = useRef(new UtilsHighlightAndAnotation(idMenu, idWrapContent, selectionCoords.nameAttributeBackgroundColor, selectionCoords.isNodeCanHighlighted));
  var selectionCoordsRef = useRef(selectionCoords); // Para tener un valor actualizado para usarlo dentro de timeouts
  selectionCoordsRef.current = selectionCoords;
  var _useState = useState({});
  useEffect(function () {
    addListenerSelectionChange();
    addListenerSelectionEnd();
    return function () {
      removeListenerSelectionChange();
      removeListenerSelectionEnd();
    };
  }, []);
  function addListenerSelectionChange() {
    document.addEventListener('selectionchange', _handleUserSelectionChanged.current);
  }
  function removeListenerSelectionChange() {
    document.removeEventListener('selectionchange', _handleUserSelectionChanged.current);
  }
  function addListenerSelectionEnd() {
    window.addEventListener('selectionEnd', _handleSelectionEnd.current); // add the listener
  }

  function removeListenerSelectionEnd() {
    window.removeEventListener('selectionEnd', _handleSelectionEnd.current); // remove the listener
  }

  function userSelectionChanged() {
    if (!_isProcessHighlightState.current) {
      // == wait 500 ms after the last selection change event
      if (_selectionEndTimeout.current) {
        clearTimeout(_selectionEndTimeout.current);
        //console.log('<li>User Selection Changed</li>');
      }

      _selectionEndTimeout.current = setTimeout(function () {
        if (!_isProcessHighlightState.current) {
          // == Adaptacion para IE11
          var event;
          if (typeof Event === 'function') {
            event = new Event('selectionEnd');
          } else {
            event = document.createEvent('Event');
            event.initEvent('selectionEnd', true, true);
          }
          window.dispatchEvent(event);
          // == Fin Adaptacion para IE11
          //window.dispatchEvent( new Event('selectionEnd') ); // Antes de adaptar a IE11
        }
      }, timeWaitLauncherSelectionEnd);
    }
  }
  function selectionEnd() {
    _selectionEndTimeout.current = null; // == reset selection timeout
    var selectedText = getSelectionText(); // == get user selection
    if (selectedText != '') {
      if (isEnabledSelectedText.current) {
        // == Selección General
        _dataToSaveSelection.current = _utilsHighlightAndAnotation.current.getDataToSaveSelection(document.getElementById(idDivSelectText));
        var selectionCoords = _getSelectionCoords(undefined);
        var selectionGeneral = {
          selectedText: selectedText,
          x: selectionCoords.x,
          y: selectionCoords.y,
          idDivSelectText: idDivSelectText,
          start: _dataToSaveSelection.current.start,
          end: _dataToSaveSelection.current.end
        };
        // == Selecciones
        var selections = [];
        var selectedNodesCanHighlighted = _utilsHighlightAndAnotation.current.getSelectedNodesCanHighlighted();
        for (var index = 0; index < selectedNodesCanHighlighted.length; index++) {
          var nodeCanHighlighted = selectedNodesCanHighlighted[index];
          var idNode = nodeCanHighlighted.id;
          var selectText = _utilsHighlightAndAnotation.current.getSelectedTextWithinRangy(document.getElementById(idNode));
          var startEnd = _utilsHighlightAndAnotation.current.getStartEndRespectElement(document.getElementById(idNode), selectText);
          selections.push({
            selectedText: selectText,
            idDivSelectText: idNode,
            start: startEnd == null ? void 0 : startEnd.start,
            end: startEnd == null ? void 0 : startEnd.end
          });
        }
        hasSelectedText(selectionGeneral, selections);
      }
    } else {
      // En safari en ios entra aqui cuando haces click en un boton del cuadro de dialogo de seleccionar texto y no deberia de entrar. Se ve que es un problema del evento  window.addEventListener('selectionEnd', this.handleSelectionEnd);
      if (isSomeOpenMenu()) ; else {
        if (isEnabledHasNotSelectedText.current) {
          hasNotSelectedText();
        }
      }
    }
  }
  /**
   *
   * @param win
   * @fuente http://stackoverflow.com/a/6847328
   */
  function _getSelectionCoords(win) {
    if (win === void 0) {
      win = undefined;
    }
    return getSelectionCoords(_extends({}, selectionCoordsRef.current, {
      win: win,
      isXLeft: false,
      collapse: false,
      idMenu: idMenu,
      idWrapContent: idWrapContent
    }));
  }
  /**
   * Nos indica si hay algun menu contextual de seleccion de texto abierto
   */
  function isSomeOpenMenu() {
    return selectedTextMenuVisible || removeSelectedTextMenuVisible;
  }
  function setIsEnabledSelectedText(_isEnabledSelectedText) {
    isEnabledSelectedText.current = _isEnabledSelectedText;
  }
  function setIsEnabledHasNotSelectedText(_isEnabledHasNotSelectedText) {
    isEnabledHasNotSelectedText.current = _isEnabledHasNotSelectedText;
  }
  return {
    removeListenerSelectionChange: removeListenerSelectionChange,
    addListenerSelectionChange: addListenerSelectionChange,
    setIsEnabledSelectedText: setIsEnabledSelectedText,
    setIsEnabledHasNotSelectedText: setIsEnabledHasNotSelectedText
  };
}

var _path$2;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/createElement("svg", _extends$4({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29289 7.29289C5.68342 6.90237 6.31658 6.90237 6.70711 7.29289L10 10.5858L13.2929 7.29289C13.6834 6.90237 14.3166 6.90237 14.7071 7.29289C15.0976 7.68342 15.0976 8.31658 14.7071 8.70711L10.7071 12.7071C10.3166 13.0976 9.68342 13.0976 9.29289 12.7071L5.29289 8.70711C4.90237 8.31658 4.90237 7.68342 5.29289 7.29289Z",
    fill: "#828282"
  })));
};

function useSelectColorHighlight(props) {
  var _useState = useState({
      showListColorHighlight: false
    }),
    state = _useState[0],
    dispatch = _useState[1];
  function onclickSpinnerColorHighlight(e) {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        showListColorHighlight: !prevState.showListColorHighlight
      });
    });
  }
  return {
    onclickSpinnerColorHighlight: onclickSpinnerColorHighlight,
    showListColorHighlight: state.showListColorHighlight
  };
}

var getClassColor = function getClassColor(numColor) {
  return CLASS_COLOR_PREFIX + numColor;
};
var CLASS_COLOR_PREFIX = 'hl-select-text__color--';
var DEFAULT_COLOR = '01';
var DEFAULT_CLASS_COLOR = /*#__PURE__*/getClassColor(DEFAULT_COLOR);
var NUMBER_MAX_COLOR = 8;
function SelectColorHighlight(props) {
  var onClickOptionSpinnerColorHighlight = props.onClickOptionSpinnerColorHighlight,
    colorActiveHighlight = props.colorActiveHighlight;
  var _useSelectColorHighli = useSelectColorHighlight(),
    onclickSpinnerColorHighlight = _useSelectColorHighli.onclickSpinnerColorHighlight,
    showListColorHighlight = _useSelectColorHighli.showListColorHighlight;
  var colors = [];
  var _loop = function _loop() {
    var numColor = i + 1 + '';
    if (numColor.length === 1) numColor = '0' + numColor; // Al menos dos cifras si era 1 sera 01
    var classColor = getClassColor(numColor);
    colors.push( /*#__PURE__*/React__default.createElement("div", {
      key: classColor,
      className: 'hl-select-color-highlight__color-color ' + classColor,
      onClick: function onClick(e) {
        return onClickOptionSpinnerColorHighlight(e, numColor);
      }
    }, "abc"));
  };
  for (var i = 0; i < NUMBER_MAX_COLOR; i++) {
    _loop();
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'hl-select-color-highlight',
    onClick: function onClick(e) {
      e.stopPropagation();
      e.preventDefault();
      onclickSpinnerColorHighlight(e);
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'hl-select-color-highlight__color-and-arrow'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'hl-select-color-highlight__color hl-select-color-highlight__color--active ' + (colorActiveHighlight && colorActiveHighlight.length > 0 ? getClassColor(colorActiveHighlight) : '')
  }, "abc"), /*#__PURE__*/React__default.createElement("div", {
    className: 'hl-select-color-highlight__arrow'
  }, /*#__PURE__*/React__default.createElement(SvgChevronDown, null))), /*#__PURE__*/React__default.createElement("div", {
    className: 'hl-select-color-highlight__color-list' + (showListColorHighlight || isIos() ? '' : ' hl-select-color-highlight__color-list--hidden')
  }, colors));
}

function getGuid() {
  return v4();
}

function getNewHighlight(selectionGeneral, selections, color) {
  var newHighlight = {
    guid: getGuid(),
    selectedText: selectionGeneral.selectedText,
    idDivSelectText: selectionGeneral.idDivSelectText,
    start: selectionGeneral.start,
    end: selectionGeneral.end,
    color: color,
    selections: selections ? selections.map(function (_selection) {
      return _extends({
        guid: getGuid(),
        color: color
      }, _selection);
    }) : []
  };
  return newHighlight;
}
function getHighlightEditColor(highlight, selection, newColor) {
  var newHighlight = _extends({}, highlight, {
    selections: highlight.selections.map(function (_selection) {
      return _selection.guid === selection.guid ? _extends({}, _selection, {
        color: newColor
      }) : _extends({}, _selection);
    })
  });
  return newHighlight;
}
function getHighlightRemoveSelection(highlight, selection) {
  var newHighlight = _extends({}, highlight, {
    selections: highlight.selections.filter(function (_selection) {
      return _selection.guid !== selection.guid;
    })
  });
  return newHighlight;
}
function createHighlight(selectionGeneral, selections, color, configHighlights, onClickHighlight, addHighlightToState, restoreSelection, restoreSelectionIfNotSelected, highlightUse) {
  if (configHighlights && Object.prototype.hasOwnProperty.call(configHighlights, 'createHighlight')) {
    var newHighlight = getNewHighlight(selectionGeneral, selections, color);
    if (newHighlight) {
      configHighlights.createHighlight(newHighlight, function (newHighlightCreate) {
        if (newHighlightCreate) {
          addHighlightToState(newHighlightCreate);
          // == Si se ha deseleccionado el texto Vuelvo a seleccionarlo, añadido para ios => TODO: Ahora en vez de usar  restoreSelectionIfNotSelected se usa restoreSelection, probarlo en IOS si va bien
          paintHighlight(newHighlightCreate, onClickHighlight, restoreSelection, restoreSelectionIfNotSelected, false, highlightUse, false, undefined);
        }
      }, function (err) {
        console.log('create err');
        console.log(err);
      });
    }
  }
}
/* function CancelSelection() {
  if (window.getSelection) {
    // all browsers, except IE before version 9
    var myRange = window.getSelection();
    myRange?.removeAllRanges();
  } else {
    document.selection.empty();
  }
} */
function editColorHighlightSelection(highlight, selection, newColor, configHighlights, onClickHighlight, editHighlightToState, restoreSelection, restoreSelectionIfNotSelected, highlightUse, unhighlightUse) {
  if (configHighlights && Object.prototype.hasOwnProperty.call(configHighlights, 'editHighlight')) {
    var oldColor = selection.color;
    var oldClassColor = getClassColor(oldColor);
    var highlightEdited = getHighlightEditColor(highlight, selection, newColor);
    if (highlightEdited) {
      configHighlights.editHighlight(highlightEdited.guid, highlightEdited, function (_highlightEdited) {
        if (_highlightEdited) {
          unhighlightUse(selection.guid, oldClassColor, function () {});
          // == Lo resalto
          editHighlightToState(_highlightEdited);
          // == Si se ha deseleccionado el texto Vuelvo a seleccionarlo, añadido para ios
          paintHighlight(_highlightEdited, onClickHighlight, restoreSelection, restoreSelectionIfNotSelected, false, highlightUse, false, [selection]);
        }
      }, function (err) {
        console.log('create err');
        console.log(err);
      });
    }
  }
}
function removeHighlightSelection(highlight, selection, configHighlights, editHighlightToState, delHighlightToState, restoreSelectionIfNotSelected, unhighlightUse) {
  if (configHighlights && Object.prototype.hasOwnProperty.call(configHighlights, 'delHighlight')) {
    var oldColor = selection.color;
    var oldClassColor = getClassColor(oldColor);
    var highlightEdited = getHighlightRemoveSelection(highlight, selection);
    if (highlightEdited) {
      if (highlightEdited.selections.length === 0) {
        // == Si no hay selecciones elimino el highlight
        configHighlights.delHighlight(highlightEdited.guid, function () {
          // == Si se ha deseleccionado el texto Vuelvo a seleccionarlo, añadido para ios
          restoreSelectionIfNotSelected(selection.idDivSelectText, selection.start, selection.end);
          unhighlightUse(selection.guid, oldClassColor, function () {});
          delHighlightToState(highlight.guid);
        }, function (err) {
          console.log('create err');
          console.log(err);
        });
      } else {
        // == Aun quedan selecciones
        configHighlights.editHighlight(highlightEdited.guid, highlightEdited, function (_highlightEdited) {
          if (_highlightEdited) {
            // == Si se ha deseleccionado el texto Vuelvo a seleccionarlo, añadido para ios
            restoreSelectionIfNotSelected(selection.idDivSelectText, selection.start, selection.end);
            unhighlightUse(selection.guid, oldClassColor, function () {});
            editHighlightToState(highlightEdited);
          }
        }, function (err) {
          console.log('create err');
          console.log(err);
        });
      }
    }
  }
}
/**
 *
 * @param highlight
 * @param onClickHighlight
 * @param restoreSelection
 * @param restoreSelectionIfNotSelected
 * @param shouldRestoreSelectionIfNotSelected
 * @param highlightUse
 * @param ignoreDesignMode Si es true ignora la instruccion de document.designMode que se hace antes y despues del pintado. Si hago un pintado individual poner ignoreDesighMode = false para que ejecute esas instrucciones, y si esta funcion la llamo dentro de un pintado global de muchos, como esa funcion ya hace sus propios desighMode pasarle true para que no los haga aqui
 * @param onlyThisSelections si tiene valor entonces va a pintar solo las selecciones pasadas en este parametro
 */
function paintHighlight(highlight, onClickHighlight, restoreSelection, restoreSelectionIfNotSelected, shouldRestoreSelectionIfNotSelected, highlightUse, ignoreDesignMode, onlyThisSelections) {
  if (highlight != null) {
    if (!ignoreDesignMode) document.designMode = 'on'; // Importante lo hago fuera del bucle una sola vez
    var _loop = function _loop() {
      var selection = highlight.selections[indexSelections];
      var canPaint = true;
      if (onlyThisSelections && onlyThisSelections.length > 0) {
        if (onlyThisSelections.find(function (onlySelection) {
          return onlySelection.guid === selection.guid;
        })) {
          // Comparar con find y no comparar con indexOf porque el color de una seleccion y de la otra es distinto por lo que el objeto como tal es distinto
          canPaint = true;
        } else canPaint = false;
      }
      if (canPaint) {
        var containerEl = document.getElementById(selection.idDivSelectText);
        if (containerEl) {
          var savedSel = {
            start: selection.start,
            end: selection.end
          };
          var idDivSelectText = selection.idDivSelectText;
          var returnRestore = null;
          if (shouldRestoreSelectionIfNotSelected) {
            returnRestore = restoreSelectionIfNotSelected(selection.idDivSelectText, selection.start, selection.end);
          } else {
            returnRestore = restoreSelection(containerEl, savedSel, idDivSelectText);
          }
          highlightUse(selection.guid, onClickHighlight, getClassColor(selection.color), returnRestore ? returnRestore.selectionUse : null, returnRestore ? returnRestore.rangeUse : null, true);
        }
      }
    };
    for (var indexSelections = 0; indexSelections < highlight.selections.length; indexSelections++) {
      _loop();
    }
    if (!ignoreDesignMode) document.designMode = 'off'; // Importante lo hago fuera del bucle una sola vez
  }
}

var CLASS_HIGHLIGHT = 'hl-highlight';
var COLOR_HIGHLIGHT = 'yellow';
var CLASS_NO_SELECT = 'hl-noselect';
function useHighlighter(props) {
  var idDivSelectText = props.idDivSelectText,
    hasSelectedText = props.hasSelectedText,
    hasNotSelectedText = props.hasNotSelectedText,
    config = props.config,
    idMenu = props.idMenu,
    idWrapContent = props.idWrapContent,
    _props$isContentReady = props.isContentReady,
    isContentReady = _props$isContentReady === void 0 ? false : _props$isContentReady,
    refresh = props.refresh;
  var onChangeState = useRef(null);
  var _utilsHighlightAndAnotation = useRef(new UtilsHighlightAndAnotation(idMenu, idWrapContent, config.selectionCoords.nameAttributeBackgroundColor, config.selectionCoords.isNodeCanHighlighted));
  var defaultState = {
    selectedTextMenu: {
      isVisible: false
    },
    removeSelectedTextMenu: {
      isVisible: false
    },
    selectedText: undefined,
    lastColorHighlight: DEFAULT_COLOR,
    highlights: [],
    isLoadedHighlightsState: false,
    isProcessPaintHighlights: false,
    paintHighlightsFinished: false,
    haveFunctionChangeState: false
  };
  var _useState = useState(defaultState),
    state = _useState[0],
    dispatch = _useState[1];
  useEffect(function () {
    if (state.haveFunctionChangeState) {
      if (onChangeState.current) onChangeState.current();
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          haveFunctionChangeState: false
        });
      });
    }
  }, [state.haveFunctionChangeState]);
  useEffect(function () {
    if (refresh) {
      // @ts-ignore
      onChangeState.current = function () {
        _getHighlights();
      };
      dispatch(function (prevState) {
        return _extends({}, defaultState, {
          haveFunctionChangeState: true
        });
      });
    }
  }, [refresh]);
  var stateRef = useRef(state);
  stateRef.current = state;
  var dispatchRef = useRef(dispatch);
  dispatchRef.current = dispatch;
  var _useSelectText = useSelectText({
      idDivSelectText: idDivSelectText,
      hasSelectedText: _hasSelectedText,
      hasNotSelectedText: _hasNotSelectedText,
      selectedTextMenuVisible: state.selectedTextMenu.isVisible,
      removeSelectedTextMenuVisible: state.removeSelectedTextMenu.isVisible,
      selectionCoords: config.selectionCoords,
      idMenu: idMenu,
      idWrapContent: idWrapContent
    }),
    removeListenerSelectionChange = _useSelectText.removeListenerSelectionChange,
    addListenerSelectionChange = _useSelectText.addListenerSelectionChange,
    setIsEnabledSelectedText = _useSelectText.setIsEnabledSelectedText,
    setIsEnabledHasNotSelectedText = _useSelectText.setIsEnabledHasNotSelectedText;
  useEffect(function () {
    if (!refresh) {
      _getHighlights();
    }
  }, []);
  useEffect(function () {
    if (isContentReady) {
      paintHighlightsState(function () {
      });
    }
  }, [isContentReady, state.isLoadedHighlightsState]);
  function _getHighlights() {
    config.highlights.getHighlights(function (_highlights) {
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          highlights: _highlights,
          isLoadedHighlightsState: true
        });
      });
      if (isContentReady) {
        paintHighlightsState(function () {
        });
      }
    }, function (error) {});
  }
  function _hasSelectedText(selectionGeneral, selections) {
    if (selectionGeneral && selections.length > 0) {
      // == solo voy abrir el menu si hay selections, es decir intervalos pequeños que se pueden resaltar
      // == en un futuro lo mismo en caso de no haber selections se quiere abrir otro menu con algunas otras opciones, como texto a voz
      // == esa logica de que menu abrir se haría dentro de este metodo
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          selectedTextMenu: {
            isVisible: true,
            x: selectionGeneral.x,
            y: selectionGeneral.y,
            colorActive: prevState.lastColorHighlight,
            onClickOutside: function onClickOutside() {
              dispatch(function (prevState) {
                return _extends({}, prevState, {
                  selectedTextMenu: {
                    isVisible: false
                  },
                  selectedText: undefined
                });
              });
            },
            onClickHighlight: onClickHighlightMenu,
            onClickOptionSpinnerColorHighlight: onClickHighlightColorMenu
          },
          removeSelectedTextMenu: {
            isVisible: false
          },
          selectedText: {
            selectionGeneral: selectionGeneral,
            selections: selections
          }
        });
      });
      hasSelectedText(selectionGeneral, selections);
    }
  }
  function _hasNotSelectedText() {
    hasNotSelectedText();
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        selectedText: undefined
      });
    });
  }
  function _createHighlight(color) {
    var _state = stateRef.current;
    if (_state.selectedText && _state.selectedText.selectionGeneral) {
      // _utilsHighlightAndAnotation.current.clearTextSelection();
      createHighlight(_state.selectedText.selectionGeneral, _state.selectedText.selections, color, config.highlights, onClickHighlight, function (_highlight) {
        dispatchRef.current(function (prevState) {
          return _extends({}, prevState, {
            highlights: [].concat(prevState.highlights, [_highlight])
          });
        });
      },
      // Importante poner el bind para que no se pierda su alcance: https://stackoverflow.com/questions/4011793/this-is-undefined-in-javascript-class-methods
      _utilsHighlightAndAnotation.current.restoreSelection.bind(_utilsHighlightAndAnotation.current), _utilsHighlightAndAnotation.current.restoreSelectionIfNotSelected.bind(_utilsHighlightAndAnotation.current), highlightUse);
    }
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        selectedTextMenu: {
          isVisible: false
        },
        selectedText: undefined
      });
    });
  }
  function _editColorHighlight(highlight, selection, color) {
    // _utilsHighlightAndAnotation.current.clearTextSelection();
    editColorHighlightSelection(highlight, selection, color, config.highlights, onClickHighlight, function (highlightEdited) {
      dispatchRef.current(function (prevState) {
        return _extends({}, prevState, {
          highlights: prevState.highlights.map(function (_highlight) {
            return _highlight.guid === highlightEdited.guid ? highlightEdited : _highlight;
          })
        });
      });
    },
    // Importante poner el bind para que no se pierda su alcance: https://stackoverflow.com/questions/4011793/this-is-undefined-in-javascript-class-methods
    _utilsHighlightAndAnotation.current.restoreSelection.bind(_utilsHighlightAndAnotation.current), _utilsHighlightAndAnotation.current.restoreSelectionIfNotSelected.bind(_utilsHighlightAndAnotation.current), highlightUse, unhighlightUse);
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        removeSelectedTextMenu: {
          isVisible: false
        },
        selectedText: undefined
      });
    });
  }
  function _removeHighlightSelection(highlight, selection) {
    // _utilsHighlightAndAnotation.current.clearTextSelection();
    removeHighlightSelection(highlight, selection, config.highlights, function (highlightEdited) {
      dispatchRef.current(function (prevState) {
        return _extends({}, prevState, {
          highlights: prevState.highlights.map(function (_highlight) {
            return _highlight.guid === highlightEdited.guid ? highlightEdited : _highlight;
          })
        });
      });
    }, function (idHighlight) {
      dispatchRef.current(function (prevState) {
        return _extends({}, prevState, {
          highlights: prevState.highlights.filter(function (_highlight) {
            return _highlight.guid !== idHighlight;
          })
        });
      });
    },
    // Importante poner el bind para que no se pierda su alcance: https://stackoverflow.com/questions/4011793/this-is-undefined-in-javascript-class-methods
    _utilsHighlightAndAnotation.current.restoreSelectionIfNotSelected.bind(_utilsHighlightAndAnotation.current), unhighlightUse);
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        removeSelectedTextMenu: {
          isVisible: false
        },
        selectedText: undefined
      });
    });
  }
  function onClickHighlightMenu(e) {
    var _state = stateRef.current;
    _createHighlight(_state.lastColorHighlight);
  }
  function onClickHighlightColorMenu(e, color) {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        lastColorHighlight: color
      });
    });
    _createHighlight(color);
  }
  /**
   *
   * @param  id
   * @param  listenerClick funcion invocada cuando se hace click en el elemento y se le pasará como unico parametro la id del elemento
   * @param  classColor clase que se le añade al resalte que le ha a poner el color
   * @param {*} selectionUse Si nos dan esta variable va a ser la que usemos y sino lo va a calcular
   * @param {*} rangeUse  Si nos dan esta variable va a ser la que usemos y sino lo va a calcular
   * @param {*} enableDisableDesignMode Si es true dentro de esta funcion se habilita y desabilita el designedMode cuando corresponda
   */
  function highlightUse(id, listenerClick, classColor, selectionUse, rangeUse, enableDisableDesignMode) {
    if (selectionUse === void 0) {
      selectionUse = null;
    }
    if (rangeUse === void 0) {
      rangeUse = null;
    }
    if (enableDisableDesignMode === void 0) {
      enableDisableDesignMode = true;
    }
    var colourHighlight = COLOR_HIGHLIGHT;
    var classHighlight = CLASS_HIGHLIGHT;
    var classColorUse = classColor ? classColor : DEFAULT_CLASS_COLOR;
    _utilsHighlightAndAnotation.current.highlightUse(id, listenerClick, colourHighlight, classHighlight, [classColorUse], [], selectionUse, rangeUse, enableDisableDesignMode);
  }
  function unhighlightUse(id, classColor, clearTextSelectionWhenFinish) {
    var color = COLOR_HIGHLIGHT;
    _utilsHighlightAndAnotation.current.unhighlightUse(id, color, CLASS_HIGHLIGHT, [classColor], clearTextSelectionWhenFinish);
  }
  // == En pqlco se llamaba hasClickSelectedText
  function onClickHighlight(id, x, y) {
    //Desactivo por un medio segundo las acciones que hacen los eventos SelectText y HasNotSelectedText ya que justo despues de hacer click tambien se lanzaba una accion de estos tipos
    setIsEnabledSelectedText(false);
    setIsEnabledHasNotSelectedText(false);
    // == Recupero la información del resalte
    var highlight = stateRef.current.highlights.find(function (_highlight) {
      return _highlight.selections.find(function (_selection) {
        return _selection.guid === id;
      });
    });
    var selection = highlight == null ? void 0 : highlight.selections.find(function (_selection) {
      return _selection.guid === id;
    });
    if (selection) {
      var _idDivSelectText = selection == null ? void 0 : selection.idDivSelectText;
      //Lo primero lo vuelvo a poner como seleccionado por el usuario
      var start = selection.start;
      var end = selection.end;
      _utilsHighlightAndAnotation.current.restoreSelection(document.getElementById(_idDivSelectText), {
        start: start,
        end: end
      }, _idDivSelectText);
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          removeSelectedTextMenu: {
            isVisible: true,
            x: x,
            y: y,
            highlight: highlight,
            selection: selection,
            colorActive: selection.color,
            onClickOutside: function onClickOutside() {
              dispatch(function (prevState) {
                return _extends({}, prevState, {
                  removeSelectedTextMenu: {
                    isVisible: false
                  },
                  selectedText: undefined
                });
              });
            },
            onClickEditColorHighlight: function onClickEditColorHighlight(e) {
              if (highlight) _editColorHighlight(highlight, selection, stateRef.current.lastColorHighlight);
            },
            onClickRemoveHighlight: function onClickRemoveHighlight(e) {
              if (highlight) _removeHighlightSelection(highlight, selection);
            },
            onClickOptionSpinnerColorHighlight: function onClickOptionSpinnerColorHighlight(e, color) {
              dispatch(function (prevState) {
                return _extends({}, prevState, {
                  lastColorHighlight: color
                });
              });
              if (highlight) _editColorHighlight(highlight, selection, color);
            }
          },
          selectedTextMenu: {
            isVisible: false
          }
        });
      });
    }
    setTimeout(function () {
      setIsEnabledHasNotSelectedText(true);
    }, 500);
    setTimeout(function () {
      setIsEnabledSelectedText(true);
    }, 800);
  }
  function paintHighlightsState(endListener) {
    // && this.props.mathJaxIsReady
    var _state = stateRef.current;
    if (_state.isLoadedHighlightsState && !_state.paintHighlightsFinished && !_state.isProcessPaintHighlights) {
      removeListenerSelectionChange(); // == Quito temporalmente el listener
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          isProcessPaintHighlights: true
        });
      });
      document.designMode = 'on'; // Importante lo hago fuera del bucle una sola vez
      for (var index = 0; index < _state.highlights.length; index++) {
        var highlight = _state.highlights[index];
        paintHighlight(highlight, onClickHighlight,
        // Importante poner el bind para que no se pierda su alcance: https://stackoverflow.com/questions/4011793/this-is-undefined-in-javascript-class-methods
        _utilsHighlightAndAnotation.current.restoreSelection.bind(_utilsHighlightAndAnotation.current), _utilsHighlightAndAnotation.current.restoreSelectionIfNotSelected.bind(_utilsHighlightAndAnotation.current), false, highlightUse, true, undefined);
      }
      document.designMode = 'off'; // Importante lo hago fuera del bucle una sola vez
      setTimeout(function () {
        dispatch(function (prevState) {
          return _extends({}, prevState, {
            isProcessPaintHighlights: false
          });
        });
        addListenerSelectionChange(); // Vuelvo a poner el listener
        endListener();
      }, 400);
    } else {
      if (_state.isLoadedHighlightsState && !(_state.highlights && _state.highlights.length > 0)) {
        // Si ya he cargado los HighlightState y no no tengo para esta pagina marco como que ya he terminado de pintarlos
        dispatch(function (prevState) {
          return _extends({}, prevState, {
            paintHighlightsFinished: true
          });
        });
        endListener();
      } else {
        endListener();
      }
    }
  }
  return {
    selectedTextMenu: state.selectedTextMenu,
    removeSelectedTextMenu: state.removeSelectedTextMenu
  };
}

var hasData = function hasData(val) {
  return val && val.toString().length > 0;
};
/**
 * Devuelve true si es un numero
 * @param {Cadena a comprobar} num
 */
function isNumeric(num) {
  return !isNaN(num);
}
/**
 * Devuelve true si la url es valida
 * @param str
 * @returns
 */
function isValidURL(str) {
  var pattern = new RegExp('^(https?:\\/\\/)?' +
  // protocol
  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
  // domain name
  '((\\d{1,3}\\.){3}\\d{1,3}))' +
  // OR ip (v4) address
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
  // port and path
  '(\\?[;&a-z\\d%_.~+=-]*)?' +
  // query string
  '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
  return !!pattern.test(str);
}
/**
   * Devuelve el identificador del video de youtube dado por la url
   * Si la url no es de youtube devuelve null
   * Soporta:
   *     // link : //youtube.com/watch?v=Bo_deCOd1HU
        // share : //youtu.be/Bo_deCOd1HU
        // embed : //youtube.com/embed/Bo_deCOd1HU
   * @param url
   * @returns
   */
function parseYouTube(url) {
  var re = /\/\/(?:www\.)?youtu(?:\.be|be\.com)\/(?:watch\?v=|embed\/)?([a-z0-9_\-]+)/i;
  var matches = re.exec(url);
  return matches && matches[1];
}
/**
 * Devuelve el identificador del video de vimeo dado por la url
 * Si la url no es de youtube devuelve null
 * Soporta:
 *     // embed & link: http://vimeo.com/86164897
 * @param url
 * @returns
 */
function parseVimeo(url) {
  var re = /\/\/(?:www\.)?vimeo.com\/([0-9a-z\-_]+)/i;
  var matches = re.exec(url);
  return matches && matches[1];
}
function isURLYoutube(url) {
  return parseYouTube(url) !== null;
}
function isURLVimeo(url) {
  return parseVimeo(url) !== null;
}
function isIframe(str) {
  var regex = /<\s*iframe[\S\s]*?src\s*=\s*(['"]).+?\1[\S\s]*?(\/\s*iframe\s*)?>/;
  return regex.test(str);
}
/**
 *  Dado un string con div y otros elementos devuelve el iframe encontrado
 *  @returns {string} iframe encontrado o cadena vacia si no lo encuentra
 */
function getIframeString(htmlString) {
  var domparser = new DOMParser();
  var doc = domparser.parseFromString(htmlString, 'text/html');
  var iframe = doc.querySelector('iframe');
  return iframe ? iframe.outerHTML : null;
}
function removeHtmlTags(text) {
  var cleanText = text.replace(/<\/?[^>]+(>|$)/g, '');
  return cleanText;
}

var _rect, _rect2, _path$3, _line;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var SvgNoAlt = function SvgNoAlt(props) {
  return /*#__PURE__*/createElement("svg", _extends$5({
    width: 34,
    height: 22,
    viewBox: "0 0 34 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 21,
    rx: 4.5,
    fill: "#DE911D"
  })), _rect2 || (_rect2 = /*#__PURE__*/createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 21,
    rx: 4.5,
    stroke: "white"
  })), _path$3 || (_path$3 = /*#__PURE__*/createElement("path", {
    d: "M7.837 15.5H6.1495L9.22195 6.77273H11.1737L14.2504 15.5H12.5629L10.2319 8.5625H10.1637L7.837 15.5ZM7.8924 12.0781H12.4947V13.348H7.8924V12.0781ZM15.3999 15.5V6.77273H16.9808V14.1747H20.8246V15.5H15.3999ZM20.6999 8.09801V6.77273H27.663V8.09801H24.9656V15.5H23.3974V8.09801H20.6999Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/createElement("line", {
    x1: 4,
    y1: 11.5,
    x2: 30,
    y2: 11.5,
    stroke: "white"
  })));
};

function usePortal(props) {
  var contentRootId = props.contentRootId,
    portalId = props.portalId,
    className = props.className;
  var _useState = useState({
      isReady: false
    }),
    state = _useState[0],
    dispatch = _useState[1];
  var portalElement = useRef(null);
  useEffect(function () {
    var contentRoot = getContentRoot();
    var p = portalId && document.getElementById(portalId);
    if (!p) {
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          isReady: true
        });
      });
      p = document.createElement('div');
      p.id = portalId;
      p.className = className;
      contentRoot.appendChild(p);
    } else {
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          isReady: true
        });
      });
    }
    portalElement.current = p;
    return function () {
      var _portalElement$curren;
      var p = portalId && document.getElementById(portalId);
      if (p && ((_portalElement$curren = portalElement.current) == null ? void 0 : _portalElement$curren.parentNode) === contentRoot) contentRoot.removeChild(portalElement.current);
      portalElement.current = null;
    };
  }, []);
  useEffect(function () {
    var p = portalId && document.getElementById(portalId);
    if (p) p.className = className;
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        isReady: true
      });
    });
  }, [portalId]);
  function getContentRoot() {
    var contentRootById = null;
    if (contentRootId) {
      contentRootById = document.getElementById(contentRootId);
      if (contentRootById) {
        return contentRootById;
      } else {
        return document.body;
      }
    } else {
      return document.body;
    }
  }
  return {
    isReady: state.isReady,
    portalElement: portalElement.current
  };
}

var _excluded = ["contentRootId", "children", "portalId"];
function Portal(props) {
  var children = props.children,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);
  var _usePortal = usePortal(props),
    isReady = _usePortal.isReady,
    portalElement = _usePortal.portalElement;
  return isReady && portalElement ? /*#__PURE__*/createPortal( /*#__PURE__*/React__default.createElement("div", Object.assign({}, otherProps), children), portalElement) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
}

/**
 * Componente que te avisa si haces click fuera de el
 */
var OutsideAlerter = /*#__PURE__*/function (_React$Component) {
  function OutsideAlerter(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.setWrapperRef = _this.setWrapperRef.bind(_this);
    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
    return _this;
  }
  _inheritsLoose(OutsideAlerter, _React$Component);
  var _proto = OutsideAlerter.prototype;
  _proto.componentDidMount = function componentDidMount() {
    if (this.props.isActive) {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.isActive !== this.props.isActive) {
      if (this.props.isActive) {
        document.addEventListener('mousedown', this.handleClickOutside);
      } else {
        document.removeEventListener('mousedown', this.handleClickOutside);
      }
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */;
  _proto.setWrapperRef = function setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Avisa si se hace click fuera del elemento
   */;
  _proto.handleClickOutside = function handleClickOutside(event) {
    if (!this.isIgnoreEvent(event)) {
      if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        if (this.props.isActive && this.props.handleClickOutside) {
          this.props.handleClickOutside();
        }
      }
    }
  }

  /**
   * Nos devuelve true si ignoramos este evento
   * @fuente https://stackoverflow.com/questions/39245488/event-path-is-undefined-running-in-firefox
   * @param event
   */;
  _proto.isIgnoreEvent = function isIgnoreEvent(event) {
    var ignore = false;
    var path;
    if (event) {
      path = event.path || event.composedPath && event.composedPath();
    }
    if (path && this.props.classListIgnoreClick) {
      var found = false;
      // == Recorro la lista de path va es un listado de elementos del lugar pulsado y si dentro existe alguna de las clases a ignorar ignoro este evento
      var father = this;
      // == some devuelve true tan pronto como cualquiera de las devoluciones de llamada, ejecutadas en orden de matriz, devuelva true, cortocircuitando la ejecución del resto
      path.some(function (element) {
        if (element && element.classList) {
          father.props.classListIgnoreClick.some(function (classIgnore) {
            if (classIgnore && classIgnore.length > 0 && element.classList.contains(classIgnore)) {
              found = true;
              return true; // Devuelvo true para que se pare el bucle some
            } else return false;
          });
          if (found) {
            return true;
          } else return false;
        } else {
          return false;
        }
      });
      if (found) ignore = true;
    }
    return ignore;
  };
  _proto.render = function render() {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "outside-alerter",
      ref: this.setWrapperRef
    }, this.props.children);
  };
  return OutsideAlerter;
}(React__default.Component);
OutsideAlerter.propTypes = {
  children: PropTypes.element.isRequired,
  isActive: PropTypes.bool,
  // Si es true se activa el que te avise cuando se hace click fuera,
  classListIgnoreClick: PropTypes.array // Es un array de string con el listado de clases a ignorar si hacen click en ella ejemplo ["lesson__block-interactive-label-link"]
};

function useTooltip(props) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var targetElement = props.targetElement,
    onClose = props.onClose;
  var _useState = useState(null),
    popperElement = _useState[0],
    setPopperElement = _useState[1];
  var _useState2 = useState(null),
    arrowElement = _useState2[0],
    setArrowElement = _useState2[1];
  //@ts-ignore
  var _usePopper = usePopper(targetElement, popperElement, getPopoverConfig(arrowElement)),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes;
  var element = useRef(null);
  var isPopperVisible = {}; //!targetElement && { display: 'none' };
  return {
    t: t,
    element: element,
    setPopperElement: setPopperElement,
    styles: styles,
    isPopperVisible: isPopperVisible,
    attributes: attributes,
    setArrowElement: setArrowElement,
    onClose: onClose
  };
}
function getPopoverConfig(arrowElement) {
  return {
    // strategy: 'fixed',
    modifiers: [{
      name: 'arrow',
      options: {
        element: arrowElement
      }
    }, {
      name: 'offset',
      options: {
        offset: [0, 16]
      }
    }, {
      name: 'preventOverflow',
      options: {
        padding: {
          top: 60,
          bottom: 70,
          left: 10,
          right: 10
        }
      }
    }],
    placement: 'top'
  };
}

function Tooltip(props) {
  var children = props.children;
  var _useTooltip = useTooltip(props),
    element = _useTooltip.element,
    setPopperElement = _useTooltip.setPopperElement,
    styles = _useTooltip.styles,
    isPopperVisible = _useTooltip.isPopperVisible,
    attributes = _useTooltip.attributes,
    setArrowElement = _useTooltip.setArrowElement,
    onClose = _useTooltip.onClose;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-tooltip__wrapper'
  }, /*#__PURE__*/React__default.createElement(OutsideAlerter, {
    isActive: true,
    handleClickOutside: onClose,
    classListIgnoreClick: []
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: element
  }, /*#__PURE__*/React__default.createElement("div", Object.assign({
    className: 'mint-tooltip',
    //@ts-ignore
    ref: setPopperElement,
    style: _extends({}, styles.popper, isPopperVisible)
  }, attributes.popper), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-tooltip__children'
  }, children), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-tooltip__arrow',
    //@ts-ignore
    ref: setArrowElement,
    style: styles.arrow
  })))));
}

function useTooltipWrapper(props) {
  var openPortal = props.openPortal;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  // eslint -> no se usa el setter
  var _useState = useState(getGuid()),
    guid = _useState[0];
  var _useState2 = useState(),
    popperTarget = _useState2[0],
    setPopperTarget = _useState2[1];
  var styles = {
    app: {
      position: 'relative'
    },
    buttonWrapper: {
      // position: 'absolute',
      // top: '90vh',
      // right: 10
    }
  };
  var showTooltip = useCallback(function (e) {
    var target = e.target;
    setPopperTarget(popperTarget ? undefined : target);
  }, [setPopperTarget, popperTarget]);
  function onClose() {
    setPopperTarget(undefined);
  }
  return {
    t: t,
    styles: styles,
    showTooltip: showTooltip,
    popperTarget: popperTarget,
    onClose: onClose,
    openPortal: openPortal,
    guid: guid
  };
}

function TooltipWrapper(props) {
  var componentButton = props.componentButton,
    componentTooltip = props.componentTooltip;
  var _useTooltipWrapper = useTooltipWrapper(props),
    styles = _useTooltipWrapper.styles,
    showTooltip = _useTooltipWrapper.showTooltip,
    popperTarget = _useTooltipWrapper.popperTarget,
    onClose = _useTooltipWrapper.onClose,
    openPortal = _useTooltipWrapper.openPortal,
    guid = _useTooltipWrapper.guid;
  function getTooltipComponent() {
    return /*#__PURE__*/React__default.createElement(Tooltip, {
      targetElement: popperTarget,
      onClose: onClose
    }, componentTooltip);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-tooltip-wrapper'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-tooltip-wrapper__icon',
    style: styles.buttonWrapper
  }, /*#__PURE__*/React__default.createElement("div", {
    onClick: showTooltip
  }, componentButton)), popperTarget !== undefined && (openPortal ? /*#__PURE__*/React__default.createElement(Portal, {
    portalId: 'mint-tooltip-wrapper__portal-' + guid,
    className: ''
  }, getTooltipComponent()) : getTooltipComponent()));
}

function TooltipContent(props) {
  var text = props.text;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-tooltip-content'
  }, /*#__PURE__*/React__default.createElement("span", null, text));
}

function ImageWrapper(props) {
  var children = props.children,
    _props$showNoAlt = props.showNoAlt,
    showNoAlt = _props$showNoAlt === void 0 ? false : _props$showNoAlt;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  return showNoAlt ? /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-image-wrapper mint-image-wrapper--show-no-alt'
  }, children, showNoAlt && /*#__PURE__*/React__default.createElement(TooltipWrapper, {
    componentButton: /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-image-wrapper__no-alt-icon'
    }, /*#__PURE__*/React__default.createElement(SvgNoAlt, null), ' '),
    componentTooltip: /*#__PURE__*/React__default.createElement(TooltipContent, {
      text: t('no_alt_tooltip')
    }),
    openPortal: false
  })) : /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-image-wrapper'
  }, children);
}

var MediaImage = function MediaImage(_ref) {
  var image = _ref.image,
    alt = _ref.alt,
    _ref$enableZoomOnClic = _ref.enableZoomOnClick,
    enableZoomOnClick = _ref$enableZoomOnClic === void 0 ? true : _ref$enableZoomOnClic,
    getSrc = _ref.getSrc,
    mode = _ref.mode;
  var _useState = useState(false),
    isZoom = _useState[0],
    setIsZoom = _useState[1];
  var altClean = alt;
  if (alt) {
    altClean = removeHtmlTags(altClean);
  }
  var handleZoomChange = useCallback(function (shouldZoom) {
    setIsZoom(shouldZoom);
  }, []);
  function getImgComponent() {
    return /*#__PURE__*/React__default.createElement(ImageWrapper, {
      showNoAlt: mode === IModesItemBlock.MODE_EDITOR && !alt && !isZoom
    }, /*#__PURE__*/React__default.createElement("img", {
      src: getSrc(image.src),
      alt: altClean || '',
      className: "img" + (isZoom ? ' img-cover' : ''),
      width: '100%',
      height: 'auto'
    }));
  }
  if (image && image.src) {
    return enableZoomOnClick ? /*#__PURE__*/React__default.createElement(Controlled, {
      isZoomed: isZoom,
      onZoomChange: handleZoomChange,
      zoomMargin: 50
    }, getImgComponent()) : getImgComponent();
  } else {
    return null;
  }
};

/**
 * Nos dice si el componente EditText va a estar en modo editable.
 * @param {*} modeItemBlock es el modo de los que aparecen en Itemblock
 */
function isModeEditTextHtml(modeItemBlock) {
  return modeItemBlock === IModesItemBlock.MODE_EDITOR || modeItemBlock === IModesItemBlock.MODE_EDITOR_FLOATING_SIDEBAR;
}

var IModesTextHtml;
(function (IModesTextHtml) {
  IModesTextHtml["MODE_TEXT_HTML_VISOR"] = "MODE_TEXT_HTML_VISOR";
  IModesTextHtml["MODE_TEXT_HTML_EDITOR"] = "MODE_TEXT_HTML_EDITOR";
  IModesTextHtml["MODE_TEXT_HTML_NUMBER_EDITOR"] = "MODE_TEXT_HTML_NUMBER_EDITOR";
  IModesTextHtml["MODE_TEXT_HTML_TEXT_EDITOR"] = "MODE_TEXT_HTML_TEXT_EDITOR";
  IModesTextHtml["MODE_TEXT_HTML_TEXT_AREA_EDITOR"] = "MODE_TEXT_HTML_TEXT_AREA_EDITOR";
})(IModesTextHtml || (IModesTextHtml = {}));

function useItemBlockGallery(props) {
  var mode = props.mode;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  return {
    t: t,
    modeTextHtml: isModeEditTextHtml(mode) ? IModesTextHtml.MODE_TEXT_HTML_EDITOR : IModesTextHtml.MODE_TEXT_HTML_VISOR
  };
}

var Carousel = function Carousel(_ref) {
  var item = _ref.item,
    getTextHtml = _ref.getTextHtml,
    captionUpdatedIndex = _ref.captionUpdatedIndex,
    mode = _ref.mode,
    getSrc = _ref.getSrc,
    onReady = _ref.onReady;
  var _useItemBlockGallery = useItemBlockGallery({
      item: item,
      mode: mode
    }),
    modeTextHtml = _useItemBlockGallery.modeTextHtml;
  var subItems = item.items;
  var navigationPrevRef = useRef(null);
  var navigationNextRef = useRef(null);
  var _useItemBlockComponen = useItemBlockComponent({
      numComponentsTextHtml: getNumComponentsTextHtml(),
      onReady: onReady,
      item: item
    }),
    onReadyGetTextHtml = _useItemBlockComponen.onReadyGetTextHtml;
  var enableZoomOnClick = getItemSettingIsZoomOnClick(item);
  var pagination = {
    el: '.swiper-pagination-' + item.id,
    clickable: true,
    renderBullet: function renderBullet(index, className) {
      return "<a href=\"\" class=\"" + className + " mint-block-carousel__bullet brand--background\"></a>";
    }
  };
  var navigation = {
    prevEl: navigationPrevRef.current,
    nextEl: navigationNextRef.current
  };
  function getNumComponentsTextHtml() {
    var num = 0;
    for (var index = 0; index < subItems.length; index++) {
      var subItem = subItems[index];
      if (subItem.caption || mode === IModesItemBlock.MODE_EDITOR) num++;
    }
    return num;
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "mint-block-carousel " + CLASS_NO_SELECT
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-carousel__swiper mint-block-carousel__swiper-' + item.id
  }, /*#__PURE__*/React__default.createElement(Swiper, {
    pagination: pagination,
    navigation: navigation,
    modules: [Navigation, Pagination, Controller],
    autoHeight: true,
    slidesPerView: 1,
    loop: true
  }, subItems.map(function (i, index) {
    var _i$media, _i$media2;
    var sizeImageItemInside = getItemSettingImageSize(i);
    var sizeImageFinal = sizeImageItemInside ? sizeImageItemInside : 'extra-large';
    return /*#__PURE__*/React__default.createElement(SwiperSlide, {
      key: i.id
    }, ((_i$media = i.media) == null ? void 0 : _i$media.image) && /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-block-carousel__figure' + (sizeImageFinal ? " mint-block-carousel__figure--" + sizeImageFinal : '') + ' ' + CLASS_CONTENT_LEFT
    }, /*#__PURE__*/React__default.createElement(MediaImage, {
      image: i.media.image,
      alt: i.media.image.alt || '',
      enableZoomOnClick: enableZoomOnClick,
      getSrc: getSrc,
      mode: mode
    })), ((_i$media2 = i.media) == null ? void 0 : _i$media2.image) && (i.caption || mode === IModesItemBlock.MODE_EDITOR) && /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-block-carousel__caption'
    }, getTextHtml(i.caption || '', function (text) {
      return captionUpdatedIndex && captionUpdatedIndex(text, index);
    }, i.id, modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml)));
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-carousel-pagination'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'swiper-pagination swiper-pagination-' + item.id
  })), /*#__PURE__*/React__default.createElement("div", {
    ref: navigationPrevRef,
    className: 'swiper-button-prev swiper-button-prev-' + item.id
  }), /*#__PURE__*/React__default.createElement("div", {
    ref: navigationNextRef,
    className: 'swiper-button-next swiper-button-next-' + item.id
  })));
};

var GalleryColumns = function GalleryColumns(_ref) {
  var item = _ref.item,
    getTextHtml = _ref.getTextHtml,
    captionUpdatedIndex = _ref.captionUpdatedIndex,
    mode = _ref.mode,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? IVariantsGalleryColumns.twocol : _ref$variant,
    getSrc = _ref.getSrc,
    onReady = _ref.onReady;
  var _useItemBlockGallery = useItemBlockGallery({
      item: item,
      mode: mode
    }),
    modeTextHtml = _useItemBlockGallery.modeTextHtml;
  var subItems = item.items;
  var _useItemBlockComponen = useItemBlockComponent({
      numComponentsTextHtml: getNumComponentsTextHtml(),
      onReady: onReady,
      item: item
    }),
    onReadyGetTextHtml = _useItemBlockComponen.onReadyGetTextHtml;
  function getNumComponentsTextHtml() {
    var num = 0;
    for (var index = 0; index < subItems.length; index++) {
      var subItem = subItems[index];
      if (subItem.caption || mode === IModesItemBlock.MODE_EDITOR) num++;
    }
    return num;
  }
  var enableZoomOnClick = getItemSettingIsZoomOnClick(item);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "mint-block-gallery mint-block-gallery--" + variant
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-gallery__content ' + CLASS_CONTENT_LEFT
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-gallery__row'
  }, subItems.map(function (i, index) {
    var _i$media, _i$media2;
    return /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-block-gallery__col',
      key: i.id
    }, ((_i$media = i.media) == null ? void 0 : _i$media.image) && /*#__PURE__*/React__default.createElement("figure", {
      className: 'mint-block-gallery__figure'
    }, /*#__PURE__*/React__default.createElement(MediaImage, {
      image: i.media.image,
      alt: i.media.image.alt || '',
      enableZoomOnClick: enableZoomOnClick,
      getSrc: getSrc,
      mode: mode
    })), ((_i$media2 = i.media) == null ? void 0 : _i$media2.image) && (i.caption || mode === IModesItemBlock.MODE_EDITOR) && /*#__PURE__*/React__default.createElement("figcaption", {
      className: 'mint-block-gallery__caption'
    }, getTextHtml(i.caption || '', function (text) {
      return captionUpdatedIndex && captionUpdatedIndex(text, index);
    }, i.id, modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml)));
  }))));
};

function useItemBlockImage(props) {
  var item = props.item,
    mode = props.mode;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  return {
    t: t,
    imagePosition: getItemSettingImagePosition(item),
    imageSize: getItemSettingImageSize(item),
    modeTextHtml: isModeEditTextHtml(mode) ? IModesTextHtml.MODE_TEXT_HTML_EDITOR : IModesTextHtml.MODE_TEXT_HTML_VISOR
  };
}

var ImageHero = function ImageHero(_ref) {
  var _subItem$media;
  var item = _ref.item,
    getTextHtml = _ref.getTextHtml,
    captionUpdated = _ref.captionUpdated,
    mode = _ref.mode,
    getSrc = _ref.getSrc,
    onReady = _ref.onReady;
  var _useItemBlockImage = useItemBlockImage({
      item: item,
      mode: mode
    }),
    modeTextHtml = _useItemBlockImage.modeTextHtml,
    imageSize = _useItemBlockImage.imageSize;
  var subItem = item && item.items ? item.items[0] : undefined;
  var image = subItem == null || (_subItem$media = subItem.media) == null ? void 0 : _subItem$media.image;
  var caption = subItem == null ? void 0 : subItem.caption;
  var _useItemBlockComponen = useItemBlockComponent({
      numComponentsTextHtml: caption || mode === IModesItemBlock.MODE_EDITOR ? 1 : 0,
      onReady: onReady,
      item: item
    }),
    onReadyGetTextHtml = _useItemBlockComponen.onReadyGetTextHtml;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "mint-block-image mint-block-image--hero mint-block-image--" + imageSize + " mint-block-image--center"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-image__content ' + CLASS_CONTENT_LEFT
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-image__row'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-image__col'
  }, image && /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-image__figure'
  }, /*#__PURE__*/React__default.createElement(MediaImage, {
    image: image,
    alt: image.alt || '',
    enableZoomOnClick: getItemSettingIsZoomOnClick(item),
    getSrc: getSrc,
    mode: mode
  })), image && (caption || mode === IModesItemBlock.MODE_EDITOR) && /*#__PURE__*/React__default.createElement("figcaption", {
    className: 'mint-block-image__caption'
  }, getTextHtml(caption || '', function (text) {
    return captionUpdated && captionUpdated(text);
  }, item.id, modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml))))));
};

var ImageTextAside = function ImageTextAside(_ref) {
  var _subItem$media;
  var item = _ref.item,
    getTextHtml = _ref.getTextHtml,
    captionUpdated = _ref.captionUpdated,
    paragraphUpdated = _ref.paragraphUpdated,
    mode = _ref.mode,
    getSrc = _ref.getSrc,
    onReady = _ref.onReady;
  var _useItemBlockImage = useItemBlockImage({
      item: item,
      mode: mode
    }),
    modeTextHtml = _useItemBlockImage.modeTextHtml,
    imagePosition = _useItemBlockImage.imagePosition,
    imageSize = _useItemBlockImage.imageSize;
  var subItem = item && item.items ? item.items[0] : undefined;
  var image = subItem == null || (_subItem$media = subItem.media) == null ? void 0 : _subItem$media.image;
  var caption = subItem == null ? void 0 : subItem.caption;
  var paragraph = subItem == null ? void 0 : subItem.paragraph;
  var _useItemBlockComponen = useItemBlockComponent({
      numComponentsTextHtml: caption || mode === IModesItemBlock.MODE_EDITOR ? 2 : 1,
      onReady: onReady,
      item: item
    }),
    onReadyGetTextHtml = _useItemBlockComponen.onReadyGetTextHtml;
  function renderImageCol() {
    return /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-block-image__col'
    }, image && /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-block-image__figure'
    }, /*#__PURE__*/React__default.createElement(MediaImage, {
      image: image,
      alt: image.alt || '',
      enableZoomOnClick: getItemSettingIsZoomOnClick(item),
      getSrc: getSrc,
      mode: mode
    })), image && (caption || mode === IModesItemBlock.MODE_EDITOR) && /*#__PURE__*/React__default.createElement("figcaption", {
      className: 'mint-block-image__caption'
    }, getTextHtml(caption || '', function (text) {
      return captionUpdated && captionUpdated(text);
    }, item.id, modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml)));
  }
  function renderTextCol() {
    return /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-block-image__col'
    }, /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-block-image__text'
    }, getTextHtml(paragraph || '', function (text) {
      return paragraphUpdated && paragraphUpdated(text);
    }, item.id, modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml)));
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "mint-block-image mint-block-image--text-aside mint-block-image--" + imageSize + " mint-block-image--" + imagePosition
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-image__content ' + CLASS_CONTENT_LEFT
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-image__row'
  }, imagePosition === SETTINGS_IMAGE_POSITION.RIGHT ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, renderTextCol(), renderImageCol()) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, renderImageCol(), renderTextCol()))));
};

var ImageTextOverlay = function ImageTextOverlay(_ref) {
  var _subItem$media;
  var item = _ref.item,
    getTextHtml = _ref.getTextHtml,
    captionUpdated = _ref.captionUpdated,
    mode = _ref.mode,
    getSrc = _ref.getSrc,
    onReady = _ref.onReady;
  var _useItemBlockImage = useItemBlockImage({
      item: item,
      mode: mode
    }),
    modeTextHtml = _useItemBlockImage.modeTextHtml,
    imageSize = _useItemBlockImage.imageSize;
  var subItem = item && item.items ? item.items[0] : undefined;
  var image = subItem == null || (_subItem$media = subItem.media) == null ? void 0 : _subItem$media.image;
  var caption = subItem == null ? void 0 : subItem.caption;
  var _useItemBlockComponen = useItemBlockComponent({
      numComponentsTextHtml: caption || mode === IModesItemBlock.MODE_EDITOR ? 2 : 1,
      onReady: onReady,
      item: item
    }),
    onReadyGetTextHtml = _useItemBlockComponen.onReadyGetTextHtml;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "mint-block-image mint-block-image--text-overlay mint-block-image--" + imageSize
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-image__content'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: ''
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'image-text-overlay'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'image-text-overlay__thumb'
  }, image ? /*#__PURE__*/React__default.createElement(MediaImage, {
    image: image,
    alt: image.alt || '',
    enableZoomOnClick: getItemSettingIsZoomOnClick(item),
    getSrc: getSrc,
    mode: mode
  }) : ''), /*#__PURE__*/React__default.createElement("div", {
    className: 'image-text-overlay__text-container ' + CLASS_CONTENT_LEFT
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'image-text-overlay__text brand--first'
  }, subItem && subItem.caption || mode === IModesItemBlock.MODE_EDITOR ? getTextHtml(caption || '', function (text) {
    return captionUpdated && captionUpdated(text);
  }, item.id, modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml) : ''))))));
};

var ImageFull = function ImageFull(_ref) {
  var _subItem$media;
  var item = _ref.item,
    getTextHtml = _ref.getTextHtml,
    captionUpdated = _ref.captionUpdated,
    mode = _ref.mode,
    getSrc = _ref.getSrc,
    onReady = _ref.onReady;
  var _useItemBlockImage = useItemBlockImage({
      item: item,
      mode: mode
    }),
    modeTextHtml = _useItemBlockImage.modeTextHtml,
    imageSize = _useItemBlockImage.imageSize;
  var subItem = item && item.items ? item.items[0] : undefined;
  var image = subItem == null || (_subItem$media = subItem.media) == null ? void 0 : _subItem$media.image;
  var caption = subItem == null ? void 0 : subItem.caption;
  var _useItemBlockComponen = useItemBlockComponent({
      numComponentsTextHtml: caption || mode === IModesItemBlock.MODE_EDITOR ? 1 : 0,
      onReady: onReady,
      item: item
    }),
    onReadyGetTextHtml = _useItemBlockComponen.onReadyGetTextHtml;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "mint-block-image mint-block-image--full mint-block-image--" + imageSize + " mint-block-image--center"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-image__content ' + CLASS_CONTENT_LEFT
  }, /*#__PURE__*/React__default.createElement("div", {
    className: ''
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'image-full'
  }, /*#__PURE__*/React__default.createElement("figure", {
    className: 'image-full__picture'
  }, image && /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-image__figure'
  }, /*#__PURE__*/React__default.createElement(MediaImage, {
    image: image,
    alt: image.alt || '',
    enableZoomOnClick: getItemSettingIsZoomOnClick(item),
    getSrc: getSrc,
    mode: mode
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: 'image-full__caption'
  }, image && (caption || mode === IModesItemBlock.MODE_EDITOR) ? getTextHtml(caption || '', function (text) {
    return captionUpdated && captionUpdated(text);
  }, item.id, modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml) : '')))));
};

var TypesActions;
(function (TypesActions) {
  TypesActions["CLICK_ACCORDION"] = "CLICK_ACCORDION";
})(TypesActions || (TypesActions = {}));
function reducerStateAccordion(state, action) {
  if (action.type === TypesActions.CLICK_ACCORDION) {
    if (state.accordionsOpen && state.accordionsOpen.indexOf(action.id) >= 0) {
      // El acordeon estaba abierto, por tanto lo cierro
      return _extends({}, state, {
        accordionsOpen: state.accordionsOpen.filter(function (item) {
          return item !== action.id;
        })
      });
    } else {
      // El ardon estaba cerrado, por tanto lo abro
      return _extends({}, state, {
        accordionsOpen: [].concat(state.accordionsOpen, [action.id])
      });
    }
  } else return state;
}
function useAccordion(props) {
  var item = props.item,
    mode = props.mode;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useReducer = useReducer(reducerStateAccordion, {
      accordionsOpen: []
    }),
    state = _useReducer[0],
    dispatch = _useReducer[1];
  var clickAccordion = function clickAccordion(e, itemId, subItemId) {
    e.preventDefault();
    dispatch({
      type: TypesActions.CLICK_ACCORDION,
      id: itemId + "|" + subItemId
    });
  };
  return {
    t: t,
    clickAccordion: clickAccordion,
    alignImages: getItemSettingAlignImages(item),
    accordionsOpen: state.accordionsOpen,
    modeTextHtml: isModeEditTextHtml(mode) ? IModesTextHtml.MODE_TEXT_HTML_EDITOR : IModesTextHtml.MODE_TEXT_HTML_VISOR,
    showAdditionalContentsSubItemVisor: ConfigGlobalSingleton.getInstance().isShowAdditionalContentsSubItemVisor()
  };
}

function useMediaAudio(props) {
  var audio = props.audio,
    audioElement = props.audioElement;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    getSrc = _useGeneral.getSrc;
  var _useState = useState(false),
    isPlaying = _useState[0],
    setIsPlaying = _useState[1];
  var _useState2 = useState(0),
    setCurrentTime = _useState2[1];
  var _useState3 = useState(0),
    duration = _useState3[0],
    setDuration = _useState3[1];
  var _useState4 = useState(null),
    setError = _useState4[1];
  var _useState5 = useState([]),
    transcriptData = _useState5[0],
    setTranscriptData = _useState5[1];
  var _useState6 = useState(''),
    currentText = _useState6[0],
    setCurrentText = _useState6[1];
  var _useState7 = useState(false),
    showTranscript = _useState7[0],
    setShowTranscript = _useState7[1];
  var _useState8 = useState(false),
    isTextFile = _useState8[0],
    setIsTextFile = _useState8[1];
  var _useState9 = useState(0),
    setStartedTime = _useState9[1];
  useEffect(function () {
    if (audio != null && audio.transcription) {
      fetchTranscription(audio.transcription);
    }
  }, [audio.src, audio.transcription]);
  // Efecto para cerrar controles al hacer click fuera
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      var playerControls = document.querySelector('.timeline-container');
      if (playerControls && playerControls.contains(event.target)) {
        return;
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showTranscript]);
  var fetchTranscription = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(transcription) {
      var transcriptionUrl, transcriptionData, url, token, isLocal, fileUrl, _url$split, fetchUrl, response, data, cookies, cookieHeader, fileResponse, text, fileExtension, cues, _cues, _t;
      return _regeneratorRuntime().wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            transcriptionUrl = transcription.slice(1);
            transcriptionData = getSrc(transcriptionUrl);
            url = transcriptionData == null ? void 0 : transcriptionData.split('?')[0];
            token = transcriptionData == null ? void 0 : transcriptionData.split('?')[1].split('=')[1];
            isLocal = window.location.origin.includes('localhost'); // const url = `http://localhost:3002/fileExamples/pruebaTXT.txt`;
            fileUrl = isLocal ? window.location.origin + '/fileExamples/pruebaVTT.vtt' : url;
            _context.prev = 1;
            if (isLocal) {
              _context.next = 5;
              break;
            }
            fetchUrl = fileUrl + '?auth=signed-url';
            _context.next = 2;
            return fetch(fetchUrl, {
              headers: {
                Authorization: "" + token
              }
            });
          case 2:
            response = _context.sent;
            if (response.ok) {
              _context.next = 3;
              break;
            }
            throw new Error('No se pudo cargar la transcripción');
          case 3:
            _context.next = 4;
            return response.json();
          case 4:
            data = _context.sent;
            fileUrl = data.data.url;
            cookies = data.data.cookies || []; // Construir el header de cookies para la segunda llamada
            cookieHeader = cookies.map(function (cookie) {
              // Extraer solo la parte del nombre=valor de la cookie
              return cookie.split(';')[0];
            }).join('; ');
          case 5:
            _context.next = 6;
            return fetch(fileUrl, {
              headers: {
                Authorization: "" + token
              }
            });
          case 6:
            fileResponse = _context.sent;
            if (fileResponse.ok) {
              _context.next = 7;
              break;
            }
            throw new Error('No se pudo cargar el archivo de transcripción');
          case 7:
            _context.next = 8;
            return fileResponse.text();
          case 8:
            text = _context.sent;
            // Comprobar la extensión del archivo
            fileExtension = (_url$split = url.split('.')) == null || (_url$split = _url$split.pop()) == null ? void 0 : _url$split.toLowerCase();
            if (!(fileExtension === 'txt')) {
              _context.next = 9;
              break;
            }
            // Si es TXT, dividimos el texto en párrafos y creamos cues con tiempos estimados
            cues = parseTXT(text, duration);
            setTranscriptData(cues);
            setIsTextFile(true);
            return _context.abrupt("return");
          case 9:
            if (!(fileExtension === 'vtt')) {
              _context.next = 10;
              break;
            }
            _cues = parseVTT(text);
            setTranscriptData(_cues);
            setIsTextFile(false);
            return _context.abrupt("return");
          case 10:
            _context.next = 12;
            break;
          case 11:
            _context.prev = 11;
            _t = _context["catch"](1);
            console.error('Error cargando el fichero de transcripción:', _t);
            setTranscriptData([]);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 11]]);
    }));
    return function fetchTranscription(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var parseVTT = function parseVTT(vttText) {
    var lines = vttText.split('\n');
    var cues = [];
    var currentCue = null;
    var currentTextLines = [];
    lines.forEach(function (line) {
      if (line.trim() === 'WEBVTT' || line.trim() === '') return;
      if (line.includes('-->')) {
        // Si tenemos un cue anterior, lo guardamos
        if (currentCue && currentTextLines.length > 0) {
          currentCue.text = currentTextLines.join('\n');
          cues.push(currentCue);
        }
        var _line$split$map = line.split('-->').map(function (t) {
            return t.trim();
          }),
          startStr = _line$split$map[0],
          endStr = _line$split$map[1];
        // Parsear el tiempo en formato "00:00:00.000" o "00:00.000"
        var parseTime = function parseTime(timeStr) {
          var parts = timeStr.split(':');
          var hours = 0,
            minutes = 0,
            seconds = 0,
            ms = 0;
          if (parts.length === 3) {
            // Formato HH:MM:SS.mmm
            var hoursStr = parts[0];
            var minutesStr = parts[1];
            var secondsStr = parts[2];
            // Separar segundos y milisegundos
            var _secondsStr$split = secondsStr.split('.'),
              secs = _secondsStr$split[0],
              millis = _secondsStr$split[1];
            hours = parseFloat(hoursStr || '0');
            minutes = parseFloat(minutesStr || '0');
            seconds = parseFloat(secs || '0');
            ms = parseFloat(millis || '0') / 1000;
          } else {
            // Formato MM:SS.mmm
            var _minutesStr = parts[0];
            var _secondsStr = parts[1];
            // Separar segundos y milisegundos
            var _secondsStr$split2 = _secondsStr.split('.'),
              _secs = _secondsStr$split2[0],
              _millis = _secondsStr$split2[1];
            minutes = parseFloat(_minutesStr || '0');
            seconds = parseFloat(_secs || '0');
            ms = parseFloat(_millis || '0') / 1000;
          }
          return hours * 3600 + minutes * 60 + seconds + ms;
        };
        var start = parseTime(startStr);
        var end = parseTime(endStr);
        currentCue = {
          startTime: start,
          endTime: end,
          text: ''
        };
        currentTextLines = [];
      } else if (currentCue && !line.match(/^\d+$/)) {
        var cleanText = line.trim();
        if (cleanText) {
          currentTextLines.push(cleanText);
        }
      }
    });
    // No olvidar el último cue
    if (currentCue && currentTextLines.length > 0) {
      currentCue.text = currentTextLines.join('\n');
      cues.push(currentCue);
    }
    return cues;
  };
  var parseTXT = function parseTXT(text, duration) {
    // Dividimos el texto en párrafos y creamos cues con tiempos estimados
    var paragraphs = text.split('\n\n').filter(function (p) {
      return p.trim().length > 0;
    });
    var cues = [];
    if (paragraphs.length > 0) {
      var timePerParagraph = duration / paragraphs.length;
      paragraphs.forEach(function (paragraph, index) {
        var startTime = index * timePerParagraph;
        var endTime = (index + 1) * timePerParagraph;
        var cue = {
          startTime: startTime,
          endTime: endTime,
          text: paragraph.trim()
        };
        cues.push(cue);
      });
    } else {
      // Si no hay párrafos, dividir por frases
      var sentences = text.split(/[.!?]+/).filter(function (s) {
        return s.trim().length > 0;
      });
      var timePerSentence = duration / Math.max(sentences.length, 1);
      sentences.forEach(function (sentence, index) {
        var startTime = index * timePerSentence;
        var endTime = (index + 1) * timePerSentence;
        var cue = {
          startTime: startTime,
          endTime: endTime,
          text: sentence.trim()
        };
        cues.push(cue);
      });
    }
    return cues;
  };
  var handleTimeUpdate = function handleTimeUpdate() {
    var _audioElement$current;
    var currentTime = ((_audioElement$current = audioElement.current) == null ? void 0 : _audioElement$current.currentTime) || 0;
    var progress = currentTime / duration * 100;
    var timeline = document.querySelector('.timeline');
    if (timeline) {
      timeline.style.setProperty('--progress-percentage', progress + "%");
    }
    // Bloque para mostrar transcripción
    var activeCue = transcriptData.find(function (cue) {
      return currentTime >= cue.startTime && currentTime < cue.endTime;
    });
    if (activeCue) {
      setCurrentText(activeCue.text);
    }
    // Fin del bloque para mostrar transcripción
    setCurrentTime(currentTime);
  };
  var handleSeek = function handleSeek(e) {
    var time = parseFloat(e.target.value);
    if (audioElement.current) {
      var _e$target;
      audioElement.current.currentTime = time;
      var progress = time / duration * 100;
      if (e != null && (_e$target = e.target) != null && _e$target.style) {
        e.target.style.setProperty('--progress-percentage', progress + "%");
      }
      setStartedTime(audioElement.current.currentTime);
    }
  };
  function handleLoadedMetadata(event) {
    setDuration(event.currentTarget.duration);
  }
  function onError(event) {
    var _event$currentTarget$;
    setError(((_event$currentTarget$ = event.currentTarget.error) == null ? void 0 : _event$currentTarget$.message) || 'Error al cargar el audio');
  }
  function handleUpdateTimeToTranscription(cue) {
    handleSeek({
      target: {
        value: cue.startTime.toString()
      }
    });
  }
  var closeAllExcept = function closeAllExcept(keepOpen) {
    if (keepOpen !== 'transcript') setShowTranscript(false);
  };
  return {
    t: t,
    transcriptData: transcriptData,
    currentText: currentText,
    showTranscript: showTranscript,
    isTextFile: isTextFile,
    isPlaying: isPlaying,
    handleTimeUpdate: handleTimeUpdate,
    handleLoadedMetadata: handleLoadedMetadata,
    setIsPlaying: setIsPlaying,
    onError: onError,
    handleUpdateTimeToTranscription: handleUpdateTimeToTranscription,
    closeAllExcept: closeAllExcept,
    setShowTranscript: setShowTranscript
  };
}

var _path$4;
function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var SvgTranscription = function SvgTranscription(props) {
  return /*#__PURE__*/createElement("svg", _extends$6({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4C4 2.89543 4.89543 2 6 2H10.5858C11.1162 2 11.6249 2.21071 12 2.58579L15.4142 6C15.7893 6.37507 16 6.88378 16 7.41421V16C16 17.1046 15.1046 18 14 18H6C4.89543 18 4 17.1046 4 16V4ZM6 10C6 9.44772 6.44772 9 7 9H13C13.5523 9 14 9.44772 14 10C14 10.5523 13.5523 11 13 11H7C6.44772 11 6 10.5523 6 10ZM7 13C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H7Z",
    fill: "#939DB0"
  })));
};

var TranscriptSelect = function TranscriptSelect(_ref) {
  var currentText = _ref.currentText,
    transcriptData = _ref.transcriptData,
    onSelect = _ref.onSelect,
    isOpen = _ref.isOpen,
    setIsOpen = _ref.setIsOpen,
    referenceElement = _ref.referenceElement,
    t = _ref.t,
    handleUpdateTimeToTranscription = _ref.handleUpdateTimeToTranscription;
  var transcriptRef = useRef(null);
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (transcriptRef.current && !transcriptRef.current.contains(event.target) && referenceElement && !referenceElement.contains(event.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, setIsOpen, referenceElement]);
  if (!isOpen) return null;
  return /*#__PURE__*/React__default.createElement("div", {
    ref: transcriptRef,
    className: "transcript-container",
    style: {
      position: 'absolute',
      top: 'calc(100% + 10px)',
      right: 0,
      width: '300px',
      maxHeight: '400px',
      backgroundColor: 'white',
      border: '1px solid #ddd',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      zIndex: 1000,
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "transcript-header"
  }, /*#__PURE__*/React__default.createElement("h4", {
    style: {
      margin: '12px 16px 8px',
      fontSize: '14px',
      fontWeight: 500
    }
  }, t('audio_transcription')), /*#__PURE__*/React__default.createElement("div", {
    style: {
      borderBottom: '1px solid #eee',
      margin: '0 16px'
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      maxHeight: '300px',
      overflowY: 'auto',
      padding: '8px 0'
    }
  }, currentText && /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: '8px 16px',
      backgroundColor: '#f5f5f5',
      margin: '0 8px 8px',
      borderRadius: '4px'
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, t('current_text'), ":"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      margin: '4px 0 0',
      fontSize: '13px'
    }
  }, currentText)), transcriptData.map(function (cue, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: index,
      className: "transcript-line",
      style: {
        padding: '8px 16px',
        cursor: 'pointer',
        borderBottom: '1px solid #f0f0f0',
        fontSize: '13px',
        lineHeight: '1.4'
      },
      onClick: function onClick() {
        handleUpdateTimeToTranscription(cue);
        onSelect(cue.text);
      },
      onMouseEnter: function onMouseEnter(e) {
        e.currentTarget.style.backgroundColor = '#f9f9f9';
      },
      onMouseLeave: function onMouseLeave(e) {
        e.currentTarget.style.backgroundColor = 'transparent';
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        color: '#666',
        fontSize: '11px',
        marginBottom: '2px'
      }
    }, formatTime(cue.startTime), " - ", formatTime(cue.endTime)), /*#__PURE__*/React__default.createElement("div", null, cue.text));
  })));
};
var formatTime = function formatTime(time) {
  var minutes = Math.floor(time / 60);
  var seconds = Math.floor(time % 60);
  return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
};

var SpeedControl = function SpeedControl(_ref) {
  var audioElement = _ref.audioElement,
    _ref$showTooltip = _ref.showTooltip,
    showTooltip = _ref$showTooltip === void 0 ? true : _ref$showTooltip;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useState = useState({
      showSpeedControl: false,
      playbackSpeed: 1
    }),
    state = _useState[0],
    setState = _useState[1];
  var speedOptions = [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];
  var playbackSpeed = state.playbackSpeed || 1;
  var handleClickOutside = function handleClickOutside() {
    setState(function (prevState) {
      return _extends({}, prevState, {
        showSpeedControl: false
      });
    });
  };
  var handleSpeedControlToggle = function handleSpeedControlToggle() {
    if (audioElement) {
      audioElement.playbackRate = state.playbackSpeed;
    }
    setState({
      showSpeedControl: !state.showSpeedControl,
      playbackSpeed: state.playbackSpeed
    });
  };
  var handleSpeedChange = function handleSpeedChange(speed) {
    if (audioElement) {
      audioElement.playbackRate = speed;
    }
    setState({
      showSpeedControl: false,
      playbackSpeed: speed
    });
  };
  return /*#__PURE__*/React__default.createElement(OutsideAlerter, {
    isActive: state.showSpeedControl,
    handleClickOutside: handleClickOutside
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "speed-control"
  }, showTooltip && /*#__PURE__*/React__default.createElement(TooltipWrapper, {
    componentButton: /*#__PURE__*/React__default.createElement("button", {
      onClick: handleSpeedControlToggle,
      className: "btn-speed",
      "aria-label": "Control de velocidad"
    }, playbackSpeed, "x"),
    componentTooltip: /*#__PURE__*/React__default.createElement(TooltipContent, {
      text: t('speed')
    }),
    openPortal: false
  }), state.showSpeedControl && /*#__PURE__*/React__default.createElement("div", {
    className: "speed-selector-container horizontal"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "speed-options"
  }, speedOptions.map(function (speed) {
    return /*#__PURE__*/React__default.createElement("button", {
      key: speed,
      onClick: function onClick() {
        return handleSpeedChange(speed);
      },
      className: "speed-option " + (playbackSpeed === speed ? 'active' : '')
    }, speed, "x");
  })))));
};

var _path$5, _path2;
function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
var SvgSound = function SvgSound(props) {
  return /*#__PURE__*/createElement("svg", _extends$7({
    className: "icon icon-sound",
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1358 4.15245C13.6589 4.3614 14 4.85366 14 5.39969V21.5997C14 22.1457 13.6589 22.638 13.1358 22.8469C12.6126 23.0559 12.0105 22.9404 11.6101 22.5543L6.42013 17.5497H2.80002C2.02683 17.5497 1.40002 16.9453 1.40002 16.1997V10.7997C1.40002 10.0541 2.02683 9.44969 2.80002 9.44969H6.42013L11.6101 4.44509C12.0105 4.05899 12.6126 3.94349 13.1358 4.15245Z",
    fill: "#4F4FFF"
  })), _path2 || (_path2 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5196 3.95363C21.0663 3.42643 21.9528 3.42643 22.4995 3.95363C25.0315 6.39517 26.6 9.77203 26.6 13.4996C26.6 17.2271 25.0315 20.604 22.4995 23.0455C21.9528 23.5727 21.0663 23.5727 20.5196 23.0455C19.9729 22.5183 19.9729 21.6635 20.5196 21.1363C22.5479 19.1804 23.8 16.4823 23.8 13.4996C23.8 10.5169 22.5479 7.81872 20.5196 5.86282C19.9729 5.33561 19.9729 4.48084 20.5196 3.95363ZM16.5598 7.77201C17.1065 7.2448 17.993 7.2448 18.5397 7.77201C19.2759 8.48195 19.8767 9.32392 20.3004 10.2591C20.7509 11.2531 21 12.3501 21 13.4996C21 15.736 20.0583 17.7628 18.5397 19.2271C17.993 19.7543 17.1065 19.7543 16.5598 19.2271C16.0131 18.6999 16.0131 17.8452 16.5598 17.318C17.5747 16.3393 18.2 14.9911 18.2 13.4996C18.2 12.7291 18.0335 11.9997 17.7347 11.3401C17.4528 10.7181 17.0523 10.1561 16.5598 9.6812C16.0131 9.15399 16.0131 8.29922 16.5598 7.77201Z",
    fill: "#4F4FFF"
  })));
};

var _path$6, _path2$1;
function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
var SvgMute = function SvgMute(props) {
  return /*#__PURE__*/createElement("svg", _extends$8({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2594 3.69148C11.7078 3.87721 12.0002 4.31478 12.0002 4.80013V19.2001C12.0002 19.6855 11.7078 20.1231 11.2594 20.3088C10.811 20.4945 10.2949 20.3919 9.95167 20.0487L5.50314 15.6001H2.4002C1.73745 15.6001 1.2002 15.0629 1.2002 14.4001V9.60013C1.2002 8.93739 1.73745 8.40013 2.4002 8.40013H5.50314L9.95167 3.9516C10.2949 3.60841 10.811 3.50574 11.2594 3.69148Z",
    fill: "#333333"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7517 8.75157C15.2203 8.28294 15.9801 8.28294 16.4487 8.75157L18.0002 10.303L19.5517 8.75157C20.0203 8.28294 20.7801 8.28294 21.2487 8.75157C21.7174 9.2202 21.7174 9.98 21.2487 10.4486L19.6973 12.0001L21.2487 13.5516C21.7174 14.0202 21.7174 14.78 21.2487 15.2486C20.7801 15.7173 20.0203 15.7173 19.5517 15.2486L18.0002 13.6972L16.4487 15.2486C15.9801 15.7173 15.2203 15.7173 14.7517 15.2486C14.283 14.78 14.283 14.0202 14.7517 13.5516L16.3031 12.0001L14.7517 10.4486C14.283 9.98 14.283 9.2202 14.7517 8.75157Z",
    fill: "#333333"
  })));
};

var VolumeControl = function VolumeControl(_ref) {
  var audioElement = _ref.audioElement;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useState = useState({
      showVolumeControl: false,
      volume: 0.5
    }),
    state = _useState[0],
    setState = _useState[1];
  var handleVolumeControlToggle = function handleVolumeControlToggle() {
    setState({
      showVolumeControl: !state.showVolumeControl,
      volume: state.volume
    });
  };
  var handleClickOutside = function handleClickOutside() {
    setState({
      showVolumeControl: false,
      volume: state.volume
    });
  };
  var handleMute = function handleMute() {
    if (audioElement) {
      audioElement.muted = !audioElement.muted;
    }
    setState({
      showVolumeControl: state.showVolumeControl,
      volume: audioElement.muted ? 0 : state.volume
    });
  };
  var handleVolumeChange = function handleVolumeChange(e) {
    if (audioElement) {
      audioElement.volume = parseFloat(e.target.value);
    }
    setState({
      showVolumeControl: state.showVolumeControl,
      volume: parseFloat(e.target.value)
    });
  };
  return /*#__PURE__*/React__default.createElement(OutsideAlerter, {
    isActive: state.showVolumeControl,
    handleClickOutside: handleClickOutside
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "volume-control"
  }, /*#__PURE__*/React__default.createElement(TooltipWrapper, {
    componentButton: /*#__PURE__*/React__default.createElement("button", {
      onClick: handleVolumeControlToggle,
      className: "btn-volume",
      "aria-label": "Control de volumen"
    }, /*#__PURE__*/React__default.createElement(SvgSound, null)),
    componentTooltip: /*#__PURE__*/React__default.createElement(TooltipContent, {
      text: t('volume')
    }),
    openPortal: false
  }), state.showVolumeControl && /*#__PURE__*/React__default.createElement("div", {
    className: "volume-slider-container horizontal"
  }, /*#__PURE__*/React__default.createElement("button", {
    onClick: handleMute,
    className: "mute-button",
    "aria-label": state.volume === 0 ? 'Activar sonido' : 'Silenciar'
  }, state.volume === 0 ? /*#__PURE__*/React__default.createElement(SvgMute, null) : /*#__PURE__*/React__default.createElement(SvgSound, null)), /*#__PURE__*/React__default.createElement("input", {
    type: "range",
    min: "0",
    max: "1",
    step: "0.01",
    value: state.volume,
    onChange: handleVolumeChange,
    className: "volume-slider horizontal",
    "aria-label": "Ajustar volumen",
    style: {
      '--volume-percentage': state.volume * 100 + "%"
    }
  }))));
};

var _g$1, _defs;
function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/createElement("svg", _extends$9({
    className: "icon icon-pause",
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$1 || (_g$1 = /*#__PURE__*/createElement("g", {
    filter: "url(#filter0_i_897_77684)"
  }, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.5 35C63.5 50.464 50.964 63 35.5 63C20.036 63 7.5 50.464 7.5 35C7.5 19.536 20.036 7 35.5 7C50.964 7 63.5 19.536 63.5 35ZM25 28C25 26.067 26.567 24.5 28.5 24.5C30.433 24.5 32 26.067 32 28V42C32 43.933 30.433 45.5 28.5 45.5C26.567 45.5 25 43.933 25 42V28ZM42.5 24.5C40.567 24.5 39 26.067 39 28V42C39 43.933 40.567 45.5 42.5 45.5C44.433 45.5 46 43.933 46 42V28C46 26.067 44.433 24.5 42.5 24.5Z",
    fill: "#4F4FFF"
  }))), _defs || (_defs = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("filter", {
    id: "filter0_i_897_77684",
    x: 7.5,
    y: 7,
    width: 59,
    height: 59,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_897_77684"
  })))));
};

var _g$2, _defs$1;
function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/createElement("svg", _extends$a({
    className: "icon icon-play",
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$2 || (_g$2 = /*#__PURE__*/createElement("g", {
    filter: "url(#filter0_i_896_74660)"
  }, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5 63C50.964 63 63.5 50.464 63.5 35C63.5 19.536 50.964 7 35.5 7C20.036 7 7.5 19.536 7.5 35C7.5 50.464 20.036 63 35.5 63ZM33.9415 25.0878C32.8675 24.3718 31.4865 24.3051 30.3485 24.9141C29.2104 25.5232 28.5 26.7092 28.5 28V42C28.5 43.2908 29.2104 44.4768 30.3485 45.0859C31.4865 45.6949 32.8675 45.6282 33.9415 44.9122L44.4414 37.9122C45.4151 37.2631 46 36.1702 46 35C46 33.8298 45.4151 32.737 44.4414 32.0878L33.9415 25.0878Z",
    fill: "#4F4FFF"
  }))), _defs$1 || (_defs$1 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("filter", {
    id: "filter0_i_896_74660",
    x: 7.5,
    y: 7,
    width: 59,
    height: 59,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_896_74660"
  })))));
};

var TimelineControl = function TimelineControl(_ref) {
  var audioElement = _ref.audioElement,
    audioState = _ref.audioState;
  var containerRef = useRef(null);
  var _useState = useState(0),
    currentTime = _useState[0],
    setCurrentTime = _useState[1];
  var _useState2 = useState(audioState || false),
    isPlaying = _useState2[0],
    setIsPlaying = _useState2[1];
  var _useState3 = useState(0),
    setStartedTime = _useState3[1];
  var _useState4 = useState(0),
    duration = _useState4[0],
    setDuration = _useState4[1];
  var formatTime = function formatTime(time) {
    var minutes = Math.floor(time / 60);
    var seconds = Math.floor(time % 60);
    return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
  };
  var togglePlay = function togglePlay() {
    if (audioElement) {
      if (isPlaying) {
        audioElement.pause();
      } else {
        audioElement.play();
      }
      setIsPlaying(!isPlaying);
    }
  };
  var handleSeek = function handleSeek(e) {
    var time = parseFloat(e.target.value);
    if (audioElement) {
      var _e$target;
      audioElement.currentTime = time;
      var progress = time / audioElement.duration * 100;
      if (e != null && (_e$target = e.target) != null && _e$target.style) {
        e.target.style.setProperty('--progress-percentage', progress + "%");
      }
      setStartedTime(audioElement.currentTime);
    }
  };
  useEffect(function () {
    if (audioElement) {
      // Verificar si la duración ya está disponible
      if (audioElement.duration && !isNaN(audioElement.duration)) {
        setDuration(audioElement.duration);
      }
      audioElement.addEventListener('timeupdate', function () {
        setCurrentTime(audioElement.currentTime);
      });
      audioElement.addEventListener('loadedmetadata', function () {
        setDuration(audioElement.duration);
      });
      // También escuchar el evento 'canplay' como respaldo
      audioElement.addEventListener('canplay', function () {
        if (audioElement.duration && !isNaN(audioElement.duration)) {
          setDuration(audioElement.duration);
        }
      });
    }
  }, [audioElement]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'timeline-control',
    ref: containerRef
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "" + (isPlaying ? 'pause-button' : 'play-button'),
    onClick: togglePlay
  }, isPlaying ? /*#__PURE__*/React__default.createElement(SvgPause, null) : /*#__PURE__*/React__default.createElement(SvgPlay, null)), /*#__PURE__*/React__default.createElement("span", {
    className: 'time current'
  }, formatTime(currentTime)), /*#__PURE__*/React__default.createElement("span", {
    className: 'time-divider'
  }, "/"), /*#__PURE__*/React__default.createElement("span", {
    className: 'time duration'
  }, formatTime(duration)), /*#__PURE__*/React__default.createElement("input", {
    type: 'range',
    className: 'timeline',
    value: currentTime,
    max: duration,
    onChange: handleSeek
  }));
};

var MediaAudio = function MediaAudio(_ref) {
  var audio = _ref.audio,
    getSrc = _ref.getSrc;
  var audioElement = useRef(null);
  var transcriptBtnRef = useRef(null);
  var _useMediaAudio = useMediaAudio({
      audio: audio,
      audioElement: audioElement
    }),
    t = _useMediaAudio.t,
    transcriptData = _useMediaAudio.transcriptData,
    currentText = _useMediaAudio.currentText,
    showTranscript = _useMediaAudio.showTranscript,
    isTextFile = _useMediaAudio.isTextFile,
    isPlaying = _useMediaAudio.isPlaying,
    handleTimeUpdate = _useMediaAudio.handleTimeUpdate,
    handleLoadedMetadata = _useMediaAudio.handleLoadedMetadata,
    setIsPlaying = _useMediaAudio.setIsPlaying,
    onError = _useMediaAudio.onError,
    handleUpdateTimeToTranscription = _useMediaAudio.handleUpdateTimeToTranscription,
    closeAllExcept = _useMediaAudio.closeAllExcept,
    setShowTranscript = _useMediaAudio.setShowTranscript;
  if (audio && audio.src) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: 'media-audio'
    }, /*#__PURE__*/React__default.createElement("audio", {
      ref: audioElement,
      src: getSrc(audio.src),
      onTimeUpdate: handleTimeUpdate,
      onLoadedMetadata: handleLoadedMetadata,
      onEnded: function onEnded() {
        return setIsPlaying(false);
      },
      onError: onError,
      key: audio.key
    }), /*#__PURE__*/React__default.createElement("div", {
      className: 'timeline-container'
    }, /*#__PURE__*/React__default.createElement(TimelineControl, {
      audioElement: audioElement.current,
      audioState: isPlaying
    }), /*#__PURE__*/React__default.createElement("div", {
      className: 'button-container'
    }, /*#__PURE__*/React__default.createElement(VolumeControl, {
      audioElement: audioElement.current
    }), /*#__PURE__*/React__default.createElement(SpeedControl, {
      audioElement: audioElement.current
    }), (audio == null ? void 0 : audio.transcription) && /*#__PURE__*/React__default.createElement("div", {
      className: 'transcript-select'
    }, /*#__PURE__*/React__default.createElement(TooltipWrapper, {
      componentButton: /*#__PURE__*/React__default.createElement("button", {
        className: 'audio-transcription-icon',
        ref: transcriptBtnRef,
        onClick: function onClick() {
          var newState = !showTranscript;
          setShowTranscript(newState);
          if (newState) closeAllExcept('transcript');
        }
      }, /*#__PURE__*/React__default.createElement(SvgTranscription, null)),
      componentTooltip: /*#__PURE__*/React__default.createElement(TooltipContent, {
        text: t('audio_transcription')
      }),
      openPortal: false
    }), showTranscript && /*#__PURE__*/React__default.createElement(TranscriptSelect, {
      currentText: currentText,
      transcriptData: transcriptData,
      onSelect: function onSelect() {},
      audioElement: audioElement,
      isOpen: showTranscript,
      setIsOpen: setShowTranscript,
      closeOtherControls: function closeOtherControls() {
        return closeAllExcept('transcript');
      },
      hideArrow: true,
      referenceElement: transcriptBtnRef.current,
      t: t,
      handleUpdateTimeToTranscription: handleUpdateTimeToTranscription,
      isTextFile: isTextFile
    })))));
  } else {
    return null;
  }
};

var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPoSURBVHgB3ZtBSBtBFIZfVCw9eFILVQqeElLISRFy0iLeLHjwkquC9NBcUvAaejcXj6mgePEkSNtTUWgvLUoVD4VoQAk0RmgtCAmllRY7/+5O3Gx2zWZ3ZnfSD56bjRv15828efPmGSHx9DGLGhYzrnjvoeW5C2YVZlVmB8yKxlUoERIDBIwyS9GtIC9wsR+YvSEB+BUIISnDvIpyAt49ZJY3XnvCq0CZwuyAyLfkQagXgZPMXlDznJINxL2iNodudxvPwlNp0sUF4TW73z9pXL8wu3bzIbcehLdypAcQFYA3n5GLIetGIMTlKfgh2QpXIlsNUVXFAQzVCdKXlKrTQ3cJVFkcp6XI7js+uE5qi+PwJOMd2QQeJ4GIlknqHPqZ3WP2yfoNO4FPmT2nziNBej5bMr/ZZXkIQ3KROpcMWdZoq0B4rxPmnRNDpKePdcwChXgvmUzeLxQK8Zubm9HV1dVHAwMD7WRLImjIj80LfZZ0D/qiXC4nhoeHe/n9+fn59dTU1AnDVWoliLxhDR4cIwGYxfH74+PjRC6XC3Lo173IBUqfe5lMZmhvby8ai8V6ST58bawLnKAAGB8f79vd3Y2l0+l+ko8WbLjAUQoIDNmVlZWRAAKQVjqBQIgLfH+3sLDw4Ojo6LHEIasVvyAwtD1eAAEoyj0YKhIDUAwCwyg/NCEpAGkeHCJFkBCA+pDJfCaBIEUjAYjKgLpIUeDNjY2NEfKJsh7kRCIRX+cVynoQbG1t/SCfQOAFKcja2tq3ubm5EvnjAgKrpBCVSuX3zMxMcX5+/iv5p9LDvpyQIhXrnZ2dq1QqVbq8vPxLYqjCg0UKmVqt9iebzZanp6dPBYoDB/BgqAJZLvpzdnb2VNKOv8g9GMo8RCCJx+MFSeK002IeZAL1ouBA4oS2fvYYN5sU0K5CQiBxAucV9YUeaqUOU4mBxA4cqWknwdyDEAcvSqlqSw4kdhzyF+ZUDQJ9e3F/f7/hZ0gOJE7k+Qvzngt/AE5ofM3F7e3tq8HBwa6zs7NfS0tL5eXl5e8ULBD3nt9Yj7Cxu39NiuzyPdB0rG3dTWB4vaTOBW0mDWf2dmWBEukeTFBngRiybn3TaT+IcRx6jtoG8Fre7htOhR0EnI/MnpD685HPO9vNcas+GdU7LVr2yvz3jUBuajIoaSySWqUNxAdXrVxui6s10tsZkQiEHV0RLbGUuSpItVM9RuBBHwo8iVbloIMPvAVhm+Sy0xB4bYjFfMSpcBAtJ3wj4ClX9tvSzDszxkh8EPIljCOqKR3AozgK93OgyqsLECVkjypSoBmIjNKtWJxg2f1bARd0YlyF14f+Aa2vRoOHSNX/AAAAAElFTkSuQmCC";

var subtitlesCache = {};
var convertSrtToVtt = function convertSrtToVtt(srtContent) {
  // Empezamos con la cabecera WEBVTT
  var vttContent = 'WEBVTT\n\n';
  // Normalizamos los saltos de línea y dividimos por bloques
  var blocks = srtContent.replace(/\r\n/g, '\n') // Convertimos CRLF a LF
  .trim().split('\n\n').filter(function (block) {
    return block.trim().length > 0;
  });
  blocks.forEach(function (block) {
    var lines = block.split('\n');
    if (lines.length >= 2) {
      // Ignoramos la primera línea (número de subtítulo)
      // Procesamos la línea de tiempo reemplazando todas las comas por puntos
      var timing = lines[1].replace(/,/g, '.');
      // Juntamos el resto de líneas como texto
      var text = lines.slice(2).join('\n');
      if (timing && text) {
        // Usamos solo \n para los saltos de línea
        vttContent += timing + "\n" + text + "\n\n";
      }
    }
  });
  // Aseguramos que todo el contenido use \n como salto de línea antes de codificar
  var normalizedContent = vttContent.replace(/\r\n/g, '\n');
  // Codificamos a base64 asegurándonos de manejar caracteres especiales
  try {
    return btoa(unescape(encodeURIComponent(normalizedContent)));
  } catch (error) {
    console.error('Error codificando subtítulos:', error);
    console.log('Contenido VTT:', normalizedContent);
    throw error;
  }
};
function validateVttContent(vttContent) {
  // El contenido debe empezar con WEBVTT
  if (!vttContent.startsWith('WEBVTT')) return false;
  // Debe tener al menos un bloque de subtítulos
  var lines = vttContent.split('\n');
  if (lines.length < 4) return false; // WEBVTT + línea vacía + tiempo + texto
  // Verificar formato de tiempo (00:00:00.000 --> 00:00:00.000)
  var timeRegex = /^\d{2}:\d{2}:\d{2}\.\d{3} --> \d{2}:\d{2}:\d{2}\.\d{3}$/;
  var hasValidTimestamp = false;
  for (var _iterator = _createForOfIteratorHelperLoose(lines), _step; !(_step = _iterator()).done;) {
    var line = _step.value;
    if (timeRegex.test(line)) {
      hasValidTimestamp = true;
      break;
    }
  }
  return hasValidTimestamp;
}
var silentFetch = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(url) {
    var _t;
    return _regeneratorRuntime().wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 1;
          return fetch(url);
        case 1:
          return _context.abrupt("return", _context.sent);
        case 2:
          _context.prev = 2;
          _t = _context["catch"](0);
          return _context.abrupt("return", null);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 2]]);
  }));
  return function silentFetch(_x) {
    return _ref.apply(this, arguments);
  };
}();
var fetchAndConvertSubtitles = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(videoSrc, getSrc) {
    var srtUrl, response, srtContent, base64Content, decodedContent, _t2;
    return _regeneratorRuntime().wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          if (!subtitlesCache[videoSrc]) {
            _context2.next = 1;
            break;
          }
          return _context2.abrupt("return", subtitlesCache[videoSrc]);
        case 1:
          srtUrl = videoSrc.substring(0, videoSrc.lastIndexOf('.')) + '.srt';
          _context2.next = 2;
          return silentFetch(getSrc(srtUrl));
        case 2:
          response = _context2.sent;
          if (!(!response || !response.ok)) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return", null);
        case 3:
          _context2.next = 4;
          return response.text();
        case 4:
          srtContent = _context2.sent;
          if (srtContent.trim()) {
            _context2.next = 5;
            break;
          }
          return _context2.abrupt("return", null);
        case 5:
          base64Content = convertSrtToVtt(srtContent); // Validar el contenido antes de devolverlo
          decodedContent = decodeURIComponent(escape(atob(base64Content)));
          if (validateVttContent(decodedContent)) {
            _context2.next = 6;
            break;
          }
          return _context2.abrupt("return", null);
        case 6:
          subtitlesCache[videoSrc] = base64Content;
          return _context2.abrupt("return", base64Content);
        case 7:
          _context2.prev = 7;
          _t2 = _context2["catch"](0);
          return _context2.abrupt("return", null);
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 7]]);
  }));
  return function fetchAndConvertSubtitles(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

var MediaVideo = function MediaVideo(_ref) {
  var video = _ref.video,
    getSrc = _ref.getSrc;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var vidRef = useRef(null);
  var _useState = useState(false),
    playVideo = _useState[0],
    setPlayVideo = _useState[1];
  var _useState2 = useState(null),
    subtitlesUrl = _useState2[0],
    setSubtitlesUrl = _useState2[1];
  var subtitlesUrlRef = useRef(null);
  useEffect(function () {
    var mounted = true;
    var loadSubtitles = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var base64Content, _t;
        return _regeneratorRuntime().wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (video != null && video.src) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              _context.prev = 1;
              _context.next = 2;
              return fetchAndConvertSubtitles(video.src, getSrc);
            case 2:
              base64Content = _context.sent;
              if (mounted) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              if (base64Content) {
                setSubtitlesUrl("data:text/vtt;base64," + base64Content);
              }
              _context.next = 5;
              break;
            case 4:
              _context.prev = 4;
              _t = _context["catch"](1);
              // Silenciosamente manejamos el error - no hay subtítulos disponibles
              setSubtitlesUrl(null);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 4]]);
      }));
      return function loadSubtitles() {
        return _ref2.apply(this, arguments);
      };
    }();
    loadSubtitles();
    return function () {
      mounted = false;
    };
  }, [video == null ? void 0 : video.src, getSrc]);
  function onClickThumbnail() {
    setPlayVideo(true);
    if (vidRef != null && vidRef.current) {
      vidRef.current.play();
    }
  }
  if (video && video.src) {
    var videoSrc = getSrc(video.src);
    return /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-video'
    }, /*#__PURE__*/React__default.createElement("video", {
      controls: true,
      controlsList: 'nodownload',
      className: 'video',
      key: video.key,
      ref: vidRef
    }, /*#__PURE__*/React__default.createElement("source", {
      src: videoSrc,
      type: 'video/mp4'
    }), subtitlesUrl && /*#__PURE__*/React__default.createElement("track", {
      label: "Espa\xF1ol",
      kind: 'subtitles',
      srcLang: 'es',
      src: subtitlesUrl,
      default: true
    }), /*#__PURE__*/React__default.createElement("p", null, t('media_video_browser_not_support_part_1'), ' ', /*#__PURE__*/React__default.createElement("a", {
      href: videoSrc
    }, t('media_video_browser_not_support_part_2_href')), ' ', t('media_video_browser_not_support_part_3'))), !playVideo && /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-video__thumbnail',
      onClick: onClickThumbnail
    }, /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-video__thumbnail-play'
    }, /*#__PURE__*/React__default.createElement("img", {
      src: img,
      alt: 'play'
    }))));
  } else {
    return null;
  }
};

var _AccordionItem = function AccordionItem(_ref) {
  var _itemInside$media2, _itemInside$contents;
  var itemInside = _ref.itemInside,
    index = _ref.index,
    isEditMode = _ref.isEditMode,
    alignImages = _ref.alignImages,
    modeTextHtml = _ref.modeTextHtml,
    mode = _ref.mode,
    getSrc = _ref.getSrc,
    getTextHtml = _ref.getTextHtml,
    titleUpdatedIndex = _ref.titleUpdatedIndex,
    descriptionUpdatedIndex = _ref.descriptionUpdatedIndex,
    captionUpdatedIndex = _ref.captionUpdatedIndex,
    clickAccordion = _ref.clickAccordion,
    onReadyGetTextHtml = _ref.onReadyGetTextHtml,
    t = _ref.t,
    accordionsOpen = _ref.accordionsOpen,
    item = _ref.item,
    onClickTitlteAccordion = _ref.onClickTitlteAccordion,
    indexContents = _ref.indexContents,
    _ref$showContents = _ref.showContents,
    showContents = _ref$showContents === void 0 ? false : _ref$showContents;
  var alignImageItemInside = getItemSettingAlignImage(itemInside);
  var sizeImageItemInside = getItemSettingImageSize(itemInside);
  // == Si esta especificada la opcion del subitem prevalece esa opción en otro caso coge la opcion del setting general alignImages
  var alignImageFinal = alignImageItemInside && alignImageItemInside !== SETTINGS_ALIGN_IMAGES.UNSPECIFIED ? alignImageItemInside : alignImages;
  var sizeImageFinal = sizeImageItemInside ? sizeImageItemInside : 'extra-large';
  var renderDescription = function renderDescription(description, onChangeText, keyDescription) {
    return description && getTextHtml(description, onChangeText, keyDescription, modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml);
  };
  var renderAudio = function renderAudio(audio, mediaId) {
    return /*#__PURE__*/React__default.createElement(MediaAudio, {
      audio: audio,
      key: mediaId + '_audio' || audio.key,
      getSrc: getSrc
    });
  };
  var renderVideo = function renderVideo(video, mediaId) {
    return /*#__PURE__*/React__default.createElement(MediaVideo, {
      video: video,
      key: mediaId + '_video' || video.key,
      getSrc: getSrc
    });
  };
  var renderImage = function renderImage() {
    var _itemInside$media;
    if (!((_itemInside$media = itemInside.media) != null && _itemInside$media.image)) return null;
    var image = itemInside.media.image;
    var alt = image.alt || '';
    var enableZoomOnClick = getItemSettingIsZoomOnClick(item);
    var hasCaption = itemInside.caption || itemInside.media && isEditMode;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-block-accordion__image-wrapper ' + (alignImageFinal ? "mint-block-accordion__image-wrapper--" + alignImageFinal : '') + (sizeImageFinal ? " mint-block-accordion__image-wrapper--" + sizeImageFinal : '')
    }, /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-block-accordion__image'
    }, /*#__PURE__*/React__default.createElement(MediaImage, {
      image: image,
      alt: alt,
      getSrc: getSrc,
      enableZoomOnClick: enableZoomOnClick,
      mode: mode
    }))), hasCaption && getTextHtml(itemInside.caption || '', function (text) {
      return captionUpdatedIndex && captionUpdatedIndex(text, index, indexContents);
    }, itemInside.id + '_caption', modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml));
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, renderDescription(itemInside.description, function (text) {
    return descriptionUpdatedIndex && descriptionUpdatedIndex(text, index, indexContents);
  }, itemInside.id + '_description'), itemInside.media && itemInside.media.audio && renderAudio(itemInside.media.audio, itemInside.id), ((_itemInside$media2 = itemInside.media) == null ? void 0 : _itemInside$media2.image) && renderImage(), itemInside.media && itemInside.media.video && renderVideo(itemInside.media.video, itemInside.id), showContents && /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-accordion__contents'
  }, (_itemInside$contents = itemInside.contents) == null ? void 0 : _itemInside$contents.map(function (itemInsideContent, indexItemInsideContents) {
    return /*#__PURE__*/React__default.createElement(_AccordionItem, {
      key: itemInsideContent.id,
      itemInside: itemInsideContent,
      index: index,
      isOpen: accordionsOpen.includes(item.id + "|" + itemInside.id),
      isEditMode: isEditMode,
      alignImages: alignImages,
      modeTextHtml: modeTextHtml,
      getSrc: getSrc,
      getTextHtml: getTextHtml,
      titleUpdatedIndex: titleUpdatedIndex,
      descriptionUpdatedIndex: descriptionUpdatedIndex,
      captionUpdatedIndex: captionUpdatedIndex,
      clickAccordion: clickAccordion,
      onReadyGetTextHtml: onReadyGetTextHtml,
      t: t,
      accordionsOpen: accordionsOpen,
      item: item,
      onClickTitlteAccordion: onClickTitlteAccordion,
      indexContents: indexItemInsideContents,
      showContents: false
    });
  })));
};

var Accordion = function Accordion(_ref) {
  var item = _ref.item,
    mode = _ref.mode,
    getTextHtml = _ref.getTextHtml,
    getSrc = _ref.getSrc,
    titleUpdatedIndex = _ref.titleUpdatedIndex,
    descriptionUpdatedIndex = _ref.descriptionUpdatedIndex,
    captionUpdatedIndex = _ref.captionUpdatedIndex,
    onReady = _ref.onReady;
  var _useAccordion = useAccordion({
      item: item,
      mode: mode
    }),
    modeTextHtml = _useAccordion.modeTextHtml,
    accordionsOpen = _useAccordion.accordionsOpen,
    alignImages = _useAccordion.alignImages,
    clickAccordion = _useAccordion.clickAccordion,
    t = _useAccordion.t,
    showAdditionalContentsSubItemVisor = _useAccordion.showAdditionalContentsSubItemVisor;
  var _useItemBlockComponen = useItemBlockComponent({
      numComponentsTextHtml: getNumComponentsTextHtml(),
      onReady: onReady,
      item: item
    }),
    onReadyGetTextHtml = _useItemBlockComponen.onReadyGetTextHtml;
  var isEditMode = modeTextHtml === IModesTextHtml.MODE_TEXT_HTML_EDITOR;
  function getNumComponentsTextHtml() {
    var num = 0;
    for (var _iterator = _createForOfIteratorHelperLoose(item.items), _step; !(_step = _iterator()).done;) {
      var itemInside = _step.value;
      if (itemInside.title) num++;
      if (itemInside.description) num++;
      if (itemInside.caption) num++;
    }
    return num;
  }
  function onClickTitlteAccordion(e) {
    if (isEditMode) e.stopPropagation();
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-accordion'
  }, item.items && item.items.map(function (itemInside, index) {
    var alignImageItemInside = getItemSettingAlignImage(itemInside);
    var sizeImageItemInside = getItemSettingImageSize(itemInside);
    return /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-block-accordion__box mint-block-accordion__box--' + (accordionsOpen && accordionsOpen.indexOf(item.id + "|" + itemInside.id) >= 0 ? 'show' : 'hidden') + ' brand--after-background' + (isEditMode ? ' mint-block-accordion__box--edit' : '') + (' ' + CLASS_CONTENT_LEFT),
      key: itemInside.id
    }, /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-block-accordion__question',
      onClick: function onClick(e) {
        return clickAccordion(e, item.id, itemInside.id);
      }
    }, /*#__PURE__*/React__default.createElement("h5", {
      className: 'mint-block-accordion__text brand--first',
      onClick: onClickTitlteAccordion
    }, (itemInside.title || isEditMode) && getTextHtml(itemInside.title, function (text) {
      return titleUpdatedIndex && titleUpdatedIndex(text, index);
    }, itemInside.id + '_title', modeTextHtml, t('Enter a title...', {
      ns: 'editor'
    }), undefined, undefined, undefined, undefined, onReadyGetTextHtml)), /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-block-accordion__symbol brand--color'
    }, /*#__PURE__*/React__default.createElement("span", {
      className: 'mint-block-accordion__icon-show'
    }, "+"), /*#__PURE__*/React__default.createElement("span", {
      className: 'mint-block-accordion__icon-hidden'
    }, "-"))), /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-block-accordion__content brand--second-all'
    }, /*#__PURE__*/React__default.createElement(_AccordionItem, {
      key: itemInside.id,
      itemInside: itemInside,
      index: index,
      isOpen: accordionsOpen.includes(item.id + "|" + itemInside.id),
      isEditMode: isEditMode,
      alignImages: alignImages,
      modeTextHtml: modeTextHtml,
      getSrc: getSrc,
      getTextHtml: getTextHtml,
      titleUpdatedIndex: titleUpdatedIndex,
      descriptionUpdatedIndex: descriptionUpdatedIndex,
      captionUpdatedIndex: captionUpdatedIndex,
      clickAccordion: clickAccordion,
      onReadyGetTextHtml: onReadyGetTextHtml,
      t: t,
      accordionsOpen: accordionsOpen,
      item: item,
      onClickTitlteAccordion: onClickTitlteAccordion,
      indexContents: undefined,
      showContents: showAdditionalContentsSubItemVisor && true
    })));
  }));
};

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  function ErrorBoundary() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      error: null,
      errorInfo: null
    };
    return _this;
  }
  _inheritsLoose(ErrorBoundary, _React$Component);
  var _proto = ErrorBoundary.prototype;
  _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  };
  _proto.render = function render() {
    if (this.state.errorInfo) {
      console.log(this.state);
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("h2", null, "Something went wrong."), /*#__PURE__*/React__default.createElement("details", {
        style: {
          whiteSpace: "pre-wrap"
        }
      }, this.state.error && this.state.error.toString(), /*#__PURE__*/React__default.createElement("br", null), this.state.errorInfo.componentStack));
    }
    return this.props.children;
  };
  return ErrorBoundary;
}(React__default.Component);

var useOnline = function useOnline() {
  var _useState = useState(navigator.onLine),
    online = _useState[0],
    isOnline = _useState[1];
  var setOnline = function setOnline() {
    isOnline(true);
  };
  var setOffline = function setOffline() {
    isOnline(false);
  };

  // Register the event listeners
  useEffect(function () {
    window.addEventListener('offline', setOffline);
    window.addEventListener('online', setOnline);

    // cleanup if we unmount
    return function () {
      window.removeEventListener('offline', setOffline);
      window.removeEventListener('online', setOnline);
    };
  }, []);
  return {
    online: online
  };
};

var _g$3, _defs$2;
function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
var SvgEyeOff = function SvgEyeOff(props) {
  return /*#__PURE__*/createElement("svg", _extends$b({
    width: 56,
    height: 54,
    viewBox: "0 0 56 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$3 || (_g$3 = /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", {
    fill: "#3573E7"
  }, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.268 6.232a2.5 2.5 0 0 0-3.536 3.536l35 35a2.5 2.5 0 0 0 3.536-3.536l-3.683-3.683a25.036 25.036 0 0 0 8.271-12.05C48.67 15.358 39.195 8 28 8c-4.058 0-7.891.967-11.28 2.684l-4.452-4.452zM22.92 16.885l3.785 3.784a5.005 5.005 0 0 1 6.126 6.127l3.785 3.784A9.954 9.954 0 0 0 38 25.5c0-5.523-4.477-10-10-10a9.953 9.953 0 0 0-5.08 1.385z"
  }), /*#__PURE__*/createElement("path", {
    d: "m34.135 42.242-6.76-6.761a10.001 10.001 0 0 1-9.355-9.355l-9.183-9.182A24.95 24.95 0 0 0 4.145 25.5C7.331 35.643 16.806 43 28 43a25.05 25.05 0 0 0 6.135-.758z"
  })))), _defs$2 || (_defs$2 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("filter", {
    id: "4undc4w8tb",
    x: -1,
    y: 0.5,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_43_28263"
  }), /*#__PURE__*/createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_43_28263",
    result: "shape"
  })), /*#__PURE__*/createElement("filter", {
    id: "0mat2i9mhc",
    x: 0.145,
    y: 3.5,
    width: 55.711,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_43_28263"
  }), /*#__PURE__*/createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_43_28263",
    result: "shape"
  })), /*#__PURE__*/createElement("clipPath", {
    id: "hbha3t2dwa"
  }, /*#__PURE__*/createElement("path", {
    fill: "#fff",
    transform: "translate(3 .5)",
    d: "M0 0h50v50H0z"
  })))));
};

var VideoNoInternet = function VideoNoInternet() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-video-no-internet'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-video-no-internet__wrapper'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-video-no-internet__icon'
  }, /*#__PURE__*/React__default.createElement(SvgEyeOff, null)), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-video-no-internet__text'
  }, t('video_no_internet'))));
};

var MediaEmbed = function MediaEmbed(_ref) {
  var embed = _ref.embed,
    _ref$showMetaData = _ref.showMetaData,
    showMetaData = _ref$showMetaData === void 0 ? true : _ref$showMetaData,
    getSrc = _ref.getSrc;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useOnline = useOnline(),
    online = _useOnline.online;
  var _useState = useState(true),
    showThumbnail = _useState[0],
    setShowThumbnail = _useState[1];
  var _useState2 = useState(false),
    playing = _useState2[0],
    setPlaying = _useState2[1];
  var isVideo = useMemo(function () {
    return isURLYoutube(embed == null ? void 0 : embed.src) || isURLVimeo(embed == null ? void 0 : embed.src);
  }, [embed.src]);
  function onClickThumbnail() {
    if (isVideo) {
      setShowThumbnail(false);
      setPlaying(true);
    } else {
      window.open(embed.src, '_blank');
    }
  }
  function renderEmbedVideo() {
    return online ? /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-embed__video-wrapper'
    }, showThumbnail ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-embed__thumbnail',
      onClick: onClickThumbnail
    }, isVideo && /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-embed__thumbnail-play'
    }, /*#__PURE__*/React__default.createElement("img", {
      src: img,
      alt: 'play'
    })), /*#__PURE__*/React__default.createElement("img", {
      className: 'mint-embed__thumbnail-img',
      src: embed.thumbnail,
      alt: embed.title
    })), /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-embed__player'
    })) : /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-embed__player'
    }, embed && /*#__PURE__*/React__default.createElement(ReactPlayer, {
      url: embed.src,
      width: '100%',
      height: '100%',
      controls: true,
      playing: playing
    }))) : /*#__PURE__*/React__default.createElement(VideoNoInternet, null);
  }
  function renderEmbedLink() {
    return embed.thumbnail && /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-embed__video-wrapper'
    }, /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-embed__thumbnail',
      onClick: onClickThumbnail
    }, /*#__PURE__*/React__default.createElement("a", {
      href: embed.src,
      target: '_blank'
    }, /*#__PURE__*/React__default.createElement("img", {
      className: 'mint-embed__thumbnail-img',
      src: embed.thumbnail,
      alt: 'Link thumb'
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-embed__player'
    }));
  }
  function renderEmbed() {
    if (embed.embedType === 'link') return renderEmbedLink();
    // En mint original video se instanciaba como un iframe y el src de embedly, ahora lo pintamos con nuestro reproductor
    else if (['videolink', 'video'].indexOf(embed.embedType) > -1) return renderEmbedVideo();else return online ? /*#__PURE__*/React__default.createElement("figure", {
      "aria-hidden": 'false',
      "aria-label": 'Embedded media player',
      className: 'mint-embed-wrap'
    }, embed.embedType === 'iframe' ? /*#__PURE__*/React__default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: embed.src
      }
    }) : embed.embedType === 'htmlInteractive' ? /*#__PURE__*/React__default.createElement("iframe", {
      className: 'mint-embed__media',
      src: getSrc(embed.src),
      title: embed.title
    }) : /*#__PURE__*/React__default.createElement("iframe", {
      className: 'mint-embed__media',
      src: embed.src,
      title: embed.title
    })) : /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-embed-wrap__no-internet'
    }, /*#__PURE__*/React__default.createElement(VideoNoInternet, null));
  }
  if (embed) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-embed ' + CLASS_CONTENT_LEFT
    }, showMetaData ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, embed.provider && /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-embed__provider'
    }, /*#__PURE__*/React__default.createElement("img", {
      className: 'mint-embed__provider-favicon',
      src: embed.favicon,
      alt: ''
    }), /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-embed__provider-provider brand--first'
    }, /*#__PURE__*/React__default.createElement("a", {
      className: 'brand--hover-color',
      href: embed.providerUrl,
      target: '_blank'
    }, embed.provider))), renderEmbed(), embed.title && /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-embed__title'
    }, /*#__PURE__*/React__default.createElement("h2", null, /*#__PURE__*/React__default.createElement("a", {
      className: 'brand--hover-color brand--first',
      href: embed.src,
      target: '_blank'
    }, embed.title))), embed.description && /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-embed__description'
    }, embed.description), embed.provider && /*#__PURE__*/React__default.createElement("a", {
      className: 'mint-embed__link brand--first brand--hover-color',
      href: embed.originalUrl,
      target: '_blank'
    }, (t('media_embed_view_on') + ' ' + embed.provider + ' >').toUpperCase())) : renderEmbed());
  } else {
    return null;
  }
};

function Media(_ref) {
  var media = _ref.media,
    alt = _ref.alt,
    mediaId = _ref.mediaId,
    _ref$enableZoomOnClic = _ref.enableZoomOnClick,
    enableZoomOnClick = _ref$enableZoomOnClic === void 0 ? true : _ref$enableZoomOnClic,
    _ref$showMetaData = _ref.showMetaData,
    showMetaData = _ref$showMetaData === void 0 ? true : _ref$showMetaData,
    getSrc = _ref.getSrc,
    mode = _ref.mode;
  if (!media) return null;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, media.audio && /*#__PURE__*/React__default.createElement(MediaAudio, {
    audio: media.audio,
    key: mediaId + '_audio' || media.audio.key,
    getSrc: getSrc
  }), media.image && /*#__PURE__*/React__default.createElement(MediaImage, {
    image: media.image,
    alt: alt,
    key: mediaId + '_image' || media.image.src,
    enableZoomOnClick: enableZoomOnClick,
    getSrc: getSrc,
    mode: mode
  }), media.video && /*#__PURE__*/React__default.createElement(MediaVideo, {
    video: media.video,
    key: mediaId + '_video' || media.video.key,
    getSrc: getSrc
  }), media.embed && /*#__PURE__*/React__default.createElement(MediaEmbed, {
    embed: media.embed,
    key: mediaId + '_embed' || media.embed.key,
    showMetaData: showMetaData,
    getSrc: getSrc
  }));
}

function LabeledGraphicDialog(props) {
  var _myItem$media;
  var getTextHtml = props.getTextHtml,
    item = props.item,
    getSrc = props.getSrc,
    myItem = props.myItem,
    mode = props.mode;
  var index = props.index;
  var items = item == null ? void 0 : item.items;
  var color = props.color ? props.color : undefined;
  var altClean = myItem.description;
  if (myItem.description) {
    altClean = removeHtmlTags(altClean);
  }
  var clickNext = props.clickNext;
  var clickBack = props.clickBack;
  // == Si esta configurado con closeWhenClickOut a true entonces vamos a activar el componente OutsideAlerter (OutsideAlerter isActive={true}) que es necesario para que nos avise cuando se hace click fuera
  return /*#__PURE__*/React__default.createElement(ErrorBoundary, null, /*#__PURE__*/React__default.createElement(OutsideAlerter, {
    isActive: props.closeWhenClickOut,
    handleClickOutside: props.handleClickOutside,
    classListIgnoreClick: ['lesson__block-interactive-label-link']
  }, /*#__PURE__*/React__default.createElement("div", {
    className: props.className,
    style: {
      borderColor: color
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'lesson__block-interactive-label-nav-title'
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: 'lesson__block-interactive-label-title brand--first'
  }, getTextHtml(myItem.title, function () {}, myItem.id, IModesTextHtml.MODE_TEXT_HTML_VISOR)), /*#__PURE__*/React__default.createElement("div", {
    className: 'lesson__block-interactive-label-nav'
  }, /*#__PURE__*/React__default.createElement("a", {
    href: '',
    className: 'lesson__block-interactive-label-back',
    onClick: function onClick(e) {
      e.stopPropagation();
      clickBack(e, items, index);
    }
  }, "Back"), /*#__PURE__*/React__default.createElement("a", {
    href: '',
    className: 'lesson__block-interactive-label-next',
    onClick: function onClick(e) {
      e.stopPropagation();
      clickNext(e, items, index);
    }
  }, "Next"), /*#__PURE__*/React__default.createElement("a", {
    href: '',
    className: 'lesson__block-interactive-label-close'
  }, "Close"))), /*#__PURE__*/React__default.createElement("div", {
    className: 'lesson__block-interactive-label-plain-text brand--second'
  }, myItem.media && /*#__PURE__*/React__default.createElement("div", {
    className: 'lesson__block-interactive-label-plain-text-img'
  }, /*#__PURE__*/React__default.createElement(Media, {
    media: myItem.media,
    alt: ((_myItem$media = myItem.media) == null || (_myItem$media = _myItem$media.image) == null ? void 0 : _myItem$media.alt) || '',
    mediaId: myItem.id,
    enableZoomOnClick: getItemSettingIsZoomOnClick(myItem),
    getSrc: getSrc,
    mode: mode
  })), myItem.description && getTextHtml(myItem.description, function () {}, myItem.id, IModesTextHtml.MODE_TEXT_HTML_VISOR)))));
}

function useLabeledGraphic(props) {
  var item = props.item,
    color = props.color;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var settings = item && item.settings ? item.settings : null;
  var keyItem = item.id;
  var mediaImage = item.media && item.media.image ? item.media.image : null;
  var mediaWidth = settings ? settings.mediaWidth : null;
  var _color = color || undefined;
  var classAddInteractiveLabel = mediaWidth ? mediaWidth === ISettingsImageWidth.SMALL ? 'lesson__block-interactive-label--small' : mediaWidth === ISettingsImageWidth.MEDIUM ? 'lesson__block-interactive-label--medium' : mediaWidth === ISettingsImageWidth.FULL_WIDTH ? 'lesson__block-interactive-label--full' : '' : '';
  var _useState = useState({
      labeledgraphicItemOpen: null
    }),
    state = _useState[0],
    dispatch = _useState[1];
  function clickLabeledgraphicItem(id) {
    if (state.labeledgraphicItemOpen && state.labeledgraphicItemOpen.valueOf() === id) {
      // El cuadro de dialogo estaba abierto, por tanto lo cierro
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          labeledgraphicItemOpen: null
        });
      });
    } else {
      // El cuadro de dialogo estaba cerrado, por tanto lo abro
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          labeledgraphicItemOpen: id
        });
      });
    }
  }
  function handleClickLabeledgraphicItem(e, id) {
    e.preventDefault();
    e.stopPropagation();
    clickLabeledgraphicItem(id);
  }
  function handleClickNext(e, items, indexItemActualOpen) {
    e.preventDefault();
    if (items) {
      if (indexItemActualOpen + 1 < items.length && items[indexItemActualOpen + 1]) {
        // Hay siguiente
        clickLabeledgraphicItem(items[indexItemActualOpen + 1].id);
      } else if (items[0]) {
        // Voy al primero
        clickLabeledgraphicItem(items[0].id);
      }
    }
  }
  function handleClickBack(e, items, indexItemActualOpen) {
    e.preventDefault();
    if (items) {
      if (indexItemActualOpen - 1 >= 0 && items[indexItemActualOpen - 1]) {
        // Hay anterior
        clickLabeledgraphicItem(items[indexItemActualOpen - 1].id);
      } else if (items[items.length - 1]) {
        // Voy al ultimo
        clickLabeledgraphicItem(items[items.length - 1].id);
      }
    }
  }
  function handleClickOutside() {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        labeledgraphicItemOpen: null
      });
    });
  }
  return {
    t: t,
    labeledgraphicItemOpen: state.labeledgraphicItemOpen,
    clickLabeledgraphicItem: clickLabeledgraphicItem,
    handleClickLabeledgraphicItem: handleClickLabeledgraphicItem,
    handleClickNext: handleClickNext,
    handleClickBack: handleClickBack,
    handleClickOutside: handleClickOutside,
    classAddInteractiveLabel: classAddInteractiveLabel,
    borderColorDialog: _color,
    keyItem: keyItem,
    mediaImage: mediaImage
  };
}

function LabeledGraphic(props) {
  var item = props.item,
    color = props.color,
    getSrc = props.getSrc,
    onReady = props.onReady,
    mode = props.mode;
  var _useLabeledGraphic = useLabeledGraphic(props),
    handleClickOutside = _useLabeledGraphic.handleClickOutside,
    handleClickBack = _useLabeledGraphic.handleClickBack,
    handleClickNext = _useLabeledGraphic.handleClickNext,
    handleClickLabeledgraphicItem = _useLabeledGraphic.handleClickLabeledgraphicItem,
    labeledgraphicItemOpen = _useLabeledGraphic.labeledgraphicItemOpen,
    classAddInteractiveLabel = _useLabeledGraphic.classAddInteractiveLabel,
    borderColorDialog = _useLabeledGraphic.borderColorDialog,
    keyItem = _useLabeledGraphic.keyItem,
    mediaImage = _useLabeledGraphic.mediaImage;
  useItemBlockComponent({
    numComponentsTextHtml: undefined,
    onReady: onReady,
    item: item
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'lesson__block-interactive-label ' + CLASS_NO_SELECT + ' ' + classAddInteractiveLabel + ' ' + CLASS_CONTENT_LEFT
  }, item && item.items ? item.items.map(function (item, index) {
    if (item === undefined || item.x === undefined || item.y === undefined) return null;
    var positionX = item.x > 0 && item.x < 50 ? 'left' : 'right';
    var classPositionY = item.y >= 0 && item.y <= 20 ? 'lesson__block-interactive-label-link--top' : item.y >= 65 && item.y <= 100 ? 'lesson__block-interactive-label-link--bottom' : '';
    var isShow = labeledgraphicItemOpen && labeledgraphicItemOpen.valueOf() === item.id.valueOf();
    var visibility = isShow ? 'show' : 'hidden';
    return /*#__PURE__*/React__default.createElement("div", {
      className: 'lesson__block-interactive-label-link ls-icon--' + item.icon + ' brand--border lesson__block-interactive-label-link--' + positionX + ' lesson__block-interactive-label-link--' + visibility + ' ' + classPositionY,
      onClick: function onClick(e) {
        return handleClickLabeledgraphicItem(e, item.id);
      },
      style: {
        top: item.y + '%',
        left: item.x + '%',
        borderColor: color
      },
      key: item.id
    }, /*#__PURE__*/React__default.createElement("div", {
      className: 'lesson__block-interactive-label-box',
      onClick: function onClick(e) {
        /* e.preventDefault(); */e.stopPropagation();
      }
    }, isShow ? /*#__PURE__*/React__default.createElement(LabeledGraphicDialog, Object.assign({
      closeWhenClickOut: true,
      className: 'lesson__block-interactive-label-content brand--border',
      myItem: item,
      index: index,
      clickNext: handleClickNext,
      clickBack: handleClickBack,
      handleClickOutside: handleClickOutside
    }, props, {
      color: borderColorDialog
    })) : ''), isShow ? /*#__PURE__*/React__default.createElement(Portal, {
      portalId: 'portal-' + keyItem + '-' + index,
      className: 'lesson__block-interactive-label-content brand--border lesson__block-interactive-popup lesson__block-interactive-popup--' + visibility,
      onClick: function onClick(e) {
        return handleClickLabeledgraphicItem(e, item.id);
      }
    }, /*#__PURE__*/React__default.createElement(LabeledGraphicDialog, Object.assign({
      closeWhenClickOut: true,
      myItem: item,
      index: index,
      clickNext: handleClickNext,
      clickBack: handleClickBack,
      handleClickOutside: handleClickOutside
    }, props, {
      color: borderColorDialog
    }))) : '');
  }) : '', mediaImage && mediaImage.src ? /*#__PURE__*/React__default.createElement(ImageWrapper, {
    showNoAlt: mode === IModesItemBlock.MODE_EDITOR && !mediaImage.alt
  }, /*#__PURE__*/React__default.createElement("img", {
    src: getSrc(mediaImage.src),
    alt: mediaImage.alt
  })) : '');
}

var _g$4;
function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/createElement("svg", _extends$c({
    viewBox: "0 0 13 9"
  }, props), _g$4 || (_g$4 = /*#__PURE__*/createElement("g", {
    id: "Round-4",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("g", {
    id: "Book-<-Index",
    transform: "translate(-282.000000, -538.000000)"
  }, /*#__PURE__*/createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/createElement("g", {
    id: "Group-5",
    transform: "translate(16.000000, 434.000000)"
  }, /*#__PURE__*/createElement("g", {
    id: "Group-4",
    transform: "translate(4.000000, 92.000000)"
  }, /*#__PURE__*/createElement("g", {
    id: "check",
    transform: "translate(257.000000, 4.000000)"
  }, /*#__PURE__*/createElement("path", {
    d: "M16.7297551,8.11067419 C16.5710252,7.9631086 16.3126152,7.9631086 16.1549689,8.11067419 L10.0977737,13.6776484 C9.93904383,13.8262144 9.6800921,13.8262144 9.52244575,13.6776484 L6.86846135,11.1820392 C6.78990905,11.1080063 6.68697844,11.0714901 6.5835061,11.0709899 C6.47895027,11.0704897 6.37276923,11.1070059 6.29313345,11.1820392 L5.12026629,12.1554719 C5.04225572,12.2295048 5,12.3220459 5,12.4185888 C5,12.5156319 5.04225572,12.6171771 5.12080803,12.6907098 L7.79700376,15.2838623 C7.95519185,15.4319281 8.21468532,15.6720348 8.37233167,15.8191002 L9.52298749,16.8900761 C9.68117558,17.0366413 9.93958557,17.0366413 10.0983154,16.8900761 L17.8809526,9.71688806 C18.0396825,9.5698227 18.0396825,9.32821532 17.8809526,9.18114996 L16.7297551,8.11067419 Z",
    id: "Path"
  })))))))));
};

var _g$5;
function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/createElement("svg", _extends$d({
    viewBox: "0 0 23 16"
  }, props), _g$5 || (_g$5 = /*#__PURE__*/createElement("g", {
    id: "Round-4",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("g", {
    id: "Book-<-Index",
    transform: "translate(-277.000000, -585.000000)"
  }, /*#__PURE__*/createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/createElement("g", {
    id: "Group-5",
    transform: "translate(16.000000, 434.000000)"
  }, /*#__PURE__*/createElement("g", {
    id: "Group-4",
    transform: "translate(4.000000, 144.000000)"
  }, /*#__PURE__*/createElement("g", {
    id: "icons/header/back",
    transform: "translate(257.000000, 7.000000)"
  }, /*#__PURE__*/createElement("g", {
    transform: "translate(11.500000, 8.000000) rotate(-180.000000) translate(-11.500000, -8.000000) ",
    id: "Path"
  }, /*#__PURE__*/createElement("polygon", {
    transform: "translate(11.437315, 8.000000) rotate(-180.000000) translate(-11.437315, -8.000000) ",
    points: "13.5305212 0.960584189 14.4931716 2.23817608e-12 21.5467293 7.0384187 22.5113889 7.99539837 14.48957 16 13.5277212 15.0402156 19.9043333 8.67728961 0.363240705 8.67728961 0.363240705 7.31990568 19.9034427 7.31990568"
  }))))))))));
};

var _g$6;
function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }
var SvgRepeat = function SvgRepeat(props) {
  return /*#__PURE__*/createElement("svg", _extends$e({
    viewBox: "0 0 138 116"
  }, props), _g$6 || (_g$6 = /*#__PURE__*/createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("g", {
    id: "iconfinder_29_171487",
    transform: "translate(69.500000, 57.500000) scale(-1, 1) translate(-69.500000, -57.500000) translate(0.000000, -1.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/createElement("path", {
    d: "M137.309,47.159 C135.495,45.345 132.547,45.347 130.727,47.165 L116.229,61.664 C116.303,60.531 116.348,59.398 116.358,58.251 C116.593,26.4 90.962,0.767 59.108,1 C27.253,1.237 1.238,27.251 1.001,59.107 C0.77,90.962 26.396,116.595 58.253,116.358 C71.194,116.262 83.172,111.911 92.85,104.643 L84.643,96.437 C77.155,101.654 68.09,104.75 58.338,104.822 C32.853,105.009 12.351,84.506 12.538,59.022 C12.726,33.537 33.54,12.726 59.024,12.536 C84.507,12.349 105.011,32.853 104.823,58.337 C104.815,59.385 104.768,60.42 104.694,61.446 L90.735,47.491 L90.735,47.49 C88.911,45.667 85.936,45.689 84.083,47.542 C82.231,49.392 82.21,52.373 84.034,54.192 L107.143,77.304 C108.612,78.775 110.831,79.039 112.6,78.121 L112.674,78.194 C112.695,78.145 112.709,78.098 112.725,78.05 C113.11,77.835 113.467,77.572 113.789,77.247 L137.3,53.74 C139.126,51.922 139.128,48.975 137.309,47.159",
    id: "Path"
  })))));
};

var ProcessStep = function ProcessStep(_ref) {
  var _item$media$image;
  var item = _ref.item,
    head = _ref.head,
    modeTextHtml = _ref.modeTextHtml,
    itemParentId = _ref.itemParentId,
    getTextHtml = _ref.getTextHtml,
    titleUpdated = _ref.titleUpdated,
    descriptionUpdated = _ref.descriptionUpdated,
    captionUpdated = _ref.captionUpdated,
    onClickStart = _ref.onClickStart,
    onClickRestart = _ref.onClickRestart,
    getSrc = _ref.getSrc,
    onReadyGetTextHtml = _ref.onReadyGetTextHtml,
    mode = _ref.mode;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var isEditMode = modeTextHtml === IModesTextHtml.MODE_TEXT_HTML_EDITOR;
  var stringBegin = t('process_button_start');
  var stringStartAgain = t('process_button_start_again');
  var isStep = item.type === 'step';
  var isIntro = item.type === 'intro';
  var isSummary = item.type === 'summary';
  return /*#__PURE__*/React__default.createElement("div", {
    className: "mint-block-process-card " + (!isStep ? ' mint-block-process-card--centered' : '') + " " + CLASS_CONTENT_LEFT
  }, isStep && /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-process-head'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-process-step brand--first brand--background'
  }, head)), /*#__PURE__*/React__default.createElement("h4", {
    className: 'mint-block-process-title brand--first'
  }, item.title && getTextHtml(item.title, function (text) {
    return titleUpdated && titleUpdated(text);
  }, item.id, modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml)), item.media && /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-process-card-media'
  }, /*#__PURE__*/React__default.createElement(Media, {
    media: item.media,
    alt: ((_item$media$image = item.media.image) == null ? void 0 : _item$media$image.alt) || '',
    mediaId: item.id,
    enableZoomOnClick: getItemSettingIsZoomOnClick(item),
    getSrc: getSrc,
    mode: mode
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-process-caption'
  }, item.media && (item.caption || isEditMode) && getTextHtml(item.caption || '', function (text) {
    return captionUpdated && captionUpdated(text);
  }, item.id + '_caption', modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml)), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-process-content'
  }, item.description && getTextHtml(item.description, function (text) {
    return descriptionUpdated && descriptionUpdated(text);
  }, item.id, modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml), isSummary && /*#__PURE__*/React__default.createElement("a", {
    href: '#',
    onClick: onClickRestart,
    className: 'mint-block-process-back brand--first brand--color brand--fill'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-process-link-content'
  }, stringStartAgain), /*#__PURE__*/React__default.createElement(SvgRepeat, {
    className: 'icon icon-repeat'
  })), isIntro ? /*#__PURE__*/React__default.createElement("a", {
    href: '#',
    onClick: onClickStart,
    className: 'mint-block-process-start brand--first brand--background'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-process-link-content'
  }, stringBegin), /*#__PURE__*/React__default.createElement(SvgArrow, {
    className: 'icon icon-arrow'
  })) : /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-process-pagination'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'swiper-pagination swiper-pagination-' + itemParentId
  }, t('process_refresh_show_pagination')))));
};

var ITypeSubItemMedia;
(function (ITypeSubItemMedia) {
  ITypeSubItemMedia["IMAGE"] = "image";
  ITypeSubItemMedia["VIDEO"] = "video";
  ITypeSubItemMedia["AUDIO"] = "audio";
  ITypeSubItemMedia["EMBED"] = "embed";
})(ITypeSubItemMedia || (ITypeSubItemMedia = {}));

function isMediaImage(media) {
  return media.type === ITypeSubItemMedia.IMAGE;
}
function isMediaAudio(media) {
  return media.type === ITypeSubItemMedia.AUDIO;
}
function isMediaVideo(media) {
  return media.type === ITypeSubItemMedia.VIDEO;
}
function isMediaEmbed(media) {
  return media.type === ITypeSubItemMedia.EMBED;
}

var text = {
	paragraph: {
		items: [
			{
				paragraph: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi porta ac elit vitae tempor. Nullam ut lacus.\n   Donec nec eros rutrum, consectetur lacus in, accumsan odio. Mauris semper dolor ut felis cursus fringilla ut ac lectus. In suscipit dapibus augue.\n    Duis risus tortor, dapibus eu fermentum eget. Aliquam ultricies mauris elit.</p>"
			}
		]
	},
	"heading paragraph": {
		items: [
			{
				heading: "<strong>Heading</strong>",
				paragraph: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi porta ac elit vitae tempor. Nullam ut lacus.\n    Donec nec eros rutrum, consectetur lacus in, accumsan odio. Mauris semper dolor ut felis\n    cursus fringilla ut ac lectus. In suscipit dapibus augue.</p>"
			}
		]
	},
	"subheading paragraph": {
		items: [
			{
				heading: "<strong>Subheading</strong>",
				paragraph: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi porta ac elit vitae tempor.\n    Nullam ut lacus. Donec nec eros rutrum, consectetur lacus in, accumsan odio. Mauris semper dolor ut felis \n    cursus fringilla ut ac lectus. In suscipit dapibus augue.</p>"
			}
		]
	},
	heading: {
		items: [
			{
				heading: "<strong>Heading</strong>"
			}
		],
		settings: {
			paddingBottom: 0
		}
	},
	subheading: {
		items: [
			{
				heading: "<strong>Subheading</strong>"
			}
		],
		settings: {
			paddingBottom: 0
		}
	},
	"two column": {
		items: [
			{
				paragraph: "<p>Pellentesque sodales dolor tellus, id dapibus tortor aliquam non\n    vestibulum semper lacus at consequat vestibulum. Pellentesque consectetur dui neque,\n    cursus consequat metus, \"rutrum non.\""
			},
			{
				paragraph: "<p>Proin nisi erat, tempus vel libero non, elementum dictum ex.\n    Nam a luctus risus, sed consectetur ligula. Vestibulum est ipsum, interdum luctus est.\n    Sed porta massa magna, id scelerisque.</p>"
			}
		]
	}
};
var impact = {
	a: {
		items: [
			{
				paragraph: "<p><strong>Suspendisse eget est sit amet magna facilisis pellentesque.\n     Etiam facilisis ligula sit amet libero viverra, eget cursus sapien blandit.\n      Quisque a augue id diam ullamcorper volutpat. </strong></p>"
			}
		]
	},
	b: {
		items: [
			{
				paragraph: "<p>Pellentesque sit amet metus interdum, sodales dolor efficitur, venenatis\n      lacus. Morbi sed diam a metus auctor tincidunt a a dolor. Nulla facilisi.\n      Aenean molestie blandit pellentesque. Nulla lectus massa, vehicula at euismod ac.</p>"
			}
		]
	},
	c: {
		items: [
			{
				paragraph: "<p>Cras vehicula eu  <strong>lorem ac dapibus.</strong>  mattis sapien non diam. <strong> Lobortis auctor.</strong>, In diam mi,\n    condimentum  <strong>eget dignissim</strong>. Imperdiet eu ante. <strong>Curabitur quam ex</strong>. Varius at ex id.</p>"
			}
		]
	},
	d: {
		items: [
			{
				paragraph: "<p><strong>Suspendisse eget est sit amet magna facilisis pellentesque.\n     Etiam facilisis ligula sit amet libero viverra, eget cursus sapien blandit.\n      Quisque a augue id diam ullamcorper volutpat. </strong></p>"
			}
		]
	},
	note: {
		items: [
			{
				paragraph: "<p><strong>Aenean tempor sagittis arcu quis aliquet. Phasellus pretium nec neque quis tristique.\n    Nunc ac scelerisque nunc. Sed mollis lectus vel ligula pulvinar pellentesque eget eu mi.</strong></p>"
			}
		]
	},
	"teacher notes": {
		items: [
			{
				paragraph: "<p></p>"
			}
		],
		settings: {
			teacherOnly: true
		}
	},
	statementA: {
		items: [
			{
				paragraph: "<p>Aenean tempor sagittis arcu quis aliquet. Phasellus pretium nec neque quis tristique.\n    Nunc ac scelerisque nunc. Sed mollis lectus vel ligula pulvinar pellentesque eget eu mi.</p>"
			}
		]
	},
	statementD: {
		items: [
			{
				paragraph: "<p>Aenean tempor sagittis arcu quis aliquet. Phasellus pretium nec neque quis tristique.\n    Nunc ac scelerisque nunc. Sed mollis lectus vel ligula pulvinar pellentesque eget eu mi.</p>"
			}
		]
	}
};
var quote = {
	a: {
		items: [
			{
				paragraph: "<p>Sed id mattis dolor. Maecenas felis arcu, scelerisque lobortis dui eget, ultrices venenatis leo. Praesent luctus tortor quis est lacinia imperdiet. In sit amet consequat est.</p>",
				name: "<p>Evil Cat</p>",
				avatar: {
					media: {
						image: {
							key: "avatar1.png",
							src: "avatar1.png",
							thumbnail: "avatar1_thumb.png",
							originalUrl: "avatar1.png",
							type: "image"
						}
					}
				},
				background: {
					media: {
						image: {
							originalUrl: "quote_background.jpg",
							src: "quote_background.jpg",
							thumbnail: "quote_background_thumb.jpg",
							key: "quote_background.jpg",
							type: "image"
						}
					}
				}
			}
		]
	},
	b: {
		items: [
			{
				paragraph: "<p>Sed id mattis dolor. Maecenas felis arcu, scelerisque lobortis dui eget, ultrices venenatis leo. Praesent luctus tortor quis est lacinia imperdiet. In sit amet consequat est.</p>",
				name: "<p>Evil Cat</p>",
				avatar: {
					media: {
						image: {
							key: "avatar1.png",
							src: "avatar1.png",
							thumbnail: "avatar1_thumb.png",
							originalUrl: "avatar1.png",
							type: "image"
						}
					}
				},
				background: {
					media: {
						image: {
							originalUrl: "quote_background.jpg",
							src: "quote_background.jpg",
							thumbnail: "quote_background_thumb.jpg",
							key: "quote_background.jpg",
							type: "image"
						}
					}
				}
			}
		]
	},
	c: {
		items: [
			{
				paragraph: "<p>Sed id mattis dolor. Maecenas felis arcu, scelerisque lobortis dui eget, ultrices venenatis leo. Praesent luctus tortor quis est lacinia imperdiet. In sit amet consequat est.</p>",
				name: "<p>Evil Cat</p>",
				avatar: {
					media: {
						image: {
							key: "avatar1.png",
							src: "avatar1.png",
							thumbnail: "avatar1_thumb.png",
							originalUrl: "avatar1.png",
							type: "image"
						}
					}
				},
				background: {
					media: {
						image: {
							originalUrl: "quote_background.jpg",
							src: "quote_background.jpg",
							thumbnail: "quote_background_thumb.jpg",
							key: "quote_background.jpg",
							type: "image"
						}
					}
				}
			}
		]
	},
	d: {
		items: [
			{
				paragraph: "<p>Sed id mattis dolor. Maecenas felis arcu, scelerisque lobortis dui eget, ultrices venenatis leo. Praesent luctus tortor quis est lacinia imperdiet. In sit amet consequat est.</p>",
				name: "<p>Evil Cat</p>",
				avatar: {
					media: {
						image: {
							key: "avatar1.png",
							src: "avatar1.png",
							thumbnail: "avatar1_thumb.png",
							originalUrl: "avatar1.png",
							type: "image"
						}
					}
				},
				background: {
					media: {
						image: {
							originalUrl: "quote_background.jpg",
							src: "quote_background.jpg",
							thumbnail: "quote_background_thumb.jpg",
							key: "quote_background.jpg",
							type: "image"
						}
					}
				}
			}
		]
	},
	background: {
		items: [
			{
				paragraph: "<p>Sed id mattis dolor. Maecenas felis arcu, scelerisque lobortis dui eget, ultrices venenatis leo. Praesent luctus tortor quis est lacinia imperdiet. In sit amet consequat est.</p>",
				name: "<p>Evil Cat</p>",
				avatar: {
					media: {
						image: {
							key: "avatar1.png",
							src: "avatar1.png",
							thumbnail: "avatar1_thumb.png",
							originalUrl: "avatar1.png",
							type: "image"
						}
					}
				},
				background: {
					media: {
						image: {
							originalUrl: "quote_background.jpg",
							src: "quote_background.jpg",
							thumbnail: "quote_background_thumb.jpg",
							key: "quote_background.jpg",
							type: "image"
						}
					}
				}
			}
		]
	},
	carousel: {
		items: [
			{
				paragraph: "<p>Sed id mattis dolor. Maecenas felis arcu, scelerisque lobortis dui eget, ultrices venenatis leo. Praesent luctus tortor quis est lacinia imperdiet. In sit amet consequat est.</p>",
				name: "<p>Evil Cat</p>",
				avatar: {
					media: {
						image: {
							key: "avatar1.png",
							src: "avatar1.png",
							thumbnail: "avatar1_thumb.png",
							originalUrl: "avatar1.png",
							type: "image"
						}
					}
				},
				background: {
					media: {
						image: {
							originalUrl: "quote_background.jpg",
							src: "quote_background.jpg",
							thumbnail: "quote_background_thumb.jpg",
							key: "quote_background.jpg",
							type: "image"
						}
					}
				}
			},
			{
				paragraph: "<p>Sed id mattis dolor. Maecenas felis arcu, scelerisque lobortis dui eget, ultrices venenatis leo. Praesent luctus tortor quis est lacinia imperdiet. In sit amet consequat est.</p>",
				name: "<p>Evil Cat</p>",
				avatar: {
					media: {
						image: {
							key: "avatar1.png",
							src: "avatar1.png",
							thumbnail: "avatar1_thumb.png",
							originalUrl: "avatar1.png",
							type: "image"
						}
					}
				},
				background: {
					media: {
						image: {
							originalUrl: "quote_background.jpg",
							src: "quote_background.jpg",
							thumbnail: "quote_background_thumb.jpg",
							key: "quote_background.jpg",
							type: "image"
						}
					}
				}
			},
			{
				paragraph: "<p>Sed id mattis dolor. Maecenas felis arcu, scelerisque lobortis dui eget, ultrices venenatis leo. Praesent luctus tortor quis est lacinia imperdiet. In sit amet consequat est.</p>",
				name: "<p>Evil Cat</p>",
				avatar: {
					media: {
						image: {
							key: "avatar1.png",
							src: "avatar1.png",
							thumbnail: "avatar1_thumb.png",
							originalUrl: "avatar1.png",
							type: "image"
						}
					}
				},
				background: {
					media: {
						image: {
							originalUrl: "quote_background.jpg",
							src: "quote_background.jpg",
							thumbnail: "quote_background_thumb.jpg",
							key: "quote_background.jpg",
							type: "image"
						}
					}
				}
			}
		]
	}
};
var list = {
	numbered: {
		items: [
			{
				paragraph: "<p>Aenean tempor sagittis arcu quis aliquet. Phasellus pretium nec neque quis tristique. Nunc ac scelerisque nunc.</p>"
			},
			{
				paragraph: "<p>Sed mollis lectus vel ligula pulvinar pellentesque eget eu mi. Sed id mattis dolor. Maecenas felis arcu, scelerisque.</p>"
			},
			{
				paragraph: "<p>Lobortis dui eget, ultrices venenatis leo. Praesent luctus tortor quis est lacinia imperdiet. In sit amet consequat est.</p>"
			}
		]
	},
	checkboxes: {
		items: [
			{
				paragraph: "<p>Aenean tempor sagittis arcu quis aliquet. Phasellus pretium nec neque quis tristique. Nunc ac scelerisque nunc.</p>"
			},
			{
				paragraph: "<p>Sed mollis lectus vel ligula pulvinar pellentesque eget eu mi. Sed id mattis dolor. Maecenas felis arcu, scelerisque.</p>"
			},
			{
				paragraph: "<p>Lobortis dui eget, ultrices venenatis leo. Praesent luctus tortor quis est lacinia imperdiet. In sit amet consequat est.</p>"
			}
		]
	},
	bulleted: {
		items: [
			{
				paragraph: "<p>Aenean tempor sagittis arcu quis aliquet. Phasellus pretium nec neque quis tristique. Nunc ac scelerisque nunc.</p>"
			},
			{
				paragraph: "<p>Sed mollis lectus vel ligula pulvinar pellentesque eget eu mi. Sed id mattis dolor. Maecenas felis arcu, scelerisque.</p>"
			},
			{
				paragraph: "<p>Lobortis dui eget, ultrices venenatis leo. Praesent luctus tortor quis est lacinia imperdiet. In sit amet consequat est.</p>"
			}
		]
	}
};
var image = {
	hero: {
		items: [
			{
				paragraph: "",
				caption: "",
				media: {
					image: {
						originalUrl: "img1.jpg",
						thumbnail: "img1_thumb.jpg",
						src: "img1.jpg",
						key: "img1.jpg",
						type: "image"
					}
				}
			}
		],
		settings: {
			zoomOnClick: true,
			opacity: 0.2,
			opacityColor: "#000000"
		}
	},
	full: {
		items: [
			{
				caption: "",
				media: {
					image: {
						originalUrl: "img2.jpg",
						thumbnail: "img2_thumb.jpg",
						src: "img2.jpg",
						key: "img2.jpg",
						type: "image"
					}
				}
			}
		],
		settings: {
			zoomOnClick: true,
			opacity: 0.2,
			opacityColor: "#000000"
		}
	},
	"text aside": {
		items: [
			{
				caption: "",
				paragraph: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras consectetur felis sit amet nulla varius, ac semper sapien pulvinar.</p>",
				media: {
					image: {
						originalUrl: "img3.jpg",
						thumbnail: "img3_thumb.jpg",
						src: "img3.jpg",
						key: "img3.jpg",
						type: "image"
					}
				}
			}
		],
		settings: {
			zoomOnClick: true,
			opacity: 0.2,
			opacityColor: "#000000"
		}
	},
	"text overlay": {
		items: [
			{
				paragraph: "",
				caption: "<p><b>Sed auctor tellus et est tempor, ac tincidunt ex aliquet. Ut lobortis, quam vitae vehicula interdum, sem.</b></p>",
				media: {
					image: {
						originalUrl: "img4.jpg",
						thumbnail: "img4_thumb.jpg",
						src: "img4.jpg",
						key: "img4.jpg",
						type: "image"
					}
				}
			}
		],
		settings: {
			zoomOnClick: true,
			opacity: 0.2,
			opacityColor: "#000000"
		}
	}
};
var gallery = {
	centered: {
		items: [
			{
				paragraph: "",
				caption: "",
				media: {
					image: {
						originalUrl: "img7.jpg",
						thumbnail: "img7_thumb.jpg",
						src: "img7.jpg",
						key: "img7.jpg",
						type: "image"
					}
				}
			},
			{
				caption: "",
				media: {
					image: {
						originalUrl: "img5.jpg",
						thumbnail: "img5_thumb.jpg",
						src: "img5.jpg",
						key: "img5.jpg",
						type: "image"
					}
				}
			},
			{
				caption: "",
				media: {
					image: {
						originalUrl: "grid_img1.jpg",
						thumbnail: "grid_img1_thumb.jpg",
						src: "grid_img1.jpg",
						key: "grid_img1.jpg",
						type: "image"
					}
				}
			}
		],
		settings: {
			zoomOnClick: true
		}
	},
	"two column": {
		items: [
			{
				caption: "",
				media: {
					image: {
						originalUrl: "img6.jpg",
						thumbnail: "img6_thumb.jpg",
						src: "img6.jpg",
						key: "img6.jpg",
						type: "image"
					}
				}
			},
			{
				caption: "",
				media: {
					image: {
						originalUrl: "img7.jpg",
						thumbnail: "img7_thumb.jpg",
						src: "img7.jpg",
						key: "img7.jpg",
						type: "image"
					}
				}
			}
		],
		settings: {
			zoomOnClick: true
		}
	},
	"three column": {
		items: [
			{
				caption: "",
				media: {
					image: {
						originalUrl: "grid_img1.jpg",
						thumbnail: "grid_img1_thumb.jpg",
						src: "grid_img1.jpg",
						key: "grid_img1.jpg",
						type: "image"
					}
				}
			},
			{
				caption: "",
				media: {
					image: {
						originalUrl: "grid_img2.jpg",
						thumbnail: "grid_img2_thumb.jpg",
						src: "grid_img2.jpg",
						key: "grid_img2.jpg",
						type: "image"
					}
				}
			},
			{
				caption: "",
				media: {
					image: {
						originalUrl: "grid_img3.jpg",
						thumbnail: "grid_img3_thumb.jpg",
						src: "grid_img3.jpg",
						key: "grid_img3.jpg",
						type: "image"
					}
				}
			}
		],
		settings: {
			zoomOnClick: true
		}
	},
	"four column": {
		items: [
			{
				caption: "",
				media: {
					image: {
						originalUrl: "grid_img4.jpg",
						thumbnail: "grid_img4_thumb.jpg",
						src: "grid_img4.jpg",
						key: "grid_img4.jpg",
						type: "image"
					}
				}
			},
			{
				caption: "",
				media: {
					image: {
						originalUrl: "grid_img5.jpg",
						thumbnail: "grid_img5_thumb.jpg",
						src: "grid_img5.jpg",
						key: "grid_img5.jpg",
						type: "image"
					}
				}
			},
			{
				caption: "",
				media: {
					image: {
						originalUrl: "grid_img6.jpg",
						thumbnail: "grid_img6_thumb.jpg",
						src: "grid_img6.jpg",
						key: "grid_img6.jpg",
						type: "image"
					}
				}
			},
			{
				caption: "",
				media: {
					image: {
						originalUrl: "grid_img7.jpg",
						thumbnail: "grid_img7_thumb.jpg",
						src: "grid_img7.jpg",
						key: "grid_img7.jpg",
						type: "image"
					}
				}
			}
		],
		settings: {
			zoomOnClick: true
		}
	}
};
var multimedia = {
	audio: {
		items: [
			{
				media: {
					audio: {
						originalUrl: "sample_audio.mp3",
						src: "sample_audio.mp3",
						key: "sample_audio.mp3",
						type: "audio"
					}
				},
				caption: ""
			}
		]
	},
	video: {
		items: [
			{
				media: {
					video: {
						originalUrl: "jellyfish.mp4",
						thumbnail: "jellyfish_thumb.png",
						poster: "jellyfish_poster.png",
						src: "jellyfish.mp4",
						key: "jellyfish.mp4",
						type: "video"
					}
				},
				caption: ""
			}
		]
	},
	attachment: {
		items: [
			{
				media: {
					attachment: {
						originalUrl: "",
						size: 0,
						src: "",
						type: "attachment"
					}
				}
			}
		]
	},
	code: {
		items: [
			{
				code: "&lt;!DOCTYPE html&gt;\n&lt;html lang=”en”&gt;\n\t&lt;head&gt;\n\t\t&lt;meta charset=”utf-8”&gt;\n\t\t&lt;title&gt;title&lt;/title&gt;\n\t\t&lt;link rel=”stylesheet” href=”style.css”&gt;\n\t\t&lt;script src=”script.js”&gt;&lt;/script&gt;\n\t&lt;/head&gt;\n\t&lt;body&gt;\n\t\t&lt;!-- page content --&gt;\n\t&lt;/body&gt;\n&lt;/html&gt;",
				caption: ""
			}
		]
	},
	embed: {
		items: [
			{
				media: {
					embed: {
						description: "I spent 3 weeks travelling across the Alps, in France, Italy, Switzerland, Austria and Germany. This video presents the amazing places and landscapes I disco...",
						embedType: "video",
						favicon: "https://www.youtube.com/s/desktop/b4620429/img/favicon.ico",
						originalUrl: "https://youtu.be/FCPdIvXo2rU",
						provider: "Youtube",
						providerUrl: "https://www.youtube.com/",
						src: "https://youtu.be/FCPdIvXo2rU",
						thumbnail: "https://i.ytimg.com/vi/FCPdIvXo2rU/hqdefault.jpg",
						title: "The Alps 4K | Drone & iPhone X",
						type: "embed"
					}
				}
			}
		],
		settings: {
			mediaWidth: 0,
			showBorder: true
		}
	}
};
var interactive = {
	accordion: {
		items: [
			{
				title: "Lorem ipsum dolor",
				description: "<p>Econsectetur adipiscing elit. Cras consectetur felis sit amet nulla varius, ac semper sapien pulvinar. Sed auctor tellus et est tempor,\n      ac tincidunt ex aliquet. Ut lobortis, quam vitae vehicula interdum.</p>",
				media: {
					image: {
						originalUrl: "img8.jpg",
						thumbnail: "img8_thumb.jpg",
						src: "img8.jpg",
						key: "img8.jpg",
						type: "image"
					}
				}
			},
			{
				title: "Quisque ex arcu",
				description: "<p>Porttitor ac felis vel, pulvinar placerat eros. Mauris iaculis lacinia eros nec viverra.\n      Mauris semper massa tortor, id laoreet nulla malesuada ut.\n       Praesent at tempor arcu, id pulvinar metus.</p><p><br></p>\n      <p>Etiam auctor lectus suscipit velit ornare pharetra. Maecenas volutpat aliquam lacinia\n       Quisque ut justo sit amet tellus volutpat lacinia. Integer sit amet eros condimentum,\n bibendum erat at, viverra ante. Duis et ultricies mi, eu viverra tellus. </p>"
			},
			{
				title: "Mauris vitae nunc",
				description: "<p>Duis a lacinia nisi, elementum euismod magna. Integer mattis sem massa,\n     sem massa, ut pharetra augue dignissim nec. Quisque ornare odio in convallis commodo.\n      Integer ipsum metus, rutrum.</p><p><br></p>\n      <p>quis fermentum et, pulvinar eu lectus. Phasellus a urna a nibh gravida convallis\n      vitae vel eros. Donec tempus faucibus dapibus. Vivamus auctor quis ipsum sed malesuada.\n      Vestibulum varius dignissim diam, eget sagittis est ultricies nec. Vivamus et luctus ex.</p>"
			}
		],
		settings: {
			zoomOnClick: true
		}
	},
	tabs: {
		items: [
			{
				title: "Lorem ipsum dolor",
				description: "<p>Econsectetur adipiscing elit. Cras consectetur felis sit amet nulla varius, ac semper sapien pulvinar. Sed auctor tellus et est tempor,\n      ac tincidunt ex aliquet. Ut lobortis, quam vitae vehicula interdum.</p>",
				media: {
					image: {
						originalUrl: "img9.jpg",
						thumbnail: "img9_thumb.jpg",
						src: "img9.jpg",
						key: "img9.jpg",
						type: "image"
					}
				}
			},
			{
				title: "Quisque ex arcu",
				description: "<p>Porttitor ac felis vel, pulvinar placerat eros. Mauris iaculis lacinia eros nec viverra.\n      Mauris semper massa tortor, id laoreet nulla malesuada ut.\n       Praesent at tempor arcu, id pulvinar metus.</p><p><br></p>\n      <p>Etiam auctor lectus suscipit velit ornare pharetra. Maecenas volutpat aliquam lacinia\n       Quisque ut justo sit amet tellus volutpat lacinia. Integer sit amet eros condimentum,\n bibendum erat at, viverra ante. Duis et ultricies mi, eu viverra tellus.</p>"
			},
			{
				title: "Mauris vitae nunc",
				description: "<p>Duis a lacinia nisi, elementum euismod magna. Integer mattis sem massa,\n     sem massa, ut pharetra augue dignissim nec. Quisque ornare odio in convallis commodo.\n      Integer ipsum metus, rutrum.</p><p><br></p>\n      <p>quis fermentum et, pulvinar eu lectus. Phasellus a urna a nibh gravida convallis\n      vitae vel eros. Donec tempus faucibus dapibus. Vivamus auctor quis ipsum sed malesuada.\n      Vestibulum varius dignissim diam, eget sagittis est ultricies nec. Vivamus et luctus ex.</p>"
			}
		],
		settings: {
			zoomOnClick: true
		}
	}
};
var buttons = {
	button: {
		items: [
			{
				type: "",
				label: "Dolor sit amet 1",
				destination: "",
				description: "<p><b>Dolor sit amet 1</b><br/> consectetur adipiscing elit. Nulla semper, eros sed feugiat commodo.\n      Est felis pulvinar dolor.</p>"
			}
		]
	},
	"button stack": {
		items: [
			{
				type: "",
				label: "Dolor sit amet 1",
				destination: "",
				description: "<p><b>Dolor sit amet 1</b><br/> consectetur adipiscing elit. Nulla semper, eros sed feugiat commodo.\n      Est felis pulvinar dolor.</p>"
			},
			{
				type: "",
				label: "Dolor sit amet 2",
				destination: "",
				description: "<p><b>Dolor sit amet 2</b><br/> consectetur adipiscing elit. Nulla semper, eros sed feugiat commodo.\n      Est felis pulvinar dolor.</p>"
			},
			{
				type: "",
				label: "Dolor sit amet 3  ",
				destination: "",
				description: "<p><b>Dolor sit amet 3</b><br/> consectetur adipiscing elit. Nulla semper, eros sed feugiat commodo.\n      Est felis pulvinar dolor.</p>"
			}
		]
	}
};
var divider = {
	divider: {
		items: [
		],
		settings: {
			paddingTop: 3,
			paddingBottom: 3,
			backgroundColor: "",
			entranceAnimation: true
		}
	},
	"spacing divider": {
		items: [
		],
		settings: {
			paddingTop: 3,
			paddingBottom: 3,
			backgroundColor: "",
			entranceAnimation: true
		}
	}
};
var provider = {
	edpuzzle: {
		items: [
			{
				media: {
					embed: {
						embedType: "iframe",
						originalUrl: "<iframe width=\"470\" height=\"404\" src=\"https://edpuzzle.com/embed/media/63a45a310dc3c73cf4efe7fb\" frameborder=\"0\" allowfullscreen></iframe>",
						src: "<iframe width=\"470\" height=\"404\" src=\"https://edpuzzle.com/embed/media/63a45a310dc3c73cf4efe7fb\" frameborder=\"0\" allowfullscreen></iframe>",
						type: "embed"
					}
				}
			}
		],
		settings: {
			mediaWidth: 0,
			showBorder: true
		}
	},
	genially: {
		items: [
			{
				media: {
					embed: {
						embedType: "iframe",
						originalUrl: "<iframe frameborder=\"0\" width=\"1200\" height=\"675\" style=\"position: absolute; top: 0; left: 0; width: 100%; height: 100%;\" src=\"https://view.genial.ly/630468e25480950018eda44e\" type=\"text/html\" allowscriptaccess=\"always\" allowfullscreen=\"true\" scrolling=\"yes\" allownetworking=\"all\"></iframe>",
						src: "<iframe frameborder=\"0\" width=\"1200\" height=\"675\" style=\"position: absolute; top: 0; left: 0; width: 100%; height: 100%;\" src=\"https://view.genial.ly/630468e25480950018eda44e\" type=\"text/html\" allowscriptaccess=\"always\" allowfullscreen=\"true\" scrolling=\"yes\" allownetworking=\"all\"></iframe>",
						type: "embed"
					}
				}
			}
		],
		settings: {
			mediaWidth: 0,
			showBorder: true
		}
	},
	feedback: {
		items: [
			{
				media: {
					embed: {
						embedType: "iframe",
						originalUrl: "<iframe frameborder=\"0\" width=\"1200\" height=\"675\" style=\"position: absolute; top: 0; left: 0; width: 100%; height: 100%;\" src=\"https://example-feedback-platform.com/embed/feedback-activity\" type=\"text/html\" allowscriptaccess=\"always\" allowfullscreen=\"true\" scrolling=\"yes\" allownetworking=\"all\"></iframe>",
						src: "<iframe frameborder=\"0\" width=\"1200\" height=\"675\" style=\"position: absolute; top: 0; left: 0; width: 100%; height: 100%;\" src=\"https://example-feedback-platform.com/embed/feedback-activity\" type=\"text/html\" allowscriptaccess=\"always\" allowfullscreen=\"true\" scrolling=\"yes\" allownetworking=\"all\"></iframe>",
						type: "embed"
					}
				}
			}
		],
		settings: {
			mediaWidth: 0,
			showBorder: true
		}
	}
};
var row = {
	row: {
		items: [
		],
		row: {
			alignment: "space-between",
			spacing: 20,
			items: [
				{
					id: "dc8aaea8-f1cf-442b-a88c-1b4ef048690e",
					type: "text",
					family: "text",
					variant: "paragraph",
					settings: {
						paddingTop: 1,
						paddingBottom: 1,
						backgroundColor: "",
						entranceAnimation: true
					},
					items: [
						{
							paragraph: "<p>1Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi porta ac elit vitae tempor. Nullam ut lacus.\n   Donec nec eros rutrum, consectetur lacus in, accumsan odio. Mauris semper dolor ut felis cursus fringilla ut ac lectus. In suscipit dapibus augue.\n    Duis risus tortor, dapibus eu fermentum eget. Aliquam ultricies mauris elit.</p>",
							id: "4020878c-dc26-4291-9b5c-0313738be979"
						}
					]
				},
				{
					id: "0d8f80d6-2dcb-48e5-8f5a-a70b548dd721",
					type: "image",
					family: "image",
					variant: "hero",
					settings: {
						paddingTop: 1,
						paddingBottom: 1,
						backgroundColor: "",
						entranceAnimation: true,
						zoomOnClick: true,
						opacity: 0.2,
						opacityColor: "#000000"
					},
					items: [
						{
							media: {
								image: {
									key: "avatar1.png",
									src: "avatar1.png",
									thumbnail: "avatar1_thumb.png",
									originalUrl: "avatar1.png",
									type: "image"
								}
							},
							caption: "",
							paragraph: "",
							id: "b3039ae1-debc-41e4-ade5-ce63547c4890"
						}
					]
				}
			]
		},
		settings: {
			backgroundColor: "",
			paddingTop: 3,
			paddingBottom: 3
		}
	}
};
var defaultData = {
	text: text,
	impact: impact,
	quote: quote,
	list: list,
	image: image,
	gallery: gallery,
	multimedia: multimedia,
	interactive: interactive,
	"interactive-fullscreen": {
	labeledgraphic: {
		media: {
			image: {
				src: "img10.jpg",
				key: "img10.jpg",
				type: "image"
			}
		},
		items: [
			{
				title: "Item 1",
				isActive: false,
				description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In purus velit, tincidunt ac nibh quis, sollicitudin varius libero. Nullam at mi felis. Donec a scelerisque augue, sit amet porttitor nibh.",
				x: 51,
				y: 70,
				icon: "01"
			},
			{
				title: "Item 2",
				isActive: false,
				description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In purus velit, tincidunt ac nibh quis, sollicitudin varius libero. Nullam at mi felis. Donec a scelerisque augue, sit amet porttitor nibh. Suspendisse at lorem ut elit placerat blandit. Nunc vitae neque mattis elit ullamcorper euismod vel eu quam. Vivamus et dolor sit amet justo tempus faucibus. Integer quis nulla laoreet, consectetur felis in, ullamcorper ligula.",
				x: 83,
				y: 31,
				icon: "01"
			}
		],
		settings: {
			backgroundColor: "#ffffff",
			zoomOnClick: true,
			mediaWidth: "1"
		}
	},
	process: {
		items: [
			{
				description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In purus velit, tincidunt ac nibh quis, sollicitudin varius libero. Nullam at mi felis. Donec a scelerisque augue, sit amet porttitor nibh. Suspendisse at lorem ut elit placerat blandit.</p>",
				isHidden: false,
				title: "Introduction",
				type: "intro"
			},
			{
				description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In purus velit, tincidunt ac nibh quis, sollicitudin varius libero. Nullam at mi felis. Donec a scelerisque augue, sit amet porttitor nibh. Suspendisse at lorem ut elit placerat blandit.</p>",
				isHidden: false,
				title: "Summary",
				type: "summary"
			},
			{
				description: "<p>Lorem ipsum excepteur sint occaecat cupidatat non proident, in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.</p>",
				isHidden: false,
				media: {
					image: {
						originalUrl: "img1.jpg",
						thumbnail: "img1_thumb.jpg",
						src: "img1.jpg",
						key: "img1.jpg",
						type: "image"
					}
				},
				title: "Lorem Ipsum 1",
				type: "step"
			},
			{
				description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>",
				isHidden: false,
				media: {
					image: {
						originalUrl: "img2.jpg",
						thumbnail: "img2_thumb.jpg",
						src: "img2.jpg",
						key: "img2.jpg",
						type: "image"
					}
				},
				title: "Lorem Ipsum 2",
				type: "step"
			}
		],
		settings: {
			backgroundColor: "#f5f5f5",
			zoomOnClick: true,
			mediaWidth: "1"
		}
	},
	timeline: {
		items: [
			{
				type: "start",
				title: "Start",
				isHidden: false
			},
			{
				type: "end",
				title: "Finish",
				isHidden: false
			},
			{
				description: "<p>Lorem ipsum excepteur sint occaecat cupidatat non proident, in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.</p>",
				isHidden: false,
				media: {
					image: {
						originalUrl: "img1.jpg",
						thumbnail: "img1_thumb.jpg",
						src: "img1.jpg",
						key: "img1.jpg",
						type: "image"
					}
				},
				title: "Event 1 Title",
				type: "step"
			},
			{
				description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>",
				isHidden: false,
				media: {
					image: {
						originalUrl: "img2.jpg",
						thumbnail: "img2_thumb.jpg",
						src: "img2.jpg",
						key: "img2.jpg",
						type: "image"
					}
				},
				title: "Event 2 Title",
				type: "step"
			},
			{
				description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>",
				isHidden: false,
				media: {
					image: {
						originalUrl: "img3.jpg",
						thumbnail: "img3_thumb.jpg",
						src: "img3.jpg",
						key: "img3.jpg",
						type: "image"
					}
				},
				title: "Event 3 Title",
				type: "step"
			},
			{
				description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>",
				isHidden: false,
				media: {
					image: {
						originalUrl: "img4.jpg",
						thumbnail: "img4_thumb.jpg",
						src: "img4.jpg",
						key: "img4.jpg",
						type: "image"
					}
				},
				title: "Event 4 Title",
				type: "step"
			}
		],
		settings: {
			backgroundColor: "#ffffff",
			zoomOnClick: true,
			mediaWidth: "1"
		}
	}
},
	buttons: buttons,
	divider: divider,
	provider: provider,
	row: row
};

var getRelativePath = function getRelativePath(path, folderBlockDefault) {
  return folderBlockDefault + "/" + path;
};
function addPaths(item, pathAssets, folderBlockDefault) {
  //TODO: Pendiente definicion de tipos
  if (item.embedType) return item; // el thumbnail de un embed no queremos que lo convierta
  var keyPaths = ['src', 'thumbnail', 'poster', 'key'];
  return Object.entries(item).reduce(function (acc, next) {
    var _extends2, _extends3, _extends4;
    return typeof next[1] === 'object' ? _extends((_extends2 = {}, _extends2[next[0]] = addPaths(next[1], pathAssets, folderBlockDefault), _extends2), acc) : keyPaths.indexOf(next[0]) > -1 ? _extends((_extends3 = {}, _extends3[next[0]] = getRelativePath(next[1], folderBlockDefault), _extends3), acc) : _extends((_extends4 = {}, _extends4[next[0]] = next[1], _extends4), acc);
  }, {});
}
//TODO: Pendiente definicion de tipos: meter { family, variant, data = defaultData } en una interfaz
function getItems(_ref, pathAssets, folderBlockDefault) {
  var family = _ref.family,
    variant = _ref.variant,
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? defaultData : _ref$data;
  //TODO: Pendiente definicion de tipos: : IItemItemBlock[]
  return data[family][variant].items.map(function (item) {
    // == Importante hacer una copia porque sino vamos devolver un objeto que tiene referencias al original, y si se modifica el objeto se va a modificar el original (MIN-301)
    var itemCopy = JSON.parse(JSON.stringify(item));
    return addPaths(_extends({
      id: getGuid()
    }, itemCopy), pathAssets, folderBlockDefault);
  });
}
function getSettings(_ref2) {
  var family = _ref2.family,
    variant = _ref2.variant,
    _ref2$data = _ref2.data,
    data = _ref2$data === void 0 ? defaultData : _ref2$data;
  if (data && data[family] && data[family][variant] && data[family][variant].settings) {
    return data[family][variant].settings;
  } else return {};
}
function getLemonade(_ref3) {
  var variant = _ref3.variant,
    guid = _ref3.guid;
  // const v = getDefaultData(variant)
  return function (item) {
    return _extends({}, item, {
      reference: guid,
      metadata: _extends({}, item.metadata, {
        template_reference: guid
      })
    });
  }(getDefaultData(variant));
  // }))(data[family][variant]);
}

function getJsonDefault(type, family, variant, pathAssets, folderBlockDefault) {
  var settingGeneral = {
    paddingTop: 1,
    paddingBottom: 1,
    backgroundColor: '',
    entranceAnimation: true
  }; // en el mint original el padding era de 3
  var id = getGuid();
  var defaultParams = {
    id: id,
    type: type,
    family: family,
    variant: variant
  };
  var settings = _extends({}, settingGeneral, getSettings({
    family: family,
    variant: variant,
    data: defaultData
  }));
  return family === 'lemonade' && (variant === 'Lemonade content guid' || variant === 'Lemonade feedback content guid') ? _extends({}, defaultParams, {
    settings: _extends({}, settings),
    items: []
  }) : family === 'lemonade' ? _extends({}, defaultParams, {
    settings: _extends({}, settings),
    items: [{
      data: getLemonade({
        family: family,
        variant: variant,
        guid: defaultParams.id,
        data: defaultData
      })
    }]
  }) : variant === 'labeledgraphic' ? _extends({}, defaultParams, {
    settings: _extends({}, settings, {
      mediaWidth: '1'
    }),
    media: {
      image: _extends({}, defaultData[family][variant].media.image, {
        //src: getFullPath(defaultData[family][variant].media.image.src, pathAssets, folderBlockDefault),
        src: getRelativePath(defaultData[family][variant].media.image.key, folderBlockDefault),
        key: getRelativePath(defaultData[family][variant].media.image.key, folderBlockDefault)
      })
    },
    items: getItems({
      family: family,
      variant: variant,
      data: defaultData
    }, pathAssets, folderBlockDefault)
  }) : _extends({}, defaultParams, {
    settings: settings,
    items: getItems({
      family: family,
      variant: variant,
      data: defaultData
    }, pathAssets, folderBlockDefault)
  });
}
function getTemporalItemBlockFromImage(image) {
  return {
    id: getGuid(),
    type: 'image',
    family: 'image',
    variant: 'full',
    settings: {},
    items: [],
    media: _extends({}, image ? {
      image: image
    } : {})
  };
}
function getTemporalItemBlockFromEmbed(embed) {
  return {
    id: getGuid(),
    type: 'multimedia',
    family: 'multimedia',
    variant: 'embed',
    settings: {},
    items: [],
    media: _extends({}, embed ? {
      embed: embed
    } : {})
  };
}
function getTemporalItemBlockFromAudio(audio) {
  return {
    id: getGuid(),
    type: 'multimedia',
    family: 'multimedia',
    variant: 'audio',
    settings: {},
    items: [],
    media: _extends({}, audio ? {
      audio: audio
    } : {})
  };
}
function getTemporalItemBlockFromVideo(video) {
  return {
    id: getGuid(),
    type: 'multimedia',
    family: 'multimedia',
    variant: 'video',
    settings: {},
    items: [],
    media: _extends({}, video ? {
      video: video
    } : {})
  };
}

function getItemUpdatedHeading(item, textUpdatedHeading) {
  var itemUpdated = item;
  if (item && item.items.length > 0) itemUpdated.items[0].heading = textUpdatedHeading;
  return itemUpdated;
}
function getItemUpdatedParagraph(item, textUpdatedParagraph) {
  var itemUpdated = item;
  if (item && item.items.length > 0) {
    itemUpdated.items[0].paragraph = textUpdatedParagraph;
  }
  return itemUpdated;
}
/**
 * Devuelve como queda el item despues de actualizar el campo paragraph de su subitem
 * @param {Campo Item de Itemblock} item
 * @param {Paragraph actualizado} textUpdatedParagraph
 * @param {index del array de items} index
 */
function getItemUpdatedParagraphIndex(item, paragraph, index) {
  var itemUpdated = item;
  if (item && item.items.length >= index + 1) itemUpdated.items[index].paragraph = paragraph;
  return itemUpdated;
}
function getItemUpdatedIsCountForNote(item, isCountForNote) {
  var itemUpdated = item;
  if (item) itemUpdated.isCountForNote = isCountForNote;
  console.log('getItemUpdatedIsCountForNote', itemUpdated);
  return itemUpdated;
}
function getItemUpdatedAttemptsNumber(item, attemptsNumber) {
  var itemUpdated = item;
  if (item) itemUpdated.attemptsNumber = attemptsNumber;
  return itemUpdated;
}
function getItemUpdatedIntelligenceTag(item, intelligenceTag) {
  var itemUpdated = item;
  if (item) {
    if (intelligenceTag === '') {
      delete itemUpdated.intelligenceTag;
    } else {
      itemUpdated.intelligenceTag = intelligenceTag;
    }
  }
  return itemUpdated;
}
function getItemUpdatedColumn(indexColumn, item, textUpdatedColumn) {
  var itemUpdated = item;
  if (item && item.items.length > 0 && indexColumn <= item.items.length - 1) {
    itemUpdated.items[indexColumn].paragraph = textUpdatedColumn;
  }
  return itemUpdated;
}
/**
 * Devuelve como queda el item despues de actualizar el campo number de su subitem
 * @param {Campo Item de Itemblock} item
 * @param {Paragraph actualizado} textUpdatedParagraph
 * @param {index del array de items} index
 */
function getItemUpdatedNumberIndex(item, number, index) {
  var itemUpdated = item;
  if (item && item.items.length >= index + 1) itemUpdated.items[index].number = number;
  return itemUpdated;
}
/**
 * Devuelve como queda el item despues de actualizar el campo caption de su subitem
 * @param {Campo Item de Itemblock} item
 * @param {Nombre actualizado} textUpdated
 */
function getItemUpdatedCaptionIndex(item, textUpdated, index, indexContents) {
  var itemUpdated = item;
  if (item.items.length > 0) {
    var targetItemItemBlock = getTargetItemItemBlock(itemUpdated, index, indexContents);
    if (targetItemItemBlock) {
      targetItemItemBlock.caption = textUpdated;
    }
  }
  return itemUpdated;
}
/**
 * Devuelve como queda el item despues de actualizar el campo label de su subitem
 * @param {Campo Item de Itemblock} item
 * @param {Nombre actualizado} textUpdated
 */
function getItemUpdatedLabelIndex(item, textUpdated, index) {
  var itemUpdated = item;
  if (item && item.items.length > 0) {
    itemUpdated.items[index].label = textUpdated;
  }
  return itemUpdated;
}
/**
 * Devuelve como queda el item despues de actualizar el campo name de su subitem
 * @param {Campo Item de Itemblock} item
 * @param {Nombre actualizado} textUpdated
 */
function getItemUpdatedNameIndex(item, textUpdated, index) {
  var itemUpdated = item;
  if (item && item.items.length > 0) {
    itemUpdated.items[index].name = textUpdated;
  }
  return itemUpdated;
}
function getItemUpdatedEmbedIndex(item, index, title, thumbnail, src, providerUrl, provider, originalUrl, favicon, embedType, description, contentGuid) {
  var itemUpdated = item;
  if (item && item.items.length > 0) {
    if (!itemUpdated.items[index].media) itemUpdated.items[index].media = {};
    // @ts-ignore Ya he comprobado antes si no existia itemUpdated.items[index].media lo crea
    if (!itemUpdated.items[index].media.embed) itemUpdated.items[index].media.embed = {};
    // @ts-ignore Ya he comprobado antes si no existia itemUpdated.items[index].media.embed lo crea
    var mediaEmbed = itemUpdated.items[index].media.embed;
    if (mediaEmbed) {
      mediaEmbed.type = ITypeSubItemMedia.EMBED;
      mediaEmbed.title = title;
      mediaEmbed.thumbnail = thumbnail;
      mediaEmbed.src = src;
      mediaEmbed.providerUrl = providerUrl;
      mediaEmbed.provider = provider;
      mediaEmbed.originalUrl = originalUrl;
      mediaEmbed.favicon = favicon;
      mediaEmbed.embedType = embedType;
      mediaEmbed.description = description;
      if (contentGuid) mediaEmbed.content_guid = contentGuid;
    }
  }
  return itemUpdated;
}
function getTargetItemItemBlock(item, index, indexContents) {
  var targetItem =
  //@ts-ignore Ignoro el error de que item.items[index].contents puede ser undefined, pues ya lo he comprobado
  item.items[index].contents && item.items[index].contents.length > 0 && indexContents !== undefined ?
  //@ts-ignore Ignoro el error de que item.items[index].contents puede ser undefined, pues ya lo he comprobado
  item.items[index].contents[indexContents] : item.items[index];
  return targetItem;
}
/**
 * Devuelve como queda el item despues de actualizar el campo title de su subitem
 * @param {Campo Item de Itemblock} item
 * @param {Nombre actualizado} textUpdated
 */
function getItemUpdatedTitleIndex(item, textUpdated, index, indexContents) {
  var itemUpdated = item;
  if (item.items.length > 0) {
    var targetItemItemBlock = getTargetItemItemBlock(itemUpdated, index, indexContents);
    if (targetItemItemBlock) targetItemItemBlock.title = textUpdated;
  }
  return itemUpdated;
}
function getItemUpdatedSettingsAlignImageIndex(item, index, indexContents, alignImage) {
  var itemUpdated = item;
  if (item.items.length > 0) {
    var targetItemItemBlock = getTargetItemItemBlock(itemUpdated, index, indexContents);
    if (targetItemItemBlock) {
      if (!targetItemItemBlock.settings) targetItemItemBlock.settings = {};
      var settings = targetItemItemBlock.settings;
      if (!settings) settings = {};
      settings.alignImage = alignImage;
    }
  }
  return itemUpdated;
}
function getItemUpdatedSettingsSizeImageIndex(item, index, indexContents, sizeImage) {
  var itemUpdated = item;
  if (item.items.length > 0) {
    var targetItemItemBlock = getTargetItemItemBlock(itemUpdated, index, indexContents);
    if (targetItemItemBlock) {
      if (!targetItemItemBlock.settings) targetItemItemBlock.settings = {};
      var settings = targetItemItemBlock.settings;
      if (!settings) settings = {};
      settings.imageSize = sizeImage;
    }
  }
  return itemUpdated;
}
/**
 * Devuelve como queda el item despues de actualizar el campo description de su subitem
 * @param {Campo Item de Itemblock} item
 * @param {Nombre actualizado} textUpdated
 */
function getItemUpdatedDescriptionIndex(item, textUpdated, index, indexContents) {
  var itemUpdated = item;
  if (item && item.items.length > 0) {
    var targetItemItemBlock = getTargetItemItemBlock(itemUpdated, index, indexContents);
    if (targetItemItemBlock) targetItemItemBlock.description = textUpdated;
  }
  return itemUpdated;
}
/**
 * Devuelve como queda el item despues de actualizar el campo destination y type de su subitem
 * @param {Campo Item de Itemblock} item
 * @param {Nombre actualizado} textUpdated
 */
function getItemUpdatedDestinationTypeIndex(item, textDestinationUpdated, textTypeUpdated, index) {
  var itemUpdated = item;
  if (item && item.items.length > 0) {
    itemUpdated.items[index].destination = textDestinationUpdated;
    itemUpdated.items[index].type = textTypeUpdated;
  }
  return itemUpdated;
}
/**
 * Devuelve como queda el item despues de actualizar el campo destination de su subitem
 * @param {Campo Item de Itemblock} item
 * @param {Nombre actualizado} textUpdated
 */
function getItemUpdatedDestinationIndex(item, textDestinationUpdated, index) {
  var itemUpdated = item;
  if (item && item.items.length > 0) {
    itemUpdated.items[index].destination = textDestinationUpdated;
  }
  return itemUpdated;
}
/**
 * Devuelve como queda el item despues de actualizar el campo caption de su subitem
 * @param {Campo Item de Itemblock} item
 * @param {Nombre actualizado} textUpdated
 */
function getItemUpdatedCaption(item, textUpdated) {
  return getItemUpdatedCaptionIndex(item, textUpdated, 0);
}
/**
 * Devuelve como queda el item despues de actualizar el campo name de su subitem
 * @param {Campo Item de Itemblock} item
 * @param {Nombre actualizado} textUpdated
 */
function getItemUpdatedName(item, textUpdated) {
  return getItemUpdatedNameIndex(item, textUpdated, 0);
}
function getItemUpdatedEmbed(item, title, thumbnail, src, providerUrl, provider, originalUrl, favicon, embedType, description, contentGuid) {
  return getItemUpdatedEmbedIndex(item, 0, title, thumbnail, src, providerUrl, provider, originalUrl, favicon, embedType, description, contentGuid);
}
function onParagraphUpdated(text, item, onChangeItem) {
  if (onChangeItem) {
    onChangeItem(getItemUpdatedParagraph(item, text));
  }
}
function onChangeMediaImage(image, item, onChangeItem) {
  if (onChangeItem) {
    onChangeItem(getItemUpdatedMediaImage(item, image));
  }
}
function onParagraphUpdatedIndex(text, item, index, onChangeItem) {
  if (onChangeItem) {
    onChangeItem(getItemUpdatedParagraphIndex(item, text, index));
  }
}
function onNumberUpdatedIndex(text, item, index, onChangeItem) {
  if (onChangeItem) {
    onChangeItem(getItemUpdatedNumberIndex(item, text, index));
  }
}
function onHeadingUpdated(text, item, onChangeItem) {
  if (onChangeItem) {
    onChangeItem(getItemUpdatedHeading(item, text));
  }
}
function onTextColumnUpdated(index, textUpdated, item, onChangeItem) {
  if (onChangeItem) {
    onChangeItem(getItemUpdatedColumn(index, item, textUpdated));
  }
}
function onEmbedUpdated(title, thumbnail, src, providerUrl, provider, originalUrl, favicon, embedType, description, item, onChangeItem, contentGuid) {
  if (onChangeItem) {
    onChangeItem(getItemUpdatedEmbed(item, title, thumbnail, src, providerUrl, provider, originalUrl, favicon, embedType, description, contentGuid));
  }
}
function onCaptionUpdated(text, item, onChangeItem) {
  if (onChangeItem) {
    onChangeItem(getItemUpdatedCaption(item, text));
  }
}
function onNameUpdated(text, item, onChangeItem) {
  if (onChangeItem) {
    onChangeItem(getItemUpdatedName(item, text));
  }
}
function onAttemptsNumberUpdated(attemptsNumber, item, onChangeItem) {
  if (onChangeItem) {
    onChangeItem(getItemUpdatedAttemptsNumber(item, attemptsNumber));
  }
}
function onCountForNoteUpdated(isCountForNote, item, onChangeItem) {
  if (onChangeItem) {
    onChangeItem(getItemUpdatedIsCountForNote(item, isCountForNote));
  }
}
function onIntelligenceTagUpdated(intelligenceTag, item, onChangeItem) {
  if (onChangeItem) {
    onChangeItem(getItemUpdatedIntelligenceTag(item, intelligenceTag));
  }
}
function onCaptionUpdatedIndex(text, item, index, indexContents, onChangeItem) {
  if (onChangeItem) {
    onChangeItem(getItemUpdatedCaptionIndex(item, text, index, indexContents));
  }
}
function onLabelUpdatedIndex(text, item, index, onChangeItem) {
  if (onChangeItem) {
    onChangeItem(getItemUpdatedLabelIndex(item, text, index));
  }
}
function onTitleUpdatedIndex(text, item, index, indexContents, onChangeItem) {
  if (onChangeItem) {
    onChangeItem(getItemUpdatedTitleIndex(item, text, index, indexContents));
  }
}
function onAlignImageUpdatedIndex(alignImage, item, index, indexContents, onChangeItem) {
  if (onChangeItem) {
    onChangeItem(getItemUpdatedSettingsAlignImageIndex(item, index, indexContents, alignImage));
  }
}
function onSizeImageUpdatedIndex(sizeImage, item, index, indexContents, onChangeItem) {
  if (onChangeItem) {
    onChangeItem(getItemUpdatedSettingsSizeImageIndex(item, index, indexContents, sizeImage));
  }
}
function onDescriptionUpdatedIndex(text, item, index, indexContents, onChangeItem) {
  if (onChangeItem) {
    onChangeItem(getItemUpdatedDescriptionIndex(item, text, index, indexContents));
  }
}
function onItemUpdatedDestinationAndTypeIndex(item, destination, type, index, onChangeItem) {
  if (onChangeItem) {
    onChangeItem(getItemUpdatedDestinationTypeIndex(item, destination, type, index));
  }
}
function onItemUpdatedDestinationIndex(item, text, index, onChangeItem) {
  if (onChangeItem) {
    onChangeItem(getItemUpdatedDestinationIndex(item, text, index));
  }
}
function onChangeImageUpdated(subItemImage, item, onChangeItem, isDeleteOtherMedias) {
  if (isDeleteOtherMedias === void 0) {
    isDeleteOtherMedias = false;
  }
  if (onChangeItem) {
    onChangeItem(getItemUpdatedSubItemImage(item, subItemImage, isDeleteOtherMedias));
  }
}
function onChangeImageAltTextUpdated(text, subItemImage, item, onChangeItem, isDeleteOtherMedias) {
  if (isDeleteOtherMedias === void 0) {
    isDeleteOtherMedias = false;
  }
  onChangeImageAltTextUpdatedIndex(text, subItemImage, item, 0, undefined, onChangeItem, isDeleteOtherMedias);
}
function onChangeImageAltTextUpdatedIndex(text, subItemImage, item, index, indexContents, onChangeItem, isDeleteOtherMedias) {
  if (isDeleteOtherMedias === void 0) {
    isDeleteOtherMedias = false;
  }
  if (onChangeItem) {
    onChangeItem(getItemUpdatedSubItemImageIndex(item, index, indexContents, getMediaImageUpdatedAltText(text, subItemImage), isDeleteOtherMedias));
  }
}
function onChangeAvatarUpdated(subItemImage, item, onChangeItem, isDeleteOtherMedias) {
  if (isDeleteOtherMedias === void 0) {
    isDeleteOtherMedias = false;
  }
  if (onChangeItem) {
    onChangeItem(getItemUpdatedSubItemAvatar(item, subItemImage, isDeleteOtherMedias));
  }
}
function onChangeAudioUpdated(subItemAudio, item, onChangeItem, isDeleteOtherMedias) {
  if (isDeleteOtherMedias === void 0) {
    isDeleteOtherMedias = false;
  }
  if (onChangeItem) {
    onChangeItem(getItemUpdatedSubItemAudio(item, subItemAudio, isDeleteOtherMedias));
  }
}
function onChangeVideoUpdated(subItemVideo, item, onChangeItem, isDeleteOtherMedias) {
  if (isDeleteOtherMedias === void 0) {
    isDeleteOtherMedias = false;
  }
  if (onChangeItem) {
    onChangeItem(getItemUpdatedSubItemVideo(item, subItemVideo, isDeleteOtherMedias));
  }
}
function onChangeImageUpdatedIndex(subItemImage, item, index, indexContents, onChangeItem) {
  if (onChangeItem) {
    onChangeItem(getItemUpdatedSubItemImageIndex(item, index, indexContents, subItemImage, false));
  }
}
function onChangeMediaUpdatedIndex(subItemMedia, item, index, indexContents, onChangeItem, isDeleteOtherMedias) {
  if (isDeleteOtherMedias === void 0) {
    isDeleteOtherMedias = false;
  }
  if (onChangeItem) {
    var itemUpdatedSubItem = null;
    if (isMediaImage(subItemMedia)) {
      itemUpdatedSubItem = getItemUpdatedSubItemImageIndex(item, index, indexContents, subItemMedia, isDeleteOtherMedias);
    } else if (isMediaAudio(subItemMedia)) {
      itemUpdatedSubItem = getItemUpdatedSubItemAudioIndex(item, index, indexContents, subItemMedia, isDeleteOtherMedias);
    } else if (isMediaVideo(subItemMedia)) {
      itemUpdatedSubItem = getItemUpdatedSubItemVideoIndex(item, index, indexContents, subItemMedia, isDeleteOtherMedias);
    }
    if (itemUpdatedSubItem) {
      onChangeItem(itemUpdatedSubItem);
    }
  }
}
//TODO: Pendiente definicion de tipos el subItemLemonade
function onChangeLemonadeUpdated(subItemLemonade, item, onChangeItem) {
  if (onChangeItem) {
    onChangeItem(getItemUpdatedSubItemLemonade(item, subItemLemonade));
  }
}
function onDeleteMediaIndex(item, index, indexContents, onChangeItem) {
  if (onChangeItem) {
    onChangeItem(getItemDeleteMediaIndex(item, index, indexContents));
  }
}
/**
 * Dado un item nos devuelve una copia de el con todos sus ids que corresponda cambiados
 * Si para hacer alguna copia para algun item particular hay que hacer algo particular hacerlo dentro de este metodo
 * @param {*} item
 */
function getItemCopy(item) {
  var itemCopy = JSON.parse(JSON.stringify(item)); // == Hago una copia
  // == Cambio su id
  itemCopy.id = getGuid();
  if (itemCopy.parent_guid) itemCopy.parent_guid = itemCopy.id;
  // == Cambio la id de sus items
  if (itemCopy.items) {
    for (var _iterator = _createForOfIteratorHelperLoose(itemCopy.items), _step; !(_step = _iterator()).done;) {
      var element = _step.value;
      var itemParticular = element;
      if (itemParticular.id) {
        itemParticular.id = getGuid();
      }
      if (itemParticular.contents) {
        for (var _iterator2 = _createForOfIteratorHelperLoose(itemParticular.contents), _step2; !(_step2 = _iterator2()).done;) {
          var content = _step2.value;
          content.id = getGuid();
        }
      }
    }
  }
  return itemCopy;
}
/**
 * Devuelve como queda el item de eliminar un subitem
 * @param {Campo Item de Itemblock} item
 * @param {Index del subitem} indexSubitem
 */
function getItemUpdatedRemoveSubitemIndex(item, indexSubitem) {
  var itemUpdated = item;
  if (itemUpdated && itemUpdated.items) {
    if (indexSubitem >= 0) {
      itemUpdated.items.splice(indexSubitem, 1);
    }
  }
  return itemUpdated;
}
/**
 * Devuelve como queda el item de añadir en el indice index de sus items, el primer item de sus items por defecto
 * @param {Campo Item de Itemblock} item
 */
function getItemUpdatedPushIndexFirstSubitem(item, index, pathAssets, folderBlockDefault) {
  var itemUpdated = item;
  if (itemUpdated) {
    if (!itemUpdated.items) itemUpdated.items = [];
    var items = getItems({
      family: itemUpdated.family,
      variant: itemUpdated.variant
    }, pathAssets, folderBlockDefault);
    if (items && items.length > 0 && items[0]) {
      var subItem = items[0];
      if (subItem.name) subItem.name = '';
      if (subItem.paragraph) subItem.paragraph = '';
      if (subItem.caption) subItem.caption = '';
      itemUpdated.items.splice(index, 0, subItem);
    }
  }
  return itemUpdated;
}
/**
 * Devuelve como queda el item de añadir al final de sus items, el primer item de sus items por defecto
 * @param {Campo Item de Itemblock} item
 */
function getItemUpdatedPushSubitem(item, subItem) {
  var itemUpdated = item;
  if (itemUpdated) {
    if (!itemUpdated.items) itemUpdated.items = [];
    if (subItem) {
      itemUpdated.items.push(subItem);
    }
    if (item.type === 'interactive' && item.family === 'interactive-fullscreen' && item.variant === 'process') {
      var itemsReorder = getItemsReorderProcess(item);
      itemUpdated.items = itemsReorder;
    }
  }
  return itemUpdated;
}
function getItemsReorderProcess(item) {
  var itemsReorder = [];
  // Reordeno los elemento colocando primero la intro, luego los step y por ultimo el summary
  if (item.items) {
    var itemsIntro = item.items.filter(function (itemInside) {
      return itemInside.type === 'intro';
    });
    var itemsStep = item.items.filter(function (itemInside) {
      return itemInside.type === 'step';
    });
    var itemsSummary = item.items.filter(function (itemInside) {
      return itemInside.type === 'summary';
    });
    itemsReorder.push.apply(itemsReorder, itemsIntro);
    itemsReorder.push.apply(itemsReorder, itemsStep);
    itemsReorder.push.apply(itemsReorder, itemsSummary);
  }
  return itemsReorder;
}
function getItemsReorderTimeline(item) {
  var itemsReorder = [];
  // Reordeno los elemento colocando primero el start, luego los step y por ultimo el end
  if (item.items) {
    var itemsStart = item.items.filter(function (itemInside) {
      return itemInside.type === 'start';
    });
    var itemsStep = item.items.filter(function (itemInside) {
      return itemInside.type === 'step';
    });
    var itemsEnd = item.items.filter(function (itemInside) {
      return itemInside.type === 'end';
    });
    itemsReorder.push.apply(itemsReorder, itemsStart);
    itemsReorder.push.apply(itemsReorder, itemsStep);
    itemsReorder.push.apply(itemsReorder, itemsEnd);
  }
  return itemsReorder;
}
function getIdsItems(item) {
  if (item && item.items) {
    return item.items.map(function (subitem) {
      return subitem.id;
    });
  } else return [];
}
/**
 * Devuelve como queda el item de añadir al final de sus items, el primer item de sus items por defecto
 * @param {Campo Item de Itemblock} item
 */
function getItemUpdatedPushFirstSubitem(item, pathAssets, folderBlockDefault) {
  var itemUpdated = item;
  if (itemUpdated) {
    if (!itemUpdated.items) itemUpdated.items = [];
    var items = getItems({
      family: itemUpdated.family,
      variant: itemUpdated.variant
    }, pathAssets, folderBlockDefault);
    if (items && items.length > 0 && items[0]) {
      var subItem = items[0];
      if (subItem.title) subItem.title = '';
      if (subItem.description) subItem.description = '';
      if (subItem.media) delete subItem.media;
      if (subItem.name) subItem.name = '';
      if (subItem.paragraph) subItem.paragraph = '';
      if (subItem.captionz) subItem.caption = '';
      itemUpdated.items.push(subItem);
    }
  }
  return itemUpdated;
}
/**
 * Devuelve como queda el item de eliminar un subitem
 * @param {Campo Item de Itemblock} item
 * @param {Id del subitem} idSubitem
 */
function getItemUpdatedRemoveSubitem(item, idSubitem) {
  var itemUpdated = item;
  if (itemUpdated && itemUpdated.items) {
    var index = itemUpdated.items.map(function (x) {
      return x.id;
    }).indexOf(idSubitem);
    if (index >= 0) {
      itemUpdated.items.splice(index, 1);
    }
  }
  return itemUpdated;
}
/**
 * Devuelve como queda el item de mover un subitem de la lista
 * @param {Campo Item de Itemblock} item
 * @param {Id del subitem} idSubitem
 */
function getItemUpdatedMoveSubitem(item, items, posInitial, posFinal) {
  var itemUpdated = item;
  if (itemUpdated && items) {
    var result = Array.from(items);
    var _result$splice = result.splice(posInitial, 1),
      removed = _result$splice[0];
    result.splice(posFinal, 0, removed);
    itemUpdated.items = result;
  }
  return itemUpdated;
}
/**
 * Devuelve como queda el item despues de actualizar sus items
 * @param {Campo Item de Itemblock} item
 * @param {name actualizado} text
 * @param {index del array de items} index
 */
function getItemUpdatedItems(item, newItems) {
  var itemUpdated = JSON.parse(JSON.stringify(item));
  itemUpdated.items = newItems;
  return itemUpdated;
}
function deleteAllMediasSubitem(item, index, indexContents) {
  if (item.items.length > 0) {
    var targetItemItemBlock = getTargetItemItemBlock(item, index, indexContents);
    if (targetItemItemBlock && targetItemItemBlock.media) {
      // @ts-ignore Ya he comprobado que item.items[index].media tenga valor
      delete targetItemItemBlock.media.image;
      // @ts-ignore Ya he comprobado que item.items[index].media tenga valor
      delete targetItemItemBlock.media.audio;
      // @ts-ignore Ya he comprobado que item.items[index].media tenga valor
      delete targetItemItemBlock.media.video;
    }
  }
}
function deleteAllMediasSubitemAvatar(item, index) {
  if (item && item.items.length > 0) {
    var _item$items$index$ava;
    if (item.items[index].avatar && (_item$items$index$ava = item.items[index].avatar) != null && _item$items$index$ava.media) {
      // @ts-ignore Ya he comprobado que item.items[index].media tenga valor
      delete item.items[index].avatar.media.image;
      // @ts-ignore Ya he comprobado que item.items[index].media tenga valor
      delete item.items[index].avatar.media.audio;
      // @ts-ignore Ya he comprobado que item.items[index].media tenga valor
      delete item.items[index].avatar.media.video;
    }
  }
}
/**
 * Devuelve como queda el item despues de actualizar el subitem
 */
function getItemUpdatedSubItemImageIndex(item, index, indexContents, subItemImage, isDeleteOtherMedias) {
  if (isDeleteOtherMedias === void 0) {
    isDeleteOtherMedias = false;
  }
  var itemUpdated = item;
  if (item.items.length > 0) {
    var targetItemItemBlock = getTargetItemItemBlock(item, index, indexContents);
    if (targetItemItemBlock) {
      if (!targetItemItemBlock.media) targetItemItemBlock.media = {};
      if (isDeleteOtherMedias) {
        deleteAllMediasSubitem(item, index, indexContents);
      }
      if (targetItemItemBlock.media) targetItemItemBlock.media = _extends({}, targetItemItemBlock.media, {
        image: subItemImage
      });
    }
  }
  return itemUpdated;
}
/**
 * Devuelve como queda el item despues de actualizar el subitem
 */
function getItemUpdatedSubItemAvatarIndex(item, index, subItemImage, isDeleteOtherMedias) {
  if (isDeleteOtherMedias === void 0) {
    isDeleteOtherMedias = false;
  }
  var itemUpdated = item;
  if (item && item.items.length > 0) {
    var _itemUpdated$items$in;
    if (!itemUpdated.items[index].avatar) itemUpdated.items[index].avatar = {
      media: {}
    };
    if (!((_itemUpdated$items$in = itemUpdated.items[index].avatar) != null && _itemUpdated$items$in.media)) itemUpdated.items[index].media = {};
    if (isDeleteOtherMedias) {
      deleteAllMediasSubitemAvatar(item, index);
    }
    // https://stackoverflow.com/questions/40349987/how-to-suppress-error-ts2533-object-is-possibly-null-or-undefined
    itemUpdated.items[index].avatar.media = _extends({}, itemUpdated.items[index].avatar.media, {
      image: subItemImage
    });
  }
  return itemUpdated;
}
/**
 * Devuelve como queda el item despues de actualizar el subitem
 */
function getItemUpdatedSubItemAudioIndex(item, index, indexContents, subItemAudio, isDeleteOtherMedias) {
  if (isDeleteOtherMedias === void 0) {
    isDeleteOtherMedias = false;
  }
  var itemUpdated = item;
  if (item.items.length > 0) {
    var targetItemItemBlock = getTargetItemItemBlock(item, index, indexContents);
    if (targetItemItemBlock) {
      if (!targetItemItemBlock.media) targetItemItemBlock.media = {};
      if (isDeleteOtherMedias) {
        deleteAllMediasSubitem(item, index, indexContents);
      }
      if (targetItemItemBlock.media) targetItemItemBlock.media = _extends({}, targetItemItemBlock.media, {
        audio: subItemAudio
      });
    }
  }
  return itemUpdated;
}
/**
 * Devuelve como queda el item despues de actualizar el subitem
 */
function getItemUpdatedSubItemVideoIndex(item, index, indexContents, subItemVideo, isDeleteOtherMedias) {
  if (isDeleteOtherMedias === void 0) {
    isDeleteOtherMedias = false;
  }
  var itemUpdated = item;
  if (item.items.length > 0) {
    var targetItemItemBlock = getTargetItemItemBlock(item, index, indexContents);
    if (targetItemItemBlock) {
      if (!targetItemItemBlock.media) targetItemItemBlock.media = {};
      if (isDeleteOtherMedias) {
        deleteAllMediasSubitem(item, index, indexContents);
      }
      if (targetItemItemBlock.media) targetItemItemBlock.media = _extends({}, targetItemItemBlock.media, {
        video: subItemVideo
      });
    }
  }
  return itemUpdated;
}
/**
 * Devuelve como queda el item despues de actualizar el subitem
 */
function getItemUpdatedMediaImage(item, image) {
  var itemUpdated = item;
  if (item) {
    if (!itemUpdated.media) itemUpdated.media = {};
    itemUpdated.media.image = image;
  }
  return itemUpdated;
}
function getItemUpdatedSubItemImage(item, subItemImage, isDeleteOtherMedias) {
  if (isDeleteOtherMedias === void 0) {
    isDeleteOtherMedias = false;
  }
  return getItemUpdatedSubItemImageIndex(item, 0, undefined, subItemImage, isDeleteOtherMedias);
}
function getItemUpdatedSubItemAvatar(item, subItemImage, isDeleteOtherMedias) {
  if (isDeleteOtherMedias === void 0) {
    isDeleteOtherMedias = false;
  }
  return getItemUpdatedSubItemAvatarIndex(item, 0, subItemImage, isDeleteOtherMedias);
}
function getItemUpdatedSubItemAudio(item, subItemAudio, isDeleteOtherMedias) {
  if (isDeleteOtherMedias === void 0) {
    isDeleteOtherMedias = false;
  }
  return getItemUpdatedSubItemAudioIndex(item, 0, undefined, subItemAudio, isDeleteOtherMedias);
}
function getItemUpdatedSubItemVideo(item, subItemVideo, isDeleteOtherMedias) {
  if (isDeleteOtherMedias === void 0) {
    isDeleteOtherMedias = false;
  }
  return getItemUpdatedSubItemVideoIndex(item, 0, undefined, subItemVideo, isDeleteOtherMedias);
}
function getItemUpdatedSubItemLemonade(item, subItemLemonade) {
  var itemUpdated = item;
  // TODO:
  // @ts-ignore // TODO: Aqui se queja porque le faltan propiedades al item, solventarlo a futuro añadiendo algunas propiedades por defecto, o ver que a esta funcion si se le pasa un item sea obligatorio a que tenga al menos un items?
  if (item && (!item.items || item.items && item.items.length === 0)) itemUpdated.items = [{}];
  itemUpdated.items[0] = _extends({}, itemUpdated.items[0], {
    data: _extends({}, subItemLemonade)
  });
  if (subItemLemonade && subItemLemonade.metadata && subItemLemonade.metadata.name) {
    itemUpdated.variant = subItemLemonade.metadata.name;
  }
  return itemUpdated;
}
/**
 * Obtiene la imagen del item
 * @param {Item de la leccion} item
 */
function getItemImageIndex(item, index) {
  var subItem = item && item.items.length > 0 ? item.items[index] : null;
  var media = subItem && subItem.media ? subItem.media : null;
  var image = media ? media.image : null;
  return image;
}
/**
 * Obtiene la imagen avatar del item
 * @param {Item de la leccion} item
 */
function getItemAvatarIndex(item, index) {
  var _subItem$avatar, _subItem$avatar2;
  var subItem = item && item.items.length > 0 ? item.items[index] : null;
  var media = subItem && subItem.avatar && (_subItem$avatar = subItem.avatar) != null && _subItem$avatar.media ? (_subItem$avatar2 = subItem.avatar) == null ? void 0 : _subItem$avatar2.media : null;
  var image = media ? media.image : null;
  return image;
}
/**
 * Obtiene el audio del item
 * @param {Item de la leccion} item
 */
function getItemAudioIndex(item, index) {
  var subItem = item && item.items.length > 0 ? item.items[index] : null;
  var media = subItem && subItem.media ? subItem.media : null;
  var audio = media ? media.audio : null;
  return audio;
}
/**
 * Obtiene el audio del item
 * @param {Item de la leccion} item
 */
function getItemVideoIndex(item, index) {
  var subItem = item && item.items.length > 0 ? item.items[index] : null;
  var media = subItem && subItem.media ? subItem.media : null;
  var video = media ? media.video : null;
  return video;
}
/**
 * Obtiene el embed del item
 * @param {Item de la leccion} item
 */
function getItemEmbedIndex(item, index) {
  var subItem = item && item.items.length > 0 ? item.items[index] : null;
  var media = subItem && subItem.media ? subItem.media : null;
  var embed = media ? media.embed : null;
  return embed;
}
/**
 * Devuelve como queda el item despues de eliminar la imagen
 * @param {*} item
 * @param {*} index
 */
function getItemDeleteMediaIndex(item, index, indexContents) {
  var itemUpdated = item;
  if (item.items.length > 0) {
    var targetItemItemBlock = getTargetItemItemBlock(item, index, indexContents);
    if (targetItemItemBlock && targetItemItemBlock.media) delete targetItemItemBlock.media;
  }
  return itemUpdated;
}
/**
 * Obtiene la imagen del item
 * @param {Item de la leccion} item
 */
function getItemLemonadeIndex(item, index) {
  //TODO: Pendiente definicion de tipos:el tipo de lemonade
  var subItem = item && item.items.length > 0 ? item.items[index] : null;
  var dataLemonade = subItem && subItem.data ? subItem.data : null;
  return dataLemonade;
}
/**
 * Obtiene el subitem de tipo imagen que ocupa la primera posicion de los items
 * @param {Item de la leccion} item
 */
function getItemImage(item) {
  return getItemImageIndex(item, 0);
}
/**
 * Obtiene el subitem avatar de tipo imagen que ocupa la primera posicion de los items
 * @param {Item de la leccion} item
 */
function getItemAvatar(item) {
  return getItemAvatarIndex(item, 0);
}
/**
 * Obtiene el subitem de tipo audio que ocupa la primera posicion de los items
 * @param {Item de la leccion} item
 */
function getItemAudio(item) {
  return getItemAudioIndex(item, 0);
}
/**
 * Obtiene el subitem de tipo video que ocupa la primera posicion de los items
 * @param {Item de la leccion} item
 */
function getItemVideo(item) {
  return getItemVideoIndex(item, 0);
}
/**
 * Obtiene el subitem de tipo embed que ocupa la primera posicion de los items
 * @param {Item de la leccion} item
 */
function getItemEmbed(item) {
  return getItemEmbedIndex(item, 0);
}
/**
 * Obtiene el subitem de tipo lemonade que ocupa la primera posicion de los items
 * @param {Item de la leccion} item
 */
function getItemLemonade(item) {
  //TODO: Pendiente definicion de tipos: el tipo de lemonade
  return getItemLemonadeIndex(item, 0);
}
/**
 * Obtiene el scoring_type de un item de lemonade
 * @param {Item de la leccion} item
 * @returns {string | null} El scoring_type o null si no se encuentra
 */
function getItemLemonadeScoringType(item) {
  if (!item || item.type !== 'lemonade') {
    return null;
  }
  var lemonadeData = getItemLemonade(item);
  if (!lemonadeData || !lemonadeData.data) {
    return null;
  }
  var activityData = lemonadeData.data;
  if (!activityData || !activityData.validation) {
    return null;
  }
  return activityData.validation.scoring_type || null;
}
/**
 * Verifica si un item es un ejercicio de lemonade con scoring_type manual
 * @param {Item de la leccion} item
 * @returns {boolean} true si es lemonade con scoring manual, false en caso contrario
 */
function isItemLemonadeManualScoring(item) {
  var scoringType = getItemLemonadeScoringType(item);
  return scoringType === 'manual';
}
/**
 * Devuelve true si el item pasado por parametro se permite su renderizacion
 */
function isCanRenderItem(item, role) {
  var _item$settings;
  // == En futuro poder hacer logica aqui, en pqlco habia algunos casos particulares donde no habia que mostrarlos
  if (!item || !item.hasOwnProperty('type')) return false;
  if (role === roleTypes.STUDENT && (_item$settings = item.settings) != null && _item$settings.teacherOnly) return false;
  return true;
}
function isHasBeenSeen(item, itemsIdHasBeenSeen) {
  return itemsIdHasBeenSeen.indexOf(item.id) >= 0;
}
/**
 * Nombre con amigable del item
 * @param item
 * @param translate getListItemBlock(blockList, translate);
 * @param listItemBlock viene de
 * @returns
 */
function getItemFriendlyName(item, translate) {
  /* const listItemBlock = getListItemBlock(blockList, translate);
  const itemBlockFind = item ? findItemBlock(listItemBlock, item.type, item.family, item.variant) : null;
  return itemBlockFind ? itemBlockFind.caption : item.variant || '';
  console.log(blockList); */
  // TODO: intento coger la traducion del menu lateral de creacion pero en este momento no tengo todo lo necsario para obtenerlo
  return item ? translate(item.variant, {
    ns: 'editor'
  }) : '';
}
/**
 * Obtiene la imagen avatar del item
 * @param {Item de la leccion} item
 */
function getMediaImageUpdatedAltText(text, subItemMedia) {
  var subItemMediaUpdated = subItemMedia;
  subItemMediaUpdated.alt = text;
  return subItemMediaUpdated;
}

function useProcess(props) {
  var item = props.item,
    mode = props.mode;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useState = useState(null),
    swiper = _useState[0],
    setSwiper = _useState[1];
  // Devuelve los sub items de un process de manera ordenada
  var items = useMemo(function () {
    return getItemsReorderProcess(item);
  }, [item != null && item.items ? item.items.length : null]);
  function getIndexOriginalItem(itemId) {
    var _item$items;
    return item == null || (_item$items = item.items) == null ? void 0 : _item$items.findIndex(function (itemFind) {
      return itemFind.id === itemId;
    });
  }
  var getStepLabel = function getStepLabel(numberStep) {
    var stepLabel = item.settings ? item.settings.stepLabel || '' : '';
    var head = '';
    if (stepLabel && stepLabel.length > 0) {
      if (stepLabel.indexOf('[NUMBER]') !== -1) {
        head = stepLabel.replace('[NUMBER]', numberStep);
      } else {
        head = t('proccess_step_label_number', {
          label: stepLabel,
          number: numberStep
        });
      }
    } else {
      head = t('proccess_step_number', {
        number: numberStep
      });
    }
    return head;
  };
  var onClickStart = function onClickStart(e) {
    e.preventDefault();
    if (swiper) swiper.slideTo(1);
  };
  var onClickRestart = function onClickRestart(e) {
    e.preventDefault();
    if (swiper) swiper.slideTo(0);
  };
  return {
    t: t,
    getStepLabel: getStepLabel,
    setSwiper: setSwiper,
    onClickStart: onClickStart,
    onClickRestart: onClickRestart,
    items: items,
    modeTextHtml: isModeEditTextHtml(mode) ? IModesTextHtml.MODE_TEXT_HTML_EDITOR : IModesTextHtml.MODE_TEXT_HTML_VISOR,
    getIndexOriginalItem: getIndexOriginalItem
  };
}

var Process = function Process(_ref) {
  var item = _ref.item,
    mode = _ref.mode,
    getTextHtml = _ref.getTextHtml,
    getSrc = _ref.getSrc,
    titleUpdatedIndex = _ref.titleUpdatedIndex,
    descriptionUpdatedIndex = _ref.descriptionUpdatedIndex,
    captionUpdatedIndex = _ref.captionUpdatedIndex,
    onReady = _ref.onReady;
  var _useProcess = useProcess({
      item: item,
      mode: mode
    }),
    modeTextHtml = _useProcess.modeTextHtml,
    items = _useProcess.items,
    getStepLabel = _useProcess.getStepLabel,
    setSwiper = _useProcess.setSwiper,
    onClickStart = _useProcess.onClickStart,
    onClickRestart = _useProcess.onClickRestart,
    getIndexOriginalItem = _useProcess.getIndexOriginalItem;
  var _useItemBlockComponen = useItemBlockComponent({
      numComponentsTextHtml: getNumComponentsTextHtml(),
      onReady: onReady,
      item: item
    }),
    onReadyGetTextHtml = _useItemBlockComponen.onReadyGetTextHtml;
  var pagination = {
    el: '.swiper-pagination-' + item.id,
    clickable: true,
    renderBullet: function renderBullet(index, className) {
      if (index === 0) return '<span></span>';
      if (items.length === index + 1) {
        // es el ultimo
        return "<a href=\"\" class=\"" + className + " gallery-carousel__bullet-content brand--fill brand--border swiper-pagination-bullet-last\">" + renderToString( /*#__PURE__*/React__default.createElement(SvgCheck, {
          className: 'icon icon-check'
        })) + "</a>";
      } else {
        return "<a href=\"\" class=\"" + className + " gallery-carousel__bullet-content brand--fill brand--border\">" + index + "</a>";
      }
    }
  };
  function getNumComponentsTextHtml() {
    var num = 0;
    for (var index = 0; index < items.length; index++) {
      var _item = items[index];
      if (_item.title) num++;
      if (_item.description) num++;
    }
    return num;
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-process ' + CLASS_NO_SELECT
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-process__gellery-carousel'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-process__swiper mint-block-process__swiper-' + item.id
  }, /*#__PURE__*/React__default.createElement(Swiper, {
    pagination: pagination,
    navigation: true,
    modules: [Navigation, Pagination, Controller],
    slidesPerView: 1,
    onSwiper: setSwiper
  }, items.map(function (i, index) {
    var head = getStepLabel(index);
    var indexOfOriginalItems = getIndexOriginalItem(i.id);
    return /*#__PURE__*/React__default.createElement(SwiperSlide, {
      key: i.id
    }, /*#__PURE__*/React__default.createElement(ProcessStep, {
      item: i,
      modeTextHtml: modeTextHtml,
      itemParentId: item.id,
      getTextHtml: getTextHtml,
      onReadyGetTextHtml: onReadyGetTextHtml,
      getSrc: getSrc,
      head: head,
      onClickStart: onClickStart,
      onClickRestart: onClickRestart,
      titleUpdated: function titleUpdated(text) {
        return titleUpdatedIndex && titleUpdatedIndex(text, indexOfOriginalItems);
      },
      descriptionUpdated: function descriptionUpdated(text) {
        return descriptionUpdatedIndex && descriptionUpdatedIndex(text, indexOfOriginalItems);
      },
      captionUpdated: function captionUpdated(text) {
        return captionUpdatedIndex && captionUpdatedIndex(text, indexOfOriginalItems);
      },
      mode: mode
    }));
  })))));
};

function useTabs(props) {
  var item = props.item,
    mode = props.mode;
  var _useState = useState(null),
    tabActive = _useState[0],
    setTabActive = _useState[1];
  var clickTab = function clickTab(e, idTab) {
    e.preventDefault();
    setTabActive(idTab);
  };
  return {
    clickTab: clickTab,
    tabActive: tabActive,
    alignImages: getItemSettingAlignImages(item),
    modeTextHtml: isModeEditTextHtml(mode) ? IModesTextHtml.MODE_TEXT_HTML_EDITOR : IModesTextHtml.MODE_TEXT_HTML_VISOR,
    showAdditionalContentsSubItemVisor: ConfigGlobalSingleton.getInstance().isShowAdditionalContentsSubItemVisor()
  };
}

function useTabItem(props) {
  var mode = props.mode;
  return {
    modeTextHtml: isModeEditTextHtml(mode) ? IModesTextHtml.MODE_TEXT_HTML_EDITOR : IModesTextHtml.MODE_TEXT_HTML_VISOR
  };
}

var _TabItem = function TabItem(_ref) {
  var _itemInside$media$ima, _itemInside$contents;
  var itemInside = _ref.itemInside,
    index = _ref.index,
    item = _ref.item,
    alignImages = _ref.alignImages,
    showItem = _ref.showItem,
    descriptionUpdatedIndex = _ref.descriptionUpdatedIndex,
    captionUpdatedIndex = _ref.captionUpdatedIndex,
    getTextHtml = _ref.getTextHtml,
    getSrc = _ref.getSrc,
    onReadyGetTextHtml = _ref.onReadyGetTextHtml,
    mode = _ref.mode,
    indexContents = _ref.indexContents,
    _ref$showContents = _ref.showContents,
    showContents = _ref$showContents === void 0 ? false : _ref$showContents;
  var _useTabItem = useTabItem({
      mode: mode
    }),
    modeTextHtml = _useTabItem.modeTextHtml;
  var alignImageItemInside = getItemSettingAlignImage(itemInside);
  var sizeImageItemInside = getItemSettingImageSize(itemInside);
  // == Si esta especificada la opcion del subitem prevalece esa opción en otro caso coge la opcion del setting general alignImages
  var alignImageFinal = alignImageItemInside && alignImageItemInside !== SETTINGS_ALIGN_IMAGES.UNSPECIFIED ? alignImageItemInside : alignImages;
  var sizeImageFinal = sizeImageItemInside ? sizeImageItemInside : 'extra-large';
  var renderDescription = function renderDescription(description, onChangeText, keyDescription) {
    return description && getTextHtml(description, onChangeText, keyDescription, modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml);
  };
  var renderAudio = function renderAudio(audio, mediaId) {
    return /*#__PURE__*/React__default.createElement(MediaAudio, {
      audio: audio,
      key: mediaId + '_audio' || audio.key,
      getSrc: getSrc
    });
  };
  var renderVideo = function renderVideo(video, mediaId) {
    return /*#__PURE__*/React__default.createElement(MediaVideo, {
      video: video,
      key: mediaId + '_video' || video.key,
      getSrc: getSrc
    });
  };
  var renderImage = function renderImage(image, alt, enableZoomOnClick, alignImageFinal, sizeImageFinal, caption, onChangeCaption, keyCaption) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: (alignImageFinal ? "mint-block-tabs__image--" + alignImageFinal : '') + (sizeImageFinal ? " mint-block-tabs__image--" + sizeImageFinal : '')
    }, /*#__PURE__*/React__default.createElement(MediaImage, {
      image: image,
      alt: alt || '',
      getSrc: getSrc,
      enableZoomOnClick: enableZoomOnClick,
      mode: mode
    })), (caption || mode === IModesItemBlock.MODE_EDITOR) && getTextHtml(caption || '', onChangeCaption, keyCaption, modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml));
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-tabs__wrap brand--second-all mint-block-tabs__wrap--content' + index + (indexContents ? '_' + indexContents : '') + ' mint-block-tabs__wrap--' + (showItem ? 'show' : 'hidden'),
    key: itemInside.id
  }, renderDescription(itemInside.description, function (text) {
    return descriptionUpdatedIndex && descriptionUpdatedIndex(text, index, indexContents);
  }, itemInside.id + '_description'), itemInside.media && itemInside.media.audio && renderAudio(itemInside.media.audio, itemInside.id), itemInside.media && itemInside.media.image && renderImage(itemInside.media.image, (_itemInside$media$ima = itemInside.media.image) == null ? void 0 : _itemInside$media$ima.alt, getItemSettingIsZoomOnClick(item), alignImageFinal, sizeImageFinal, itemInside.caption, function (text) {
    return captionUpdatedIndex && captionUpdatedIndex(text, index, indexContents);
  }, itemInside.id + '_caption'), itemInside.media && itemInside.media.video && renderVideo(itemInside.media.video, itemInside.id), showContents && /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-tabs__contents'
  }, (_itemInside$contents = itemInside.contents) == null ? void 0 : _itemInside$contents.map(function (itemInsideContent, indexItemInsideContents) {
    return /*#__PURE__*/React__default.createElement(_TabItem, {
      key: itemInsideContent.id,
      itemInside: itemInsideContent,
      item: item,
      index: index,
      getTextHtml: getTextHtml,
      descriptionUpdatedIndex: descriptionUpdatedIndex,
      captionUpdatedIndex: captionUpdatedIndex,
      indexContents: indexItemInsideContents,
      showContents: false,
      alignImages: alignImages,
      showItem: showItem,
      getSrc: getSrc,
      onReadyGetTextHtml: onReadyGetTextHtml,
      mode: mode
    });
  })));
};

var TABS_SLIDER_FOR_VIEW = 3;
var Tabs = function Tabs(_ref) {
  var _item$items2, _item$items3;
  var item = _ref.item,
    mode = _ref.mode,
    getTextHtml = _ref.getTextHtml,
    getSrc = _ref.getSrc,
    descriptionUpdatedIndex = _ref.descriptionUpdatedIndex,
    captionUpdatedIndex = _ref.captionUpdatedIndex,
    titleUpdatedIndex = _ref.titleUpdatedIndex,
    onReady = _ref.onReady;
  var _useTabs = useTabs({
      item: item,
      mode: mode
    }),
    tabActive = _useTabs.tabActive,
    alignImages = _useTabs.alignImages,
    clickTab = _useTabs.clickTab,
    showAdditionalContentsSubItemVisor = _useTabs.showAdditionalContentsSubItemVisor;
  var navigationPrevRef = useRef(null);
  var navigationNextRef = useRef(null);
  var _useItemBlockComponen = useItemBlockComponent({
      numComponentsTextHtml: getNumComponentsTextHtml(),
      onReady: onReady,
      item: item
    }),
    onReadyGetTextHtml = _useItemBlockComponen.onReadyGetTextHtml;
  function isItemShow(idTab, indexItem) {
    return tabActive === idTab || !tabActive && indexItem == 0;
  }
  function getNumComponentsTextHtml() {
    var num = 0;
    if (item.items) {
      for (var index = 0; index < item.items.length; index++) {
        var itemInside = item.items[index];
        // == Dentro de Swiper
        num++;
        // == Dentro de mint-block-tabs__content'
        if (itemInside.description) {
          num++;
        }
        if (itemInside.caption) {
          num++;
        }
      }
    }
    return num;
  }
  var isArrowsVisibles = useMemo(function () {
    var _item$items;
    return (((_item$items = item.items) == null ? void 0 : _item$items.length) || 0) > TABS_SLIDER_FOR_VIEW;
  }, [item == null || (_item$items2 = item.items) == null ? void 0 : _item$items2.length]);
  var navigation = {
    prevEl: navigationPrevRef.current,
    nextEl: navigationNextRef.current
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-tabs'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-tabs__nav ' + CLASS_CONTENT_LEFT
  }, /*#__PURE__*/React__default.createElement(Swiper, {
    navigation: navigation,
    modules: [Navigation, Controller],
    slidesPerView: isArrowsVisibles ? TABS_SLIDER_FOR_VIEW : ((_item$items3 = item.items) == null ? void 0 : _item$items3.length) || 0,
    autoHeight: true,
    containerModifierClass: 'swiper-container-'
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: navigationPrevRef,
    className: 'swiper-button-prev swiper-button-prev-' + item.id + ' ' + (isArrowsVisibles ? '' : 'hidden')
  }), /*#__PURE__*/React__default.createElement("div", {
    ref: navigationNextRef,
    className: 'swiper-button-next swiper-button-next-' + item.id + ' ' + (isArrowsVisibles ? '' : 'hidden')
  }), item.items && item.items.map(function (itemInside, index) {
    return /*#__PURE__*/React__default.createElement(SwiperSlide, {
      key: itemInside.id,
      className: 'brand--first'
    }, /*#__PURE__*/React__default.createElement("a", {
      href: '#',
      onClick: function onClick(e) {
        return clickTab(e, itemInside.id);
      },
      className: 'mint-block-tabs__tab ' + (isItemShow(itemInside.id, index) ? 'mint-block-tabs__tab--show brand--color' : '')
    }, getTextHtml(itemInside.title || '', function (text) {
      return titleUpdatedIndex && titleUpdatedIndex(text, index);
    }, itemInside.id + '_title', IModesTextHtml.MODE_TEXT_HTML_EDITOR, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml)));
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-tabs__content'
  }, item.items && item.items.map(function (itemInside, index) {
    return /*#__PURE__*/React__default.createElement(_TabItem, {
      key: itemInside.id,
      itemInside: itemInside,
      index: index,
      item: item,
      alignImages: alignImages,
      showItem: isItemShow(itemInside.id, index),
      descriptionUpdatedIndex: descriptionUpdatedIndex,
      captionUpdatedIndex: captionUpdatedIndex,
      getTextHtml: getTextHtml,
      getSrc: getSrc,
      onReadyGetTextHtml: onReadyGetTextHtml,
      mode: mode,
      showContents: showAdditionalContentsSubItemVisor && true
    });
  }))));
};

function useScormControls(reference, lessonId, type) {
  var _window = window,
    sco_instance = _window.sco_instance;
  var scoLesson = sco_instance == null ? void 0 : sco_instance[lessonId != null ? lessonId : ''];
  return useMemo(function () {
    return {
      onInit: function onInit(value) {
        // console.log('onInit', value);
        scoLesson == null || scoLesson.init(value);
      },
      onComplete: function onComplete(value, corrects, tryNumber) {
        console.log('onComplete', value, corrects, tryNumber, reference);
        var simpleAnswer = ['longtextV2', 'mcq', 'shorttext'].indexOf(type || '') > -1;
        var _corrects = corrects == -1 ? 1 : corrects; // si es negativo se trata de un no evaluable que mint lo considera como bien hecho// type === 'longtextV2' ? 1 : corrects;
        scoLesson == null || scoLesson.set(value, _corrects, tryNumber, reference, simpleAnswer);
      }
    };
  }, [scoLesson, reference, lessonId]);
}

// Definir los breakpoints disponibles
var BREAKPOINT_SMALL = '576px';
var BREAKPOINT_DEFAULT = '768px';
var BREAKPOINT_LARGE = '992px';
/**
 * Configuración inicial por defecto de cada nueva columna que se crea en el layout.
 * @param itemId - ID del item que contendrá la columna
 * @param guid - Identificador único de la columna. Si no se especifica, se genera uno nuevo
 * @returns IPostColumn
 */
function createNewColumn(itemId, guid) {
  return {
    guid: guid || getGuid(),
    itemId: itemId,
    config: {
      // width: '100%',
      // background: '#0000FF80',
    }
  };
}
/**
 * Configuración inicial por defecto de cada nueva fila que se crea en el layout.
 * @param columns - Array de columnas de la fila
 * @param guid - Identificador único de la fila. Si no se especifica, se genera uno nuevo
 * @returns IPostRow
 */
function createNewRow(columns, guid) {
  if (columns === void 0) {
    columns = [];
  }
  return {
    guid: guid || getGuid(),
    columns: columns,
    config: {
      //stackOnMobile: true,
      // mobileBreakpoint: BREAKPOINT_DEFAULT, // Usar el breakpoint por defecto
      //gap: '16px',
      //width: '50%',
      // background: '#FF000080',
      //alignHorizontal: 'center',
      // alignVertical: 'stretch',
    }
  };
}
/**
 * Configuración inicial por defecto de cada nuevo layout que se crea.
 * @param rows - Array de filas del layout. Si no se especifica, se inicializa vacío
 * @returns IPostLayout
 */
function createNewLayout(rows) {
  if (rows === void 0) {
    rows = [];
  }
  return {
    guid: getGuid(),
    rows: rows,
    config: {
      // Row defaults
      //defaultRowWidth: '50%',
      //defaultRowGap: '8px',
      //defaultRowStackOnMobile: true,
      //defaultRowMobileBreakpoint: BREAKPOINT_DEFAULT,
      //defaultRowAlignHorizontal: 'center',
      //defaultRowAlignVertical: 'center',
      defaultRowBackground: '#FFFFFF'
    }
  };
}

function getUrlWithoutBeginBar(url) {
  if (url.charAt(0) === '/') {
    return url.substring(1);
  } else return url;
}
function getImageFromTangerine(content) {
  return {
    content_guid: content.content_guid,
    originalUrl: content.name,
    src: getUrlWithoutBeginBar(content.url),
    thumbnail: content.thumbnail,
    key: getUrlWithoutBeginBar(content.url),
    type: ITypeSubItemMedia.IMAGE
  };
}
function getAudioFromTangerine(content) {
  return {
    content_guid: content.content_guid,
    originalUrl: content.name,
    src: getUrlWithoutBeginBar(content.url),
    key: getUrlWithoutBeginBar(content.url),
    type: ITypeSubItemMedia.AUDIO,
    transcription: content == null ? void 0 : content.transcription_url
  };
}
function getVideoFromTangerine(content) {
  return {
    content_guid: content.content_guid,
    originalUrl: content.name,
    thumbnail: content.thumbnail,
    poster: content.thumbnail,
    src: getUrlWithoutBeginBar(content.url),
    key: getUrlWithoutBeginBar(content.url),
    type: ITypeSubItemMedia.VIDEO
  };
}
function getEmbedFromTangerine(content) {
  var typeGuid = content.type_guid;
  //LINK: 'CTTY_06',
  //HTML INTERACTIVO: 'CTTY_08',
  //TIN_CAM_XAPI: 'CTTY_20',
  /*const url =
    typeGuid === 'CTTY_08'
      ? `<div style="width: 100%;"><div style="position: relative; padding-bottom: 56.25%; padding-top: 0; height: 0;"><iframe title="Interactive Content" frameborder="0" width="1200" height="675" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;" src="${getUrlWithoutBeginBar(
          content.url
        )}" type="text/html" allowscriptaccess="always" allowfullscreen="true" scrolling="yes" allownetworking="all"></iframe></div></div>`
      : getUrlWithoutBeginBar(content.url);*/
  var url = getUrlWithoutBeginBar(content.url);
  var embedType = '';
  if (typeGuid === 'CTTY_08' || typeGuid === 'CTTY_20') {
    embedType = 'htmlInteractive';
  }
  return {
    key: url,
    originalUrl: url,
    src: url,
    type: ITypeSubItemMedia.EMBED,
    content_guid: content.content_guid,
    thumbnail: '',
    embedType: embedType
  };
  // Si el src no ha cambiado y tenemos mediaEmbedOriginal
  /* if (mediaEmbedOriginal) {
    if (mediaEmbedOriginal.src === url) {
      return {
        ...mediaEmbedOriginal,
        key: url,
        originalUrl: url,
        src: url,
        type: ITypeSubItemMedia.EMBED,
        content_guid: content.content_guid,
        // Mantener valores originales si no vienen en content.data
        // Solo incluir los atributos si existen en content.data o mediaEmbedOriginal
        ...(content.data?.title ?? mediaEmbedOriginal.title
          ? { title: content.data?.title ?? mediaEmbedOriginal.title }
          : {}),
        ...(content.data?.description ?? mediaEmbedOriginal.description
          ? { description: content.data?.description ?? mediaEmbedOriginal.description }
          : {}),
        ...(content.data?.provider ?? mediaEmbedOriginal.provider
          ? { provider: content.data?.provider ?? mediaEmbedOriginal.provider }
          : {}),
        ...(content.data?.provider_url ?? mediaEmbedOriginal.providerUrl
          ? { providerUrl: content.data?.provider_url ?? mediaEmbedOriginal.providerUrl }
          : {}),
        ...(content.data?.favicon ?? mediaEmbedOriginal.favicon
          ? { favicon: content.data?.favicon ?? mediaEmbedOriginal.favicon }
          : {}),
        thumbnail: content.data?.thumbnail ?? mediaEmbedOriginal.thumbnail,
        embedType: content.data?.embed_type ?? mediaEmbedOriginal.embedType,
      };
    } else {
      return {
        key: url,
        originalUrl: url,
        src: url,
        type: ITypeSubItemMedia.EMBED,
        content_guid: content.content_guid,
        ...(content.data?.title && { title: content.data.title }),
        ...(content.data?.description && { description: content.data.description }),
        ...(content.data?.provider && { provider: content.data.provider }),
        ...(content.data?.provider_url && { providerUrl: content.data.provider_url }),
        ...(content.data?.favicon && { favicon: content.data.favicon }),
        thumbnail: content.data?.thumbnail || '',
        embedType: content.data?.embedType || '',
      };
    }
     // Si el src ha cambiado o no hay mediaEmbedOriginal, comportamiento original
  return {
    key: url,
    originalUrl: url,
    src: url,
    type: ITypeSubItemMedia.EMBED,
    content_guid: content.content_guid,
    ...(content.data?.title && { title: content.data.title }),
    ...(content.data?.description && { description: content.data.description }),
    ...(content.data?.provider && { provider: content.data.provider }),
    ...(content.data?.provider_url && { providerUrl: content.data.provider_url }),
    ...(content.data?.favicon && { favicon: content.data.favicon }),
    thumbnail: content.data?.thumbnail ?? ?? '',
    embedType: content.data?.embed_type ?? mediaEmbedOriginal?.embedType ?? '',
  };*/
}
// TODO función del deomio que convierte el json de lemonade de la api en json compatible con lemonade
function prepareLemonadeData(json, content_guid) {
  var _json$data, _json$data2;
  if (json != null && (_json$data = json.data) != null && _json$data.data && json != null && (_json$data2 = json.data) != null && _json$data2.metadata) return json;
  return {
    data: _extends({}, json, {
      reference: content_guid || json.reference || '',
      title: json.title || '',
      metadata: json.metadata || json.data && json.data.metadata || {}
    })
  };
}
function getLemonadeFromTangerine(content) {
  var data = content.data;
  try {
    if (typeof data === 'string') {
      data = JSON.parse(data);
    }
  } catch (error) {}
  return _extends({
    content_guid: content.content_guid
  }, data);
}
/**
 *
 * @param postTangerine
 * @param enableHasChangeItem Si es true se tiene en cuenta que los items pueden tener el atributo has_change y en ese caso en este metodo hay que quitar dicho atributo para limpiarlo ya que cuando viene un item del server se le quita para indicar que no tiene cambios y luego en la aplicación cuando haya un cambio se le pone
 * @returns
 */
function getPostsFromTangerine(postTangerine, enableHasChangeItem, enableRowColumnLayout) {
  if (enableHasChangeItem === void 0) {
    enableHasChangeItem = true;
  }
  if (enableRowColumnLayout === void 0) {
    enableRowColumnLayout = false;
  }
  function getItemBlockFromTangerine(item) {
    var _itemToRet;
    if (!item.data) return null;
    var itemToRet = item.data;
    itemToRet.lms = item.lms;
    itemToRet.parent_guid = item.guid;
    function getItemFromContentGuid(contentGuid) {
      var _item$items;
      return item == null || (_item$items = item.items) == null ? void 0 : _item$items.find(function (itemMultimedia) {
        return itemMultimedia.content_guid === contentGuid;
      });
    }
    function processItemWithMediaOrData(subItem, getItemFromContentGuid) {
      var _subItem$data;
      var processedItem = _extends({}, subItem);
      if (subItem.media) {
        processedItem = _extends({}, processedItem, {
          media: getMediaItemBlockFromTangerine(subItem.media, getItemFromContentGuid)
        });
      } else if ((_subItem$data = subItem.data) != null && _subItem$data.content_guid) {
        var itemFromContentGuid = getItemFromContentGuid(subItem.data.content_guid);
        if (itemFromContentGuid) {
          processedItem = _extends({}, processedItem, {
            data: getLemonadeFromTangerine(itemFromContentGuid)
          });
        }
      }
      return processedItem;
    }
    if (enableHasChangeItem && Object.prototype.hasOwnProperty.call(itemToRet, 'has_change')) delete itemToRet.has_change;
    itemToRet.items = (_itemToRet = itemToRet) == null || (_itemToRet = _itemToRet.items) == null ? void 0 : _itemToRet.map(function (subItem) {
      var subItemToRet = processItemWithMediaOrData(subItem, getItemFromContentGuid);
      if (subItem.contents) {
        subItemToRet = _extends({}, subItemToRet, {
          contents: subItem.contents.map(function (content) {
            return processItemWithMediaOrData(content, getItemFromContentGuid);
          })
        });
      }
      return subItemToRet;
    });
    if (itemToRet.media) {
      itemToRet = _extends({}, itemToRet, {
        media: getMediaItemBlockFromTangerine(itemToRet.media, getItemFromContentGuid)
      });
    }
    return itemToRet;
  }
  function getPostFromTangerine(post) {
    var postConverted = post;
    try {
      // Hago una copia para no modificar los originales pasados por parámetro
      postConverted = JSON.parse(JSON.stringify(post));
    } catch (error) {}
    postConverted.items = postConverted.items.map(function (item) {
      return getItemBlockFromTangerine(item);
    }).filter(function (item) {
      return item !== null;
    });
    postConverted.pdfPages = postConverted.pdf_pages || undefined;
    delete postConverted.pdf_pages;
    if (enableRowColumnLayout) {
      // == En postConverted.data es una caja negra donde vamos a tener entre otros el layout, lo copiamos de ese lugar a donde corresponde que es postConverted.layout
      if (postConverted.data) {
        var _postConverted$data;
        // == Si viene layout en data lo copio a layout
        if ((_postConverted$data = postConverted.data) != null && _postConverted$data.layout) {
          postConverted.layout = postConverted.data.layout;
        }
      }
      // == Si no tiene layout lo creo (TODO: ver si es necesario o sólo hacerlo si quiere crear mas de un elemento por fila)
      if (!postConverted.layout) {
        var newLayout = createNewLayout(postConverted.items.map(function (item) {
          return createNewRow([createNewColumn(item.id)]);
        }));
        postConverted.layout = newLayout;
      }
    }
    if (postConverted.data) {
      // == Si viene version en data lo copio a version
      if (postConverted.data.version) {
        postConverted.version = postConverted.data.version;
      }
      // == Quito la información de data porque en postConverted no debe de existir data
      delete postConverted.data;
    }
    //TODO: temporal para probar audios
    /* postConverted.audios = [
      {
        guid: getGuid(),
        src: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-3.mp3',
        blocks: [
          'db9099bd-e9df-427c-b80b-2a8fc4317552',
          '5a79e036-9441-4300-894e-8437ca414e81',
          'ceccc66e-0599-4a93-8791-98c2e56afae2',
        ],
      },
      {
        guid: getGuid(),
        src: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3',
        blocks: ['e12b427f-62af-4090-b8ff-1ca6c109f2d4'],
      },
      {
        guid: getGuid(),
        src: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3',
        blocks: [
          // Item de cuourse
          '36148a2a-ce1c-4310-8ad9-dd6c50b42c04',
        ],
      },
    ]; */
    return postConverted;
  }
  return postTangerine.map(function (post) {
    return getPostFromTangerine(post);
  });
}
function getMediaItemBlockFromTangerine(media, getItemFromContentGuid) {
  var subItemMedia = _extends({}, media);
  if (subItemMedia.image && subItemMedia.image.content_guid) {
    var itemFromContentGuid = getItemFromContentGuid(subItemMedia.image.content_guid);
    if (itemFromContentGuid) {
      subItemMedia.image = _extends({}, subItemMedia.image, getImageFromTangerine(itemFromContentGuid));
    }
  }
  if (subItemMedia.audio && subItemMedia.audio.content_guid) {
    var _itemFromContentGuid = getItemFromContentGuid(subItemMedia.audio.content_guid);
    if (_itemFromContentGuid) {
      subItemMedia.audio = _extends({}, subItemMedia.audio, getAudioFromTangerine(_itemFromContentGuid));
    }
  }
  if (subItemMedia.video && subItemMedia.video.content_guid) {
    var _itemFromContentGuid2 = getItemFromContentGuid(subItemMedia.video.content_guid);
    if (_itemFromContentGuid2) {
      subItemMedia.video = _extends({}, subItemMedia.video, getVideoFromTangerine(_itemFromContentGuid2));
    }
  }
  if (subItemMedia.embed && subItemMedia.embed.content_guid) {
    var _itemFromContentGuid3 = getItemFromContentGuid(subItemMedia.embed.content_guid);
    if (_itemFromContentGuid3) {
      subItemMedia.embed = _extends({}, subItemMedia.embed);
    }
  }
  return subItemMedia;
}
function getItemsOutMediaItemBlocksToTangerine(media) {
  var itemsOut = [];
  if (media.image && media.image.content_guid) {
    itemsOut.push({
      content_guid: media.image.content_guid
    });
  }
  if (media.audio && media.audio.content_guid) {
    itemsOut.push({
      content_guid: media.audio.content_guid
    });
  }
  if (media.video && media.video.content_guid) {
    itemsOut.push({
      content_guid: media.video.content_guid
    });
  }
  if (media.embed && media.embed.content_guid) {
    itemsOut.push({
      content_guid: media.embed.content_guid
    });
  }
  return itemsOut;
}
function getPostsToTangerine(postMint) {
  function getItemBlockToTangerine(item, index) {
    function getContentGuidFromSubItem(subItem) {
      var _subItem$data2;
      if (subItem.media) {
        return getItemsOutMediaItemBlocksToTangerine(subItem.media);
      }
      if ((_subItem$data2 = subItem.data) != null && _subItem$data2.content_guid) {
        return [{
          content_guid: subItem.data.content_guid
        }];
      }
      return [];
    }
    var itemsOut = [];
    for (var _iterator = _createForOfIteratorHelperLoose(item.items), _step; !(_step = _iterator()).done;) {
      var subItem = _step.value;
      itemsOut.push.apply(itemsOut, getContentGuidFromSubItem(subItem));
      if (subItem.contents) {
        subItem.contents.forEach(function (content) {
          itemsOut.push.apply(itemsOut, getContentGuidFromSubItem(content));
        });
      }
    }
    if (item.media) {
      itemsOut.push.apply(itemsOut, getItemsOutMediaItemBlocksToTangerine(item.media));
    }
    if (item.lms) delete item.lms;
    if (item.parent_guid) delete item.parent_guid;
    return {
      guid: item.id,
      type_guid: 'CTTY_MINTBLOCK',
      status: 'published',
      name: item.caption,
      order: index,
      data: _extends({}, item),
      assistent: null,
      teacher_notes: null,
      items: itemsOut
    };
  }
  function getPostToTangerine(post, index) {
    var postFinal = _extends({}, post);
    var pdfPages = postFinal.pdfPages;
    delete postFinal.pdfPages;
    var layout = post.layout;
    delete postFinal.layout;
    var version = post.version;
    delete postFinal.version;
    return _extends({}, postFinal, {
      items: post.items.map(function (item, _index) {
        return getItemBlockToTangerine(item, _index);
      }),
      name: 'Post ' + index,
      order: index,
      status: 'published',
      pdf_pages: pdfPages === undefined ? null : pdfPages
    }, layout || version ? {
      data: _extends({}, layout && {
        layout: layout
      }, version && {
        version: version
      })
    } : {});
  }
  return postMint.map(function (post, index) {
    return getPostToTangerine(post, index);
  });
}
function getLessonFromTangerine(lessonTangerine, enableHasChangeItem, enableRowColumnLayout) {
  if (enableHasChangeItem === void 0) {
    enableHasChangeItem = true;
  }
  if (enableRowColumnLayout === void 0) {
    enableRowColumnLayout = false;
  }
  return {
    id: lessonTangerine.guid,
    name: lessonTangerine.name || lessonTangerine.lesson_name,
    items: getPostsFromTangerine(lessonTangerine.items, enableHasChangeItem, enableRowColumnLayout),
    courseGuid: lessonTangerine.course_guid
  };
}
function getLessonsFromTangerine(lessonsTangerine, enableHasChangeItem) {
  if (enableHasChangeItem === void 0) {
    enableHasChangeItem = true;
  }
  return lessonsTangerine.map(function (item) {
    return getLessonFromTangerine(item, enableHasChangeItem);
  });
}
/**
 *
 * @param unitTrangerine
 * @param enableHasChangeItem Si es true se tiene en cuenta que los items pueden tener el atributo has_change y en ese caso en este metodo hay que quitar dicho atributo para limpiarlo ya que cuando viene un item del server se le quita para indicar que no tiene cambios y luego en la aplicación cuando haya un cambio se le pone
 * @returns
 */
function getUnitFromTangerine(unitTrangerine, enableHasChangeItem) {
  if (enableHasChangeItem === void 0) {
    enableHasChangeItem = true;
  }
  return {
    id: unitTrangerine.guid,
    name: unitTrangerine.name || unitTrangerine.section,
    lessons: getLessonsFromTangerine(unitTrangerine.items, enableHasChangeItem)
  };
}
/**
 *
 * @param unitTrangerine
 * @param enableHasChangeItem Si es true se tiene en cuenta que los items pueden tener el atributo has_change y en ese caso en este metodo hay que quitar dicho atributo para limpiarlo ya que cuando viene un item del server se le quita para indicar que no tiene cambios y luego en la aplicación cuando haya un cambio se le pone
 * @returns
 */
function getUnitsFromTangerine(unitsTrangerine, enableHasChangeItem) {
  if (enableHasChangeItem === void 0) {
    enableHasChangeItem = true;
  }
  return unitsTrangerine.map(function (item) {
    return getUnitFromTangerine(item, enableHasChangeItem);
  });
}
function getColorsFromTangerine(courseTrangerine) {
  return {
    first: courseTrangerine.color
  };
}
function getFontsFromTangerine(courseTrangerine) {
  return {
    heading: {
      id: courseTrangerine.headingTypefaceId,
      name: courseTrangerine.headingTypeface
    },
    body: {
      id: courseTrangerine.bodyTypefaceId,
      name: courseTrangerine.bodyTypeface
    },
    files: courseTrangerine.fonts.map(function (font) {
      return {
        id: font.id,
        name: font.name,
        style: font.style,
        weight: font.weight,
        src: font.src
      };
    })
  };
}
/**
 *
 * @param unitTrangerine
 * @param enableHasChangeItem Si es true se tiene en cuenta que los items pueden tener el atributo has_change y en ese caso en este metodo hay que quitar dicho atributo para limpiarlo ya que cuando viene un item del server se le quita para indicar que no tiene cambios y luego en la aplicación cuando haya un cambio se le pone
 * @returns
 */
function getCourseFromTangerine(courseTrangerine, enableHasChangeItem) {
  var _courseTrangerine$cov, _courseTrangerine$cov2;
  if (enableHasChangeItem === void 0) {
    enableHasChangeItem = true;
  }
  return _extends({
    id: courseTrangerine.guid,
    name: courseTrangerine.name,
    subtitle: courseTrangerine.subtitle,
    coverImage: {
      alpha: (_courseTrangerine$cov = courseTrangerine.coverImage) == null ? void 0 : _courseTrangerine$cov.alpha,
      src: (_courseTrangerine$cov2 = courseTrangerine.coverImage) == null ? void 0 : _courseTrangerine$cov2.src
    }
  }, courseTrangerine.color && {
    colors: getColorsFromTangerine(courseTrangerine)
  }, courseTrangerine.headingTypeface && courseTrangerine.bodyTypeface && {
    fonts: getFontsFromTangerine(courseTrangerine)
  }, {
    units: getUnitsFromTangerine(courseTrangerine.items, enableHasChangeItem)
  });
}
/**
 *
 * @param unitTrangerine
 * @param enableHasChangeItem Si es true se tiene en cuenta que los items pueden tener el atributo has_change y en ese caso en este metodo hay que quitar dicho atributo para limpiarlo ya que cuando viene un item del server se le quita para indicar que no tiene cambios y luego en la aplicación cuando haya un cambio se le pone
 * @returns
 */
function getCourseOrUnitFromTangerine(dataTrangerine, enableHasChangeItem) {
  if (enableHasChangeItem === void 0) {
    enableHasChangeItem = true;
  }
  // == TODO: Cambiarlo en un futuro cuando sepa como distinguir entre un curso y una unidad, ahora mismo lo voy hacer mirando el atributo color y headingTypefaceId que si está es un curso
  var isCourse = dataTrangerine.color !== undefined && dataTrangerine.headingTypefaceId !== undefined ? true : false;
  var couse = isCourse ? getCourseFromTangerine(dataTrangerine, enableHasChangeItem) : null;
  var unit = !isCourse ? getUnitFromTangerine(dataTrangerine, enableHasChangeItem) : null;
  return {
    course: couse,
    unit: unit
  };
}

var _path$7, _path2$2, _path3, _path4;
function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }
var SvgAstonished = function SvgAstonished(props) {
  return /*#__PURE__*/createElement("svg", _extends$f({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/createElement("path", {
    d: "M12 1.79248C0.298086 1.79248 0.0224609 14.91 0.0224609 17.505C0.0224609 20.1037 5.38309 22.2075 12 22.2075C18.615 22.2075 23.9775 20.1037 23.9775 17.505C23.9775 14.91 23.7 1.79248 12 1.79248Z",
    fill: "#FCC21B"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/createElement("path", {
    d: "M7.92197 11.8181C6.7576 11.8294 5.80135 10.71 5.78822 9.32063C5.7751 7.92563 6.71072 6.78938 7.8751 6.77813C9.03947 6.76876 9.99572 7.88626 10.0088 9.28126C10.0201 10.6725 9.08635 11.8069 7.92197 11.8181Z",
    fill: "#2F2F2F"
  })), _path3 || (_path3 = /*#__PURE__*/createElement("path", {
    d: "M16.185 11.098C17.0156 11.0961 17.6888 10.2898 17.6869 9.29797C17.685 8.30235 17.0081 7.49797 16.1775 7.50172C15.345 7.5036 14.67 8.30985 14.6719 9.30547C14.6756 10.2973 15.3525 11.0998 16.185 11.098Z",
    fill: "#2F2F2F"
  })), _path4 || (_path4 = /*#__PURE__*/createElement("path", {
    d: "M15.7201 12.5718C13.0201 12.4293 11.9251 14.0568 9.75576 14.0568C8.55201 14.0568 7.80389 13.6087 6.41076 13.9537C5.34014 14.2181 4.93701 15.27 4.93701 15.8475C4.93701 16.425 5.34201 17.4768 6.41076 17.7412C7.80389 18.0843 8.55201 17.6381 9.75576 17.6381C11.9251 17.6381 13.0183 19.2637 15.7201 19.1231C17.642 19.0218 19.0708 17.6718 19.0633 15.8475C19.0708 14.0212 17.642 12.6712 15.7201 12.5718Z",
    fill: "#ED6C30"
  })));
};

var _path$8, _path2$3, _path3$1, _path4$1;
function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/createElement("svg", _extends$g({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#99AAB5"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/createElement("path", {
    d: "M12.0001 21.3333C17.1547 21.3333 21.3334 17.1547 21.3334 12C21.3334 6.84535 17.1547 2.66667 12.0001 2.66667C6.84542 2.66667 2.66675 6.84535 2.66675 12C2.66675 17.1547 6.84542 21.3333 12.0001 21.3333Z",
    fill: "#E1E8ED"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/createElement("path", {
    d: "M12.6666 12C12.6666 12.3687 12.3686 12.6667 11.9999 12.6667C11.6319 12.6667 11.3333 12.3687 11.3333 12V4.66667C11.3333 4.29867 11.6319 4 11.9999 4C12.3686 4 12.6666 4.29867 12.6666 4.66667V12Z",
    fill: "#66757F"
  })), _path4$1 || (_path4$1 = /*#__PURE__*/createElement("path", {
    d: "M17.7733 15.3333C17.5899 15.6526 17.1819 15.762 16.8633 15.578L11.6666 12.578C11.3479 12.394 11.2386 11.9853 11.4226 11.6666C11.6066 11.348 12.0139 11.2386 12.3333 11.4233L17.5299 14.4233C17.8486 14.6073 17.9579 15.0146 17.7733 15.3333Z",
    fill: "#66757F"
  })));
};

var _circle, _path$9;
function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }
var SvgCorrect = function SvgCorrect(props) {
  return /*#__PURE__*/createElement("svg", _extends$h({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 12,
    fill: "#41D158"
  })), _path$9 || (_path$9 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0278 6.94371C16.3135 6.6605 16.6992 6.50112 17.1015 6.50001C17.5038 6.4989 17.8904 6.65615 18.1776 6.93778C18.4649 7.21941 18.6298 7.60278 18.6366 8.00501C18.6435 8.40724 18.4917 8.796 18.2143 9.08726L11.3282 18.0106C11.1882 18.1615 11.0191 18.2826 10.8312 18.3666C10.6433 18.4506 10.4404 18.4959 10.2345 18.4997C10.0287 18.5035 9.82423 18.4658 9.63333 18.3888C9.44242 18.3118 9.26901 18.197 9.12346 18.0515L4.98732 13.9133C4.83689 13.7731 4.71623 13.6041 4.63255 13.4163C4.54886 13.2285 4.50387 13.0257 4.50024 12.8201C4.49661 12.6146 4.53443 12.4103 4.61144 12.2197C4.68844 12.029 4.80306 11.8559 4.94845 11.7105C5.09384 11.5651 5.26703 11.4505 5.45768 11.3735C5.64833 11.2964 5.85253 11.2586 6.05811 11.2623C6.2637 11.2659 6.46644 11.3109 6.65426 11.3946C6.84207 11.4783 7.0111 11.5989 7.15128 11.7493L10.1626 14.7586L15.989 6.98863C16.0017 6.97281 16.0153 6.95781 16.0299 6.94371H16.0278Z",
    fill: "white"
  })));
};

var _circle$1, _path$a;
function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }
var SvgFail = function SvgFail(props) {
  return /*#__PURE__*/createElement("svg", _extends$i({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$1 || (_circle$1 = /*#__PURE__*/createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 12,
    fill: "#F76868"
  })), _path$a || (_path$a = /*#__PURE__*/createElement("path", {
    d: "M16.7555 7.6472C16.2249 7.1176 15.3646 7.1176 14.834 7.6472L11.9417 10.534L9.16602 7.76354C8.63541 7.23394 7.77513 7.23394 7.24452 7.76354C6.71391 8.29314 6.71391 9.15179 7.24452 9.68139L10.0202 12.4518L7.14796 15.3186C6.61735 15.8482 6.61735 16.7069 7.14796 17.2365C7.67857 17.7661 8.53885 17.7661 9.06946 17.2365L11.9417 14.3697L14.9305 17.3528C15.4611 17.8824 16.3214 17.8824 16.852 17.3528C17.3827 16.8232 17.3827 15.9645 16.852 15.4349L13.8632 12.4518L16.7555 9.56505C17.2861 9.03545 17.2861 8.1768 16.7555 7.6472Z",
    fill: "white"
  })));
};

var _path$b, _path2$4, _path3$2, _path4$2, _path5, _path6;
function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }
var SvgMaster = function SvgMaster(props) {
  return /*#__PURE__*/createElement("svg", _extends$j({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$b || (_path$b = /*#__PURE__*/createElement("path", {
    d: "M11.9606 1.62012C0.2775 1.62012 0 14.7189 0 17.312C0 19.9051 5.355 22.0051 11.9606 22.0051C18.5681 22.0051 23.9212 19.9032 23.9212 17.312C23.9212 14.7189 23.6456 1.62012 11.9606 1.62012Z",
    fill: "#FCC21B"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/createElement("path", {
    d: "M11.9832 19.6537C11.3401 19.6537 10.6951 19.5731 10.0613 19.4081C9.91722 19.37 9.79399 19.2765 9.71848 19.148C9.64298 19.0194 9.62131 18.8663 9.65821 18.7218C9.6961 18.5777 9.78965 18.4545 9.91832 18.3792C10.047 18.304 10.2003 18.2829 10.3445 18.3206C12.5288 18.8906 14.8838 18.2812 16.4907 16.7306C16.5438 16.6792 16.6065 16.6388 16.6753 16.6117C16.744 16.5847 16.8175 16.5715 16.8913 16.5729C16.9652 16.5742 17.0381 16.5902 17.1058 16.6199C17.1734 16.6495 17.2346 16.6922 17.2857 16.7456C17.3371 16.7987 17.3775 16.8614 17.4046 16.9302C17.4316 16.9989 17.4449 17.0723 17.4435 17.1462C17.4421 17.2201 17.4261 17.293 17.3964 17.3606C17.3668 17.4283 17.3241 17.4895 17.2707 17.5406C15.8513 18.9094 13.9351 19.6537 11.9832 19.6537Z",
    fill: "#2F2F2F"
  })), _path3$2 || (_path3$2 = /*#__PURE__*/createElement("path", {
    d: "M10.412 12.6113L10.4082 12.6151C10.4082 12.6132 10.4101 12.6113 10.412 12.6113Z",
    fill: "#2F2F2F"
  })), _path4$2 || (_path4$2 = /*#__PURE__*/createElement("path", {
    d: "M18.4142 7.75114C15.9092 7.75114 15.5736 8.13177 14.4017 8.38114C13.2299 8.62864 11.9999 8.62864 11.9999 8.62864C11.9999 8.62864 10.7699 8.62864 9.59799 8.37927C8.42611 8.12989 8.08861 7.74927 5.58549 7.74927C3.08049 7.74927 0.0786133 8.29114 0.0786133 8.29114V9.88677C0.0786133 9.88677 0.751738 9.97489 0.811738 10.5899C0.841738 10.8393 0.226738 15.9055 5.21986 15.9055C8.76361 15.9055 10.258 13.7811 10.7417 12.0543C10.9611 11.2349 11.1524 10.2974 12.0017 10.2974C12.8511 10.2974 13.0424 11.2349 13.2617 12.0543C13.7455 13.783 15.238 15.9055 18.7836 15.9055C23.7767 15.9055 23.1617 10.8374 23.1917 10.5899C23.2499 9.97489 23.9249 9.88677 23.9249 9.88677V8.29114C23.9211 8.29302 20.9192 7.75114 18.4142 7.75114Z",
    fill: "#2F2F2F"
  })), _path5 || (_path5 = /*#__PURE__*/createElement("path", {
    d: "M17.989 8.44685C16.7478 8.48998 15.8046 8.69248 15.8046 8.69248C13.9596 9.07873 13.8265 10.2187 13.9428 11.1244C14.0928 12.2625 14.5596 13.7025 15.8253 14.5912C15.9246 14.6625 16.1553 14.7394 16.2659 14.4469C16.2659 14.4469 16.2621 14.4675 16.2659 14.4469C16.6821 12.4819 17.3009 10.6706 18.2871 8.84248C18.4015 8.50686 18.1334 8.44123 17.989 8.44685Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/createElement("path", {
    d: "M5.82349 8.44116C5.02286 8.42429 4.11536 8.47679 3.26411 8.69241C2.30786 8.93241 1.93849 9.41429 1.83911 10.453C1.73974 11.4712 1.62724 14.0662 3.47599 15.0393C3.58286 15.0955 3.81911 15.133 3.93349 14.8687C4.49974 12.4143 4.80161 11.2743 6.10099 8.85366C6.20786 8.52929 5.96786 8.44304 5.82349 8.44116Z",
    fill: "white"
  })));
};

var _path$c, _path2$5, _path3$3;
function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }
var SvgThumbsUp = function SvgThumbsUp(props) {
  return /*#__PURE__*/createElement("svg", _extends$k({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$c || (_path$c = /*#__PURE__*/createElement("path", {
    d: "M14.8988 10.1625C16.0519 9.83625 18.0956 9.87937 18.6938 9.9225C19.74 9.9975 20.7863 9.975 20.9663 11.2444C21.0863 12.0994 20.7994 12.8775 19.5319 13.0162C19.0856 13.065 18.54 13.0912 18.09 13.1625L17.7375 13.5506C18.1538 13.4944 19.1081 13.5131 19.395 13.4775C20.6063 13.3294 21.63 13.815 21.7838 14.9794C21.9188 15.9994 21.15 16.7869 20.0588 16.7269C19.6856 16.7062 18.6319 16.8506 17.5856 16.8787L17.505 17.0906L17.4675 17.1544C18.1313 17.1731 18.7669 17.1994 19.2188 17.2219C20.4281 17.2819 21.0881 17.9306 21.0713 18.7931C21.0506 19.8412 20.07 20.235 19.3688 20.2931C18.8438 20.3362 16.965 20.2819 15.7031 20.1787L15.5044 20.5181C15.5944 20.52 18.0113 20.6362 18.1031 20.6419C19.2113 20.7244 19.6838 21.1256 19.6556 21.9169C19.6163 23.0269 18.4313 23.3212 17.79 23.4225C16.7494 23.5875 15.3619 23.5387 14.3513 23.5669C12.165 23.6269 7.69127 23.7244 5.60252 21.8944C4.89002 21.27 4.17189 20.4206 3.56064 20.1769C2.28002 19.6669 2.16939 17.9981 2.22752 15.8887C2.25564 14.8687 1.90502 12.0056 3.14252 11.3119C4.87877 10.3387 7.82252 9.60375 8.80127 8.835C10.4063 7.57312 11.3438 5.52 11.7713 4.31812C12.585 2.02875 12.8325 0.375 14.2556 0.375C16.7494 0.375 16.6838 2.6025 16.7306 3.71625C16.8225 5.89687 14.1319 9.93187 14.8988 10.1625Z",
    fill: "#FAC036"
  })), _path2$5 || (_path2$5 = /*#__PURE__*/createElement("path", {
    d: "M12.7538 15.1761C12.7782 16.2992 13.6445 16.7811 13.6838 16.8017C13.187 16.7904 12.1107 17.2948 12.1107 18.3654C12.1107 19.2486 12.5907 19.9367 13.0726 20.1711C12.7557 20.2386 12.1576 20.6698 12.1576 21.6111C12.1576 22.9911 13.1813 23.4955 13.9557 23.5911C14.7301 23.6867 16.8826 23.5573 17.5932 23.4486C17.9738 23.3904 15.707 23.3642 14.0476 23.1467C13.5713 23.0848 13.0032 22.6367 12.9113 22.033C12.9113 22.033 12.7763 21.2361 13.5038 20.7767C13.5038 20.7767 13.8113 20.5123 15.2382 20.5236L15.6695 20.5292C15.8045 20.5386 17.5276 20.5986 18.1013 20.6398C18.3545 20.6586 18.572 20.6942 18.7595 20.7467C18.7295 20.7036 18.6957 20.6323 18.707 20.5292C18.7313 20.3117 18.8738 20.3023 18.9113 20.3023L18.5701 20.2836L17.3551 20.2142C16.1438 20.1411 14.4376 20.0248 14.2407 19.9461C14.2407 19.9461 13.052 19.6461 13.052 18.4273C13.052 18.4273 12.9901 17.3904 14.5763 17.3417C14.5763 17.3417 18.3245 17.1261 19.9107 17.3361C19.9107 17.3361 19.6838 16.9142 20.0588 16.7248C20.0588 16.7248 17.3832 16.7904 15.707 16.8354C14.0307 16.8804 13.6726 15.9898 13.6295 15.5042C13.6238 15.4311 13.6088 15.3148 13.6088 15.1779C13.6088 14.2123 14.4563 14.0848 15.6695 13.9273C18.287 13.5842 19.3951 13.4773 19.3951 13.4773C19.5395 13.4604 19.6763 13.4511 19.8095 13.4529C19.7363 13.4117 19.637 13.3348 19.6238 13.2073C19.6163 13.1248 19.6576 12.9992 19.6576 12.9992C19.6576 12.9992 18.5288 13.0911 16.787 13.3236C15.047 13.5561 13.6557 13.4492 13.5301 12.4311C13.4382 11.6848 13.5638 11.2104 13.8863 10.8411C14.2838 10.3854 14.9232 10.1586 14.9232 10.1586C14.9232 10.1586 14.8501 10.1436 14.8088 10.0892C14.7676 10.0329 14.7657 9.94482 14.7657 9.94482C13.3463 10.1248 12.3751 11.0267 12.4557 12.1854C12.512 12.9786 12.722 13.5073 13.2488 13.7642C13.2507 13.7623 12.7295 14.0548 12.7538 15.1761Z",
    fill: "#E48C15"
  })), _path3$3 || (_path3$3 = /*#__PURE__*/createElement("path", {
    d: "M13.3333 12.6602L12.7108 12.8402C12.7108 12.8402 13.6333 16.2358 10.2283 18.5758C10.2283 18.5758 9.79143 18.8683 10.0033 19.0877C10.0033 19.0877 10.1514 19.3427 10.7777 18.8645C10.7777 18.8627 14.1002 16.6952 13.3333 12.6602Z",
    fill: "#E48C15"
  })));
};

function getUserNoteStatus(note, total) {
  var status = 'needs-reinforcement';
  if (note == 0) status = 'incorrect';
  if (note >= 5) status = 'needs-ampliacion';
  if (note >= 7) status = 'good-progress';
  if (note == total) status = 'correct';
  return status;
}
var AssessmentGradeTag = function AssessmentGradeTag(_ref) {
  var _ref$grade = _ref.grade,
    grade = _ref$grade === void 0 ? '1' : _ref$grade,
    _ref$gradeTotal = _ref.gradeTotal,
    gradeTotal = _ref$gradeTotal === void 0 ? '10' : _ref$gradeTotal,
    _ref$isTimedOut = _ref.isTimedOut,
    isTimedOut = _ref$isTimedOut === void 0 ? false : _ref$isTimedOut,
    _ref$isPending = _ref.isPending,
    isPending = _ref$isPending === void 0 ? false : _ref$isPending,
    t = _ref.t;
  var ICONS = {
    'needs-reinforcement': {
      icon: /*#__PURE__*/React__default.createElement(SvgAstonished, null)
    },
    'needs-ampliacion': {
      icon: /*#__PURE__*/React__default.createElement(SvgThumbsUp, null)
    },
    'good-progress': {
      icon: /*#__PURE__*/React__default.createElement(SvgMaster, null)
    },
    'timed-out': {
      icon: /*#__PURE__*/React__default.createElement(SvgClock, null)
    },
    correct: {
      icon: /*#__PURE__*/React__default.createElement(SvgCorrect, null)
    },
    incorrect: {
      icon: /*#__PURE__*/React__default.createElement(SvgFail, null)
    }
  };
  var status = isTimedOut || isPending ? 'timed-out' : getUserNoteStatus(grade, gradeTotal);
  var isGradeText = grade == gradeTotal || grade == '0'; // cuando mostrar correcto e incorrecto
  return /*#__PURE__*/React__default.createElement("div", {
    className: "assessment-grade-tag assessment-grade-tag--" + status
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'assessment-grade-tag__grade-container'
  }, isTimedOut ? /*#__PURE__*/React__default.createElement("span", {
    className: "assessment-grade-tag__grade"
  }, t('Timed out')) : isPending ? /*#__PURE__*/React__default.createElement("span", {
    className: "assessment-grade-tag__grade"
  }, t('lms_waiting_correction')) : isGradeText ? /*#__PURE__*/React__default.createElement("span", {
    className: "assessment-grade-tag__grade assessment-grade-tag__grade-text"
  }, t(grade === gradeTotal ? 'correct' : 'incorrect')) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
    className: "assessment-grade-tag__grade"
  }, grade || 0), /*#__PURE__*/React__default.createElement("span", {
    className: 'assessment-grade-tag__grade-total'
  }, "/", gradeTotal))), /*#__PURE__*/React__default.createElement("div", {
    className: 'assessment-grade-tag__icon'
  }, ICONS[status].icon));
};

function CustomControls(_ref) {
  var _ref$disable = _ref.disable,
    disable = _ref$disable === void 0 ? true : _ref$disable,
    _ref$sendButtonText = _ref.sendButtonText,
    sendButtonText = _ref$sendButtonText === void 0 ? 'Send' : _ref$sendButtonText,
    onSend = _ref.onSend,
    _ref$hintButtonText = _ref.hintButtonText,
    hintButtonText = _ref$hintButtonText === void 0 ? 'Hint' : _ref$hintButtonText,
    onHint = _ref.onHint,
    _ref$showButtonHint = _ref.showButtonHint,
    showButtonHint = _ref$showButtonHint === void 0 ? false : _ref$showButtonHint,
    _ref$disabledButtonHi = _ref.disabledButtonHint,
    disabledButtonHint = _ref$disabledButtonHi === void 0 ? false : _ref$disabledButtonHi,
    renderScore = _ref.renderScore,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'lemo-send-controls'
  }, children, /*#__PURE__*/React__default.createElement("div", {
    className: 'lemo-controls-wrapper'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'lemo-controls-left'
  }, (renderScore == null ? void 0 : renderScore()) && /*#__PURE__*/React__default.createElement("span", {
    className: 'lemo-points'
  }, renderScore && renderScore()), showButtonHint && /*#__PURE__*/React__default.createElement("button", {
    type: 'button',
    className: 'lemo-simple-button lemo-base-button lemo-text-body-m-bold lemo-simple-button--secondary lemo-base-button--secondary lemo-controls-button-show-hint',
    onClick: onHint,
    disabled: disabledButtonHint
  }, /*#__PURE__*/React__default.createElement("svg", {
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 32 32',
    className: 'lemo-icon'
  }, /*#__PURE__*/React__default.createElement("path", {
    d: 'M17.6 4.8a1.6 1.6 0 0 0-3.2 0v1.6a1.6 1.6 0 1 0 3.2 0zm7.45 4.412a1.6 1.6 0 0 0-2.262-2.263L21.657 8.08a1.6 1.6 0 0 0 2.262 2.263l1.132-1.131zM28.8 16a1.6 1.6 0 0 1-1.6 1.6h-1.6a1.6 1.6 0 0 1 0-3.2h1.6a1.6 1.6 0 0 1 1.6 1.6M8.08 10.343a1.6 1.6 0 1 0 2.263-2.263L9.212 6.95a1.6 1.6 0 1 0-2.263 2.263l1.131 1.131zM8 16a1.6 1.6 0 0 1-1.6 1.6H4.8a1.6 1.6 0 0 1 0-3.2h1.6A1.6 1.6 0 0 1 8 16m4.8 9.6V24h6.4v1.6a3.2 3.2 0 1 1-6.4 0m6.401-3.2c.024-.545.331-1.034.762-1.374a6.4 6.4 0 1 0-7.926 0c.43.34.738.83.762 1.374H19.2z'
  })), hintButtonText)), /*#__PURE__*/React__default.createElement("div", {
    className: 'lemo-controls-right'
  }, /*#__PURE__*/React__default.createElement("button", {
    type: 'button',
    className: 'lemo-simple-button lemo-base-button lemo-simple-button--primary lemo-base-button--primary lemo-controls-button-send',
    disabled: disable,
    onClick: onSend
  }, sendButtonText))));
}

// Templates que hacen subida de archivos haciendo uso de assetsQuestionApi
var TEMPLATES_UPLOAD_FILES = [types.other.UploadFile, types.other.AudioRecorder];
var isDebug = process.env.NODE_ENV === 'development';
function LemonadeQuestion(_ref) {
  var _item$items$2, _questionApi$output2, _questionApi$hints4, _questionApi$hints5, _questionApi$hints6;
  var item = _ref.item,
    response = _ref.response,
    onResponse = _ref.onResponse,
    onBeforeSend = _ref.onBeforeSend,
    onXAPIComplete = _ref.onXAPIComplete,
    _ref$manualScore = _ref.manualScore,
    manualScore = _ref$manualScore === void 0 ? null : _ref$manualScore,
    _ref$isPending = _ref.isPending,
    isPending = _ref$isPending === void 0 ? false : _ref$isPending,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? roleTypes.STUDENT : _ref$role,
    _ref$fileApi = _ref.fileApi,
    fileApi = _ref$fileApi === void 0 ? '' : _ref$fileApi,
    onReady = _ref.onReady,
    lessonId = _ref.lessonId,
    _ref$repeatEnabled = _ref.repeatEnabled,
    repeatEnabled = _ref$repeatEnabled === void 0 ? true : _ref$repeatEnabled,
    _ref$hideWaitingRespo = _ref.hideWaitingResponseOffline,
    hideWaitingResponseOffline = _ref$hideWaitingRespo === void 0 ? true : _ref$hideWaitingRespo;
  var _useGeneral = useGeneral(),
    lang = _useGeneral.lang,
    pathAssets = _useGeneral.pathAssets,
    googleApi = _useGeneral.googleApi,
    mathRenderEngine = _useGeneral.mathRenderEngine,
    t = _useGeneral.t;
  var _useOnline = useOnline(),
    online = _useOnline.online;
  useItemBlockComponent({
    numComponentsTextHtml: undefined,
    onReady: onReady,
    item: item
  }); // == numComponentsTextHtml es undefined porque no se usa el componente getTextHtml
  setConfig({
    mathRenderEngine: mathRenderEngine,
    showSampleAnswer: true,
    googlePicker: googleApi,
    inputMathFloating: false
  });
  var _useState = useState(manualScore),
    score = _useState[0],
    setScore = _useState[1]; // si la puntuación nos viene desde el host lo respetamos
  var _useState2 = useState(isPending),
    isSent = _useState2[0],
    setIsSent = _useState2[1]; // estado particular para ejercicios manuales
  var isReset = false;
  var data = item && item.items && item.items.length > 0 ? prepareLemonadeData(item.items[0], item.items[0].data.content_guid).data : null;
  var _useLemonadeQuestion = useLemonadeQuestion({
      data: data,
      assetsQuestionApi: fileApi,
      lang: lang,
      basePath: pathAssets
    }),
    _useLemonadeQuestion$ = _useLemonadeQuestion.exercise,
    Controls = _useLemonadeQuestion$.Controls,
    Question = _useLemonadeQuestion$.Question,
    Feedback = _useLemonadeQuestion$.Feedback,
    questionApi = _useLemonadeQuestion$.questionApi,
    SampleAnswer = _useLemonadeQuestion$.SampleAnswer;
  var scormControls = useScormControls(data == null ? void 0 : data.reference, lessonId, data == null ? void 0 : data.type);
  useEffect(function () {
    window.lemonadeApi = questionApi;
    if (response) questionApi.checkAnswers();
  }, [questionApi, response]);
  useEffect(function () {
    // updateExercise({ data });
    /* Ejemplo de sobreescribir cadenas */
    if (lang === 'pt') {
      getConfig().overwriteTranslations({
        button_validate: 'Enviar',
        richText_placeholder: 'Escreva sua resposta aqui'
      });
    }
  }, [item]);
  function consoleLemonade(first, second) {
    isDebug && console.log(first, second);
  }
  var handleChange = useCallback(function (output) {
    return consoleLemonade('changed: ', output.store.getUserResponse());
  }, []);
  var onImmediateSuccess = useCallback(function (_item) {
    return consoleLemonade('onImmediateSuccess: ', _item);
  }, []);
  var onImmediateError = useCallback(function (_item) {
    return consoleLemonade('onImmediateError: ', _item);
  }, []);
  var onComplete = useCallback(function () {
    return consoleLemonade('complete!');
  }, []);
  // Cuando se pulsa en validar el ejercicio
  var handleValidate = useCallback(function (_data) {
    if (_data != null && _data.response && _data.output && onResponse) {
      onResponse(item, _data.response[_data.output.reference], isReset);
    }
  }, [item]);
  // Cuando se pulsa en Send de un ejercicio con corrección manual
  var handleSend = useCallback(function (_response) {
    setIsSent(true);
    consoleLemonade('handleSend ', _response);
    var finalResponse = _response[data == null ? void 0 : data.reference] || _response;
    // Si es un template de subida de archivos debemos obviar e ir por handleUploadComplete, que es cuando se termina de subir
    if (TEMPLATES_UPLOAD_FILES.indexOf(finalResponse == null ? void 0 : finalResponse.type) > -1) {
      consoleLemonade('handleSend return, template de subida archivos, esperar a handleUploadComplete', _response);
      return;
    }
    if (_response && onResponse) onResponse(item, finalResponse, isReset);
  }, [item]);
  var handleXAPIComplete = useCallback(function (data) {
    consoleLemonade('handleXAPIComplete', data);
    if (onXAPIComplete) onXAPIComplete(item, data, questionApi);
  }, [onXAPIComplete]);
  // cuando se pulsa el botón de send en Upload File y Audio Recorder
  var handleOnBeforeSend = function handleOnBeforeSend(next) {
    consoleLemonade('handleOnBeforeSend');
    onBeforeSend ? onBeforeSend(item, questionApi, next) : next(); // item?.items?.[0].data?.content_guid
  };

  var handleReset = useCallback(function (_response) {
    consoleLemonade('ON RESET CALLBACK');
    isReset = true;
    setScore(null);
  }, [item]);
  var handleChangeStatus = useCallback(function (_data) {
    consoleLemonade('handleChangeStatus');
    consoleLemonade(_data);
  }, []);
  var handleUploadComplete = useCallback(function (_response) {
    consoleLemonade('handleUploadComplete', _response);
    if (!response && _response && onResponse) onResponse(item, _response[data == null ? void 0 : data.reference] || _response, isReset);
  }, [item]);
  var onKeyboardVisible = useCallback(function (_data) {
    consoleLemonade('onKeyboardVisible');
    consoleLemonade(_data);
    if (_data) {
      document.body.classList.add('block-scroll');
    } else {
      document.body.classList.remove('block-scroll');
    }
  }, []);
  var hasIndex = useMemo(function () {
    var _item$items$;
    return hasData((_item$items$ = item.items[0]) == null ? void 0 : _item$items$.number);
  }, [(_item$items$2 = item.items[0]) == null ? void 0 : _item$items$2.number]);
  var isManual = useMemo(function () {
    var _questionApi$output;
    return (questionApi == null || (_questionApi$output = questionApi.output) == null || (_questionApi$output = _questionApi$output.data) == null || (_questionApi$output = _questionApi$output.validation) == null ? void 0 : _questionApi$output.scoring_type) === 'manual';
  }, [questionApi == null || (_questionApi$output2 = questionApi.output) == null || (_questionApi$output2 = _questionApi$output2.data) == null || (_questionApi$output2 = _questionApi$output2.validation) == null ? void 0 : _questionApi$output2.scoring_type]);
  var isAutoevaluative = isAutoevaluativeFn(getMetadataName());
  function getMetadataName() {
    var _questionApi$output3, _questionApi$output4;
    return (questionApi == null || (_questionApi$output3 = questionApi.output) == null || (_questionApi$output3 = _questionApi$output3.data) == null || (_questionApi$output3 = _questionApi$output3.metadata) == null ? void 0 : _questionApi$output3.name) || (questionApi == null || (_questionApi$output4 = questionApi.output) == null || (_questionApi$output4 = _questionApi$output4.metadata) == null ? void 0 : _questionApi$output4.name);
  }
  function isAutoevaluativeFn(metadataName) {
    return ![types.essay.PlainText, types.essay.ShortText, types.essay.RichText, types.other.UploadFile, types.other.Pencil, types.other.Statement, types.other.AudioRecorder, types.other.Rating, types.other.AdaptativeChoice].includes(metadataName);
  }
  var sendManualActivity = function sendManualActivity() {
    var response = questionApi.getResponse();
    questionApi.setDisabled(true);
    handleSend(response);
    consoleLemonade('sendManualActivity', response);
  };
  var onHint = function onHint() {
    var _questionApi$hints;
    if (questionApi != null && (_questionApi$hints = questionApi.hints) != null && _questionApi$hints.isVisible) {
      var _questionApi$hints2;
      questionApi == null || (_questionApi$hints2 = questionApi.hints) == null || _questionApi$hints2.hideHint();
    } else {
      var _questionApi$hints3;
      questionApi == null || (_questionApi$hints3 = questionApi.hints) == null || _questionApi$hints3.showHint();
    }
  };
  function renderScoreManual() {
    return score !== null && renderScore(score / 10);
  }
  function renderScore(points) {
    return (points !== undefined && points !== null || isSent) && /*#__PURE__*/React__default.createElement("div", {
      className: 'lemonade-exercises__score'
    }, isSent && (hideWaitingResponseOffline ? !online : false) ?
    /*#__PURE__*/
    // == No mostrar esperando respuesta si no hay conexión en caso de flag hideWaitingResponseOffline este activado
    React__default.createElement("span", null) : isFeedbackQuestionType(item == null ? void 0 : item.variant) ? /*#__PURE__*/React__default.createElement("span", null) : /*#__PURE__*/React__default.createElement(AssessmentGradeTag, {
      grade: "" + Math.round((points || 0) * 10),
      gradeTotal: '10',
      isPending: isSent,
      t: t
    }));
  }
  function isDisabledCustomControls() {
    var metadataName = getMetadataName();
    // Si es un ejercicio de emociones, se debe deshabilitar el botón de enviar si no hay respuesta
    // Hago la logica desde aqui porque para EmotionsSingle se pinta esta botonera personalizada, pero no puedo jugar con el atributo por defecto de questionApi?.disabled porque como la ponga a disabled desde lemonade se me van a desactivar los botones de las opciones, ya que interfanmente esta plantilla es como el SingleChoice y tiene ese comportamiento.
    if (metadataName === types.multipleChoice.EmotionsSingle) {
      var _questionApi$getUserR;
      return (questionApi == null || (_questionApi$getUserR = questionApi.getUserResponse()) == null ? void 0 : _questionApi$getUserR.length) === 0 || (questionApi == null ? void 0 : questionApi.disabled);
    }
    return questionApi == null ? void 0 : questionApi.disabled;
  }
  return /*#__PURE__*/React__default.createElement(Lemonade, {
    className: 'lemonade-exercises-question ' + CLASS_NO_SELECT + (hasIndex ? ' lemonade-exercises--bullet' : '') + (questionApi != null && (_questionApi$hints4 = questionApi.hints) != null && _questionApi$hints4.hasHints ? ' lemonade-exercises--has-hint' : '') + ' lemonade-exercises--lms'
  }, /*#__PURE__*/React__default.createElement("div", null, hasIndex && /*#__PURE__*/React__default.createElement("span", {
    className: 'lemonade-exercises-question__number brand--background-second'
  }, item.items[0].number), /*#__PURE__*/React__default.createElement(Question, {
    response: response,
    changed: handleChange,
    onImmediateSuccess: onImmediateSuccess,
    onImmediateError: onImmediateError,
    onComplete: onComplete,
    onChangeStatus: handleChangeStatus,
    onUploadComplete: handleUploadComplete,
    immediateFeedback: false,
    onKeyboardVisible: onKeyboardVisible,
    scormControls: scormControls,
    xAPI_onComplete: handleXAPIComplete
  }), isManual && isAutoevaluative ? /*#__PURE__*/React__default.createElement(CustomControls, {
    disable: isDisabledCustomControls(),
    sendButtonText: t('send'),
    onSend: sendManualActivity,
    renderScore: score === null ? renderScore : renderScoreManual,
    showButtonHint: questionApi == null || (_questionApi$hints5 = questionApi.hints) == null ? void 0 : _questionApi$hints5.hasHints,
    disabledButtonHint: questionApi == null || (_questionApi$hints6 = questionApi.hints) == null ? void 0 : _questionApi$hints6.isVisible,
    hintButtonText: t('button_show_hints'),
    onHint: onHint
  }, SampleAnswer && /*#__PURE__*/React__default.createElement(SampleAnswer, {
    isVisible: role !== roleTypes.STUDENT
  })) : /*#__PURE__*/React__default.createElement(Controls, {
    showPoints: true,
    showCheckAnswer: true,
    showReset: repeatEnabled,
    showEdit: false,
    showRepeat: false,
    showSolution: role !== roleTypes.STUDENT,
    onValidate: handleValidate,
    renderScore: score === null ? renderScore : renderScoreManual,
    onSend: handleSend,
    onBeforeSend: handleOnBeforeSend,
    onChangeStatus: handleChangeStatus,
    onReset: handleReset
  }, /*#__PURE__*/React__default.createElement(Feedback, null), SampleAnswer && /*#__PURE__*/React__default.createElement(SampleAnswer, {
    isVisible: role !== roleTypes.STUDENT
  }))));
}
var LemonadeQuestion$1 = /*#__PURE__*/observer(LemonadeQuestion);

var ITypeFroalaToolbar;
(function (ITypeFroalaToolbar) {
  ITypeFroalaToolbar["MODE_ADVANCED"] = "advanced";
  ITypeFroalaToolbar["MODE_MEDIUM"] = "medium";
  ITypeFroalaToolbar["MODE_SIMPLE"] = "simple";
})(ITypeFroalaToolbar || (ITypeFroalaToolbar = {}));

/**
 * Funciones de utilidad del Editor del Froala
 * Estas funciones como norma general van a recibir el parametro editor
 */
function focusEnd(editor) {
  if (editor && editor.$el) {
    // == Time out lo pongo para que funcione en la versión 3.0.6 del froala
    setTimeout(function () {
      if (editor.selection) {
        editor.selection.setAtEnd(editor.$el.get(0));
        editor.selection.restore();
      }
    }, 300);
  }
}
/**
 * Devuelve si el editor está vacio
 * @param {object} editor
 * @returns Devuevle si el editor esta vacio y false en otro caso
 */
function isEmptyEditor(editor) {
  if (editor && editor.core) {
    return editor.core.isEmpty();
  }
  return false;
}
function getFroalaToolbar(type, isMath, isUpload, ismintTooltip) {
  if (type === void 0) {
    type = ITypeFroalaToolbar.MODE_MEDIUM;
  }
  if (isMath === void 0) {
    isMath = false;
  }
  if (isUpload === void 0) {
    isUpload = false;
  }
  if (ismintTooltip === void 0) {
    ismintTooltip = false;
  }
  if (type === ITypeFroalaToolbar.MODE_SIMPLE) {
    // modo simple
    return ['bold', 'italic', 'underline'];
  } else if (type === ITypeFroalaToolbar.MODE_ADVANCED) {
    // role editor
    return {
      moreText: {
        buttons: ['bold', 'italic', 'subscript', 'superscript', 'fontSize', 'textColor', 'clearFormatting', 'underline', 'strikeThrough', 'backgroundColor'].filter(Boolean),
        buttonsVisible: 7
      },
      moreRich: {
        buttons: [ismintTooltip && 'mintTooltip', isMath && 'mathButtonV3', 'insertLink', isUpload && 'insertImage', isUpload && 'insertVideo'],
        align: 'right',
        buttonsVisible: 1
      },
      moreParagraph: {
        buttons: ['numGroup', 'formatOL', 'formatUL', 'outdent', 'indent', 'alignCenter', 'alignLeft', 'alignRight', 'alignJustify'],
        buttonsVisible: 6
      },
      moreMisc: {
        buttons: ['html'],
        align: 'right',
        buttonsVisible: 3
      }
    };
  } else {
    // role teacher
    return {
      moreText: {
        buttons: ['bold', 'italic', 'underline', 'subscript', 'superscript', 'fontSize', 'textColor', 'strikeThrough', 'backgroundColor', isMath ? 'mathButtonV3' : '', ismintTooltip ? 'mintTooltip' : ''],
        buttonsVisible: 7
      },
      moreRich: {
        buttons: ['insertLink', isUpload && 'insertImage', isUpload && 'insertVideo', 'insertTable'],
        align: 'right',
        buttonsVisible: 2
      },
      moreParagraph: {
        buttons: ['numGroup', 'formatOL', 'formatUL', 'outdent', 'indent', 'alignLeft', 'alignCenter', 'alignRight', 'alignJustify'],
        buttonsVisible: 5
      },
      moreMisc: {
        buttons: ['undo', 'redo', 'html'],
        align: 'right',
        buttonsVisible: 3
      }
    };
  }
}

function useKeydownList(props) {
  var item = props.item,
    items = props.items,
    onChangeItem = props.onChangeItem,
    onDeleteItem = props.onDeleteItem;
  var _useGeneral = useGeneral(),
    pathAssets = _useGeneral.pathAssets,
    folderBlockDefault = _useGeneral.folderBlockDefault;
  var _useState = useState(null),
    idFocusPending = _useState[0],
    setIdFocusPending = _useState[1];
  var _useState2 = useState(null),
    pendingDeleteItem = _useState2[0],
    setPendingDeleteItem = _useState2[1];
  var editorsRef = useRef([]);
  var itemPropRef = useRef(item);
  itemPropRef.current = item;
  useEffect(function () {
    editorsRef.current = editorsRef.current.slice(0, items.length);
    if (pendingDeleteItem) {
      setPendingDeleteItem(null);
      onDeleteItem(item);
    }
  }, [items, pendingDeleteItem]);
  /**
   *  Como la funcion onEnterDown está siendo invocada desde dentro de un timeout en FroalaEditor entonces
   *  para poder tener valores actualizados de item una de las formas es cuando nos haga falta un valor actualizado
   *  como para mi caso es el item tengo que guardarlo primero su valor actualizado con useRef que es mi constante itemRef
   *  Si en lugar de usar esa referencia directamente accedo a item tendré el valor inicial de item que está desactualizado.
   *
   *  Otra opcion:
   *  ------------
   *  const [flagOnEnter, setFlagOnEnter] = useState(uuid());
   *
   *  useEffect(() => {
   *     console.log(item) // == Aqui ya tendria el valor de item actualizado
   *   }, [flagOnEnter]);
   *
   *  function onEnterDown(index){
   *     setFlagOnEnter(flagOnEnter => uuid());
   *  }
   *
   *  Documentacion:
   *  -------------
   *  - https://github.com/facebook/react/issues/14010
   *  - https://stackoverflow.com/questions/55198517/react-usestate-why-settimeout-function-does-not-have-latest-state-value
   *  - https://stackoverflow.com/questions/61320212/how-to-use-settimeout-along-with-react-hooks-useeffect-and-setstate
   *  - https://stackoverflow.com/questions/51026090/settimeout-in-react-setstate
   */
  function onEnterDown(index) {
    if (onChangeItem && itemPropRef && itemPropRef.current) {
      var newIndex = index + 1;
      var itemUpdated = getItemUpdatedPushIndexFirstSubitem(itemPropRef.current, newIndex, pathAssets, folderBlockDefault);
      var subItemInserted = itemUpdated.items && itemUpdated.items.length > 0 && newIndex < itemUpdated.items.length ? itemUpdated.items[newIndex] : null;
      if (subItemInserted && subItemInserted.id) {
        setIdFocusPending(getKey(subItemInserted.id, newIndex));
      }
      onChangeItem(itemUpdated);
    }
  }
  function onBackAndEmpty(index) {
    if (onChangeItem && itemPropRef && itemPropRef.current) {
      var itemUpdated = getItemUpdatedRemoveSubitemIndex(itemPropRef.current, index);
      if (itemUpdated && itemUpdated.items && itemUpdated.items.length === 0) {
        // == Ya no me hedan items, elimino el componente
        // == Como tambien va a recibir una actualizacion de textUpdate el froala, hago esta eliminacion en el useEffect de cuando los items han cambiado
        setPendingDeleteItem(new Date().getTime()); // == Marco como pendiente de eliminar
      } else {
        // == Si aun tengo items notifico de como queda y pongo el foco en el anterior
        var previousIndex = index >= 1 ? index - 1 : 0;
        var subItemPrevious = itemUpdated.items && itemUpdated.items.length > 0 && previousIndex < itemUpdated.items.length ? itemUpdated.items[previousIndex] : null;
        onChangeItem(itemUpdated);
        if (subItemPrevious && subItemPrevious.id) {
          focusEnd(editorsRef.current[previousIndex]);
        }
      }
    }
  }
  /**
   *
   * @param editor Editor de froala, aqui esta bien el tipo any porque no lo tenemos tipado
   * @param editorId
   * @param index
   */
  function onInitialized(editor, editorId, index) {
    editorsRef.current[index] = editor;
    if (idFocusPending && editorId === idFocusPending) {
      focusEnd(editor);
    }
  }
  function getKey(itemId, index) {
    return itemId + "__" + index;
  }
  return {
    getKey: getKey,
    onEnterDown: onEnterDown,
    onBackAndEmpty: onBackAndEmpty,
    onInitialized: onInitialized
  };
}

function useBulleted(props) {
  var item = props.item,
    mode = props.mode,
    onChangeItem = props.onChangeItem,
    onDeleteItem = props.onDeleteItem;
  var items = item && item.items ? item.items : [];
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useKeydownList = useKeydownList({
      item: item,
      items: items,
      onChangeItem: onChangeItem,
      onDeleteItem: onDeleteItem
    }),
    getKey = _useKeydownList.getKey,
    onEnterDown = _useKeydownList.onEnterDown,
    onBackAndEmpty = _useKeydownList.onBackAndEmpty,
    onInitialized = _useKeydownList.onInitialized;
  return {
    t: t,
    modeTextHtml: isModeEditTextHtml(mode) ? IModesTextHtml.MODE_TEXT_HTML_EDITOR : IModesTextHtml.MODE_TEXT_HTML_VISOR,
    getKey: getKey,
    onEnterDown: onEnterDown,
    onBackAndEmpty: onBackAndEmpty,
    onInitialized: onInitialized
  };
}

var Bulleted = function Bulleted(_ref) {
  var item = _ref.item,
    getTextHtml = _ref.getTextHtml,
    paragraphUpdatedIndex = _ref.paragraphUpdatedIndex,
    mode = _ref.mode,
    onChangeItem = _ref.onChangeItem,
    onDeleteItem = _ref.onDeleteItem,
    onReady = _ref.onReady;
  var _useBulleted = useBulleted({
      item: item,
      mode: mode,
      onChangeItem: onChangeItem,
      onDeleteItem: onDeleteItem
    }),
    modeTextHtml = _useBulleted.modeTextHtml,
    getKey = _useBulleted.getKey,
    onEnterDown = _useBulleted.onEnterDown,
    onBackAndEmpty = _useBulleted.onBackAndEmpty,
    onInitialized = _useBulleted.onInitialized;
  var _useItemBlockComponen = useItemBlockComponent({
      numComponentsTextHtml: item == null ? void 0 : item.items.length,
      onReady: onReady,
      item: item
    }),
    onReadyGetTextHtml = _useItemBlockComponen.onReadyGetTextHtml;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'list-bullets'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'list-bullets__list-container ' + CLASS_CONTENT_LEFT
  }, item && item.items && item.items.map(function (subItem, index) {
    var key = getKey(subItem.id, index);
    return /*#__PURE__*/React__default.createElement("div", {
      className: 'list-bullets__list-item brand--before-background',
      key: subItem.id
    }, /*#__PURE__*/React__default.createElement("div", {
      className: 'list-bullets__content brand--link'
    }, getTextHtml(subItem.paragraph || '', function (text) {
      return paragraphUpdatedIndex && paragraphUpdatedIndex(text, index);
    }, subItem.id, modeTextHtml, undefined, function () {
      return onEnterDown(index);
    }, function () {
      return onBackAndEmpty(index);
    }, function (editor) {
      return onInitialized(editor, key, index);
    }, undefined, onReadyGetTextHtml)));
  })));
};

var NumberedListItem = function NumberedListItem(_ref) {
  var subItem = _ref.subItem,
    index = _ref.index,
    modeTextHtml = _ref.modeTextHtml,
    getTextHtml = _ref.getTextHtml,
    paragraphUpdated = _ref.paragraphUpdated,
    keyItem = _ref.keyItem,
    onEnterDown = _ref.onEnterDown,
    onBackAndEmpty = _ref.onBackAndEmpty,
    onInitialized = _ref.onInitialized,
    _ref$numberLabel = _ref.numberLabel,
    numberLabel = _ref$numberLabel === void 0 ? index + 1 + '' : _ref$numberLabel,
    onReadyGetTextHtml = _ref.onReadyGetTextHtml;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'list-numered__list-item',
    key: keyItem
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'list-numered__ball '
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'list-numered__number brand--background'
  }, subItem.number ? subItem.number : numberLabel)), /*#__PURE__*/React__default.createElement("div", {
    className: 'list-numered__content'
  }, getTextHtml(subItem.paragraph || '', function (text) {
    return paragraphUpdated && paragraphUpdated(text);
  }, subItem.id, modeTextHtml, undefined, function () {
    return onEnterDown(index);
  }, function () {
    return onBackAndEmpty(index);
  }, function (editor) {
    return onInitialized(editor, keyItem, index);
  }, undefined, onReadyGetTextHtml)));
};
/*
onEnterDown={()=> onEnterDown(index)}
onBackAndEmpty={()=> onBackAndEmpty(index)}
onInitialized={(editor)=> onInitialized(editor, keyItem , index)} */
NumberedListItem.propTypes = {
  /** Numero o letra que se muestra dentro del circulo */
  numberLabel: PropTypes.string
};
NumberedListItem.defaultProps = {};

function getNumbersLabelCalculate(items) {
  var numbersLabeltoRet = [];
  items.forEach(function (item, index) {
    var numberActual = hasData(item.number) ? item.number + '' : null;
    var previewNumber = numbersLabeltoRet && index - 1 >= 0 && index - 1 < numbersLabeltoRet.length && isNumeric(numbersLabeltoRet[index - 1]) ? parseInt(numbersLabeltoRet[index - 1]) : null;
    var numberToRet = index + 1 + '';
    if (numberActual) {
      numberToRet = numberActual;
    } else if (previewNumber) {
      numberToRet = previewNumber + 1 + '';
    }
    numbersLabeltoRet.push(numberToRet);
  });
  return numbersLabeltoRet;
}
function getNumerLabel(numbersLabel, index) {
  var numberLabel = numbersLabel && index + 1 <= numbersLabel.length ? numbersLabel[index] : index + 1 + '';
  return numberLabel;
}

function useNumered(props) {
  var item = props.item,
    mode = props.mode,
    onChangeItem = props.onChangeItem,
    onDeleteItem = props.onDeleteItem;
  var items = item && item.items ? item.items : [];
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useKeydownList = useKeydownList({
      item: item,
      items: item.items,
      onChangeItem: onChangeItem,
      onDeleteItem: onDeleteItem
    }),
    getKey = _useKeydownList.getKey,
    onEnterDown = _useKeydownList.onEnterDown,
    onBackAndEmpty = _useKeydownList.onBackAndEmpty,
    onInitialized = _useKeydownList.onInitialized;
  var _useState = useState([]),
    numbersLabel = _useState[0],
    setNumbersLabel = _useState[1];
  useEffect(function () {
    setNumbersLabel(getNumbersLabelCalculate(items));
  }, [JSON.stringify(items)]);
  return {
    t: t,
    modeTextHtml: isModeEditTextHtml(mode) ? IModesTextHtml.MODE_TEXT_HTML_EDITOR : IModesTextHtml.MODE_TEXT_HTML_VISOR,
    getKey: getKey,
    onEnterDown: onEnterDown,
    onBackAndEmpty: onBackAndEmpty,
    onInitialized: onInitialized,
    numbersLabel: numbersLabel
  };
}

var Numered = function Numered(_ref) {
  var item = _ref.item,
    getTextHtml = _ref.getTextHtml,
    paragraphUpdatedIndex = _ref.paragraphUpdatedIndex,
    mode = _ref.mode,
    onChangeItem = _ref.onChangeItem,
    onDeleteItem = _ref.onDeleteItem,
    onReady = _ref.onReady;
  var _useNumered = useNumered({
      item: item,
      mode: mode,
      onChangeItem: onChangeItem,
      onDeleteItem: onDeleteItem
    }),
    modeTextHtml = _useNumered.modeTextHtml,
    getKey = _useNumered.getKey,
    _onEnterDown = _useNumered.onEnterDown,
    _onBackAndEmpty = _useNumered.onBackAndEmpty,
    _onInitialized = _useNumered.onInitialized,
    numbersLabel = _useNumered.numbersLabel;
  var _useItemBlockComponen = useItemBlockComponent({
      numComponentsTextHtml: item == null ? void 0 : item.items.length,
      onReady: onReady,
      item: item
    }),
    onReadyGetTextHtml = _useItemBlockComponen.onReadyGetTextHtml;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'list-numered'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'list-numered__list-container ' + CLASS_CONTENT_LEFT
  }, item && item.items && item.items.map(function (subItem, index) {
    var key = getKey(subItem.id, index);
    var numberLabel = getNumerLabel(numbersLabel, index);
    return /*#__PURE__*/React__default.createElement(NumberedListItem, {
      keyItem: key,
      key: key,
      subItem: subItem,
      index: index,
      paragraphUpdated: function paragraphUpdated(text) {
        return paragraphUpdatedIndex == null ? void 0 : paragraphUpdatedIndex(text, index);
      },
      modeTextHtml: modeTextHtml,
      onEnterDown: function onEnterDown() {
        return _onEnterDown(index);
      },
      onBackAndEmpty: function onBackAndEmpty() {
        return _onBackAndEmpty(index);
      },
      onInitialized: function onInitialized(editor) {
        return _onInitialized(editor, key, index);
      },
      numberLabel: numberLabel,
      getTextHtml: getTextHtml,
      onReadyGetTextHtml: onReadyGetTextHtml
    });
  })));
};

function useItemBlockMultimedia(props) {
  var mode = props.mode;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  return {
    t: t,
    modeTextHtml: isModeEditTextHtml(mode) ? IModesTextHtml.MODE_TEXT_HTML_EDITOR : IModesTextHtml.MODE_TEXT_HTML_VISOR
  };
}

var Audio = function Audio(_ref) {
  var _subItem$media;
  var item = _ref.item,
    mode = _ref.mode,
    getTextHtml = _ref.getTextHtml,
    captionUpdated = _ref.captionUpdated,
    getSrc = _ref.getSrc,
    onReady = _ref.onReady;
  var _useItemBlockMultimed = useItemBlockMultimedia({
      item: item,
      mode: mode
    }),
    modeTextHtml = _useItemBlockMultimed.modeTextHtml;
  var subItem = item && item.items ? item.items[0] : undefined;
  var audio = subItem == null || (_subItem$media = subItem.media) == null ? void 0 : _subItem$media.audio;
  var caption = subItem == null ? void 0 : subItem.caption;
  var _useItemBlockComponen = useItemBlockComponent({
      numComponentsTextHtml: getNumComponentsTextHtml(),
      onReady: onReady,
      item: item
    }),
    onReadyGetTextHtml = _useItemBlockComponen.onReadyGetTextHtml;
  function getNumComponentsTextHtml() {
    var num = 0;
    if (caption || mode === IModesItemBlock.MODE_EDITOR) num++;
    return num;
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-audio ' + CLASS_NO_SELECT
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-audio__content ' + CLASS_CONTENT_LEFT
  }, audio && /*#__PURE__*/React__default.createElement(MediaAudio, {
    audio: audio,
    getSrc: getSrc
  }), (caption || mode === IModesItemBlock.MODE_EDITOR) && /*#__PURE__*/React__default.createElement("figcaption", {
    className: 'mint-block-audio__caption'
  }, getTextHtml(caption || '', function (text) {
    return captionUpdated && captionUpdated(text);
  }, item.id, modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml))));
};

var Embed = function Embed(_ref) {
  var item = _ref.item,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    onReady = _ref.onReady,
    getSrc = _ref.getSrc;
  var subItem = item && item.items ? item.items[0] : undefined;
  var showMetaData = getItemSettingIsShowMetaData(subItem);
  var showBorder = getItemSettingIsShowBorder(item);
  var mediaWidth = getItemSettingMediaWidth(item);
  useItemBlockComponent({
    numComponentsTextHtml: undefined,
    onReady: onReady,
    item: item
  });
  var embedClasses = classNames({
    'mint-block-embed': true,
    'mint-block-embed--no-shadow': !showBorder,
    'mint-block-embed--small': mediaWidth == ISettingsImageWidth.SMALL,
    'mint-block-embed--medium': mediaWidth == ISettingsImageWidth.MEDIUM,
    'mint-block-embed--full': mediaWidth == ISettingsImageWidth.FULL_WIDTH
  }, CLASS_NO_SELECT, CLASS_CONTENT_LEFT);
  return subItem != null && subItem.media && subItem.media.embed ? /*#__PURE__*/React__default.createElement("div", {
    className: embedClasses + " " + className
  }, /*#__PURE__*/React__default.createElement(MediaEmbed, {
    embed: subItem.media.embed,
    showMetaData: showMetaData,
    getSrc: getSrc
  })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
};

var Video = function Video(_ref) {
  var _subItem$media;
  var item = _ref.item,
    mode = _ref.mode,
    getTextHtml = _ref.getTextHtml,
    captionUpdated = _ref.captionUpdated,
    getSrc = _ref.getSrc,
    onReady = _ref.onReady;
  var _useItemBlockMultimed = useItemBlockMultimedia({
      item: item,
      mode: mode
    }),
    modeTextHtml = _useItemBlockMultimed.modeTextHtml;
  var subItem = item && item.items ? item.items[0] : undefined;
  var video = subItem == null || (_subItem$media = subItem.media) == null ? void 0 : _subItem$media.video;
  var caption = subItem == null ? void 0 : subItem.caption;
  var _useItemBlockComponen = useItemBlockComponent({
      numComponentsTextHtml: getNumComponentsTextHtml(),
      onReady: onReady,
      item: item
    }),
    onReadyGetTextHtml = _useItemBlockComponen.onReadyGetTextHtml;
  function getNumComponentsTextHtml() {
    var num = 0;
    if (caption || mode === IModesItemBlock.MODE_EDITOR) num++;
    return num;
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-video ' + CLASS_NO_SELECT + ' ' + CLASS_CONTENT_LEFT
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-video__content'
  }, video && /*#__PURE__*/React__default.createElement(MediaVideo, {
    video: video,
    getSrc: getSrc
  }), (caption || mode === IModesItemBlock.MODE_EDITOR) && /*#__PURE__*/React__default.createElement("figcaption", {
    className: 'mint-block-video__caption'
  }, getTextHtml(caption || '', function (text) {
    return captionUpdated && captionUpdated(text);
  }, item.id, modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml))));
};

var _g$7;
function _extends$l() { _extends$l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }
var SvgInformation = function SvgInformation(props) {
  return /*#__PURE__*/createElement("svg", _extends$l({
    viewBox: "0 0 18 18"
  }, props), _g$7 || (_g$7 = /*#__PURE__*/createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("g", {
    id: "information_x5F_badge",
    fillRule: "nonzero"
  }, /*#__PURE__*/createElement("path", {
    d: "M8,14 L10,14 L10,8 L8,8 L8,14 Z M8,4 L8,6 L10,6 L10,4 L8,4 Z",
    id: "Shape"
  }), /*#__PURE__*/createElement("path", {
    d: "M0,9 C0,4.027 4.027,0 9,0 L9,0 C13.971,0 17.998,4.027 18,9 L18,9 C17.998,13.971 13.971,17.998 9,18 L9,18 C4.027,17.998 0,13.971 0,9 L0,9 Z M2.115,9 C2.124,12.799 5.199,15.874 9,15.883 L9,15.883 C12.799,15.874 15.874,12.799 15.883,9 L15.883,9 C15.874,5.199 12.799,2.124 9,2.116 L9,2.116 C5.199,2.124 2.124,5.199 2.115,9 L2.115,9 Z",
    id: "Shape"
  })))));
};

var _path$d;
function _extends$m() { _extends$m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }
var SvgTeacher = function SvgTeacher(props) {
  return /*#__PURE__*/createElement("svg", _extends$m({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    id: "prefix__Trazado_182",
    d: "M0 0h24v24H0z",
    "data-name": "Trazado 182",
    style: {
      fill: "none"
    }
  }), _path$d || (_path$d = /*#__PURE__*/createElement("path", {
    id: "prefix__Trazado_183",
    d: "M5 13.18v2.81a2.011 2.011 0 001.04 1.76l5 2.73a1.986 1.986 0 001.92 0l5-2.73A2.011 2.011 0 0019 15.99v-2.81l-6.04 3.3a1.986 1.986 0 01-1.92 0zm6.04-9.66l-8.43 4.6a1.007 1.007 0 000 1.76l8.43 4.6a1.986 1.986 0 001.92 0L21 10.09V16a1 1 0 002 0V9.59a1.006 1.006 0 00-.52-.88l-9.52-5.19a2.04 2.04 0 00-1.92 0z",
    "data-name": "Trazado 183"
  })));
};

function useNoteView(props) {
  var isTeacherNote = props.isTeacherNote,
    _props$collapsed = props.collapsed,
    collapsed = _props$collapsed === void 0 ? false : _props$collapsed;
  var _useState = useState(collapsed),
    isCollapsed = _useState[0],
    setIsCollapsed = _useState[1];
  function toggleAccordion() {
    if (!isTeacherNote) return;
    setIsCollapsed(!isCollapsed);
  }
  return {
    isCollapsed: isCollapsed,
    toggleAccordion: toggleAccordion
  };
}

var NoteView = function NoteView(_ref) {
  var id = _ref.id,
    text = _ref.text,
    getTextHtml = _ref.getTextHtml,
    textUpdated = _ref.textUpdated,
    modeTextHtml = _ref.modeTextHtml,
    title = _ref.title,
    _ref$isTeacherNote = _ref.isTeacherNote,
    isTeacherNote = _ref$isTeacherNote === void 0 ? false : _ref$isTeacherNote,
    onReadyGetTextHtml = _ref.onReadyGetTextHtml;
  var _useNoteView = useNoteView({
      isTeacherNote: isTeacherNote,
      collapsed: isTeacherNote && modeTextHtml === IModesTextHtml.MODE_TEXT_HTML_VISOR
    }),
    isCollapsed = _useNoteView.isCollapsed,
    toggleAccordion = _useNoteView.toggleAccordion;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-note-view mint-note-view--note brand--fill brand--border'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-note-view__row ' + CLASS_CONTENT_LEFT
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-note-view__col'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "mint-note-view__accordion " + (isCollapsed ? 'mint-note-view__accordion--hidden' : 'mint-note-view__accordion--show'),
    onClick: function onClick(e) {
      return toggleAccordion();
    }
  }, title && /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-note-view__title brand--first'
  }, title), isTeacherNote ? /*#__PURE__*/React__default.createElement(SvgTeacher, {
    className: 'icon icon-teacher'
  }) : /*#__PURE__*/React__default.createElement(SvgInformation, {
    className: 'icon icon-information'
  }), isTeacherNote && /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-note-view__symbol brand--color'
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'mint-note-view__icon-show'
  }, "+"), /*#__PURE__*/React__default.createElement("span", {
    className: 'mint-note-view__icon-hidden'
  }, "-"))), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-note-view__body brand--first-all mint-note-view__body--' + (isCollapsed ? 'hidden' : 'show')
  }, getTextHtml(text, function (_text) {
    return textUpdated && textUpdated(_text);
  }, id, modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml)))));
};

function useItemBlockStatement(props) {
  var mode = props.mode;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  return {
    t: t,
    modeTextHtml: isModeEditTextHtml(mode) ? IModesTextHtml.MODE_TEXT_HTML_EDITOR : IModesTextHtml.MODE_TEXT_HTML_VISOR
  };
}

var Note = function Note(_ref) {
  var item = _ref.item,
    getTextHtml = _ref.getTextHtml,
    paragraphUpdated = _ref.paragraphUpdated,
    mode = _ref.mode,
    onReady = _ref.onReady;
  var _useItemBlockStatemen = useItemBlockStatement({
      item: item,
      mode: mode
    }),
    modeTextHtml = _useItemBlockStatemen.modeTextHtml;
  var subItem = item && item.items ? item.items[0] : undefined;
  var paragraph = subItem == null ? void 0 : subItem.paragraph;
  var _useItemBlockComponen = useItemBlockComponent({
      numComponentsTextHtml:  1 ,
      onReady: onReady,
      item: item
    }),
    onReadyGetTextHtml = _useItemBlockComponen.onReadyGetTextHtml;
  return /*#__PURE__*/React__default.createElement(NoteView, {
    text: paragraph || '',
    id: item.id,
    getTextHtml: getTextHtml,
    onReadyGetTextHtml: onReadyGetTextHtml,
    textUpdated: function textUpdated(text) {
      return paragraphUpdated && paragraphUpdated(text);
    },
    modeTextHtml: modeTextHtml
  });
};

var TeacherNotes = function TeacherNotes(_ref) {
  var item = _ref.item,
    getTextHtml = _ref.getTextHtml,
    paragraphUpdated = _ref.paragraphUpdated,
    mode = _ref.mode,
    onReady = _ref.onReady;
  var _useItemBlockStatemen = useItemBlockStatement({
      item: item,
      mode: mode
    }),
    modeTextHtml = _useItemBlockStatemen.modeTextHtml,
    t = _useItemBlockStatemen.t;
  var subItem = item && item.items ? item.items[0] : undefined;
  var paragraph = subItem == null ? void 0 : subItem.paragraph;
  var collapsed =  modeTextHtml === IModesTextHtml.MODE_TEXT_HTML_VISOR;
  var _useItemBlockComponen = useItemBlockComponent({
      numComponentsTextHtml: !collapsed ? 1 : undefined,
      onReady: onReady,
      item: item
    }),
    onReadyGetTextHtml = _useItemBlockComponen.onReadyGetTextHtml;
  return /*#__PURE__*/React__default.createElement(NoteView, {
    id: item.id,
    text: paragraph || '',
    getTextHtml: getTextHtml,
    onReadyGetTextHtml: onReadyGetTextHtml,
    textUpdated: function textUpdated(text) {
      return paragraphUpdated && paragraphUpdated(text);
    },
    modeTextHtml: modeTextHtml,
    isTeacherNote: true,
    title: t('teacher_notes')
  });
};

function useItemBlockText(props) {
  var mode = props.mode;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  return {
    t: t,
    modeTextHtml: isModeEditTextHtml(mode) ? IModesTextHtml.MODE_TEXT_HTML_EDITOR : IModesTextHtml.MODE_TEXT_HTML_VISOR
  };
}

var Heading = function Heading(_ref) {
  var item = _ref.item,
    getTextHtml = _ref.getTextHtml,
    headingUpdated = _ref.headingUpdated,
    mode = _ref.mode,
    onReady = _ref.onReady;
  var _useItemBlockText = useItemBlockText({
      item: item,
      mode: mode
    }),
    modeTextHtml = _useItemBlockText.modeTextHtml;
  var _useItemBlockComponen = useItemBlockComponent({
      numComponentsTextHtml: 1,
      onReady: onReady,
      item: item
    }),
    onReadyGetTextHtml = _useItemBlockComponen.onReadyGetTextHtml;
  var subItem = item && item.items ? item.items[0] : undefined;
  var heading = subItem == null ? void 0 : subItem.heading;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text mint-block-text--onecol'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text__content ' + CLASS_CONTENT_LEFT
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text__row'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text__col brand--first-all'
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: 'mint-block-text__header brand--link'
  }, getTextHtml(heading || '', function (text) {
    return headingUpdated && headingUpdated(text);
  }, item.id, modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml))))));
};

var HeadingParagraph = function HeadingParagraph(_ref) {
  var item = _ref.item,
    getTextHtml = _ref.getTextHtml,
    paragraphUpdated = _ref.paragraphUpdated,
    headingUpdated = _ref.headingUpdated,
    mode = _ref.mode,
    onReady = _ref.onReady;
  var _useItemBlockText = useItemBlockText({
      item: item,
      mode: mode
    }),
    modeTextHtml = _useItemBlockText.modeTextHtml;
  var _useItemBlockComponen = useItemBlockComponent({
      numComponentsTextHtml: 2,
      onReady: onReady,
      item: item
    }),
    onReadyGetTextHtml = _useItemBlockComponen.onReadyGetTextHtml;
  var subItem = item && item.items ? item.items[0] : undefined;
  var heading = subItem == null ? void 0 : subItem.heading;
  var paragraph = subItem == null ? void 0 : subItem.paragraph;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text mint-block-text--onecol'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text__content ' + CLASS_CONTENT_LEFT
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text__row'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text__col brand--first-all'
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: 'mint-block-text__header brand--link'
  }, getTextHtml(heading || '', function (text) {
    return headingUpdated && headingUpdated(text);
  }, item.id, modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml)))), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text__row'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text__col mint-block-text__body'
  }, getTextHtml(paragraph || '', function (text) {
    return paragraphUpdated && paragraphUpdated(text);
  }, item.id + '_paragraph', modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml)))));
};

var Paragraph = function Paragraph(_ref) {
  var item = _ref.item,
    getTextHtml = _ref.getTextHtml,
    paragraphUpdated = _ref.paragraphUpdated,
    mode = _ref.mode,
    onReady = _ref.onReady;
  var _useItemBlockText = useItemBlockText({
      item: item,
      mode: mode
    }),
    modeTextHtml = _useItemBlockText.modeTextHtml;
  var _useItemBlockComponen = useItemBlockComponent({
      numComponentsTextHtml: 1,
      onReady: onReady,
      item: item
    }),
    onReadyGetTextHtml = _useItemBlockComponen.onReadyGetTextHtml;
  var subItem = item && item.items ? item.items[0] : undefined;
  var paragraph = subItem && subItem.paragraph ? subItem.paragraph : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text mint-block-text--onecol'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text__content ' + CLASS_CONTENT_LEFT
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text__row'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text__col mint-block-text__body'
  }, getTextHtml(paragraph, function (text) {
    return paragraphUpdated && paragraphUpdated(text);
  }, item.id, modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml)))));
};

var Subheading = function Subheading(_ref) {
  var item = _ref.item,
    getTextHtml = _ref.getTextHtml,
    headingUpdated = _ref.headingUpdated,
    mode = _ref.mode,
    onReady = _ref.onReady;
  var _useItemBlockText = useItemBlockText({
      item: item,
      mode: mode
    }),
    modeTextHtml = _useItemBlockText.modeTextHtml;
  var _useItemBlockComponen = useItemBlockComponent({
      numComponentsTextHtml: 1,
      onReady: onReady,
      item: item
    }),
    onReadyGetTextHtml = _useItemBlockComponen.onReadyGetTextHtml;
  var subItem = item && item.items ? item.items[0] : undefined;
  var heading = subItem && subItem.heading ? subItem.heading : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text mint-block-text--onecol'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text__content ' + CLASS_CONTENT_LEFT
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text__row'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text__col brand--first-all'
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: 'mint-block-text__subheader brand--link'
  }, getTextHtml(heading, function (text) {
    return headingUpdated && headingUpdated(text);
  }, item.id, modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml))))));
};

var SubheadingParagraph = function SubheadingParagraph(_ref) {
  var item = _ref.item,
    getTextHtml = _ref.getTextHtml,
    paragraphUpdated = _ref.paragraphUpdated,
    headingUpdated = _ref.headingUpdated,
    mode = _ref.mode,
    onReady = _ref.onReady;
  var _useItemBlockText = useItemBlockText({
      item: item,
      mode: mode
    }),
    modeTextHtml = _useItemBlockText.modeTextHtml;
  var _useItemBlockComponen = useItemBlockComponent({
      numComponentsTextHtml: 2,
      onReady: onReady,
      item: item
    }),
    onReadyGetTextHtml = _useItemBlockComponen.onReadyGetTextHtml;
  var subItem = item && item.items ? item.items[0] : undefined;
  var heading = subItem == null ? void 0 : subItem.heading;
  var paragraph = subItem == null ? void 0 : subItem.paragraph;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text mint-block-text--onecol'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text__content ' + CLASS_CONTENT_LEFT
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text__row'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text__col brand--first-all'
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: 'mint-block-text__subheader brand--link'
  }, getTextHtml(heading || '', function (text) {
    return headingUpdated && headingUpdated(text);
  }, item.id, modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml)))), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text__row'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text__col mint-block-text__body'
  }, getTextHtml(paragraph || '', function (text) {
    return paragraphUpdated && paragraphUpdated(text);
  }, item.id + '_paragraph', modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml)))));
};

var TwoColumn = function TwoColumn(_ref) {
  var item = _ref.item,
    getTextHtml = _ref.getTextHtml,
    textColumnUpdated = _ref.textColumnUpdated,
    mode = _ref.mode,
    onReady = _ref.onReady;
  var _useItemBlockText = useItemBlockText({
      item: item,
      mode: mode
    }),
    modeTextHtml = _useItemBlockText.modeTextHtml;
  var _useItemBlockComponen = useItemBlockComponent({
      numComponentsTextHtml: item == null ? void 0 : item.items.length,
      onReady: onReady,
      item: item
    }),
    onReadyGetTextHtml = _useItemBlockComponen.onReadyGetTextHtml;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text mint-block-text--twocol'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text__content ' + CLASS_CONTENT_LEFT
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-text__row'
  }, item.items && item.items.map(function (i, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-block-text__col mint-block-text__body',
      key: i.id
    }, getTextHtml(i.paragraph || '', function (text) {
      return textColumnUpdated && textColumnUpdated(text, index);
    }, i.id, modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml));
  }))));
};

var TypeUndefined = function TypeUndefined(_ref) {
  var item = _ref.item,
    onReady = _ref.onReady;
  useItemBlockComponent({
    numComponentsTextHtml: undefined,
    onReady: onReady,
    item: item
  });
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", null, item.id), /*#__PURE__*/React__default.createElement("p", null, item.type), /*#__PURE__*/React__default.createElement("p", null, item.family), /*#__PURE__*/React__default.createElement("p", null, item.variant));
};

function useStatementA(props) {
  var mode = props.mode;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useState = useState([]),
    numbersLabel = _useState[0];
  return {
    t: t,
    modeTextHtml: isModeEditTextHtml(mode) ? IModesTextHtml.MODE_TEXT_HTML_EDITOR : IModesTextHtml.MODE_TEXT_HTML_VISOR,
    numbersLabel: numbersLabel
  };
}

var StatementA = function StatementA(_ref) {
  var item = _ref.item,
    getTextHtml = _ref.getTextHtml,
    paragraphUpdated = _ref.paragraphUpdated,
    mode = _ref.mode,
    onReady = _ref.onReady;
  var _useStatementA = useStatementA({
      item: item,
      mode: mode
    }),
    modeTextHtml = _useStatementA.modeTextHtml;
  var _useItemBlockComponen = useItemBlockComponent({
      numComponentsTextHtml: item == null ? void 0 : item.items.length,
      onReady: onReady,
      item: item
    }),
    onReadyGetTextHtml = _useItemBlockComponen.onReadyGetTextHtml;
  var subItem = item && item.items ? item.items[0] : undefined;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'statement-a'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'statement-a__content brand--first ' + CLASS_CONTENT_LEFT
  }, getTextHtml(subItem ? subItem.paragraph || '' : '', function (text) {
    return paragraphUpdated && paragraphUpdated(text);
  }, item.id, modeTextHtml, undefined, onReadyGetTextHtml)));
};

function useStatementD(props) {
  var mode = props.mode;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  return {
    t: t,
    modeTextHtml: isModeEditTextHtml(mode) ? IModesTextHtml.MODE_TEXT_HTML_EDITOR : IModesTextHtml.MODE_TEXT_HTML_VISOR
  };
}

var StatementD = function StatementD(_ref) {
  var item = _ref.item,
    getTextHtml = _ref.getTextHtml,
    paragraphUpdated = _ref.paragraphUpdated,
    mode = _ref.mode,
    onReady = _ref.onReady;
  var _useStatementD = useStatementD({
      item: item,
      mode: mode
    }),
    modeTextHtml = _useStatementD.modeTextHtml;
  var _useItemBlockComponen = useItemBlockComponent({
      numComponentsTextHtml: item == null ? void 0 : item.items.length,
      onReady: onReady,
      item: item
    }),
    onReadyGetTextHtml = _useItemBlockComponen.onReadyGetTextHtml;
  var subItem = item && item.items ? item.items[0] : undefined;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'statement-d ItemBlocks_Statement_StatementD '
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'statement-d__content brand--first-all brand--before-background ' + CLASS_CONTENT_LEFT
  }, getTextHtml(subItem ? subItem.paragraph || '' : '', function (text) {
    return paragraphUpdated && paragraphUpdated(text);
  }, item.id, modeTextHtml, undefined, onReadyGetTextHtml)));
};

var TypesActions$1;
(function (TypesActions) {
  TypesActions["CLICK_ITEM"] = "CLICK_ITEM";
})(TypesActions$1 || (TypesActions$1 = {}));
function reducerStateTimeline(state, action) {
  if (action.type === TypesActions$1.CLICK_ITEM) {
    if (state.itemsClose && state.itemsClose.indexOf(action.id) >= 0) {
      // El acordeon estaba abierto, por tanto lo cierro
      return _extends({}, state, {
        itemsClose: state.itemsClose.filter(function (item) {
          return item !== action.id;
        })
      });
    } else {
      // El ardon estaba cerrado, por tanto lo abro
      return _extends({}, state, {
        itemsClose: [].concat(state.itemsClose, [action.id])
      });
    }
  } else return state;
}
function useAccordion$1(props) {
  var item = props.item,
    mode = props.mode;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useReducer = useReducer(reducerStateTimeline, {
      itemsClose: []
    }),
    state = _useReducer[0],
    dispatch = _useReducer[1];
  var clickItem = function clickItem(e, itemId, subItemId) {
    e.preventDefault();
    dispatch({
      type: TypesActions$1.CLICK_ITEM,
      id: getIdToItemsClose(itemId, subItemId)
    });
  };
  var orientation = TimelineOrientations.VERTICAL; // TODO: en un futuro hacer aqui logica
  var modeTextHtml = isModeEditTextHtml(mode) ? IModesTextHtml.MODE_TEXT_HTML_EDITOR : IModesTextHtml.MODE_TEXT_HTML_VISOR;
  var isEditMode = modeTextHtml === IModesTextHtml.MODE_TEXT_HTML_EDITOR;
  var itemStart = item.items.find(function (item) {
    return item.type === 'start';
  });
  var itemEnd = item.items.find(function (item) {
    return item.type === 'end';
  });
  /**
   *
   * @param itemBlockId
   * @param itemItemBlockId
   * @returns
   */
  function getIdToItemsClose(itemBlockId, itemItemBlockId) {
    return itemBlockId + "|" + itemItemBlockId;
  }
  function getItemsStep() {
    return item.items.filter(function (itemInside) {
      return itemInside.type === 'step';
    });
  }
  function getNumComponentsTextHtml() {
    var num = 0;
    var _items = getItemsStep();
    for (var index = 0; index < _items.length; index++) {
      var _item = _items[index];
      if (_item.title) num++;
      if (_item.description) num++;
    }
    return num;
  }
  function getIndexOriginalItem(itemInside) {
    var _item$items;
    return item == null || (_item$items = item.items) == null ? void 0 : _item$items.findIndex(function (itemFind) {
      return itemFind.id === itemInside.id;
    });
  }
  return {
    t: t,
    clickItem: clickItem,
    itemsClose: state.itemsClose,
    modeTextHtml: modeTextHtml,
    getNumComponentsTextHtml: getNumComponentsTextHtml,
    orientation: orientation,
    isEditMode: isEditMode,
    itemStart: itemStart,
    itemEnd: itemEnd,
    getIndexOriginalItem: getIndexOriginalItem
  };
}

var _rect$1, _path$e;
function _extends$n() { _extends$n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/createElement("svg", _extends$n({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$1 || (_rect$1 = /*#__PURE__*/createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#4F4FFF"
  })), _path$e || (_path$e = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 9C15.6627 9 16.2 9.53726 16.2 10.2V13.8L19.8 13.8C20.4627 13.8 21 14.3373 21 15C21 15.6627 20.4627 16.2 19.8 16.2H16.2V19.8C16.2 20.4627 15.6627 21 15 21C14.3373 21 13.8 20.4627 13.8 19.8V16.2H10.2C9.53726 16.2 9 15.6627 9 15C9 14.3373 9.53726 13.8 10.2 13.8H13.8V10.2C13.8 9.53726 14.3373 9 15 9Z",
    fill: "white"
  })));
};

var _rect$2, _path$f;
function _extends$o() { _extends$o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }
var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/createElement("svg", _extends$o({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$2 || (_rect$2 = /*#__PURE__*/createElement("rect", {
    y: 0.5,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#4F4FFF"
  })), _path$f || (_path$f = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15.4998C9 14.8371 9.53726 14.2998 10.2 14.2998L19.8 14.2998C20.4627 14.2998 21 14.8371 21 15.4998C21 16.1625 20.4627 16.6998 19.8 16.6998L10.2 16.6998C9.53726 16.6998 9 16.1625 9 15.4998Z",
    fill: "white"
  })));
};

var TimelineCard = function TimelineCard(_ref) {
  var _item$media$image;
  var modeTextHtml = _ref.modeTextHtml,
    item = _ref.item,
    getTextHtml = _ref.getTextHtml,
    descriptionUpdated = _ref.descriptionUpdated,
    onReadyGetTextHtml = _ref.onReadyGetTextHtml,
    getSrc = _ref.getSrc,
    mode = _ref.mode;
  var _useGeneral = useGeneral();
  var isEditMode = modeTextHtml === IModesTextHtml.MODE_TEXT_HTML_EDITOR;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-timeline-card'
  }, item.media && /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-timeline-card__img'
  }, /*#__PURE__*/React__default.createElement(Media, {
    media: item.media,
    alt: ((_item$media$image = item.media.image) == null ? void 0 : _item$media$image.alt) || '',
    mediaId: item.id,
    enableZoomOnClick: getItemSettingIsZoomOnClick(item),
    getSrc: getSrc,
    mode: mode
  })), (item.description || isEditMode) && /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-timeline-card__text'
  }, getTextHtml(item.description || '', function (text) {
    return descriptionUpdated && descriptionUpdated(text);
  }, item.id, modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml)));
};

var TypesOfViews;
(function (TypesOfViews) {
  TypesOfViews["VERTICAL_LEFT"] = "vertical-left";
  TypesOfViews["VERTICAL_RIGHT"] = "vertical-right";
  // == TODO, en un futuro añadir HORIZONTAL_LEFT Y HORIZONTAL_RIGHT cuando tengamos timeline en horizontal
})(TypesOfViews || (TypesOfViews = {}));
var TimelineItem = function TimelineItem(_ref) {
  var modeTextHtml = _ref.modeTextHtml,
    typeOfView = _ref.typeOfView,
    onClickIcon = _ref.onClickIcon,
    isVisibleCard = _ref.isVisibleCard,
    getTextHtml = _ref.getTextHtml,
    item = _ref.item,
    descriptionUpdated = _ref.descriptionUpdated,
    onReadyGetTextHtml = _ref.onReadyGetTextHtml,
    getSrc = _ref.getSrc,
    titleUpdated = _ref.titleUpdated,
    mode = _ref.mode;
  var _useGeneral = useGeneral();
  function getCardComponent() {
    return /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-block-timeline-item__card' + (' mint-block-timeline-item__card--' + (isVisibleCard ? 'show' : 'hidden') + (typeOfView === TypesOfViews.VERTICAL_LEFT ? ' ' + CLASS_CONTENT_LEFT : ''))
    }, /*#__PURE__*/React__default.createElement(TimelineCard, {
      modeTextHtml: modeTextHtml,
      getTextHtml: getTextHtml,
      item: item,
      descriptionUpdated: descriptionUpdated,
      onReadyGetTextHtml: onReadyGetTextHtml,
      getSrc: getSrc,
      mode: mode
    }));
  }
  function getIconComponent() {
    return /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-block-timeline-item__icon',
      onClick: onClickIcon
    }, isVisibleCard ? /*#__PURE__*/React__default.createElement(SvgMinus, null) : /*#__PURE__*/React__default.createElement(SvgPlus, null));
  }
  function getTitleComponent() {
    return getTextHtml(item.title || '', function (text) {
      return titleUpdated && titleUpdated(text);
    }, item.id, modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml);
  }
  var showLine = item.title && removeHtmlTags(item.title).length > 0 ? true : false;
  return typeOfView === TypesOfViews.VERTICAL_LEFT ? /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-timeline-item' + (' mint-block-timeline-item--' + typeOfView)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-timeline-item__left'
  }, getCardComponent()), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-timeline-item__right'
  }, showLine && /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-timeline-item__line'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-timeline-item__title'
  }, getTitleComponent())), getIconComponent()) : typeOfView === TypesOfViews.VERTICAL_RIGHT ? /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-timeline-item' + (' mint-block-timeline-item--' + typeOfView)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-timeline-item__left'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-timeline-item__title'
  }, getTitleComponent()), showLine && /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-timeline-item__line'
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-timeline-item__right'
  }, getCardComponent()), getIconComponent()) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
};

function useMobile(props) {
  var _props$maxWidthPx = props.maxWidthPx,
    maxWidthPx = _props$maxWidthPx === void 0 ? 420 : _props$maxWidthPx;
  var _useState = useState(false),
    isMobile = _useState[0],
    setIsMobile = _useState[1];
  var mobileMediaQuery = window.matchMedia('(max-width: ' + maxWidthPx + 'px)');
  useEffect(function () {
    checkMedia(mobileMediaQuery);
    mobileMediaQuery.addEventListener('change', checkMedia);
    return function () {
      mobileMediaQuery.removeEventListener('change', checkMedia);
    };
  }, []);
  function checkMedia(mediaStatus) {
    setIsMobile(mediaStatus.matches);
  }
  return isMobile;
}

var TimelineOrientations;
(function (TimelineOrientations) {
  TimelineOrientations["VERTICAL"] = "vertical";
  TimelineOrientations["HORIZONTAL"] = "horizontal";
})(TimelineOrientations || (TimelineOrientations = {}));
var Timeline = function Timeline(_ref) {
  var item = _ref.item,
    mode = _ref.mode,
    getTextHtml = _ref.getTextHtml,
    getSrc = _ref.getSrc,
    titleUpdatedIndex = _ref.titleUpdatedIndex,
    descriptionUpdatedIndex = _ref.descriptionUpdatedIndex,
    onReady = _ref.onReady;
  var _useTimeline = useAccordion$1({
      item: item,
      mode: mode
    }),
    modeTextHtml = _useTimeline.modeTextHtml,
    itemsClose = _useTimeline.itemsClose,
    clickItem = _useTimeline.clickItem,
    getNumComponentsTextHtml = _useTimeline.getNumComponentsTextHtml,
    orientation = _useTimeline.orientation,
    isEditMode = _useTimeline.isEditMode,
    itemStart = _useTimeline.itemStart,
    itemEnd = _useTimeline.itemEnd,
    getIndexOriginalItem = _useTimeline.getIndexOriginalItem;
  var isMobile = useMobile({
    maxWidthPx: 900
  });
  var _useItemBlockComponen = useItemBlockComponent({
      numComponentsTextHtml: getNumComponentsTextHtml(),
      onReady: onReady,
      item: item
    }),
    onReadyGetTextHtml = _useItemBlockComponen.onReadyGetTextHtml;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-timeline' + ' mint-block-timeline--' + orientation + (isMobile ? ' mint-block-timeline--mobile' : '')
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-timeline__wrapper'
  }, itemStart && /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-timeline__header'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-timeline__start-end mint-block-timeline__start'
  }, itemStart.title)), item.items && item.items.map(function (itemInside, index) {
    var isVisibleCard = !(itemsClose && itemsClose.indexOf(item.id + "|" + itemInside.id) >= 0);
    var indexOfOriginalItems = getIndexOriginalItem(itemInside);
    return /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-block-timeline__box mint-block-timeline__box--' + (isVisibleCard ? 'show' : 'hidden') + ' brand--after-background' + (isEditMode ? ' mint-block-timeline__box--edit' : ''),
      key: itemInside.id
    }, itemInside.type === 'step' ? /*#__PURE__*/React__default.createElement(TimelineItem, {
      modeTextHtml: modeTextHtml,
      typeOfView: isMobile ? TypesOfViews.VERTICAL_LEFT : index % 2 == 0 ? TypesOfViews.VERTICAL_RIGHT : TypesOfViews.VERTICAL_LEFT,
      onClickIcon: function onClickIcon(e) {
        return clickItem(e, item.id, itemInside.id);
      },
      isVisibleCard: isVisibleCard,
      item: itemInside,
      itemParentId: item.id,
      getTextHtml: getTextHtml,
      onReadyGetTextHtml: onReadyGetTextHtml,
      getSrc: getSrc,
      titleUpdated: function titleUpdated(text) {
        return titleUpdatedIndex && titleUpdatedIndex(text, indexOfOriginalItems);
      },
      descriptionUpdated: function descriptionUpdated(text) {
        return descriptionUpdatedIndex && descriptionUpdatedIndex(text, indexOfOriginalItems);
      },
      mode: mode
    }) : '');
  }), itemEnd && /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-timeline__footer'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-timeline__start-end mint-block-timeline__end'
  }, itemEnd.title))));
};
// https://squarechip.github.io/timeline/#vertical-demo

function useItemBlockQuote(props) {
  var item = props.item,
    mode = props.mode;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  return {
    t: t,
    imagePosition: getItemSettingImagePosition(item),
    imageSize: getItemSettingImageSize(item),
    modeTextHtml: isModeEditTextHtml(mode) ? IModesTextHtml.MODE_TEXT_HTML_EDITOR : IModesTextHtml.MODE_TEXT_HTML_VISOR
  };
}

var QuoteA = function QuoteA(_ref) {
  var _subItem$avatar;
  var item = _ref.item,
    getTextHtml = _ref.getTextHtml,
    nameUpdated = _ref.nameUpdated,
    paragraphUpdated = _ref.paragraphUpdated,
    mode = _ref.mode,
    getSrc = _ref.getSrc,
    onReady = _ref.onReady;
  var _useItemBlockQuote = useItemBlockQuote({
      item: item,
      mode: mode
    }),
    modeTextHtml = _useItemBlockQuote.modeTextHtml;
  var subItem = item && item.items ? item.items[0] : undefined;
  var image = subItem == null || (_subItem$avatar = subItem.avatar) == null || (_subItem$avatar = _subItem$avatar.media) == null ? void 0 : _subItem$avatar.image;
  var caption = subItem == null ? void 0 : subItem.caption;
  var paragraph = subItem == null ? void 0 : subItem.paragraph;
  var name = subItem == null ? void 0 : subItem.name;
  var _useItemBlockComponen = useItemBlockComponent({
      numComponentsTextHtml: caption || mode === IModesItemBlock.MODE_EDITOR ? 2 : 1,
      onReady: onReady,
      item: item
    }),
    onReadyGetTextHtml = _useItemBlockComponen.onReadyGetTextHtml;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "mint-block-image mint-block-quote--a"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-image__content ' + CLASS_CONTENT_LEFT
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'quote-a'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'quote-a__avatar'
  }, image ? /*#__PURE__*/React__default.createElement(MediaImage, {
    image: image,
    alt: image.alt || '',
    enableZoomOnClick: getItemSettingIsZoomOnClick(item),
    getSrc: getSrc,
    mode: mode
  }) : ''), /*#__PURE__*/React__default.createElement("div", {
    className: 'quote-a__content'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'quote-a__blockquote brand--second'
  }, getTextHtml(paragraph || '', function (text) {
    return paragraphUpdated && paragraphUpdated(text);
  }, item.id, modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml)), /*#__PURE__*/React__default.createElement("div", {
    className: 'quote-a__author'
  }, getTextHtml(name || '', function (text) {
    return nameUpdated && nameUpdated(text);
  }, item.id + '_name', modeTextHtml, undefined, undefined, undefined, undefined, undefined, onReadyGetTextHtml))))));
};

var TypesActions$2;
(function (TypesActions) {
  TypesActions["CLICK_ACCORDION"] = "CLICK_ACCORDION";
})(TypesActions$2 || (TypesActions$2 = {}));
function useButton(props) {
  var mode = props.mode;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var BUTTON_TYPE_LINK = 'link';
  var BUTTON_TYPE_LESSON = 'lesson';
  var BUTTON_TYPE_EMAIL = 'email';
  var BUTTON_TYPE_EXIT_COURSE = 'exit-course';
  function buttonOnClick(e, subItem, ownProps) {
    var type = subItem ? subItem.type : null;
    e.preventDefault();
    if (type) {
      if (type.valueOf() === BUTTON_TYPE_LINK) ; else if (type.valueOf() === BUTTON_TYPE_LESSON) ; else if (type.valueOf() === BUTTON_TYPE_EMAIL) ; else if (type.valueOf() === BUTTON_TYPE_EXIT_COURSE) ;
    }
  }
  return {
    t: t,
    modeTextHtml: isModeEditTextHtml(mode) ? IModesTextHtml.MODE_TEXT_HTML_EDITOR : IModesTextHtml.MODE_TEXT_HTML_VISOR,
    BUTTON_TYPE_LINK: BUTTON_TYPE_LINK,
    BUTTON_TYPE_LESSON: BUTTON_TYPE_LESSON,
    BUTTON_TYPE_EMAIL: BUTTON_TYPE_EMAIL,
    BUTTON_TYPE_EXIT_COURSE: BUTTON_TYPE_EXIT_COURSE,
    onClickButton: buttonOnClick
  };
}

var Button$1 = function Button(_ref) {
  var item = _ref.item,
    mode = _ref.mode,
    getTextHtml = _ref.getTextHtml,
    descriptionUpdated = _ref.descriptionUpdated,
    onReady = _ref.onReady;
  var _useButton = useButton({
      item: item,
      mode: mode
    }),
    modeTextHtml = _useButton.modeTextHtml,
    BUTTON_TYPE_EMAIL = _useButton.BUTTON_TYPE_EMAIL,
    BUTTON_TYPE_LINK = _useButton.BUTTON_TYPE_LINK,
    onClickButton = _useButton.onClickButton;
  var _useItemBlockComponen = useItemBlockComponent({
      numComponentsTextHtml: item == null ? void 0 : item.items.length,
      onReady: onReady,
      item: item
    }),
    onReadyGetTextHtml = _useItemBlockComponen.onReadyGetTextHtml;
  var isEditMode = modeTextHtml === IModesTextHtml.MODE_TEXT_HTML_EDITOR;
  var subItem = item && item.items ? item.items[0] : undefined;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-block-button interactive-button ' + CLASS_CONTENT_LEFT
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'interactive-button__wrap'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'interactive-button__text'
  }, subItem && subItem.description || isEditMode ? getTextHtml(subItem ? subItem.description || '' : '', function (text) {
    return descriptionUpdated && descriptionUpdated(text);
  }, item.id, modeTextHtml, undefined, onReadyGetTextHtml) : ''), /*#__PURE__*/React__default.createElement("div", {
    className: 'interactive-button__link'
  }, subItem && subItem.type && subItem.type.valueOf() === BUTTON_TYPE_LINK ? /*#__PURE__*/React__default.createElement("a", {
    href: subItem.destination,
    target: '_blank',
    className: "interactive-button__button brand--first brand--background " + (isEditMode ? 'interactive-button__button--disabled' : '')
  }, subItem.label) : subItem && subItem.type && subItem.type.valueOf() === BUTTON_TYPE_EMAIL ? /*#__PURE__*/React__default.createElement("a", {
    href: 'mailto:' + subItem.destination + '?subject=null',
    className: "interactive-button__button brand--first brand--background " + (isEditMode ? 'interactive-button__button--disabled' : '')
  }, subItem.label) : /*#__PURE__*/React__default.createElement("a", {
    href: '',
    className: "interactive-button__button brand--first brand--background " + (isEditMode ? 'interactive-button__button--disabled' : ''),
    onClick: function onClick() {
      return onClickButton;
    }
  }, subItem ? subItem.label : ''))));
};

var _g$8;
function _extends$p() { _extends$p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }
var SvgLightBulb = function SvgLightBulb(props) {
  return /*#__PURE__*/createElement("svg", _extends$p({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$8 || (_g$8 = /*#__PURE__*/createElement("g", {
    id: "Icon/Solid/light-bulb"
  }, /*#__PURE__*/createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/createElement("path", {
    d: "M8.79998 2.4001C8.79998 1.95827 8.4418 1.6001 7.99998 1.6001C7.55815 1.6001 7.19998 1.95827 7.19998 2.4001V3.2001C7.19998 3.64193 7.55815 4.0001 7.99998 4.0001C8.4418 4.0001 8.79998 3.64193 8.79998 3.2001V2.4001Z",
    fill: "#828282"
  }), /*#__PURE__*/createElement("path", {
    d: "M12.5254 4.60594C12.8378 4.29352 12.8378 3.78699 12.5254 3.47457C12.213 3.16215 11.7065 3.16215 11.3941 3.47457L10.8284 4.04026C10.516 4.35268 10.516 4.85921 10.8284 5.17163C11.1408 5.48405 11.6473 5.48405 11.9597 5.17163L12.5254 4.60594Z",
    fill: "#828282"
  }), /*#__PURE__*/createElement("path", {
    d: "M14.4 8.0001C14.4 8.44193 14.0418 8.8001 13.6 8.8001H12.8C12.3581 8.8001 12 8.44193 12 8.0001C12 7.55827 12.3581 7.2001 12.8 7.2001H13.6C14.0418 7.2001 14.4 7.55827 14.4 8.0001Z",
    fill: "#828282"
  }), /*#__PURE__*/createElement("path", {
    d: "M4.04013 5.17164C4.35255 5.48406 4.85908 5.48406 5.1715 5.17164C5.48392 4.85922 5.48392 4.35269 5.1715 4.04027L4.60581 3.47459C4.29339 3.16217 3.78686 3.16217 3.47444 3.47459C3.16202 3.78701 3.16202 4.29354 3.47444 4.60596L4.04013 5.17164Z",
    fill: "#828282"
  }), /*#__PURE__*/createElement("path", {
    d: "M3.99998 8.0001C3.99998 8.44193 3.6418 8.8001 3.19998 8.8001H2.39998C1.95815 8.8001 1.59998 8.44193 1.59998 8.0001C1.59998 7.55827 1.95815 7.2001 2.39998 7.2001H3.19998C3.6418 7.2001 3.99998 7.55827 3.99998 8.0001Z",
    fill: "#828282"
  }), /*#__PURE__*/createElement("path", {
    d: "M6.39998 12.8001V12.0001H9.59998V12.8001C9.59998 13.6838 8.88363 14.4001 7.99998 14.4001C7.11632 14.4001 6.39998 13.6838 6.39998 12.8001Z",
    fill: "#828282"
  }), /*#__PURE__*/createElement("path", {
    d: "M9.60069 11.2001C9.61237 10.9278 9.76605 10.6831 9.98143 10.513C10.7236 9.92698 11.2 9.01917 11.2 8.0001C11.2 6.23279 9.76729 4.8001 7.99998 4.8001C6.23267 4.8001 4.79998 6.23279 4.79998 8.0001C4.79998 9.01917 5.27633 9.92698 6.01853 10.513C6.2339 10.6831 6.38759 10.9278 6.39926 11.2001H9.60069Z",
    fill: "#828282"
  })))));
};

var _g$9;
function _extends$q() { _extends$q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }
var SvgPlusSm = function SvgPlusSm(props) {
  return /*#__PURE__*/createElement("svg", _extends$q({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$9 || (_g$9 = /*#__PURE__*/createElement("g", {
    id: "Icon/Solid/plus-sm"
  }, /*#__PURE__*/createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4C8.44183 4 8.8 4.35817 8.8 4.8V7.2L11.2 7.2C11.6418 7.2 12 7.55817 12 8C12 8.44183 11.6418 8.8 11.2 8.8H8.8V11.2C8.8 11.6418 8.44183 12 8 12C7.55817 12 7.2 11.6418 7.2 11.2V8.8H4.8C4.35817 8.8 4 8.44183 4 8C4 7.55817 4.35817 7.2 4.8 7.2L7.2 7.2V4.8C7.2 4.35817 7.55817 4 8 4Z",
    fill: "#828282"
  }))));
};

var _g$a;
function _extends$r() { _extends$r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }
var SvgLightningBolt = function SvgLightningBolt(props) {
  return /*#__PURE__*/createElement("svg", _extends$r({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$a || (_g$a = /*#__PURE__*/createElement("g", {
    id: "Icon/Solid/lightning-bolt"
  }, /*#__PURE__*/createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04054 0.836872C9.37356 0.941849 9.60003 1.25069 9.60003 1.59986V5.59986L12.8 5.59986C13.0983 5.59986 13.3719 5.76583 13.5096 6.03041C13.6474 6.295 13.6265 6.61426 13.4554 6.85863L7.85541 14.8586C7.65517 15.1447 7.29254 15.2678 6.95952 15.1629C6.62649 15.0579 6.40003 14.749 6.40003 14.3999V10.3999H3.20003C2.90173 10.3999 2.6282 10.2339 2.49044 9.96931C2.35269 9.70473 2.37358 9.38547 2.54464 9.14109L8.14464 1.14109C8.34488 0.855037 8.70752 0.731896 9.04054 0.836872Z",
    fill: "#828282"
  }))));
};

var _g$b;
function _extends$s() { _extends$s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }
var SvgQuestionMarkCircle = function SvgQuestionMarkCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends$s({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$b || (_g$b = /*#__PURE__*/createElement("g", {
    id: "Icon/Solid/question-mark-circle"
  }, /*#__PURE__*/createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4 8.0001C14.4 11.5347 11.5346 14.4001 7.99998 14.4001C4.46535 14.4001 1.59998 11.5347 1.59998 8.0001C1.59998 4.46548 4.46535 1.6001 7.99998 1.6001C11.5346 1.6001 14.4 4.46548 14.4 8.0001ZM7.99999 5.6001C7.70488 5.6001 7.44605 5.75947 7.30652 6.00068C7.08529 6.38313 6.59591 6.51382 6.21346 6.29258C5.83101 6.07135 5.70032 5.58197 5.92155 5.19952C6.33532 4.48424 7.11064 4.0001 7.99999 4.0001C9.32547 4.0001 10.4 5.07461 10.4 6.4001C10.4 7.44507 9.73214 8.33406 8.79999 8.66353V8.8001C8.79999 9.24193 8.44181 9.6001 7.99999 9.6001C7.55816 9.6001 7.19999 9.24193 7.19999 8.8001V8.0001C7.19999 7.55827 7.55816 7.2001 7.99999 7.2001C8.44181 7.2001 8.79999 6.84193 8.79999 6.4001C8.79999 5.95827 8.44181 5.6001 7.99999 5.6001ZM7.99998 12.0001C8.4418 12.0001 8.79998 11.6419 8.79998 11.2001C8.79998 10.7583 8.4418 10.4001 7.99998 10.4001C7.55815 10.4001 7.19998 10.7583 7.19998 11.2001C7.19998 11.6419 7.55815 12.0001 7.99998 12.0001Z",
    fill: "#828282"
  }))));
};

var _g$c;
function _extends$t() { _extends$t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/createElement("svg", _extends$t({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$c || (_g$c = /*#__PURE__*/createElement("g", {
    id: "Icon/Solid/star"
  }, /*#__PURE__*/createElement("path", {
    id: "Icon",
    d: "M7.23912 3.14165C7.4786 2.4046 8.52133 2.40461 8.76081 3.14165L9.61646 5.77509C9.72356 6.10471 10.0307 6.32788 10.3773 6.32788H13.1463C13.9212 6.32788 14.2435 7.31957 13.6165 7.77509L11.3764 9.40265C11.096 9.60636 10.9786 9.96745 11.0857 10.2971L11.9414 12.9305C12.1809 13.6676 11.3373 14.2805 10.7103 13.8249L8.47019 12.1974C8.1898 11.9937 7.81012 11.9937 7.52973 12.1974L5.2896 13.8249C4.66263 14.2805 3.81904 13.6676 4.05853 12.9305L4.91418 10.2971C5.02128 9.96745 4.90395 9.60636 4.62356 9.40265L2.38343 7.77509C1.75646 7.31957 2.07868 6.32788 2.85366 6.32788H5.62262C5.9692 6.32788 6.27636 6.10471 6.38346 5.77509L7.23912 3.14165Z",
    fill: "#828282"
  }))));
};

var _g$d;
function _extends$u() { _extends$u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/createElement("svg", _extends$u({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$d || (_g$d = /*#__PURE__*/createElement("g", {
    id: "Icon/Solid/heart"
  }, /*#__PURE__*/createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.53723 4.13697C3.78691 2.88729 5.81304 2.88729 7.06272 4.13697L7.99998 5.07422L8.93723 4.13697C10.1869 2.88729 12.213 2.88729 13.4627 4.13697C14.7124 5.38664 14.7124 7.41277 13.4627 8.66245L7.99998 14.1252L2.53723 8.66245C1.28756 7.41277 1.28756 5.38664 2.53723 4.13697Z",
    fill: "#828282"
  }))));
};

var _g$e;
function _extends$v() { _extends$v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }
var SvgLocationMarker = function SvgLocationMarker(props) {
  return /*#__PURE__*/createElement("svg", _extends$v({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$e || (_g$e = /*#__PURE__*/createElement("g", {
    id: "Icon/Solid/location-marker"
  }, /*#__PURE__*/createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.04023 3.2403C6.22716 1.05336 9.77289 1.05336 11.9598 3.2403C14.1468 5.42724 14.1468 8.97296 11.9598 11.1599L8.00002 15.1197L4.04023 11.1599C1.85329 8.97296 1.85329 5.42724 4.04023 3.2403ZM8.00002 8.8001C8.88368 8.8001 9.60002 8.08375 9.60002 7.2001C9.60002 6.31644 8.88368 5.6001 8.00002 5.6001C7.11637 5.6001 6.40002 6.31644 6.40002 7.2001C6.40002 8.08375 7.11637 8.8001 8.00002 8.8001Z",
    fill: "#828282"
  }))));
};

var _g$f;
function _extends$w() { _extends$w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }
var SvgSearchCircle = function SvgSearchCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends$w({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$f || (_g$f = /*#__PURE__*/createElement("g", {
    id: "Icon/Solid/search-circle"
  }, /*#__PURE__*/createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/createElement("path", {
    d: "M7.19998 7.2001C7.19998 6.31644 7.91632 5.6001 8.79998 5.6001C9.68363 5.6001 10.4 6.31644 10.4 7.2001C10.4 8.08375 9.68363 8.8001 8.79998 8.8001C8.35793 8.8001 7.95902 8.62189 7.66861 8.33147C7.37819 8.04105 7.19998 7.64215 7.19998 7.2001Z",
    fill: "#828282"
  }), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99998 14.4001C11.5346 14.4001 14.4 11.5347 14.4 8.0001C14.4 4.46548 11.5346 1.6001 7.99998 1.6001C4.46535 1.6001 1.59998 4.46548 1.59998 8.0001C1.59998 11.5347 4.46535 14.4001 7.99998 14.4001ZM8.79998 4.0001C7.03266 4.0001 5.59998 5.43279 5.59998 7.2001C5.59998 7.79321 5.76181 8.3492 6.04315 8.82555L4.23429 10.6344C3.92187 10.9468 3.92187 11.4534 4.23429 11.7658C4.54671 12.0782 5.05324 12.0782 5.36566 11.7658L7.17452 9.95693C7.65087 10.2383 8.20687 10.4001 8.79998 10.4001C10.5673 10.4001 12 8.96741 12 7.2001C12 5.43279 10.5673 4.0001 8.79998 4.0001Z",
    fill: "#828282"
  })))));
};

var _g$g;
function _extends$x() { _extends$x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }
var SvgExclamationCircle = function SvgExclamationCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends$x({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$g || (_g$g = /*#__PURE__*/createElement("g", {
    id: "Icon/Solid/exclamation-circle"
  }, /*#__PURE__*/createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4 8.0001C14.4 11.5347 11.5346 14.4001 7.99998 14.4001C4.46535 14.4001 1.59998 11.5347 1.59998 8.0001C1.59998 4.46548 4.46535 1.6001 7.99998 1.6001C11.5346 1.6001 14.4 4.46548 14.4 8.0001ZM8.79998 11.2001C8.79998 11.6419 8.4418 12.0001 7.99998 12.0001C7.55815 12.0001 7.19998 11.6419 7.19998 11.2001C7.19998 10.7583 7.55815 10.4001 7.99998 10.4001C8.4418 10.4001 8.79998 10.7583 8.79998 11.2001ZM7.99998 4.0001C7.55815 4.0001 7.19998 4.35827 7.19998 4.8001V8.0001C7.19998 8.44193 7.55815 8.8001 7.99998 8.8001C8.4418 8.8001 8.79998 8.44193 8.79998 8.0001V4.8001C8.79998 4.35827 8.4418 4.0001 7.99998 4.0001Z",
    fill: "#828282"
  }))));
};

var IPopupButtonPosition;
(function (IPopupButtonPosition) {
  IPopupButtonPosition["TOP_RIGHT"] = "top-right";
  IPopupButtonPosition["TOP_LEFT"] = "top-left";
  IPopupButtonPosition["BOTTOM_RIGHT"] = "bottom-right";
  IPopupButtonPosition["BOTTOM_LEFT"] = "bottom-left";
})(IPopupButtonPosition || (IPopupButtonPosition = {}));
var IPopupTriggerIconType;
(function (IPopupTriggerIconType) {
  IPopupTriggerIconType["ICON_LIGHT_BULB"] = "01";
  IPopupTriggerIconType["ICON_PLUS"] = "02";
  IPopupTriggerIconType["ICON_LIGHTNING_BOLT"] = "03";
  IPopupTriggerIconType["ICON_QUESTION_MARK_CIRCLE"] = "04";
  IPopupTriggerIconType["ICON_STAR"] = "05";
  IPopupTriggerIconType["ICON_HEART"] = "06";
  IPopupTriggerIconType["ICON_LOCATION_MARKER"] = "07";
  IPopupTriggerIconType["ICON_SEARCH_CIRCLE"] = "08";
  IPopupTriggerIconType["ICON_EXCLAMATION_CIRCLE"] = "09";
})(IPopupTriggerIconType || (IPopupTriggerIconType = {}));
// Array ordenado de los valores del enum
var POPUP_TRIGGER_ICONS_ORDERED = [IPopupTriggerIconType.ICON_LIGHT_BULB, IPopupTriggerIconType.ICON_PLUS, IPopupTriggerIconType.ICON_LIGHTNING_BOLT, IPopupTriggerIconType.ICON_QUESTION_MARK_CIRCLE, IPopupTriggerIconType.ICON_STAR, IPopupTriggerIconType.ICON_HEART, IPopupTriggerIconType.ICON_LOCATION_MARKER, IPopupTriggerIconType.ICON_SEARCH_CIRCLE, IPopupTriggerIconType.ICON_EXCLAMATION_CIRCLE];
// Función helper para validar si un string es un valor válido del enum
/*export function isValidTriggerIcon(value: string): value is IPopupTriggerIconType {
  return Object.values(IPopupTriggerIconType).includes(value as IPopupTriggerIconType);
}
const data = JSON.parse('{"triggerIcon": "01"}');
if (isValidTriggerIcon(data.triggerIcon)) {
  const icon: IPopupTriggerIconType = data.triggerIcon;
  // Usar icon...
}
*/

function useItemBlockPopup() {
  return {};
}

var _path$g;
function _extends$y() { _extends$y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/createElement("svg", _extends$y({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24"
  }, props), _path$g || (_path$g = /*#__PURE__*/createElement("path", {
    fill: "#000000",
    d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
  })));
};

function Dialog(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    children = _ref.children,
    onClickOutside = _ref.onClickOutside,
    _ref$ignoreClickOutsi = _ref.ignoreClickOutsideSelectors,
    ignoreClickOutsideSelectors = _ref$ignoreClickOutsi === void 0 ? [] : _ref$ignoreClickOutsi;
  var dialogRef = useRef(null);
  var portalId = useRef("mint-dialog-portal-" + Math.random().toString(36).substr(2, 9));
  // Solo aplicamos el hook si onClickOutside es true
  if (onClickOutside) {
    useOnClickOutside(dialogRef, function (event) {
      // Ignorar clicks en los selectores especificados
      var target = event.target;
      var shouldIgnore = ignoreClickOutsideSelectors.some(function (selector) {
        return target.closest(selector);
      });
      if (shouldIgnore) {
        return;
      }
      onClickOutside();
    });
  }
  useEffect(function () {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    }
    return function () {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  // Buscar el contenedor mint-lesson más cercano
  var mintLessonContainer = document.querySelector('.mint-lesson');
  var contentRootId = (mintLessonContainer == null ? void 0 : mintLessonContainer.id) || ID_LESSON_VISOR;
  return /*#__PURE__*/React__default.createElement(Portal, {
    portalId: portalId.current,
    contentRootId: contentRootId,
    className: 'mint-dialog-overlay'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-dialog',
    ref: dialogRef
  }, onClose && /*#__PURE__*/React__default.createElement("button", {
    className: 'mint-dialog__close',
    onClick: onClose
  }, /*#__PURE__*/React__default.createElement(SvgClose, null)), children));
}

var IPopupContentType;
(function (IPopupContentType) {
  IPopupContentType["HEADER"] = "header";
  IPopupContentType["TEXT"] = "text";
  IPopupContentType["MEDIA"] = "media";
})(IPopupContentType || (IPopupContentType = {}));

function useItemBlockPopupContent() {
  var _useGeneral = useGeneral(),
    getSrc = _useGeneral.getSrc;
  return {
    getSrc: getSrc
  };
}

var DEFAULT_POPUP_WIDTH = '600px';
var ItemBlockPopupContent = function ItemBlockPopupContent(_ref) {
  var itemBlockPopup = _ref.itemBlockPopup,
    isVisor = _ref.isVisor,
    onClose = _ref.onClose,
    getTextHtml = _ref.getTextHtml;
  var _useItemBlockPopupCon = useItemBlockPopupContent(),
    getSrc = _useItemBlockPopupCon.getSrc;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-item-block-popup-content',
    style: _extends({}, isVisor && {
      width: itemBlockPopup.popup.width || DEFAULT_POPUP_WIDTH
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-item-block-popup-content__header'
  }, onClose && /*#__PURE__*/React__default.createElement("button", {
    className: 'close-button',
    onClick: onClose
  }, /*#__PURE__*/React__default.createElement(SvgX, null))), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-item-block-popup-content__content'
  }, itemBlockPopup.popup.contents.map(function (content) {
    var _content$media;
    switch (content.type) {
      case IPopupContentType.HEADER:
        return /*#__PURE__*/React__default.createElement("div", {
          className: 'mint-item-block-popup-content__header brand--first',
          key: content.guid
        }, getTextHtml(content.text, function () {}, content.guid, IModesTextHtml.MODE_TEXT_HTML_VISOR));
      case IPopupContentType.TEXT:
        return /*#__PURE__*/React__default.createElement("div", {
          className: 'mint-item-block-popup-content__text brand--second',
          key: content.guid
        }, getTextHtml(content.text, function () {}, content.guid, IModesTextHtml.MODE_TEXT_HTML_VISOR));
      case IPopupContentType.MEDIA:
        return content.media && /*#__PURE__*/React__default.createElement("div", {
          className: 'mint-item-block-popup-content__media'
        }, /*#__PURE__*/React__default.createElement("div", {
          className: 'mint-item-block-popup-content__media-media'
        }, /*#__PURE__*/React__default.createElement(Media, {
          media: content.media,
          alt: ((_content$media = content.media) == null || (_content$media = _content$media.image) == null ? void 0 : _content$media.alt) || '',
          mediaId: content.guid,
          enableZoomOnClick: true,
          getSrc: getSrc,
          mode: IModesItemBlock.MODE_VISOR
        }), /*#__PURE__*/React__default.createElement("div", {
          className: 'mint-item-block-popup-content__media-caption brand--second'
        }, content.caption && getTextHtml(content.caption, function () {}, content.guid + '_caption', IModesTextHtml.MODE_TEXT_HTML_VISOR))));
      default:
        return null;
    }
  })));
};

var ItemBlockPopup = function ItemBlockPopup(_ref) {
  var itemBlockPopup = _ref.itemBlockPopup,
    _ref$isVisor = _ref.isVisor,
    isVisor = _ref$isVisor === void 0 ? false : _ref$isVisor,
    getTextHtml = _ref.getTextHtml,
    onClose = _ref.onClose;
  _objectDestructuringEmpty(useItemBlockPopup());
  return /*#__PURE__*/React__default.createElement(Dialog, {
    isOpen: true,
    onClose: undefined,
    onClickOutside: onClose,
    ignoreClickOutsideSelectors: ['[data-rmiz-overlay="true"]']
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-item-block-popup'
  }, /*#__PURE__*/React__default.createElement(ItemBlockPopupContent, {
    itemBlockPopup: itemBlockPopup,
    isVisor: isVisor,
    getTextHtml: getTextHtml,
    onClose: onClose
  })));
};
/* == Para probar el popup ==
          <ItemBlockPopup
            itemBlockPopup={{
              popup: {
                guid: '123',
                contents: [
                  {
                    guid: '123',
                    type: IPopupContentType.HEADER,
                    text: 'Hola',
                  },
                  {
                    guid: '123',
                    type: IPopupContentType.TEXT,
                    text: 'Hola',
                  },
                ],
              },
              buttonPosition: IPopupButtonPosition.BOTTOM_RIGHT,
              triggerIcon: IPopupTriggerIconType.ICON_PLUS,
            }}
            isVisor={false}
            onClose={closeConfirmDialog}
            getTextHtml={getTextHtml}
          />*/

var POPUP_ICONS = {
  '01': SvgLightBulb,
  '02': SvgPlusSm,
  '03': SvgLightningBolt,
  '04': SvgQuestionMarkCircle,
  '05': SvgStar,
  '06': SvgHeart,
  '07': SvgLocationMarker,
  '08': SvgSearchCircle,
  '09': SvgExclamationCircle
};
var ItemBlockPopupWrapper = function ItemBlockPopupWrapper(_ref) {
  var popup = _ref.popup,
    getTextHtml = _ref.getTextHtml,
    children = _ref.children;
  var _useState = useState(false),
    showPopup = _useState[0],
    setShowPopup = _useState[1];
  var _useGeneral = useGeneral(),
    enablePopups = _useGeneral.enablePopups;
  var IconComponent = popup != null && popup.triggerIcon ? POPUP_ICONS[popup.triggerIcon] : null;
  var popupPosition = (popup == null ? void 0 : popup.buttonPosition) || IPopupButtonPosition.TOP_RIGHT;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-item-block-popup-wrapper'
  }, enablePopups && popup && /*#__PURE__*/React__default.createElement("button", {
    className: "mint-item-block__popup-trigger mint-item-block__popup-trigger--" + popupPosition,
    onClick: function onClick() {
      return setShowPopup(true);
    }
  }, IconComponent && /*#__PURE__*/React__default.createElement(IconComponent, null)), children, enablePopups && showPopup && popup && /*#__PURE__*/React__default.createElement(ItemBlockPopup, {
    itemBlockPopup: popup,
    isVisor: true,
    getTextHtml: getTextHtml,
    onClose: function onClose() {
      return setShowPopup(false);
    }
  }));
};

var PREFIX_ID_ITEM_CONTENT = 'item-content-';
var CLASS_CONTENT_LEFT = 'mint-item-block__content-left'; // == Clase que identifica la parte izquierda del contenido
function ItemBlock(props) {
  var _props$item$settings2, _props$item$settings3, _props$item$settings4;
  var getComponentHead = props.getComponentHead,
    getComponentFooter = props.getComponentFooter,
    role = props.role,
    onReady = props.onReady,
    lessonId = props.lessonId;
  var _useGeneral = useGeneral(),
    eventsVisor = _useGeneral.eventsVisor,
    repeatActivityEnabled = _useGeneral.repeatActivityEnabled,
    scormEnabled = _useGeneral.scormEnabled,
    t = _useGeneral.t,
    hideWaitingResponseOfflineActivity = _useGeneral.hideWaitingResponseOfflineActivity;
  // Comprueba si es visible, ya que puede ser un bloque solo para el profesor
  var isVisible = useMemo(function () {
    var _props$item$settings;
    return !(role === roleTypes.STUDENT && (_props$item$settings = props.item.settings) != null && _props$item$settings.teacherOnly);
  }, [props.item, role]);
  useEffect(function () {
    if (!isVisible) {
      // == Si no está visible no se va a renderizar su Component, por tanto notifico ya que está cargado
      onReady && onReady();
    }
  }, []);
  function getTextHtmlVisor(texto, onChangeText, keyItem, mode, placeholder, onEnterDown, onBackAndEmpty, onInitialized,
  // == Este tipo any no se puede quitar porque es el editor de froala
  isTextUpdatedKeyEnter, _onReady) {
    return /*#__PURE__*/React__default.createElement(TextHtmlVisor, {
      text: texto,
      tooltips: props.item.tooltips,
      onBegin: function onBegin() {},
      onReady: function onReady() {
        _onReady && _onReady();
      }
    });
  }
  /**
   *
   * @param _item
   * @param response es la respuesta del ejercicio, el tipo any está bien porque no lo tenemos esa parte tipada
   * @param isReset
   */
  function onResponseActivity(_item, response, isReset) {
    var _item$lms;
    var jobGuid = _item == null || (_item$lms = _item.lms) == null || (_item$lms = _item$lms.job) == null ? void 0 : _item$lms.guid;
    var lessonGuid = _item == null ? void 0 : _item.parent_guid;
    eventsVisor == null || eventsVisor.onActivityResponseSent == null || eventsVisor.onActivityResponseSent(lessonGuid || '', jobGuid, isReset, response);
  }
  function onXAPICompleteActivity(_item, data, questionApi) {
    var _item$lms2;
    var jobGuid = _item == null || (_item$lms2 = _item.lms) == null || (_item$lms2 = _item$lms2.job) == null ? void 0 : _item$lms2.guid;
    var lessonGuid = _item == null ? void 0 : _item.parent_guid;
    eventsVisor == null || eventsVisor.onActivityXAPIComplete == null || eventsVisor.onActivityXAPIComplete(questionApi, data, lessonGuid || '', jobGuid, _item.id, _item);
  }
  /**
   *
   * @param _item
   * @param questionApi es la api (store), está bien el tipo any porque no tenemos esa parte tipada
   * @param next Funcion a la que invocar para continuar con el flujo
   */
  function onActivityBeforeSend(_item, questionApi, next) {
    var _item$lms3;
    var jobGuid = _item == null || (_item$lms3 = _item.lms) == null || (_item$lms3 = _item$lms3.job) == null ? void 0 : _item$lms3.guid;
    var lessonGuid = _item == null ? void 0 : _item.parent_guid;
    eventsVisor == null || eventsVisor.onActivityBeforeSend == null || eventsVisor.onActivityBeforeSend(questionApi, next, lessonGuid, jobGuid, _item.id, _item);
  }
  function onNeedHelpClick() {
    var item = props.item;
    // const { items } = item;
    eventsVisor == null || eventsVisor.onNeedHelp == null || eventsVisor.onNeedHelp(item, role);
  }
  var isNeedHelpButton = useMemo(function () {
    var item = props.item;
    return eventsVisor != null && eventsVisor.onNeedHelp && item && ['text', 'list'].indexOf(item.family) > -1 ? true : false;
  }, [props.item, role, eventsVisor]);
  var responseLemonade = useMemo(function () {
    var _props$item, _props$item2;
    return ((_props$item = props.item) == null ? void 0 : _props$item.type) === 'lemonade' && ((_props$item2 = props.item) == null ? void 0 : _props$item2.family) === 'lemonade' ? getResponseFromLemonadeItem(props.item, scormEnabled) : undefined;
  }, [props.item]);
  var popup = props.item.popup;
  var _React$useState = React__default.useState(false);
  function getComponent(item) {
    var propsCommons = {
      // === Props comunes a varios Itemblocks
      item: item,
      onChangeItem: function onChangeItem() {},
      onDeleteItem: function onDeleteItem() {},
      getTextHtml: props.getTextHtml ? props.getTextHtml : getTextHtmlVisor,
      getSrc: props.getSrc,
      mode: props.mode,
      onReady: props.onReady
    };
    if (item.type === 'text' && item.family === 'text' && item.variant === 'heading paragraph') {
      return /*#__PURE__*/React__default.createElement(HeadingParagraph, Object.assign({}, propsCommons));
    } else if (item.type === 'text' && item.family === 'text' && item.variant === 'heading') {
      return /*#__PURE__*/React__default.createElement(Heading, Object.assign({}, propsCommons));
    } else if (item.type === 'text' && item.family === 'text' && item.variant === 'subheading paragraph') {
      return /*#__PURE__*/React__default.createElement(SubheadingParagraph, Object.assign({}, propsCommons));
    } else if (item.type === 'text' && item.family === 'text' && item.variant === 'subheading') {
      return /*#__PURE__*/React__default.createElement(Subheading, Object.assign({}, propsCommons));
    } else if (item.type === 'text' && item.family === 'text' && item.variant === 'paragraph') {
      return /*#__PURE__*/React__default.createElement(Paragraph, Object.assign({}, propsCommons));
    } else if (item.type === 'text' && item.family === 'text' && item.variant === 'two column') {
      return /*#__PURE__*/React__default.createElement(TwoColumn, Object.assign({}, propsCommons));
    } else if (item.type === 'list' && item.family === 'list' && item.variant === 'numbered') {
      return /*#__PURE__*/React__default.createElement(Numered, Object.assign({}, propsCommons));
    } else if (item.type === 'list' && item.family === 'list' && item.variant === 'bulleted') {
      return /*#__PURE__*/React__default.createElement(Bulleted, Object.assign({}, propsCommons));
    } else if (item.type === 'image' && item.family === 'image' && item.variant === 'hero') {
      return /*#__PURE__*/React__default.createElement(ImageHero, Object.assign({}, propsCommons));
    } else if (item.type === 'image' && item.family === 'image' && item.variant === 'text aside') {
      return /*#__PURE__*/React__default.createElement(ImageTextAside, Object.assign({}, propsCommons));
    } else if (item.type === 'image' && item.family === 'image' && item.variant === 'text overlay') {
      return /*#__PURE__*/React__default.createElement(ImageTextOverlay, Object.assign({}, propsCommons));
    } else if (item.type === 'image' && item.family === 'image' && item.variant === 'full') {
      return /*#__PURE__*/React__default.createElement(ImageFull, Object.assign({}, propsCommons));
    } else if (item.type === 'image' && item.family === 'gallery') {
      if (['two column', 'three column', 'four column'].indexOf(item.variant) > -1) {
        var variant = item.variant === 'four column' ? IVariantsGalleryColumns.fourcol : item.variant === 'three column' ? IVariantsGalleryColumns.threecol : IVariantsGalleryColumns.twocol;
        return /*#__PURE__*/React__default.createElement(GalleryColumns, Object.assign({}, propsCommons, {
          variant: variant
        }));
      } else {
        return /*#__PURE__*/React__default.createElement(Carousel, Object.assign({}, propsCommons));
      }
    } else if (item.type === 'interactive' && item.family === 'interactive-fullscreen' && item.variant === 'labeledgraphic') {
      return /*#__PURE__*/React__default.createElement(LabeledGraphic, Object.assign({}, propsCommons));
    } else if (item.type === 'interactive' && item.family === 'interactive-fullscreen' && item.variant === 'process') {
      return /*#__PURE__*/React__default.createElement(Process, Object.assign({}, propsCommons));
    } else if (item.type === 'interactive' && item.family === 'interactive-fullscreen' && item.variant === 'timeline') {
      return /*#__PURE__*/React__default.createElement(Timeline, Object.assign({}, propsCommons));
    } else if (item.type === 'interactive' && item.family === 'interactive' && item.variant === 'accordion') {
      return /*#__PURE__*/React__default.createElement(Accordion, Object.assign({}, propsCommons));
    } else if (item.type === 'interactive' && item.family === 'interactive' && item.variant === 'tabs') {
      return /*#__PURE__*/React__default.createElement(Tabs, Object.assign({}, propsCommons));
    } else if (item.type === 'interactive' && item.family === 'buttons' && item.variant === 'button') {
      return /*#__PURE__*/React__default.createElement(Button$1, Object.assign({}, propsCommons));
    } else if (item.type === 'multimedia' && item.family === 'multimedia' && item.variant === 'video') {
      return /*#__PURE__*/React__default.createElement(Video, Object.assign({}, propsCommons));
    } else if (item.type === 'multimedia' && item.family === 'multimedia' && item.variant === 'audio') {
      return /*#__PURE__*/React__default.createElement(Audio, Object.assign({}, propsCommons));
    } else if (item.type === 'multimedia' && item.family === 'multimedia' && item.variant === 'embed') {
      return /*#__PURE__*/React__default.createElement(Embed, Object.assign({}, propsCommons));
    } else if (item.type === 'divider' && item.family === 'divider' && item.variant === 'spacing divider') {
      return /*#__PURE__*/React__default.createElement(SpacingDivider, Object.assign({}, propsCommons));
    } else if (item.type === 'divider' && item.family === 'divider' && item.variant === 'divider') {
      return /*#__PURE__*/React__default.createElement(Divider, Object.assign({}, propsCommons));
    } else if (item.type === 'text' && item.family === 'impact' && item.variant === 'note') {
      return /*#__PURE__*/React__default.createElement(Note, Object.assign({}, propsCommons));
    } else if (item.type === 'text' && item.family === 'impact' && item.variant === 'statementA') {
      return /*#__PURE__*/React__default.createElement(StatementA, Object.assign({}, propsCommons));
    } else if (item.type === 'text' && item.family === 'impact' && item.variant === 'statementD') {
      return /*#__PURE__*/React__default.createElement(StatementD, Object.assign({}, propsCommons));
    } else if (item.type === 'quote' && item.family === 'quote' && item.variant === 'a') {
      return /*#__PURE__*/React__default.createElement(QuoteA, Object.assign({}, propsCommons));
    } else if (item.type === 'text' && item.family === 'impact' && item.variant === 'teacher notes') {
      return role !== roleTypes.STUDENT && /*#__PURE__*/React__default.createElement(TeacherNotes, Object.assign({}, propsCommons));
    } else if (item.type === 'provider' && item.family === 'provider') {
      return /*#__PURE__*/React__default.createElement(Embed, Object.assign({}, propsCommons, {
        className: "mint-block-embed--" + item.variant
      }));
    } else if (item.type === 'lemonade' && item.family === 'lemonade') {
      // const responseLemonade = getResponseFromLemonadeItem(item, scormEnabled);
      if (item.variant === 'Lemonade content guid') {
        return /*#__PURE__*/React__default.createElement("div", {
          style: {
            background: '#efefef',
            padding: '20px',
            marginTop: '10px',
            marginBottom: '10px'
          }
        }, /*#__PURE__*/React__default.createElement("p", null, t('undefined_activity')));
      }
      var score = getScoreLemonadeItem(item);
      var isPending = getStatusLemonadeItem(item) === 'delivered';
      return /*#__PURE__*/React__default.createElement(LemonadeQuestion$1, Object.assign({}, propsCommons, {
        onResponse: onResponseActivity,
        onBeforeSend: onActivityBeforeSend,
        onXAPIComplete: onXAPICompleteActivity,
        response: responseLemonade,
        role: role,
        manualScore: score,
        isPending: isPending,
        lessonId: lessonId,
        repeatEnabled: repeatActivityEnabled,
        hideWaitingResponseOffline: hideWaitingResponseOfflineActivity
      }));
    } else {
      return /*#__PURE__*/React__default.createElement(TypeUndefined, Object.assign({}, propsCommons));
    }
  }
  var getTextHtml = props.getTextHtml ? props.getTextHtml : getTextHtmlVisor;
  return isVisible ? /*#__PURE__*/React__default.createElement(ItemBlockPopupWrapper, {
    popup: popup,
    getTextHtml: getTextHtml
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-item-block',
    id: 'item-' + props.item.id,
    "data-family": props.item.family,
    "data-type": props.item.variant,
    "data-guid": props.item.parent_guid
  }, /*#__PURE__*/React__default.createElement(WrapperItemBlockOptionsVisor, {
    onNeedHelp: isNeedHelpButton && onNeedHelpClick,
    needHelpText: t(role === roleTypes.STUDENT ? 'need_help' : 'get_recomendation')
  }, /*#__PURE__*/React__default.createElement(SectionItemBlock, {
    paddingTop: (_props$item$settings2 = props.item.settings) == null ? void 0 : _props$item$settings2.paddingTop,
    paddingBottom: (_props$item$settings3 = props.item.settings) == null ? void 0 : _props$item$settings3.paddingBottom,
    backgroundColor: (_props$item$settings4 = props.item.settings) == null ? void 0 : _props$item$settings4.backgroundColor
  }, getComponentHead && getComponentHead(props.item), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-item-block_component',
    id: PREFIX_ID_ITEM_CONTENT + props.item.id
  }, getComponent(props.item)), getComponentFooter && getComponentFooter(props.item))))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
}

var _path$h, _path2$6, _rect$3;
function _extends$z() { _extends$z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }
var SvgHighlight = function SvgHighlight(props) {
  return /*#__PURE__*/createElement("svg", _extends$z({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$h || (_path$h = /*#__PURE__*/createElement("path", {
    d: "M13.3334 11.1878L8.8334 6.66699L5.50006 10.0003C5.16673 10.3331 5.00701 10.7323 5.0209 11.1978C5.03479 11.6634 5.2084 12.0628 5.54173 12.3962L3.62506 14.292C3.48673 14.4309 3.45562 14.5837 3.53173 14.7503C3.60784 14.917 3.74312 15.0003 3.93756 15.0003H6.47923C6.67368 15.0003 6.86118 14.9656 7.04173 14.8962C7.22229 14.8267 7.38895 14.7295 7.54173 14.6045L7.6459 14.5212C7.97868 14.8545 8.3709 15.0212 8.82257 15.0212C9.27423 15.0212 9.66673 14.8545 10.0001 14.5212L13.3334 11.1878Z",
    fill: "#828282"
  })), _path2$6 || (_path2$6 = /*#__PURE__*/createElement("path", {
    d: "M13.3334 2.16699L10.0001 5.47949L14.5209 10.0003L17.8542 6.66699C18.1876 6.33421 18.3542 5.94199 18.3542 5.49033C18.3542 5.03866 18.1876 4.64616 17.8542 4.31283L15.6876 2.16699C15.3548 1.83366 14.9626 1.66699 14.5109 1.66699C14.0592 1.66699 13.6667 1.83366 13.3334 2.16699Z",
    fill: "#828282"
  })), _rect$3 || (_rect$3 = /*#__PURE__*/createElement("rect", {
    y: 17,
    width: 19,
    height: 3,
    rx: 1.5,
    fill: "#828282"
  })));
};

/**
 * Componente que te avisa si haces click fuera de el
 */
var OutsideAlerter$1 = /*#__PURE__*/function (_React$Component) {
  function OutsideAlerter(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.setWrapperRef = _this.setWrapperRef.bind(_this);
    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
    return _this;
  }
  _inheritsLoose(OutsideAlerter, _React$Component);
  var _proto = OutsideAlerter.prototype;
  _proto.componentDidMount = function componentDidMount() {
    if (this.props.isActive) document.addEventListener('mousedown', this.handleClickOutside);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.isActive) document.removeEventListener('mousedown', this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */;
  _proto.setWrapperRef = function setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Avisa si se hace click fuera del elemento
   */;
  _proto.handleClickOutside = function handleClickOutside(event) {
    if (!this.isIgnoreEvent(event)) {
      if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        if (this.props.isActive && this.props.handleClickOutside) {
          this.props.handleClickOutside();
        }
      }
    }
  }

  /**
   * Nos devuelve true si ignoramos este evento
   * @fuente https://stackoverflow.com/questions/39245488/event-path-is-undefined-running-in-firefox
   * @param event
   */;
  _proto.isIgnoreEvent = function isIgnoreEvent(event) {
    var ignore = false;
    var path;
    if (event) {
      path = event.path || event.composedPath && event.composedPath();
    }
    if (path && this.props.classListIgnoreClick) {
      var found = false;
      // == Recorro la lista de path va es un listado de elementos del lugar pulsado y si dentro existe alguna de las clases a ignorar ignoro este evento
      var father = this;
      // == some devuelve true tan pronto como cualquiera de las devoluciones de llamada, ejecutadas en orden de matriz, devuelva true, cortocircuitando la ejecución del resto
      path.some(function (element) {
        if (element && element.classList) {
          father.props.classListIgnoreClick.some(function (classIgnore) {
            if (classIgnore && classIgnore.length > 0 && element.classList.contains(classIgnore)) {
              found = true;
              return true; // Devuelvo true para que se pare el bucle some
            } else return false;
          });
          if (found) {
            return true;
          } else return false;
        } else {
          return false;
        }
      });
      if (found) ignore = true;
    }
    return ignore;
  };
  _proto.render = function render() {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "outside-alerter",
      ref: this.setWrapperRef
    }, this.props.children);
  };
  return OutsideAlerter;
}(React__default.Component);
OutsideAlerter$1.propTypes = {
  children: PropTypes.element.isRequired,
  isActive: PropTypes.bool,
  // Si es true se activa el que te avise cuando se hace click fuera,
  classListIgnoreClick: PropTypes.array // Es un array de string con el listado de clases a ignorar si hacen click en ella ejemplo ["lesson__block-interactive-label-link"]
};

var ID_HIGHLIGHTER_MENU = 'hl-id-highlighter-menu';
function HighlighterMenu(props) {
  var showActionCreateHighlight = props.showActionCreateHighlight,
    onClickOutside = props.onClickOutside,
    onClickHighlight = props.onClickHighlight,
    stringHighlight = props.stringHighlight,
    onClickOptionSpinnerColorHighlight = props.onClickOptionSpinnerColorHighlight,
    colorActiveHighlight = props.colorActiveHighlight;
  return /*#__PURE__*/React__default.createElement(OutsideAlerter$1, {
    isActive: true,
    handleClickOutside: onClickOutside,
    classListIgnoreClick: []
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'hl-highlighter-menu',
    id: ID_HIGHLIGHTER_MENU
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'hl-highlighter-menu__item' + (!showActionCreateHighlight ? ' hidden' : '')
  }, /*#__PURE__*/React__default.createElement("a", {
    href: '',
    onClick: function onClick(e) {
      e.stopPropagation();
      e.preventDefault();
      onClickHighlight(e);
    },
    className: 'hl-highlighter-menu__link'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'hl-highlighter-menu__icon'
  }, /*#__PURE__*/React__default.createElement(SvgHighlight, {
    className: 'icon icon-rotu'
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'hl-highlighter-menu__content'
  }, /*#__PURE__*/React__default.createElement("span", null, stringHighlight), /*#__PURE__*/React__default.createElement(SelectColorHighlight, {
    onClickOptionSpinnerColorHighlight: onClickOptionSpinnerColorHighlight,
    colorActiveHighlight: colorActiveHighlight
  }))))));
}

var _path$i;
function _extends$A() { _extends$A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/createElement("svg", _extends$A({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$i || (_path$i = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2C8.62123 2 8.27497 2.214 8.10557 2.55279L7.38197 4H4C3.44772 4 3 4.44772 3 5C3 5.55228 3.44772 6 4 6L4 16C4 17.1046 4.89543 18 6 18H14C15.1046 18 16 17.1046 16 16V6C16.5523 6 17 5.55228 17 5C17 4.44772 16.5523 4 16 4H12.618L11.8944 2.55279C11.725 2.214 11.3788 2 11 2H9ZM7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8V14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14V8ZM12 7C11.4477 7 11 7.44772 11 8V14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14V8C13 7.44772 12.5523 7 12 7Z",
    fill: "#828282"
  })));
};

var ID_REMOVE_HIGHLIGHTER_MENU = 'hl-id-remove-highlighter-menu';
function RemoveHighlighterMenu(props) {
  var showActionDeleteHighlight = props.showActionDeleteHighlight,
    showActionEditColorHighlight = props.showActionEditColorHighlight,
    onClickOutside = props.onClickOutside,
    onClickEditColorHighlight = props.onClickEditColorHighlight,
    onClickRemoveHighlight = props.onClickRemoveHighlight,
    stringEditColorHighlight = props.stringEditColorHighlight,
    stringRemoveHighlight = props.stringRemoveHighlight,
    onClickOptionSpinnerColorHighlight = props.onClickOptionSpinnerColorHighlight,
    colorActiveHighlight = props.colorActiveHighlight;
  return /*#__PURE__*/React__default.createElement(OutsideAlerter$1, {
    isActive: true,
    handleClickOutside: onClickOutside,
    classListIgnoreClick: []
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'hl-highlighter-menu',
    id: ID_REMOVE_HIGHLIGHTER_MENU
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'hl-highlighter-menu__item' + (!showActionEditColorHighlight ? ' hidden' : '')
  }, /*#__PURE__*/React__default.createElement("a", {
    href: '',
    onClick: function onClick(e) {
      e.stopPropagation();
      e.preventDefault();
      onClickEditColorHighlight(e);
    },
    className: 'hl-highlighter-menu__link'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'hl-highlighter-menu__icon'
  }, /*#__PURE__*/React__default.createElement(SvgHighlight, {
    className: 'icon icon-rotu'
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'hl-highlighter-menu__content'
  }, /*#__PURE__*/React__default.createElement("span", null, stringEditColorHighlight), /*#__PURE__*/React__default.createElement(SelectColorHighlight, {
    onClickOptionSpinnerColorHighlight: onClickOptionSpinnerColorHighlight,
    colorActiveHighlight: colorActiveHighlight
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: 'hl-highlighter-menu__item' + (!showActionDeleteHighlight ? ' hidden' : '')
  }, /*#__PURE__*/React__default.createElement("a", {
    href: '',
    onClick: function onClick(e) {
      e.stopPropagation();
      e.preventDefault();
      onClickRemoveHighlight(e);
    },
    className: 'hl-highlighter-menu__link'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'hl-highlighter-menu__icon'
  }, /*#__PURE__*/React__default.createElement(SvgTrash, {
    className: 'icon icon-delete'
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'hl-highlighter-menu__content'
  }, stringRemoveHighlight)))));
}

var ID_SELECT_TEXT = 'hl-id-select-text';
var ID_WRAP_CONTENT = 'hl-id-highlighter-wrap-content';
function Highlighter(props) {
  var idDivSelectText = ID_SELECT_TEXT;
  var strings = props.strings;
  var _useHighlighter = useHighlighter(_extends({}, props, {
      idDivSelectText: idDivSelectText,
      idMenu: ID_HIGHLIGHTER_MENU,
      idWrapContent: ID_WRAP_CONTENT
    })),
    selectedTextMenu = _useHighlighter.selectedTextMenu,
    removeSelectedTextMenu = _useHighlighter.removeSelectedTextMenu;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'hl-highlighter',
    id: ID_WRAP_CONTENT
  }, selectedTextMenu.isVisible && /*#__PURE__*/React__default.createElement("div", {
    className: 'hl-highlighter__menu',
    style: {
      top: selectedTextMenu.y + 'px',
      left: selectedTextMenu.x + 'px'
    }
  }, /*#__PURE__*/React__default.createElement(HighlighterMenu, {
    showActionCreateHighlight: true,
    onClickOutside: function onClickOutside() {
      selectedTextMenu.onClickOutside && selectedTextMenu.onClickOutside();
    },
    onClickHighlight: function onClickHighlight(e) {
      return (selectedTextMenu == null ? void 0 : selectedTextMenu.onClickHighlight) && (selectedTextMenu == null ? void 0 : selectedTextMenu.onClickHighlight(e));
    },
    stringHighlight: strings.stringHighlight,
    onClickOptionSpinnerColorHighlight: function onClickOptionSpinnerColorHighlight(e, color) {
      return (selectedTextMenu == null ? void 0 : selectedTextMenu.onClickOptionSpinnerColorHighlight) && (selectedTextMenu == null ? void 0 : selectedTextMenu.onClickOptionSpinnerColorHighlight(e, color));
    },
    colorActiveHighlight: selectedTextMenu.colorActive || DEFAULT_COLOR
  })), removeSelectedTextMenu.isVisible && /*#__PURE__*/React__default.createElement("div", {
    className: 'hl-highlighter__menu',
    style: {
      top: removeSelectedTextMenu.y + 'px',
      left: removeSelectedTextMenu.x + 'px'
    }
  }, /*#__PURE__*/React__default.createElement(RemoveHighlighterMenu, {
    showActionEditColorHighlight: true,
    showActionDeleteHighlight: true,
    onClickOutside: function onClickOutside() {
      removeSelectedTextMenu.onClickOutside && removeSelectedTextMenu.onClickOutside();
    },
    onClickEditColorHighlight: function onClickEditColorHighlight(e) {
      return (removeSelectedTextMenu == null ? void 0 : removeSelectedTextMenu.onClickEditColorHighlight) && (removeSelectedTextMenu == null ? void 0 : removeSelectedTextMenu.onClickEditColorHighlight(e));
    },
    onClickRemoveHighlight: function onClickRemoveHighlight(e) {
      return (removeSelectedTextMenu == null ? void 0 : removeSelectedTextMenu.onClickRemoveHighlight) && (removeSelectedTextMenu == null ? void 0 : removeSelectedTextMenu.onClickRemoveHighlight(e));
    },
    stringEditColorHighlight: strings.stringEditColorHighlight,
    stringRemoveHighlight: strings.stringRemoveHighlight,
    onClickOptionSpinnerColorHighlight: function onClickOptionSpinnerColorHighlight(e, color) {
      return (removeSelectedTextMenu == null ? void 0 : removeSelectedTextMenu.onClickOptionSpinnerColorHighlight) && (removeSelectedTextMenu == null ? void 0 : removeSelectedTextMenu.onClickOptionSpinnerColorHighlight(e, color));
    },
    colorActiveHighlight: removeSelectedTextMenu.colorActive || DEFAULT_COLOR
  })), /*#__PURE__*/React__default.createElement("div", {
    id: idDivSelectText
  }, props.children));
}

var DATA_ATRIBUTE_BACKGROUND_SECTION = 'data-background';
function getHighlightFromMint(highlightMint) {
  var highlight = {
    guid: highlightMint.guid,
    selectedText: highlightMint.selectedText,
    idDivSelectText: ID_SELECT_TEXT,
    start: highlightMint.start,
    end: highlightMint.end,
    color: highlightMint.color,
    selections: highlightMint.selections.map(function (_selection) {
      return {
        guid: _selection.guid,
        selectedText: _selection.selectedText,
        idDivSelectText: PREFIX_ID_ITEM_CONTENT + _selection.itemId,
        start: _selection.start,
        end: _selection.end,
        color: _selection.color
      };
    })
  };
  return highlight;
}
function getHighlightsFromMint(highlightsMint) {
  var highlight = highlightsMint.map(function (_highlight) {
    return getHighlightFromMint(_highlight);
  });
  return highlight;
}
function getHighlightToMint(highlights) {
  var highlight = {
    guid: highlights.guid,
    selectedText: highlights.selectedText,
    start: highlights.start,
    end: highlights.end,
    color: highlights.color,
    selections: highlights.selections.map(function (_selection) {
      return {
        guid: _selection.guid,
        selectedText: _selection.selectedText,
        itemId: _selection.idDivSelectText.replace(PREFIX_ID_ITEM_CONTENT, ''),
        start: _selection.start,
        end: _selection.end,
        color: _selection.color
      };
    })
  };
  return highlight;
}
function getConfigHighlights(config) {
  var configHighlights = {
    getHighlights: function getHighlights(success, error) {
      config == null || config.getHighlights(function (_highlights) {
        success(getHighlightsFromMint(_highlights));
      }, function (_error) {
        error(_error);
      });
    },
    createHighlight: function createHighlight(highlight, success, error) {
      config == null || config.createHighlight(getHighlightToMint(highlight), function (_highlight) {
        success(getHighlightFromMint(_highlight));
      }, function (_error) {
        error(_error);
      });
    },
    editHighlight: function editHighlight(idHighlight, highlight, success, error) {
      config == null || config.editHighlight(idHighlight, getHighlightToMint(highlight), function (_highlight) {
        success(getHighlightFromMint(_highlight));
      }, function (_error) {
        error(_error);
      });
    },
    delHighlight: function delHighlight(idHighlight, success, error) {
      config == null || config.delHighlight(idHighlight, function () {
        success();
      }, function (_error) {
        error(_error);
      });
    }
  };
  return configHighlights;
}
function getConfigSelectionCoords(selectionCoordsMint) {
  var selectionCoords = _extends({}, selectionCoordsMint, {
    nameAttributeBackgroundColor: DATA_ATRIBUTE_BACKGROUND_SECTION,
    isNodeCanHighlighted: function isNodeCanHighlighted(node) {
      if (
      // == Si esta definido tambien se debe de cumplir que selectionCoordsMint.isNodeCanHighlighted sea true
      (selectionCoordsMint && selectionCoordsMint.isNodeCanHighlighted ? selectionCoordsMint.isNodeCanHighlighted(node) : true) && node && node.className === 'mint-item-block_component' && node.firstChild &&
      // == Para desactivar algun bloque que no queremos resaltes añadirlo aqui, además de añadir al lado de la dicha clase dentro del bloque la clase CLASS_NO_SELECT
      !hasClass(node.firstChild, 'lemonade-exercises') && !hasClass(node.firstChild, 'lesson__block-interactive-label') && !hasClass(node.firstChild, 'mint-block-embed') && !hasClass(node.firstChild, 'mint-block-process') && !hasClass(node.firstChild, 'mint-block-carousel') && !hasClass(node.firstChild, 'mint-block-audio') && !hasClass(node.firstChild, 'mint-block-video')) {
        return true;
      }
      return false;
    }
  });
  return selectionCoords;
}

var _g$h;
function _extends$B() { _extends$B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }
var SvgRepeat$1 = function SvgRepeat(props) {
  return /*#__PURE__*/createElement("svg", _extends$B({
    className: "icon icon-repeat",
    viewBox: "0 0 138 116"
  }, props), _g$h || (_g$h = /*#__PURE__*/createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("g", {
    id: "iconfinder_29_171487",
    transform: "translate(69.500000, 57.500000) scale(-1, 1) translate(-69.500000, -57.500000) translate(0.000000, -1.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/createElement("path", {
    d: "M137.309,47.159 C135.495,45.345 132.547,45.347 130.727,47.165 L116.229,61.664 C116.303,60.531 116.348,59.398 116.358,58.251 C116.593,26.4 90.962,0.767 59.108,1 C27.253,1.237 1.238,27.251 1.001,59.107 C0.77,90.962 26.396,116.595 58.253,116.358 C71.194,116.262 83.172,111.911 92.85,104.643 L84.643,96.437 C77.155,101.654 68.09,104.75 58.338,104.822 C32.853,105.009 12.351,84.506 12.538,59.022 C12.726,33.537 33.54,12.726 59.024,12.536 C84.507,12.349 105.011,32.853 104.823,58.337 C104.815,59.385 104.768,60.42 104.694,61.446 L90.735,47.491 L90.735,47.49 C88.911,45.667 85.936,45.689 84.083,47.542 C82.231,49.392 82.21,52.373 84.034,54.192 L107.143,77.304 C108.612,78.775 110.831,79.039 112.6,78.121 L112.674,78.194 C112.695,78.145 112.709,78.098 112.725,78.05 C113.11,77.835 113.467,77.572 113.789,77.247 L137.3,53.74 C139.126,51.922 139.128,48.975 137.309,47.159",
    id: "Path"
  })))));
};

var _path$j;
function _extends$C() { _extends$C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }
var SvgXCircle = function SvgXCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends$C({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$j || (_path$j = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289C6.90237 7.68342 6.90237 8.31658 7.29289 8.70711L8.58579 10L7.29289 11.2929C6.90237 11.6834 6.90237 12.3166 7.29289 12.7071C7.68342 13.0976 8.31658 13.0976 8.70711 12.7071L10 11.4142L11.2929 12.7071C11.6834 13.0976 12.3166 13.0976 12.7071 12.7071C13.0976 12.3166 13.0976 11.6834 12.7071 11.2929L11.4142 10L12.7071 8.70711C13.0976 8.31658 13.0976 7.68342 12.7071 7.29289C12.3166 6.90237 11.6834 6.90237 11.2929 7.29289L10 8.58579L8.70711 7.29289Z",
    fill: "#BDBDBD"
  })));
};

var AudioPlayerPopup = function AudioPlayerPopup(_ref) {
  var audioElement = _ref.audioElement,
    isVisible = _ref.isVisible,
    showButtonPause = _ref.showButtonPause,
    showButtonPlay = _ref.showButtonPlay,
    showButtonResume = _ref.showButtonResume,
    onClickPlay = _ref.onClickPlay,
    onClickPause = _ref.onClickPause,
    onClickResume = _ref.onClickResume,
    onClickRepeat = _ref.onClickRepeat,
    onClickCancel = _ref.onClickCancel,
    _ref$progressValue = _ref.progressValue,
    progressValue = _ref$progressValue === void 0 ? 0 : _ref$progressValue,
    onClickProgress = _ref.onClickProgress,
    actualDuration = _ref.actualDuration,
    totalDuration = _ref.totalDuration;
  var progressRef = useRef(null);
  function _onClickProgress(e) {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    try {
      if (progressRef.current) {
        var percent = e.nativeEvent.offsetX / progressRef.current.offsetWidth * 100;
        onClickProgress && onClickProgress(percent);
      }
    } catch (error) {}
  }
  function onClickGeneral(e) {
    // Paro la propagacion porque cuando hacia click en cualquier sitio del recuadro si estaba dentro de un arcordeon abria y cerraba el acordeon
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-audio-player-popup' + (!isVisible ? ' hidden' : ''),
    onClick: onClickGeneral
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-audio-player-popup__wrap'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-audio-player-popup__content'
  }, /*#__PURE__*/React__default.createElement("a", {
    href: '',
    className: 'mint-audio-player-popup__repeat brand--fill',
    onClick: onClickRepeat
  }, /*#__PURE__*/React__default.createElement(SvgRepeat$1, null)), /*#__PURE__*/React__default.createElement("a", {
    href: '',
    className: 'mint-audio-player-popup__play mint-audio-player-popup__play' + (showButtonPlay || showButtonResume ? '--play' : showButtonPause ? '--pause' : '') + (showButtonResume || showButtonPlay || showButtonPause ? '' : ' hidden'),
    onClick: showButtonPlay ? onClickPlay : showButtonResume ? onClickResume : onClickPause
  }, showButtonPlay || showButtonResume ? /*#__PURE__*/React__default.createElement(SvgPlay, null) : /*#__PURE__*/React__default.createElement(SvgPause, null))), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-audio-player-popup__progress'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-audio-player-popup__progress-texts'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-audio-player-popup__progress-text-actual'
  }, actualDuration), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-audio-player-popup__progress-text-total'
  }, " / ", totalDuration)), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-audio-player-popup__progress-progress'
  }, /*#__PURE__*/React__default.createElement("progress", {
    className: 'brand--value-color brand--value-background-color brand--value-progress-bar-color brand--value-progress-bar-background-color brand--value-progress-value-background-color',
    //@ts-ignore indica que la propiedad min no existe
    min: '0',
    max: '100',
    value: progressValue,
    ref: progressRef,
    onClick: _onClickProgress
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-audio-player-popup__content'
  }, /*#__PURE__*/React__default.createElement(VolumeControl, {
    audioElement: audioElement
  }), /*#__PURE__*/React__default.createElement(SpeedControl, {
    audioElement: audioElement
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-audio-player-popup__nav'
  }, /*#__PURE__*/React__default.createElement("a", {
    href: '',
    className: 'mint-audio-player-popup__close',
    onClick: onClickCancel
  }, /*#__PURE__*/React__default.createElement(SvgXCircle, null)))));
};
AudioPlayerPopup.propTypes = {};

function convertElapsedTime(inputSeconds) {
  var seconds = Math.floor(inputSeconds % 60);
  var secondsString = seconds + '';
  if (seconds < 10) {
    secondsString = '0' + seconds;
  }
  var minutes = Math.floor(inputSeconds / 60);
  return minutes + ':' + secondsString;
}

var MINT_ID_AUDIOS_BLOCKS_GENERAL = 'mint-audios-blocks-general';
var MINT_ID_AUDIO_PLAYER_GENERAL_PREFIX = 'mint-id-audio-player-general__';
var MINT_ID_AUDIO_PLAYER_PREFIX = 'mint-id-audio-player__';
/**
 * Tenemos 2 opciones:
 * - Opcion 1, la actual, crear un elemento audio dinamico y usarlo
 * - Opcion 2, comentada, el elemento audio esta visible en el dom y se podria descargar el audio facilmente
 * @param {*} param0
 */
var AudioPlayerFloating = function AudioPlayerFloating(props) {
  var audio = props.audio,
    nextAudio = props.nextAudio,
    _props$isAudioBlock = props.isAudioBlock,
    isAudioBlock = _props$isAudioBlock === void 0 ? false : _props$isAudioBlock,
    uiActualPlayAudio = props.uiActualPlayAudio,
    setActualPlayAudio = props.setActualPlayAudio;
  var idAudioBlock = audio.guid;
  var _useGeneral = useGeneral(),
    getSrc = _useGeneral.getSrc;
  //Estado
  var _useReducer = useReducer(function (state, newState) {
      return _extends({}, state, newState);
    }, {
      showPopup: false,
      showButtonStop: false,
      showButtonPlay: false,
      showButtonPause: false,
      showButtonResume: false,
      progressValue: 0,
      actualDuration: '',
      totalDuration: ''
    }),
    state = _useReducer[0],
    setState = _useReducer[1];
  // const uiActualPlayAudio = useSelector(state => getLessonPagePrefActualPlayAudio(state));
  var onPlay = function onPlay() {
    setState({
      showPopup: true,
      showButtonStop: true,
      showButtonPlay: false,
      showButtonPause: true,
      showButtonResume: false
    });
    setActualPlayAudio && setActualPlayAudio(audio);
  };
  var onPause = function onPause() {
    setState({
      showButtonStop: false,
      showButtonPlay: true,
      showButtonPause: false,
      showButtonResume: false
    });
  };
  var onEnd = function onEnd() {
    setState({
      showButtonStop: false,
      showButtonPlay: true,
      showButtonPause: false,
      showButtonResume: false
    });
    if (nextAudio) {
      setActualPlayAudio && setActualPlayAudio(nextAudio);
    } else setActualPlayAudio && setActualPlayAudio(undefined);
  };
  var audioRef = useRef(document.createElement('audio'));
  var classBase = isAudioBlock ? 'mint-player-audio-ab' : 'mint-player-audio';
  var suffixGeneral = '-general';
  var classPlay = classBase + '__play';
  var audioElement = audioRef && audioRef.current ? audioRef.current : null;
  var handleOntimeupdate = function handleOntimeupdate(e) {
    updateProgress();
  };
  //const audioRef = userRef(null) // OPCION 2
  // En la opcion 1 esta funcion no estaria
  var initAudioElement = function initAudioElement(url) {
    if (audioElement) {
      audioElement.src = url;
      audioElement.style.display = 'none'; //added to fix ios issue
      audioElement.autoplay = false; //avoid the user has not interacted with your page issue
      audioElement.onended = function () {
        onEnd();
      };
      audioElement.onplay = function () {
        onPlay();
      };
      audioElement.onpause = function () {
        onPause();
      };
      // == El evento lo hago de esta forma en lugar de audioElement.ontimeupdate para poder quitar el listener cuando se destruye el componente, ya que este listener es constante, se va ejecutar cada vez que cambia la barra de proceso, y hay que dejar de escucharlo cuando vamos a eliminar este componente
      audioElement.addEventListener('timeupdate', handleOntimeupdate);
    }
  };
  function updateProgress() {
    if (audioElement !== null) {
      var value = 0;
      if (audioElement.currentTime > 0) {
        value = Math.floor(100 / audioElement.duration * audioElement.currentTime);
      }
      setState({
        progressValue: value,
        actualDuration: convertElapsedTime(audioElement.currentTime),
        totalDuration: convertElapsedTime(audioElement.duration)
      });
    }
  }
  var handlePlay = function handlePlay() {
    if (audioElement !== null) {
      audioElement.play();
    }
  };
  var handleStop = function handleStop() {
    if (audioElement !== null) {
      audioElement.currentTime = 0;
      audioElement.pause();
    }
  };
  var handlePause = function handlePause() {
    if (audioElement !== null) {
      audioElement.pause();
    }
  };
  var handleRepeat = function handleRepeat() {
    if (audioElement !== null) {
      audioElement.currentTime = 0;
      audioElement.play();
    }
  };
  var handleChangeCurrentTime = function handleChangeCurrentTime(percent) {
    if (audioElement !== null) {
      audioElement.currentTime = percent / 100 * audioElement.duration;
    }
  };
  useEffect(function () {
    initAudioElement(getSrc(audio.src)); // En la OPCION 1, esta linea no estaria
    return function () {
      handleStop();
      // En la opcion 1 no estaria estas lineas
      if (audioElement && audioElement.remove) {
        audioElement.removeEventListener('timeupdate', handleOntimeupdate);
        audioElement.remove(); //remove after playing to clean the Dom
      }
    };
  }, []);
  useEffect(function () {
    uiActualPlayAudio && uiActualPlayAudio.guid == audio.guid ? handlePlay() : handleStop();
  }, [uiActualPlayAudio]);
  var onClickSound = function onClickSound(e) {
    e.stopPropagation();
    e.preventDefault();
    setState({
      showPopup: true
    });
    handlePlay();
  };
  /*********** POPUP **********/
  var popupOnClickStop = function popupOnClickStop(e) {
    e.stopPropagation();
    e.preventDefault();
    handleStop();
  };
  var popupOnClickPlay = function popupOnClickPlay(e) {
    e.stopPropagation();
    e.preventDefault();
    handlePlay();
  };
  var popupOnClickPause = function popupOnClickPause(e) {
    e.stopPropagation();
    e.preventDefault();
    handlePause();
  };
  var popupOnClickResume = function popupOnClickResume(e) {
    e.stopPropagation();
    e.preventDefault();
    console.log('popupOnClickResume');
  };
  var popupOnClickRepeat = function popupOnClickRepeat(e) {
    e.stopPropagation();
    e.preventDefault();
    handleRepeat();
  };
  var popupOnClickCancel = function popupOnClickCancel(e) {
    e.stopPropagation();
    e.preventDefault();
    setState({
      showPopup: false
    });
    handleStop();
  };
  var popupOnClickProgress = function popupOnClickProgress(percent) {
    handleChangeCurrentTime(percent);
  };
  var isShowActual = function isShowActual() {
    return state.showPopup && audio && uiActualPlayAudio && uiActualPlayAudio.guid == audio.guid;
  };
  var elementA = function elementA(insideGeneral) {
    if (insideGeneral === void 0) {
      insideGeneral = false;
    }
    return /*#__PURE__*/React__default.createElement("a", {
      href: '',
      className: classPlay + (isShowActual() ? ' ' + classPlay + '--active' : '') + (insideGeneral ? ' ' + classPlay + suffixGeneral : ''),
      id: getIdAudioPlayer(idAudioBlock, insideGeneral),
      onClick: onClickSound
    }, /*#__PURE__*/React__default.createElement(SvgSound, null));
  };
  var elementAudioPlayerPopup = function elementAudioPlayerPopup() {
    return /*#__PURE__*/React__default.createElement(AudioPlayerPopup, {
      audioElement: audioElement,
      isVisible: state.showPopup,
      showButtonStop: state.showButtonStop,
      showButtonPause: state.showButtonPause,
      showButtonPlay: state.showButtonPlay,
      showButtonResume: state.showButtonResume,
      onClickStop: popupOnClickStop,
      onClickPlay: popupOnClickPlay,
      onClickPause: popupOnClickPause,
      onClickResume: popupOnClickResume,
      onClickRepeat: popupOnClickRepeat,
      onClickCancel: popupOnClickCancel,
      onClickProgress: popupOnClickProgress,
      progressValue: state.progressValue,
      actualDuration: state.actualDuration,
      totalDuration: state.totalDuration
    });
  };
  if (audio && audio.guid) {
    return !isAudioBlock ?
    /*#__PURE__*/
    // =====================
    // == Audios no bloques
    // =====================
    React__default.createElement(React__default.Fragment, null, elementA(false), isShowActual() && /*#__PURE__*/React__default.createElement(Portal, {
      portalId: classBase + '-' + (audio ? audio.guid : ''),
      key: audio ? audio.guid : 'key',
      className: '',
      contentRootId: MINT_ID_AUDIOS_BLOCKS_GENERAL
    }, elementAudioPlayerPopup())) :
    /*#__PURE__*/
    // ===================
    // == Audios Bloques
    // ===================
    React__default.createElement(React__default.Fragment, null, elementA(false), /*#__PURE__*/React__default.createElement(Portal, {
      portalId: MINT_ID_AUDIOS_BLOCKS_GENERAL + '-' + (audio ? audio.guid : ''),
      className: '',
      contentRootId: MINT_ID_AUDIOS_BLOCKS_GENERAL
    }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, elementA(true), isShowActual() && /*#__PURE__*/React__default.createElement("div", {
      className: classBase + '-' + (audio ? audio.guid : '')
    }, elementAudioPlayerPopup()))));
  } else {
    return null;
  }
};
AudioPlayerFloating.propTypes = {
  audio: PropTypes.object.isRequired
};
var getIdAudioPlayer = function getIdAudioPlayer(idAudioBlock, insideGeneral) {
  if (insideGeneral === void 0) {
    insideGeneral = false;
  }
  if (idAudioBlock) {
    return insideGeneral ? MINT_ID_AUDIO_PLAYER_GENERAL_PREFIX + idAudioBlock : MINT_ID_AUDIO_PLAYER_PREFIX + idAudioBlock;
  } else return undefined;
};

/**
 * @fuente https://stackoverflow.com/questions/33710833/how-do-i-conditionally-wrap-a-react-component
 * @param param0
 * @returns
 */
var ConditionalWrapper = function ConditionalWrapper(_ref) {
  var condition = _ref.condition,
    wrapper = _ref.wrapper,
    children = _ref.children;
  return condition ? wrapper(children) : children;
};

function useInterval(callback, delay) {
  var savedCallback = useRef();

  // Remember the latest function.
  useEffect(function () {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(function () {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      var id = setInterval(tick, delay);
      return function () {
        return clearInterval(id);
      };
    }
  }, [delay]);
}

function usePost(props) {
  var post = props.post,
    setPostReady = props.setPostReady;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    getSrc = _useGeneral.getSrc,
    offsetVisibilityPost = _useGeneral.offsetVisibilityPost,
    offsetVisibilityItemBlock = _useGeneral.offsetVisibilityItemBlock,
    eventsVisor = _useGeneral.eventsVisor;
  var _useState = useState(false),
    isVisible = _useState[0],
    setIsVisible = _useState[1];
  var _useState2 = useState(false),
    isReady = _useState2[0],
    setIsReady = _useState2[1];
  var _useState3 = useState({
      itemsLocal: getItemsProps()
    }),
    state = _useState3[0],
    dispatch = _useState3[1];
  var itemBlocksPending = useRef(getItemBlocksPendingReady(getItemsProps())); // == Esta variable tiene un listado de todos los itemblock y conforme se van cargando se van eliminando de esta variable, y cuando ya está vacia entonces ya está cargado todo en el dom
  // ========================================
  // == Para hacer un forzaje de que no hay itemBlocks pending
  // == Lo hago de esta forma usando el useInterval para asegurarme que para el intervalo bien
  var DELAY_FORCE_CLEAR_ITEMBLOCKPENDING = 10000;
  var _useState4 = useState(false),
    isRunningForceClearItemBlocksPending = _useState4[0],
    setIsRunningForceClearItemBlocksPending = _useState4[1];
  // ========================================
  useInterval(function () {
    if (isRunningForceClearItemBlocksPending && itemBlocksPending.current.length > 0) {
      // == Mecanismo de emergencia
      // == Fuerzo al vaciado de itemBlockPending y fuerzo que este post está Ready
      itemBlocksPending.current = [];
      setPostReady && setPostReady();
      setIsRunningForceClearItemBlocksPending(false);
    }
  }, isRunningForceClearItemBlocksPending ? DELAY_FORCE_CLEAR_ITEMBLOCKPENDING : null);
  useEffect(function () {
    // == Para saber cuando se ha cargado la pagina tenemos dos mecanismos:
    // == 1) Mediante itemBlocksPending, esta variable tiene un listado de todos los itemblock y conforme se van cargando se van eliminando de esta variable, y cuando ya está vacia entonces ya está cargado todo en el dom
    // == 2) Si por lo que sea fallara el mecanismo 1, tenemos tambien un mecanismo de emergencia, que consiste que apartir de se invoque a este useEffect que es similar a componentDidMount, entonces ponemos un temporizador y a los DELAY_FORCE_CLEAR_ITEMBLOCKPENDING segundos vamos a forzar a vaciar el array de itemBlocksPending para asi decir que ya se ha cargado todo
    setIsRunningForceClearItemBlocksPending(true);
  }, []);
  useEffect(function () {
    var propsItemsString = JSON.stringify(getItemsProps());
    var itemsStateString = JSON.stringify(state.itemsLocal);
    if (propsItemsString !== itemsStateString) {
      dispatch({
        itemsLocal: getItemsProps()
      });
      itemBlocksPending.current = getItemBlocksPendingReady(getItemsProps());
    }
  }, [getItemsProps()]);
  useEffect(function () {
    setIsReady(eventsVisor !== null);
  }, [eventsVisor !== null]);
  function getItemBlocksPendingReady(items) {
    return items.map(function (_item) {
      return _item.id;
    });
  }
  /**
   * Establece que un itemBlock está ready, por lo que lo quita de la lista de itemBlockPending
   * @param item
   */
  function setItemBlockReady(item) {
    if (itemBlocksPending.current.length > 0) {
      itemBlocksPending.current = itemBlocksPending.current.filter(function (_item) {
        return _item !== item.id;
      });
      if (itemBlocksPending.current.length === 0) {
        setPostReady && setPostReady();
        // == Paro el mecanismo de emergencia
        setIsRunningForceClearItemBlocksPending(false);
      }
    }
  }
  function getItemsProps() {
    return (post == null ? void 0 : post.items) || [];
  }
  function onChangeVisibilityPost(_isVisible) {
    setIsVisible(_isVisible);
    eventsVisor == null || eventsVisor.onChangeVisibilityPost == null || eventsVisor.onChangeVisibilityPost(post, _isVisible);
  }
  return {
    t: t,
    items: state.itemsLocal,
    getSrc: getSrc,
    onChangeVisibilityPost: onChangeVisibilityPost,
    isVisible: isVisible,
    isReady: isReady,
    offsetVisibilityPost: offsetVisibilityPost || {},
    offsetVisibilityItemBlock: offsetVisibilityItemBlock || {},
    setItemBlockReady: setItemBlockReady
  };
}

/**
 * Dado un item nos devuelve una copia de el con todos sus ids que corresponda cambiados
 * Si para hacer alguna copia para algun item particular hay que hacer algo particular hacerlo dentro de este metodo
 * @param {*} post: IPosy
 */
function getPostCopy(post) {
  var postCopy = JSON.parse(JSON.stringify(post)); // == Hago una copia
  // == Cambio su id
  postCopy.guid = getGuid();
  // == Cambio la id de sus items
  var newItems = [];
  if (post.items) {
    for (var i = 0; i < post.items.length; i++) {
      var itemParticular = post.items[i];
      if (itemParticular) {
        itemParticular = getItemCopy(itemParticular);
      }
      newItems.push(itemParticular);
    }
  }
  postCopy.items = newItems;
  return postCopy;
}
function getItemsHasBeenSeenPost(post, itemsIdHasBeenSeen, role) {
  var itemsHasBeenSeen = post.items.filter(function (item) {
    return isCanRenderItem(item, role) && isHasBeenSeen(item, itemsIdHasBeenSeen);
  }); // total de item que se renderizar y han sido vistos
  return itemsHasBeenSeen;
}
/**
 * Devuelve los items que podia renderizar
 */
function getItemsCanRenderPost(post, role) {
  var itemsHasBeenSeen = post.items.filter(function (item) {
    return isCanRenderItem(item, role);
  }); // total de item que se renderizar
  return itemsHasBeenSeen;
}
/**
 * Devuelve el audio asociado a un itemBlock o undefined si no lo tiene
 * @param post
 * @param itemBlock
 */
function getAudioItemBlockPost(post, itemBlock) {
  var _post$audios;
  return (_post$audios = post.audios) == null ? void 0 : _post$audios.find(function (audio) {
    return audio.blocks.indexOf(itemBlock.id) >= 0;
  });
}
function removeHasChangesPost(post) {
  for (var index = 0; index < post.items.length; index++) {
    var itemBlock = post.items[index];
    if (Object.prototype.hasOwnProperty.call(itemBlock, 'has_change')) delete itemBlock.has_change;
  }
}

/**
 * Funciones utiles relacionadas con los elementos de html
 */
function getPosTop(idElement) {
  var element = document.getElementById(idElement);
  var boundingClientRect = element ? element.getBoundingClientRect() : null;
  var pos = boundingClientRect ? boundingClientRect.top : null;
  return pos;
}
function getPosBottom(idElement) {
  var element = document.getElementById(idElement);
  var boundingClientRect = element ? element.getBoundingClientRect() : null;
  var pos = boundingClientRect ? boundingClientRect.bottom : null;
  return pos;
}

var CLASS_PLAYER_AUDIO_BLOCK = 'mint-player-audio-ab';
var CLASS_PLAYER_AUDIO_CONTROL_BLOCK = 'mint-player-audio-control-ab';
var ID_DIV_LESSON_MENU = 'mint-lesson-menu';
var ID_DIV_LESSON_MENU_SHOW = 'mint-lesson-menu--show';
var MINT_AUDIO_BLOCK_BEGIN = 'mint-ab-begin'; // Se usa tanto para la CLASS como para la ID
var MINT_AUDIO_BLOCK_END = 'mint-ab-end'; // Se usa tanto para la CLASS como para la ID
var MINT_AUDIO_BLOCK_CON = 'mint-ab-con'; // Se usa tanto para la CLASS como para la ID
var MINT_AUDIO_BLOCK = 'mint-ab'; // Se usa tanto para la CLASS como para la ID
function AudioBlockWrap(props) {
  var children = props.children,
    audio = props.audio,
    item = props.item,
    uiActualPlayAudio = props.uiActualPlayAudio,
    setActualPlayAudio = props.setActualPlayAudio;
  var timer = useRef(null); // we can save timer in useRef and pass it to child
  function getIdAudioBlockBegin(idAudioBlock) {
    return MINT_AUDIO_BLOCK_BEGIN + '__' + idAudioBlock;
  }
  function getIdAudioBlockEnd(idAudioBlock) {
    return MINT_AUDIO_BLOCK_END + '__' + idAudioBlock;
  }
  function getIdAudioBlockCon(idAudioBlock) {
    return MINT_AUDIO_BLOCK_CON + '__' + idAudioBlock;
  }
  function getIdAudioBlock(idAudioBlock) {
    return MINT_AUDIO_BLOCK + '__' + idAudioBlock;
  }
  function getPageLeft(el) {
    var rect = el.getBoundingClientRect();
    var docEl = document.documentElement;
    return rect.left + (window.pageXOffset || docEl.scrollLeft || 0);
  }
  function onMouseOver(e, idAudioBlock, marginLeft, marginTop) {
    var isOpenMenuSidebar = document.getElementById(ID_DIV_LESSON_MENU_SHOW) ? true : false;
    var id = getIdAudioPlayer(idAudioBlock, true);
    if (id) {
      var el = document.getElementById(id);
      if (el && !isOpenMenuSidebar) {
        el.style.opacity = '1';
        el.style.filter = 'alpha(opacity=100)'; // IE fallback
      }
      // == Calculos la posicion x del altavoz general absoluto
      var elementItemBlock = document.getElementById('item-content-' + item.id);
      var forceX = null;
      if (elementItemBlock) {
        var elementsContentLeft = elementItemBlock.getElementsByClassName(CLASS_CONTENT_LEFT);
        var contentLeft = elementsContentLeft && elementsContentLeft.length ? elementsContentLeft[0] : undefined;
        // == Casos particulares
        if (!contentLeft) {
          if (item.type === 'lemonade' && item.family === 'lemonade') {
            var elemntsLemoQuestion = elementItemBlock.getElementsByClassName('lemo-question');
            contentLeft = elemntsLemoQuestion && elemntsLemoQuestion.length > 0 ? elemntsLemoQuestion[0] : undefined;
          }
        }
        if (contentLeft) {
          var left = getPageLeft(contentLeft);
          forceX = left + 30;
        }
      }
      updateStyleTop(idAudioBlock, marginLeft, marginTop, forceX);
    }
  }
  function onMouseOut(e, idAudioBlock) {
    if (idAudioBlock) {
      endAndStartTimerHideIconAudio(idAudioBlock);
    }
  }
  function endAndStartTimerHideIconAudio(idAudioBlock) {
    if (timer.current) window.clearTimeout(timer.current);
    timer.current = window.setTimeout(function () {
      if (timer.current) {
        var id = getIdAudioPlayer(idAudioBlock, true);
        if (id) {
          var el = document.getElementById(id);
          if (el) {
            el.style.opacity = '0';
            el.style.filter = 'alpha(opacity=0)'; // IE fallback
          }
        }
      }
    }, 2000);
  }
  function updateStyleTop(idAudioBlock, marginLeft, marginTop, forceX) {
    var idElementBegin = getIdAudioBlockBegin(idAudioBlock);
    var idElementEnd = getIdAudioBlockEnd(idAudioBlock);
    var idAudioPlayer = getIdAudioPlayer(idAudioBlock, true);
    var e = idAudioPlayer ? document.getElementById(idAudioPlayer) : null;
    var topVisorWrap = getPosTop('mint-id-lesson-visor-wrap');
    // =====  TOP ========
    var offsetRelativeY = Math.abs(window.scrollY - Math.abs(topVisorWrap || 0));
    var posBegin = getPosTop(idElementBegin);
    var posEnd = getPosBottom(idElementEnd);
    if (posBegin && !posEnd) {
      // == Miro si la causa es que el mismo item es begin y end
      var elementBegin = document.getElementById(idElementBegin);
      if (elementBegin && hasClass(elementBegin, idElementEnd)) {
        // == Si tiene el elemento begin la clase de mint-ab-end__XXXX es que es elemento end tambien
        posEnd = getPosBottom(idElementBegin);
      }
    }
    if (posBegin && posEnd) {
      var y = posBegin;
      var yBegin = posBegin - (topVisorWrap || 0); // Este apunta siempre al primer elemento con audio arriba de este
      var yEnd = posEnd - (topVisorWrap || 0); // == que  posEnd + window.scrollY - offsetRelativeY;
      var heightPlayIcon = getHeightById(MINT_ID_AUDIO_PLAYER_GENERAL_PREFIX + idAudioBlock, 32);
      if (posEnd > window.innerHeight) {
        // Esta abajo oculto su parte de abajo del elemento
        if (posBegin > 0) {
          // Esta visible la parte top del elemento begin
          y = posBegin + (window.innerHeight - posBegin) / 2 - (topVisorWrap || 0);
        } else {
          // Esta oculta la parte top del elemento begin
          // == Se muestra en la mitad de la ventana
          y = window.scrollY - offsetRelativeY + window.innerHeight / 2;
        }
      } else {
        // Esta visible su parte de abajo del elemento
        if (posBegin > 0) {
          // Esta visible la parte top del elemento begin
          y = yBegin + (yEnd - yBegin) / 2;
        } else {
          // Esta oculta la parte top del elemento begin
          y = yEnd - posEnd / 2;
          if (y > yEnd) y = yEnd - heightPlayIcon;
        }
      }
      // He visto que posEnd varia segun el scroll, por ejemplo si hago scroll y situo ese div de posBegin arriba de la pagina, entonces es 0, por lo que sus posiciones ya me sirven, no tengo que mirar el scroll de la pagina
      var yToRet = y - (marginTop ? marginTop : 0);
      if (yToRet < 0) yToRet = 0; // == Si estoy encima y se ha mostrado no puedo ponerlo fuera de la y de la pagina. la parte superior de la pagina es 0, independientemente de si hay scroll por arriba, es decir si ha bajado la pagina y se ha quedado scroll arriba
      if (e) e.style.top = yToRet + 'px';
    }
    // =====  LEFT ========
    var nodesAudioBlock = document.getElementsByClassName(getIdAudioBlock(idAudioBlock));
    var maxWidth = undefined;
    var nodeMaxWidth = undefined;
    if (nodesAudioBlock) {
      Array.prototype.forEach.call(nodesAudioBlock, function (node) {
        var width = node && node.offsetWidth ? node.offsetWidth : null;
        if (width) {
          if (maxWidth) {
            if (width > maxWidth) {
              maxWidth = width;
              nodeMaxWidth = node;
            }
          } else {
            maxWidth = width;
            nodeMaxWidth = node;
          }
        }
      });
    }
    if (maxWidth) {
      var weigthIcon = 35;
      var boundingClientRectMaxWidth = nodeMaxWidth ? nodeMaxWidth.getBoundingClientRect() : null;
      var leftMaxWidth = boundingClientRectMaxWidth ? boundingClientRectMaxWidth.left : null;
      var x = forceX ? forceX : leftMaxWidth || 0;
      var marginLeftConst = 60;
      var xToRet = x - weigthIcon - marginLeftConst - (marginLeft ? marginLeft : 0);
      if (xToRet < 0) xToRet = 0; // == Si estoy fuera lo pongo en 0, la parte izquierda de la pagina es 0, independientemente de si hay scroll horizontal que en mi caso no va haber nunca
      if (e) e.style.left = xToRet + 'px';
    }
  }
  /**
   * @param {string} classAdd Cadena que se va a añadir a la clase
   */
  function getDivWrapChilden(classAdd, idAudioBlock, id, marginLeft, marginTop) {
    if (classAdd === void 0) {
      classAdd = '';
    }
    var spaceNecessary = classAdd && classAdd.length > 0 && classAdd.charAt(0) != ' ';
    return /*#__PURE__*/React__default.createElement("div", {
      onMouseOver: idAudioBlock ? function (e) {
        return onMouseOver(e, idAudioBlock, marginLeft, marginTop);
      } : undefined,
      onMouseOut: idAudioBlock ? function (e) {
        return onMouseOut(e, idAudioBlock);
      } : undefined,
      className: '' + (spaceNecessary ? ' ' : '') + classAdd,
      id: id ? id : null
    }, children);
  }
  var componentAudio = null;
  var classPlayerAudio = 'mint-player-audio';
  var classPlayerAudioControl = 'mint-player-audio-control';
  var classAddHtmlText = '';
  var idHtmlText = null;
  /**
      ======================
      == Bloques de Audio ==
      ======================
  */
  var isAudioBlockBegin = false;
  var isAudioBlockEnd = false;
  var idAudioBlock = audio.guid;
  // == Inicio bloque audio => [ab$_Kalimba.mp3--NEXT--Sleep Away.mp3_$ab]
  if (audio.blocks.indexOf(item.id) === 0) {
    var _isAudioBlockEnd = audio.blocks.indexOf(item.id) === audio.blocks.length - 1;
    isAudioBlockBegin = true;
    componentAudio = /*#__PURE__*/React__default.createElement(AudioPlayerFloating, {
      audio: audio,
      nextAudio: undefined,
      isAudioBlock: true,
      uiActualPlayAudio: uiActualPlayAudio,
      setActualPlayAudio: setActualPlayAudio
    });
    classAddHtmlText = MINT_AUDIO_BLOCK + ' ' + getIdAudioBlock(idAudioBlock) + ' ' + MINT_AUDIO_BLOCK_BEGIN + ' ' + getIdAudioBlockBegin(idAudioBlock) + (_isAudioBlockEnd ? ' ' + MINT_AUDIO_BLOCK_END + ' ' + getIdAudioBlockEnd(idAudioBlock) : ''); // == Puede ser un bloque de inicio y fin a la vez
    idHtmlText = getIdAudioBlockBegin(idAudioBlock);
    classPlayerAudio = CLASS_PLAYER_AUDIO_BLOCK + ' ' + CLASS_PLAYER_AUDIO_BLOCK + '__' + idAudioBlock;
    classPlayerAudioControl = CLASS_PLAYER_AUDIO_CONTROL_BLOCK + ' ' + CLASS_PLAYER_AUDIO_CONTROL_BLOCK + '__' + idAudioBlock;
  }
  // == Fin bloque audio => [/ab$_Kalimba.mp3--NEXT--Sleep Away.mp3_$ab]
  if (!isAudioBlockBegin && audio.blocks.indexOf(item.id) === audio.blocks.length - 1) {
    isAudioBlockEnd = true;
    classAddHtmlText = MINT_AUDIO_BLOCK + ' ' + getIdAudioBlock(idAudioBlock) + ' ' + MINT_AUDIO_BLOCK_END + ' ' + getIdAudioBlockEnd(idAudioBlock);
    idHtmlText = getIdAudioBlockEnd(idAudioBlock);
  }
  // == Compruebo si es un bloque de continuacion de audio
  if (!isAudioBlockBegin && !isAudioBlockEnd) {
    if (audio.blocks.indexOf(item.id) < 0) ; else {
      classAddHtmlText = MINT_AUDIO_BLOCK + ' ' + getIdAudioBlock(idAudioBlock) + ' ' + MINT_AUDIO_BLOCK_CON + ' ' + getIdAudioBlockCon(idAudioBlock);
      idHtmlText = getIdAudioBlockCon(idAudioBlock);
    }
  }
  //@ts-ignore
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, componentAudio ? /*#__PURE__*/React__default.createElement("div", {
    className: classPlayerAudio
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classPlayerAudioControl
  }, componentAudio), getDivWrapChilden(classAddHtmlText, idAudioBlock, idHtmlText, null, null)) : getDivWrapChilden(classAddHtmlText, idAudioBlock, idHtmlText, null, null));
}

var PostItem = function PostItem(_ref) {
  var item = _ref.item,
    post = _ref.post,
    offsetVisibilityItemBlock = _ref.offsetVisibilityItemBlock,
    onChangeVisibilityItemblock = _ref.onChangeVisibilityItemblock,
    uiActualPlayAudio = _ref.uiActualPlayAudio,
    setActualPlayAudio = _ref.setActualPlayAudio,
    getSrc = _ref.getSrc,
    getComponentFooter = _ref.getComponentFooter,
    getComponentHead = _ref.getComponentHead,
    role = _ref.role,
    setItemBlockReady = _ref.setItemBlockReady,
    lessonId = _ref.lessonId;
  var audio = getAudioItemBlockPost(post, item);
  return /*#__PURE__*/React__default.createElement(VisibilitySensor, {
    partialVisibility: true,
    offset: offsetVisibilityItemBlock,
    key: item.id,
    onChange: function onChange(_isVisible) {
      onChangeVisibilityItemblock && onChangeVisibilityItemblock(item, _isVisible !== null && _isVisible !== undefined && _isVisible);
    }
  }, /*#__PURE__*/React__default.createElement(ConditionalWrapper, {
    condition: !!audio,
    wrapper: function wrapper(wrapperChildren) {
      return audio ? /*#__PURE__*/React__default.createElement(AudioBlockWrap, {
        audio: audio,
        item: item,
        uiActualPlayAudio: uiActualPlayAudio,
        setActualPlayAudio: setActualPlayAudio
      }, wrapperChildren) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
    }
  }, /*#__PURE__*/React__default.createElement(ItemBlock, {
    item: item,
    key: item.id,
    mode: IModesItemBlock.MODE_VISOR,
    getSrc: getSrc,
    getComponentFooter: getComponentFooter,
    getComponentHead: getComponentHead,
    role: role,
    onReady: function onReady() {
      return setItemBlockReady(item);
    },
    lessonId: lessonId
  })));
};

// Mapeo interno para convertir nuestros valores intuitivos a valores CSS
var alignHorizontalToCss = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
  'space-between': 'space-between',
  'space-around': 'space-around'
};
var alignVerticalToCss = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end',
  stretch: 'stretch'
};
function PostRow(_ref) {
  var _row$config4, _row$config5, _layout$config4, _row$config6, _layout$config5, _row$config7, _layout$config6, _row$config8, _layout$config7, _row$config9, _row$config10, _row$config11, _row$config12;
  var row = _ref.row,
    layout = _ref.layout,
    children = _ref.children;
  var getStackOnMobile = function getStackOnMobile() {
    var _row$config, _layout$config;
    if (((_row$config = row.config) == null ? void 0 : _row$config.stackOnMobile) !== undefined) return row.config.stackOnMobile;
    if ((layout == null || (_layout$config = layout.config) == null ? void 0 : _layout$config.defaultRowStackOnMobile) !== undefined) return layout.config.defaultRowStackOnMobile;
    return false;
  };
  // Convertir valores intuitivos a valores CSS
  var getJustifyContent = function getJustifyContent() {
    var _row$config2, _layout$config2;
    var alignHorizontal = ((_row$config2 = row.config) == null ? void 0 : _row$config2.alignHorizontal) || (layout == null || (_layout$config2 = layout.config) == null ? void 0 : _layout$config2.defaultRowAlignHorizontal) || 'center';
    return alignHorizontalToCss[alignHorizontal];
  };
  var getAlignItems = function getAlignItems() {
    var _row$config3, _layout$config3;
    var alignVertical = ((_row$config3 = row.config) == null ? void 0 : _row$config3.alignVertical) || (layout == null || (_layout$config3 = layout.config) == null ? void 0 : _layout$config3.defaultRowAlignVertical) || 'stretch';
    return alignVerticalToCss[alignVertical];
  };
  var justifyContent = getJustifyContent();
  // Determinar si debemos aplicar márgenes automáticos
  var shouldApplyMargins = !['space-between', 'space-around'].includes(((_row$config4 = row.config) == null ? void 0 : _row$config4.alignHorizontal) || 'center');
  var getPaddingValue = function getPaddingValue(value) {
    if (value === undefined || value === '') return undefined; // No definido
    if (value === 'none') return '0px'; // Explícitamente sin padding
    return value; // Valor específico
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "mint-post-row " + (getStackOnMobile() ? 'mint-post-row--stack-on-mobile' : ''),
    "data-breakpoint": ((_row$config5 = row.config) == null ? void 0 : _row$config5.mobileBreakpoint) || (layout == null || (_layout$config4 = layout.config) == null ? void 0 : _layout$config4.defaultRowMobileBreakpoint),
    style: _extends({
      width: ((_row$config6 = row.config) == null ? void 0 : _row$config6.width) || (layout == null || (_layout$config5 = layout.config) == null ? void 0 : _layout$config5.defaultRowWidth) || '100%',
      maxWidth: '100%',
      boxSizing: 'border-box',
      display: 'flex',
      justifyContent: justifyContent,
      alignItems: getAlignItems(),
      gap: ((_row$config7 = row.config) == null ? void 0 : _row$config7.gap) !== undefined ? row.config.gap : (layout == null || (_layout$config6 = layout.config) == null ? void 0 : _layout$config6.defaultRowGap) !== undefined ? layout.config.defaultRowGap : '0px',
      background: ((_row$config8 = row.config) == null ? void 0 : _row$config8.background) || (layout == null || (_layout$config7 = layout.config) == null ? void 0 : _layout$config7.defaultRowBackground) || 'transparent',
      paddingTop: getPaddingValue((_row$config9 = row.config) == null ? void 0 : _row$config9.paddingTop),
      paddingBottom: getPaddingValue((_row$config10 = row.config) == null ? void 0 : _row$config10.paddingBottom),
      paddingLeft: getPaddingValue((_row$config11 = row.config) == null ? void 0 : _row$config11.paddingLeft),
      paddingRight: getPaddingValue((_row$config12 = row.config) == null ? void 0 : _row$config12.paddingRight)
    }, shouldApplyMargins && {
      marginLeft: justifyContent === 'flex-start' ? '0' : 'auto',
      marginRight: justifyContent === 'flex-end' ? '0' : 'auto'
    })
  }, children);
}

function PostColumn(_ref) {
  var _column$config, _layout$config, _column$config2, _column$config3, _column$config4, _layout$config2;
  var column = _ref.column,
    layout = _ref.layout,
    row = _ref.row,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    key: column.guid,
    className: 'mint-post-column-item',
    style: {
      width: ((_column$config = column.config) == null ? void 0 : _column$config.width) || (layout == null || (_layout$config = layout.config) == null ? void 0 : _layout$config.defaultColumnWidth) || 100 / row.columns.length + "%",
      paddingLeft: ((_column$config2 = column.config) == null ? void 0 : _column$config2.paddingLeft) || '0px',
      paddingRight: ((_column$config3 = column.config) == null ? void 0 : _column$config3.paddingRight) || '0px',
      minWidth: '100px',
      background: ((_column$config4 = column.config) == null ? void 0 : _column$config4.background) || (layout == null || (_layout$config2 = layout.config) == null ? void 0 : _layout$config2.defaultColumnBackground) || 'transparent'
    }
  }, children);
}

var BackgroundWrapper = function BackgroundWrapper(_ref) {
  var backgroundImage = _ref.backgroundImage,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? '' : _ref$backgroundColor,
    _ref$overlayOpacity = _ref.overlayOpacity,
    overlayOpacity = _ref$overlayOpacity === void 0 ? 0 : _ref$overlayOpacity,
    _ref$overlayColor = _ref.overlayColor,
    overlayColor = _ref$overlayColor === void 0 ? 'white' : _ref$overlayColor,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$fixed = _ref.fixed,
    fixed = _ref$fixed === void 0 ? false : _ref$fixed;
  // Si no hay imagen ni color de fondo, retornamos los children directamente
  if (!backgroundImage && (!backgroundColor || backgroundColor === '')) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: className
    }, children);
  }
  var backgroundStyles = _extends({}, backgroundImage ? {
    backgroundImage: "url(" + encodeURI(backgroundImage) + ")"
  } : backgroundColor ? {
    background: backgroundColor
  } : {}, {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: fixed ? 'fixed' : 'scroll',
    position: fixed ? 'absolute' : 'relative'
  }, fixed ? {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  } : {}, {
    zIndex: fixed ? 0 : undefined
  });
  var overlayStyles = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: overlayColor,
    opacity: overlayOpacity,
    pointerEvents: 'none',
    zIndex: fixed ? 1 : undefined
  };
  var contentStyles = {
    position: 'relative',
    zIndex: 2,
    height: '100%',
    width: '100%'
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, fixed ?
  /*#__PURE__*/
  // Versión fixed (actual BackgroundWrapper)
  React__default.createElement("div", {
    className: className,
    style: {
      position: 'relative',
      height: '100%',
      isolation: 'isolate'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: backgroundStyles
  }), backgroundImage && /*#__PURE__*/React__default.createElement("div", {
    style: overlayStyles
  }), /*#__PURE__*/React__default.createElement("div", {
    style: contentStyles
  }, children)) :
  /*#__PURE__*/
  // Versión relative (actual PostBackground)
  React__default.createElement("div", {
    className: className,
    style: backgroundStyles
  }, backgroundImage && (overlayColor || overlayOpacity) && /*#__PURE__*/React__default.createElement("div", {
    style: overlayStyles
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: 'relative'
    }
  }, children)));
};

function Post(props) {
  var _post$layout;
  var post = props.post,
    getComponentFooter = props.getComponentFooter,
    getComponentHead = props.getComponentHead,
    role = props.role,
    onChangeVisibilityItemblock = props.onChangeVisibilityItemblock,
    uiActualPlayAudio = props.uiActualPlayAudio,
    setActualPlayAudio = props.setActualPlayAudio,
    lessonId = props.lessonId;
  var _usePost = usePost(_extends({}, props)),
    items = _usePost.items,
    getSrc = _usePost.getSrc,
    onChangeVisibilityPost = _usePost.onChangeVisibilityPost,
    isVisible = _usePost.isVisible,
    isReady = _usePost.isReady,
    offsetVisibilityPost = _usePost.offsetVisibilityPost,
    setItemBlockReady = _usePost.setItemBlockReady,
    offsetVisibilityItemBlock = _usePost.offsetVisibilityItemBlock;
  var _useGeneral = useGeneral();
  var background = (_post$layout = post.layout) == null || (_post$layout = _post$layout.config) == null ? void 0 : _post$layout.background;
  return isReady ? /*#__PURE__*/React__default.createElement(BackgroundWrapper, {
    className: 'mint-post mint-post--view',
    backgroundImage: background == null ? void 0 : background.backgroundImage,
    backgroundColor: background == null ? void 0 : background.backgroundColor,
    overlayOpacity: background == null ? void 0 : background.overlayOpacity,
    overlayColor: background == null ? void 0 : background.overlayColor,
    fixed: true
  }, /*#__PURE__*/React__default.createElement(VisibilitySensor, {
    partialVisibility: true,
    offset: offsetVisibilityPost,
    key: post.guid,
    onChange: function onChange(_isVisible) {
      onChangeVisibilityPost(_isVisible !== null && _isVisible !== undefined && _isVisible);
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-post',
    id: 'post-' + post.guid
  }, post.layout ? post.layout.rows.map(function (row) {
    return /*#__PURE__*/React__default.createElement(PostRow, {
      key: row.guid,
      row: row,
      layout: post.layout
    }, row.columns.map(function (column, indexColumn) {
      var itemBlock = items.find(function (item) {
        return item.id === column.itemId;
      });
      return itemBlock ? /*#__PURE__*/React__default.createElement(PostColumn, {
        key: itemBlock.id + indexColumn,
        column: column,
        layout: post.layout,
        row: row
      }, /*#__PURE__*/React__default.createElement(PostItem, {
        key: itemBlock.id,
        item: itemBlock,
        post: post,
        offsetVisibilityItemBlock: offsetVisibilityItemBlock,
        onChangeVisibilityItemblock: onChangeVisibilityItemblock,
        uiActualPlayAudio: uiActualPlayAudio,
        setActualPlayAudio: setActualPlayAudio,
        getSrc: getSrc,
        getComponentFooter: getComponentFooter,
        getComponentHead: getComponentHead,
        role: role,
        setItemBlockReady: setItemBlockReady,
        lessonId: lessonId
      })) : null;
    }));
  }) : items.map(function (item) {
    return /*#__PURE__*/React__default.createElement(PostItem, {
      key: item.id,
      item: item,
      post: post,
      offsetVisibilityItemBlock: offsetVisibilityItemBlock,
      onChangeVisibilityItemblock: onChangeVisibilityItemblock,
      uiActualPlayAudio: uiActualPlayAudio,
      setActualPlayAudio: setActualPlayAudio,
      getSrc: getSrc,
      getComponentFooter: getComponentFooter,
      getComponentHead: getComponentHead,
      role: role,
      setItemBlockReady: setItemBlockReady,
      lessonId: lessonId
    });
  }), props.getComponentBelowItems ? props.getComponentBelowItems(isVisible) : null))) : /*#__PURE__*/React__default.createElement("div", null);
}

function ProgressBar(props) {
  var progressBarPercentage = props.progressBarPercentage,
    classAdd = props.classAdd;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-progress-bar'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classNames('mint-progress-bar__progress', classAdd),
    style: {
      width: progressBarPercentage + '%'
    }
  }));
}

var MINT_ID_LESSON_VISOR_TITLE = 'mint-id-lesson-visor-title';
function LessonVisorTitle(props) {
  var title = props.title,
    progressBarPercentage = props.progressBarPercentage;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-lesson-visor-title',
    id: MINT_ID_LESSON_VISOR_TITLE
  }, /*#__PURE__*/React__default.createElement("h1", {
    className: 'mint-lesson-visor-title__head brand--first'
  }, /*#__PURE__*/React__default.createElement(TextHtmlVisor, {
    text: title
  })), /*#__PURE__*/React__default.createElement(ProgressBar, {
    progressBarPercentage: progressBarPercentage,
    classAdd: 'brand--background'
  }));
}

function PostsEmpty(props) {
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-posts-editor lesson'
  }, "No tiene posts"));
}

function getItemsHasBeenSeenLesson(lesson, itemsIdHasBeenSeen, role) {
  var itemsHasBeenSeen = [];
  for (var index = 0; index < lesson.items.length; index++) {
    var post = lesson.items[index];
    var itemsHasBeenSeenPost = getItemsHasBeenSeenPost(post, itemsIdHasBeenSeen, role);
    itemsHasBeenSeen = [].concat(itemsHasBeenSeen, itemsHasBeenSeenPost);
  }
  return itemsHasBeenSeen;
}
/**
 * Devuelve los items que podia renderizar
 */
function getItemsCanRenderLesson(lesson, role) {
  var itemsCanRender = [];
  for (var index = 0; index < lesson.items.length; index++) {
    var post = lesson.items[index];
    var itemsCanRenderPost = getItemsCanRenderPost(post, role);
    itemsCanRender = [].concat(itemsCanRender, itemsCanRenderPost);
  }
  return itemsCanRender;
}
/**
 * Devuelve el numero de items que puedo renderizar y he visto
 */
function getNumItemsHasBeenSeen(lesson, itemsIdHasBeenSeen, role) {
  var itemsHasBeenSeen = getItemsHasBeenSeenLesson(lesson, itemsIdHasBeenSeen, role);
  var numItemsHasbeenSeen = itemsHasBeenSeen ? itemsHasBeenSeen.length : 0;
  return numItemsHasbeenSeen;
}
/**
 * Devuelve el numero de items que puedo renderizar
 */
function getNumItemsCanRender(lesson, role) {
  var itemsCanRender = getItemsCanRenderLesson(lesson, role);
  var numItems = itemsCanRender ? itemsCanRender.length : 0;
  return numItems;
}
function getProgressLesson(lesson, itemsIdHasBeenSeen, role) {
  var numItemsCanRender = getNumItemsCanRender(lesson, role);
  var numItemsHasbeenSeen = getNumItemsHasBeenSeen(lesson, itemsIdHasBeenSeen, role);
  var progressBar = numItemsCanRender > 0 ? Math.floor(100 * numItemsHasbeenSeen / numItemsCanRender) : 0;
  return progressBar;
}
function removeHasChangesLesson(lesson) {
  for (var index = 0; index < lesson.items.length; index++) {
    var post = lesson.items[index];
    removeHasChangesPost(post);
  }
}

function LessonsEmpty(props) {
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-lessons-empty'
  }, "No tiene lecciones"));
}

var _path$k;
function _extends$D() { _extends$D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/createElement("svg", _extends$D({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    className: "icon icon--menu icon--lib-skin icon--size-big icon--color-default"
  }, props), _path$k || (_path$k = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6C2 5.44772 2.44772 5 3 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H3C2.44772 7 2 6.55228 2 6ZM2 12C2 11.4477 2.44772 11 3 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H3C2.44772 13 2 12.5523 2 12ZM3 17C2.44772 17 2 17.4477 2 18C2 18.5523 2.44772 19 3 19H15C15.5523 19 16 18.5523 16 18C16 17.4477 15.5523 17 15 17H3Z"
  })));
};

function UnitHeader(props) {
  var unit = props.unit,
    lessonActive = props.lessonActive,
    _props$isOpen = props.isOpen,
    isOpen = _props$isOpen === void 0 ? false : _props$isOpen,
    onButtonMenu = props.onButtonMenu,
    componentRight = props.componentRight;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-unit-header brand--second ' + (isOpen ? ' mint-unit-header--open-menu' : '')
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-unit-header__button-menu',
    onClick: onButtonMenu
  }, /*#__PURE__*/React__default.createElement(SvgMenu, null)), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-unit-header__unit-name'
  }, /*#__PURE__*/React__default.createElement(TextHtmlVisor, {
    text: unit.name
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-unit-header__lesson-name'
  }, /*#__PURE__*/React__default.createElement(TextHtmlVisor, {
    text: lessonActive.name || ''
  })), componentRight && /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-unit-header__right'
  }, componentRight));
}

function useUnitMenu(props) {
  var canDisableScrollBody = false; // == Si es true cuando este el menu abierto se desactiva el scroll del body
  var onChangeLessonActive = props.onChangeLessonActive,
    isOpen = props.isOpen;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useState = useState({});
  useEffect(function () {
    if (isOpen === true && canDisableScrollBody) {
      setScrollBody(false);
    } else if (isOpen === false && canDisableScrollBody) {
      setScrollBody(true);
    }
    return function () {
    };
  }, [isOpen]);
  function setScrollBody(show) {
    document.getElementsByTagName('body')[0].style.overflow = show ? 'auto' : 'hidden';
  }
  function onClickItem(lesson) {
    onChangeLessonActive(lesson);
  }
  return {
    t: t,
    onClickItem: onClickItem
  };
}

function UnitMenu(props) {
  var unit = props.unit,
    lessonActive = props.lessonActive,
    _props$isOpen = props.isOpen,
    isOpen = _props$isOpen === void 0 ? false : _props$isOpen,
    closeMenu = props.closeMenu;
  var _useUnitMenu = useUnitMenu(_extends({}, props)),
    onClickItem = _useUnitMenu.onClickItem;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-unit-menu' + (isOpen ? ' mint-unit-menu--open' : '')
  }, /*#__PURE__*/React__default.createElement(OutsideAlerter, {
    isActive: true,
    handleClickOutside: closeMenu,
    classListIgnoreClick: ['mint-unit-menu__item', 'mint-unit-header__button-menu']
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, unit.lessons.map(function (lesson) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: lesson.id,
      className: 'mint-unit-menu__item' + (lesson.id === lessonActive.id ? ' mint-unit-menu__item--active' : ''),
      onClick: function onClick() {
        return onClickItem(lesson);
      }
    }, lesson.id === lessonActive.id && /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-unit-menu__item-active'
    }), /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-unit-menu__item-name'
    }, /*#__PURE__*/React__default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: lesson.name || ''
      }
    })));
  }))));
}

/**
 * Devuelve el indice de la leccion activa o -1 si no la encuentra
 * @param unit
 * @param lessonActive
 * @returns
 */
function getLessonActiveIndex(unit, lessonActive) {
  var lessonActiveIndex = unit.lessons.findIndex(function (lesson) {
    return lesson.id === lessonActive.id;
  });
  return lessonActiveIndex;
}
function getLessonUnitById(unit, lessonId) {
  var lesson = unit.lessons.find(function (lesson) {
    return lesson.id === lessonId;
  });
  return lesson;
}
/**
 * Devuelve cual es la leccion siguiente o null si no la hay
 * @param unit
 * @param lessonActive
 */
function getLessonNext(unit, lessonActive) {
  var lessonActiveIndex = getLessonActiveIndex(unit, lessonActive);
  var lessonNext = null;
  if (lessonActiveIndex + 1 < unit.lessons.length) {
    // == Si hay leccion siguiente
    lessonNext = unit.lessons[lessonActiveIndex + 1];
  }
  return lessonNext;
}
/**
 * Devuelve cual es la leccion anterior o null si no la hay
 * @param unit
 * @param lessonActive
 */
function getLessonBack(unit, lessonActive) {
  var lessonActiveIndex = getLessonActiveIndex(unit, lessonActive);
  var lessonNext = null;
  if (lessonActiveIndex - 1 >= 0) {
    // == Si hay leccion anterior
    lessonNext = unit.lessons[lessonActiveIndex - 1];
  }
  return lessonNext;
}
function getFirstLessonUnit(unit) {
  var _lessons = unit && unit.lessons ? unit.lessons : [];
  return _lessons && _lessons.length > 0 ? _lessons[0] : null;
}

var useTokenStyles = function useTokenStyles(uiStyles) {
  var _uiStyles$button, _uiStyles$buttonInter, _uiStyles$media, _uiStyles$box, _uiStyles$boxProcess, _uiStyles$dialog, _uiStyles$note;
  var tokenStyles = _extends({}, (uiStyles == null ? void 0 : uiStyles.borderRadius) && {
    '--mint-border-radius': uiStyles.borderRadius
  }, (uiStyles == null || (_uiStyles$button = uiStyles.button) == null ? void 0 : _uiStyles$button.borderRadius) && {
    '--mint-button-border-radius': uiStyles.button.borderRadius
  }, (uiStyles == null || (_uiStyles$buttonInter = uiStyles.buttonInteractive) == null ? void 0 : _uiStyles$buttonInter.borderRadius) && {
    '--mint-button-interactive-border-radius': uiStyles.buttonInteractive.borderRadius
  }, (uiStyles == null || (_uiStyles$media = uiStyles.media) == null ? void 0 : _uiStyles$media.borderRadius) && {
    '--mint-media-border-radius': uiStyles.media.borderRadius
  }, (uiStyles == null || (_uiStyles$box = uiStyles.box) == null ? void 0 : _uiStyles$box.borderRadius) && {
    '--mint-box-border-radius': uiStyles.box.borderRadius
  }, (uiStyles == null || (_uiStyles$boxProcess = uiStyles.boxProcess) == null ? void 0 : _uiStyles$boxProcess.borderRadius) && {
    '--mint-box-process-border-radius': uiStyles.boxProcess.borderRadius
  }, (uiStyles == null || (_uiStyles$dialog = uiStyles.dialog) == null ? void 0 : _uiStyles$dialog.borderRadius) && {
    '--mint-dialog-border-radius': uiStyles.dialog.borderRadius
  }, (uiStyles == null || (_uiStyles$note = uiStyles.note) == null ? void 0 : _uiStyles$note.borderRadius) && {
    '--mint-note-border-radius': uiStyles.note.borderRadius
  });
  return {
    tokenStyles: tokenStyles
  };
};

function useUnit(props) {
  var unit = props.unit,
    getComponentBelowItemsPostLesson = props.getComponentBelowItemsPostLesson,
    getComponentHeadLesson = props.getComponentHeadLesson,
    getComponentFooterLesson = props.getComponentFooterLesson,
    getComponentEmptyPostLesson = props.getComponentEmptyPostLesson,
    lessonActive = props.lessonActive;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    uiStyles = _useGeneral.uiStyles;
  var _useTokenStyles = useTokenStyles(uiStyles),
    tokenStyles = _useTokenStyles.tokenStyles;
  var _useState = useState({
      lessons: getLessonsProps(),
      isOpenMenu: false
    }),
    state = _useState[0],
    dispatch = _useState[1];
  var lessonNext = useMemo(function () {
    return lessonActive ? getLessonNext(unit, lessonActive) : null;
  }, [unit, lessonActive == null ? void 0 : lessonActive.id]);
  var lessonBack = useMemo(function () {
    return lessonActive ? getLessonBack(unit, lessonActive) : null;
  }, [unit, lessonActive == null ? void 0 : lessonActive.id]);
  useEffect(function () {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        lessons: getLessonsProps()
      });
    });
  }, [unit]);
  function getLessonsProps() {
    return unit && unit.lessons ? unit.lessons : [];
  }
  function isEmpty() {
    if (state.lessons && state.lessons.length > 0) {
      // == Hay elementos
      return false;
    } else return true;
  }
  function closeMenu() {
    if (state.isOpenMenu) dispatch(function (prevState) {
      return _extends({}, prevState, {
        isOpenMenu: false
      });
    });
  }
  function openMenu() {
    if (!state.isOpenMenu) dispatch(function (prevState) {
      return _extends({}, prevState, {
        isOpenMenu: true
      });
    });
  }
  function onButtonMenu() {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        isOpenMenu: !prevState.isOpenMenu
      });
    });
  }
  return {
    t: t,
    isEmptyLessons: isEmpty(),
    lessonActive: lessonActive,
    isOpenMenu: state.isOpenMenu,
    lessonNext: lessonNext,
    lessonBack: lessonBack,
    getComponentBelowItemsPost: getComponentBelowItemsPostLesson && lessonActive ? function (post, onChangePost, isModePostEditor, isVisible) {
      return (
        // @ts-ignore ya he comprobado que state.lessonActive tenga valor
        getComponentBelowItemsPostLesson(state.lessonActive, post, onChangePost, isModePostEditor, isVisible)
      );
    } : undefined,
    getComponentHead: getComponentHeadLesson && lessonActive ?
    // @ts-ignore ya he comprobado que state.lessonActive tenga valor
    function (item) {
      return getComponentHeadLesson(state.lessonActive, item);
    } : undefined,
    getComponentFooter: getComponentFooterLesson && lessonActive ?
    // @ts-ignore ya he comprobado que state.lessonActive tenga valor
    function (item) {
      return getComponentFooterLesson(state.lessonActive, item);
    } : undefined,
    getComponentEmptyPost: getComponentEmptyPostLesson && lessonActive ?
    // @ts-ignore ya he comprobado que state.lessonActive tenga valor
    function () {
      return getComponentEmptyPostLesson(state.lessonActive);
    } : undefined,
    onChangeLessonActive: props.onChangeLessonActive,
    closeMenu: closeMenu,
    openMenu: openMenu,
    onButtonMenu: onButtonMenu,
    tokenStyles: tokenStyles
  };
}

var ID_DIV_LESSON_ACTIVE = 'mint-unit__lesson--active';
function Unit(props) {
  var unit = props.unit,
    role = props.role,
    componentRightHeader = props.componentRightHeader,
    configSelectionCoords = props.configSelectionCoords,
    configHighlights = props.configHighlights;
  var _useUnit = useUnit(props),
    isEmptyLessons = _useUnit.isEmptyLessons,
    lessonActive = _useUnit.lessonActive,
    isOpenMenu = _useUnit.isOpenMenu,
    lessonNext = _useUnit.lessonNext,
    lessonBack = _useUnit.lessonBack,
    getComponentBelowItemsPost = _useUnit.getComponentBelowItemsPost,
    getComponentHead = _useUnit.getComponentHead,
    getComponentFooter = _useUnit.getComponentFooter,
    getComponentEmptyPost = _useUnit.getComponentEmptyPost,
    onChangeLessonActive = _useUnit.onChangeLessonActive,
    closeMenu = _useUnit.closeMenu,
    onButtonMenu = _useUnit.onButtonMenu,
    tokenStyles = _useUnit.tokenStyles;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-lesson brand--second mint-unit' + (isOpenMenu ? ' mint-unit--open-menu' : ''),
    style: tokenStyles
  }, isEmptyLessons ? /*#__PURE__*/React__default.createElement(LessonsEmpty, null) : /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-unit__wrapper'
  }, lessonActive && /*#__PURE__*/React__default.createElement(UnitHeader, {
    unit: unit,
    lessonActive: lessonActive,
    isOpen: isOpenMenu,
    onButtonMenu: onButtonMenu,
    componentRight: componentRightHeader
  }), lessonActive && /*#__PURE__*/React__default.createElement(UnitMenu, {
    unit: unit,
    lessonActive: lessonActive,
    onChangeLessonActive: onChangeLessonActive,
    isOpen: isOpenMenu,
    closeMenu: closeMenu
  }), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-unit__lesson',
    id: ID_DIV_LESSON_ACTIVE
  }, lessonActive ? /*#__PURE__*/React__default.createElement(LessonWithLinks, {
    isOpen: isOpenMenu,
    lessonNext: lessonNext,
    lessonBack: lessonBack,
    lessonActive: lessonActive,
    getComponentBelowItemsPost: getComponentBelowItemsPost,
    getComponentHead: getComponentHead,
    getComponentFooter: getComponentFooter,
    getComponentEmptyPost: getComponentEmptyPost,
    role: role,
    onChangeLessonActive: onChangeLessonActive,
    configSelectionCoords: configSelectionCoords,
    configHighlights: configHighlights
  }) : /*#__PURE__*/React__default.createElement(LessonActiveEmpty, null))));
}

/**
 * Añade la clase del parametro classAdd a todos los span que estan dentro del container excepto los que tenga la clase classIgnore
 * @param container
 * @param classAdd
 * @param classIgnore Clase que ignorará ese elemento, ejemplo 'hl-highlight' que es la clase de los resaltes
 */
function addClassSpanBackgrounds(container, classAdd, classIgnore) {
  // obtener el div específico por su id
  if (container) {
    // buscar en todos los elementos span que son hijos de este div
    var spans = container.querySelectorAll('span');
    for (var i = 0; i < spans.length; i++) {
      var span = spans[i];
      var spanColor = window.getComputedStyle(span).getPropertyValue('background-color');
      // comprobar si el elemento span tiene un color de fondo y no tiene la clase 'hl-highlight'
      if (spanColor && spanColor !== 'rgba(0, 0, 0, 0)' && !span.classList.contains(classIgnore)) {
        // añadir la clase 'pepito'
        span.classList.add(classAdd);
      }
    }
  }
}
/**
 * Elimina la clase classRemove de todos los span que estan dentro del container y no tengan color de fondo
 * @param container
 */
function removeClassSpanEmptyBackgrounds(container, classRemove) {
  if (container) {
    // buscar en todos los elementos span que son hijos de este div
    var spans = container.querySelectorAll('span');
    for (var i = 0; i < spans.length; i++) {
      var span = spans[i];
      var spanColor = window.getComputedStyle(span).getPropertyValue('background-color');
      // comprobar si el elemento span NO tiene un color de fondo y tiene la clase 'pepito'
      if (spanColor === 'rgba(0, 0, 0, 0)' && span.classList.contains(classRemove)) {
        // quitar la clase 'pepito'
        span.classList.remove(classRemove);
        console.log(span.getAttribute('class'));
        // Si el atributo class está vacío, elimínalo.
        if (span.getAttribute('class') === '') {
          span.removeAttribute('class');
        }
      }
    }
  }
}

function useClassSpanBackgroundsVisor(props) {
  var isReady = props.isReady;
  var _useGeneral = useGeneral(),
    addClassSpanBackgroundsVisor = _useGeneral.addClassSpanBackgroundsVisor;
  var classAdd = addClassSpanBackgroundsVisor;
  useEffect(function () {
    if (classAdd && isReady) {
      var frViewElems = document.querySelectorAll('#' + ID_LESSON_VISOR + ' .fr-view'); // == Solo los que tengan la clase 'fr-view' que es el html que se hizo con froala
      frViewElems.forEach(function (frViewElem) {
        removeClassSpanEmptyBackgrounds(frViewElem, classAdd);
        addClassSpanBackgrounds(frViewElem, classAdd, CLASS_HIGHLIGHT);
      });
    }
  }, [isReady]);
  return {};
}

function useLessonVisor(props) {
  var lesson = props.lesson,
    itemsIdHasBeenSeen = props.itemsIdHasBeenSeen,
    role = props.role;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    showLessonTitles = _useGeneral.showLessonTitles,
    backgroundVisor = _useGeneral.backgroundVisor,
    isSinglePost = _useGeneral.isSinglePost,
    uiStyles = _useGeneral.uiStyles;
  var _useTokenStyles = useTokenStyles(uiStyles),
    tokenStyles = _useTokenStyles.tokenStyles;
  var _useState = useState({
      isReady: false,
      uiActualPlayAudio: undefined
    }),
    state = _useState[0],
    dispatch = _useState[1];
  _objectDestructuringEmpty(useClassSpanBackgroundsVisor({
    isReady: state.isReady
  }));
  var postPendingReady = useRef(getPostPendingReady(getPostsProps()));
  useEffect(function () {
    var _postPendingReady = getPostPendingReady(getPostsProps());
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        isReady: false
      });
    });
    postPendingReady.current = _postPendingReady;
    scrollToTop();
  }, [lesson.id]);
  function getPostPendingReady(post) {
    return post.filter(function (_post) {
      return _post.items && _post.items.length > 0;
    }).map(function (_post) {
      return _post.guid;
    });
  }
  function getPostsProps() {
    return lesson && lesson.items ? lesson.items : [];
  }
  function isEmpty() {
    var posts = getPostsProps();
    if (posts && posts.length > 0) {
      // == Hay elementos
      return false;
    } else return true;
  }
  /**
   * Establece que un post está ready, por lo que lo quita de la lista de postPendingReady
   */
  function setPostReady(post) {
    postPendingReady.current = postPendingReady.current.filter(function (_post) {
      return _post !== post.guid;
    });
    if (postPendingReady.current.length === 0) {
      // == Si no hay post pendientes de guardar establezco que la lesson está ready
      // == Lesson is ready
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          isReady: true
        });
      });
    }
  }
  function scrollToTop() {
    var _document$getElementB;
    if ((_document$getElementB = document.getElementById(ID_DIV_LESSON_ACTIVE)) != null && _document$getElementB.scrollTo) {
      var _document$getElementB2;
      // No hago una animacion al subir al inicio porque sino al venir de una pagina con scroll grande y estar abajo luego al pasar de pagina y subir, los post de abajo de la siguiente pagina los notifica como vistos
      (_document$getElementB2 = document.getElementById(ID_DIV_LESSON_ACTIVE)) == null || _document$getElementB2.scrollTo(0, 0 /*{ top: 0, left: 0, behavior: 'smooth' }*/);
    }
  }

  function setActualPlayAudio(actualPlayAudio) {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        uiActualPlayAudio: actualPlayAudio
      });
    });
  }
  return {
    t: t,
    isEmptyPosts: isEmpty(),
    posts: getPostsProps(),
    setPostReady: setPostReady,
    isReady: state.isReady,
    isContentReadyHighlighter: state.isReady,
    showLessonTitles: showLessonTitles,
    progressLesson: getProgressLesson(lesson, itemsIdHasBeenSeen || [], role),
    setActualPlayAudio: setActualPlayAudio,
    uiActualPlayAudio: state.uiActualPlayAudio,
    backgroundVisor: backgroundVisor,
    isSinglePost: isSinglePost,
    tokenStyles: tokenStyles
  };
}

function LessonVisor(props) {
  var lesson = props.lesson,
    getComponentBelowItemsPost = props.getComponentBelowItemsPost,
    getComponentHead = props.getComponentHead,
    getComponentFooter = props.getComponentFooter,
    getComponentEmptyPost = props.getComponentEmptyPost,
    role = props.role,
    configSelectionCoords = props.configSelectionCoords,
    configHighlights = props.configHighlights,
    onChangeVisibilityItemblockPost = props.onChangeVisibilityItemblockPost;
  var _useLessonVisor = useLessonVisor(props),
    t = _useLessonVisor.t,
    isEmptyPosts = _useLessonVisor.isEmptyPosts,
    posts = _useLessonVisor.posts,
    isContentReadyHighlighter = _useLessonVisor.isContentReadyHighlighter,
    _setPostReady = _useLessonVisor.setPostReady,
    showLessonTitles = _useLessonVisor.showLessonTitles,
    progressLesson = _useLessonVisor.progressLesson,
    setActualPlayAudio = _useLessonVisor.setActualPlayAudio,
    uiActualPlayAudio = _useLessonVisor.uiActualPlayAudio,
    backgroundVisor = _useLessonVisor.backgroundVisor,
    isSinglePost = _useLessonVisor.isSinglePost,
    tokenStyles = _useLessonVisor.tokenStyles;
  var visiblePosts = isSinglePost ? [posts[0]] : posts;
  return /*#__PURE__*/React__default.createElement(BackgroundWrapper, {
    backgroundImage: backgroundVisor == null ? void 0 : backgroundVisor.backgroundImage,
    backgroundColor: backgroundVisor == null ? void 0 : backgroundVisor.backgroundColor,
    overlayOpacity: backgroundVisor == null ? void 0 : backgroundVisor.overlayOpacity,
    overlayColor: backgroundVisor == null ? void 0 : backgroundVisor.overlayColor
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-lesson-visor-wrap',
    id: 'mint-id-lesson-visor-wrap'
  }, showLessonTitles && /*#__PURE__*/React__default.createElement(LessonVisorTitle, {
    title: lesson.name || '',
    progressBarPercentage: progressLesson
  }), /*#__PURE__*/React__default.createElement(ConditionalWrapper, {
    condition: configHighlights !== undefined,
    wrapper: function wrapper(wrapperChildren) {
      return /*#__PURE__*/React__default.createElement(Highlighter, {
        hasSelectedText: function hasSelectedText(selectionGeneral, selections) {
          // console.log(selectedText, x, y, idDivSelectText, start, end);
        },
        hasNotSelectedText: function hasNotSelectedText() {},
        config: {
          // @ts-ignore => ya está comprobado en condition que configHighlights sea distinto a undefine
          selectionCoords: getConfigSelectionCoords(configSelectionCoords),
          // @ts-ignore => ya está comprobado en condition que configHighlights sea distinto a undefine
          highlights: getConfigHighlights(configHighlights)
        },
        strings: {
          stringHighlight: t('highlighter_highlight'),
          stringEditColorHighlight: t('highlighter_edit_color_highlight'),
          stringRemoveHighlight: t('highlighter_remove_highlight')
        },
        isContentReady: isContentReadyHighlighter,
        refresh: lesson.id
      }, wrapperChildren);
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-lesson brand--second mint-lesson-visor',
    id: ID_LESSON_VISOR,
    style: tokenStyles
  }, isEmptyPosts ? getComponentEmptyPost ? getComponentEmptyPost() : /*#__PURE__*/React__default.createElement(PostsEmpty, null) : visiblePosts.map(function (post) {
    return /*#__PURE__*/React__default.createElement(Post, {
      key: post.guid,
      post: post,
      getComponentBelowItems: function getComponentBelowItems(isVisible) {
        return getComponentBelowItemsPost ? getComponentBelowItemsPost(post, function () {}, false, isVisible) : null;
      },
      getComponentHead: getComponentHead,
      getComponentFooter: getComponentFooter,
      role: role,
      setPostReady: function setPostReady() {
        return _setPostReady(post);
      },
      onChangeVisibilityItemblock: function onChangeVisibilityItemblock(item, isVisible) {
        return onChangeVisibilityItemblockPost && onChangeVisibilityItemblockPost(item, post, isVisible);
      },
      setActualPlayAudio: setActualPlayAudio,
      uiActualPlayAudio: uiActualPlayAudio,
      lessonId: lesson.id
    });
  }))),
  /*#__PURE__*/
  // Contenedor bloques de audio
  React__default.createElement("div", {
    className: MINT_ID_AUDIOS_BLOCKS_GENERAL,
    id: MINT_ID_AUDIOS_BLOCKS_GENERAL
  })));
}

function LessonLink(props) {
  var text = props.text;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-lesson-link'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-lesson-link__link brand--first'
  }, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: text || ''
    }
  })));
}

var MINT_ID_LESSON_LINK_BACK = 'mint-id-lesson-link-back';
function LessonLinkBack(props) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var lessonBack = props.lessonBack,
    onClick = props.onClick;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-lesson-link-back',
    id: MINT_ID_LESSON_LINK_BACK,
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement(LessonLink, {
    text: lessonBack && lessonBack.name ? lessonBack.name : t('lesson_link_home')
  }));
}

function LessonLinkNext(props) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var lessonNext = props.lessonNext,
    onClick = props.onClick;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-lesson-link-next',
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement(LessonLink, {
    text: lessonNext && lessonNext.name ? lessonNext.name : t('lesson_link_home')
  }));
}

function useLessonWithLinks(props) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var onChangeLessonActive = props.onChangeLessonActive,
    lessonBack = props.lessonBack,
    lessonNext = props.lessonNext,
    onClickLinkToHome = props.onClickLinkToHome;
  function onBack() {
    if (lessonBack) {
      lessonBack && onChangeLessonActive(lessonBack);
    } else {
      onClickLinkToHome && onClickLinkToHome();
    }
  }
  function onNext() {
    lessonNext && onChangeLessonActive(lessonNext);
  }
  return {
    t: t,
    onBack: onBack,
    onNext: onNext,
    showLinkBack: lessonBack || onClickLinkToHome
  };
}

function LessonWithLinks(props) {
  var lessonBack = props.lessonBack,
    lessonNext = props.lessonNext,
    lessonActive = props.lessonActive,
    getComponentBelowItemsPost = props.getComponentBelowItemsPost,
    getComponentHead = props.getComponentHead,
    getComponentFooter = props.getComponentFooter,
    getComponentEmptyPost = props.getComponentEmptyPost,
    role = props.role,
    configSelectionCoords = props.configSelectionCoords,
    configHighlights = props.configHighlights,
    onChangeVisibilityItemblockPost = props.onChangeVisibilityItemblockPost,
    itemsIdHasBeenSeen = props.itemsIdHasBeenSeen;
  var _useLessonWithLinks = useLessonWithLinks(props),
    onBack = _useLessonWithLinks.onBack,
    onNext = _useLessonWithLinks.onNext,
    showLinkBack = _useLessonWithLinks.showLinkBack;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-lesson-with-links'
  }, showLinkBack && /*#__PURE__*/React__default.createElement(LessonLinkBack, {
    lessonBack: lessonBack,
    onClick: onBack
  }), /*#__PURE__*/React__default.createElement(LessonVisor, {
    lesson: lessonActive,
    getComponentBelowItemsPost: getComponentBelowItemsPost,
    getComponentHead: getComponentHead,
    getComponentFooter: getComponentFooter,
    getComponentEmptyPost: getComponentEmptyPost,
    role: role,
    configSelectionCoords: configSelectionCoords,
    configHighlights: configHighlights,
    onChangeVisibilityItemblockPost: onChangeVisibilityItemblockPost,
    itemsIdHasBeenSeen: itemsIdHasBeenSeen
  }), lessonNext && /*#__PURE__*/React__default.createElement(LessonLinkNext, {
    lessonNext: lessonNext,
    onClick: onNext
  }));
}

function useIndexItemUnitType2(props) {
  var itemsIdHasBeenSeen = props.itemsIdHasBeenSeen,
    unit = props.unit,
    role = props.role;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useState = useState({
      progressLessons: {}
    }),
    state = _useState[0],
    dispatch = _useState[1];
  useEffect(function () {
    var progressLessons = {};
    for (var index = 0; index < unit.lessons.length; index++) {
      var lesson = unit.lessons[index];
      progressLessons[lesson.id] = _getProgressLesson(lesson);
    }
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        progressLessons: progressLessons
      });
    });
  }, [unit.id, itemsIdHasBeenSeen == null ? void 0 : itemsIdHasBeenSeen.length]);
  function _getProgressLesson(lesson) {
    return getProgressLesson(lesson, itemsIdHasBeenSeen || [], role);
  }
  return {
    t: t,
    getProgressLesson: _getProgressLesson,
    progressLessons: state.progressLessons
  };
}

var _path$l, _path2$7;
function _extends$E() { _extends$E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }
var SvgArrowBottom = function SvgArrowBottom(props) {
  return /*#__PURE__*/createElement("svg", _extends$E({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-arrow-bottom",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path$l || (_path$l = /*#__PURE__*/createElement("path", {
    d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
  })), _path2$7 || (_path2$7 = /*#__PURE__*/createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
};

function useIndexItemLessonType2(props) {
  var progressBarPercentage = props.progressBarPercentage;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useState = useState({});
  function getStatusLesson() {
    if (progressBarPercentage === 100) {
      return StatusIndexLesson.STATUS_READ;
    } else if (progressBarPercentage === 0) {
      return StatusIndexLesson.STATUS_NOT_READ;
    } else {
      return StatusIndexLesson.STATUS_PROGRESS;
    }
  }
  return {
    t: t,
    status: getStatusLesson()
  };
}

var _path$m;
function _extends$F() { _extends$F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }
var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends$F({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$m || (_path$m = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 29.2999C23.5693 29.2999 29.3 23.5692 29.3 16.5C29.3 9.43071 23.5693 3.69995 16.5 3.69995C9.43077 3.69995 3.70001 9.43071 3.70001 16.5C3.70001 23.5692 9.43077 29.2999 16.5 29.2999ZM22.4314 14.4313C23.0562 13.8065 23.0562 12.7934 22.4314 12.1686C21.8065 11.5437 20.7935 11.5437 20.1686 12.1686L14.9 17.4372L12.8314 15.3686C12.2065 14.7437 11.1935 14.7437 10.5686 15.3686C9.9438 15.9934 9.9438 17.0065 10.5686 17.6313L13.7686 20.8313C14.3935 21.4562 15.4065 21.4562 16.0314 20.8313L22.4314 14.4313Z",
    fill: "#4F4FFF"
  })));
};

var ITypeTextHtmlTagName;
(function (ITypeTextHtmlTagName) {
  ITypeTextHtmlTagName["H1"] = "h1";
  ITypeTextHtmlTagName["SPAN"] = "span";
  ITypeTextHtmlTagName["DIV"] = "div";
  ITypeTextHtmlTagName["P"] = "p";
})(ITypeTextHtmlTagName || (ITypeTextHtmlTagName = {}));

function Text(props) {
  var _props$text = props.text,
    text = _props$text === void 0 ? '' : _props$text,
    classAdd = props.classAdd,
    _props$as = props.as,
    Component = _props$as === void 0 ? ITypeTextHtmlTagName.DIV : _props$as;
  return /*#__PURE__*/React__default.createElement(Component, {
    className: classAdd
  }, text);
}

function TextGeneral(props) {
  var _props$isHtmlVisor = props.isHtmlVisor,
    isHtmlVisor = _props$isHtmlVisor === void 0 ? true : _props$isHtmlVisor;
  return isHtmlVisor ? /*#__PURE__*/React__default.createElement(TextHtmlVisor, Object.assign({}, props)) : /*#__PURE__*/React__default.createElement(Text, Object.assign({}, props));
}

function TextSmallBold14And24(props) {
  var _props$classAdd = props.classAdd,
    classAdd = _props$classAdd === void 0 ? '' : _props$classAdd;
  var customClass = "mint-text-small-bold-14-24 " + classAdd;
  return /*#__PURE__*/React__default.createElement(TextGeneral, Object.assign({}, props, {
    classAdd: customClass
  }));
}

var StatusIndexLesson;
(function (StatusIndexLesson) {
  StatusIndexLesson["STATUS_NOT_READ"] = "STATUS_NOT_READ";
  StatusIndexLesson["STATUS_READING"] = "STATUS_READING";
  StatusIndexLesson["STATUS_PROGRESS"] = "STATUS_PROGRESS";
  StatusIndexLesson["STATUS_READ"] = "STATUS_READ";
})(StatusIndexLesson || (StatusIndexLesson = {}));
// En livebook era LessonType2.js
function IndexItemLessonType2(props) {
  var active = props.active,
    title = props.title,
    progressBarPercentage = props.progressBarPercentage,
    _onClick = props.onClick;
  var _useIndexItemLessonTy = useIndexItemLessonType2(props),
    status = _useIndexItemLessonTy.status;
  return (
    /*#__PURE__*/
    // <div className='mint-index-item-unit-type2'>
    React__default.createElement("a", {
      href: '#',
      className: 'mint-main-page__subindex-link ' + (active ? 'mint-main-page__subindex-link--active ' : '') + (status === StatusIndexLesson.STATUS_READING ? 'mint-main-page__subindex-link--reading' : status === StatusIndexLesson.STATUS_READ ? 'mint-main-page__subindex-link--read' : status === StatusIndexLesson.STATUS_PROGRESS || status === StatusIndexLesson.STATUS_NOT_READ ? 'mint-main-page__subindex-link--unread' : ''),
      onClick: function onClick(e) {
        e.stopPropagation();
        e.preventDefault();
        _onClick(e);
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-main-page__subindex-progress brand--first'
    }, status === StatusIndexLesson.STATUS_READ ? /*#__PURE__*/React__default.createElement(SvgCheckCircle, {
      className: 'mint-main-page__subindex-icon-check-circle'
    }) : /*#__PURE__*/React__default.createElement(CircularProgressbar, {
      value: progressBarPercentage
    })), /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-main-page__subindex-text brand--first'
    }, /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-main-page__subindex-text-text'
    }, /*#__PURE__*/React__default.createElement(TextSmallBold14And24, {
      text: title
    }))))
  );
}

// En livebook era UnityType2.js
function IndexItemUnitType2(props) {
  var unit = props.unit,
    isOpenUnit = props.isOpenUnit,
    onClickUnit = props.onClickUnit,
    lessonActive = props.lessonActive,
    onClickLesson = props.onClickLesson;
  var _useIndexItemUnitType = useIndexItemUnitType2(props),
    progressLessons = _useIndexItemUnitType.progressLessons;
  return (
    /*#__PURE__*/
    // <div className='mint-index-item-unit-type2'>
    React__default.createElement("div", {
      className: 'mint-main-page__index-unity ' + (isOpenUnit ? 'mint-main-page__index-unity--show' : 'mint-main-page__index-unity--hidden'),
      onClick: function onClick(e) {
        e.stopPropagation();
        e.preventDefault();
        onClickUnit(e);
      }
    }, /*#__PURE__*/React__default.createElement("a", {
      href: '#',
      className: 'mint-main-page__index-unity-link'
    }, /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-main-page__index-unity-text brand--first'
    }, /*#__PURE__*/React__default.createElement(TextSmallBold14And24, {
      text: unit.name
    })), /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-main-page__index-unity-icon'
    }, /*#__PURE__*/React__default.createElement(SvgArrowBottom, null))), /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-main-page__subindex'
    }, unit.lessons ? unit.lessons.map(function (lesson, index) {
      return /*#__PURE__*/React__default.createElement(IndexItemLessonType2, {
        key: lesson.id,
        number: ('0' + (index + 1)).slice(-2),
        active: lessonActive && lessonActive.id === lesson.id ? true : false,
        title: lesson.name || '',
        progressBarPercentage: progressLessons[lesson.id] || 0,
        onClick: function onClick(e) {
          return onClickLesson(e, lesson);
        }
      });
    }) : ''))
  );
}

function useIndexLessonListType2(props) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useState = useState({});
  return {
    t: t
  };
}

// En livebook era LessonListType2.js
function IndexLessonListType2(props) {
  var course = props.course,
    lessonActive = props.lessonActive,
    unitOpenId = props.unitOpenId,
    role = props.role,
    onClickLesson = props.onClickLesson,
    _onClickUnit = props.onClickUnit,
    itemsIdHasBeenSeen = props.itemsIdHasBeenSeen;
  var _useIndexLessonListTy = useIndexLessonListType2();
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-index-lesson-list-type2'
  }, course.units ? course.units.map(function (unit) {
    return /*#__PURE__*/React__default.createElement(IndexItemUnitType2, {
      key: unit.id,
      unit: unit,
      isOpenUnit: unit.id == unitOpenId,
      lessonActive: lessonActive,
      onClickLesson: onClickLesson,
      onClickUnit: function onClickUnit(e) {
        return _onClickUnit(e, unit);
      },
      itemsIdHasBeenSeen: itemsIdHasBeenSeen,
      role: role
    });
  }) : '');
}

function useMenuLessonCoursePageType2(props) {
  var _course$coverImage;
  var course = props.course,
    onChangeUnitOpenMenuId = props.onChangeUnitOpenMenuId,
    unitOpenMenuId = props.unitOpenMenuId,
    pathBaseRoute = props.pathBaseRoute;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    getSrc = _useGeneral.getSrc;
  var navigate = useNavigate();
  var _useState = useState({});
  function onClickUnit(e, unit) {
    // Si esta abierta se cierra
    onChangeUnitOpenMenuId(unit.id === unitOpenMenuId ? null : unit.id);
  }
  function onClickHome() {
    navigate(pathBaseRoute || '/');
  }
  return {
    t: t,
    coverImage: (_course$coverImage = course.coverImage) != null && _course$coverImage.src ? getSrc(course.coverImage.src) : undefined,
    onClickUnit: onClickUnit,
    onClickHome: onClickHome
  };
}

function MenuLessonCoursePageType2(props) {
  var course = props.course,
    lessonActive = props.lessonActive,
    unitOpenMenuId = props.unitOpenMenuId,
    onChangeLessonActive = props.onChangeLessonActive,
    role = props.role,
    itemsIdHasBeenSeen = props.itemsIdHasBeenSeen;
  var _useMenuLessonCourseP = useMenuLessonCoursePageType2(props),
    coverImage = _useMenuLessonCourseP.coverImage,
    onClickUnit = _useMenuLessonCourseP.onClickUnit,
    onClickHome = _useMenuLessonCourseP.onClickHome;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-menu-lesson-course-page-type2'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-lesson-menu__menu'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-lesson-menu__content brand--background'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-lesson-menu__skin'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-lesson-menu__skin-title-and-img'
  }, coverImage && /*#__PURE__*/React__default.createElement("img", {
    className: 'mint-lesson-menu__skin-img',
    src: coverImage
  }), lessonActive && /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-lesson-menu__new-title brand--first',
    onClick: onClickHome
  }, /*#__PURE__*/React__default.createElement(TextHtmlVisor, {
    text: /*lessonActive.name*/course.name
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-lesson-menu__skin-index mint-lesson-menu__skin--show'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-main-page__index mint-main-page__index--min'
  }, /*#__PURE__*/React__default.createElement(IndexLessonListType2, {
    course: course,
    lessonActive: lessonActive,
    unitOpenId: unitOpenMenuId,
    onClickLesson: function onClickLesson(e, lesson) {
      return onChangeLessonActive(lesson);
    },
    onClickUnit: onClickUnit,
    role: role,
    itemsIdHasBeenSeen: itemsIdHasBeenSeen
  })))))));
}

function getLessonCourseById(course, lessonId) {
  var lesson = undefined;
  var unitFoundLesson = course.units.find(function (unit) {
    var lessonFound = getLessonUnitById(unit, lessonId);
    if (lessonFound) {
      lesson = lessonFound;
    }
    return lessonFound !== undefined;
  });
  return lesson;
}
function getFirstUnitCourse(course) {
  var units = course && course.units ? course.units : [];
  return units && units.length > 0 ? units[0] : null;
}
function getUnitLesson(course, lessonId) {
  var unitToRet = undefined;
  var unitFoundLesson = course.units.find(function (unit) {
    var lessonFound = getLessonUnitById(unit, lessonId);
    if (lessonFound) {
      unitToRet = unit;
    }
    return lessonFound !== undefined;
  });
  return unitToRet;
}
function getUnitIdFromLesson(course, lessonId) {
  var unitFound = lessonId ? getUnitLesson(course, lessonId) : null;
  return unitFound ? unitFound.id : null;
}
function getFirstLessonCourse(course) {
  var firstUnitCourse = getFirstUnitCourse(course);
  var firstLessonUnit = getFirstLessonUnit(firstUnitCourse);
  return firstLessonUnit;
}
function getListOnlyLessonsIdCourse(course) {
  var arr = [];
  for (var indexUnit = 0; indexUnit < course.units.length; indexUnit++) {
    var unit = course.units[indexUnit];
    for (var indexLesson = 0; indexLesson < unit.lessons.length; indexLesson++) {
      var lesson = unit.lessons[indexLesson];
      arr.push(lesson.id);
    }
  }
  return arr;
}
function getLessonPreviousAndNextCourse(course, lessonActive) {
  var toRet = {
    back: null,
    next: null
  };
  var listOnlyLessonsId = getListOnlyLessonsIdCourse(course);
  if (lessonActive && listOnlyLessonsId) {
    var index = listOnlyLessonsId.indexOf(lessonActive.id);
    if (index >= 0) {
      //La encuentra
      if (index - 1 >= 0) {
        // Hay anterior
        var idLessonPrevious = listOnlyLessonsId[index - 1];
        if (idLessonPrevious) {
          var lessonPrevious = getLessonCourseById(course, idLessonPrevious);
          if (lessonPrevious) {
            toRet.back = lessonPrevious;
          }
        }
      }
      if (index + 1 < listOnlyLessonsId.length) {
        // Hay siguiente
        var idLessonNext = listOnlyLessonsId[index + 1];
        if (idLessonNext) {
          var lessonNext = getLessonCourseById(course, idLessonNext);
          if (lessonNext) {
            toRet.next = lessonNext;
          }
        }
      }
    }
  }
  return toRet;
}
function getProgressCourse(course, itemsIdHasBeenSeen, role) {
  var numItemsCanRenderTotal = 0;
  var numItemsHasBeenSeenTotal = 0;
  for (var indexUnit = 0; indexUnit < course.units.length; indexUnit++) {
    var unit = course.units[indexUnit];
    for (var indexLesson = 0; indexLesson < unit.lessons.length; indexLesson++) {
      var lesson = unit.lessons[indexLesson];
      var numItemsCanRender = getNumItemsCanRender(lesson, role);
      var numItemsHasBeenSeen = getNumItemsHasBeenSeen(lesson, itemsIdHasBeenSeen, role);
      numItemsCanRenderTotal += numItemsCanRender;
      numItemsHasBeenSeenTotal += numItemsHasBeenSeen;
    }
  }
  var progressBar = numItemsCanRenderTotal > 0 ? Math.floor(100 * numItemsHasBeenSeenTotal / numItemsCanRenderTotal) : 0;
  return progressBar;
}

function useLessonCoursePageType2(props) {
  var course = props.course,
    getComponentBelowItemsPostLesson = props.getComponentBelowItemsPostLesson,
    getComponentHeadLesson = props.getComponentHeadLesson,
    getComponentFooterLesson = props.getComponentFooterLesson,
    getComponentEmptyPostLesson = props.getComponentEmptyPostLesson,
    lessonActive = props.lessonActive,
    unitOpenMenuId = props.unitOpenMenuId,
    onChangeUnitOpenMenuId = props.onChangeUnitOpenMenuId;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    uiStyles = _useGeneral.uiStyles;
  var _useTokenStyles = useTokenStyles(uiStyles),
    tokenStyles = _useTokenStyles.tokenStyles;
  var lessonPreviousAndNext = useMemo(function () {
    return lessonActive ? getLessonPreviousAndNextCourse(course, lessonActive) : {
      next: null,
      back: null
    };
  }, [course, lessonActive == null ? void 0 : lessonActive.id]);
  var _useState = useState({
      isOpenMenu: false
    }),
    state = _useState[0],
    dispatch = _useState[1];
  function closeMenu() {
    if (state.isOpenMenu) dispatch(function (prevState) {
      return _extends({}, prevState, {
        isOpenMenu: false
      });
    });
  }
  function openMenu() {
    if (!state.isOpenMenu) dispatch(function (prevState) {
      return _extends({}, prevState, {
        isOpenMenu: true
      });
    });
  }
  function onButtonMenu() {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        isOpenMenu: !prevState.isOpenMenu
      });
    });
  }
  function onClickUnit(e, unit) {
    // Si esta abierta se cierra
    onChangeUnitOpenMenuId(unit.id === unitOpenMenuId ? null : unit.id);
  }
  function getSelectionCoords() {
    return {};
  }
  return {
    t: t,
    lessonActive: lessonActive,
    getComponentBelowItemsPost: getComponentBelowItemsPostLesson && lessonActive ? function (post, onChangePost, isModePostEditor, isVisible) {
      return (
        // @ts-ignore ya he comprobado que state.lessonActive tenga valor
        getComponentBelowItemsPostLesson(state.lessonActive, post, onChangePost, isModePostEditor, isVisible)
      );
    } : undefined,
    getComponentHead: getComponentHeadLesson && lessonActive ?
    // @ts-ignore ya he comprobado que state.lessonActive tenga valor
    function (item) {
      return getComponentHeadLesson(state.lessonActive, item);
    } : undefined,
    getComponentFooter: getComponentFooterLesson && lessonActive ?
    // @ts-ignore ya he comprobado que state.lessonActive tenga valor
    function (item) {
      return getComponentFooterLesson(state.lessonActive, item);
    } : undefined,
    getComponentEmptyPost: getComponentEmptyPostLesson && lessonActive ?
    // @ts-ignore ya he comprobado que state.lessonActive tenga valor
    function () {
      return getComponentEmptyPostLesson(state.lessonActive);
    } : undefined,
    onChangeLessonActive: props.onChangeLessonActive,
    isOpenMenu: state.isOpenMenu,
    closeMenu: closeMenu,
    openMenu: openMenu,
    onButtonMenu: onButtonMenu,
    onClickUnit: onClickUnit,
    lessonNext: lessonPreviousAndNext.next,
    lessonBack: lessonPreviousAndNext.back,
    configSelectionCoords: getSelectionCoords(),
    tokenStyles: tokenStyles
  };
}

var _path$n, _path2$8, _path3$4;
function _extends$G() { _extends$G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }
var SvgMenuV2 = function SvgMenuV2(props) {
  return /*#__PURE__*/createElement("svg", _extends$G({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$n || (_path$n = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09961 3.4998C2.09961 3.11321 2.41301 2.7998 2.79961 2.7998H11.1996C11.5862 2.7998 11.8996 3.11321 11.8996 3.4998C11.8996 3.8864 11.5862 4.1998 11.1996 4.1998H2.79961C2.41301 4.1998 2.09961 3.8864 2.09961 3.4998Z"
  })), _path2$8 || (_path2$8 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09961 6.9998C2.09961 6.61321 2.41301 6.2998 2.79961 6.2998H11.1996C11.5862 6.2998 11.8996 6.61321 11.8996 6.9998C11.8996 7.3864 11.5862 7.6998 11.1996 7.6998H2.79961C2.41301 7.6998 2.09961 7.3864 2.09961 6.9998Z"
  })), _path3$4 || (_path3$4 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09961 10.4998C2.09961 10.1132 2.41301 9.7998 2.79961 9.7998H11.1996C11.5862 9.7998 11.8996 10.1132 11.8996 10.4998C11.8996 10.8864 11.5862 11.1998 11.1996 11.1998H2.79961C2.41301 11.1998 2.09961 10.8864 2.09961 10.4998Z"
  })));
};

function LessonCoursePageType2(props) {
  var course = props.course,
    role = props.role,
    configHighlights = props.configHighlights,
    unitOpenMenuId = props.unitOpenMenuId,
    onChangeUnitOpenMenuId = props.onChangeUnitOpenMenuId,
    onClickLinkToHome = props.onClickLinkToHome,
    onChangeVisibilityItemblockPost = props.onChangeVisibilityItemblockPost,
    itemsIdHasBeenSeen = props.itemsIdHasBeenSeen,
    pathBaseRoute = props.pathBaseRoute;
  var _useLessonCoursePageT = useLessonCoursePageType2(props),
    lessonActive = _useLessonCoursePageT.lessonActive,
    getComponentBelowItemsPost = _useLessonCoursePageT.getComponentBelowItemsPost,
    getComponentHead = _useLessonCoursePageT.getComponentHead,
    getComponentFooter = _useLessonCoursePageT.getComponentFooter,
    getComponentEmptyPost = _useLessonCoursePageT.getComponentEmptyPost,
    onChangeLessonActive = _useLessonCoursePageT.onChangeLessonActive,
    isOpenMenu = _useLessonCoursePageT.isOpenMenu,
    closeMenu = _useLessonCoursePageT.closeMenu,
    openMenu = _useLessonCoursePageT.openMenu,
    lessonNext = _useLessonCoursePageT.lessonNext,
    lessonBack = _useLessonCoursePageT.lessonBack,
    configSelectionCoords = _useLessonCoursePageT.configSelectionCoords,
    tokenStyles = _useLessonCoursePageT.tokenStyles;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-lesson brand--second mint-lesson-course-page-type2' + (isOpenMenu ? ' mint-lesson-course-page-type2--open-menu' : ''),
    style: tokenStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-lesson-menu mint-lesson-menu--' + (isOpenMenu ? 'show' : 'hidden'),
    id: isOpenMenu ? ID_DIV_LESSON_MENU_SHOW : ID_DIV_LESSON_MENU
  }, /*#__PURE__*/React__default.createElement(MenuLessonCoursePageType2, {
    course: course,
    lessonActive: lessonActive,
    unitOpenMenuId: unitOpenMenuId,
    role: role,
    onChangeLessonActive: onChangeLessonActive,
    onChangeUnitOpenMenuId: onChangeUnitOpenMenuId,
    itemsIdHasBeenSeen: itemsIdHasBeenSeen,
    pathBaseRoute: pathBaseRoute
  }), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-lesson-course-page-type2__button-menu',
    onClick: isOpenMenu ? closeMenu : openMenu
  }, /*#__PURE__*/React__default.createElement(SvgMenuV2, {
    className: 'mint-lesson-course-page-type2__button-menu-icon'
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-lesson-course-page-type2__lesson mint-lesson-menu__page page page--lesson',
    id: ID_DIV_LESSON_ACTIVE
  }, lessonActive ? /*#__PURE__*/React__default.createElement(LessonWithLinks, {
    isOpen: isOpenMenu,
    lessonNext: lessonNext,
    lessonBack: lessonBack,
    lessonActive: lessonActive,
    getComponentBelowItemsPost: getComponentBelowItemsPost,
    getComponentHead: getComponentHead,
    getComponentFooter: getComponentFooter,
    getComponentEmptyPost: getComponentEmptyPost,
    role: role,
    onChangeLessonActive: onChangeLessonActive,
    configSelectionCoords: configSelectionCoords,
    configHighlights: configHighlights,
    onClickLinkToHome: onClickLinkToHome,
    onChangeVisibilityItemblockPost: onChangeVisibilityItemblockPost,
    itemsIdHasBeenSeen: itemsIdHasBeenSeen
  }) : /*#__PURE__*/React__default.createElement(LessonActiveEmpty, null))));
}

function useLessonCoursePage(props) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    uiStyles = _useGeneral.uiStyles;
  var _useTokenStyles = useTokenStyles(uiStyles),
    tokenStyles = _useTokenStyles.tokenStyles;
  var _useState = useState({});
  return {
    t: t,
    tokenStyles: tokenStyles
  };
}

var TypesOfLessonCoursePage;
(function (TypesOfLessonCoursePage) {
  TypesOfLessonCoursePage["TYPE_1"] = "1";
  TypesOfLessonCoursePage["TYPE_2"] = "2";
})(TypesOfLessonCoursePage || (TypesOfLessonCoursePage = {}));
/**
 *
 * @param props
 * @returns
 * @notes He renombrado la clase portada que teniamos en livebook por mint-main-page
 */
function LessonCoursePage(props) {
  var type = props.type,
    course = props.course,
    lessonActive = props.lessonActive,
    unitOpenMenuId = props.unitOpenMenuId,
    onChangeLessonActive = props.onChangeLessonActive,
    onChangeUnitOpenMenuId = props.onChangeUnitOpenMenuId,
    getComponentBelowItemsPostLesson = props.getComponentBelowItemsPostLesson,
    getComponentHeadLesson = props.getComponentHeadLesson,
    getComponentFooterLesson = props.getComponentFooterLesson,
    getComponentEmptyPostLesson = props.getComponentEmptyPostLesson,
    role = props.role,
    componentRightHeader = props.componentRightHeader,
    configSelectionCoords = props.configSelectionCoords,
    configHighlights = props.configHighlights,
    onClickLinkToHome = props.onClickLinkToHome,
    itemsIdHasBeenSeen = props.itemsIdHasBeenSeen,
    onChangeVisibilityItemblockPost = props.onChangeVisibilityItemblockPost,
    pathBaseRoute = props.pathBaseRoute;
  var _useLessonCoursePage = useLessonCoursePage(),
    tokenStyles = _useLessonCoursePage.tokenStyles;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-lesson brand--second mint-lesson-course-page',
    style: tokenStyles
  }, type === TypesOfLessonCoursePage.TYPE_1 ? /*#__PURE__*/React__default.createElement(LessonCoursePageType1, null) : type === TypesOfLessonCoursePage.TYPE_2 ? /*#__PURE__*/React__default.createElement(LessonCoursePageType2, {
    course: course,
    lessonActive: lessonActive,
    unitOpenMenuId: unitOpenMenuId,
    onChangeLessonActive: onChangeLessonActive,
    onChangeUnitOpenMenuId: onChangeUnitOpenMenuId,
    getComponentBelowItemsPostLesson: getComponentBelowItemsPostLesson,
    getComponentHeadLesson: getComponentHeadLesson,
    getComponentFooterLesson: getComponentFooterLesson,
    getComponentEmptyPostLesson: getComponentEmptyPostLesson,
    role: role,
    componentRightHeader: componentRightHeader,
    configSelectionCoords: configSelectionCoords,
    configHighlights: configHighlights,
    onClickLinkToHome: onClickLinkToHome,
    itemsIdHasBeenSeen: itemsIdHasBeenSeen,
    onChangeVisibilityItemblockPost: onChangeVisibilityItemblockPost,
    pathBaseRoute: pathBaseRoute
  }) : '');
}

function useMainPageType1(props) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useState = useState({});
  return {
    t: t
  };
}

function MainPageType1(props) {
  var _useMainPageType = useMainPageType1();
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-main-page-type1'
  }, "TODO: Hacer main page type 1");
}

function useMainPageType2(props) {
  var _course$coverImage;
  var onChangeUnitOpenMenuId = props.onChangeUnitOpenMenuId,
    unitOpenMenuId = props.unitOpenMenuId,
    course = props.course,
    onChangeLessonActive = props.onChangeLessonActive,
    itemsIdHasBeenSeen = props.itemsIdHasBeenSeen,
    role = props.role;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    getSrc = _useGeneral.getSrc;
  var _useState = useState({});
  var progressCourse = useMemo(function () {
    return getProgressCourse(course, itemsIdHasBeenSeen || [], role);
  }, [itemsIdHasBeenSeen, course.id]);
  function onClickKeepReading(e) {
    e.stopPropagation();
    e.preventDefault();
    var firstLessonCourse = getFirstLessonCourse(course);
    if (firstLessonCourse) {
      onChangeLessonActive(firstLessonCourse);
    }
  }
  function onClickUnit(e, unit) {
    // Si esta abierta se cierra
    onChangeUnitOpenMenuId(unit.id === unitOpenMenuId ? null : unit.id);
  }
  return {
    t: t,
    stringKeepReading: t('start'),
    onClickKeepReading: onClickKeepReading,
    onClickUnit: onClickUnit,
    coverImage: (_course$coverImage = course.coverImage) != null && _course$coverImage.src ? getSrc(course.coverImage.src) : undefined,
    progressCourse: progressCourse
  };
}

function TextH1Bold24And32(props) {
  var _props$classAdd = props.classAdd,
    classAdd = _props$classAdd === void 0 ? '' : _props$classAdd;
  var customClass = "mint-text-h1-bold-24-32 " + classAdd;
  return /*#__PURE__*/React__default.createElement(TextGeneral, Object.assign({
    as: ITypeTextHtmlTagName.H1
  }, props, {
    classAdd: customClass
  }));
}

function TextParagraphBold(props) {
  var _props$classAdd = props.classAdd,
    classAdd = _props$classAdd === void 0 ? '' : _props$classAdd;
  var customClass = classNames("mint-text-paragraph-bold", classAdd);
  return /*#__PURE__*/React__default.createElement(TextGeneral, Object.assign({
    as: ITypeTextHtmlTagName.SPAN
  }, props, {
    classAdd: customClass
  }));
}

function TextSubtitleRegular18and24(props) {
  var _props$classAdd = props.classAdd,
    classAdd = _props$classAdd === void 0 ? '' : _props$classAdd;
  var customClass = classNames("mint-text-subtitle-regular-18-24", classAdd);
  return /*#__PURE__*/React__default.createElement(TextGeneral, Object.assign({
    as: ITypeTextHtmlTagName.P
  }, props, {
    classAdd: customClass
  }));
}

function MainPageType2(props) {
  var course = props.course,
    role = props.role,
    lessonActive = props.lessonActive,
    unitOpenMenuId = props.unitOpenMenuId,
    onChangeLessonActive = props.onChangeLessonActive,
    itemsIdHasBeenSeen = props.itemsIdHasBeenSeen;
  var _useMainPageType = useMainPageType2(props),
    stringKeepReading = _useMainPageType.stringKeepReading,
    coverImage = _useMainPageType.coverImage,
    onClickKeepReading = _useMainPageType.onClickKeepReading,
    onClickUnit = _useMainPageType.onClickUnit;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-main-page-type2'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-main-page__nav'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-main-page brand--background'
  }, /*#__PURE__*/React__default.createElement("img", {
    className: 'mint-main-page__thumb-img',
    src: coverImage
  }), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-main-page__content'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-main-page__head'
  }, /*#__PURE__*/React__default.createElement(TextH1Bold24And32, {
    text: course.name,
    isHtmlVisor: false,
    classAdd: 'mint-main-page__title brand--first'
  }), course.subtitle && /*#__PURE__*/React__default.createElement(TextSubtitleRegular18and24, {
    text: course.subtitle,
    isHtmlVisor: false,
    classAdd: 'mint-main-page__description brand--first'
  }), /*#__PURE__*/React__default.createElement("a", {
    href: '',
    className: 'mint-main-page__read brand--first',
    onClick: onClickKeepReading
  }, /*#__PURE__*/React__default.createElement(TextParagraphBold, {
    text: stringKeepReading,
    isHtmlVisor: false
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-main-page__index'
  }, /*#__PURE__*/React__default.createElement(IndexLessonListType2, {
    course: course,
    lessonActive: lessonActive,
    unitOpenId: unitOpenMenuId,
    onClickLesson: function onClickLesson(e, lesson) {
      return onChangeLessonActive(lesson);
    },
    onClickUnit: onClickUnit,
    role: role,
    itemsIdHasBeenSeen: itemsIdHasBeenSeen
  })))));
}

function useMainPage(props) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    uiStyles = _useGeneral.uiStyles;
  var _useTokenStyles = useTokenStyles(uiStyles),
    tokenStyles = _useTokenStyles.tokenStyles;
  var _useState = useState({});
  return {
    t: t,
    tokenStyles: tokenStyles
  };
}

var TypesOfMainPage;
(function (TypesOfMainPage) {
  TypesOfMainPage["TYPE_1"] = "1";
  TypesOfMainPage["TYPE_2"] = "2";
})(TypesOfMainPage || (TypesOfMainPage = {}));
/**
 *
 * @param props
 * @returns
 * @notes He renombrado la clase portada que teniamos en livebook por mint-main-page
 */
function MainPage(props) {
  var type = props.type,
    course = props.course,
    role = props.role,
    lessonActive = props.lessonActive,
    unitOpenMenuId = props.unitOpenMenuId,
    onChangeLessonActive = props.onChangeLessonActive,
    onChangeUnitOpenMenuId = props.onChangeUnitOpenMenuId,
    itemsIdHasBeenSeen = props.itemsIdHasBeenSeen;
  var _useMainPage = useMainPage(),
    tokenStyles = _useMainPage.tokenStyles;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-lesson brand--second mint-main-page',
    style: tokenStyles
  }, type === TypesOfMainPage.TYPE_1 ? /*#__PURE__*/React__default.createElement(MainPageType1, null) : type === TypesOfMainPage.TYPE_2 ? /*#__PURE__*/React__default.createElement(MainPageType2, {
    course: course,
    role: role,
    lessonActive: lessonActive,
    unitOpenMenuId: unitOpenMenuId,
    onChangeLessonActive: onChangeLessonActive,
    onChangeUnitOpenMenuId: onChangeUnitOpenMenuId,
    itemsIdHasBeenSeen: itemsIdHasBeenSeen
  }) : '');
}

var text$1 = "Text";
var impact$1 = "Destacats";
var quote$1 = "Frases";
var list$1 = "Llistes";
var image$1 = "Imatges";
var gallery$1 = "Galeries";
var multimedia$1 = "Multimèdia";
var interactive$1 = "Interactius";
var buttons$1 = "Botons";
var divider$1 = "Divisors";
var lemonade = "Activitat";
var Paragraph$1 = "Paràgraf";
var Heading$1 = "Capçalera";
var Subheading$1 = "Subcapçalera";
var Note$1 = "Nota";
var Carousel$1 = "Carrusel";
var Audio$1 = "Àudio";
var Video$1 = "Vídeo";
var Embed$1 = "Encastat";
var Attachment = "Fitxer adjunt";
var Accordion$1 = "Acordió";
var Tabs$1 = "Pestanyes";
var Process$1 = "Procés";
var Button$2 = "Botó";
var Divider$1 = "Divisor";
var Spacer = "Espaiador";
var Classification = "Classificació";
var button_edit_post = "Edita el bloc";
var button_close_edit_post = "Tanca l’edició";
var create_block_collection_menu_title = "Biblioteca de blocs";
var empty_lemonade = "Activitat: edita aquest bloc per triar plantilla";
var empty_lemonade_feedback = "Activitat UNOIntelligence: edita aquest bloc per triar plantilla";
var Edit = "Edita";
var Text$1 = "Text";
var List = "Llista";
var Image = "Imatge";
var Graphic = "Gràfic";
var Slider = "Procés";
var Gallery = "Galeria";
var Content = "Contingut";
var Settings = "Opcions";
var Description = "Descripció";
var Caption = "Etiqueta";
var image_alt_text = "Text alternatiu de la imatge";
var Unspecified = "Sense especificar";
var Left = "Esquerra";
var Center = "Centrada";
var Right = "Dreta";
var Step = "Pas";
var Intro = "Intro";
var Summary = "Sumari";
var Index = "Índex";
var Title = "Títol";
var Subtitle = "Subtítol";
var Column = "Columna";
var help_step_number = "Per indicar on s’ha de mostrar el número del pas, utilitza [NUMBER] exemple: 'Pas [NUMBER] exemple'";
var Small = "Petit";
var Medium = "Mitjà";
var Undo = "Desfes";
var Markers = "Marcadors";
var labeledgraphic = "Gràfic etiquetat";
var Change = "Modifica";
var Border = "Vora";
var Loading = "Carregant";
var Activity = "Activitat";
var Visibility = "Visible";
var Notes = "Notes";
var embed_error_not_valid = "Introdueix una URL vàlida (YouTube o Vimeo) o un iframe";
var embed_genially_error_not_valid = "Introdueix un iframe";
var Timeline$1 = "Línia de temps";
var timeline_title_start = "Títol d'inici";
var timeline_title_end = "Títol de final";
var tabs_audios_post_title = "Àudio {{number}}";
var tabs_audios_post_button_new = "Nou";
var tabs_audios_post_button_delete = "Esborrar {{audio_title}}";
var tabs_audios_post_block_text = "Bloc #{{number}} _ {{caption}}";
var tabs_audios_post_select_blocks_title = "Seleccionar blocs";
var tabs_audios_post_select_head = "Blocs";
var tabs_audios_post_select_help = "Tots els blocs seleccionats han de ser consecutius";
var tabs_audios_post_select_placeholder = "Seleccionar bloc";
var tabs_audios_post_assigned_to = "Assignat a";
var file_uploaded_successfully = "Àudio enviat correctament";
var files_uploaded_successfully = "Àudios enviats correctament";
var file_drop_audio_line1 = "Deixar l'àudio";
var file_drop_audio_line2 = "(o fes clic aquí per seleccionar)";
var file_uploading_audio = "Pujant àudio {{number}}%";
var item_delete_audio_empty_blocks = "L'àudio no està associat a cap bloc";
var label_pdf_pages_post = "Pàgines";
var item_option_title_edit = "Editar";
var item_option_title_up = "Pujar";
var item_option_title_down = "Baixar";
var item_option_title_left = "Moure a l'esquerra";
var item_option_title_right = "Moure a la dreta";
var item_option_title_duplicate = "Duplicar";
var item_option_title_settings = "Configuració acadèmica";
var item_option_title_delete = "Esborrar";
var item_option_title_audios = "Àudios";
var option_item_block_settings = "Opcions";
var option_item_block_change_type = "Canviar a";
var option_item_block_edit = "Edita";
var option_item_block_move_up = "Mou amunt";
var option_item_block_move_down = "Mou avall";
var option_item_block_audio = "Àudio";
var option_item_block_duplicate = "Duplica";
var option_item_block_delete = "Esborra";
var clear_background = "Esborra";
var image_caption = "Pie de imatge";
var video_caption = "Pie de vídeo";
var audio_caption = "Pie d'àudio";
var tooltip_placeholder = "Escriu aquí...";
var tooltip_char_counter = " / 240 caràcters";
var tooltip_add = "Afegeix";
var tooltip_update = "Actualitza";
var tooltip_cancel = "Cancel·la";
var tooltip_edit = "Edita";
var tooltip_remove = "Elimina";
var embed_button_add = "Afegeix";
var feedback_activity = "Activitat UNOIntelligence";
var settings_evaluation_title = "Avaluació";
var settings_count_for_note = "La qualificació compta per a la nota";
var settings_attempts_title = "Intents";
var intelligence_tag_title = "Etiqueta per a Intelligence";
var select = "Seleccionar";
var exercise = "Exercitació";
var verification = "Comprovació";
var practice = "Pràctica";
var editorCA = {
	text: text$1,
	impact: impact$1,
	quote: quote$1,
	list: list$1,
	image: image$1,
	gallery: gallery$1,
	multimedia: multimedia$1,
	interactive: interactive$1,
	"interactive-fullscreen": "Interactius pantalla completa",
	buttons: buttons$1,
	divider: divider$1,
	lemonade: lemonade,
	Paragraph: Paragraph$1,
	"Paragraph with Heading": "Paràgraf amb capçalera",
	"Paragraph with Subheading": "Paràgraf amb subcapçalera",
	Heading: Heading$1,
	Subheading: Subheading$1,
	"Two column": "Dues columnes",
	"Statement A": "Declaració A",
	"Statement B": "Declaració B",
	"Statement C": "Declaració C",
	"Statement D": "Declaració D",
	Note: Note$1,
	"Quote A": "Frase A",
	"Quote B": "Frase B",
	"Quote C": "Frase C",
	"Quote D": "Frase D",
	"Quote on image": "Frase en imatge",
	"Quote carousel": "Carrusel en francès",
	"Numbered list": "Llista numerada",
	"Checkbox list": "Llista de verificació",
	"Bulleted list": "Llista de pics",
	"Image centered": "Imatge centrada",
	"Image full width": "Imatge pantalla completa",
	"Image & text": "Imatge i text",
	"Text on image": "Text en imatge",
	Carousel: Carousel$1,
	"Two column grid": "Dues columnes",
	"Three column grid": "Tres columnes",
	"Four column grid": "Quatre columnes",
	Audio: Audio$1,
	Video: Video$1,
	Embed: Embed$1,
	Attachment: Attachment,
	"Code snippet": "Fragment de codi",
	Accordion: Accordion$1,
	Tabs: Tabs$1,
	"Labeled Graphic": "Gràfic etiquetat",
	Process: Process$1,
	Button: Button$2,
	"Button stack": "Pila de botons",
	Divider: Divider$1,
	Spacer: Spacer,
	"Lemonade content guid": "Lemonade content guid",
	"Multiple choice standard": "Test amb resposta única",
	"Multiple choice multiple": "Test amb resposta múltiple",
	"Multiple choice true / false": "Test amb veritable/fals",
	"Multiple choice block letter": "Test amb resposta múltiple en bloc",
	"Choice matrix standard": "Taula de selecció",
	"Choice matrix inline": "Llista de selecció",
	"Essay plain text": "Resposta oberta",
	"Essay short text": "Resposta curta",
	"Cloze with drag & drop": "Completa els buits amb l’arrossega i deixa anar",
	"Cloze with dropdown": "Completa els buits amb el desplegable",
	"Cloze with text": "Completa els buits amb text",
	Classification: Classification,
	"Match list": "Aparella",
	"Order list": "Ordena la llista",
	"Label image with text": "Completa la imatge amb text",
	button_edit_post: button_edit_post,
	button_close_edit_post: button_close_edit_post,
	create_block_collection_menu_title: create_block_collection_menu_title,
	empty_lemonade: empty_lemonade,
	empty_lemonade_feedback: empty_lemonade_feedback,
	"Type something": "Escriu alguna cos.a",
	Edit: Edit,
	"All Blocks": "Tots",
	"Add your first itemblock": "Afegeix el teu primer bloc.",
	Text: Text$1,
	List: List,
	Image: Image,
	Graphic: Graphic,
	Slider: Slider,
	Gallery: Gallery,
	Content: Content,
	Settings: Settings,
	Description: Description,
	Caption: Caption,
	image_alt_text: image_alt_text,
	"Image alignment": "Alineació de la imatge",
	Unspecified: Unspecified,
	Left: Left,
	Center: Center,
	Right: Right,
	"Padding Top": "Marge superior",
	"Padding Bottom": "Marge inferior",
	"No padding": "Sense marge",
	"Background Color": "Color de fons",
	"Select color": "Selecciona el color",
	"List item": "Element",
	"Add item": "Afegeix element",
	"Add Image": "Afegeix imatge",
	"Add Step": "Afegeix pas",
	Step: Step,
	Intro: Intro,
	Summary: Summary,
	Index: Index,
	Title: Title,
	Subtitle: Subtitle,
	Column: Column,
	help_step_number: help_step_number,
	Small: Small,
	Medium: Medium,
	"Full width": "Ample complet",
	"Image width": "Amplada de la imatge",
	"Removed block": "Bloc eliminat",
	Undo: Undo,
	"Teacher notes": "Notes per al docent",
	Markers: Markers,
	"Marker style": "Estil de marca",
	labeledgraphic: labeledgraphic,
	"Press Enter to add": "Prem Intro per afegir",
	Change: Change,
	"Show border": "Mostra vora",
	Border: Border,
	Loading: Loading,
	Activity: Activity,
	"Image position": "Posició de la imatge",
	"Image size": "Mida de la imatge",
	"Add an item block": "Afegeix un bloc de contingut",
	Visibility: Visibility,
	"Teacher only": "Només per al docent",
	"Add your first block": "Afegeix el primer bloc",
	"Enter a title...": "Escriu un títol...",
	"Upload video": "Puja vídeo",
	"URL video": "URL vídeo",
	Notes: Notes,
	embed_error_not_valid: embed_error_not_valid,
	embed_genially_error_not_valid: embed_genially_error_not_valid,
	Timeline: Timeline$1,
	timeline_title_start: timeline_title_start,
	timeline_title_end: timeline_title_end,
	tabs_audios_post_title: tabs_audios_post_title,
	tabs_audios_post_button_new: tabs_audios_post_button_new,
	tabs_audios_post_button_delete: tabs_audios_post_button_delete,
	tabs_audios_post_block_text: tabs_audios_post_block_text,
	tabs_audios_post_select_blocks_title: tabs_audios_post_select_blocks_title,
	tabs_audios_post_select_head: tabs_audios_post_select_head,
	tabs_audios_post_select_help: tabs_audios_post_select_help,
	tabs_audios_post_select_placeholder: tabs_audios_post_select_placeholder,
	tabs_audios_post_assigned_to: tabs_audios_post_assigned_to,
	file_uploaded_successfully: file_uploaded_successfully,
	files_uploaded_successfully: files_uploaded_successfully,
	file_drop_audio_line1: file_drop_audio_line1,
	file_drop_audio_line2: file_drop_audio_line2,
	file_uploading_audio: file_uploading_audio,
	item_delete_audio_empty_blocks: item_delete_audio_empty_blocks,
	"Select all": "Seleccionar tot",
	"files supported": "Formats suportats: {{format}}",
	label_pdf_pages_post: label_pdf_pages_post,
	item_option_title_edit: item_option_title_edit,
	item_option_title_up: item_option_title_up,
	item_option_title_down: item_option_title_down,
	item_option_title_left: item_option_title_left,
	item_option_title_right: item_option_title_right,
	item_option_title_duplicate: item_option_title_duplicate,
	item_option_title_settings: item_option_title_settings,
	item_option_title_delete: item_option_title_delete,
	item_option_title_audios: item_option_title_audios,
	option_item_block_settings: option_item_block_settings,
	option_item_block_change_type: option_item_block_change_type,
	option_item_block_edit: option_item_block_edit,
	option_item_block_move_up: option_item_block_move_up,
	option_item_block_move_down: option_item_block_move_down,
	option_item_block_audio: option_item_block_audio,
	option_item_block_duplicate: option_item_block_duplicate,
	option_item_block_delete: option_item_block_delete,
	clear_background: clear_background,
	image_caption: image_caption,
	video_caption: video_caption,
	audio_caption: audio_caption,
	tooltip_placeholder: tooltip_placeholder,
	tooltip_char_counter: tooltip_char_counter,
	tooltip_add: tooltip_add,
	tooltip_update: tooltip_update,
	tooltip_cancel: tooltip_cancel,
	tooltip_edit: tooltip_edit,
	tooltip_remove: tooltip_remove,
	embed_button_add: embed_button_add,
	feedback_activity: feedback_activity,
	settings_evaluation_title: settings_evaluation_title,
	settings_count_for_note: settings_count_for_note,
	settings_attempts_title: settings_attempts_title,
	intelligence_tag_title: intelligence_tag_title,
	select: select,
	exercise: exercise,
	verification: verification,
	practice: practice
};

var process_button_start = "COMENÇA";
var process_button_start_again = "COMENÇA DE NOU";
var process_refresh_show_pagination = "Refresca la pàgina per mostrar la paginació en aquesta diapositiva.";
var proccess_step_number = "Pas {{number}}";
var teacher_notes = "Notes per al docent";
var media_audio_browser_not_support_part_1 = "El seu navegador no suporta àudios HTML5. Aquí hi ha un";
var media_audio_browser_not_support_part_2_href = "enllaç a l’àudio";
var media_audio_browser_not_support_part_3 = "en lloc seu.";
var media_video_browser_not_support_part_1 = "El seu navegador no suporta vídeos HTML5. Aquí hi ha un";
var media_video_browser_not_support_part_2_href = "enllaç al vídeo";
var media_video_browser_not_support_part_3 = "en lloc seu.";
var media_embed_view_on = "Mostra en";
var lms_waiting_correction = "Esperant correcció…";
var send = "Envia";
var highlighter_highlight = "Ressalta";
var highlighter_edit_color_highlight = "Edita color";
var highlighter_remove_highlight = "Treu resultat";
var correct = "Correcte";
var incorrect = "Incorrecte";
var video_no_internet = "No es pot visualitzar el vídeo. Si us plau, comprova la teva connexió a internet.";
var need_help = "No lo entiendo";
var get_recomendation = "Recomendación";
var undefined_activity = "Activitat no definida.";
var proccess_step_label_number = "{{label}} {{number}}";
var no_alt_tooltip = "No conté text alternatiu";
var button_show_hints = "Pista";
var volume = "Volum";
var speed = "Velocitat";
var audio_transcription = "Transcripció";
var current_text = "Text actual";
var visorCA = {
	process_button_start: process_button_start,
	process_button_start_again: process_button_start_again,
	process_refresh_show_pagination: process_refresh_show_pagination,
	proccess_step_number: proccess_step_number,
	teacher_notes: teacher_notes,
	media_audio_browser_not_support_part_1: media_audio_browser_not_support_part_1,
	media_audio_browser_not_support_part_2_href: media_audio_browser_not_support_part_2_href,
	media_audio_browser_not_support_part_3: media_audio_browser_not_support_part_3,
	media_video_browser_not_support_part_1: media_video_browser_not_support_part_1,
	media_video_browser_not_support_part_2_href: media_video_browser_not_support_part_2_href,
	media_video_browser_not_support_part_3: media_video_browser_not_support_part_3,
	media_embed_view_on: media_embed_view_on,
	lms_waiting_correction: lms_waiting_correction,
	send: send,
	highlighter_highlight: highlighter_highlight,
	highlighter_edit_color_highlight: highlighter_edit_color_highlight,
	highlighter_remove_highlight: highlighter_remove_highlight,
	correct: correct,
	incorrect: incorrect,
	video_no_internet: video_no_internet,
	need_help: need_help,
	get_recomendation: get_recomendation,
	undefined_activity: undefined_activity,
	proccess_step_label_number: proccess_step_label_number,
	no_alt_tooltip: no_alt_tooltip,
	button_show_hints: button_show_hints,
	volume: volume,
	speed: speed,
	audio_transcription: audio_transcription,
	current_text: current_text
};

var text$2 = "Text";
var impact$2 = "Notes";
var quote$2 = "Quote";
var list$2 = "List";
var image$2 = "Images";
var gallery$2 = "Gallery";
var multimedia$2 = "Multimedia";
var interactive$2 = "Interactive";
var buttons$2 = "Buttons";
var divider$2 = "Divider";
var lemonade$1 = "Activity";
var Paragraph$2 = "Paragraph";
var Heading$2 = "Heading";
var Subheading$2 = "Subheading";
var Note$2 = "Note";
var Carousel$2 = "Carousel";
var Audio$2 = "Audio";
var Video$2 = "Video";
var Embed$2 = "Embed";
var Attachment$1 = "Attachment";
var Accordion$2 = "Accordion";
var Tabs$2 = "Tabs";
var Process$2 = "Process";
var Button$3 = "Button";
var Divider$2 = "Divider";
var Spacer$1 = "Spacer";
var Classification$1 = "Classification";
var button_edit_post$1 = "Edit post";
var button_close_edit_post$1 = "Close edition";
var create_block_collection_menu_title$1 = "Blocks library";
var empty_lemonade$1 = "Activity: edit this block to choose template";
var empty_lemonade_feedback$1 = "UNOIntelligence activity: edit this block to choose template";
var Edit$1 = "Edit";
var Text$2 = "Text";
var List$1 = "List";
var Image$1 = "Image";
var Graphic$1 = "Graphic";
var Slider$1 = "Slider";
var Gallery$1 = "Gallery";
var Content$1 = "Content";
var Settings$1 = "Settings";
var Description$1 = "Description";
var Caption$1 = "Image caption";
var image_alt_text$1 = "Image alt text";
var Unspecified$1 = "Unspecified";
var Left$1 = "Left";
var Center$1 = "Center";
var Right$1 = "Right";
var Step$1 = "Step";
var Intro$1 = "Intro";
var Summary$1 = "Summary";
var Index$1 = "Index";
var Title$1 = "Title";
var Subtitle$1 = "Subtitle";
var Column$1 = "Column";
var help_step_number$1 = "To indicate where to put the number use [NUMBER] example: 'Step [NUMBER] example'";
var Small$1 = "Small";
var Medium$1 = "Medium";
var Undo$1 = "Undo";
var Markers$1 = "Markers";
var labeledgraphic$1 = "Labeled Graphic";
var Change$1 = "Change";
var Border$1 = "Border";
var Loading$1 = "Loading";
var Activity$1 = "Activity";
var Visibility$1 = "Visibility";
var Notes$1 = "Notes";
var embed_error_not_valid$1 = "Please provide a valid URL (YouTube or Vimeo) or iframe";
var embed_genially_error_not_valid$1 = "Please provide an iframe";
var Timeline$2 = "Timeline";
var timeline_title_start$1 = "Start title";
var timeline_title_end$1 = "End title";
var tabs_audios_post_title$1 = "Audio {{number}}";
var tabs_audios_post_button_new$1 = "New";
var tabs_audios_post_button_delete$1 = "Delete {{audio_title}}";
var tabs_audios_post_block_text$1 = "Block #{{number}} _ {{caption}}";
var tabs_audios_post_select_blocks_title$1 = "Select blocks";
var tabs_audios_post_select_head$1 = "Blocks";
var tabs_audios_post_select_help$1 = "All selected blocks must be consecutive";
var tabs_audios_post_select_placeholder$1 = "Select block";
var tabs_audios_post_assigned_to$1 = "Assigned to";
var file_uploaded_successfully$1 = "Audio sent successfully";
var files_uploaded_successfully$1 = "Audios sent successfully";
var file_drop_audio_line1$1 = "Drop audio";
var file_drop_audio_line2$1 = "(or click here to select)";
var file_uploading_audio$1 = "Uploading audio {{number}}%";
var item_delete_audio_empty_blocks$1 = "The audio is not linked to any block";
var label_pdf_pages_post$1 = "Pages";
var item_option_title_edit$1 = "Edit";
var item_option_title_up$1 = "Rise";
var item_option_title_down$1 = "Lower";
var item_option_title_left$1 = "Move left";
var item_option_title_right$1 = "Move right";
var item_option_title_duplicate$1 = "Duplicate";
var item_option_title_settings$1 = "Academic settings";
var item_option_title_delete$1 = "Delete";
var item_option_title_audios$1 = "Audios";
var option_item_block_settings$1 = "Options";
var option_item_block_change_type$1 = "Change to";
var option_item_block_edit$1 = "Edit";
var option_item_block_move_up$1 = "Move up";
var option_item_block_move_down$1 = "Move down";
var option_item_block_audio$1 = "Audio";
var option_item_block_duplicate$1 = "Duplicate";
var option_item_block_delete$1 = "Delete";
var additional_content_item_title = "Additional content";
var additional_content_header = "Additional content # {{number}}";
var button_additional_content_add = "Add additional content";
var warning_single_post_mode = "This lesson has multiple posts but is configured to display a single post. Please organize and delete the posts until you are left with only one. Only the first post will be displayed in the viewer.";
var item_option_title_edit_type_compatible = "Replace with compatible block";
var delete_layout_confirmation_title = "Delete content";
var delete_layout_confirmation_message = "If you delete the central block, you will lose all edited content.\nDo you want to continue?";
var delete_layout_confirmation_button = "Delete";
var Cancel = "Cancel";
var popup_editor_content_header = "Header";
var popup_editor_content_text = "Text body";
var popup_editor_content_type_block = "Multimedia content";
var warning_disable_background_gradient = "The background color is a gradient, but the gradient option is disabled in the mint configuration.";
var clear_background$1 = "Clear";
var image_caption$1 = "Image caption";
var video_caption$1 = "Video caption";
var audio_caption$1 = "Audio caption";
var tooltip_placeholder$1 = "Write here...";
var tooltip_char_counter$1 = " / 240 characters";
var tooltip_add$1 = "Add";
var tooltip_update$1 = "Update";
var tooltip_cancel$1 = "Cancel";
var tooltip_edit$1 = "Edit";
var tooltip_remove$1 = "Remove";
var tooltip_add_or_edit = "Add/Edit Tooltip";
var embed_button_add$1 = "Add";
var feedback_activity$1 = "UNOIntelligence activity";
var settings_evaluation_title$1 = "Evaluation";
var settings_count_for_note$1 = "The grade counts towards the final score";
var settings_attempts_title$1 = "Attempts";
var intelligence_tag_title$1 = "Intelligence Tag";
var select$1 = "Select";
var exercise$1 = "Exercise";
var verification$1 = "Verification";
var practice$1 = "Practice";
var editorEn = {
	text: text$2,
	impact: impact$2,
	quote: quote$2,
	list: list$2,
	image: image$2,
	gallery: gallery$2,
	multimedia: multimedia$2,
	interactive: interactive$2,
	"interactive-fullscreen": "Interactive fullscreen",
	buttons: buttons$2,
	divider: divider$2,
	lemonade: lemonade$1,
	Paragraph: Paragraph$2,
	"Paragraph with Heading": "Paragraph with Heading",
	"Paragraph with Subheading": "Paragraph with Subheading",
	Heading: Heading$2,
	Subheading: Subheading$2,
	"Two column": "Two column",
	"Statement A": "Statement A",
	"Statement B": "Statement B",
	"Statement C": "Statement C",
	"Statement D": "Statement D",
	Note: Note$2,
	"Quote A": "Quote A",
	"Quote B": "Quote B",
	"Quote C": "Quote C",
	"Quote D": "Quote D",
	"Quote on image": "Quote on image",
	"Quote carousel": "Quote carousel",
	"Numbered list": "Numbered list",
	"Checkbox list": "Checkbox list",
	"Bulleted list": "Bulleted list",
	"Image centered": "Image centered",
	"Image full width": "Image full width",
	"Image & text": "Image & text",
	"Text on image": "Text on image",
	Carousel: Carousel$2,
	"Two column grid": "Two column grid",
	"Three column grid": "Three column grid",
	"Four column grid": "Four column grid",
	Audio: Audio$2,
	Video: Video$2,
	Embed: Embed$2,
	Attachment: Attachment$1,
	"Code snippet": "Code snippet",
	Accordion: Accordion$2,
	Tabs: Tabs$2,
	"Labeled Graphic": "Labeled Graphic",
	Process: Process$2,
	Button: Button$3,
	"Button stack": "Button stack",
	Divider: Divider$2,
	Spacer: Spacer$1,
	"Lemonade content guid": "Lemonade content guid",
	"Multiple choice standard": "Multiple choice standard",
	"Multiple choice multiple": "Multiple choice multiple",
	"Multiple choice true / false": "Multiple choice true / false",
	"Multiple choice block letter": "Multiple choice block letter",
	"Choice matrix standard": "Choice matrix standard",
	"Choice matrix inline": "Choice matrix inline",
	"Essay plain text": "Essay plain text",
	"Essay short text": "Essay short text",
	"Cloze with drag & drop": "Cloze with drag & drop",
	"Cloze with dropdown": "Cloze with dropdown",
	"Cloze with text": "Cloze with text",
	Classification: Classification$1,
	"Match list": "Match list",
	"Order list": "Order list",
	"Label image with text": "Label image with text",
	button_edit_post: button_edit_post$1,
	button_close_edit_post: button_close_edit_post$1,
	create_block_collection_menu_title: create_block_collection_menu_title$1,
	empty_lemonade: empty_lemonade$1,
	empty_lemonade_feedback: empty_lemonade_feedback$1,
	"Type something": "Type something",
	Edit: Edit$1,
	"All Blocks": "All Blocks",
	"Add your first itemblock": "Add your first itemblock",
	Text: Text$2,
	List: List$1,
	Image: Image$1,
	Graphic: Graphic$1,
	Slider: Slider$1,
	Gallery: Gallery$1,
	Content: Content$1,
	Settings: Settings$1,
	Description: Description$1,
	Caption: Caption$1,
	image_alt_text: image_alt_text$1,
	"Image alignment": "Image alignment",
	Unspecified: Unspecified$1,
	Left: Left$1,
	Center: Center$1,
	Right: Right$1,
	"Padding Top": "Padding Top",
	"Padding Bottom": "Padding Bottom",
	"No padding": "No padding",
	"Background Color": "Background Color",
	"Select color": "Select color",
	"List item": "List item",
	"Add item": "Add item",
	"Add Image": "Add Image",
	"Add Step": "Add Step",
	Step: Step$1,
	Intro: Intro$1,
	Summary: Summary$1,
	Index: Index$1,
	Title: Title$1,
	Subtitle: Subtitle$1,
	Column: Column$1,
	help_step_number: help_step_number$1,
	Small: Small$1,
	Medium: Medium$1,
	"Full width": "Full width",
	"Image width": "Image width",
	"Removed block": "Removed block",
	Undo: Undo$1,
	"Teacher notes": "Teaching notes",
	Markers: Markers$1,
	"Marker style": "Marker style",
	labeledgraphic: labeledgraphic$1,
	"Press Enter to add": "Press Enter to add",
	Change: Change$1,
	"Show border": "Show border",
	Border: Border$1,
	Loading: Loading$1,
	Activity: Activity$1,
	"Image position": "Image position",
	"Image size": "Image size",
	"Add an item block": "Add an item block",
	Visibility: Visibility$1,
	"Teacher only": "Teacher only",
	"Add your first block": "Add your first block",
	"Enter a title...": "Enter a title...",
	"Upload video": "Upload video",
	"URL video": "URL video",
	Notes: Notes$1,
	embed_error_not_valid: embed_error_not_valid$1,
	embed_genially_error_not_valid: embed_genially_error_not_valid$1,
	Timeline: Timeline$2,
	timeline_title_start: timeline_title_start$1,
	timeline_title_end: timeline_title_end$1,
	tabs_audios_post_title: tabs_audios_post_title$1,
	tabs_audios_post_button_new: tabs_audios_post_button_new$1,
	tabs_audios_post_button_delete: tabs_audios_post_button_delete$1,
	tabs_audios_post_block_text: tabs_audios_post_block_text$1,
	tabs_audios_post_select_blocks_title: tabs_audios_post_select_blocks_title$1,
	tabs_audios_post_select_head: tabs_audios_post_select_head$1,
	tabs_audios_post_select_help: tabs_audios_post_select_help$1,
	tabs_audios_post_select_placeholder: tabs_audios_post_select_placeholder$1,
	tabs_audios_post_assigned_to: tabs_audios_post_assigned_to$1,
	file_uploaded_successfully: file_uploaded_successfully$1,
	files_uploaded_successfully: files_uploaded_successfully$1,
	file_drop_audio_line1: file_drop_audio_line1$1,
	file_drop_audio_line2: file_drop_audio_line2$1,
	file_uploading_audio: file_uploading_audio$1,
	item_delete_audio_empty_blocks: item_delete_audio_empty_blocks$1,
	"Select all": "Select all",
	"files supported": "{{format}} files supported",
	label_pdf_pages_post: label_pdf_pages_post$1,
	item_option_title_edit: item_option_title_edit$1,
	item_option_title_up: item_option_title_up$1,
	item_option_title_down: item_option_title_down$1,
	item_option_title_left: item_option_title_left$1,
	item_option_title_right: item_option_title_right$1,
	item_option_title_duplicate: item_option_title_duplicate$1,
	item_option_title_settings: item_option_title_settings$1,
	item_option_title_delete: item_option_title_delete$1,
	item_option_title_audios: item_option_title_audios$1,
	option_item_block_settings: option_item_block_settings$1,
	option_item_block_change_type: option_item_block_change_type$1,
	option_item_block_edit: option_item_block_edit$1,
	option_item_block_move_up: option_item_block_move_up$1,
	option_item_block_move_down: option_item_block_move_down$1,
	option_item_block_audio: option_item_block_audio$1,
	option_item_block_duplicate: option_item_block_duplicate$1,
	option_item_block_delete: option_item_block_delete$1,
	additional_content_item_title: additional_content_item_title,
	additional_content_header: additional_content_header,
	button_additional_content_add: button_additional_content_add,
	warning_single_post_mode: warning_single_post_mode,
	item_option_title_edit_type_compatible: item_option_title_edit_type_compatible,
	delete_layout_confirmation_title: delete_layout_confirmation_title,
	delete_layout_confirmation_message: delete_layout_confirmation_message,
	delete_layout_confirmation_button: delete_layout_confirmation_button,
	Cancel: Cancel,
	popup_editor_content_header: popup_editor_content_header,
	popup_editor_content_text: popup_editor_content_text,
	popup_editor_content_type_block: popup_editor_content_type_block,
	warning_disable_background_gradient: warning_disable_background_gradient,
	clear_background: clear_background$1,
	image_caption: image_caption$1,
	video_caption: video_caption$1,
	audio_caption: audio_caption$1,
	tooltip_placeholder: tooltip_placeholder$1,
	tooltip_char_counter: tooltip_char_counter$1,
	tooltip_add: tooltip_add$1,
	tooltip_update: tooltip_update$1,
	tooltip_cancel: tooltip_cancel$1,
	tooltip_edit: tooltip_edit$1,
	tooltip_remove: tooltip_remove$1,
	tooltip_add_or_edit: tooltip_add_or_edit,
	embed_button_add: embed_button_add$1,
	feedback_activity: feedback_activity$1,
	settings_evaluation_title: settings_evaluation_title$1,
	settings_count_for_note: settings_count_for_note$1,
	settings_attempts_title: settings_attempts_title$1,
	intelligence_tag_title: intelligence_tag_title$1,
	select: select$1,
	exercise: exercise$1,
	verification: verification$1,
	practice: practice$1
};

var process_button_start$1 = "START";
var process_button_start_again$1 = "START AGAIN";
var process_refresh_show_pagination$1 = "Refresh the page to show pagination on this slide";
var proccess_step_number$1 = "Step {{number}}";
var teacher_notes$1 = "Teaching notes";
var media_audio_browser_not_support_part_1$1 = "Your browser does not support HTML5 audio. here's a";
var media_audio_browser_not_support_part_2_href$1 = "link to audio";
var media_audio_browser_not_support_part_3$1 = "instead.";
var media_video_browser_not_support_part_1$1 = "Your browser does not support HTML5 video. here's a";
var media_video_browser_not_support_part_2_href$1 = "link to video";
var media_video_browser_not_support_part_3$1 = "instead.";
var media_embed_view_on$1 = "Ver en";
var lms_waiting_correction$1 = "Waiting correction...";
var send$1 = "Send";
var highlighter_highlight$1 = "Highlight";
var highlighter_edit_color_highlight$1 = "Edit color";
var highlighter_remove_highlight$1 = "Remove highlight";
var correct$1 = "Correct";
var incorrect$1 = "Incorrect";
var video_no_internet$1 = "The video cannot be displayed. Please, check your internet conection";
var need_help$1 = "I don't understand";
var get_recomendation$1 = "Get recommendation";
var offline_response_exercise_need_internet = "To ensure that your responses in the activities persist, you need to access the online version of the book.";
var offline_highlight_need_internet = "Oops! It seems that the connection has been lost. To save your work in the book, you need to have an internet connection.";
var lesson_link_home = "Home";
var offline_response_exercise_need_internet_type_activity = "You need a stable internet connection to perform this type of activity.";
var undefined_activity$1 = "Undefined activity";
var start = "Start";
var proccess_step_label_number$1 = "{{label}} {{number}}";
var main_page_progress_text = "{{number}}% completed";
var no_alt_tooltip$1 = "It does not contain alternative text";
var button_show_hints$1 = "Hint";
var volume$1 = "Volume";
var speed$1 = "Speed";
var audio_transcription$1 = "Audio transcription";
var current_text$1 = "Current text";
var visorEn = {
	process_button_start: process_button_start$1,
	process_button_start_again: process_button_start_again$1,
	process_refresh_show_pagination: process_refresh_show_pagination$1,
	proccess_step_number: proccess_step_number$1,
	teacher_notes: teacher_notes$1,
	media_audio_browser_not_support_part_1: media_audio_browser_not_support_part_1$1,
	media_audio_browser_not_support_part_2_href: media_audio_browser_not_support_part_2_href$1,
	media_audio_browser_not_support_part_3: media_audio_browser_not_support_part_3$1,
	media_video_browser_not_support_part_1: media_video_browser_not_support_part_1$1,
	media_video_browser_not_support_part_2_href: media_video_browser_not_support_part_2_href$1,
	media_video_browser_not_support_part_3: media_video_browser_not_support_part_3$1,
	media_embed_view_on: media_embed_view_on$1,
	lms_waiting_correction: lms_waiting_correction$1,
	send: send$1,
	highlighter_highlight: highlighter_highlight$1,
	highlighter_edit_color_highlight: highlighter_edit_color_highlight$1,
	highlighter_remove_highlight: highlighter_remove_highlight$1,
	correct: correct$1,
	incorrect: incorrect$1,
	video_no_internet: video_no_internet$1,
	need_help: need_help$1,
	get_recomendation: get_recomendation$1,
	offline_response_exercise_need_internet: offline_response_exercise_need_internet,
	offline_highlight_need_internet: offline_highlight_need_internet,
	lesson_link_home: lesson_link_home,
	offline_response_exercise_need_internet_type_activity: offline_response_exercise_need_internet_type_activity,
	undefined_activity: undefined_activity$1,
	start: start,
	proccess_step_label_number: proccess_step_label_number$1,
	main_page_progress_text: main_page_progress_text,
	no_alt_tooltip: no_alt_tooltip$1,
	button_show_hints: button_show_hints$1,
	volume: volume$1,
	speed: speed$1,
	audio_transcription: audio_transcription$1,
	current_text: current_text$1
};

var text$3 = "Texto";
var impact$3 = "Notas";
var quote$3 = "Frases";
var list$3 = "Listas";
var image$3 = "Imágenes";
var gallery$3 = "Galerías";
var multimedia$3 = "Multimedia";
var interactive$3 = "Interactivos";
var buttons$3 = "Botones";
var divider$3 = "Divisores";
var lemonade$2 = "Actividad";
var Paragraph$3 = "Parrafo";
var Heading$3 = "Cabecera";
var Subheading$3 = "Subcabecera";
var Note$3 = "Nota";
var Carousel$3 = "Carrusel";
var Audio$3 = "Audio";
var Video$3 = "Vídeo";
var Embed$3 = "Embebido";
var Attachment$2 = "Archivo adjunto";
var Accordion$3 = "Acordeón";
var Tabs$3 = "Pestañas";
var Process$3 = "Proceso";
var Button$4 = "Botón";
var Divider$3 = "Divisor";
var Spacer$2 = "Espaciador";
var Classification$2 = "Clasificación";
var button_edit_post$2 = "Editar bloque";
var button_close_edit_post$2 = "Cerrar edición";
var create_block_collection_menu_title$2 = "Biblioteca de bloques";
var empty_lemonade$2 = "Actividad: edita este bloque para elegir plantilla";
var empty_lemonade_feedback$2 = "Actividad UNOIntelligence: edita este bloque para elegir plantilla";
var Edit$2 = "Editar";
var Text$3 = "Texto";
var List$2 = "Lista";
var Image$2 = "Imagen";
var Graphic$2 = "Gráfico";
var Slider$2 = "Proceso";
var Gallery$2 = "Galería";
var Content$2 = "Contenido";
var Settings$2 = "Opciones";
var Description$2 = "Descripción";
var Caption$2 = "Pie de imagen";
var image_alt_text$2 = "Texto alternativo";
var Unspecified$2 = "Sin especificar";
var Left$2 = "Izquierda";
var Center$2 = "Centrada";
var Right$2 = "Derecha";
var Step$2 = "Paso";
var Intro$2 = "Intro";
var Summary$2 = "Sumario";
var Index$2 = "Índice";
var Title$2 = "Título";
var Subtitle$2 = "Subtítulo";
var Column$2 = "Columna";
var help_step_number$2 = "Para indicar donde mostrar el número del paso usa [NUMBER] ejemplo: 'Paso [NUMBER] ejemplo'";
var Small$2 = "Pequeño";
var Medium$2 = "Mediano";
var Undo$2 = "Deshacer";
var Markers$2 = "Marcadores";
var labeledgraphic$2 = "Gráfico etiquetado";
var Change$2 = "Modificar";
var Border$2 = "Borde";
var Loading$2 = "Cargando";
var Activity$2 = "Actividad";
var Visibility$2 = "Visible";
var Notes$2 = "Notas";
var embed_error_not_valid$2 = "Introduce una URL válida (YouTube o Vimeo) o iframe";
var embed_genially_error_not_valid$2 = "Introduce un iframe";
var Timeline$3 = "Linea de tiempo";
var timeline_title_start$2 = "Título de inicio";
var timeline_title_end$2 = "Título de fin";
var tabs_audios_post_title$2 = "Audio {{number}}";
var tabs_audios_post_button_new$2 = "Nuevo";
var tabs_audios_post_button_delete$2 = "Borrar {{audio_title}}";
var tabs_audios_post_block_text$2 = "Bloque #{{number}} _ {{caption}}";
var tabs_audios_post_select_blocks_title$2 = "Selecionar bloques";
var tabs_audios_post_select_head$2 = "Bloques";
var tabs_audios_post_select_help$2 = "Todos los bloques seleccionados deben ser consecutivos";
var tabs_audios_post_select_placeholder$2 = "Seleccionar bloque";
var tabs_audios_post_assigned_to$2 = "Asignado a";
var file_uploaded_successfully$2 = "Audio enviado correctamente";
var files_uploaded_successfully$2 = "Audios enviados correctamente";
var file_drop_audio_line1$2 = "Soltar el audio";
var file_drop_audio_line2$2 = "(o haz click aquí para seleccionar)";
var file_uploading_audio$2 = "Subiendo audio {{number}}%";
var item_delete_audio_empty_blocks$2 = "El audio no está asociado a ningún bloque";
var label_pdf_pages_post$2 = "Páginas";
var item_option_title_edit$2 = "Editar";
var item_option_title_up$2 = "Subir";
var item_option_title_down$2 = "Bajar";
var item_option_title_left$2 = "Mover a la izquierda";
var item_option_title_right$2 = "Mover a la derecha";
var item_option_title_duplicate$2 = "Duplicar";
var item_option_title_settings$2 = "Configuración académica";
var item_option_title_delete$2 = "Borrar";
var item_option_title_audios$2 = "Audios";
var option_item_block_settings$2 = "Opciones";
var option_item_block_change_type$2 = "Cambiar a";
var option_item_block_edit$2 = "Editar";
var option_item_block_move_up$2 = "Mover arriba";
var option_item_block_move_down$2 = "Mover abajo";
var option_item_block_audio$2 = "Audio";
var option_item_block_duplicate$2 = "Duplicar";
var option_item_block_delete$2 = "Borrar";
var additional_content_item_title$1 = "Contenido adicional";
var additional_content_header$1 = "Contenido adicional # {{number}}";
var button_additional_content_add$1 = "Añadir contenido adicional";
var warning_single_post_mode$1 = "Esta lección tiene múltiples posts pero está configurada para mostrar un único post. Por favor, organiza y elimina los posts hasta dejar solo uno. En el visor se mostrará sólo el primer post.";
var row_settings_title = "Configuración de fila";
var row_settings_settings_tab = "Configuración";
var row_settings_width = "Ancho";
var row_settings_gap = "Espacio entre columnas";
var row_settings_background = "Color de fondo";
var row_settings_stack_on_mobile = "Apilar en móvil";
var row_settings_mobile_breakpoint = "Punto de quiebre móvil";
var row_settings_breakpoint_small = "Pequeño (576px)";
var row_settings_breakpoint_medium = "Mediano (768px)";
var row_settings_breakpoint_large = "Grande (992px)";
var row_settings_align_horizontal = "Alineación horizontal";
var row_settings_align_vertical = "Alineación vertical";
var row_settings_align_left = "Izquierda";
var row_settings_align_center = "Centro";
var row_settings_align_right = "Derecha";
var row_settings_align_space_between = "Espacio entre";
var row_settings_align_space_around = "Espacio alrededor";
var row_settings_align_top = "Arriba";
var row_settings_align_bottom = "Abajo";
var row_settings_align_stretch = "Estirar";
var row_settings_no_gap = "Sin espacio";
var row_settings_width_not_set = "Sin definir";
var row_settings_default_width = "Heredado layout ({{width}})";
var row_settings_default_gap = "Heredado layout ({{gap}})";
var row_settings_default_horizontal = "Heredado layout ({{align}})";
var row_settings_default_vertical = "Heredado layout ({{align}})";
var row_settings_default_background = "{{color}}";
var row_settings_padding_not_set = "No definido";
var row_settings_padding_none = "Sin margen";
var row_settings_padding_top = "Margen superior";
var row_settings_padding_bottom = "Margen inferior";
var row_settings_padding_left = "Margen izquierdo";
var row_settings_padding_right = "Margen derecho";
var item_option_title_edit_type_compatible$1 = "Sustituir por bloque compatible";
var settings_column_width = "Ancho columna";
var settings_column_padding_right = "Margen derecho";
var settings_column_padding_left = "Margen izquierdo";
var delete_layout_confirmation_title$1 = "Borrar contenido";
var delete_layout_confirmation_message$1 = "Si borras el bloque central, perderás todo el contenido editado.\n¿Deseas continuar?";
var delete_layout_confirmation_button$1 = "Borrar";
var Cancel$1 = "Cancelar";
var layout_post_sidebar_title = "Configuración general";
var layout_post_sidebar_setting_width = "Tamaño bloque central";
var settings_popup_enable_control = "Incluir contenido emergente";
var settings_popup_enable_control_include = "Incluir";
var settings_popup_enable_control_not_include = "No incluir";
var settings_popup_button_position = "Posición del botón";
var settings_popup_position_top_right = "Superior derecha";
var settings_popup_position_top_left = "Superior izquierda";
var settings_popup_position_bottom_right = "Inferior derecha";
var settings_popup_position_bottom_left = "Inferior izquierda";
var settings_popup_edit_popup = "Editar ventana emergente";
var popup_trigger_icon_label = "Icono del botón";
var popup_trigger_icon_01 = "Bombilla";
var popup_trigger_icon_02 = "Más";
var popup_trigger_icon_03 = "Rayo";
var popup_trigger_icon_04 = "Interrogación";
var popup_trigger_icon_05 = "Estrella";
var popup_trigger_icon_06 = "Corazón";
var popup_trigger_icon_07 = "Ubicación";
var popup_trigger_icon_08 = "Búsqueda";
var popup_trigger_icon_09 = "Exclamación";
var popup_editor_content_header$1 = "Cabecera";
var popup_editor_content_text$1 = "Cuerpo de texto";
var popup_editor_content_type_block$1 = "Contenido multimedia";
var popup_editor_title = "Editar ventana emergente";
var popup_trigger_button_title = "Apariencia del botón";
var popup_trigger_button_subtitle = "Icono";
var popup_media_embed_edit_url_title = "Pega aquí el enlace";
var warning_disable_background_gradient$1 = "El color de fondo es un degradado, pero la opción de degradado no está habilitada en la configuración de mint.";
var clear_background$2 = "Borrar";
var image_caption$2 = "Pie de imagen";
var video_caption$2 = "Pie de vídeo";
var audio_caption$2 = "Pie de audio";
var popup_editor_width = "Tamaño de la ventana emergente";
var popup_editor_width_help = "La vista previa no refleja el tamaño final. La ventana emergente se ajustará correctamente al integrarse en la página";
var tooltip_placeholder$2 = "Escribe aquí...";
var tooltip_char_counter$2 = " / 240 caracteres";
var tooltip_add$2 = "Añadir";
var tooltip_update$2 = "Actualizar";
var tooltip_cancel$2 = "Cancelar";
var tooltip_edit$2 = "Editar";
var tooltip_remove$2 = "Eliminar";
var tooltip_add_or_edit$1 = "Añadir/Editar Tooltip";
var embed_button_add$2 = "Añadir";
var feedback_activity$2 = "Actividad UNOIntelligence";
var settings_manual_scoring_title = "Configuración de corrección manual";
var settings_automatic_scoring_title = "Configuración de corrección automática";
var settings_evaluation_title$2 = "Evaluación";
var settings_attempts_title$2 = "Intentos";
var settings_response_behavior_title = "Comportamiento de las respuestas";
var settings_response_behavior_help = "Información sobre el comportamiento de las respuestas";
var settings_learning_objectives_title = "Objetivos de aprendizaje";
var settings_count_for_note$2 = "La calificación cuenta para la nota";
var settings_add_objectives = "Añadir objetivos";
var intelligence_tag_title$2 = "Etiqueta para Intelligence";
var select$2 = "Seleccionar";
var exercise$2 = "Ejercitación";
var verification$2 = "Comprobación";
var practice$2 = "Práctica";
var editorEs = {
	text: text$3,
	impact: impact$3,
	quote: quote$3,
	list: list$3,
	image: image$3,
	gallery: gallery$3,
	multimedia: multimedia$3,
	interactive: interactive$3,
	"interactive-fullscreen": "Interactivos pantalla completa",
	buttons: buttons$3,
	divider: divider$3,
	lemonade: lemonade$2,
	Paragraph: Paragraph$3,
	"Paragraph with Heading": "Párrafo con cabecera",
	"Paragraph with Subheading": "Párrafo con subcabecera",
	Heading: Heading$3,
	Subheading: Subheading$3,
	"Two column": "Dos columnas",
	"Statement A": "Declaración A",
	"Statement B": "Declaración B",
	"Statement C": "Declaración C",
	"Statement D": "Declaración D",
	Note: Note$3,
	"Quote A": "Frase A",
	"Quote B": "Frase B",
	"Quote C": "Frase C",
	"Quote D": "Frase D",
	"Quote on image": "Frase en imagen",
	"Quote carousel": "Carrusel de frases",
	"Numbered list": "Lista numerada",
	"Checkbox list": "Lista de verificación",
	"Bulleted list": "Lista con viñetas",
	"Image centered": "Imagen centrada",
	"Image full width": "Imagen pantalla completa",
	"Image & text": "Imagen y texto",
	"Text on image": "Texto en imagen",
	Carousel: Carousel$3,
	"Two column grid": "Dos columnas",
	"Three column grid": "Tres columnas",
	"Four column grid": "Cuatro columnas",
	Audio: Audio$3,
	Video: Video$3,
	Embed: Embed$3,
	Attachment: Attachment$2,
	"Code snippet": "Fragmento de código",
	Accordion: Accordion$3,
	Tabs: Tabs$3,
	"Labeled Graphic": "Gráfico etiquetado",
	Process: Process$3,
	Button: Button$4,
	"Button stack": "Pila de botones",
	Divider: Divider$3,
	Spacer: Spacer$2,
	"Lemonade content guid": "Lemonade content guid",
	"Multiple choice standard": "Test con respuesta única",
	"Multiple choice multiple": "Test con respuesta múltiple",
	"Multiple choice true / false": "Test con con verdadero / falso",
	"Multiple choice block letter": "Test con respuesta múltiple en bloque",
	"Choice matrix standard": "Tabla de selección",
	"Choice matrix inline": "Lista de selección",
	"Essay plain text": "Respuesta abierta",
	"Essay short text": "Respuesta corta",
	"Cloze with drag & drop": "Completar huecos con arrastrar y soltar",
	"Cloze with dropdown": "Completar huecos con desplegable",
	"Cloze with text": "Completar huecos con texto",
	Classification: Classification$2,
	"Match list": "Emparejar",
	"Order list": "Ordenar lista",
	"Label image with text": "Completar imagen con texto",
	button_edit_post: button_edit_post$2,
	button_close_edit_post: button_close_edit_post$2,
	create_block_collection_menu_title: create_block_collection_menu_title$2,
	empty_lemonade: empty_lemonade$2,
	empty_lemonade_feedback: empty_lemonade_feedback$2,
	"Type something": "Escribir aquí",
	Edit: Edit$2,
	"All Blocks": "Todos",
	"Add your first itemblock": "Añade tu primer bloque",
	Text: Text$3,
	List: List$2,
	Image: Image$2,
	Graphic: Graphic$2,
	Slider: Slider$2,
	Gallery: Gallery$2,
	Content: Content$2,
	Settings: Settings$2,
	Description: Description$2,
	Caption: Caption$2,
	image_alt_text: image_alt_text$2,
	"Image alignment": "Alineación de imagen",
	Unspecified: Unspecified$2,
	Left: Left$2,
	Center: Center$2,
	Right: Right$2,
	"Padding Top": "Margen superior",
	"Padding Bottom": "Margen inferior",
	"No padding": "Sin margen",
	"Background Color": "Color de fondo",
	"Select color": "Selecciona color",
	"List item": "Elemento",
	"Add item": "Añadir elemento",
	"Add Image": "Añadir imagen",
	"Add Step": "Añadir paso",
	Step: Step$2,
	Intro: Intro$2,
	Summary: Summary$2,
	Index: Index$2,
	Title: Title$2,
	Subtitle: Subtitle$2,
	Column: Column$2,
	help_step_number: help_step_number$2,
	Small: Small$2,
	Medium: Medium$2,
	"Full width": "Ancho completo",
	"Image width": "Anchura imagen",
	"Removed block": "Bloque eliminado",
	Undo: Undo$2,
	"Teacher notes": "Notas para el profesorado",
	Markers: Markers$2,
	"Marker style": "Estilo de marca",
	labeledgraphic: labeledgraphic$2,
	"Press Enter to add": "Pulsa Enter para añadir",
	Change: Change$2,
	"Show border": "Mostrar borde",
	Border: Border$2,
	Loading: Loading$2,
	Activity: Activity$2,
	"Image position": "Posición de la imagen",
	"Image size": "Tamaño de la imagen",
	"Add an item block": "Añade un bloque de contenido",
	Visibility: Visibility$2,
	"Teacher only": "Solo para el docente",
	"Add your first block": "Añade tu primer bloque",
	"Enter a title...": "Escribe un título...",
	"Upload video": "Subir vídeo",
	"URL video": "URL vídeo",
	Notes: Notes$2,
	embed_error_not_valid: embed_error_not_valid$2,
	embed_genially_error_not_valid: embed_genially_error_not_valid$2,
	Timeline: Timeline$3,
	timeline_title_start: timeline_title_start$2,
	timeline_title_end: timeline_title_end$2,
	tabs_audios_post_title: tabs_audios_post_title$2,
	tabs_audios_post_button_new: tabs_audios_post_button_new$2,
	tabs_audios_post_button_delete: tabs_audios_post_button_delete$2,
	tabs_audios_post_block_text: tabs_audios_post_block_text$2,
	tabs_audios_post_select_blocks_title: tabs_audios_post_select_blocks_title$2,
	tabs_audios_post_select_head: tabs_audios_post_select_head$2,
	tabs_audios_post_select_help: tabs_audios_post_select_help$2,
	tabs_audios_post_select_placeholder: tabs_audios_post_select_placeholder$2,
	tabs_audios_post_assigned_to: tabs_audios_post_assigned_to$2,
	file_uploaded_successfully: file_uploaded_successfully$2,
	files_uploaded_successfully: files_uploaded_successfully$2,
	file_drop_audio_line1: file_drop_audio_line1$2,
	file_drop_audio_line2: file_drop_audio_line2$2,
	file_uploading_audio: file_uploading_audio$2,
	item_delete_audio_empty_blocks: item_delete_audio_empty_blocks$2,
	"Select all": "Seleccionar todo",
	"files supported": "Formatos soportados: {{format}}",
	label_pdf_pages_post: label_pdf_pages_post$2,
	item_option_title_edit: item_option_title_edit$2,
	item_option_title_up: item_option_title_up$2,
	item_option_title_down: item_option_title_down$2,
	item_option_title_left: item_option_title_left$2,
	item_option_title_right: item_option_title_right$2,
	item_option_title_duplicate: item_option_title_duplicate$2,
	item_option_title_settings: item_option_title_settings$2,
	item_option_title_delete: item_option_title_delete$2,
	item_option_title_audios: item_option_title_audios$2,
	option_item_block_settings: option_item_block_settings$2,
	option_item_block_change_type: option_item_block_change_type$2,
	option_item_block_edit: option_item_block_edit$2,
	option_item_block_move_up: option_item_block_move_up$2,
	option_item_block_move_down: option_item_block_move_down$2,
	option_item_block_audio: option_item_block_audio$2,
	option_item_block_duplicate: option_item_block_duplicate$2,
	option_item_block_delete: option_item_block_delete$2,
	additional_content_item_title: additional_content_item_title$1,
	additional_content_header: additional_content_header$1,
	button_additional_content_add: button_additional_content_add$1,
	warning_single_post_mode: warning_single_post_mode$1,
	row_settings_title: row_settings_title,
	row_settings_settings_tab: row_settings_settings_tab,
	row_settings_width: row_settings_width,
	row_settings_gap: row_settings_gap,
	row_settings_background: row_settings_background,
	row_settings_stack_on_mobile: row_settings_stack_on_mobile,
	row_settings_mobile_breakpoint: row_settings_mobile_breakpoint,
	row_settings_breakpoint_small: row_settings_breakpoint_small,
	row_settings_breakpoint_medium: row_settings_breakpoint_medium,
	row_settings_breakpoint_large: row_settings_breakpoint_large,
	row_settings_align_horizontal: row_settings_align_horizontal,
	row_settings_align_vertical: row_settings_align_vertical,
	row_settings_align_left: row_settings_align_left,
	row_settings_align_center: row_settings_align_center,
	row_settings_align_right: row_settings_align_right,
	row_settings_align_space_between: row_settings_align_space_between,
	row_settings_align_space_around: row_settings_align_space_around,
	row_settings_align_top: row_settings_align_top,
	row_settings_align_bottom: row_settings_align_bottom,
	row_settings_align_stretch: row_settings_align_stretch,
	row_settings_no_gap: row_settings_no_gap,
	row_settings_width_not_set: row_settings_width_not_set,
	row_settings_default_width: row_settings_default_width,
	row_settings_default_gap: row_settings_default_gap,
	row_settings_default_horizontal: row_settings_default_horizontal,
	row_settings_default_vertical: row_settings_default_vertical,
	row_settings_default_background: row_settings_default_background,
	row_settings_padding_not_set: row_settings_padding_not_set,
	row_settings_padding_none: row_settings_padding_none,
	row_settings_padding_top: row_settings_padding_top,
	row_settings_padding_bottom: row_settings_padding_bottom,
	row_settings_padding_left: row_settings_padding_left,
	row_settings_padding_right: row_settings_padding_right,
	item_option_title_edit_type_compatible: item_option_title_edit_type_compatible$1,
	settings_column_width: settings_column_width,
	settings_column_padding_right: settings_column_padding_right,
	settings_column_padding_left: settings_column_padding_left,
	delete_layout_confirmation_title: delete_layout_confirmation_title$1,
	delete_layout_confirmation_message: delete_layout_confirmation_message$1,
	delete_layout_confirmation_button: delete_layout_confirmation_button$1,
	Cancel: Cancel$1,
	layout_post_sidebar_title: layout_post_sidebar_title,
	layout_post_sidebar_setting_width: layout_post_sidebar_setting_width,
	settings_popup_enable_control: settings_popup_enable_control,
	settings_popup_enable_control_include: settings_popup_enable_control_include,
	settings_popup_enable_control_not_include: settings_popup_enable_control_not_include,
	settings_popup_button_position: settings_popup_button_position,
	settings_popup_position_top_right: settings_popup_position_top_right,
	settings_popup_position_top_left: settings_popup_position_top_left,
	settings_popup_position_bottom_right: settings_popup_position_bottom_right,
	settings_popup_position_bottom_left: settings_popup_position_bottom_left,
	settings_popup_edit_popup: settings_popup_edit_popup,
	popup_trigger_icon_label: popup_trigger_icon_label,
	popup_trigger_icon_01: popup_trigger_icon_01,
	popup_trigger_icon_02: popup_trigger_icon_02,
	popup_trigger_icon_03: popup_trigger_icon_03,
	popup_trigger_icon_04: popup_trigger_icon_04,
	popup_trigger_icon_05: popup_trigger_icon_05,
	popup_trigger_icon_06: popup_trigger_icon_06,
	popup_trigger_icon_07: popup_trigger_icon_07,
	popup_trigger_icon_08: popup_trigger_icon_08,
	popup_trigger_icon_09: popup_trigger_icon_09,
	popup_editor_content_header: popup_editor_content_header$1,
	popup_editor_content_text: popup_editor_content_text$1,
	popup_editor_content_type_block: popup_editor_content_type_block$1,
	popup_editor_title: popup_editor_title,
	popup_trigger_button_title: popup_trigger_button_title,
	popup_trigger_button_subtitle: popup_trigger_button_subtitle,
	popup_media_embed_edit_url_title: popup_media_embed_edit_url_title,
	warning_disable_background_gradient: warning_disable_background_gradient$1,
	clear_background: clear_background$2,
	image_caption: image_caption$2,
	video_caption: video_caption$2,
	audio_caption: audio_caption$2,
	popup_editor_width: popup_editor_width,
	popup_editor_width_help: popup_editor_width_help,
	tooltip_placeholder: tooltip_placeholder$2,
	tooltip_char_counter: tooltip_char_counter$2,
	tooltip_add: tooltip_add$2,
	tooltip_update: tooltip_update$2,
	tooltip_cancel: tooltip_cancel$2,
	tooltip_edit: tooltip_edit$2,
	tooltip_remove: tooltip_remove$2,
	tooltip_add_or_edit: tooltip_add_or_edit$1,
	embed_button_add: embed_button_add$2,
	feedback_activity: feedback_activity$2,
	settings_manual_scoring_title: settings_manual_scoring_title,
	settings_automatic_scoring_title: settings_automatic_scoring_title,
	settings_evaluation_title: settings_evaluation_title$2,
	settings_attempts_title: settings_attempts_title$2,
	settings_response_behavior_title: settings_response_behavior_title,
	settings_response_behavior_help: settings_response_behavior_help,
	settings_learning_objectives_title: settings_learning_objectives_title,
	settings_count_for_note: settings_count_for_note$2,
	settings_add_objectives: settings_add_objectives,
	intelligence_tag_title: intelligence_tag_title$2,
	select: select$2,
	exercise: exercise$2,
	verification: verification$2,
	practice: practice$2
};

var process_button_start$2 = "COMENZAR";
var process_button_start_again$2 = "EMPEZAR DE NUEVO";
var process_refresh_show_pagination$2 = "Refresca la página para mostrar la paginación en esta diapositiva";
var proccess_step_number$2 = "Paso {{number}}";
var teacher_notes$2 = "Notas para el profesorado";
var media_audio_browser_not_support_part_1$2 = "Su navegador no soporta audio HTML5. Aquí hay un";
var media_audio_browser_not_support_part_2_href$2 = "enlace al audio";
var media_audio_browser_not_support_part_3$2 = "en su lugar.";
var media_video_browser_not_support_part_1$2 = "Su navegador no soporta video HTML5. Aquí hay un";
var media_video_browser_not_support_part_2_href$2 = "enlace al video";
var media_video_browser_not_support_part_3$2 = "en su lugar.";
var media_embed_view_on$2 = "Ver en";
var lms_waiting_correction$2 = "Esperando corrección...";
var send$2 = "Enviar";
var highlighter_highlight$2 = "Resaltar";
var highlighter_edit_color_highlight$2 = "Editar color";
var highlighter_remove_highlight$2 = "Quitar resaltado";
var correct$2 = "Correcto";
var incorrect$2 = "Incorrecto";
var video_no_internet$2 = "No se puede visualizar el vídeo. Por favor, comprueba tu conexión a internet.";
var need_help$2 = "No lo entiendo";
var get_recomendation$2 = "Recomendación";
var offline_response_exercise_need_internet$1 = "Para que tus respuestas en las actividades persistan tienes que acceder a la versión online del libro";
var offline_highlight_need_internet$1 = "Ups! Parece que se ha perdido la conexión. Para que tu trabajo en el libro se guarde debes tener conexión a internet.";
var lesson_link_home$1 = "Inicio";
var offline_response_exercise_need_internet_type_activity$1 = "Necesitas una conexión estable a internet para hacer este tipo de actividad";
var undefined_activity$2 = "Actividad sin definir";
var start$1 = "Comenzar";
var proccess_step_label_number$2 = "{{label}} {{number}}";
var main_page_progress_text$1 = "{{number}}% completado";
var no_alt_tooltip$2 = "No contiene texto alternativo";
var button_show_hints$2 = "Pista";
var volume$2 = "Volumen";
var speed$2 = "Velocidad";
var audio_transcription$2 = "Transcripción";
var current_text$2 = "Texto actual";
var visorEs = {
	process_button_start: process_button_start$2,
	process_button_start_again: process_button_start_again$2,
	process_refresh_show_pagination: process_refresh_show_pagination$2,
	proccess_step_number: proccess_step_number$2,
	teacher_notes: teacher_notes$2,
	media_audio_browser_not_support_part_1: media_audio_browser_not_support_part_1$2,
	media_audio_browser_not_support_part_2_href: media_audio_browser_not_support_part_2_href$2,
	media_audio_browser_not_support_part_3: media_audio_browser_not_support_part_3$2,
	media_video_browser_not_support_part_1: media_video_browser_not_support_part_1$2,
	media_video_browser_not_support_part_2_href: media_video_browser_not_support_part_2_href$2,
	media_video_browser_not_support_part_3: media_video_browser_not_support_part_3$2,
	media_embed_view_on: media_embed_view_on$2,
	lms_waiting_correction: lms_waiting_correction$2,
	send: send$2,
	highlighter_highlight: highlighter_highlight$2,
	highlighter_edit_color_highlight: highlighter_edit_color_highlight$2,
	highlighter_remove_highlight: highlighter_remove_highlight$2,
	correct: correct$2,
	incorrect: incorrect$2,
	video_no_internet: video_no_internet$2,
	need_help: need_help$2,
	get_recomendation: get_recomendation$2,
	offline_response_exercise_need_internet: offline_response_exercise_need_internet$1,
	offline_highlight_need_internet: offline_highlight_need_internet$1,
	lesson_link_home: lesson_link_home$1,
	offline_response_exercise_need_internet_type_activity: offline_response_exercise_need_internet_type_activity$1,
	undefined_activity: undefined_activity$2,
	start: start$1,
	proccess_step_label_number: proccess_step_label_number$2,
	main_page_progress_text: main_page_progress_text$1,
	no_alt_tooltip: no_alt_tooltip$2,
	button_show_hints: button_show_hints$2,
	volume: volume$2,
	speed: speed$2,
	audio_transcription: audio_transcription$2,
	current_text: current_text$2
};

var text$4 = "Testua";
var impact$4 = "Nabarmenduak";
var quote$4 = "Esaldiak";
var list$4 = "Zerrendak";
var image$4 = "Irudiak";
var gallery$4 = "Galeriak";
var multimedia$4 = "Multimedia";
var interactive$4 = "Interaktiboak";
var buttons$4 = "Botoiak";
var divider$4 = "Zatitzaileak";
var lemonade$3 = "Jarduera";
var Paragraph$4 = "Paragrafoa";
var Heading$4 = "Goiburua";
var Subheading$4 = "Azpigoiburua";
var Note$4 = "Oharra";
var Carousel$4 = "Karrusela";
var Audio$4 = "Audioa";
var Video$4 = "Bideoa";
var Embed$4 = "Txertatuta";
var Attachment$3 = "Fitxategi erantsia";
var Accordion$4 = "Akordeoia";
var Tabs$4 = "Erlaitzak";
var Process$4 = "Prozesua";
var Button$5 = "Botoia";
var Divider$4 = "Zatitzailea";
var Spacer$3 = "Zuriune barra";
var Classification$3 = "Sailkapena";
var button_edit_post$3 = "Editatu blokea";
var button_close_edit_post$3 = "Itxi edizioa";
var create_block_collection_menu_title$3 = "Bloke liburutegia";
var empty_lemonade$3 = "Jarduera: editatu blokea plantilaketa aukeratzeko";
var empty_lemonade_feedback$3 = "UNOIntelligence Jarduera: editatu bloke hau txantiloi bat aukeratzeko";
var Edit$3 = "Editatu";
var Text$4 = "Testua";
var List$3 = "Zerrenda";
var Image$3 = "Irudia";
var Graphic$3 = "Grafikoa";
var Slider$3 = "Prozesua";
var Gallery$3 = "Galeria";
var Content$3 = "Edukia";
var Settings$3 = "Aukerak";
var Description$3 = "Deskribapena";
var Caption$3 = "Etiketa";
var image_alt_text$3 = "Irudiaren testu alternatiboa";
var Unspecified$3 = "Zehaztu gabe";
var Left$3 = "Ezkerra";
var Center$3 = "Erdiratuta";
var Right$3 = "Eskuina";
var Step$3 = "Pausoa";
var Intro$3 = "Sartu";
var Summary$3 = "Laburpena";
var Index$3 = "Aurkibidea";
var Title$3 = "Titulua";
var Subtitle$3 = "Azpititulua";
var Column$3 = "Zutabea";
var help_step_number$3 = "Pausoaren zenbakia non erakutsi adierazteko, erabili [NUMBER] adibidea: '[NUMBER] pausoa adibidea'";
var Small$3 = "Txikia";
var Medium$3 = "Ertaina";
var Undo$3 = "Desegin";
var Markers$3 = "Laster markak";
var labeledgraphic$3 = "Grafiko etiketatua";
var Change$3 = "Aldatu";
var Border$3 = "Ertza";
var Loading$3 = "Kargatzen";
var Activity$3 = "Jarduera";
var Visibility$3 = "Ikusgai";
var Notes$3 = "Notak";
var embed_error_not_valid$3 = "Sartu baliozko URL bat (Youtube edo Vimeo) edo iframe bat";
var embed_genially_error_not_valid$3 = "Sartu iframe bat";
var Timeline$4 = "Denbora lerro";
var timeline_title_start$3 = "Hasierako titulua";
var timeline_title_end$3 = "Amaierako titulua";
var tabs_audios_post_title$3 = "Audioa {{number}}";
var tabs_audios_post_button_new$3 = "Berria";
var tabs_audios_post_button_delete$3 = "Ezabatu {{audio_title}}";
var tabs_audios_post_block_text$3 = "Blokea #{{number}} _ {{caption}}";
var tabs_audios_post_select_blocks_title$3 = "Aukeratu blokeak";
var tabs_audios_post_select_head$3 = "Blokeak";
var tabs_audios_post_select_help$3 = "Aukeratutako bloke guztiak jarraian egon behar dute";
var tabs_audios_post_select_placeholder$3 = "Aukeratu blokea";
var tabs_audios_post_assigned_to$3 = "Esleituta";
var file_uploaded_successfully$3 = "Audioa behar bezala igo da";
var files_uploaded_successfully$3 = "Audioak behar bezala igo dira";
var file_drop_audio_line1$3 = "Utzi audioa";
var file_drop_audio_line2$3 = "(edo klik egin hemen hautatzeko)";
var file_uploading_audio$3 = "Audioa igotzen {{number}}%";
var item_delete_audio_empty_blocks$3 = "Audioa ez dago bloke batekin ere lotuta";
var label_pdf_pages_post$3 = "Orriak";
var item_option_title_edit$3 = "Editatu";
var item_option_title_up$3 = "Igo";
var item_option_title_down$3 = "Jaitsi";
var item_option_title_left$3 = "Ezkerrera";
var item_option_title_right$3 = "Eskubiera";
var item_option_title_duplicate$3 = "Bikoiztu";
var item_option_title_settings$3 = "Ikastararen konfigurazioa";
var item_option_title_delete$3 = "Ezabatu";
var item_option_title_audios$3 = "Audioak";
var option_item_block_settings$3 = "Aukerak";
var option_item_block_change_type$3 = "Aldatu";
var option_item_block_edit$3 = "Editatu";
var option_item_block_move_up$3 = "Mugitu gora";
var option_item_block_move_down$3 = "Mugitu behera";
var option_item_block_audio$3 = "Audio";
var option_item_block_duplicate$3 = "Bikoiztu";
var option_item_block_delete$3 = "Ezabatu";
var additional_content_item_title$2 = "Edukia gehiago";
var additional_content_header$2 = "Edukia gehiago # {{number}}";
var button_additional_content_add$2 = "Edukia gehiago gehitu";
var warning_single_post_mode$2 = "Lección hau multiplo post ditu baina bakarrik post baten bistaratzeko konfiguratuta dago. Mesedez, organizatu eta ezabatu postak errorean bakarrik gelditzen dena. Lehenengo posta bakarrik erakutsi daiteke.";
var warning_disable_background_gradient$2 = "Atzealdeko kolorea degradatu bat da, baina degradatu aukerak desgaitu da mintaren konfigurazioan.";
var clear_background$3 = "Ezabatu";
var image_caption$3 = "Irudiaren etiketa";
var video_caption$3 = "Bideoaren etiketa";
var audio_caption$3 = "Audioaren oina";
var tooltip_placeholder$3 = "Idatzi hemen...";
var tooltip_char_counter$3 = "/ 240 karaktere";
var tooltip_add$3 = "Gehitu";
var tooltip_update$3 = "Eguneratu";
var tooltip_cancel$3 = "Utzi";
var tooltip_edit$3 = "Editatu";
var tooltip_remove$3 = "Ezabatu";
var tooltip_add_or_edit$2 = "Gehitu/Editatu Tooltip";
var embed_button_add$3 = "Gehitu";
var feedback_activity$3 = "UNOIntelligence Jarduera";
var settings_evaluation_title$3 = "Ebaluazioa";
var settings_count_for_note$3 = "Kalifikazioa azken notan kontatzen da";
var settings_attempts_title$3 = "Saiakerak";
var intelligence_tag_title$3 = "Intelligence Etiketa";
var select$3 = "Aukeratu";
var exercise$3 = "Ariketak";
var verification$3 = "Egiaztapena";
var practice$3 = "Praktika";
var editorEU = {
	text: text$4,
	impact: impact$4,
	quote: quote$4,
	list: list$4,
	image: image$4,
	gallery: gallery$4,
	multimedia: multimedia$4,
	interactive: interactive$4,
	"interactive-fullscreen": "Pantaila osoko interaktiboak",
	buttons: buttons$4,
	divider: divider$4,
	lemonade: lemonade$3,
	Paragraph: Paragraph$4,
	"Paragraph with Heading": "Goiburudun paragrafoa",
	"Paragraph with Subheading": "Azpigoiburudun paragrafoa",
	Heading: Heading$4,
	Subheading: Subheading$4,
	"Two column": "Bi zutabe",
	"Statement A": "A adierazpena",
	"Statement B": "B adierazpena",
	"Statement C": "C adierazpena",
	"Statement D": "D adierazpena",
	Note: Note$4,
	"Quote A": "A esaldia",
	"Quote B": "B esaldia",
	"Quote C": "C esaldia",
	"Quote D": "D esaldia",
	"Quote on image": "Esaldia irudian",
	"Quote carousel": "Esaldi karrusela",
	"Numbered list": "Zenbakidun zerrenda",
	"Checkbox list": "Egiaztapen zerrenda",
	"Bulleted list": "Binetadun zerrenda",
	"Image centered": "Irudi erdiratua",
	"Image full width": "Pantaila osoko irudia",
	"Image & text": "Irudia eta testua",
	"Text on image": "Irudidun testua",
	Carousel: Carousel$4,
	"Two column grid": "Bi zutabe",
	"Three column grid": "Hiru zutabe",
	"Four column grid": "Lau zutabe",
	Audio: Audio$4,
	Video: Video$4,
	Embed: Embed$4,
	Attachment: Attachment$3,
	"Code snippet": "Kode zatia",
	Accordion: Accordion$4,
	Tabs: Tabs$4,
	"Labeled Graphic": "Grafiko etiketatua",
	Process: Process$4,
	Button: Button$5,
	"Button stack": "Botoi pila",
	Divider: Divider$4,
	Spacer: Spacer$3,
	"Lemonade content guid": "Lemonade content guid",
	"Multiple choice standard": "Erantzun bakarreko testa",
	"Multiple choice multiple": "Erantzun ugariko testa",
	"Multiple choice true / false": "Zuzena/okerra duen testua",
	"Multiple choice block letter": "Blokeko erantzun ugariko testa",
	"Choice matrix standard": "Aukeraketa taula",
	"Choice matrix inline": "Aukeraketa zerrenda",
	"Essay plain text": "Erantzun irekia",
	"Essay short text": "Erantzun laburra",
	"Cloze with drag & drop": "Osatu hutsuneak, arrastatu eta askatuta",
	"Cloze with dropdown": "Osatu hutsuneak goitibeherako menuarekin",
	"Cloze with text": "Osatu hutsuneak testuarekin",
	Classification: Classification$3,
	"Match list": "Egin bikoteak",
	"Order list": "Ordenatu zerrenda",
	"Label image with text": "Osatu irudia testuarekin",
	button_edit_post: button_edit_post$3,
	button_close_edit_post: button_close_edit_post$3,
	create_block_collection_menu_title: create_block_collection_menu_title$3,
	empty_lemonade: empty_lemonade$3,
	empty_lemonade_feedback: empty_lemonade_feedback$3,
	"Type something": "Idatzi zerbait",
	Edit: Edit$3,
	"All Blocks": "Guztiak",
	"Add your first itemblock": "Gehitu zure lehen blokea",
	Text: Text$4,
	List: List$3,
	Image: Image$3,
	Graphic: Graphic$3,
	Slider: Slider$3,
	Gallery: Gallery$3,
	Content: Content$3,
	Settings: Settings$3,
	Description: Description$3,
	Caption: Caption$3,
	image_alt_text: image_alt_text$3,
	"Image alignment": "Irudia lerrokatzea",
	Unspecified: Unspecified$3,
	Left: Left$3,
	Center: Center$3,
	Right: Right$3,
	"Padding Top": "Goiko marjina",
	"Padding Bottom": "Beheko marjina",
	"No padding": "Marjinarik gabe",
	"Background Color": "Atzealdeko kolorea",
	"Select color": "Aukeratu kolorea",
	"List item": "Elementua",
	"Add item": "Gehitu elementua",
	"Add Image": "Gehitu irudia",
	"Add Step": "Gehitu pausoa",
	Step: Step$3,
	Intro: Intro$3,
	Summary: Summary$3,
	Index: Index$3,
	Title: Title$3,
	Subtitle: Subtitle$3,
	Column: Column$3,
	help_step_number: help_step_number$3,
	Small: Small$3,
	Medium: Medium$3,
	"Full width": "Zabalera osoa",
	"Image width": "Irudiaren zabalera",
	"Removed block": "Blokea ezabatuta",
	Undo: Undo$3,
	"Teacher notes": "Irakaslearentzako oharrak",
	Markers: Markers$3,
	"Marker style": "Marka mota",
	labeledgraphic: labeledgraphic$3,
	"Press Enter to add": "Sakatu Enter gehitzeko",
	Change: Change$3,
	"Show border": "Erakutsi ertza",
	Border: Border$3,
	Loading: Loading$3,
	Activity: Activity$3,
	"Image position": "Irudiaren posizioa",
	"Image size": "Irudiaren tamaina",
	"Add an item block": "Gehitu eduki bloke bat",
	Visibility: Visibility$3,
	"Teacher only": "Irakaslearentzako bakarrik",
	"Add your first block": "Gehitu lehenengo blokea",
	"Enter a title...": "Idatzi izenburu bat...",
	"Upload video": "Igo bideoa",
	"URL video": "URL bideoa",
	Notes: Notes$3,
	embed_error_not_valid: embed_error_not_valid$3,
	embed_genially_error_not_valid: embed_genially_error_not_valid$3,
	Timeline: Timeline$4,
	timeline_title_start: timeline_title_start$3,
	timeline_title_end: timeline_title_end$3,
	tabs_audios_post_title: tabs_audios_post_title$3,
	tabs_audios_post_button_new: tabs_audios_post_button_new$3,
	tabs_audios_post_button_delete: tabs_audios_post_button_delete$3,
	tabs_audios_post_block_text: tabs_audios_post_block_text$3,
	tabs_audios_post_select_blocks_title: tabs_audios_post_select_blocks_title$3,
	tabs_audios_post_select_head: tabs_audios_post_select_head$3,
	tabs_audios_post_select_help: tabs_audios_post_select_help$3,
	tabs_audios_post_select_placeholder: tabs_audios_post_select_placeholder$3,
	tabs_audios_post_assigned_to: tabs_audios_post_assigned_to$3,
	file_uploaded_successfully: file_uploaded_successfully$3,
	files_uploaded_successfully: files_uploaded_successfully$3,
	file_drop_audio_line1: file_drop_audio_line1$3,
	file_drop_audio_line2: file_drop_audio_line2$3,
	file_uploading_audio: file_uploading_audio$3,
	item_delete_audio_empty_blocks: item_delete_audio_empty_blocks$3,
	"Select all": "Aukeratu dena",
	"files supported": "Onartutako formatuak: {{format}}",
	label_pdf_pages_post: label_pdf_pages_post$3,
	item_option_title_edit: item_option_title_edit$3,
	item_option_title_up: item_option_title_up$3,
	item_option_title_down: item_option_title_down$3,
	item_option_title_left: item_option_title_left$3,
	item_option_title_right: item_option_title_right$3,
	item_option_title_duplicate: item_option_title_duplicate$3,
	item_option_title_settings: item_option_title_settings$3,
	item_option_title_delete: item_option_title_delete$3,
	item_option_title_audios: item_option_title_audios$3,
	option_item_block_settings: option_item_block_settings$3,
	option_item_block_change_type: option_item_block_change_type$3,
	option_item_block_edit: option_item_block_edit$3,
	option_item_block_move_up: option_item_block_move_up$3,
	option_item_block_move_down: option_item_block_move_down$3,
	option_item_block_audio: option_item_block_audio$3,
	option_item_block_duplicate: option_item_block_duplicate$3,
	option_item_block_delete: option_item_block_delete$3,
	additional_content_item_title: additional_content_item_title$2,
	additional_content_header: additional_content_header$2,
	button_additional_content_add: button_additional_content_add$2,
	warning_single_post_mode: warning_single_post_mode$2,
	warning_disable_background_gradient: warning_disable_background_gradient$2,
	clear_background: clear_background$3,
	image_caption: image_caption$3,
	video_caption: video_caption$3,
	audio_caption: audio_caption$3,
	tooltip_placeholder: tooltip_placeholder$3,
	tooltip_char_counter: tooltip_char_counter$3,
	tooltip_add: tooltip_add$3,
	tooltip_update: tooltip_update$3,
	tooltip_cancel: tooltip_cancel$3,
	tooltip_edit: tooltip_edit$3,
	tooltip_remove: tooltip_remove$3,
	tooltip_add_or_edit: tooltip_add_or_edit$2,
	embed_button_add: embed_button_add$3,
	feedback_activity: feedback_activity$3,
	settings_evaluation_title: settings_evaluation_title$3,
	settings_count_for_note: settings_count_for_note$3,
	settings_attempts_title: settings_attempts_title$3,
	intelligence_tag_title: intelligence_tag_title$3,
	select: select$3,
	exercise: exercise$3,
	verification: verification$3,
	practice: practice$3
};

var process_button_start$3 = "HASI";
var process_button_start_again$3 = "HASI BERRIRO";
var process_refresh_show_pagination$3 = "Freskatu orria diapositiba honetan orrialde-zenbaketa bistaratzeko";
var proccess_step_number$3 = "{{number}}. urratsa";
var teacher_notes$3 = "Irakaslearentzako oharrak";
var media_audio_browser_not_support_part_1$3 = "Zure nabigatzaileak ez du HTML5 audioa onartzen. Hemen duzu";
var media_audio_browser_not_support_part_2_href$3 = "audiorako esteka";
var media_audio_browser_not_support_part_3$3 = "haren ordez.";
var media_video_browser_not_support_part_1$3 = "Zure nabigatzaileak ez du HTML5 bideoa onartzen. Hemen duzu";
var media_video_browser_not_support_part_2_href$3 = "bideorako esteka";
var media_video_browser_not_support_part_3$3 = "haren ordez.";
var media_embed_view_on$3 = "Ikusi hemen:";
var lms_waiting_correction$3 = "Zuzenketaren zain...";
var send$3 = "Bidali";
var highlighter_highlight$3 = "Nabarmendu";
var highlighter_edit_color_highlight$3 = "Editatu kolorea";
var highlighter_remove_highlight$3 = "Nabarmendutakoa kendu";
var correct$3 = "Zuzena";
var incorrect$3 = "Okerra";
var video_no_internet$3 = "Ezin da bideoa ikusi. Mesedez, egiaztatu zure Interneteko konexioa.";
var need_help$3 = "No lo entiendo";
var get_recomendation$3 = "Recomendación";
var undefined_activity$3 = "Definik gabe dagoen aktibitatea.";
var proccess_step_label_number$3 = "{{number}}. {{label}}";
var no_alt_tooltip$3 = "Ez du testu alternatiborik";
var button_show_hints$3 = "Lagungarria";
var volume$3 = "Bolumena";
var speed$3 = "Abiadura";
var audio_transcription$3 = "Audio transkripzioa";
var current_text$3 = "Uneko testua";
var visorEU = {
	process_button_start: process_button_start$3,
	process_button_start_again: process_button_start_again$3,
	process_refresh_show_pagination: process_refresh_show_pagination$3,
	proccess_step_number: proccess_step_number$3,
	teacher_notes: teacher_notes$3,
	media_audio_browser_not_support_part_1: media_audio_browser_not_support_part_1$3,
	media_audio_browser_not_support_part_2_href: media_audio_browser_not_support_part_2_href$3,
	media_audio_browser_not_support_part_3: media_audio_browser_not_support_part_3$3,
	media_video_browser_not_support_part_1: media_video_browser_not_support_part_1$3,
	media_video_browser_not_support_part_2_href: media_video_browser_not_support_part_2_href$3,
	media_video_browser_not_support_part_3: media_video_browser_not_support_part_3$3,
	media_embed_view_on: media_embed_view_on$3,
	lms_waiting_correction: lms_waiting_correction$3,
	send: send$3,
	highlighter_highlight: highlighter_highlight$3,
	highlighter_edit_color_highlight: highlighter_edit_color_highlight$3,
	highlighter_remove_highlight: highlighter_remove_highlight$3,
	correct: correct$3,
	incorrect: incorrect$3,
	video_no_internet: video_no_internet$3,
	need_help: need_help$3,
	get_recomendation: get_recomendation$3,
	undefined_activity: undefined_activity$3,
	proccess_step_label_number: proccess_step_label_number$3,
	no_alt_tooltip: no_alt_tooltip$3,
	button_show_hints: button_show_hints$3,
	volume: volume$3,
	speed: speed$3,
	audio_transcription: audio_transcription$3,
	current_text: current_text$3
};

var text$5 = "Texto";
var impact$5 = "Destacados";
var quote$5 = "Frases";
var list$5 = "Listas";
var image$5 = "Imaxes";
var gallery$5 = "Galerías";
var multimedia$5 = "Multimedia";
var interactive$5 = "Interactivos";
var buttons$5 = "Botóns";
var divider$5 = "Divisores";
var lemonade$4 = "Actividade";
var Paragraph$5 = "Parágrafo";
var Heading$5 = "Cabeceira";
var Subheading$5 = "Subcabeceira";
var Note$5 = "Nota";
var Carousel$5 = "Carrusel";
var Audio$5 = "Audio";
var Video$5 = "Vídeo";
var Embed$5 = "Embebido";
var Attachment$4 = "Arquivo adxunto";
var Accordion$5 = "Acordeón";
var Tabs$5 = "Pestanas";
var Process$5 = "Proceso";
var Button$6 = "Botón";
var Divider$5 = "Divisor";
var Spacer$4 = "Espazador";
var Classification$4 = "Clasificación";
var button_edit_post$4 = "Editar bloque";
var button_close_edit_post$4 = "Pechar edición";
var create_block_collection_menu_title$4 = "Biblioteca de bloques";
var empty_lemonade$4 = "Actividade: edita este bloque para escoller plantilla";
var empty_lemonade_feedback$4 = "Actividade UNOIntelligence: edita este bloque para elixir modelo";
var Edit$4 = "Editar";
var Text$5 = "Texto";
var List$4 = "Lista";
var Image$4 = "Imaxe";
var Graphic$4 = "Gráfico";
var Slider$4 = "Proceso";
var Gallery$4 = "Galería";
var Content$4 = "Contido";
var Settings$4 = "Opcións";
var Description$4 = "Descrición";
var Caption$4 = "Etiqueta";
var image_alt_text$4 = "Texto alternativo da imaxe";
var Unspecified$4 = "Sen especificar";
var Left$4 = "Esquerda";
var Center$4 = "Centrada";
var Right$4 = "Dereita";
var Step$4 = "Paso";
var Intro$4 = "Intro";
var Summary$4 = "Sumario";
var Index$4 = "Índice";
var Title$4 = "Título";
var Subtitle$4 = "Subtítulo";
var Column$4 = "Columna";
var help_step_number$4 = "Para indicar onde mostrar o número do paso usa [NUMBER] exemplo: 'Paso [NUMBER] exemplo'";
var Small$4 = "Pequeno";
var Medium$4 = "Mediano";
var Undo$4 = "Desfacer";
var Markers$4 = "Marcadores";
var labeledgraphic$4 = "Gráfico etiquetado";
var Change$4 = "Modificar";
var Border$4 = "Bordo";
var Loading$4 = "Cargando";
var Activity$4 = "Actividade";
var Visibility$4 = "Visible";
var Notes$4 = "Notas";
var embed_error_not_valid$4 = "Introduce unha URL válida (YouTube ou Vimeo) ou un iframe";
var embed_genially_error_not_valid$4 = "Introduce un iframe";
var Timeline$5 = "Liña do tempo";
var timeline_title_start$4 = "Título de inicio";
var timeline_title_end$4 = "Título do fin";
var tabs_audios_post_title$4 = "Audio {{number}}";
var tabs_audios_post_button_new$4 = "Novo";
var tabs_audios_post_button_delete$4 = "Borrar {{audio_title}}";
var tabs_audios_post_block_text$4 = "Bloque #{{number}} _ {{caption}}";
var tabs_audios_post_select_blocks_title$4 = "Seleccionar bloques";
var tabs_audios_post_select_head$4 = "Bloques";
var tabs_audios_post_select_help$4 = "Todos os bloques seleccionados deben ser consecutivos";
var tabs_audios_post_select_placeholder$4 = "Seleccionar bloque";
var tabs_audios_post_assigned_to$4 = "Asignado a";
var file_uploaded_successfully$4 = "Audio enviado correctamente";
var files_uploaded_successfully$4 = "Audios enviados correctamente";
var file_drop_audio_line1$4 = "Soltar o audio";
var file_drop_audio_line2$4 = "(ou fai clic aquí para seleccionar)";
var file_uploading_audio$4 = "Subindo audio {{number}}%";
var item_delete_audio_empty_blocks$4 = "O audio non está asociado a ningún bloque";
var label_pdf_pages_post$4 = "Páxinas";
var item_option_title_edit$4 = "Editar";
var item_option_title_up$4 = "Subir";
var item_option_title_down$4 = "Baixar";
var item_option_title_left$4 = "Mover a esquerda";
var item_option_title_right$4 = "Mover a dereita";
var item_option_title_duplicate$4 = "Duplicar";
var item_option_title_settings$4 = "Configuración académica";
var item_option_title_delete$4 = "Borrar";
var item_option_title_audios$4 = "Audios";
var option_item_block_settings$4 = "Opcións";
var option_item_block_change_type$4 = "Cambiar a";
var option_item_block_edit$4 = "Editar";
var option_item_block_move_up$4 = "Mover arriba";
var option_item_block_move_down$4 = "Mover abaixo";
var option_item_block_audio$4 = "Audio";
var option_item_block_duplicate$4 = "Duplicar";
var option_item_block_delete$4 = "Borrar";
var additional_content_item_title$3 = "Contido adicional";
var additional_content_header$3 = "Contido adicional # {{number}}";
var button_additional_content_add$3 = "Engadir contido adicional";
var warning_single_post_mode$3 = "Esta lección ten múltiples posts pero está configurada para mostrar un único post. Por favor, organiza e elimina os posts ata deixar só un.";
var warning_disable_background_gradient$3 = "O color de fondo é un degradado, pero a opción de degradado no está habilitada na configuración de mint.";
var clear_background$4 = "Borrar";
var image_caption$4 = "Pie de imaxe";
var video_caption$4 = "Pie de vídeo";
var audio_caption$4 = "Pie de audio";
var tooltip_placeholder$4 = "Escribe aquí...";
var tooltip_char_counter$4 = " / 240 caracteres";
var tooltip_add$4 = "Engadir";
var tooltip_update$4 = "Actualizar";
var tooltip_cancel$4 = "Cancelar";
var tooltip_edit$4 = "Editar";
var tooltip_remove$4 = "Eliminar";
var tooltip_add_or_edit$3 = "Engadir/Editar Tooltip";
var embed_button_add$4 = "Engadir";
var feedback_activity$4 = "Actividade UNOIntelligence";
var settings_evaluation_title$4 = "Avaliación";
var settings_count_for_note$4 = "A cualificación conta para a nota";
var settings_attempts_title$4 = "Intentos";
var intelligence_tag_title$4 = "Etiqueta para Intelligence";
var select$4 = "Seleccionar";
var exercise$4 = "Exercitación";
var verification$4 = "Comprobación";
var practice$4 = "Práctica";
var editorGL = {
	text: text$5,
	impact: impact$5,
	quote: quote$5,
	list: list$5,
	image: image$5,
	gallery: gallery$5,
	multimedia: multimedia$5,
	interactive: interactive$5,
	"interactive-fullscreen": "Interactivos pantalla completa",
	buttons: buttons$5,
	divider: divider$5,
	lemonade: lemonade$4,
	Paragraph: Paragraph$5,
	"Paragraph with Heading": "Parágrafo con cabeceira",
	"Paragraph with Subheading": "Parágrafo con subcabeceira",
	Heading: Heading$5,
	Subheading: Subheading$5,
	"Two column": "Dúas columnas",
	"Statement A": "Declaración A",
	"Statement B": "Declaración B",
	"Statement C": "Declaración C",
	"Statement D": "Declaración D",
	Note: Note$5,
	"Quote A": "Frase A",
	"Quote B": "Frase B",
	"Quote C": "Frase C",
	"Quote D": "Frase D",
	"Quote on image": "Frase en imaxe",
	"Quote carousel": "Carrusel de frases",
	"Numbered list": "Lista numerada",
	"Checkbox list": "Lista de verificación",
	"Bulleted list": "Lista con viñetas",
	"Image centered": "Imaxe centrada",
	"Image full width": "Imaxe pantalla completa",
	"Image & text": "Imaxe e texto",
	"Text on image": "Texto en imaxe",
	Carousel: Carousel$5,
	"Two column grid": "Dúas columnas",
	"Three column grid": "Tres columnas",
	"Four column grid": "Catro columnas",
	Audio: Audio$5,
	Video: Video$5,
	Embed: Embed$5,
	Attachment: Attachment$4,
	"Code snippet": "Fragmento de código",
	Accordion: Accordion$5,
	Tabs: Tabs$5,
	"Labeled Graphic": "Gráfico etiquetado",
	Process: Process$5,
	Button: Button$6,
	"Button stack": "Pía de botóns",
	Divider: Divider$5,
	Spacer: Spacer$4,
	"Lemonade content guid": "Lemonade content guid",
	"Multiple choice standard": "Test con resposta única",
	"Multiple choice multiple": "Test con resposta múltiple",
	"Multiple choice true / false": "Test con verdadeiro / falso",
	"Multiple choice block letter": "Test con resposta múltiple en bloque",
	"Choice matrix standard": "Táboa de selección",
	"Choice matrix inline": "Lista de selección",
	"Essay plain text": "Resposta aberta",
	"Essay short text": "Resposta curta",
	"Cloze with drag & drop": "Completar ocos con arrastrar e soltar",
	"Cloze with dropdown": "Completar ocos con despregable",
	"Cloze with text": "Completar ocos con texto",
	Classification: Classification$4,
	"Match list": "Emparellar",
	"Order list": "Ordenar lista",
	"Label image with text": "Completar imaxe con texto",
	button_edit_post: button_edit_post$4,
	button_close_edit_post: button_close_edit_post$4,
	create_block_collection_menu_title: create_block_collection_menu_title$4,
	empty_lemonade: empty_lemonade$4,
	empty_lemonade_feedback: empty_lemonade_feedback$4,
	"Type something": "Escribe algo",
	Edit: Edit$4,
	"All Blocks": "Todos",
	"Add your first itemblock": "Engade o teu primeiro bloque",
	Text: Text$5,
	List: List$4,
	Image: Image$4,
	Graphic: Graphic$4,
	Slider: Slider$4,
	Gallery: Gallery$4,
	Content: Content$4,
	Settings: Settings$4,
	Description: Description$4,
	Caption: Caption$4,
	image_alt_text: image_alt_text$4,
	"Image alignment": "Aliñación de imaxe",
	Unspecified: Unspecified$4,
	Left: Left$4,
	Center: Center$4,
	Right: Right$4,
	"Padding Top": "Marxe superior",
	"Padding Bottom": "Marxe inferior",
	"No padding": "Sen marxe",
	"Background Color": "Cor de fondo",
	"Select color": "Selecciona cor",
	"List item": "Elemento",
	"Add item": "Engadir elemento",
	"Add Image": "Engadir imaxe",
	"Add Step": "Engadir paso",
	Step: Step$4,
	Intro: Intro$4,
	Summary: Summary$4,
	Index: Index$4,
	Title: Title$4,
	Subtitle: Subtitle$4,
	Column: Column$4,
	help_step_number: help_step_number$4,
	Small: Small$4,
	Medium: Medium$4,
	"Full width": "Ancho completo",
	"Image width": "Anchura imaxe",
	"Removed block": "Bloque eliminado",
	Undo: Undo$4,
	"Teacher notes": "Notas do docente",
	Markers: Markers$4,
	"Marker style": "Estilo de marca",
	labeledgraphic: labeledgraphic$4,
	"Press Enter to add": "Preme Enter para engadir",
	Change: Change$4,
	"Show border": "Mostrar bordo",
	Border: Border$4,
	Loading: Loading$4,
	Activity: Activity$4,
	"Image position": "Posición da imaxe",
	"Image size": "Tamaño da imaxe",
	"Add an item block": "Engade un bloque de contido",
	Visibility: Visibility$4,
	"Teacher only": "Só para o docente",
	"Add your first block": "Añade o teu primer bloque",
	"Enter a title...": "Escribe un título...",
	"Upload video": "Cargar vídeo",
	"URL video": "URL vídeo",
	Notes: Notes$4,
	embed_error_not_valid: embed_error_not_valid$4,
	embed_genially_error_not_valid: embed_genially_error_not_valid$4,
	Timeline: Timeline$5,
	timeline_title_start: timeline_title_start$4,
	timeline_title_end: timeline_title_end$4,
	tabs_audios_post_title: tabs_audios_post_title$4,
	tabs_audios_post_button_new: tabs_audios_post_button_new$4,
	tabs_audios_post_button_delete: tabs_audios_post_button_delete$4,
	tabs_audios_post_block_text: tabs_audios_post_block_text$4,
	tabs_audios_post_select_blocks_title: tabs_audios_post_select_blocks_title$4,
	tabs_audios_post_select_head: tabs_audios_post_select_head$4,
	tabs_audios_post_select_help: tabs_audios_post_select_help$4,
	tabs_audios_post_select_placeholder: tabs_audios_post_select_placeholder$4,
	tabs_audios_post_assigned_to: tabs_audios_post_assigned_to$4,
	file_uploaded_successfully: file_uploaded_successfully$4,
	files_uploaded_successfully: files_uploaded_successfully$4,
	file_drop_audio_line1: file_drop_audio_line1$4,
	file_drop_audio_line2: file_drop_audio_line2$4,
	file_uploading_audio: file_uploading_audio$4,
	item_delete_audio_empty_blocks: item_delete_audio_empty_blocks$4,
	"Select all": "Seleccionar todo",
	"files supported": "Formatos soportados: {{format}}",
	label_pdf_pages_post: label_pdf_pages_post$4,
	item_option_title_edit: item_option_title_edit$4,
	item_option_title_up: item_option_title_up$4,
	item_option_title_down: item_option_title_down$4,
	item_option_title_left: item_option_title_left$4,
	item_option_title_right: item_option_title_right$4,
	item_option_title_duplicate: item_option_title_duplicate$4,
	item_option_title_settings: item_option_title_settings$4,
	item_option_title_delete: item_option_title_delete$4,
	item_option_title_audios: item_option_title_audios$4,
	option_item_block_settings: option_item_block_settings$4,
	option_item_block_change_type: option_item_block_change_type$4,
	option_item_block_edit: option_item_block_edit$4,
	option_item_block_move_up: option_item_block_move_up$4,
	option_item_block_move_down: option_item_block_move_down$4,
	option_item_block_audio: option_item_block_audio$4,
	option_item_block_duplicate: option_item_block_duplicate$4,
	option_item_block_delete: option_item_block_delete$4,
	additional_content_item_title: additional_content_item_title$3,
	additional_content_header: additional_content_header$3,
	button_additional_content_add: button_additional_content_add$3,
	warning_single_post_mode: warning_single_post_mode$3,
	warning_disable_background_gradient: warning_disable_background_gradient$3,
	clear_background: clear_background$4,
	image_caption: image_caption$4,
	video_caption: video_caption$4,
	audio_caption: audio_caption$4,
	tooltip_placeholder: tooltip_placeholder$4,
	tooltip_char_counter: tooltip_char_counter$4,
	tooltip_add: tooltip_add$4,
	tooltip_update: tooltip_update$4,
	tooltip_cancel: tooltip_cancel$4,
	tooltip_edit: tooltip_edit$4,
	tooltip_remove: tooltip_remove$4,
	tooltip_add_or_edit: tooltip_add_or_edit$3,
	embed_button_add: embed_button_add$4,
	feedback_activity: feedback_activity$4,
	settings_evaluation_title: settings_evaluation_title$4,
	settings_count_for_note: settings_count_for_note$4,
	settings_attempts_title: settings_attempts_title$4,
	intelligence_tag_title: intelligence_tag_title$4,
	select: select$4,
	exercise: exercise$4,
	verification: verification$4,
	practice: practice$4
};

var process_button_start$4 = "COMEZAR";
var process_button_start_again$4 = "EMPEZAR DE NOVO";
var process_refresh_show_pagination$4 = "Refresca a páxina para mostrar a paxinación nesta diapositiva";
var proccess_step_number$4 = "Paso {{number}}";
var teacher_notes$4 = "Notas do docente";
var media_audio_browser_not_support_part_1$4 = "O seu navegador non soporta audio HTML5. Aquí hai un";
var media_audio_browser_not_support_part_2_href$4 = "ligazón ao audio";
var media_audio_browser_not_support_part_3$4 = "no seu lugar.";
var media_video_browser_not_support_part_1$4 = "O seu navegador non soporta vídeo HTML5. Aquí hai un";
var media_video_browser_not_support_part_2_href$4 = "ligazón ao vídeo";
var media_video_browser_not_support_part_3$4 = "no seu lugar.";
var media_embed_view_on$4 = "Ver en";
var lms_waiting_correction$4 = "Agardando corrección…";
var send$4 = "Enviar";
var highlighter_highlight$4 = "Resaltar";
var highlighter_edit_color_highlight$4 = "Editar cor";
var highlighter_remove_highlight$4 = "Quitar resaltado";
var correct$4 = "Correcto";
var incorrect$4 = "Incorrecto";
var video_no_internet$4 = "Non se pode visualizar o vídeo. Por favor, comproba a túa conexión a Internet.";
var need_help$4 = "No lo entiendo";
var get_recomendation$4 = "Recomendación";
var undefined_activity$4 = "Atividade non definida.";
var proccess_step_label_number$4 = "{{label}} {{number}}";
var no_alt_tooltip$4 = "Non contén texto alternativo";
var button_show_hints$4 = "Pista";
var volume$4 = "Volume";
var speed$4 = "Velocidade";
var audio_transcription$4 = "Transcrição";
var current_text$4 = "Texto actual";
var visorGL = {
	process_button_start: process_button_start$4,
	process_button_start_again: process_button_start_again$4,
	process_refresh_show_pagination: process_refresh_show_pagination$4,
	proccess_step_number: proccess_step_number$4,
	teacher_notes: teacher_notes$4,
	media_audio_browser_not_support_part_1: media_audio_browser_not_support_part_1$4,
	media_audio_browser_not_support_part_2_href: media_audio_browser_not_support_part_2_href$4,
	media_audio_browser_not_support_part_3: media_audio_browser_not_support_part_3$4,
	media_video_browser_not_support_part_1: media_video_browser_not_support_part_1$4,
	media_video_browser_not_support_part_2_href: media_video_browser_not_support_part_2_href$4,
	media_video_browser_not_support_part_3: media_video_browser_not_support_part_3$4,
	media_embed_view_on: media_embed_view_on$4,
	lms_waiting_correction: lms_waiting_correction$4,
	send: send$4,
	highlighter_highlight: highlighter_highlight$4,
	highlighter_edit_color_highlight: highlighter_edit_color_highlight$4,
	highlighter_remove_highlight: highlighter_remove_highlight$4,
	correct: correct$4,
	incorrect: incorrect$4,
	video_no_internet: video_no_internet$4,
	need_help: need_help$4,
	get_recomendation: get_recomendation$4,
	undefined_activity: undefined_activity$4,
	proccess_step_label_number: proccess_step_label_number$4,
	no_alt_tooltip: no_alt_tooltip$4,
	button_show_hints: button_show_hints$4,
	volume: volume$4,
	speed: speed$4,
	audio_transcription: audio_transcription$4,
	current_text: current_text$4
};

var text$6 = "Text";
var impact$6 = "Destacats";
var quote$6 = "Frases";
var list$6 = "Llistes";
var image$6 = "Imatges";
var gallery$6 = "Galeries";
var multimedia$6 = "Multimèdia";
var interactive$6 = "Interactius";
var buttons$6 = "Botons";
var divider$6 = "Divisors";
var lemonade$5 = "Activitat";
var Paragraph$6 = "Paràgraf";
var Heading$6 = "Capçalera";
var Subheading$6 = "Subcapçalera";
var Note$6 = "Nota";
var Carousel$6 = "Carrusel";
var Audio$6 = "Àudio";
var Video$6 = "Vídeo";
var Embed$6 = "Incrustat";
var Attachment$5 = "Arxiu adjunt";
var Accordion$6 = "Acordió";
var Tabs$6 = "Pestanyes";
var Process$6 = "Procés";
var Button$7 = "Botó";
var Divider$6 = "Divisor";
var Spacer$5 = "Espaiador";
var Classification$5 = "Classificació";
var button_edit_post$5 = "Edita bloc";
var button_close_edit_post$5 = "Tanca edició";
var create_block_collection_menu_title$5 = "Biblioteca de blocs";
var empty_lemonade$5 = "Activitat: edita aquest bloc per triar plantilla";
var empty_lemonade_feedback$5 = "Activitat UNOIntelligence: edita aquest bloc per triar plantilla";
var Edit$5 = "Edita";
var Text$6 = "Text";
var List$5 = "Llista";
var Image$5 = "Imatge";
var Graphic$5 = "Gràfic";
var Slider$5 = "Procés";
var Gallery$5 = "Galeria";
var Content$5 = "Contingut";
var Settings$5 = "Opcions";
var Description$5 = "Descripció";
var Caption$5 = "Etiqueta";
var image_alt_text$5 = "Text alternatiu de la imatge";
var Unspecified$5 = "Sense especificar";
var Left$5 = "Esquerra";
var Center$5 = "Centrada";
var Right$5 = "Dreta";
var Step$5 = "Pas";
var Intro$5 = "Intro";
var Summary$5 = "Sumari";
var Index$5 = "Índex";
var Title$5 = "Títol";
var Subtitle$5 = "Subtítol";
var Column$5 = "Columna";
var help_step_number$5 = "Per a indicar on es mostra el nombre del pas usa [NUMBER] exemple: 'Pas [NUMBER] exemple'";
var Small$5 = "Xicotet";
var Medium$5 = "Mitjà";
var Undo$5 = "Desfes";
var Markers$5 = "Marcadors";
var labeledgraphic$5 = "Gràfic etiquetat";
var Change$5 = "Modifica";
var Border$5 = "Vora";
var Loading$5 = "Carregant";
var Activity$5 = "Activitat";
var Visibility$5 = "Visible";
var Notes$5 = "Notes";
var embed_error_not_valid$5 = "Introdueix una URL vàlida (YouTube o Vimeo) o un iframe";
var embed_genially_error_not_valid$5 = "Introdueix un iframe";
var Timeline$6 = "Línia de temps";
var timeline_title_start$5 = "Títol d'inici";
var timeline_title_end$5 = "Títol de fi";
var tabs_audios_post_title$5 = "Àudio {{number}}";
var tabs_audios_post_button_new$5 = "Nou";
var tabs_audios_post_button_delete$5 = "Esborrar {{audio_title}}";
var tabs_audios_post_block_text$5 = "Bloc #{{number}} _ {{caption}}";
var tabs_audios_post_select_blocks_title$5 = "Seleccionar blocs";
var tabs_audios_post_select_head$5 = "Blocs";
var tabs_audios_post_select_help$5 = "Tots els blocs seleccionats han de ser consecutius";
var tabs_audios_post_select_placeholder$5 = "Seleccionar bloc";
var tabs_audios_post_assigned_to$5 = "Assignat a";
var file_uploaded_successfully$5 = "Àudio enviat correctament";
var files_uploaded_successfully$5 = "Àudios enviats correctament";
var file_drop_audio_line1$5 = "Deixar l'àudio";
var file_drop_audio_line2$5 = "(o fes clic ací per a seleccionar)";
var file_uploading_audio$5 = "Pujant àudio {{number}}%";
var item_delete_audio_empty_blocks$5 = "L'àudio no està associat a cap bloc";
var label_pdf_pages_post$5 = "Pàgines";
var item_option_title_edit$5 = "Editar";
var item_option_title_up$5 = "Pujar";
var item_option_title_down$5 = "Baixar";
var item_option_title_left$5 = "Moure a l'esquerra";
var item_option_title_right$5 = "Moure a la dreta";
var item_option_title_duplicate$5 = "Duplicar";
var item_option_title_settings$5 = "Configuració acadèmica";
var item_option_title_delete$5 = "Esborrar";
var item_option_title_audios$5 = "Àudios";
var option_item_block_settings$5 = "Opcions";
var option_item_block_change_type$5 = "Canviar a";
var option_item_block_edit$5 = "Edita";
var option_item_block_move_up$5 = "Mou amunt";
var option_item_block_move_down$5 = "Mou avall";
var option_item_block_audio$5 = "Àudio";
var option_item_block_duplicate$5 = "Duplica";
var option_item_block_delete$5 = "Esborra";
var additional_content_item_title$4 = "Contingut addicional";
var additional_content_header$4 = "Contingut addicional # {{number}}";
var button_additional_content_add$4 = "Afegeix contingut addicional";
var warning_single_post_mode$4 = "Aquesta lliçó té múltiples posts però està configurada per mostrar un sol post. Si us plau, organitza i esborra els posts fins que només quedi un. Només es mostrarà el primer post.";
var warning_disable_background_gradient$4 = "El color de fons és un degradat, però l'opció de degradat no està habilitada en la configuració de mint.";
var clear_background$5 = "Esborra";
var image_caption$5 = "Pie de imatge";
var video_caption$5 = "Pie de vídeo";
var audio_caption$5 = "Pie d'àudio";
var tooltip_placeholder$5 = "Escriu ací...";
var tooltip_char_counter$5 = " / 240 caràcters";
var tooltip_add$5 = "Afig";
var tooltip_update$5 = "Actualitza";
var tooltip_cancel$5 = "Cancel·la";
var tooltip_edit$5 = "Edita";
var tooltip_remove$5 = "Elimina";
var tooltip_add_or_edit$4 = "Afegir/Editar Tooltip";
var embed_button_add$5 = "Afegir";
var feedback_activity$5 = "Activitat UNOIntelligence";
var settings_evaluation_title$5 = "Avaluació";
var settings_count_for_note$5 = "La qualificació compta per a la nota";
var settings_attempts_title$5 = "Intents";
var intelligence_tag_title$5 = "Etiqueta per a Intelligence";
var select$5 = "Seleccionar";
var exercise$5 = "Exercitació";
var verification$5 = "Comprovació";
var practice$5 = "Pràctica";
var editorVL = {
	text: text$6,
	impact: impact$6,
	quote: quote$6,
	list: list$6,
	image: image$6,
	gallery: gallery$6,
	multimedia: multimedia$6,
	interactive: interactive$6,
	"interactive-fullscreen": "Interactius pantalla completa",
	buttons: buttons$6,
	divider: divider$6,
	lemonade: lemonade$5,
	Paragraph: Paragraph$6,
	"Paragraph with Heading": "Paràgraf amb capçalera",
	"Paragraph with Subheading": "Paràgraf amb subcapçalera",
	Heading: Heading$6,
	Subheading: Subheading$6,
	"Two column": "Dues columnes",
	"Statement A": "Declaració A",
	"Statement B": "Declaració B",
	"Statement C": "Declaració C",
	"Statement D": "Declaració D",
	Note: Note$6,
	"Quote A": "Frase A",
	"Quote B": "Frase B",
	"Quote C": "Frase C",
	"Quote D": "Frase D",
	"Quote on image": "Frase en imatge",
	"Quote carousel": "Carrusel de frases",
	"Numbered list": "Llista numerada",
	"Checkbox list": "Llista de verificació",
	"Bulleted list": "Llista amb vinyetes",
	"Image centered": "Imatge centrada",
	"Image full width": "Imatge pantalla completa",
	"Image & text": "Imatge i text",
	"Text on image": "Text en imatge",
	Carousel: Carousel$6,
	"Two column grid": "Dues columnes",
	"Three column grid": "Tres columnes",
	"Four column grid": "Quatre columnes",
	Audio: Audio$6,
	Video: Video$6,
	Embed: Embed$6,
	Attachment: Attachment$5,
	"Code snippet": "Fragment de codi",
	Accordion: Accordion$6,
	Tabs: Tabs$6,
	"Labeled Graphic": "Gràfic etiquetat",
	Process: Process$6,
	Button: Button$7,
	"Button stack": "Pila de botons",
	Divider: Divider$6,
	Spacer: Spacer$5,
	"Lemonade content guid": "Lemonade content guid",
	"Multiple choice standard": "Test amb resposta única",
	"Multiple choice multiple": "Test amb resposta múltiple",
	"Multiple choice true / false": "Test amb vertader / fals",
	"Multiple choice block letter": "Test amb resposta múltiple en bloc",
	"Choice matrix standard": "Taula de selecció",
	"Choice matrix inline": "Llista de selecció",
	"Essay plain text": "Resposta oberta",
	"Essay short text": "Resposta curta",
	"Cloze with drag & drop": "Completa buits amb arrossegar i soltar",
	"Cloze with dropdown": "Completa buits amb desplegable",
	"Cloze with text": "Completa buits amb text",
	Classification: Classification$5,
	"Match list": "Emparella",
	"Order list": "Ordena llista",
	"Label image with text": "Completa imatge amb text",
	button_edit_post: button_edit_post$5,
	button_close_edit_post: button_close_edit_post$5,
	create_block_collection_menu_title: create_block_collection_menu_title$5,
	empty_lemonade: empty_lemonade$5,
	empty_lemonade_feedback: empty_lemonade_feedback$5,
	"Type something": "Escriu alguna cosa",
	Edit: Edit$5,
	"All Blocks": "Tots",
	"Add your first itemblock": "Afig el teu primer bloc",
	Text: Text$6,
	List: List$5,
	Image: Image$5,
	Graphic: Graphic$5,
	Slider: Slider$5,
	Gallery: Gallery$5,
	Content: Content$5,
	Settings: Settings$5,
	Description: Description$5,
	Caption: Caption$5,
	image_alt_text: image_alt_text$5,
	"Image alignment": "Alineació d’imatge",
	Unspecified: Unspecified$5,
	Left: Left$5,
	Center: Center$5,
	Right: Right$5,
	"Padding Top": "Marge superior",
	"Padding Bottom": "Marge inferior",
	"No padding": "Sense marge",
	"Background Color": "Color de fons",
	"Select color": "Selecciona color",
	"List item": "Element",
	"Add item": "Afig element",
	"Add Image": "Afig imatge",
	"Add Step": "Afig pas",
	Step: Step$5,
	Intro: Intro$5,
	Summary: Summary$5,
	Index: Index$5,
	Title: Title$5,
	Subtitle: Subtitle$5,
	Column: Column$5,
	help_step_number: help_step_number$5,
	Small: Small$5,
	Medium: Medium$5,
	"Full width": "Amplària completa",
	"Image width": "Amplària imatge",
	"Removed block": "Bloc eliminat",
	Undo: Undo$5,
	"Teacher notes": "Notes per al docent",
	Markers: Markers$5,
	"Marker style": "Estil de marca",
	labeledgraphic: labeledgraphic$5,
	"Press Enter to add": "Fes clic en Enter per a afegir",
	Change: Change$5,
	"Show border": "Mostra vora",
	Border: Border$5,
	Loading: Loading$5,
	Activity: Activity$5,
	"Image position": "Posició de la imatge",
	"Image size": "Grandària de la imatge",
	"Add an item block": "Afig un bloc de contingut",
	Visibility: Visibility$5,
	"Teacher only": "Només per al docent",
	"Add your first block": "Afegeix el primer bloc",
	"Enter a title...": "Escriu un títol...",
	"Upload video": "Pujar vídeo",
	"URL video": "URL vídeo",
	Notes: Notes$5,
	embed_error_not_valid: embed_error_not_valid$5,
	embed_genially_error_not_valid: embed_genially_error_not_valid$5,
	Timeline: Timeline$6,
	timeline_title_start: timeline_title_start$5,
	timeline_title_end: timeline_title_end$5,
	tabs_audios_post_title: tabs_audios_post_title$5,
	tabs_audios_post_button_new: tabs_audios_post_button_new$5,
	tabs_audios_post_button_delete: tabs_audios_post_button_delete$5,
	tabs_audios_post_block_text: tabs_audios_post_block_text$5,
	tabs_audios_post_select_blocks_title: tabs_audios_post_select_blocks_title$5,
	tabs_audios_post_select_head: tabs_audios_post_select_head$5,
	tabs_audios_post_select_help: tabs_audios_post_select_help$5,
	tabs_audios_post_select_placeholder: tabs_audios_post_select_placeholder$5,
	tabs_audios_post_assigned_to: tabs_audios_post_assigned_to$5,
	file_uploaded_successfully: file_uploaded_successfully$5,
	files_uploaded_successfully: files_uploaded_successfully$5,
	file_drop_audio_line1: file_drop_audio_line1$5,
	file_drop_audio_line2: file_drop_audio_line2$5,
	file_uploading_audio: file_uploading_audio$5,
	item_delete_audio_empty_blocks: item_delete_audio_empty_blocks$5,
	"Select all": "Seleccionar tot",
	"files supported": "Formats suportats: {{format}}",
	label_pdf_pages_post: label_pdf_pages_post$5,
	item_option_title_edit: item_option_title_edit$5,
	item_option_title_up: item_option_title_up$5,
	item_option_title_down: item_option_title_down$5,
	item_option_title_left: item_option_title_left$5,
	item_option_title_right: item_option_title_right$5,
	item_option_title_duplicate: item_option_title_duplicate$5,
	item_option_title_settings: item_option_title_settings$5,
	item_option_title_delete: item_option_title_delete$5,
	item_option_title_audios: item_option_title_audios$5,
	option_item_block_settings: option_item_block_settings$5,
	option_item_block_change_type: option_item_block_change_type$5,
	option_item_block_edit: option_item_block_edit$5,
	option_item_block_move_up: option_item_block_move_up$5,
	option_item_block_move_down: option_item_block_move_down$5,
	option_item_block_audio: option_item_block_audio$5,
	option_item_block_duplicate: option_item_block_duplicate$5,
	option_item_block_delete: option_item_block_delete$5,
	additional_content_item_title: additional_content_item_title$4,
	additional_content_header: additional_content_header$4,
	button_additional_content_add: button_additional_content_add$4,
	warning_single_post_mode: warning_single_post_mode$4,
	warning_disable_background_gradient: warning_disable_background_gradient$4,
	clear_background: clear_background$5,
	image_caption: image_caption$5,
	video_caption: video_caption$5,
	audio_caption: audio_caption$5,
	tooltip_placeholder: tooltip_placeholder$5,
	tooltip_char_counter: tooltip_char_counter$5,
	tooltip_add: tooltip_add$5,
	tooltip_update: tooltip_update$5,
	tooltip_cancel: tooltip_cancel$5,
	tooltip_edit: tooltip_edit$5,
	tooltip_remove: tooltip_remove$5,
	tooltip_add_or_edit: tooltip_add_or_edit$4,
	embed_button_add: embed_button_add$5,
	feedback_activity: feedback_activity$5,
	settings_evaluation_title: settings_evaluation_title$5,
	settings_count_for_note: settings_count_for_note$5,
	settings_attempts_title: settings_attempts_title$5,
	intelligence_tag_title: intelligence_tag_title$5,
	select: select$5,
	exercise: exercise$5,
	verification: verification$5,
	practice: practice$5
};

var process_button_start$5 = "COMENÇA";
var process_button_start_again$5 = "COMENÇA DE NOU";
var process_refresh_show_pagination$5 = "Refresca la pàgina per a mostrar la paginació en aquesta diapositiva";
var proccess_step_number$5 = "Pas {{number}}";
var teacher_notes$5 = "Notes per al docent";
var media_audio_browser_not_support_part_1$5 = "El vostre navegador no suporta àudio HTML5. Ací n’hi ha un";
var media_audio_browser_not_support_part_2_href$5 = "enllaç a l’àudio";
var media_audio_browser_not_support_part_3$5 = "en el seu lloc.";
var media_video_browser_not_support_part_1$5 = "El vostre navegador no suporta vídeo HTML5. Ací n’hi ha un";
var media_video_browser_not_support_part_2_href$5 = "enllaç al vídeo";
var media_video_browser_not_support_part_3$5 = "en el seu lloc.";
var media_embed_view_on$5 = "Vegeu en";
var lms_waiting_correction$5 = "Esperant correcció…";
var send$5 = "Envia";
var highlighter_highlight$5 = "Ressaltar";
var highlighter_edit_color_highlight$5 = "Editar color";
var highlighter_remove_highlight$5 = "Llevar ressaltat";
var correct$5 = "Correcte";
var incorrect$5 = "Incorrecte";
var video_no_internet$5 = "No es pot visionar el vídeo. Per favor, comprova la teua connexió a Internet.";
var need_help$5 = "No lo entiendo";
var get_recomendation$5 = "Recomendación";
var undefined_activity$5 = "Activitat no definida.";
var proccess_step_label_number$5 = "{{label}} {{number}}";
var no_alt_tooltip$5 = "No conté text alternatiu";
var button_show_hints$5 = "Pista";
var volume$5 = "Volum";
var speed$5 = "Velocitat";
var audio_transcription$5 = "Transcripció";
var current_text$5 = "Text actual";
var visorVL = {
	process_button_start: process_button_start$5,
	process_button_start_again: process_button_start_again$5,
	process_refresh_show_pagination: process_refresh_show_pagination$5,
	proccess_step_number: proccess_step_number$5,
	teacher_notes: teacher_notes$5,
	media_audio_browser_not_support_part_1: media_audio_browser_not_support_part_1$5,
	media_audio_browser_not_support_part_2_href: media_audio_browser_not_support_part_2_href$5,
	media_audio_browser_not_support_part_3: media_audio_browser_not_support_part_3$5,
	media_video_browser_not_support_part_1: media_video_browser_not_support_part_1$5,
	media_video_browser_not_support_part_2_href: media_video_browser_not_support_part_2_href$5,
	media_video_browser_not_support_part_3: media_video_browser_not_support_part_3$5,
	media_embed_view_on: media_embed_view_on$5,
	lms_waiting_correction: lms_waiting_correction$5,
	send: send$5,
	highlighter_highlight: highlighter_highlight$5,
	highlighter_edit_color_highlight: highlighter_edit_color_highlight$5,
	highlighter_remove_highlight: highlighter_remove_highlight$5,
	correct: correct$5,
	incorrect: incorrect$5,
	video_no_internet: video_no_internet$5,
	need_help: need_help$5,
	get_recomendation: get_recomendation$5,
	undefined_activity: undefined_activity$5,
	proccess_step_label_number: proccess_step_label_number$5,
	no_alt_tooltip: no_alt_tooltip$5,
	button_show_hints: button_show_hints$5,
	volume: volume$5,
	speed: speed$5,
	audio_transcription: audio_transcription$5,
	current_text: current_text$5
};

var text$7 = "Texto";
var impact$7 = "Notas";
var quote$7 = "Citações";
var list$7 = "Listas";
var image$7 = "Imagens";
var gallery$7 = "Galerias";
var multimedia$7 = "Multimídia";
var interactive$7 = "Interativos";
var buttons$7 = "Botões";
var divider$7 = "Divisores";
var lemonade$6 = "Atividade";
var Paragraph$7 = "Parágrafo";
var Heading$7 = "Título";
var Subheading$7 = "Subtítulo";
var Note$7 = "Nota";
var Carousel$7 = "Carrossel";
var Audio$7 = "Áudio";
var Video$7 = "Vídeo";
var Embed$7 = "Incorporar";
var Attachment$6 = "Anexo";
var Accordion$7 = "Acordeão";
var Tabs$7 = "Abas";
var Process$7 = "Processo";
var Button$8 = "Botão";
var Divider$7 = "Divisor";
var Spacer$6 = "Espaçador";
var Classification$6 = "Classificação";
var button_edit_post$6 = "Editar Bloco";
var button_close_edit_post$6 = "Fechar Edição";
var create_block_collection_menu_title$6 = "Biblioteca de Blocos";
var empty_lemonade$6 = "Atividade: edite este bloco para escolher modelo";
var empty_lemonade_feedback$6 = "Atividade UNOIntelligence: edite este bloco para escolher modelo";
var Edit$6 = "Editar";
var Text$7 = "Texto";
var List$6 = "Lista";
var Image$6 = "Imagem";
var Graphic$6 = "Gráfico";
var Slider$6 = "Controle Deslizante";
var Gallery$6 = "Galeria";
var Content$6 = "Conteúdo";
var Settings$6 = "Configurações";
var Description$6 = "Descrição";
var Caption$6 = "Legenda";
var image_alt_text$6 = "Texto alternativo da imagem";
var Unspecified$6 = "Não Especificado";
var Left$6 = "Esquerda";
var Center$6 = "Centro";
var Right$6 = "Direita";
var Step$6 = "Etapa";
var Intro$6 = "Introdução";
var Summary$6 = "Resumo";
var Index$6 = "Índice";
var Title$6 = "Título";
var Subtitle$6 = "Subtítulo";
var Column$6 = "Coluna";
var help_step_number$6 = "Para indicar onde mostrar o número da etapa, use [NUMBER], exemplo: 'Etapa [NUMBER] exemplo'";
var Small$6 = "Pequeno";
var Medium$6 = "Médio";
var Undo$6 = "Desfazer";
var Markers$6 = "Marcadores";
var labeledgraphic$6 = "Gráfico Rotulado";
var Change$6 = "Alterar";
var Border$6 = "Borda";
var Loading$6 = "Carregando";
var Activity$6 = "Atividade";
var Visibility$6 = "Visibilidade";
var Notes$6 = "Notas";
var embed_error_not_valid$6 = "Insira uma URL válida (YouTube ou Vimeo) ou iframe";
var embed_genially_error_not_valid$6 = "Insira um iframe";
var Timeline$7 = "Linha do Tempo";
var timeline_title_start$6 = "Título de Início";
var timeline_title_end$6 = "Título de Fim";
var tabs_audios_post_title$6 = "Áudio {{number}}";
var tabs_audios_post_button_new$6 = "Novo";
var tabs_audios_post_button_delete$6 = "Excluir {{audio_title}}";
var tabs_audios_post_block_text$6 = "Bloco #{{number}} _ {{caption}}";
var tabs_audios_post_select_blocks_title$6 = "Selecionar Blocos";
var tabs_audios_post_select_head$6 = "Blocos";
var tabs_audios_post_select_help$6 = "Todos os blocos selecionados devem ser consecutivos";
var tabs_audios_post_select_placeholder$6 = "Selecionar Bloco";
var tabs_audios_post_assigned_to$6 = "Atribuído a";
var file_uploaded_successfully$6 = "Áudio enviado com sucesso";
var files_uploaded_successfully$6 = "Áudios enviados com sucesso";
var file_drop_audio_line1$6 = "Solte o áudio";
var file_drop_audio_line2$6 = "(ou clique aqui para selecionar)";
var file_uploading_audio$6 = "Enviando áudio {{number}}%";
var item_delete_audio_empty_blocks$6 = "O áudio não está associado a nenhum bloco";
var label_pdf_pages_post$6 = "Páginas";
var item_option_title_edit$6 = "Editar";
var item_option_title_up$6 = "Subir";
var item_option_title_down$6 = "Baixar";
var item_option_title_left$6 = "Mover para a esquerda";
var item_option_title_right$6 = "Mover para a direita";
var item_option_title_duplicate$6 = "Duplicar";
var item_option_title_settings$6 = "Configuração acadêmica";
var item_option_title_delete$6 = "Excluir";
var item_option_title_audios$6 = "Áudios";
var option_item_block_settings$6 = "Opções";
var option_item_block_change_type$6 = "Mudar para";
var option_item_block_edit$6 = "Editar";
var option_item_block_move_up$6 = "Mover para cima";
var option_item_block_move_down$6 = "Mover para baixo";
var option_item_block_audio$6 = "Áudio";
var option_item_block_duplicate$6 = "Duplicar";
var option_item_block_delete$6 = "Deletar";
var additional_content_item_title$5 = "Conteúdo adicional";
var additional_content_header$5 = "Conteúdo adicional # {{number}}";
var button_additional_content_add$5 = "Adicionar conteúdo adicional";
var warning_single_post_mode$5 = "Esta lección tem múltiplos posts, mas está configurada para mostrar um único post. Por favor, organiza e elimina os posts até ficar só com um. Só o primeiro post será mostrado no visor.";
var item_option_title_edit_type_compatible$2 = "Substituir por bloco compatível";
var delete_layout_confirmation_title$2 = "Excluir conteúdo";
var delete_layout_confirmation_message$2 = "Se você excluir o bloco central, perderá todo o conteúdo editado.\nDeseja continuar?";
var delete_layout_confirmation_button$2 = "Excluir";
var Cancel$2 = "Cancelar";
var popup_editor_content_header$2 = "Cabeçalho";
var popup_editor_content_text$2 = "Corpo do texto";
var popup_editor_content_type_block$2 = "Conteúdo multimídia";
var warning_disable_background_gradient$5 = "A cor de fundo é um degradado, mas a opção de degradado não está habilitada na configuração de mint.";
var clear_background$6 = "Limpar";
var image_caption$6 = "Legenda da imagem";
var video_caption$6 = "Legenda do vídeo";
var audio_caption$6 = "Legenda do áudio";
var tooltip_placeholder$6 = "Escreva aqui...";
var tooltip_char_counter$6 = " / 240 caracteres";
var tooltip_add$6 = "Adicionar";
var tooltip_update$6 = "Atualizar";
var tooltip_cancel$6 = "Cancelar";
var tooltip_edit$6 = "Editar";
var tooltip_remove$6 = "Remover";
var tooltip_add_or_edit$5 = "Adicionar/Editar Tooltip";
var embed_button_add$6 = "Adicionar";
var feedback_activity$6 = "Atividade UNOIntelligence";
var settings_evaluation_title$6 = "Avaliação";
var settings_count_for_note$6 = "A classificação conta para a nota";
var settings_attempts_title$6 = "Tentativas";
var intelligence_tag_title$6 = "Etiqueta para Intelligence";
var select$6 = "Selecionar";
var exercise$6 = "Exercitação";
var verification$6 = "Comprovação";
var practice$6 = "Prática";
var editorPT = {
	text: text$7,
	impact: impact$7,
	quote: quote$7,
	list: list$7,
	image: image$7,
	gallery: gallery$7,
	multimedia: multimedia$7,
	interactive: interactive$7,
	"interactive-fullscreen": "Interativos em tela cheia",
	buttons: buttons$7,
	divider: divider$7,
	lemonade: lemonade$6,
	Paragraph: Paragraph$7,
	"Paragraph with Heading": "Parágrafo com Título",
	"Paragraph with Subheading": "Parágrafo com Subtítulo",
	Heading: Heading$7,
	Subheading: Subheading$7,
	"Two column": "Duas colunas",
	"Statement A": "Declaração A",
	"Statement B": "Declaração B",
	"Statement C": "Declaração C",
	"Statement D": "Declaração D",
	Note: Note$7,
	"Quote A": "Citação A",
	"Quote B": "Citação B",
	"Quote C": "Citação C",
	"Quote D": "Citação D",
	"Quote on image": "Citação na Imagem",
	"Quote carousel": "Carrossel de Citações",
	"Numbered list": "Lista Numerada",
	"Checkbox list": "Lista de Verificação",
	"Bulleted list": "Lista com Marcadores",
	"Image centered": "Imagem Centralizada",
	"Image full width": "Imagem em Tela Cheia",
	"Image & text": "Imagem e Texto",
	"Text on image": "Texto na Imagem",
	Carousel: Carousel$7,
	"Two column grid": "Grade de Duas Colunas",
	"Three column grid": "Grade de Três Colunas",
	"Four column grid": "Grade de Quatro Colunas",
	Audio: Audio$7,
	Video: Video$7,
	Embed: Embed$7,
	Attachment: Attachment$6,
	"Code snippet": "Trecho de Código",
	Accordion: Accordion$7,
	Tabs: Tabs$7,
	"Labeled Graphic": "Gráfico Rotulado",
	Process: Process$7,
	Button: Button$8,
	"Button stack": "Pilha de Botões",
	Divider: Divider$7,
	Spacer: Spacer$6,
	"Lemonade content guid": "Lemonade Conteúdo Guia",
	"Multiple choice standard": "Múltipla Escolha Padrão",
	"Multiple choice multiple": "Múltipla Escolha Múltipla",
	"Multiple choice true / false": "Múltipla Escolha Verdadeiro/Falso",
	"Multiple choice block letter": "Múltipla Escolha Bloco de Letras",
	"Choice matrix standard": "Matriz de Escolha Padrão",
	"Choice matrix inline": "Matriz de Escolha Inline",
	"Essay plain text": "Ensaio de Texto Simples",
	"Essay short text": "Ensaio de Texto Curto",
	"Cloze with drag & drop": "Preencher Lacunas com Arrastar e Soltar",
	"Cloze with dropdown": "Preencher Lacunas com Menu Suspenso",
	"Cloze with text": "Preencher Lacunas com Texto",
	Classification: Classification$6,
	"Match list": "Corresponder Lista",
	"Order list": "Ordenar Lista",
	"Label image with text": "Rotular Imagem com Texto",
	button_edit_post: button_edit_post$6,
	button_close_edit_post: button_close_edit_post$6,
	create_block_collection_menu_title: create_block_collection_menu_title$6,
	empty_lemonade: empty_lemonade$6,
	empty_lemonade_feedback: empty_lemonade_feedback$6,
	"Type something": "Digite algo",
	Edit: Edit$6,
	"All Blocks": "Todos os Blocos",
	"Add your first itemblock": "Adicione seu primeiro bloco de item",
	Text: Text$7,
	List: List$6,
	Image: Image$6,
	Graphic: Graphic$6,
	Slider: Slider$6,
	Gallery: Gallery$6,
	Content: Content$6,
	Settings: Settings$6,
	Description: Description$6,
	Caption: Caption$6,
	image_alt_text: image_alt_text$6,
	"Image alignment": "Alinhamento da Imagem",
	Unspecified: Unspecified$6,
	Left: Left$6,
	Center: Center$6,
	Right: Right$6,
	"Padding Top": "Preenchimento Superior",
	"Padding Bottom": "Preenchimento Inferior",
	"No padding": "Sem Preenchimento",
	"Background Color": "Cor de Fundo",
	"Select color": "Selecionar Cor",
	"List item": "Item da Lista",
	"Add item": "Adicionar Item",
	"Add Image": "Adicionar Imagem",
	"Add Step": "Adicionar Etapa",
	Step: Step$6,
	Intro: Intro$6,
	Summary: Summary$6,
	Index: Index$6,
	Title: Title$6,
	Subtitle: Subtitle$6,
	Column: Column$6,
	help_step_number: help_step_number$6,
	Small: Small$6,
	Medium: Medium$6,
	"Full width": "Largura Total",
	"Image width": "Largura da Imagem",
	"Removed block": "Bloco Removido",
	Undo: Undo$6,
	"Teacher notes": "Notas do Professor",
	Markers: Markers$6,
	"Marker style": "Estilo do Marcador",
	labeledgraphic: labeledgraphic$6,
	"Press Enter to add": "Pressione Enter para adicionar",
	Change: Change$6,
	"Show border": "Mostrar Borda",
	Border: Border$6,
	Loading: Loading$6,
	Activity: Activity$6,
	"Image position": "Posição da Imagem",
	"Image size": "Tamanho da Imagem",
	"Add an item block": "Adicionar um Bloco de Item",
	Visibility: Visibility$6,
	"Teacher only": "Somente para o Professor",
	"Add your first block": "Adicione seu primeiro bloco",
	"Enter a title...": "Digite um Título...",
	"Upload video": "Enviar Vídeo",
	"URL video": "URL vídeo",
	Notes: Notes$6,
	embed_error_not_valid: embed_error_not_valid$6,
	embed_genially_error_not_valid: embed_genially_error_not_valid$6,
	Timeline: Timeline$7,
	timeline_title_start: timeline_title_start$6,
	timeline_title_end: timeline_title_end$6,
	tabs_audios_post_title: tabs_audios_post_title$6,
	tabs_audios_post_button_new: tabs_audios_post_button_new$6,
	tabs_audios_post_button_delete: tabs_audios_post_button_delete$6,
	tabs_audios_post_block_text: tabs_audios_post_block_text$6,
	tabs_audios_post_select_blocks_title: tabs_audios_post_select_blocks_title$6,
	tabs_audios_post_select_head: tabs_audios_post_select_head$6,
	tabs_audios_post_select_help: tabs_audios_post_select_help$6,
	tabs_audios_post_select_placeholder: tabs_audios_post_select_placeholder$6,
	tabs_audios_post_assigned_to: tabs_audios_post_assigned_to$6,
	file_uploaded_successfully: file_uploaded_successfully$6,
	files_uploaded_successfully: files_uploaded_successfully$6,
	file_drop_audio_line1: file_drop_audio_line1$6,
	file_drop_audio_line2: file_drop_audio_line2$6,
	file_uploading_audio: file_uploading_audio$6,
	item_delete_audio_empty_blocks: item_delete_audio_empty_blocks$6,
	"Select all": "Selecionar Tudo",
	"files supported": "Formatos suportados: {{format}}",
	label_pdf_pages_post: label_pdf_pages_post$6,
	item_option_title_edit: item_option_title_edit$6,
	item_option_title_up: item_option_title_up$6,
	item_option_title_down: item_option_title_down$6,
	item_option_title_left: item_option_title_left$6,
	item_option_title_right: item_option_title_right$6,
	item_option_title_duplicate: item_option_title_duplicate$6,
	item_option_title_settings: item_option_title_settings$6,
	item_option_title_delete: item_option_title_delete$6,
	item_option_title_audios: item_option_title_audios$6,
	option_item_block_settings: option_item_block_settings$6,
	option_item_block_change_type: option_item_block_change_type$6,
	option_item_block_edit: option_item_block_edit$6,
	option_item_block_move_up: option_item_block_move_up$6,
	option_item_block_move_down: option_item_block_move_down$6,
	option_item_block_audio: option_item_block_audio$6,
	option_item_block_duplicate: option_item_block_duplicate$6,
	option_item_block_delete: option_item_block_delete$6,
	additional_content_item_title: additional_content_item_title$5,
	additional_content_header: additional_content_header$5,
	button_additional_content_add: button_additional_content_add$5,
	warning_single_post_mode: warning_single_post_mode$5,
	item_option_title_edit_type_compatible: item_option_title_edit_type_compatible$2,
	delete_layout_confirmation_title: delete_layout_confirmation_title$2,
	delete_layout_confirmation_message: delete_layout_confirmation_message$2,
	delete_layout_confirmation_button: delete_layout_confirmation_button$2,
	Cancel: Cancel$2,
	popup_editor_content_header: popup_editor_content_header$2,
	popup_editor_content_text: popup_editor_content_text$2,
	popup_editor_content_type_block: popup_editor_content_type_block$2,
	warning_disable_background_gradient: warning_disable_background_gradient$5,
	clear_background: clear_background$6,
	image_caption: image_caption$6,
	video_caption: video_caption$6,
	audio_caption: audio_caption$6,
	tooltip_placeholder: tooltip_placeholder$6,
	tooltip_char_counter: tooltip_char_counter$6,
	tooltip_add: tooltip_add$6,
	tooltip_update: tooltip_update$6,
	tooltip_cancel: tooltip_cancel$6,
	tooltip_edit: tooltip_edit$6,
	tooltip_remove: tooltip_remove$6,
	tooltip_add_or_edit: tooltip_add_or_edit$5,
	embed_button_add: embed_button_add$6,
	feedback_activity: feedback_activity$6,
	settings_evaluation_title: settings_evaluation_title$6,
	settings_count_for_note: settings_count_for_note$6,
	settings_attempts_title: settings_attempts_title$6,
	intelligence_tag_title: intelligence_tag_title$6,
	select: select$6,
	exercise: exercise$6,
	verification: verification$6,
	practice: practice$6
};

var process_button_start$6 = "INICIAR";
var process_button_start_again$6 = "INICIAR NOVAMENTE";
var process_refresh_show_pagination$6 = "Atualize a página para mostrar a paginação nesta slide";
var proccess_step_number$6 = "Passo {{number}}";
var teacher_notes$6 = "Orientações para o professor";
var media_audio_browser_not_support_part_1$6 = "Seu navegador não suporta áudio HTML5. Aqui está um";
var media_audio_browser_not_support_part_2_href$6 = "link para o áudio";
var media_audio_browser_not_support_part_3$6 = "em vez disso.";
var media_video_browser_not_support_part_1$6 = "Seu navegador não suporta vídeo HTML5. Aqui está um";
var media_video_browser_not_support_part_2_href$6 = "link para o vídeo";
var media_video_browser_not_support_part_3$6 = "em vez disso.";
var media_embed_view_on$6 = "Ver em";
var lms_waiting_correction$6 = "Aguardando correção...";
var send$6 = "Enviar";
var highlighter_highlight$6 = "Destacar";
var highlighter_edit_color_highlight$6 = "Editar cor";
var highlighter_remove_highlight$6 = "Remover destaque";
var correct$6 = "Correto";
var incorrect$6 = "Incorreto";
var video_no_internet$6 = "Não é possível visualizar o vídeo. Por favor, verifique sua conexão com a internet.";
var need_help$6 = "Não entendi";
var get_recomendation$6 = "Recomendação";
var offline_response_exercise_need_internet$2 = "Para que suas respostas nas atividades sejam salvas, você precisa acessar a versão online do livro";
var offline_highlight_need_internet$2 = "Ops! Parece que a conexão foi perdida. Para que seu trabalho no livro seja salvo, você precisa de uma conexão com a internet.";
var lesson_link_home$2 = "Início";
var offline_response_exercise_need_internet_type_activity$2 = "Você precisa de uma conexão à internet estável para fazer esse tipo de atividade";
var undefined_activity$6 = "Atividade não definida.";
var start$2 = "Começar";
var proccess_step_label_number$6 = "{{label}} {{number}}";
var main_page_progress_text$2 = "{{number}}% concluído";
var no_alt_tooltip$6 = "Não contém texto alternativo";
var button_show_hints$6 = "Dica";
var volume$6 = "Volume";
var speed$6 = "Velocidade";
var audio_transcription$6 = "Transcrição";
var current_text$6 = "Texto atual";
var visorPT = {
	process_button_start: process_button_start$6,
	process_button_start_again: process_button_start_again$6,
	process_refresh_show_pagination: process_refresh_show_pagination$6,
	proccess_step_number: proccess_step_number$6,
	teacher_notes: teacher_notes$6,
	media_audio_browser_not_support_part_1: media_audio_browser_not_support_part_1$6,
	media_audio_browser_not_support_part_2_href: media_audio_browser_not_support_part_2_href$6,
	media_audio_browser_not_support_part_3: media_audio_browser_not_support_part_3$6,
	media_video_browser_not_support_part_1: media_video_browser_not_support_part_1$6,
	media_video_browser_not_support_part_2_href: media_video_browser_not_support_part_2_href$6,
	media_video_browser_not_support_part_3: media_video_browser_not_support_part_3$6,
	media_embed_view_on: media_embed_view_on$6,
	lms_waiting_correction: lms_waiting_correction$6,
	send: send$6,
	highlighter_highlight: highlighter_highlight$6,
	highlighter_edit_color_highlight: highlighter_edit_color_highlight$6,
	highlighter_remove_highlight: highlighter_remove_highlight$6,
	correct: correct$6,
	incorrect: incorrect$6,
	video_no_internet: video_no_internet$6,
	need_help: need_help$6,
	get_recomendation: get_recomendation$6,
	offline_response_exercise_need_internet: offline_response_exercise_need_internet$2,
	offline_highlight_need_internet: offline_highlight_need_internet$2,
	lesson_link_home: lesson_link_home$2,
	offline_response_exercise_need_internet_type_activity: offline_response_exercise_need_internet_type_activity$2,
	undefined_activity: undefined_activity$6,
	start: start$2,
	proccess_step_label_number: proccess_step_label_number$6,
	main_page_progress_text: main_page_progress_text$2,
	no_alt_tooltip: no_alt_tooltip$6,
	button_show_hints: button_show_hints$6,
	volume: volume$6,
	speed: speed$6,
	audio_transcription: audio_transcription$6,
	current_text: current_text$6
};

var i18nMint = /*#__PURE__*/i18next.createInstance();
i18nMint.use(LanguageDetector)
// .use(XHR)
.use(initReactI18next) // passes i18n down to react-i18next
.init({
  fallbackLng: 'es',
  resources: {
    en: {
      visor: visorEn,
      editor: editorEn
    },
    es: {
      visor: visorEs,
      editor: editorEs
    },
    ca: {
      visor: visorCA,
      editor: editorCA
    },
    gl: {
      visor: visorGL,
      editor: editorGL
    },
    eu: {
      visor: visorEU,
      editor: editorEU
    },
    vl: {
      visor: visorVL,
      editor: editorVL
    },
    pt: {
      visor: visorPT,
      editor: editorPT
    }
  },
  // Set default namespace
  // defaultNS: 'common',
  keySeparator: false,
  // we do not use keys in form messages.welcome

  interpolation: {
    escapeValue: false // react already safes from xss
  }
});

var PostTeacherNotes = function PostTeacherNotes(_ref) {
  var note = _ref.note,
    onChangeNote = _ref.onChangeNote,
    getTextHtml = _ref.getTextHtml,
    modeTextHtml = _ref.modeTextHtml;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-teacher-notes'
  }, /*#__PURE__*/React__default.createElement(NoteView, {
    id: 'mint-note-view',
    text: note,
    getTextHtml: getTextHtml,
    textUpdated: onChangeNote,
    modeTextHtml: modeTextHtml,
    isTeacherNote: true,
    title: t('teacher_notes')
  }));
};

var actionTypes = {
  // VISOR
  SEE_TEACHER_NOTES_VISOR: 'SEE_TEACHER_NOTES_VISOR',
  // == Puedes ver las notas del profesor
  SEE_ASSISTANT_VISOR: 'SEE_ASSISTANT_VISOR',
  // == ver los resultados de las actividades de los alumnos cuando esta en el visor
  // EDITOR
  SEE_TEACHER_NOTES_EDITOR: 'SEE_TEACHER_NOTES_EDITOR',
  // == Puedes ver las notas del profesor cuando estoy en el Editor
  SEE_ASSISTANT_EDITOR: 'SEE_ASSISTANT_EDITOR',
  // == Ver el editor del asistente
  SEE_POST_OPTIONS: 'SEE_POST_OPTIONS ' // == Puede ver las opciones a nivel de post, duplicar, mover, borrar
};

var _permissions;
var permissions = (_permissions = {}, _permissions[actionTypes.SEE_TEACHER_NOTES_VISOR] = [roleTypes.TEACHER, roleTypes.EDITORIAL], _permissions[actionTypes.SEE_ASSISTANT_VISOR] = [roleTypes.EDITORIAL], _permissions[actionTypes.SEE_TEACHER_NOTES_EDITOR] = [roleTypes.TEACHER, roleTypes.EDITORIAL], _permissions[actionTypes.SEE_ASSISTANT_EDITOR] = [roleTypes.EDITORIAL], _permissions[actionTypes.SEE_POST_OPTIONS] = [roleTypes.EDITORIAL], _permissions);

/**
 * Devuelve si un el role puede realizar la accion
 * Ejemplo: canAction(actionTypes.EDIT_ALL_DLO, roleTypes.ADMIN)
 * @param {string} action
 * @param {string} role
 */
var canAction = function canAction(action, role) {
  var usersCanAction = permissions[action] ? permissions[action] : [];
  return usersCanAction.includes(role);
};

function canSeeTeacherNotesVisor(userRoleGuid) {
  var canSee = false;
  if (userRoleGuid) {
    if (canAction(actionTypes.SEE_TEACHER_NOTES_VISOR, userRoleGuid)) {
      canSee = true;
    }
  }
  return canSee;
}
function canSeeAssistantVisor(userRoleGuid) {
  var canSee = false;
  if (userRoleGuid) {
    if (canAction(actionTypes.SEE_ASSISTANT_VISOR, userRoleGuid)) {
      canSee = true;
    }
  }
  return canSee;
}

function usePlusV1(props) {
  var role = props.role,
    getAssistantVisorLesson = props.getAssistantVisorLesson,
    config = props.config;
  function getTextHtml(text) {
    return /*#__PURE__*/React__default.createElement(TextHtmlVisor, {
      text: text
    });
  }
  function getComponentBelowItemsPostLesson(lesson, post, onChangePost, isModePostEditor, isVisible) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, canSeeTeacherNotesVisor(role) && post.teacher_notes && /*#__PURE__*/React__default.createElement(PostTeacherNotes, {
      note: post.teacher_notes,
      onChangeNote: function onChangeNote() {},
      getTextHtml: getTextHtml,
      modeTextHtml: isModePostEditor ? IModesTextHtml.MODE_TEXT_HTML_EDITOR : IModesTextHtml.MODE_TEXT_HTML_VISOR
    }), canSeeAssistantVisor(role) && post.assistent && getAssistantVisorLesson && getAssistantVisorLesson(lesson, post, isVisible));
  }
  return {
    getComponentBelowItemsPostLesson: getComponentBelowItemsPostLesson,
    configSelectionCoords: config.selectionCoords,
    configHighlights: config.highlights,
    configItemsHasBeenSeen: config.itemsHasBeenSeen
  };
}

function createLinkTags(_ref) {
  var src = _ref.src;
  return new Promise(function (resolve, reject) {
    var lnk = document.createElement('link');
    lnk.href = src;
    lnk.rel = 'stylesheet';
    lnk.type = 'text/css';
    (document.head || document.documentElement).appendChild(lnk);
    var r = false;

    // s.async = true;
    lnk.onerror = function (err) {
      reject(err, lnk);
    };
    lnk.onload = lnk.onreadystatechange = function () {
      // console.log(this.readyState); // uncomment this line to see which ready states are called.
      if (!r && (!this.readyState || this.readyState === 'complete')) {
        // console.log('se ha cargado Mathjax correctamente', window.MathJax);
        r = true;
        resolve();
      }
    };
    var t = document.getElementsByTagName('link')[0];
    t.parentElement.insertBefore(lnk, t);
  });
}

function createScriptTags(_ref) {
  var id = _ref.id,
    src = _ref.src;
  return new Promise(function (resolve, reject) {
    var s = document.createElement('script');
    var r = false;
    s.type = 'text/javascript';
    s.id = id;
    s.src = src;
    // s.async = true;
    s.onerror = function (err) {
      reject(err, s);
    };
    s.onload = s.onreadystatechange = function () {
      // console.log(this.readyState); // uncomment this line to see which ready states are called.
      if (!r && (!this.readyState || this.readyState === 'complete')) {
        // console.log('se ha cargado Mathjax correctamente', window.MathJax);
        r = true;
        resolve();
      }
    };
    var t = document.getElementsByTagName('script')[0];
    t.parentElement.insertBefore(s, t);
  });
}
function createInlineScript(_ref2) {
  var id = _ref2.id,
    content = _ref2.content,
    _ref2$attrs = _ref2.attrs,
    attrs = _ref2$attrs === void 0 ? {} : _ref2$attrs;
  if (document.getElementById(id)) return Promise.resolve();
  return new Promise(function (resolve) {
    var tag = document.createElement('script');
    tag.id = id;
    tag.innerHTML = content;
    Object.entries(attrs).forEach(function (entry) {
      return tag[entry[0]] = entry[1];
    });
    document.head.append(tag);
    resolve();
  });
}

function addMathJax() {
  var mathJaxConfig = "\n    function configMathJax () {\n      try{\n        MathJax.Hub.Config({\"fast-preview\": {disabled: true},asciimath2jax: { processClass: \"fr-math\", ignoreClass: \"no-mathjax|editor-page\"},\"TeX\": { extensions: [\"color.js\",\"cancel.js\"] },\"HTML-CSS\": { scale: 100, linebreaks: { automatic: true }, availableFonts : [\"TeX\"], preferredFont : \"TeX\", webFont : \"STIX-Web\"},SVG: { scale: 100, linebreaks: { automatic:false }, font: \"STIX-Web\"}, displayAlign: \"left\",showMathMenu: false,showMathMenuMSIE: false,showProcessingMessages: false, messageStyle: \"none\"});\n       }catch(e){ /* setTimeout (configMathJax, 300) */}\n    }\n    configMathJax();";
  var cdnPath = 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.7/MathJax.js?config=TeX-MML-AM_SVG'; // TeX-MML-AM_HTMLorMML // TeX-MML-AM_SVG // TeX-MML-AM_CHTML No renderiza los acentos, descartado
  if (window && !window.MathJax && !window.loadingMathLib) {
    window.loadingMathLib = true;
    return createScriptTags({
      id: 'MathJax-script',
      src: cdnPath
    }).then(function () {
      return createInlineScript({
        id: 'MathJax-config',
        content: mathJaxConfig,
        attrs: {
          type: 'text/x-mathjax-config'
        }
      });
    }).catch(function (e) {
      return console.log('error cargando Mathjax', e);
    });
  } else {
    return Promise.resolve();
  }
}
function addAutoRenderKatex() {
  var autoRendercdnPath = 'https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/contrib/auto-render.min.js';
  if (window && !window.renderMathInElement) {
    return createScriptTags({
      id: 'Katex-auto-render',
      src: autoRendercdnPath
    });
  } else {
    return Promise.resolve();
  }
}
function addKatex() {
  var cdnPath = 'https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/katex.min.js';
  if (window && !window.katex && !window.loadingMathLib) {
    window.loadingMathLib = true;
    return createScriptTags({
      id: 'Katex-script',
      src: cdnPath
    });
  } else {
    return Promise.reject();
  }
}
function addKatexCss() {
  var cdnStylePath = 'https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/katex.min.css';
  createLinkTags({
    id: 'Katex-style',
    src: cdnStylePath
  });
}
function firstRender(mathEngine) {
  if (mathEngine === void 0) {
    mathEngine = IMathRenderEngine.MATHJAX;
  }
  // console.log('FIRST RENDER ', mathEngine);
  var lemonadeContainer = document.getElementsByClassName(MINT_WRAPPER_CLASS);
  if (lemonadeContainer.length > 0) if (window.renderMathInElement && mathEngine === IMathRenderEngine.KATEX) {
    window.renderMathInElement(lemonadeContainer[0]);
  } else if (window.MathJax) {
    window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub, lemonadeContainer[0]]);
  }
}
function addLatex(mathEngine) {
  console.log('ADD MATH ENGINE ', mathEngine);
  if (mathEngine === IMathRenderEngine.KATEX) {
    addKatex().then(function () {
      addKatexCss();
      addAutoRenderKatex().then(function () {
        return firstRender(mathEngine);
      });
    });
  } else {
    addMathJax().then(function () {
      return firstRender(mathEngine);
    });
  }
}

function useInitializationVisor(props) {
  var config = props.config,
    eventsVisor = props.eventsVisor;
  var _useApplicationConfig = useApplicationConfig(),
    lang = _useApplicationConfig.lang;
  useEffect(function () {
    if (config.pathAssets !== ConfigGlobalSingleton.getInstance().getPathAssets()) ConfigGlobalSingleton.getInstance().setPathAssets(config == null ? void 0 : config.pathAssets);
    if ((config == null ? void 0 : config.lang) !== ConfigGlobalSingleton.getInstance().getLang()) ConfigGlobalSingleton.getInstance().setLang(config == null ? void 0 : config.lang);
    if ((config == null ? void 0 : config.offsetVisibilityPost) !== ConfigGlobalSingleton.getInstance().getOffsetVisibilityPost()) ConfigGlobalSingleton.getInstance().setOffsetVisibilityPost(config == null ? void 0 : config.offsetVisibilityPost);
    if ((config == null ? void 0 : config.offsetVisibilityItemBlock) !== ConfigGlobalSingleton.getInstance().getOffsetVisibilityItemBlock()) ConfigGlobalSingleton.getInstance().setOffsetVisibilityItemBlock(config == null ? void 0 : config.offsetVisibilityItemBlock);
    if (hasData(config == null ? void 0 : config.pathEmbedApi) && (config == null ? void 0 : config.pathEmbedApi) !== ConfigGlobalSingleton.getInstance().getPathEmbedApi())
      //@ts-ignore Quito el warning porque ya esta comprobado que config?.pathEmbedApi tenga valor
      ConfigGlobalSingleton.getInstance().setPathEmbedApi(config == null ? void 0 : config.pathEmbedApi);
    if (hasData(config == null ? void 0 : config.googleApi) && (config == null ? void 0 : config.googleApi) !== ConfigGlobalSingleton.getInstance().getGoogleApi()) ConfigGlobalSingleton.getInstance().setGoogleApi(config == null ? void 0 : config.googleApi);
    if ((config == null ? void 0 : config.showLessonTitles) !== ConfigGlobalSingleton.getInstance().isShowLessonTitles()) ConfigGlobalSingleton.getInstance().setShowLessonTitles((config == null ? void 0 : config.showLessonTitles) || false);
    if ((config == null ? void 0 : config.repeatActivityEnabled) !== ConfigGlobalSingleton.getInstance().isRepeatActivityEnabled()) ConfigGlobalSingleton.getInstance().setRepeatActivityEnabled((config == null ? void 0 : config.repeatActivityEnabled) !== undefined ? config == null ? void 0 : config.repeatActivityEnabled : true);
    if ((config == null ? void 0 : config.scormEnabled) !== ConfigGlobalSingleton.getInstance().isScormEnabled()) ConfigGlobalSingleton.getInstance().setScormEnabled((config == null ? void 0 : config.scormEnabled) || false);
    if ((config == null ? void 0 : config.hideWaitingResponseOfflineActivity) !== ConfigGlobalSingleton.getInstance().isHideWaitingResponseOfflineActivity()) ConfigGlobalSingleton.getInstance().setHideWaitingResponseOfflineActivity((config == null ? void 0 : config.hideWaitingResponseOfflineActivity) !== undefined ? config == null ? void 0 : config.hideWaitingResponseOfflineActivity : true);
    if ((config == null ? void 0 : config.addClassSpanBackgroundsVisor) !== ConfigGlobalSingleton.getInstance().getAddClassSpanBackgroundsVisor()) ConfigGlobalSingleton.getInstance().setAddClassSpanBackgroundsVisor(config == null ? void 0 : config.addClassSpanBackgroundsVisor);
    if ((config == null ? void 0 : config.activityConfig) !== ConfigGlobalSingleton.getInstance().getActivityConfig()) ConfigGlobalSingleton.getInstance().setActivityConfig(config == null ? void 0 : config.activityConfig);
    if ((config == null ? void 0 : config.showAdditionalContentsSubItemVisor) !== ConfigGlobalSingleton.getInstance().isShowAdditionalContentsSubItemVisor()) ConfigGlobalSingleton.getInstance().setShowAdditionalContentsSubItemVisor((config == null ? void 0 : config.showAdditionalContentsSubItemVisor) || false);
    if ((config == null ? void 0 : config.getSrc) !== ConfigGlobalSingleton.getInstance().getGetSrc()) ConfigGlobalSingleton.getInstance().setGetSrc(config == null ? void 0 : config.getSrc);
    if ((config == null ? void 0 : config.background) !== ConfigGlobalSingleton.getInstance().getBackgroundVisor()) ConfigGlobalSingleton.getInstance().setBackgroundVisor(config == null ? void 0 : config.background);
    if ((config == null ? void 0 : config.uiStyles) !== ConfigGlobalSingleton.getInstance().getUiStyles()) ConfigGlobalSingleton.getInstance().setUiStyles(config == null ? void 0 : config.uiStyles);
    if ((config == null ? void 0 : config.enableRowColumnLayout) !== ConfigGlobalSingleton.getInstance().getEnableRowColumnLayout()) ConfigGlobalSingleton.getInstance().setEnableRowColumnLayout((config == null ? void 0 : config.enableRowColumnLayout) || false);
    if ((config == null ? void 0 : config.isSinglePost) !== ConfigGlobalSingleton.getInstance().getIsSinglePost()) ConfigGlobalSingleton.getInstance().setIsSinglePost((config == null ? void 0 : config.isSinglePost) || false);
    if ((config == null ? void 0 : config.enablePopups) !== ConfigGlobalSingleton.getInstance().getEnablePopup()) ConfigGlobalSingleton.getInstance().setEnablePopup((config == null ? void 0 : config.enablePopups) || false);
    if ((config == null ? void 0 : config.enableTextTooltips) !== ConfigGlobalSingleton.getInstance().getEnableTextTooltip()) ConfigGlobalSingleton.getInstance().setEnableTextTooltip((config == null ? void 0 : config.enableTextTooltips) || false);
    if ((config == null ? void 0 : config.enableBackgroundGradient) !== ConfigGlobalSingleton.getInstance().getEnableBackgroundGradient()) ConfigGlobalSingleton.getInstance().setEnableBackgroundGradient((config == null ? void 0 : config.enableBackgroundGradient) || false);
  }, [config]);
  useEffect(function () {
    var mathRenderEngine = (config == null ? void 0 : config.mathRenderEngine) || MATH_RENDER_ENGINE_DEFAUT;
    if ((config == null ? void 0 : config.mathRenderEngine) !== ConfigGlobalSingleton.getInstance().getMathRenderEngine()) ConfigGlobalSingleton.getInstance().setMathRenderEngine(mathRenderEngine);
    addLatex(mathRenderEngine);
  }, [config.mathRenderEngine]);
  useEffect(function () {
    if (eventsVisor) ConfigGlobalSingleton.getInstance().setEventsVisor(eventsVisor);
  }, [eventsVisor !== null]);
  useEffect(function () {
    if (lang && lang !== (i18nMint == null ? void 0 : i18nMint.language)) i18nMint == null || i18nMint.changeLanguage(lang);
  }, [lang]);
  return {};
}

function useCoursePlusV1(props) {
  var configVisor = props.configVisor,
    role = props.role,
    getAssistantVisorLesson = props.getAssistantVisorLesson,
    eventsVisor = props.eventsVisor;
  var _useState = useState({
      lessonActive: null
    }),
    state = _useState[0],
    dispatch = _useState[1];
  var _useGeneral = useGeneral();
  useInitializationVisor({
    config: configVisor,
    eventsVisor: eventsVisor
  });
  var _usePlusV = usePlusV1({
      config: configVisor,
      role: role,
      getAssistantVisorLesson: getAssistantVisorLesson
    }),
    getComponentBelowItemsPostLesson = _usePlusV.getComponentBelowItemsPostLesson,
    configSelectionCoords = _usePlusV.configSelectionCoords,
    configHighlights = _usePlusV.configHighlights,
    configItemsHasBeenSeen = _usePlusV.configItemsHasBeenSeen;
  function onChangeLessonActive(lessonActive) {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        lessonActive: lessonActive
      });
    });
  }
  return {
    configVisor: configVisor,
    lessonActive: state.lessonActive,
    onChangeLessonActive: onChangeLessonActive,
    getComponentBelowItemsPostLesson: getComponentBelowItemsPostLesson,
    configSelectionCoords: configSelectionCoords,
    configHighlights: configHighlights,
    configItemsHasBeenSeen: configItemsHasBeenSeen
  };
}

function useLessonCoursePageWithRoute(props) {
  var course = props.course,
    lessonActive = props.lessonActive,
    onChangeLessonActive = props.onChangeLessonActive,
    nameParamLessons = props.nameParamLessons,
    pathBaseRoute = props.pathBaseRoute;
  var params = useParams();
  var navigate = useNavigate();
  useEffect(function () {
    if (params.id && (!lessonActive || lessonActive && lessonActive.id !== params.id)) {
      //onChangeLessonActive();
      var lessonFound = getLessonCourseById(course, params.id);
      if (lessonFound) onChangeLessonActive(lessonFound);
    }
  }, [params == null ? void 0 : params.id]);
  function _onChangeLessonActive(lessonActive) {
    navigate(pathBaseRoute + nameParamLessons + '/' + lessonActive.id);
  }
  function onClickLinkToHome() {
    navigate(pathBaseRoute);
  }
  return {
    _onChangeLessonActive: _onChangeLessonActive,
    onClickLinkToHome: onClickLinkToHome
  };
}

function LessonCoursePageWithRoute(props) {
  var _useLessonCoursePageW = useLessonCoursePageWithRoute(props),
    _onChangeLessonActive = _useLessonCoursePageW._onChangeLessonActive,
    onClickLinkToHome = _useLessonCoursePageW.onClickLinkToHome;
  return /*#__PURE__*/React__default.createElement(LessonCoursePage, Object.assign({}, props, {
    onChangeLessonActive: _onChangeLessonActive,
    onClickLinkToHome: onClickLinkToHome
  }));
}

function useMainPageWithRoute(props) {
  var nameParamLessons = props.nameParamLessons,
    pathBaseRoute = props.pathBaseRoute;
  var navigate = useNavigate();
  function onChangeLessonActiveMainPage(lessonActive) {
    navigate(pathBaseRoute + nameParamLessons + '/' + lessonActive.id);
  }
  return {
    onChangeLessonActiveMainPage: onChangeLessonActiveMainPage
  };
}

function MainPageWithRoute(props) {
  var _useMainPageWithRoute = useMainPageWithRoute(props),
    onChangeLessonActiveMainPage = _useMainPageWithRoute.onChangeLessonActiveMainPage;
  return /*#__PURE__*/React__default.createElement(MainPage, Object.assign({}, props, {
    onChangeLessonActive: onChangeLessonActiveMainPage
  }));
}

function reorder(list, startIndex, endIndex) {
  var result = Array.from(list);
  var _result$splice = result.splice(startIndex, 1),
    removed = _result$splice[0];
  result.splice(endIndex, 0, removed);
  return result;
}
function arrayUnique(array) {
  var a = array.concat();
  for (var i = 0; i < a.length; ++i) {
    for (var j = i + 1; j < a.length; ++j) {
      if (a[i] === a[j]) a.splice(j--, 1);
    }
  }
  return a;
}

function getHeadDocument() {
  return document.head || document.getElementsByTagName('head')[0];
}
/**
 *
 * @param callBack Notifica con la funcion callBack() cuando esta cargado
 */
function setFonts(fonts, getSrc, onSuccess) {
  var isIE11Local = isIE11();
  var fontsString = '';
  var headFont = fonts.heading.name || '';
  var bodyFont = fonts.body.name || '';
  if (fonts) {
    for (var i = 0; i < fonts.files.length; i++) {
      var font = fonts.files[i];
      fontsString += '\n@font-face { \n' + "font-family: '" + font.name + "';\n" + 'src: url("' + getSrc(font.src) + '") format("woff");\n' + 'font-weight: ' + font.weight + ';\n' + 'font-style:  ' + font.style + ';\n' + '}\n';
      if (bodyFont === '') {
        bodyFont = font.name;
        headFont = font.name;
      }
    }
  }
  var styleNode = document.createElement('style');
  var content = document.createTextNode(fontsString);
  styleNode.appendChild(content);
  if (!isIE11Local) {
    styleNode.onload = function () {
      if (onSuccess) onSuccess({
        head: headFont,
        body: bodyFont
      });
    };
  }
  getHeadDocument().appendChild(styleNode);
  if (isIE11Local) {
    // == // == En ie11 no lanza el metodo onload del sytle por lo que despues de añadirlo lo fuerzo
    setTimeout(function () {
      if (onSuccess) onSuccess({
        head: headFont,
        body: bodyFont
      });
    }, 1);
  }
}
function _setColorsAndFonts(colors, fontsNames, onSuccess) {
  var isIE11Local = isIE11();
  var styles = '';
  if (colors && fontsNames) {
    styles = '' + '.mint-lesson, .mint-blocks-sidebar, .mint-floating-fullscreen {' + '--mint-brand-color: ' + colors.first + ' !important;' + '--mint-brand-color-second: ' + colors.first +
    // addAlpha(colors.first, 0.8) +
    ' !important;' + "--mint-brand-font-first: '" + fontsNames.head + "' !important;" + "--mint-brand-font-second: '" + fontsNames.body + "' !important;" + '};';
  }
  var styleNode = document.createElement('style');
  var content = document.createTextNode(styles);
  styleNode.appendChild(content);
  if (!isIE11Local) {
    styleNode.onload = function () {
      onSuccess();
    };
  }
  getHeadDocument().appendChild(styleNode);
  if (isIE11Local) {
    // == En ie11 no lanza el metodo onload del sytle por lo que despues de añadirlo lo fuerzo
    setTimeout(function () {
      onSuccess();
    }, 1);
  }
}
function setColorsAndFonts(colors, fonts, getSrc, onSuccess) {
  setFonts(fonts, getSrc, function (params) {
    _setColorsAndFonts(colors, params, function () {
      onSuccess();
    });
  });
}

var NAME_PARAM_LESSONS = 'lessons';
function useCourseWithRoutes(props) {
  var _course$colors, _course$fonts, _course$fonts2;
  var course = props.course,
    configItemsHasBeenSeen = props.configItemsHasBeenSeen,
    lessonActive = props.lessonActive;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    getSrc = _useGeneral.getSrc;
  var _useState = useState({
      unitOpenMenuId: getUnitIdFromLessonActive(),
      itemsIdsHasBeenSeen: [],
      pendingNotifyItemsIdsHasBeenSeen: false
    }),
    state = _useState[0],
    dispatch = _useState[1];
  useEffect(function () {
    if (configItemsHasBeenSeen && configItemsHasBeenSeen.getIdsItems) {
      configItemsHasBeenSeen.getIdsItems(function (itemsIds) {
        dispatch(function (prevState) {
          var newItemsIdsHasBeenSeen = arrayUnique(prevState.itemsIdsHasBeenSeen.concat(itemsIds));
          var pendingNotifyItemsIdsHasBeenSeen =
          // == Habia elementos anteriormente y se han añadido al nuevo itemsIdsHasBeenSeen
          prevState.itemsIdsHasBeenSeen.length > 0 && newItemsIdsHasBeenSeen.length !== itemsIds.length; // Ya tenia algunos marcados como que han sido vistos
          return _extends({}, prevState, {
            itemsIdsHasBeenSeen: newItemsIdsHasBeenSeen,
            pendingNotifyItemsIdsHasBeenSeen: pendingNotifyItemsIdsHasBeenSeen
          });
        });
      }, function (error) {
        dispatch(function (prevState) {
          return _extends({}, prevState, {
            itemsIdsHasBeenSeen: []
          });
        });
      });
    }
  }, [course.id, configItemsHasBeenSeen]);
  useEffect(function () {
    if (state.pendingNotifyItemsIdsHasBeenSeen) {
      configItemsHasBeenSeen == null || configItemsHasBeenSeen.setIdsItems(state.itemsIdsHasBeenSeen, function (itemsIds) {
        dispatch(function (prevState) {
          return _extends({}, prevState, {
            itemsIdsHasBeenSeen: itemsIds,
            pendingNotifyItemsIdsHasBeenSeen: false
          });
        });
      }, function (error) {});
    }
  }, [state.pendingNotifyItemsIdsHasBeenSeen]);
  useEffect(function () {
    if (course.colors && course.fonts) setColorsAndFonts(course.colors, course.fonts, getSrc, function () {});
  }, [(_course$colors = course.colors) == null ? void 0 : _course$colors.first, (_course$fonts = course.fonts) == null ? void 0 : _course$fonts.heading.name, (_course$fonts2 = course.fonts) == null ? void 0 : _course$fonts2.body.name]);
  useEffect(function () {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        unitOpenMenuId: getUnitIdFromLessonActive()
      });
    });
  }, [lessonActive == null ? void 0 : lessonActive.id]);
  function onChangeUnitOpenMenuId(unitOpenMenuId) {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        unitOpenMenuId: unitOpenMenuId
      });
    });
  }
  function getUnitIdFromLessonActive() {
    return lessonActive ? getUnitIdFromLesson(course, lessonActive == null ? void 0 : lessonActive.id) : null;
  }
  function onChangeVisibilityItemblockPost(item, post, isVisible) {
    if (isVisible && state.itemsIdsHasBeenSeen.indexOf(item.id) < 0) {
      // == Si no está lo meto
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          itemsIdsHasBeenSeen: [].concat(prevState.itemsIdsHasBeenSeen, [item.id]),
          pendingNotifyItemsIdsHasBeenSeen: true
        });
      });
    }
  }
  return {
    unitOpenMenuId: state.unitOpenMenuId,
    t: t,
    onChangeUnitOpenMenuId: onChangeUnitOpenMenuId,
    nameParamLessons: NAME_PARAM_LESSONS,
    itemsIdHasBeenSeen: state.itemsIdsHasBeenSeen,
    onChangeVisibilityItemblockPost: onChangeVisibilityItemblockPost
  };
}

function CourseWithRoutes(props) {
  var typeMainPage = props.typeMainPage,
    typeLessonCoursePage = props.typeLessonCoursePage,
    course = props.course,
    lang = props.lang,
    lessonActive = props.lessonActive,
    role = props.role,
    onChangeLessonActive = props.onChangeLessonActive,
    _props$pathBaseRoute = props.pathBaseRoute,
    pathBaseRoute = _props$pathBaseRoute === void 0 ? '/' : _props$pathBaseRoute,
    getComponentBelowItemsPostLesson = props.getComponentBelowItemsPostLesson,
    getComponentHeadLesson = props.getComponentHeadLesson,
    getComponentFooterLesson = props.getComponentFooterLesson,
    getComponentEmptyPostLesson = props.getComponentEmptyPostLesson,
    componentRightHeader = props.componentRightHeader,
    configSelectionCoords = props.configSelectionCoords,
    configHighlights = props.configHighlights;
  var _useCourseWithRoutes = useCourseWithRoutes(props),
    unitOpenMenuId = _useCourseWithRoutes.unitOpenMenuId,
    onChangeUnitOpenMenuId = _useCourseWithRoutes.onChangeUnitOpenMenuId,
    nameParamLessons = _useCourseWithRoutes.nameParamLessons,
    itemsIdHasBeenSeen = _useCourseWithRoutes.itemsIdHasBeenSeen,
    onChangeVisibilityItemblockPost = _useCourseWithRoutes.onChangeVisibilityItemblockPost;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "mint-course-with-routes mint-course-" + lang
  }, /*#__PURE__*/React__default.createElement(HashRouter, null, /*#__PURE__*/React__default.createElement(Routes, null, /*#__PURE__*/React__default.createElement(Route, {
    path: pathBaseRoute,
    element: /*#__PURE__*/React__default.createElement(MainPageWithRoute, {
      course: course,
      lessonActive: lessonActive,
      unitOpenMenuId: unitOpenMenuId,
      onChangeUnitOpenMenuId: onChangeUnitOpenMenuId,
      role: role,
      type: typeMainPage,
      nameParamLessons: nameParamLessons,
      pathBaseRoute: pathBaseRoute,
      itemsIdHasBeenSeen: itemsIdHasBeenSeen
    })
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: pathBaseRoute + nameParamLessons + '/:id',
    element: /*#__PURE__*/React__default.createElement(LessonCoursePageWithRoute, {
      course: course,
      lessonActive: lessonActive,
      unitOpenMenuId: unitOpenMenuId,
      type: typeLessonCoursePage,
      onChangeLessonActive: onChangeLessonActive,
      onChangeUnitOpenMenuId: onChangeUnitOpenMenuId,
      getComponentBelowItemsPostLesson: getComponentBelowItemsPostLesson,
      getComponentHeadLesson: getComponentHeadLesson,
      getComponentFooterLesson: getComponentFooterLesson,
      getComponentEmptyPostLesson: getComponentEmptyPostLesson,
      role: role,
      componentRightHeader: componentRightHeader,
      configSelectionCoords: configSelectionCoords,
      configHighlights: configHighlights,
      nameParamLessons: nameParamLessons,
      pathBaseRoute: pathBaseRoute,
      itemsIdHasBeenSeen: itemsIdHasBeenSeen,
      onChangeVisibilityItemblockPost: onChangeVisibilityItemblockPost
    })
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: '*',
    element: /*#__PURE__*/React__default.createElement(Navigate, {
      to: pathBaseRoute
    })
  }))));
}

function I18nProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement(I18nextProvider, {
    i18n: i18nMint
  }, children);
}

function CoursePlusV1(props) {
  var course = props.course,
    configVisor = props.configVisor,
    role = props.role,
    typeMainPage = props.typeMainPage,
    typeLessonCoursePage = props.typeLessonCoursePage,
    pathBaseRoute = props.pathBaseRoute,
    getComponentHeadLesson = props.getComponentHeadLesson,
    getComponentFooterLesson = props.getComponentFooterLesson,
    getComponentEmptyPostLesson = props.getComponentEmptyPostLesson,
    componentRightHeader = props.componentRightHeader;
  var _useCoursePlusV = useCoursePlusV1(props),
    lessonActive = _useCoursePlusV.lessonActive,
    onChangeLessonActive = _useCoursePlusV.onChangeLessonActive,
    getComponentBelowItemsPostLesson = _useCoursePlusV.getComponentBelowItemsPostLesson,
    configSelectionCoords = _useCoursePlusV.configSelectionCoords,
    configHighlights = _useCoursePlusV.configHighlights,
    configItemsHasBeenSeen = _useCoursePlusV.configItemsHasBeenSeen;
  return /*#__PURE__*/React__default.createElement(I18nProvider, null, /*#__PURE__*/React__default.createElement(CourseWithRoutes, {
    course: course,
    lang: configVisor.lang,
    lessonActive: lessonActive,
    role: role,
    onChangeLessonActive: onChangeLessonActive,
    typeMainPage: typeMainPage,
    typeLessonCoursePage: typeLessonCoursePage,
    pathBaseRoute: pathBaseRoute,
    getComponentBelowItemsPostLesson: getComponentBelowItemsPostLesson,
    configSelectionCoords: configSelectionCoords,
    configHighlights: configHighlights,
    configItemsHasBeenSeen: configItemsHasBeenSeen,
    getComponentHeadLesson: getComponentHeadLesson,
    getComponentFooterLesson: getComponentFooterLesson,
    getComponentEmptyPostLesson: getComponentEmptyPostLesson,
    componentRightHeader: componentRightHeader
  }));
}

var _g$i;
function _extends$H() { _extends$H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }
var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/createElement("svg", _extends$H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g$i || (_g$i = /*#__PURE__*/createElement("g", {
    id: "add"
  }, /*#__PURE__*/createElement("path", {
    id: "plus",
    d: "M13 6h-2v5H6v2h5v5h2v-5h5v-2h-5z"
  }))));
};

var _path$o;
function _extends$I() { _extends$I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }
var SvgExclamationCircle$1 = function SvgExclamationCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends$I({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$o || (_path$o = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5999 12.4999C21.5999 17.8018 17.3018 22.0999 11.9999 22.0999C6.69797 22.0999 2.3999 17.8018 2.3999 12.4999C2.3999 7.19797 6.69797 2.8999 11.9999 2.8999C17.3018 2.8999 21.5999 7.19797 21.5999 12.4999ZM13.1999 17.2999C13.1999 17.9626 12.6626 18.4999 11.9999 18.4999C11.3372 18.4999 10.7999 17.9626 10.7999 17.2999C10.7999 16.6372 11.3372 16.0999 11.9999 16.0999C12.6626 16.0999 13.1999 16.6372 13.1999 17.2999ZM11.9999 6.4999C11.3372 6.4999 10.7999 7.03716 10.7999 7.6999V12.4999C10.7999 13.1626 11.3372 13.6999 11.9999 13.6999C12.6626 13.6999 13.1999 13.1626 13.1999 12.4999V7.6999C13.1999 7.03716 12.6626 6.4999 11.9999 6.4999Z",
    fill: "white"
  })));
};

var ToastInfo = function ToastInfo(_ref) {
  var onClose = _ref.onClose,
    text = _ref.text;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-toast-info'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-toast-info__icon'
  }, /*#__PURE__*/React__default.createElement(SvgExclamationCircle$1, null)), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-toast-info__text'
  }, text), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-toast-info__close',
    onClick: onClose
  }, /*#__PURE__*/React__default.createElement(SvgClose, null)));
};

var ToastTextButton = function ToastTextButton(_ref) {
  var children = _ref.children,
    handleAction = _ref.handleAction,
    textButton = _ref.textButton;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'toast-undo-component'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'toast-undo-component__text'
  }, children), /*#__PURE__*/React__default.createElement("div", {
    className: 'toast-undo-component__button'
  }, /*#__PURE__*/React__default.createElement(Button, {
    onClick: handleAction
  }, textButton)));
};

// We need to wrap component in `forwardRef` in order to gain
// access to the ref object that is assigned using the `ref` prop.
// This ref is passed as the second parameter to the function component.
var WithToastForwardRef = /*#__PURE__*/forwardRef(function (_props, ref) {
  var _useToasts = useToasts(),
    addToast = _useToasts.addToast,
    _removeToast = _useToasts.removeToast,
    removeAllToasts = _useToasts.removeAllToasts;
  // The component instance will be extended
  // with whatever you return from the callback passed
  // as the second argument
  useImperativeHandle(ref, function () {
    return {
      showToastTextButton: function showToastTextButton(_ref) {
        var text = _ref.text,
          textButton = _ref.textButton,
          handleAction = _ref.handleAction,
          setToastId = _ref.setToastId;
        addToast( /*#__PURE__*/React__default.createElement(ToastTextButton, {
          handleAction: handleAction,
          textButton: textButton
        }, text), {
          appearance: 'success',
          autoDismiss: true,
          autoDismissTimeout: 5000,
          placement: 'top-center'
        }, function (id) {
          setToastId && setToastId(id);
        });
      },
      //        this.toastUndoRef = React.createRef(); // Poner esto en el constructor primero
      //        this.toastUndoRef.current.showToastTextButton(...  // Y llamar a esta funcion de la siguiente forma
      showToastInfo: function showToastInfo(_ref2) {
        var text = _ref2.text,
          setToastId = _ref2.setToastId,
          handleOnClose = _ref2.handleOnClose;
        addToast( /*#__PURE__*/React__default.createElement(ToastInfo, {
          text: text,
          onClose: handleOnClose
        }), {
          appearance: 'success',
          autoDismiss: true,
          autoDismissTimeout: 10000,
          placement: 'bottom-left'
        }, function (id) {
          setToastId && setToastId(id);
        });
      },
      //        this.toastUndoRef = React.createRef(); // Poner esto en el constructor primero
      //        this.toastUndoRef.current.showToastInfo(...  // Y llamar a esta funcion de la siguiente forma
      removeAllToasts: removeAllToasts,
      removeToast: function removeToast(id) {
        _removeToast(id);
      }
    };
  });
  return null;
});
WithToastForwardRef.displayName = 'WithToastForwardRef';

var ToastEmptyComponent = function ToastEmptyComponent(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'toast-empty-component'
  }, children);
};

var WrapperToastBottom = function WrapperToastBottom(_ref) {
  var children = _ref.children;
  return (
    /*#__PURE__*/
    /* Provide `react-toast-notifications` which provides context for the Toast descendants  */
    React__default.createElement(ToastProvider, {
      components: {
        Toast: ToastEmptyComponent
      },
      placement: 'bottom-center'
    }, children)
  );
};

function canSeeTeacherNotesEditor(userRoleGuid) {
  var canSee = false;
  if (userRoleGuid) {
    if (canAction(actionTypes.SEE_TEACHER_NOTES_EDITOR, userRoleGuid)) {
      canSee = true;
    }
  }
  return canSee;
}
function canSeeAssistantEditor(userRoleGuid) {
  var canSee = false;
  if (userRoleGuid) {
    if (canAction(actionTypes.SEE_ASSISTANT_EDITOR, userRoleGuid)) {
      canSee = true;
    }
  }
  return canSee;
}
function canSeePostOptions(userRoleGuid) {
  return canAction(actionTypes.SEE_POST_OPTIONS, userRoleGuid);
}

var MINT_ID_BLOCKS_SIDEBAR_CONTENT = 'mint-id-blocks-sidebar-content';
var MINT_BLOCKS_SIDEBAR_CONTENT_KEYBOARD_VISIBLE = 'mint-blocks-sidebar__content---keyboard-visible';
var MINT_BLOCKS_SIDEBAR_CONTENT_COLOR_PICKER_VISIBLE = 'mint-blocks-sidebar__content---color-picker-visible';
var FloatingSidebar = /*#__PURE__*/function (_Component) {
  function FloatingSidebar(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.handleClose = function (event) {
      event.preventDefault();
      _this.setState({
        visible: false
      });
      try {
        _this.props.onClose && setTimeout(function () {
          return _this.props.onClose();
        }, 450);
      } catch (e) {}
    };
    _this.el = document.createElement('div');
    _this.container = props.container ? document.getElementById(props.container || '') || document.body : document.body;
    _this.state = {
      visible: props.visible || false,
      mounted: false
    };
    return _this;
  }
  _inheritsLoose(FloatingSidebar, _Component);
  var _proto = FloatingSidebar.prototype;
  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      visible: nextProps.visible || false
    });
  };
  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;
    // The portal element is inserted in the DOM tree after
    // the Modal's children are mounted, meaning that children
    // will be mounted on a detached DOM node. If a child
    // component requires to be attached to the DOM tree
    // immediately when mounted, for example to measure a
    // DOM node, or uses 'autoFocus' in a descendant, add
    // state to Modal and only render the children when Modal
    // is inserted in the DOM tree.
    this.container.appendChild(this.el);
    setTimeout(function () {
      return _this2.setState({
        mounted: true
      });
    }, 100);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.container.removeChild(this.el);
  };
  _proto.render = function render() {
    var title = this.props.title;
    var sidebarClasses = classNames({
      'mint-blocks-sidebar': true,
      'mint-blocks-sidebar--open': this.state.visible && this.state.mounted
    });
    var sidebarOverlayClasses = classNames({
      'mint-blocks-sidebar__overlay': true,
      'mint-blocks-sidebar__overlay--active': this.state.visible
    });
    return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
      className: sidebarClasses
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "mint-blocks-sidebar__container mint-blocks-sidebar__edit"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "mint-blocks-sidebar__header"
    }, /*#__PURE__*/React__default.createElement("h6", {
      className: "mint-blocks-sidebar__title"
    }, title), /*#__PURE__*/React__default.createElement("button", {
      className: "mint-blocks-sidebar__close",
      onClick: this.handleClose
    }, /*#__PURE__*/React__default.createElement(SvgClose, null))), /*#__PURE__*/React__default.createElement("div", {
      className: "block-edit"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "block-edit__content",
      id: MINT_ID_BLOCKS_SIDEBAR_CONTENT
    }, this.props.children)))), /*#__PURE__*/React__default.createElement("div", {
      className: sidebarOverlayClasses,
      onClick: this.handleClose
    })), this.el);
  };
  return FloatingSidebar;
}(Component);

function useMultiSelectCheckbox(props) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _props$onlyConsecutiv = props.onlyConsecutive,
    onlyConsecutive = _props$onlyConsecutiv === void 0 ? false : _props$onlyConsecutiv,
    options = props.options,
    optionsSelected = props.optionsSelected;
  var _useState = useState({
      optionSelected: optionsSelected
    }),
    state = _useState[0],
    dispatch = _useState[1];
  function preChange(_optionsSelected) {
    var optionsSelectedOrder = getOptionsSelectedOrder(_optionsSelected);
    var optionSelectedMin = optionsSelectedOrder.length > 0 ? optionsSelectedOrder[0] : undefined;
    var optionSelectedMax = optionsSelectedOrder.length > 0 ? optionsSelectedOrder[optionsSelectedOrder.length - 1] : undefined;
    var indexOptionSelectedMin = optionSelectedMin ? options.findIndex(function (option) {
      return option.value === optionSelectedMin.value;
    }) : -1;
    var indexOptionSelectedMax = optionSelectedMax ? options.findIndex(function (option) {
      return option.value === optionSelectedMax.value;
    }) : -1;
    var indexMin = undefined;
    var indexMax = undefined;
    // == Calculo cual es el indice min y max que voy a tener
    if (indexOptionSelectedMin >= 0 && indexOptionSelectedMax >= 0) {
      for (var index = 0; index < options.length; index++) {
        var _option = options[index];
        // == Miro los indices que estan entre los elementos min y max seleccionados
        if (index >= indexOptionSelectedMin && index <= indexOptionSelectedMax) {
          if (!_option.disabled) {
            if (indexMin === undefined) indexMin = index;
            if (indexMax === undefined || indexMax < index) indexMax = index;
          } else {
            // Cuando llego a uno disable me salgo
            break;
          }
        }
      }
    }
    var optionsSelectedToRet = _optionsSelected;
    if (indexMin !== undefined && indexMax !== undefined && indexMin < indexMax) {
      // == Selecciono todos los elementos que haya entre los extremos indexMin e indexMax
      optionsSelectedToRet = options.slice(indexMin, indexMax + 1); // == Le sumo uno porque en slice: "The last index is non-inclusive"
    }

    onChange(optionsSelectedToRet);
  }
  function getOptionsSelectedOrder(_optionsSelected) {
    var optionsSelectedOrder = [];
    var _loop = function _loop() {
      var option = options[index];
      var optionFound = _optionsSelected.find(function (optionSelected) {
        return optionSelected.value === option.value;
      });
      if (optionFound) {
        optionsSelectedOrder.push(option);
      }
    };
    for (var index = 0; index < options.length; index++) {
      _loop();
    }
    return optionsSelectedOrder;
  }
  function onChange(optionsSelected) {
    var lastIndex = undefined;
    var isValid = true;
    if (onlyConsecutive) {
      // == Son validos los consecutivos
      // == Primero los optionsSelected los ordeno segun el array de props.options
      var optionsSelectedOrder = getOptionsSelectedOrder(optionsSelected);
      // == Ahora compruebo que los optionsSelectOrder sean consecutivos
      var _loop2 = function _loop2() {
        var optionSelect = optionsSelectedOrder[index];
        var indexInsideOptions = props.options.findIndex(function (option) {
          return option.value === optionSelect.value;
        });
        if (lastIndex !== undefined) {
          if (lastIndex + 1 === indexInsideOptions && !optionSelect.disabled) ; else {
            isValid = false;
            return 1; // break
          }
        }
        lastIndex = indexInsideOptions;
      };
      for (var index = 0; index < optionsSelectedOrder.length; index++) {
        if (_loop2()) break;
      }
    }
    if (isValid) {
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          optionSelected: optionsSelected
        });
      });
      props.onChange && props.onChange(optionsSelected);
    }
  }
  return {
    t: t,
    onChange: preChange,
    optionSelected: state.optionSelected
  };
}

function useMultiSelect() {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  return {
    t: t
  };
}

function MultiSelect(props) {
  var _useMultiSelect = useMultiSelect(),
    t = _useMultiSelect.t;
  var allowSelectAll = props.allowSelectAll,
    _props$allOption = props.allOption,
    allOption = _props$allOption === void 0 ? {
      label: t('Select all', {
        ns: 'editor'
      }),
      value: '*'
    } : _props$allOption,
    options = props.options,
    _onChange = props.onChange;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-multi-select'
  }, allowSelectAll ? /*#__PURE__*/React__default.createElement(ReactSelect, Object.assign({}, props, {
    options: [allOption].concat(options),
    isOptionDisabled: function isOptionDisabled(option) {
      return option.disabled;
    },
    onChange: function onChange(selected) {
      if (selected !== null && selected.length > 0 && selected[selected.length - 1].value === allOption.value) {
        return _onChange(props.options);
      }
      return _onChange(selected);
    }
  })) : /*#__PURE__*/React__default.createElement(ReactSelect, Object.assign({}, props)));
}

/**
 *
 * @param props
 * @returns
 * @example
 *   const colourOptions: OptionTypeMultiSelect[] = [
    { value: 'ocean', label: 'Ocean', color: '#00B8D9', disabled: true },
    { value: 'blue', label: 'Blue', color: '#0052CC' },
    { value: 'purple', label: 'Purple', color: '#5243AA' },
    { value: 'red', label: 'Red', color: '#FF5630' },
    { value: 'orange', label: 'Orange', color: '#FF8B00' },
    { value: 'yellow', label: 'Yellow', color: '#FFC400' },
    { value: 'green', label: 'Green', color: '#36B37E' },
    { value: 'forest', label: 'Forest', color: '#00875A' },
    { value: 'slate', label: 'Slate', color: '#253858' },
    { value: 'silver', label: 'Silver', color: '#666666' },
  ];
   <MultiSelectCheckbox options={colourOptions} />
 */
function MultiSelectCheckbox(props) {
  var options = props.options,
    _props$allowSelectAll = props.allowSelectAll,
    allowSelectAll = _props$allowSelectAll === void 0 ? false : _props$allowSelectAll,
    placeholder = props.placeholder;
  var _useMultiSelectCheckb = useMultiSelectCheckbox(props),
    onChange = _useMultiSelectCheckb.onChange,
    optionSelected = _useMultiSelectCheckb.optionSelected;
  var Option = function Option(props) {
    return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(components.Option, Object.assign({}, props), /*#__PURE__*/React__default.createElement("input", {
      type: 'checkbox',
      className: 'mint-multi-select-checkbox__option' + (props.value === '*' ? ' mint-multi-select-checkbox__option-all' : ''),
      checked: props.isSelected,
      onChange: function onChange() {
        return null;
      }
    }), ' ', /*#__PURE__*/React__default.createElement("label", null, props.label)));
  };
  var MultiValue = function MultiValue(props) {
    return /*#__PURE__*/React__default.createElement(components.MultiValue, Object.assign({}, props), /*#__PURE__*/React__default.createElement("span", null, props.data.label));
  };
  var CustomValueContainer = function CustomValueContainer(props) {
    var length = props.getValue().length;
    var children = props.children;
    return length ? /*#__PURE__*/React__default.createElement(components.ValueContainer, Object.assign({}, props), /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-multi-select-checkbox__value-container'
    }, length, " selected", children.slice(-1))) : /*#__PURE__*/React__default.createElement(components.ValueContainer, Object.assign({}, props), children);
  };
  var animatedComponents = makeAnimated();
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-multi-select-checkbox'
  }, /*#__PURE__*/React__default.createElement(MultiSelect, {
    options: options,
    isMulti: true,
    closeMenuOnSelect: false,
    hideSelectedOptions: false,
    components: {
      Option: Option,
      MultiValue: MultiValue,
      animatedComponents: animatedComponents,
      ValueContainer: CustomValueContainer
    },
    onChange: onChange,
    allowSelectAll: allowSelectAll,
    value: optionSelected,
    placeholder: placeholder
  }));
}

var IFileStatuses;
(function (IFileStatuses) {
  IFileStatuses["START"] = "START";
  IFileStatuses["ADDED"] = "ADDED";
  IFileStatuses["UPLOADING"] = "UPLOADING";
  IFileStatuses["COMPLETE"] = "COMPLETE";
  IFileStatuses["ERROR"] = "ERROR";
  IFileStatuses["FILE_LIMIT"] = "FILE_LIMIT";
})(IFileStatuses || (IFileStatuses = {}));

function useTabAudioPostSidebarItem(props) {
  var onChangeSrc = props.onChangeSrc;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useState = useState({
      isVisibleHelp: false
    }),
    state = _useState[0],
    dispatch = _useState[1];
  function setIsVisibleHelp(isVisible) {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        isVisibleHelp: isVisible
      });
    });
  }
  function onChangeFilesCompleted(files) {
    for (var index = 0; index < files.length; index++) {
      var file = files[index];
      if (file.status === IFileStatuses.COMPLETE) onChangeSrc(file.path);
    }
  }
  function onDeleteAudio() {
    onChangeSrc(undefined);
  }
  return {
    t: t,
    isVisibleHelp: state.isVisibleHelp,
    setIsVisibleHelp: setIsVisibleHelp,
    onChangeFilesCompleted: onChangeFilesCompleted,
    onDeleteAudio: onDeleteAudio
  };
}

var _path$p;
function _extends$J() { _extends$J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }
var SvgTrash$1 = function SvgTrash(props) {
  return /*#__PURE__*/createElement("svg", _extends$J({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$p || (_path$p = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2C8.62123 2 8.27497 2.214 8.10557 2.55279L7.38197 4H4C3.44772 4 3 4.44772 3 5C3 5.55228 3.44772 6 4 6L4 16C4 17.1046 4.89543 18 6 18H14C15.1046 18 16 17.1046 16 16V6C16.5523 6 17 5.55228 17 5C17 4.44772 16.5523 4 16 4H12.618L11.8944 2.55279C11.725 2.214 11.3788 2 11 2H9ZM7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8V14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14V8ZM12 7C11.4477 7 11 7.44772 11 8V14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14V8C13 7.44772 12.5523 7 12 7Z",
    fill: "#828282"
  })));
};

var _path$q;
function _extends$K() { _extends$K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }
var SvgInformationCircle = function SvgInformationCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends$K({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$q || (_path$q = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM11 6C11 6.55228 10.5523 7 10 7C9.44772 7 9 6.55228 9 6C9 5.44772 9.44772 5 10 5C10.5523 5 11 5.44772 11 6ZM9 9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11V14C9 14.5523 9.44772 15 10 15H11C11.5523 15 12 14.5523 12 14C12 13.4477 11.5523 13 11 13V10C11 9.44772 10.5523 9 10 9H9Z",
    fill: "#4F4FFF"
  })));
};

function isStatusCompleted(status) {
  return status === IFileStatuses.COMPLETE;
}
function isStatusDisabled(status) {
  return status === IFileStatuses.UPLOADING || isStatusCompleted(status) || status === IFileStatuses.FILE_LIMIT;
}
function mbToBytes(mb) {
  return mb * 1024 * 1024;
}

function useDropArea(props) {
  var onDrop = props.onDrop,
    onDropRejected = props.onDropRejected,
    status = props.status,
    maxSize = props.maxSize,
    allowedFiles = props.allowedFiles,
    _props$numFilesAdd = props.numFilesAdd,
    numFilesAdd = _props$numFilesAdd === void 0 ? 0 : _props$numFilesAdd;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useState = useState({});
  var _useDropzone = useDropzone({
      accept: allowedFiles,
      // maxFiles: 1,
      maxSize: mbToBytes(maxSize),
      onDrop: onDrop,
      onDropRejected: onDropRejected
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps,
    isDragActive = _useDropzone.isDragActive;
  var _isCompleted = isStatusCompleted(status);
  var _isDisabled = isStatusDisabled(status);
  var messageCompleted = '';
  if (numFilesAdd === 1) {
    messageCompleted = t('editor:file_uploaded_successfully');
  } else if (numFilesAdd > 1) {
    messageCompleted = t('editor:files_uploaded_successfully');
  }
  return {
    t: t,
    isDragActive: isDragActive,
    _isDisabled: _isDisabled,
    _isCompleted: _isCompleted,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    messageCompleted: messageCompleted
  };
}

var _path$r, _path2$9;
function _extends$L() { _extends$L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }
var SvgCloudUpload = function SvgCloudUpload(props) {
  return /*#__PURE__*/createElement("svg", _extends$L({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$r || (_path$r = /*#__PURE__*/createElement("path", {
    d: "M9.30019 20.8001C6.2074 20.8001 3.7002 18.2929 3.7002 15.2001C3.7002 12.3067 5.89453 9.92582 8.70982 9.63085C8.57304 9.11021 8.5002 8.56366 8.5002 8.0001C8.5002 4.46548 11.3656 1.6001 14.9002 1.6001C17.9063 1.6001 20.4284 3.6727 21.1154 6.46689C21.4374 6.42285 21.7661 6.4001 22.1002 6.4001C26.0766 6.4001 29.3002 9.62365 29.3002 13.6001C29.3002 17.5765 26.0766 20.8001 22.1002 20.8001H18.1002V15.0628L20.1688 17.1315C20.7937 17.7563 21.8067 17.7563 22.4316 17.1315C23.0564 16.5066 23.0564 15.4936 22.4316 14.8687L17.6316 10.0687C17.0067 9.44389 15.9937 9.44389 15.3688 10.0687L10.5688 14.8687C9.94399 15.4936 9.94399 16.5066 10.5688 17.1315C11.1937 17.7563 12.2067 17.7563 12.8316 17.1315L14.9002 15.0628L14.9002 20.8001H9.30019Z",
    fill: "#4F4FFF"
  })), _path2$9 || (_path2$9 = /*#__PURE__*/createElement("path", {
    d: "M14.9002 20.8001H18.1002L18.1002 28.8001C18.1002 29.6838 17.3838 30.4001 16.5002 30.4001C15.6165 30.4001 14.9002 29.6838 14.9002 28.8001L14.9002 20.8001Z",
    fill: "#4F4FFF"
  })));
};

function UploadIcon(props) {
  var status = props.status;
  var UPLOADING = IFileStatuses.UPLOADING,
    ADDED = IFileStatuses.ADDED,
    ERROR = IFileStatuses.ERROR,
    START = IFileStatuses.START,
    FILE_LIMIT = IFileStatuses.FILE_LIMIT;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-upload-icon'
  }, status === ADDED || status === START || status === FILE_LIMIT ? /*#__PURE__*/React__default.createElement(SvgCloudUpload, null) : status === UPLOADING ? /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-upload-icon__upload-progress-icon'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-spinner'
  })) : status === ERROR ? /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-upload-icon__error'
  }, /*#__PURE__*/React__default.createElement(SvgClose, null)) : /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-upload-icon__complete'
  }, /*#__PURE__*/React__default.createElement(SvgCheckCircle, null)));
}

function DropArea(props) {
  var status = props.status,
    procressTotal = props.procressTotal,
    allowedFiles = props.allowedFiles;
  var _useDropArea = useDropArea(props),
    t = _useDropArea.t,
    isDragActive = _useDropArea.isDragActive,
    _isDisabled = _useDropArea._isDisabled,
    _isCompleted = _useDropArea._isCompleted,
    messageCompleted = _useDropArea.messageCompleted,
    getRootProps = _useDropArea.getRootProps,
    getInputProps = _useDropArea.getInputProps;
  var formatsSupported = useMemo(function () {
    return Object.values(allowedFiles).map(function (f) {
      return f.map(function (y) {
        return y.substring(1).toUpperCase();
      }).join(', ');
    }).join(', ');
  }, [allowedFiles]);
  return /*#__PURE__*/React__default.createElement("div", Object.assign({
    className: classNames('mint-drop-area', {
      'mint-drop-area--isDragActive': isDragActive,
      'mint-drop-area--disabled': _isDisabled
    })
  }, getRootProps()), /*#__PURE__*/React__default.createElement("input", Object.assign({}, getInputProps())), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-drop-area__icon'
  }, /*#__PURE__*/React__default.createElement(UploadIcon, {
    status: status
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-drop-area__message'
  }, _isCompleted ? messageCompleted : status === IFileStatuses.UPLOADING ? /*#__PURE__*/React__default.createElement("div", null, t('editor:file_uploading_audio', {
    number: Math.floor(procressTotal)
  })) : /*#__PURE__*/React__default.createElement("div", null, t('editor:file_drop_audio_line1'), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-drop-area__message-second'
  }, t('editor:file_drop_audio_line2')), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-drop-area__message-second'
  }, t('files supported', {
    ns: 'editor',
    format: formatsSupported || ''
  })))));
}

var IFileErrors;
(function (IFileErrors) {
  IFileErrors["MAX_FILES_REACHED"] = "MAX_FILES_REACHED";
  IFileErrors["INVALID_TYPE"] = "INVALID_TYPE";
  IFileErrors["MAX_SIZE_EXCEEDED"] = "MAX_SIZE_EXCEEDED";
  IFileErrors["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
  IFileErrors["SERVER_ERROR"] = "SERVER_ERROR";
  IFileErrors["NONE"] = "";
})(IFileErrors || (IFileErrors = {}));

function useFileUploader(props) {
  var _props$maxFiles = props.maxFiles,
    maxFiles = _props$maxFiles === void 0 ? 1 : _props$maxFiles,
    onChangeFilesCompleted = props.onChangeFilesCompleted;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    assetsEditorApi = _useGeneral.assetsEditorApi;
  var _useState = useState({
      error: undefined,
      files: [],
      procressTotal: 0
    }),
    state = _useState[0],
    dispatch = _useState[1];
  useEffect(function () {
    for (var index = 0; index < state.files.length; index++) {
      var file = state.files[index];
      sendFile(file, function () {}, function () {});
    }
  }, [state.files.length]);
  function onAddFiles(acceptedFiles) {
    if (maxFiles > 0 && state.files.length === maxFiles) {
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          error: IFileErrors.MAX_FILES_REACHED
        });
      });
    } else if (state.files.length + acceptedFiles.length - maxFiles > 0) {
      addFiles(acceptedFiles.splice(0, maxFiles - state.files.length), IFileErrors.MAX_FILES_REACHED);
    } else {
      addFiles(acceptedFiles);
    }
  }
  function addFiles(acceptedFiles, error) {
    if (error === void 0) {
      error = undefined;
    }
    var filesToSave = [];
    acceptedFiles.length > 0 && acceptedFiles.forEach(function (file) {
      filesToSave.push({
        guid: getGuid(),
        file: file,
        name: file.name,
        path: '',
        size: file.size,
        process: 0,
        status: IFileStatuses.ADDED
      });
    });
    dispatch(function (prevState) {
      return _extends({}, prevState, error && {
        error: error
      }, {
        files: filesToSave
      });
    });
  }
  /**
   * Funcion de añadir explorando el ordenador
   * @param {*} acceptedFiles
   * @param {*} fileRejections
   * @param {*} event
   */
  function onDrop(acceptedFiles, fileRejections, event) {
    onAddFiles(acceptedFiles);
  }
  function onDropRejected(files, event) {
    var errorCode = files[0].errors[0].code;
    if (files.length === 0) return;
    //state.files.forEach((file) => file.setStatus(fileStatuses.ADDED))
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        error: errorCode === 'file-invalid-type' ? IFileErrors.INVALID_TYPE : errorCode === 'file-too-large' ? IFileErrors.MAX_SIZE_EXCEEDED : IFileErrors.UNKNOWN_ERROR
      });
    });
  }
  function getStatus() {
    var COMPLETE = IFileStatuses.COMPLETE,
      UPLOADING = IFileStatuses.UPLOADING,
      ADDED = IFileStatuses.ADDED,
      ERROR = IFileStatuses.ERROR,
      START = IFileStatuses.START,
      FILE_LIMIT = IFileStatuses.FILE_LIMIT;
    var currentStatus = state.files.map(function (f) {
      return f.status;
    });
    if (state.files.length === 0) return START;
    if (maxFiles > 0 && state.files && state.files.length + 1 > maxFiles && currentStatus.includes(ADDED)) {
      return FILE_LIMIT;
    }
    if (currentStatus.includes(ADDED)) return ADDED;
    if (currentStatus.includes(ERROR)) return ERROR;
    if (currentStatus.includes(UPLOADING)) return UPLOADING;
    return COMPLETE;
  }
  /**
   * Envio de ficheros
   * @param {*} onChangeAbort
   * @param {*} onAbortSuccess
   * @returns
   */
  function sendFile(file, onChangeAbort, onAbortSuccess) {
    if (!hasData(assetsEditorApi)) {
      return console.error('To send files you need to configure an API');
    } else {
      var data = new FormData();
      data.append('file', file.file);
      var request = new XMLHttpRequest();
      request.open('POST', assetsEditorApi);
      request.upload.addEventListener('progress', function (e) {
        dispatch(function (prevState) {
          var newFiles = prevState.files.map(function (_file) {
            return _file.guid === file.guid ? _extends({}, _file, {
              process: e.loaded / e.total * 100
            }) : _file;
          });
          return _extends({}, prevState, {
            files: newFiles,
            procressTotal: getProcessTotal(newFiles)
          });
        });
      });
      request.addEventListener('load', function () {
        if (request.status === 404) {
          dispatch(function (prevState) {
            return _extends({}, prevState, {
              error: IFileErrors.UNKNOWN_ERROR
            });
          });
        } else if (request.status === 200) {
          dispatch(function (prevState) {
            var newFiles = prevState.files.map(function (_file) {
              return _file.guid === file.guid ? _extends({}, _file, {
                path: JSON.parse(request.response).link,
                process: 100,
                status: IFileStatuses.COMPLETE
              }) : _file;
            });
            onChangeFilesCompleted(newFiles);
            return _extends({}, prevState, {
              files: newFiles,
              procressTotal: getProcessTotal(newFiles)
            });
          });
        }
      });
      request.addEventListener('error', function () {
        dispatch(function (prevState) {
          return _extends({}, prevState, {
            error: IFileErrors.UNKNOWN_ERROR
          });
        });
      });
      request.addEventListener('abort', function () {
        onAbortSuccess && onAbortSuccess();
      });
      // send POST request to server
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          error: IFileErrors.UNKNOWN_ERROR
        });
      });
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          error: undefined,
          files: prevState.files.map(function (_file) {
            return _file.guid === file.guid ? _extends({}, _file, {
              status: IFileStatuses.UPLOADING
            }) : _file;
          })
        });
      });
      request.send(data);
      onChangeAbort && onChangeAbort(function () {
        // == Se va a ejecutar cuando el usuario pulse el boton de cancelar la subida
        request.abort();
      });
    }
  }
  /**
   * Devuelve en % el porcentaje total de subida
   */
  function getProcessTotal(files) {
    var processSum = 0;
    for (var index = 0; index < files.length; index++) {
      var file = files[index];
      processSum += file.process;
    }
    var toRet = files.length > 0 ? processSum * 100 / (files.length * 100) : 0;
    return toRet;
  }
  return {
    t: t,
    onDrop: onDrop,
    onDropRejected: onDropRejected,
    status: getStatus(),
    files: state.files,
    procressTotal: state.procressTotal
  };
}

function FileUploader(props) {
  var allowedFiles = props.allowedFiles,
    maxSize = props.maxSize;
  var _useFileUploader = useFileUploader(props),
    onDrop = _useFileUploader.onDrop,
    onDropRejected = _useFileUploader.onDropRejected,
    status = _useFileUploader.status,
    files = _useFileUploader.files,
    procressTotal = _useFileUploader.procressTotal;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-file-uploader'
  }, /*#__PURE__*/React__default.createElement(DropArea, {
    onDrop: onDrop,
    onDropRejected: onDropRejected,
    status: status,
    maxSize: maxSize,
    allowedFiles: allowedFiles,
    numFilesAdd: files ? files.length : 0,
    procressTotal: procressTotal
  }));
}

var _path$s, _path2$a;
function _extends$M() { _extends$M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }
var SvgMicrophone = function SvgMicrophone(props) {
  return /*#__PURE__*/createElement("svg", _extends$M({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$s || (_path$s = /*#__PURE__*/createElement("path", {
    d: "M8.39998 4.79995C8.39998 2.81173 10.0118 1.19995 12 1.19995C13.9882 1.19995 15.6 2.81173 15.6 4.79995V9.59995C15.6 11.5882 13.9882 13.2 12 13.2C10.0118 13.2 8.39998 11.5882 8.39998 9.59995V4.79995Z",
    fill: "white"
  })), _path2$a || (_path2$a = /*#__PURE__*/createElement("path", {
    d: "M13.2 17.9149C17.2707 17.3326 20.4 13.8317 20.4 9.59995C20.4 8.93721 19.8627 8.39995 19.2 8.39995C18.5372 8.39995 18 8.93721 18 9.59995C18 12.9137 15.3137 15.6 12 15.6C8.68627 15.6 5.99998 12.9137 5.99998 9.59995C5.99998 8.93721 5.46272 8.39995 4.79998 8.39995C4.13723 8.39995 3.59998 8.93721 3.59998 9.59995C3.59998 13.8317 6.72922 17.3326 10.8 17.9149V20.4H7.19998C6.53723 20.4 5.99998 20.9372 5.99998 21.6C5.99998 22.2627 6.53723 22.7999 7.19998 22.7999H16.8C17.4627 22.7999 18 22.2627 18 21.6C18 20.9372 17.4627 20.4 16.8 20.4H13.2V17.9149Z",
    fill: "white"
  })));
};

function TabAudioPostSidebarItemAudio(props) {
  var text = props.text,
    onDelete = props.onDelete;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-tab-audio-post-sidebar-item-audio'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-tab-audio-post-sidebar-item-audio__icon'
  }, /*#__PURE__*/React__default.createElement(SvgMicrophone, null)), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-tab-audio-post-sidebar-item-audio__text'
  }, text), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-tab-audio-post-sidebar-item-audio__delete',
    onClick: onDelete
  }, /*#__PURE__*/React__default.createElement(SvgTrash$1, null)));
}

function TabAudioPostSidebarItem(props) {
  var _tabItem$audio, _tabItem$audio2;
  var tabItem = props.tabItem,
    onDelete = props.onDelete,
    title = props.title,
    optionsSelectBlocks = props.optionsSelectBlocks,
    optionsSelectedBlocks = props.optionsSelectedBlocks,
    onChangeBlocks = props.onChangeBlocks;
  var _useTabAudioPostSideb = useTabAudioPostSidebarItem(props),
    t = _useTabAudioPostSideb.t,
    onChangeFilesCompleted = _useTabAudioPostSideb.onChangeFilesCompleted,
    onDeleteAudio = _useTabAudioPostSideb.onDeleteAudio;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-tab-audio-post-sidebar-item',
    key: tabItem.guid
  }, hasData((_tabItem$audio = tabItem.audio) == null ? void 0 : _tabItem$audio.src) ? /*#__PURE__*/React__default.createElement(TabAudioPostSidebarItemAudio, {
    text: ((_tabItem$audio2 = tabItem.audio) == null ? void 0 : _tabItem$audio2.src) || '',
    onDelete: onDeleteAudio
  }) : /*#__PURE__*/React__default.createElement(FileUploader, {
    maxSize: 10,
    allowedFiles: {
      'audio/mp3': ['.mp3'],
      'audio/ogg': ['.ogg']
    },
    maxFiles: 1,
    onChangeFilesCompleted: onChangeFilesCompleted
  }), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-tab-audio-post-sidebar-item__select'
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'mint-tab-audio-post-sidebar-item__select-title'
  }, t('editor:tabs_audios_post_select_blocks_title')), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-tab-audio-post-sidebar-item__select-head-help'
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'mint-tab-audio-post-sidebar-item__select-head'
  }, t('editor:tabs_audios_post_select_head')), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-tab-audio-post-sidebar-item__select-help'
  }, /*#__PURE__*/React__default.createElement(TooltipWrapper, {
    componentButton: /*#__PURE__*/React__default.createElement(SvgInformationCircle, null),
    componentTooltip: /*#__PURE__*/React__default.createElement(TooltipContent, {
      text: t('editor:tabs_audios_post_select_help')
    }),
    openPortal: false
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-tab-audio-post-sidebar-item__select-select'
  }, /*#__PURE__*/React__default.createElement(MultiSelectCheckbox, {
    optionsSelected: optionsSelectedBlocks,
    options: optionsSelectBlocks,
    onChange: onChangeBlocks,
    allowSelectAll: true,
    onlyConsecutive: true,
    placeholder: t('editor:tabs_audios_post_select_placeholder')
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-tab-audio-post-sidebar-item__assigned'
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'mint-tab-audio-post-sidebar-item__assigned-title'
  }, t('editor:tabs_audios_post_assigned_to')), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-tab-audio-post-sidebar-item__assigned-blocks'
  }, optionsSelectedBlocks.map(function (block) {
    return /*#__PURE__*/React__default.createElement("span", {
      key: block.value,
      className: 'mint-tab-audio-post-sidebar-item__assigned-blocks-item'
    }, block.label);
  })))), onDelete && /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-tab-audio-post-sidebar-item__delete-wrapper'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-tab-audio-post-sidebar-item__delete',
    onClick: onDelete
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'mint-tab-audio-post-sidebar-item__delete-text'
  }, t('editor:tabs_audios_post_button_delete', {
    audio_title: title
  })), /*#__PURE__*/React__default.createElement("span", {
    className: 'mint-tab-audio-post-sidebar-item__delete-icon'
  }, /*#__PURE__*/React__default.createElement(SvgTrash$1, null)))));
}

function useTabsAudiosPostHeader(props) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useState = useState({});
  return {
    t: t
  };
}

function TabsAudiosPostHeader(props) {
  var titleTabsList = props.titleTabsList,
    onNew = props.onNew,
    indexTabActive = props.indexTabActive,
    onClickTab = props.onClickTab;
  var _useTabsAudiosPostHea = useTabsAudiosPostHeader(),
    t = _useTabsAudiosPostHea.t;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-tabs-audios-post-header'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-tabs-audios-post-header__tabs'
  }, titleTabsList ? titleTabsList.map(function (titleTab, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-tabs-audios-post-header__tab' + (indexTabActive !== null && indexTabActive === index ? ' mint-tabs-audios-post-header__tab--active' : ''),
      key: index,
      onClick: function onClick(e) {
        e.stopPropagation();
        e.preventDefault();
        onClickTab(index);
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-tabs-audios-post-header__tab-content'
    }, /*#__PURE__*/React__default.createElement("a", {
      href: ''
    }, titleTab), indexTabActive !== null && indexTabActive === index && /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-tabs-audios-post-header__tab-content-line'
    })));
  }) : ''), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-tabs-audios-post-header__button',
    onClick: function onClick() {
      return onNew();
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'mint-tabs-audios-post-header__button-icon'
  }, /*#__PURE__*/React__default.createElement(SvgPlus, null)), /*#__PURE__*/React__default.createElement("span", {
    className: 'mint-tabs-audios-post-header__button-text'
  }, t('editor:tabs_audios_post_button_new'))));
}

/**
 *
 * @param value Tiene de tipo any para hacerlo generico
 * @param delay
 * @returns
 */
function useDebounce(value, delay) {
  var _useState = useState(value),
    debouncedValue = _useState[0],
    setDebouncedValue = _useState[1];
  useEffect(function () {
    var handler = setTimeout(function () {
      setDebouncedValue(value);
    }, delay);
    return function () {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
}

function useTabsAudiosPostSidebar(props) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var post = props.post,
    onChangePost = props.onChangePost;
  var _useState = useState(function () {
      var tabItemsDefault = getTabItemsDefault();
      return {
        tabItems: tabItemsDefault,
        tabActiveGuid: tabItemsDefault && tabItemsDefault.length > 0 ? tabItemsDefault[0].guid : undefined,
        isPendingAudiosOnChangePost: undefined,
        pendingAudiosOnChangePost: undefined
      };
    }),
    state = _useState[0],
    dispatch = _useState[1];
  var stateRef = useRef(state);
  stateRef.current = state;
  var debouncedChangePost = useDebounce(state.isPendingAudiosOnChangePost, 2000); //== debouncedSearch va a tener el valor de state.text en el momento en que reaccionara internamente useDebounce y devolverá otro debouncedSearch
  useEffect(function () {
    // == Verifico que siga siendo igual que lo que hay ahora en el state.text, en caso de haber cambiado ya se invocará de nuevo al
    if (state.isPendingAudiosOnChangePost && debouncedChangePost === state.isPendingAudiosOnChangePost) {
      onChangePost && onChangePost(_extends({}, post, {
        audios: state.pendingAudiosOnChangePost
      }));
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          isPendingAudiosOnChangePost: undefined
        });
      });
    }
  }, [debouncedChangePost]);
  useEffect(function () {
    return function () {
      // == Antes de que se destruya el componente si hay algo pendiente de notificar a onChangePost lo hago
      // == estoy usando stateRef.current.isPendingAudiosOnChangePost en lugar de state.isPendingAudiosOnChangePost porque el state tarda mas en estar reflejado y no tenia en este punto el valor actualizado y con el ref es mas rapido
      if (stateRef.current.isPendingAudiosOnChangePost) {
        onChangePost && onChangePost(_extends({}, post, {
          audios: stateRef.current.pendingAudiosOnChangePost
        }));
      }
    };
  }, []);
  function getTabItemsDefault() {
    if (post.audios && post.audios.length > 0) {
      var toRet = [];
      for (var indexAudio = 0; indexAudio < post.audios.length; indexAudio++) {
        var audio = post.audios[indexAudio];
        toRet.push(getTabItem(indexAudio + 1, audio));
      }
      return toRet;
    } else return [getTabItemTemp(1)];
  }
  function getAudiosToOnChangePost(tabItems) {
    var tabItemsToPost = tabItems.filter(function (tab) {
      return tab.audio && (tab.audio.src || tab.audio.blocks && tab.audio.blocks.length > 0);
    });
    var toRet = tabItemsToPost.map(function (tabItemToPost) {
      var _tabItemToPost$audio, _tabItemToPost$audio2;
      return {
        guid: getGuid(),
        src: ((_tabItemToPost$audio = tabItemToPost.audio) == null ? void 0 : _tabItemToPost$audio.src) || '',
        blocks: ((_tabItemToPost$audio2 = tabItemToPost.audio) == null ? void 0 : _tabItemToPost$audio2.blocks) || []
      };
    });
    return toRet;
  }
  function getTabItemTemp(number) {
    return getTabItem(number, undefined);
  }
  function getTabItem(number, audio) {
    return {
      guid: getGuid(),
      audio: audio
    };
  }
  function onClickTab(index) {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        tabActiveGuid: state.tabItems[index].guid
      });
    });
  }
  function onNew() {
    dispatch(function (prevState) {
      var tabItemTempNew = getTabItemTemp(prevState.tabItems ? prevState.tabItems.length + 1 : 1);
      return _extends({}, prevState, {
        tabItems: [].concat(prevState.tabItems, [tabItemTempNew]),
        tabActiveGuid: tabItemTempNew.guid
      });
    });
  }
  function onChangeSrcBlocksTab(src, blocks, tabActive) {
    if (src || blocks && blocks.length > 0) {
      if (tabActive.audio) {
        // Actualizo los tabItems locales con el campo src
        dispatch(function (prevState) {
          var newTabItems = prevState.tabItems.map(function (tab) {
            return tab.guid === tabActive.guid ? _extends({}, tab, {
              audio: tab.audio ? _extends({}, tab.audio, {
                src: src || '',
                blocks: blocks
              }) : {
                guid: getGuid(),
                src: src || '',
                blocks: blocks
              }
            }) : tab;
          });
          return _extends({}, prevState, {
            tabItems: newTabItems,
            isPendingAudiosOnChangePost: new Date().getTime(),
            pendingAudiosOnChangePost: getAudiosToOnChangePost(newTabItems)
          });
        });
      } else {
        var newAudio = {
          guid: getGuid(),
          src: src || '',
          blocks: blocks
        };
        // Actualizo los tabItems locales con el campo src
        dispatch(function (prevState) {
          var newTabItems = prevState.tabItems.map(function (tab) {
            return tab.guid === tabActive.guid ? _extends({}, tab, {
              audio: newAudio
            }) : tab;
          });
          return _extends({}, prevState, {
            tabItems: newTabItems,
            isPendingAudiosOnChangePost: new Date().getTime(),
            pendingAudiosOnChangePost: getAudiosToOnChangePost(newTabItems)
          });
        });
      }
    } else {
      if (tabActive.audio) {
        if (!hasData(src) && blocks.length === 0) {
          // == Src viene a null y no tiene blocks por lo que lo elimino
          // Actualizo los tabItems locales elimando el audio asociado
          dispatch(function (prevState) {
            var newTabItems = prevState.tabItems.map(function (tab) {
              if (tab.guid === tabActive.guid) {
                delete tab.audio;
              }
              return tab;
            });
            return _extends({}, prevState, {
              tabItems: newTabItems,
              isPendingAudiosOnChangePost: new Date().getTime(),
              pendingAudiosOnChangePost: getAudiosToOnChangePost(newTabItems)
            });
          });
        } //else CREO QUE NO SE DA ESTE CASO PORQUE SI TIEN SRC O BLOCK ENTRA POR EL IF DE ARRIBA
      }
    }
  }
  function onChangeSrcTab(src, tabActive) {
    var _tabActive$audio;
    onChangeSrcBlocksTab(src, ((_tabActive$audio = tabActive.audio) == null ? void 0 : _tabActive$audio.blocks) || [], tabActive);
  }
  function onChangeBlocksTab(value, tabActive) {
    var _tabActive$audio2;
    var blocks = value.map(function (option) {
      return option.value;
    });
    onChangeSrcBlocksTab((_tabActive$audio2 = tabActive.audio) == null ? void 0 : _tabActive$audio2.src, blocks || [], tabActive);
  }
  function onDeleteTab(tabActive) {
    if (tabActive.audio) {
      var _post$audios;
      onChangePost && onChangePost(_extends({}, post, {
        audios: (_post$audios = post.audios) == null ? void 0 : _post$audios.filter(function (audio) {
          var _tabActive$audio3;
          return audio.guid !== ((_tabActive$audio3 = tabActive.audio) == null ? void 0 : _tabActive$audio3.guid);
        })
      }));
    }
    dispatch(function (prevState) {
      var newTabItems = prevState.tabItems.filter(function (tab) {
        return tab.guid !== tabActive.guid;
      });
      var newTabActiveGuid = undefined;
      if (prevState.tabActiveGuid) {
        var indexTabActive = prevState.tabItems.findIndex(function (tab) {
          return tab.guid === prevState.tabActiveGuid;
        });
        if (indexTabActive > 0 && indexTabActive + 1 < prevState.tabItems.length) {
          newTabActiveGuid = prevState.tabItems[indexTabActive + 1].guid; // Activo la siguiente
        }
      }

      if (!newTabActiveGuid && newTabItems.length > 0) {
        newTabActiveGuid = newTabItems[0].guid; // == En otro caso activo la primera
      }

      return _extends({}, prevState, {
        tabItems: newTabItems,
        tabActiveGuid: newTabActiveGuid
      });
    });
  }
  function getTabActive() {
    return state.tabItems.find(function (tab) {
      return tab.guid === state.tabActiveGuid;
    });
  }
  function getIndexTabActive() {
    if (state.tabActiveGuid) {
      var tabActive = getTabActive();
      if (tabActive) {
        return state.tabItems.indexOf(tabActive);
      } else return -1;
    } else return -1;
  }
  function getTitle(index) {
    return t('editor:tabs_audios_post_title', {
      number: index + 1
    });
  }
  /** Indica que blocks estan seleccionados en el resto de tabs excluyendo la tab indexTab */
  function getBlocksOtherTabs(indexTab) {
    var blocksToRet = [];
    for (var index = 0; index < state.tabItems.length; index++) {
      var tabItem = state.tabItems[index];
      // == Excluyo la tab indexTab
      if (index !== indexTab) {
        var _tabItem$audio;
        if ((_tabItem$audio = tabItem.audio) != null && _tabItem$audio.blocks) {
          var _tabItem$audio2;
          blocksToRet.push.apply(blocksToRet, (_tabItem$audio2 = tabItem.audio) == null ? void 0 : _tabItem$audio2.blocks);
        }
      }
    }
    return blocksToRet;
  }
  function getOptionsSelectBlocks(indexTab) {
    // const listItemBlock = getListItemBlock(blockList, t);
    var blocksOtherTabs = getBlocksOtherTabs(indexTab);
    return post.items.map(function (item, index) {
      var opcion = {
        value: (item == null ? void 0 : item.id) || '',
        label: t('editor:tabs_audios_post_block_text', {
          number: index + 1,
          caption: item ? getItemFriendlyName(item, t) : ''
        }),
        disabled: item != null && item.id ? blocksOtherTabs.indexOf(item == null ? void 0 : item.id) >= 0 : false
      };
      return opcion;
    });
  }
  function getOptionsSelectedBlocks(indexTab) {
    var _state$tabItems$index;
    if ((_state$tabItems$index = state.tabItems[indexTab].audio) != null && _state$tabItems$index.blocks) {
      var options = getOptionsSelectBlocks(indexTab);
      // const listItemBlock = getListItemBlock(blockList, t);
      var selected = [];
      for (var index = 0; index < options.length; index++) {
        var option = options[index];
        if (state.tabItems[indexTab].audio.blocks.indexOf(option.value) >= 0) {
          // == Esta seleccionado
          selected.push(option);
        }
      }
      return selected;
    } else return [];
  }
  return {
    t: t,
    titleTabsList: state.tabItems.map(function (tabItem, index) {
      return getTitle(index);
    }),
    tabActive: getTabActive(),
    onClickTab: onClickTab,
    onNew: onNew,
    indexTabActive: getIndexTabActive(),
    onChangeSrcTab: onChangeSrcTab,
    onChangeBlocksTab: onChangeBlocksTab,
    onDeleteTab: onDeleteTab,
    getTitle: getTitle,
    getOptionsSelectBlocks: getOptionsSelectBlocks,
    getOptionsSelectedBlocks: getOptionsSelectedBlocks
  };
}

function TabsAudiosPostSidebar(props) {
  var _useGeneral = useGeneral();
  var _useTabsAudiosPostSid = useTabsAudiosPostSidebar(props),
    titleTabsList = _useTabsAudiosPostSid.titleTabsList,
    tabActive = _useTabsAudiosPostSid.tabActive,
    indexTabActive = _useTabsAudiosPostSid.indexTabActive,
    onClickTab = _useTabsAudiosPostSid.onClickTab,
    onNew = _useTabsAudiosPostSid.onNew,
    onChangeSrcTab = _useTabsAudiosPostSid.onChangeSrcTab,
    onChangeBlocksTab = _useTabsAudiosPostSid.onChangeBlocksTab,
    onDeleteTab = _useTabsAudiosPostSid.onDeleteTab,
    getTitle = _useTabsAudiosPostSid.getTitle,
    getOptionsSelectBlocks = _useTabsAudiosPostSid.getOptionsSelectBlocks,
    getOptionsSelectedBlocks = _useTabsAudiosPostSid.getOptionsSelectedBlocks;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-tabs-audios-post-sidebar'
  }, /*#__PURE__*/React__default.createElement(TabsAudiosPostHeader, {
    titleTabsList: titleTabsList,
    onClickTab: onClickTab,
    indexTabActive: indexTabActive,
    onNew: onNew
  }), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-tabs-audios-post-sidebar__content'
  }, tabActive && /*#__PURE__*/React__default.createElement(TabAudioPostSidebarItem, {
    key: tabActive.guid,
    tabItem: tabActive,
    title: getTitle(indexTabActive),
    optionsSelectBlocks: getOptionsSelectBlocks(indexTabActive),
    optionsSelectedBlocks: getOptionsSelectedBlocks(indexTabActive),
    onChangeSrc: function onChangeSrc(src) {
      return onChangeSrcTab(src, tabActive);
    },
    onChangeBlocks: function onChangeBlocks(value) {
      return onChangeBlocksTab(value, tabActive);
    },
    onDelete: titleTabsList.length > 1 ? function () {
      return onDeleteTab(tabActive);
    } : undefined
  })));
}

function useAudiosPostSidebar(props) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useState = useState({});
  return {
    t: t
  };
}

var AudiosPostSidebar = function AudiosPostSidebar(props) {
  var visible = props.visible,
    onClose = props.onClose,
    post = props.post,
    onChangePost = props.onChangePost;
  var _useAudiosPostSidebar = useAudiosPostSidebar();
  return /*#__PURE__*/React__default.createElement(FloatingSidebar, {
    title: '',
    visible: visible,
    onClose: onClose,
    container: 'mint-lesson'
  }, /*#__PURE__*/React__default.createElement(TabsAudiosPostSidebar, {
    post: post,
    onChangePost: onChangePost
  }));
};

var FloatingFullscreen = /*#__PURE__*/function (_Component) {
  function FloatingFullscreen(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.handleClose = function (event) {
      event.preventDefault();
      _this.setState({
        visible: false
      });
      try {
        _this.props.onClose && _this.props.onClose();
      } catch (e) {}
    };
    _this.el = document.createElement('div');
    _this.container = props.container ? document.getElementById(props.container || '') || document.body : document.body;
    _this.state = {
      visible: props.visible || false,
      mounted: false
    };
    return _this;
  }
  _inheritsLoose(FloatingFullscreen, _Component);
  var _proto = FloatingFullscreen.prototype;
  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      visible: nextProps.visible || false
    });
  };
  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;
    // The portal element is inserted in the DOM tree after
    // the Modal's children are mounted, meaning that children
    // will be mounted on a detached DOM node. If a child
    // component requires to be attached to the DOM tree
    // immediately when mounted, for example to measure a
    // DOM node, or uses 'autoFocus' in a descendant, add
    // state to Modal and only render the children when Modal
    // is inserted in the DOM tree.
    this.container.appendChild(this.el);
    if (this.state.visible) {
      document.body.style.overflow = 'hidden'; // TODO Ver si al poner esto en un host estoy ocultando el scroll del body y lo mismo no aplica
    }

    setTimeout(function () {
      return _this2.setState({
        mounted: true
      });
    }, 100);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.container.removeChild(this.el);
    document.body.style.overflow = 'unset';
  };
  _proto.render = function render() {
    var _classNames;
    var title = this.props.title;
    var sidebarClasses = classNames((_classNames = {
      'mint-floating-fullscreen': true,
      'mint-floating-fullscreen--open': this.state.visible && this.state.mounted
    }, _classNames[this.props.classAdd] = this.props.classAdd, _classNames));
    var sidebarOverlayClasses = classNames({
      'mint-floating-fullscreen__overlay': true,
      'mint-floating-fullscreen__overlay--active': this.state.visible
    });
    return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: sidebarClasses
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "mint-floating-fullscreen__container mint-floating-fullscreen__edit mint-fade-in"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "mint-floating-fullscreen__header"
    }, /*#__PURE__*/React__default.createElement("h6", {
      className: "mint-floating-fullscreen__title"
    }, title), /*#__PURE__*/React__default.createElement("button", {
      className: "mint-floating-fullscreen__close",
      onClick: this.handleClose
    }, /*#__PURE__*/React__default.createElement(SvgClose, null))), /*#__PURE__*/React__default.createElement("div", {
      className: "block-edit"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "block-edit__content"
    }, this.props.children)))), /*#__PURE__*/React__default.createElement("div", {
      className: sidebarOverlayClasses,
      onClick: this.handleClose
    })), this.el);
  };
  return FloatingFullscreen;
}(Component);

function useCommonInputTextArea(props) {
  var onFocus = props.onFocus,
    onBlur = props.onBlur,
    textInput = props.textInput,
    onChange = props.onChange,
    _props$isTextUpdatedK = props.isTextUpdatedKeyEnter,
    isTextUpdatedKeyEnter = _props$isTextUpdatedK === void 0 ? false : _props$isTextUpdatedK,
    onEnterDown = props.onEnterDown; // == Le paso todos los props que venian excepto el modifier, extraclass y children
  var _useState = useState({
      textInput: textInput || '',
      focus: false
    }),
    state = _useState[0],
    dispatch = _useState[1];
  useEffect(function () {
    if (textInput !== state.textInput && !state.focus) {
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          textInput: textInput || ''
        });
      });
    }
  }, [textInput]);
  function onChangeInput(value) {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        textInput: value
      });
    });
    if (!isTextUpdatedKeyEnter && onChange) {
      onChange(value);
    }
  }
  function _stopPropagation(e) {
    e.preventDefault();
    e.stopPropagation();
  }
  function onKeyDown(e) {
    if (isTextUpdatedKeyEnter && e.key === 'Enter') {
      if (onChange) {
        onChange(state.textInput);
      }
    }
    if (e.key === 'Enter' && !e.shiftKey) {
      // == Si esta definida la funcion onEnterDown se para la propagacion y se ejecuta
      if (onEnterDown) {
        _stopPropagation(e);
        onEnterDown();
        return false;
      }
    }
  }
  function _onFocus(e) {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        focus: true
      });
    });
    onFocus && onFocus(e);
  }
  function _onBlur(e) {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        focus: false
      });
    });
    onBlur && onBlur(e);
  }
  return {
    _onFocus: _onFocus,
    _onBlur: _onBlur,
    onChangeInput: onChangeInput,
    onKeyDown: onKeyDown,
    textInputState: state.textInput
  };
}

var _excluded$1 = ["onClick", "autofocus", "placeholder", "type", "disabled", "maxLength", "onFocus", "onBlur", "onEnterDown", "textInput", "onChange", "isTextUpdatedKeyEnter"];
function InputGeneric(props) {
  var onClick = props.onClick,
    _props$autofocus = props.autofocus,
    autofocus = _props$autofocus === void 0 ? false : _props$autofocus,
    placeholder = props.placeholder,
    type = props.type,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$maxLength = props.maxLength,
    maxLength = _props$maxLength === void 0 ? undefined : _props$maxLength,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$1); // == Le paso todos los props que venian excepto el modifier, extraclass y children
  var _useCommonInputTextAr = useCommonInputTextArea(props),
    onChangeInput = _useCommonInputTextAr.onChangeInput,
    textInputState = _useCommonInputTextAr.textInputState,
    onKeyDown = _useCommonInputTextAr.onKeyDown,
    _onFocus = _useCommonInputTextAr._onFocus,
    _onBlur = _useCommonInputTextAr._onBlur;
  return /*#__PURE__*/React__default.createElement("input", Object.assign({
    onClick: onClick,
    type: type || 'text',
    className: 'input-text input-text--simple',
    placeholder: placeholder || '',
    onChange: function onChange(e) {
      return onChangeInput(e.target.value);
    },
    value: textInputState,
    autoFocus: autofocus,
    onKeyDown: onKeyDown,
    disabled: disabled,
    maxLength: maxLength,
    onFocus: _onFocus,
    onBlur: _onBlur
  }, otherProps));
}

var InputText = function InputText(_ref) {
  var textInput = _ref.textInput,
    onChange = _ref.onChange,
    placeholder = _ref.placeholder,
    _ref$isTextUpdatedKey = _ref.isTextUpdatedKeyEnter,
    isTextUpdatedKeyEnter = _ref$isTextUpdatedKey === void 0 ? false : _ref$isTextUpdatedKey,
    onClick = _ref.onClick,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    onEnterDown = _ref.onEnterDown,
    _ref$autofocus = _ref.autofocus,
    autofocus = _ref$autofocus === void 0 ? false : _ref$autofocus,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$maxLength = _ref.maxLength,
    maxLength = _ref$maxLength === void 0 ? undefined : _ref$maxLength;
  return /*#__PURE__*/React__default.createElement(InputGeneric, {
    textInput: textInput,
    onChange: onChange,
    placeholder: placeholder,
    type: 'text',
    isTextUpdatedKeyEnter: isTextUpdatedKeyEnter,
    autofocus: autofocus,
    onClick: onClick,
    onFocus: onFocus,
    onBlur: onBlur,
    onEnterDown: onEnterDown,
    disabled: disabled,
    maxLength: maxLength
  });
};

var TextArea = function TextArea(props) {
  var placeholder = props.placeholder,
    _props$rows = props.rows,
    rows = _props$rows === void 0 ? 2 : _props$rows;
  var _useCommonInputTextAr = useCommonInputTextArea(props),
    onChangeInput = _useCommonInputTextAr.onChangeInput,
    textInputState = _useCommonInputTextAr.textInputState,
    onKeyDown = _useCommonInputTextAr.onKeyDown,
    _onFocus = _useCommonInputTextAr._onFocus,
    _onBlur = _useCommonInputTextAr._onBlur;
  return /*#__PURE__*/React__default.createElement("textarea", {
    className: 'textarea',
    value: textInputState,
    onChange: function onChange(e) {
      return onChangeInput(e.target.value);
    },
    placeholder: placeholder,
    onKeyDown: onKeyDown,
    rows: rows,
    onFocus: _onFocus,
    onBlur: _onBlur
  });
};

function useClassSpanBackgroundsEditor(props) {
  _objectDestructuringEmpty(props);
  var _useGeneral = useGeneral(),
    addClassSpanBackgroundsEditor = _useGeneral.addClassSpanBackgroundsEditor;
  var froalaEditorRef = useRef(null);
  var pendingInitializedFroala = useRef(false);
  useEffect(function () {
    if (addClassSpanBackgroundsEditor && pendingInitializedFroala.current && froalaEditorRef.current) {
      onInitializedFroalaFinal(froalaEditorRef.current, addClassSpanBackgroundsEditor);
    }
  }, [addClassSpanBackgroundsEditor, pendingInitializedFroala.current, froalaEditorRef.current]);
  function onInitializedFroala(editor) {
    froalaEditorRef.current = editor;
    if (!addClassSpanBackgroundsEditor) {
      pendingInitializedFroala.current = true;
    } else {
      onInitializedFroalaFinal(editor, addClassSpanBackgroundsEditor);
    }
  }
  function onInitializedFroalaFinal(editor, classAdd) {
    if (classAdd) {
      // Esto en la 3.0.6 de froala no va, y en la 3.2.6 no funciana en froala en prod
      // @ts-ignore
      removeClassSpanEmptyBackgrounds(editor.el, classAdd);
      // @ts-ignore
      addClassSpanBackgrounds(editor.el, classAdd, CLASS_HIGHLIGHT);
      // == Pongo un timeout pequeño porque sin este si veo en este punto que vale editor.events siempre me da undefined
      setTimeout(function () {
        // @ts-ignore
        if (editor.events) {
          // @ts-ignore
          editor.events.on('html.get', function (html) {
            var parser = new DOMParser();
            var $html = parser.parseFromString(html, 'text/html'); // Crea un nuevo documento HTML.
            // Quita la clase 'pepito' a todos los elementos que la tengan.
            $html.querySelectorAll('.' + classAdd).forEach(function (element) {
              element.classList.remove(classAdd);
              // Si el atributo class está vacío, elimínalo.
              if (element.getAttribute('class') === '') {
                element.removeAttribute('class');
              }
            });
            return $html.documentElement.innerHTML; // Devuelve el HTML modificado.
          }, true);
          // @ts-ignore
          editor.events.on('html.set', function () {
            // @ts-ignore
            removeClassSpanEmptyBackgrounds(editor.el, classAdd);
            // @ts-ignore
            addClassSpanBackgrounds(editor.el, classAdd, CLASS_HIGHLIGHT);
          });
          // @ts-ignore
          editor.events.on('commands.before', function (cmd, param1, param2) {
            // Si el comando es bgColor y el nuevo color es transparente (o cualquier otro valor que indique la eliminación de color de fondo)
            if (cmd === 'applybackgroundColor' && param1 === 'REMOVE') {
              // @ts-ignore
              editor.$el.find('.' + classAdd).removeClass(classAdd);
            }
          });
          // @ts-ignore
          editor.events.on('commands.after', function (cmd, param1, param2) {
            if (cmd === 'applybackgroundColor') {
              // @ts-ignore
              removeClassSpanEmptyBackgrounds(editor.el, classAdd);
              // @ts-ignore
              addClassSpanBackgrounds(editor.el, classAdd, CLASS_HIGHLIGHT);
            }
          });
        }
      }, 200);
    }
  }
  return {
    onInitializedFroala: onInitializedFroala
  };
}

/*eslint-disable*/
(function addMathPluginv3() {
  var DELIMITER_BEGIN_LATEX = '\\(';
  var DELIMITER_END_LATEX = '\\)';
  var mfes = {}; // vamos a guardar una instancia de mathfield por cada popup nuevo
  var firstEditor = undefined; // como se reutilizan los popup entre froalas, nos quedamos con la primera instancia abierta que será el reutilizable
  FroalaEditor.POPUP_TEMPLATES['mathPluginv3.popup'] = '[_BUTTONS_][_CUSTOM_LAYER_]';
  FroalaEditor.POPUP_TEMPLATES['mathPluginv3.edit'] = '[_BUTTONS_]';

  // Define popup buttons.
  Object.assign(FroalaEditor.DEFAULTS, {
    popupButtonsv3: ['popupClosev3'],
    mathPluginEditButtonsv3: ['mathPluginv3Edit', '|', 'mathPluginv3Remove']
  });
  var delayRerender;
  // The custom popup is defined inside a plugin (new or existing).
  FroalaEditor.PLUGINS.mathPluginv3 = function (editor) {
    function _init() {
      editor.events.$on(editor.$el, 'click touchend', 'span.fr-math-v3', touchEndElement);
      editor.events.on('html.processGet', resetMathDiv); // para cuando se mande a servidor quitar los divs que genera mathjax
      editor.events.on('initialized', function () {
        this.opts.htmlAllowedEmptyTags.push('span'); // tengo que añadirlo si no borra el span vacio de mathjax
        setTimeout(function () {
          renderMathExpression(getMathElements(editor.el));
        }, 100);
      });
      editor.events.on('html.set', function () {
        //Retrasamos el render porque el usuario puede estar escribiendo
        clearTimeout(delayRerender);
        delayRerender = setTimeout(function () {
          renderMathExpression(getMathElements(editor.el));
        }, 2000);
      });
    }

    // Create custom popup.
    function initPopup() {
      getEventListenersPolyfill();
      // Popup buttons.
      var popup_buttons = '';
      // Create the list of buttons.
      if (editor.opts.popupButtonsv3.length > 1) {
        popup_buttons += '<div class="fr-buttons fr-tabs">';
        popup_buttons += editor.button.buildList(editor.opts.popupButtonsv3);
        popup_buttons += '</div>';
      }
      // Load popup template.
      var template = {
        buttons: popup_buttons,
        custom_layer: '<div class="fr-math-v3-insert-layer fr-layer fr-active" id="fr-math-v3-insert-layer-"' + editor.id + '" data-mouseenter-event-set="true" data-popup-id="' + editor.id + '">' + '<div class="fr-input-line" style="display: block;">' + '<div class="fr-math-v3-field"></div>' + '</div>' + '<div class="fr-action-buttons"><button class="fr-command fr-submit fr-math-v3-action-button" role="button" data-cmd="mathInsertv3" href="#" tabindex="3" type="button">Insert</button></div>' + '</div>'
      };

      // Create popup.
      var $popup = editor.popups.create('mathPluginv3.popup', template);
      initMathField();
      return $popup;
    }

    // Show the popup
    function showPopup(isQuickInsert) {
      if (isQuickInsert === void 0) {
        isQuickInsert = false;
      }
      if (editor.selection) editor.selection.save(); // == Guardamos donde está el cursor para cuando hagamos la inserccion poder hacer un editor.selection.restore() y formar que el editor.html.insert se haga en dicha posicion, antes no hacia falta hacer esto pero ahora si porque sino se inserta alfinal del texto LEMO-599

      var selection = editor.selection.text();

      // Get the popup object defined above.
      var $popup = editor.popups.get('mathPluginv3.popup');

      // If popup doesn't exist then create it.
      // To improve performance it is best to create the popup when it is first needed
      // and not when the editor is initialized.
      if (!$popup) $popup = initPopup();

      // Set the editor toolbar as the popup's container.
      editor.popups.setContainer('mathPluginv3.popup', isQuickInsert ? editor.$sc : editor.$tb); //tb para toolbar; tooltip para quick insert

      // This will trigger the refresh event assigned to the popup.
      editor.popups.refresh('mathPluginv3.popup');

      // This custom popup is opened by pressing a button from the editor's toolbar.
      // Get the button's object in order to place the popup relative to it.
      var $btn = isQuickInsert ? $('.fr-qi-helper') : editor.$tb.find('.fr-command[data-cmd="mathButtonV3"]');

      // Set the popup's position.
      var left = $btn.offset().left + $btn.outerWidth() / 2;
      var top = $btn.offset().top + (!isQuickInsert ? editor.opts.toolbarBottom ? 10 : $btn.outerHeight() - 10 : 0);

      // Show the custom popup.
      // The button's outerHeight is required in case the popup needs to be displayed above it.
      editor.popups.show('mathPluginv3.popup', left, top, $btn.outerHeight());
      var buttonAction = $popup.find('.fr-math-v3-action-button');
      if (buttonAction) {
        buttonAction.text('Insert');
        buttonAction.data('cmd', 'mathInsertv3');
      }
      var mfe = getMathfiledInstance();
      if (mfe) {
        if (selection.length > 0) {
          mfe.setValue(selection);
        } else mfe.setValue('');
        mfe.focus();
      }
      fixKeyboardMathDiv();
    }

    /** Hay un fix que no se permite manejar el teclado,
     * y analizando se ha visto que quitando el listener de tipo 'keydown'
     * que tiene el elemento fr-math-v3-insert-layer ya te permite usar el teclado
     * Con esta funcion lo que vamos hacer es eliminar dicho listener
     * */
    function fixKeyboardMathDiv() {
      var items = document.getElementsByClassName('fr-math-v3-insert-layer');
      for (var i = 0; i < items.length; i++) {
        if (typeof items[i].clearEventListeners !== 'undefined') {
          items[i].clearEventListeners('keydown');
        }
      }
    }
    function resetMathDiv(e) {
      if (e && editor.node.hasClass(e, 'fr-math-v3')) {
        e.textContent = e.getAttribute('data-original-math');
        e.setAttribute('class', (e.getAttribute('class') || '').replace('fr-math-v3-render', ''));
      } else if (e && e.nodeType === Node.ELEMENT_NODE) for (var n = e.querySelectorAll('.fr-math-v3'), i = 0; i < n.length; i++) resetMathDiv(n[i]);
    }
    function getEditButtons() {
      var e = '';
      if (editor.opts.mathPluginEditButtonsv3.length > 0) {
        e += '<div class="fr-buttons">\n      '.concat(editor.button.buildList(editor.opts.mathPluginEditButtonsv3), '\n      </div>');
        var n = {
            buttons: e
          },
          i = editor.popups.create('mathPluginv3.edit', n);
        return editor.events.$on(editor.$wp, 'scroll.mathPluginv3-edit', function () {
          currentElement && editor.popups.isVisible('mathPluginv3.edit') && editor.events.disableBlur() && a(currentElement);
        }), i;
      }
      return !1;
    }
    function a(e) {
      touchEndElement.call(e.get(0));
    }
    function touchEndElement() {
      currentElement = $(this);
      showPopupElement();
    }
    function showPopupElement() {
      var e = editor.popups.get('mathPluginv3.edit');
      if (e || (e = getEditButtons()), e) {
        editor.popups.setContainer('mathPluginv3.edit', editor.$sc);
        editor.popups.refresh('mathPluginv3.edit');
        var left = currentElement.offset().left + currentElement.outerWidth() / 2,
          top = currentElement.offset().top + currentElement.outerHeight();
        editor.popups.show('mathPluginv3.edit', left, top, currentElement.outerHeight());
      }
    }
    function getMathliveLatexFormula() {
      var mfe = getMathfiledInstance();
      var latexFormula = mfe.getValue('latex'); // 2/8/2022 se cambia a latex en vez de latex-expanded
      // console.log(mfe.getValue('latex-expanded'));
      // console.log(mfe.getValue('latex'));
      if (latexFormula.length > 1) {
        if (!latexFormula.startsWith(DELIMITER_BEGIN_LATEX) && !latexFormula.endsWith(DELIMITER_END_LATEX) && latexFormula.indexOf('`') !== 0 && latexFormula.indexOf('$$') !== 0) {
          // si tiene delimitador \(exp\) no añadir este `
          latexFormula = DELIMITER_BEGIN_LATEX + latexFormula + DELIMITER_END_LATEX;
        }
        latexFormula = latexFormula.replaceAll('mleft', 'left');
        latexFormula = latexFormula.replaceAll('mright', 'right');
        latexFormula = latexFormula.replaceAll('\\exponentialE', '\\mathrm{e}');
        latexFormula = latexFormula.replaceAll('\\doubleprime', '\\prime\\prime');
        latexFormula = latexFormula.replaceAll('mathcolor', 'color');
        latexFormula = latexFormula.replaceAll('^^b7', ' · ');
      }
      return latexFormula;
    }
    function createFragment(markup) {
      var fragment = document.createRange().createContextualFragment(markup);
      return fragment.firstElementChild;
    }
    function insertMathLatex(latex) {
      if (latex) {
        // Hay un problema con el simbolo de < en el span, se cree que es un html
        var newElement = " <span class=\"fr-math-v3 fr-draggable\" draggable=\"true\" contenteditable=\"false\" data-original-math=\"" + latex + "\">" + latex + "</span> ";
        var newElementDom = createFragment(newElement);
        newElementDom.textContent = latex;
        if (editor.selection) editor.selection.restore(); // == Restauro donde está el cursor, antes no hacia falta hacer esto pero ahora si porque sino se inserta alfinal del texto LEMO-599
        editor.html.insert(newElementDom.outerHTML);
        renderMathExpression(newElement);
      }
    }
    function insert() {
      // == Insert mathlive
      var mfe = getMathfiledInstance();
      if (mfe) {
        var latexFormula = getMathliveLatexFormula();
        if (latexFormula.length > 1) {
          insertMathLatex(latexFormula);
          editor.popups.hideAll();
        }
      }
    }
    function remove() {
      if (currentElement) {
        var e = currentElement[0];
        editor.selection.setBefore(e) || editor.selection.setAfter(e);
        e.remove();
        editor.events.focus(true);
        editor.selection.restore();
        editor.html.fillEmptyBlocks();
        editor.undo.saveStep();
        editor.popups.hideAll();
        setTimeout(function () {
          editor.selection.restore();
          editor.html.fillEmptyBlocks();
          editor.undo.saveStep();
          editor.popups.hideAll();
        }, 100);
      }
    }
    function edit() {
      if (currentElement) {
        var latexFormula = currentElement[0].getAttribute('data-original-math');
        var left = currentElement.offset().left + currentElement.outerWidth() / 2,
          top = currentElement.offset().top + currentElement.outerHeight();
        var $popup = editor.popups.get('mathPluginv3.popup');
        if (!$popup) $popup = initPopup();
        editor.popups.setContainer('mathPluginv3.popup', editor.$sc);
        // This will trigger the refresh event assigned to the popup.
        editor.popups.refresh('mathPluginv3.popup');
        editor.popups.show('mathPluginv3.popup', left, top, currentElement.outerHeight());
        //Mathlive
        var mfe = getMathfiledInstance();
        if (mfe) {
          var latexFormulaFinal = latexFormula;
          if (latexFormula.startsWith(DELIMITER_BEGIN_LATEX) && latexFormula.endsWith(DELIMITER_END_LATEX)) {
            latexFormulaFinal = latexFormulaFinal.substring(DELIMITER_BEGIN_LATEX.length, latexFormulaFinal.length - DELIMITER_END_LATEX.length);
          }
          mfe.setValue(latexFormulaFinal);
          mfe.focus();
        }
        var buttonAction = $popup.find('.fr-math-v3-action-button');
        if (buttonAction) {
          buttonAction.text('Update');
          buttonAction.data('cmd', 'mathUpdatev3');
        }
      }
      fixKeyboardMathDiv();
    }
    function update() {
      if (currentElement) {
        var latexFormula = getMathliveLatexFormula();
        currentElement[0].setAttribute('data-original-math', latexFormula);
        resetMathDiv(currentElement[0]);
        editor.events.focus(true);
        editor.selection.setAfter(currentElement[0]);
        editor.selection.restore();
        renderMathExpression([currentElement[0]]);
        editor.popups.hideAll();
      }
    }

    // Hide the custom popup.
    function hidePopup() {
      editor.popups.hide('mathPluginv3.popup');
    }
    function getMathElements(_editor) {
      return _editor.getElementsByClassName('fr-math-v3');
    }
    function renderMathKatex(elements) {
      if (typeof renderMathInElement != 'undefined') {
        // console.log('Froala: renderMathKatex')
        renderMathInElement(elements, {
          throwOnError: true
        });
        editor.$el.find('.fr-math-v3').css('opacity', '1');
      }
    }
    function renderMathJax(elements) {
      if (typeof MathJax != 'undefined') {
        MathJax.Hub.Queue(['Typeset', MathJax.Hub, elements, function () {
          // callback finish render
        }]);
      }
    }
    function renderMathExpression(elements) {
      if (elements && elements.length > 0) {
        var renderEngine = ConfigGlobalSingleton.getInstance().getMathRenderEngine();
        if (renderEngine === IMathRenderEngine.KATEX) {
          // renderMathInElement es una funcion global de katex auto render
          renderMathKatex(editor.el);
        } else {
          // MathJax es una variable definida fuera, a nivel general
          renderMathJax(elements);
        }
      }
    }
    function initMathField() {
      //  if(!mfe){ // == Lo comento porque sino la segunda vez que se accedia al editor no salia la caja del Mathlive
      //mfe = new MathfieldElement(); // == Si usaba //import {MathfieldElement} from 'mathlive'
      if (typeof window.MathLive !== 'undefined') {
        if (!mfes[editor.id]) {
          var mfe = new window.MathLive.MathfieldElement();
          // Set initial value and options
          //mfe.value = "\\frac{\\sin(x)}{\\cos(x)}";
          // Options can be set either as an attribute (for simple options)...
          mfe.setAttribute('virtual-keyboard-layout', 'dvorak');
          /* mfe.setOptions({
            virtualKeyboardMode: 'onfocus',
          });*/
          //mfe.virtualKeyboardMode = 'onfocus';
          mfe.addEventListener('focusin', function () {
            return mathVirtualKeyboard.show();
          });
          mfe.setAttribute('class', 'froala-mathField__input');
          mfe.addEventListener('virtual-keyboard-toggle', function (param1, param2) {
            var sidebarContent = document.getElementById(MINT_ID_BLOCKS_SIDEBAR_CONTENT);
            if (sidebarContent) {
              if (mfe.virtualKeyboardState === 'visible') {
                addClass(sidebarContent, MINT_BLOCKS_SIDEBAR_CONTENT_KEYBOARD_VISIBLE);
              } else {
                removeClass(sidebarContent, MINT_BLOCKS_SIDEBAR_CONTENT_KEYBOARD_VISIBLE);
              }
            }
          });
          if (!firstEditor) firstEditor = editor.id;
          mfes[editor.id] = mfe;
        }
        var $popup = editor.popups.get('mathPluginv3.popup');
        var mathFieldContent = $popup.find('.fr-math-v3-field');
        mathFieldContent.append(mfes[editor.id]);
      }
      // }
    }

    // Se guarda una instancia por cada nuevo popup que se instancia. Los popup se reutilizan entre enditores por tanto, si no existe el popup del id, se tira del primer editor que instanció el popup de fórmulas
    function getMathfiledInstance() {
      var $popup = editor.popups.get('mathPluginv3.popup');
      var popupid = $popup ? $popup.find('.fr-math-v3-insert-layer').data('popup-id') : undefined;
      // console.log('Popup id: ', popupid || editor.id || firstEditor)
      return mfes[popupid || editor.id] || mfes[firstEditor];
    }
    var currentElement,
      $ = editor.$;
    // Methods visible outside the plugin.
    return {
      _init: _init,
      showPopup: showPopup,
      hidePopup: hidePopup,
      insert: insert,
      remove: remove,
      edit: edit,
      update: update
    };
  };

  // Define an icon and command for the button that opens the custom popup.
  FroalaEditor.DefineIcon('mathIcon', {
    NAME: 'mathIcon',
    SVG_KEY: 'symbols'
  });
  FroalaEditor.RegisterCommand('mathButtonV3', {
    title: 'Insert math expresion',
    icon: 'mathIcon',
    undo: false,
    focus: false,
    plugin: 'mathPluginv3',
    callback: function callback() {
      this.mathPluginv3.showPopup(false);
    }
  });
  FroalaEditor.RegisterQuickInsertButton('mathButtonQI', {
    title: 'Insert math expression',
    icon: 'mathIcon',
    undo: false,
    focus: false,
    plugin: 'mathPluginv3',
    callback: function callback() {
      this.mathPluginv3.showPopup(true);
    }
  });
  FroalaEditor.DefineIcon('mathPluginv3Remove', {
    NAME: 'trash',
    SVG_KEY: 'remove'
  });
  FroalaEditor.RegisterCommand('mathPluginv3Remove', {
    title: 'Remove',
    undo: false,
    callback: function callback() {
      this.mathPluginv3.remove();
    }
  });
  FroalaEditor.DefineIcon('mathPluginv3Edit', {
    NAME: 'edit',
    SVG_KEY: 'edit'
  });
  FroalaEditor.RegisterCommand('mathPluginv3Edit', {
    title: 'Edit',
    undo: false,
    callback: function callback() {
      this.mathPluginv3.edit();
    }
  });
  FroalaEditor.DefineIcon('popupClosev3', {
    NAME: 'times',
    SVG_KEY: 'back'
  });
  FroalaEditor.RegisterCommand('popupClosev3', {
    title: 'Close',
    undo: false,
    focus: false,
    callback: function callback() {
      this.mathPluginv3.hidePopup();
    }
  });
  FroalaEditor.RegisterCommand('mathInsertv3', {
    focus: false,
    plugin: 'mathPluginv3',
    callback: function callback() {
      this.mathPluginv3.insert();
    }
  });
  FroalaEditor.RegisterCommand('mathUpdatev3', {
    focus: false,
    plugin: 'mathPluginv3',
    callback: function callback() {
      this.mathPluginv3.update();
    }
  });
})();

/*********************************************************************************************/
/** UTILS: Polyfill, añadir metodos a los elementos getEventListeners y clearEventListeners  */
/*********************************************************************************************/
/**
 * Usage:
 *  someElement.getEventListeners([name]) - return list of event listeners, if name is set return array of listeners for that event
 *  someElement.clearEventListeners([name]) - remove all event listeners, if name is set only remove listeners for that event
 * Doc:
 *  https://gist.github.com/cmbaughman/61ad5b49f10832e07b21993a20b94d8a
 */
function getEventListenersPolyfill() {
  if (!Element.prototype.hasOwnProperty('getEventListeners') && !Element.prototype.hasOwnProperty('clearEventListeners')) {
    Element.prototype._addEventListener = Element.prototype.addEventListener;
    Element.prototype.addEventListener = function (a, b, c) {
      if (c == undefined) c = false;
      this._addEventListener(a, b, c);
      if (!this.eventListenerList) this.eventListenerList = {};
      if (!this.eventListenerList[a]) this.eventListenerList[a] = [];
      //this.removeEventListener(a,b,c); // TODO - handle duplicates..
      this.eventListenerList[a].push({
        listener: b,
        useCapture: c
      });
    };
    Element.prototype.getEventListeners = function (a) {
      if (!this.eventListenerList) this.eventListenerList = {};
      if (a == undefined) return this.eventListenerList;
      return this.eventListenerList[a];
    };
    Element.prototype.clearEventListeners = function (a) {
      if (!this.eventListenerList) this.eventListenerList = {};
      if (a == undefined) {
        for (var x in this.getEventListeners()) this.clearEventListeners(x);
        return;
      }
      var el = this.getEventListeners(a);
      if (el == undefined) return;
      for (var i = el.length - 1; i >= 0; --i) {
        var ev = el[i];
        this.removeEventListener(a, ev.listener, ev.useCapture);
      }
    };
    Element.prototype._removeEventListener = Element.prototype.removeEventListener;
    Element.prototype.removeEventListener = function (a, b, c) {
      if (c == undefined) c = false;
      this._removeEventListener(a, b, c);
      if (!this.eventListenerList) this.eventListenerList = {};
      if (!this.eventListenerList[a]) this.eventListenerList[a] = [];

      // Find the event in the list
      for (var i = 0; i < this.eventListenerList[a].length; i++) {
        if (this.eventListenerList[a][i].useCapture == c) {
          // Hmm..
          this.eventListenerList[a].splice(i, 1);
          break;
        }
      }
      if (this.eventListenerList[a].length == 0) delete this.eventListenerList[a];
    };
  }
}

/*eslint-disable*/
(function () {

  var FE = FroalaEditor;
  FE.DefineIcon('numGroup', {
    NAME: 'numGroup',
    PATH: 'M7.795,2.523l0,1.458l-3.887,0l0,16.038l3.887,0l0,1.458l-4.616,0c-0.403,0 -0.729,-0.326 -0.729,-0.729l0,-17.496c0,-0.403 0.326,-0.729 0.729,-0.729l4.616,0Zm8.748,0l4.278,0c0.403,0 0.729,0.326 0.729,0.729l0,17.496c0,0.403 -0.326,0.729 -0.729,0.729l-4.278,0l0,-1.458l3.549,0l0,-16.038l-3.549,0l0,-1.458Zm-4.543,7.804l4.601,-4.601l1.673,1.673l-4.601,4.601l4.601,4.601l-1.673,1.673l-4.601,-4.601l-4.601,4.601l-1.673,-1.673l4.601,-4.601l-4.601,-4.601l1.673,-1.673l4.601,4.601Z '
  });
  FE.RegisterCommand('numGroup', {
    title: 'Number Group',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function callback() {
      var cleanNode = function cleanNode(n) {
        n.innerText.length === 0 && n.parentNode.removeChild(n);
      };
      this.format.toggle('span', {
        class: 'no-break'
      });
      this.el.querySelectorAll('.fr-class-no-break').forEach(cleanNode);
    }
  });
})();

(function addMintTooltipPlugin() {
  console.log('Plugin MintTooltip being registered'); // Debug log inicial
  // Definir la plantilla del popup
  FroalaEditor.POPUP_TEMPLATES['mintTooltip.popup'] = '[_BUTTONS_][_CUSTOM_LAYER_]';
  FroalaEditor.POPUP_TEMPLATES['mintTooltip.edit'] = '[_BUTTONS_]';
  // Definir el icono personalizado
  FroalaEditor.DefineIcon('mintTooltipIcon', {
    NAME: 'mintTooltipIcon',
    PATH: 'M19.5234 4H5.52344C4.993 4 4.4843 4.21071 4.10922 4.58579C3.73415 4.96086 3.52344 5.46957 3.52344 6V16C3.52344 16.5304 3.73415 17.0391 4.10922 17.4142C4.4843 17.7893 4.993 18 5.52344 18H8.69544C9.22583 18.0001 9.73445 18.2109 10.1094 18.586L11.8164 20.293C12.004 20.4805 12.2583 20.5858 12.5234 20.5858C12.7886 20.5858 13.0429 20.4805 13.2304 20.293L14.9374 18.586C15.3124 18.2109 15.821 18.0001 16.3514 18H19.5234C20.0539 18 20.5626 17.7893 20.9377 17.4142C21.3127 17.0391 21.5234 16.5304 21.5234 16V6C21.5234 5.46957 21.3127 4.96086 20.9377 4.58579C20.5626 4.21071 20.0539 4 19.5234 4Z'
  });
  // Definir botones del popup de edición
  Object.assign(FroalaEditor.DEFAULTS, {
    mintTooltipEditButtons: ['mintTooltipEdit', '|', 'mintTooltipRemove']
  });
  // Registrar el comando
  FroalaEditor.RegisterCommand('mintTooltip', {
    title: i18nMint.t('tooltip_add_or_edit', {
      ns: 'editor'
    }),
    icon: 'mintTooltipIcon',
    undo: true,
    focus: true,
    popup: true,
    plugin: 'mintTooltip',
    callback: function callback() {
      if (!this.popups.isVisible('mintTooltip.popup')) {
        this.mintTooltip.showPopup();
      } else {
        if (this.mintTooltip.isVisible()) {
          this.mintTooltip.hide();
        }
      }
    }
  });
  // Definir el plugin
  FroalaEditor.PLUGINS.mintTooltip = function (editor) {
    var $ = editor.$;
    var savedSelection = null;
    var currentElement = null;
    function _init() {
      // Asegurarnos de que las opciones existan
      editor.opts.mintTooltipOptions = editor.opts.mintTooltipOptions || {
        getTooltips: function getTooltips() {
          return [];
        },
        onChangeTooltips: null
      };
      editor.events.$on(editor.$el, 'click touchend', 'span.fr-mintTooltip-text', touchEndElement);
    }
    function initPopup() {
      // Crear el popup si no existe
      if (!editor.popups.get('mintTooltip.popup')) {
        var popup_buttons = '';
        // Contenido del popup
        var tooltip_layer = '<div class="fr-mintTooltip-popup fr-layer fr-active">' + '<div class="fr-mintTooltip-input-line">' + '<div class="fr-mintTooltip-textarea-wrapper">' + ("<textarea maxlength=\"240\" rows=\"4\" placeholder=\"" + i18nMint.t('tooltip_placeholder', {
          ns: 'editor'
        }) + "\" tabIndex=\"1\" class=\"fr-mintTooltip-input\"></textarea>") + ("<div class=\"fr-character-counter\"><span class=\"fr-current-chars\">0</span> " + i18nMint.t('tooltip_char_counter', {
          ns: 'editor'
        }) + "</div>") + '</div>' + '</div>' + '<div class="fr-action-buttons">' + ("<button class=\"fr-command fr-cancel\" data-cmd=\"mintTooltipCancel\" tabIndex=\"3\">" + i18nMint.t('tooltip_cancel', {
          ns: 'editor'
        }) + "</button>") + ("<button class=\"fr-command fr-submit fr-mintTooltip-action-button\" data-cmd=\"mintTooltipInsert\" tabIndex=\"2\">" + i18nMint.t('tooltip_add', {
          ns: 'editor'
        }) + "</button>") + '</div>' + '</div>';
        var template = {
          buttons: popup_buttons,
          custom_layer: tooltip_layer
        };
        editor.popups.create('mintTooltip.popup', template);
        // Eventos para los botones y el contador de caracteres
        editor.events.on('popup.tab', function (e) {
          var popup = editor.popups.get('mintTooltip.popup');
          var $focused_item = $(popup).find('textarea:focus, button:focus').first();
          // Removemos la validación con Enter
          return true;
        }, true);
        // Evento para actualizar el contador de caracteres
        $(document).on('input', '.fr-mintTooltip-input', function () {
          var currentLength = this.value.length;
          var popup = editor.popups.get('mintTooltip.popup');
          $(popup).find('.fr-current-chars').text(currentLength);
          $(popup).find('.fr-character-counter').html("<span class=\"fr-current-chars\">" + currentLength + "</span> " + i18nMint.t('tooltip_char_counter', {
            ns: 'editor'
          }));
          // Actualizar estado del botón submit
          var $submitButton = $(popup).find('button.fr-submit');
          if (currentLength > 0) {
            $submitButton.removeAttr('disabled');
          } else {
            $submitButton.attr('disabled', 'disabled');
          }
          // Limitar a 240 caracteres
          if (currentLength > 240) {
            this.value = this.value.substring(0, 240);
          }
        });
        // Deshabilitar el botón submit inicialmente
        var popup = editor.popups.get('mintTooltip.popup');
        $(popup).find('button.fr-submit').attr('disabled', 'disabled');
      }
    }
    function showPopup() {
      initPopup();
      // Guardar la selección actual antes de mostrar el popup
      savedSelection = editor.selection.get();
      var element = editor.selection.element();
      editor.popups.setContainer('mintTooltip.popup', editor.$tb);
      var $btn = editor.$tb.find('.fr-command[data-cmd="mintTooltip"]');
      var popup = editor.popups.get('mintTooltip.popup');
      // Limpiar el textarea y el contador antes de mostrar el popup
      var $textarea = $(popup).find('.fr-mintTooltip-input');
      $textarea.val('');
      $(popup).find('.fr-current-chars').text('0');
      $(popup).find('.fr-character-counter').html("<span class=\"fr-current-chars\">0</span> " + i18nMint.t('tooltip_char_counter', {
        ns: 'editor'
      }));
      $(popup).find('button.fr-submit').attr('disabled', 'disabled');
      // Asegurarnos de que el botón muestre "Añadir" y tenga el comando correcto
      var buttonAction = $(popup).find('.fr-mintTooltip-action-button');
      buttonAction.text(i18nMint.t('tooltip_add', {
        ns: 'editor'
      }));
      buttonAction.data('cmd', 'mintTooltipInsert');
      var left = $btn.offset().left;
      var top = $btn.offset().top + $btn.outerHeight();
      // Mostrar el popup
      editor.popups.show('mintTooltip.popup', left, top, $btn.outerHeight());
      // Verificar si el elemento actual es o contiene un tooltip
      var tooltipElement = null;
      if ($(element).is('span.fr-mintTooltip-text')) {
        tooltipElement = element;
      } else {
        var $tooltipParent = $(element).closest('span.fr-mintTooltip-text');
        if ($tooltipParent.length) {
          tooltipElement = $tooltipParent[0];
        }
      }
      // Si encontramos un tooltip, mostrar su texto y cambiar el botón a "Update"
      if (tooltipElement) {
        var _editor$opts$mintTool, _currentTooltip$conte;
        var tooltipGuid = $(tooltipElement).attr('data-tooltip-guid');
        var currentTooltips = ((_editor$opts$mintTool = editor.opts.mintTooltipOptions) == null ? void 0 : _editor$opts$mintTool.getTooltips()) || [];
        var currentTooltip = currentTooltips.find(function (t) {
          return t.guid === tooltipGuid;
        });
        // Muestro el primer contenido del tooltip si es de tipo texto
        if (currentTooltip && ((_currentTooltip$conte = currentTooltip.contents) == null ? void 0 : _currentTooltip$conte.length) > 0 && currentTooltip.contents[0].type === ITooltipContentType.TEXT) {
          var contentText = currentTooltip.contents[0].text || '';
          $(popup).find('.fr-mintTooltip-input').val(contentText);
          $(popup).find('.fr-current-chars').text(contentText.length);
          $(popup).find('.fr-character-counter').html("<span class=\"fr-current-chars\">" + contentText.length + "</span> " + i18nMint.t('tooltip_char_counter', {
            ns: 'editor'
          }));
          $(popup).find('button.fr-submit').removeAttr('disabled');
          // Si es un tooltip existente, cambiar el botón a "Update"
          buttonAction.text(i18nMint.t('tooltip_update', {
            ns: 'editor'
          }));
          buttonAction.data('cmd', 'mintTooltipUpdate');
        }
      }
      // Focus en el textarea
      $(popup).find('.fr-mintTooltip-input').focus();
    }
    function hidePopup() {
      var _currentElement;
      editor.popups.hide('mintTooltip.popup');
      savedSelection = null; // Limpiar la selección guardada
      // Limpiar el textarea
      var popup = editor.popups.get('mintTooltip.popup');
      if (popup) {
        $(popup).find('.fr-mintTooltip-input').val('');
      }
      // Ocultar la barra de herramientas flotante
      editor.selection.clear();
      editor.toolbar.hide();
      editor.popups.hideAll();
      (_currentElement = currentElement) == null || _currentElement.removeClass('fr-mintTooltip-text--active');
      currentElement = null;
    }
    function insert() {
      var popup = editor.popups.get('mintTooltip.popup');
      var tooltip_text = $(popup).find('.fr-mintTooltip-input').val();
      if (tooltip_text) {
        // Restaurar la selección guardada si existe
        if (savedSelection) {
          editor.selection.restore();
        }
        var tooltipElement = null;
        var element = editor.selection.element();
        // Verificar si estamos editando un tooltip existente
        if (currentElement) {
          tooltipElement = currentElement;
        } else if ($(element).is('span.fr-mintTooltip-text')) {
          tooltipElement = element;
        } else {
          var $tooltipParent = $(element).closest('span.fr-mintTooltip-text');
          if ($tooltipParent.length) {
            tooltipElement = $tooltipParent[0];
          }
        }
        // Actualizar o crear tooltip
        if (tooltipElement) {
          var _editor$opts$mintTool2, _editor$opts$mintTool3;
          // Actualizar tooltip existente
          var tooltipGuid = $(tooltipElement).attr('data-tooltip-guid');
          var currentTooltips = ((_editor$opts$mintTool2 = editor.opts.mintTooltipOptions) == null ? void 0 : _editor$opts$mintTool2.getTooltips()) || [];
          var updatedTooltips = currentTooltips.map(function (t) {
            return t.guid === tooltipGuid ? _extends({}, t, {
              contents: [{
                type: ITooltipContentType.TEXT,
                text: tooltip_text
              }]
            }) : t;
          });
          (_editor$opts$mintTool3 = editor.opts.mintTooltipOptions) == null || _editor$opts$mintTool3.onChangeTooltips(updatedTooltips);
        } else {
          // Crear nuevo tooltip
          var selectionText = editor.selection.text();
          if (selectionText) {
            var _editor$opts$mintTool4, _editor$opts$mintTool5;
            var newGuid = getGuid();
            var _currentTooltips = ((_editor$opts$mintTool4 = editor.opts.mintTooltipOptions) == null ? void 0 : _editor$opts$mintTool4.getTooltips()) || [];
            // Obtener el rango de selección actual
            var range = editor.selection.ranges(0);
            var $selectionContainer = $(range.commonAncestorContainer);
            // Buscar tooltips existentes dentro de la selección
            var existingTooltips = $selectionContainer.find('span.fr-mintTooltip-text').toArray();
            // Crear el nuevo tooltip
            var newTooltip = {
              guid: newGuid,
              contents: [{
                type: ITooltipContentType.TEXT,
                text: tooltip_text
              }]
            };
            // Actualizar la lista de tooltips
            (_editor$opts$mintTool5 = editor.opts.mintTooltipOptions) == null || _editor$opts$mintTool5.onChangeTooltips([].concat(_currentTooltips, [newTooltip]));
            if (existingTooltips.length > 0) {
              // Si hay tooltips existentes, preservarlos
              var $temp = $('<div>');
              // Clonar el contenido seleccionado manteniendo la estructura
              var clonedContent = range.cloneContents();
              $temp.append(clonedContent);
              // Insertar el nuevo tooltip con el contenido clonado
              editor.html.insert("<span class=\"fr-mintTooltip-text\" data-tooltip-guid=\"" + newGuid + "\">" + $temp.html() + "</span>");
            } else {
              // Si no hay tooltips existentes, insertar normalmente
              editor.html.insert("<span class=\"fr-mintTooltip-text\" data-tooltip-guid=\"" + newGuid + "\">" + selectionText + "</span>");
            }
          }
        }
      }
      hidePopup();
      currentElement = null;
    }
    function getEditButtons() {
      var e = '';
      if (editor.opts.mintTooltipEditButtons.length > 0) {
        e += '<div class="fr-buttons">\n      '.concat(editor.button.buildList(editor.opts.mintTooltipEditButtons), '\n      </div>');
        var popup = editor.popups.create('mintTooltip.edit', {
          buttons: e
        });
        editor.events.$on(editor.$wp, 'scroll.mintTooltip-edit', function () {
          currentElement && editor.popups.isVisible('mintTooltip.edit') && editor.events.disableBlur() && showPopupElement();
        });
        // Añadir evento para limpiar la clase --active cuando se oculta el popup
        $(document).on('click', function (e) {
          function clearActiveTooltip() {
            if (currentElement) {
              currentElement.removeClass('fr-mintTooltip-text--active');
              currentElement = null;
            }
          }
          // Convertir el elemento clickeado a un objeto jQuery para poder usar sus métodos
          var $target = $(e.target);
          // Verificar si el click fue dentro del popup o dentro de un tooltip
          // closest() busca el elemento padre más cercano que coincida con los selectores
          // Si length > 0 significa que encontró un elemento padre que coincide
          var isTooltipOrPopup = $target.closest('.fr-mintTooltip-text, .fr-popup').length > 0;
          if (!isTooltipOrPopup) {
            clearActiveTooltip();
          }
        });
        return popup;
      }
      return false;
    }
    function touchEndElement() {
      // Limpiar el tooltip anterior si existe
      if (currentElement && currentElement[0] !== this) {
        currentElement.removeClass('fr-mintTooltip-text--active');
      }
      // Activar el nuevo tooltip
      currentElement = $(this);
      showPopupElement();
    }
    function showPopupElement() {
      if (!currentElement) return;
      var popup = editor.popups.get('mintTooltip.edit');
      if (popup || (popup = getEditButtons()), popup) {
        editor.popups.setContainer('mintTooltip.edit', editor.$sc);
        editor.popups.refresh('mintTooltip.edit');
        var left = currentElement.offset().left + currentElement.outerWidth() / 2,
          top = currentElement.offset().top + currentElement.outerHeight();
        editor.popups.show('mintTooltip.edit', left, top, currentElement.outerHeight());
        currentElement.addClass('fr-mintTooltip-text--active');
      }
    }
    function remove() {
      if (currentElement) {
        // Obtener el guid del tooltip actual
        var tooltipGuid = currentElement.attr('data-tooltip-guid');
        if (tooltipGuid) {
          var _editor$opts$mintTool6, _editor$opts$mintTool7;
          // Obtener el contenido HTML actual
          var currentHtml = currentElement.html();
          // Crear un elemento temporal para manipular el HTML
          var $temp = $('<div>').append(currentHtml);
          // Encontrar todos los spans con el mismo GUID dentro del elemento temporal
          var $tooltips = $temp.find(".fr-mintTooltip-text[data-tooltip-guid=\"" + tooltipGuid + "\"]");
          // Reemplazar cada span con su texto contenido
          $tooltips.each(function () {
            $(this).replaceWith($(this).text());
          });
          // Si el elemento actual tiene el GUID, reemplazarlo con el HTML procesado
          if (currentElement.attr('data-tooltip-guid') === tooltipGuid) {
            currentElement.replaceWith($temp.html());
          } else {
            // Si no, actualizar su contenido
            currentElement.html($temp.html());
          }
          editor.events.focus(true);
          editor.selection.restore();
          editor.undo.saveStep();
          editor.popups.hideAll();
          // Actualizar tooltips - eliminar el tooltip de la lista
          var currentTooltips = ((_editor$opts$mintTool6 = editor.opts.mintTooltipOptions) == null ? void 0 : _editor$opts$mintTool6.getTooltips()) || [];
          var updatedTooltips = currentTooltips.filter(function (t) {
            return t.guid !== tooltipGuid;
          });
          (_editor$opts$mintTool7 = editor.opts.mintTooltipOptions) == null || _editor$opts$mintTool7.onChangeTooltips(updatedTooltips);
          // Limpiar la referencia al elemento actual
          currentElement = null;
        }
      }
    }
    function edit() {
      if (currentElement) {
        var _editor$opts$mintTool8, _currentTooltip$conte2;
        var tooltipGuid = currentElement.attr('data-tooltip-guid');
        var currentTooltips = ((_editor$opts$mintTool8 = editor.opts.mintTooltipOptions) == null ? void 0 : _editor$opts$mintTool8.getTooltips()) || [];
        var currentTooltip = currentTooltips.find(function (t) {
          return t.guid === tooltipGuid;
        });
        var left = currentElement.offset().left + currentElement.outerWidth() / 2,
          top = currentElement.offset().top + currentElement.outerHeight();
        // Asegurarnos de que el popup esté inicializado
        initPopup();
        var $popup = editor.popups.get('mintTooltip.popup');
        if (!$popup) {
          console.error('No se pudo inicializar el popup');
          return;
        }
        editor.popups.setContainer('mintTooltip.popup', editor.$sc);
        editor.popups.refresh('mintTooltip.popup');
        editor.popups.show('mintTooltip.popup', left, top, currentElement.outerHeight());
        currentElement.addClass('fr-mintTooltip-text--active');
        var $textarea = $($popup).find('.fr-mintTooltip-input');
        if (currentTooltip && ((_currentTooltip$conte2 = currentTooltip.contents) == null ? void 0 : _currentTooltip$conte2.length) > 0 && currentTooltip.contents[0].type === ITooltipContentType.TEXT) {
          var _currentTooltip$conte3;
          $textarea.val(currentTooltip.contents[0].text || '');
          $($popup).find('.fr-current-chars').text(((_currentTooltip$conte3 = currentTooltip.contents[0].text) == null ? void 0 : _currentTooltip$conte3.length) || 0);
          $($popup).find('button.fr-submit').removeAttr('disabled');
        }
        var buttonAction = $($popup).find('.fr-mintTooltip-action-button');
        if (buttonAction.length) {
          buttonAction.text(i18nMint.t('tooltip_update', {
            ns: 'editor'
          }));
          buttonAction.data('cmd', 'mintTooltipUpdate');
        }
      }
    }
    // Añadir hook para limpiar las clases --active antes de guardar
    editor.events.on('html.processGet', function (e) {
      if (e.innerHTML) {
        e.innerHTML = removeActiveClasses(e.innerHTML);
      }
    });
    function removeActiveClasses(html) {
      // Buscar todos los elementos con la clase --active
      return html.replace(/class="([^"]*?)fr-mintTooltip-text--active([^"]*?)"/g, function (match, beforeClasses, afterClasses) {
        // Combinar las clases antes y después de --active
        var remainingClasses = (beforeClasses + afterClasses).trim();
        // Si quedan clases, mantenerlas, si no, eliminar el atributo class
        return remainingClasses ? "class=\"" + remainingClasses + "\"" : '';
      });
    }
    return {
      _init: _init,
      showPopup: showPopup,
      hidePopup: hidePopup,
      insert: insert,
      remove: remove,
      edit: edit,
      isVisible: function isVisible() {
        return editor.popups.isVisible('mintTooltip.popup');
      },
      hide: hidePopup
    };
  };
  // Registrar los comandos de los botones
  FroalaEditor.RegisterCommand('mintTooltipInsert', {
    title: i18nMint.t('tooltip_add', {
      ns: 'editor'
    }),
    undo: true,
    focus: true,
    callback: function callback() {
      this.mintTooltip.insert();
    }
  });
  FroalaEditor.RegisterCommand('mintTooltipUpdate', {
    title: i18nMint.t('tooltip_update', {
      ns: 'editor'
    }),
    undo: true,
    focus: true,
    callback: function callback() {
      this.mintTooltip.insert();
    }
  });
  FroalaEditor.RegisterCommand('mintTooltipCancel', {
    title: i18nMint.t('tooltip_cancel', {
      ns: 'editor'
    }),
    undo: false,
    focus: false,
    callback: function callback() {
      this.mintTooltip.hidePopup();
    }
  });
  // Registrar los comandos de edición y eliminación
  FroalaEditor.DefineIcon('mintTooltipRemove', {
    NAME: 'trash',
    SVG_KEY: 'remove'
  });
  FroalaEditor.RegisterCommand('mintTooltipRemove', {
    title: i18nMint.t('tooltip_remove', {
      ns: 'editor'
    }),
    undo: false,
    callback: function callback() {
      this.mintTooltip.remove();
    }
  });
  FroalaEditor.DefineIcon('mintTooltipEdit', {
    NAME: 'edit',
    SVG_KEY: 'edit'
  });
  FroalaEditor.RegisterCommand('mintTooltipEdit', {
    title: i18nMint.t('tooltip_edit', {
      ns: 'editor'
    }),
    undo: false,
    callback: function callback() {
      this.mintTooltip.edit();
    }
  });
})();

(function () {
  var FE = FroalaEditor;
  // FE = FE && FE.hasOwnProperty('default') ? FE['default'] : FE;

  /**
   * Catalán
   */
  FE.LANGUAGE['ca'] = {
    translation: {
      // Place holder
      'Type something': 'Escriu alguna cosa',
      // Basic formatting
      Bold: 'Negreta',
      Italic: 'Itàlica',
      Underline: 'Subratllat',
      Strikethrough: 'Ratllat',
      // Main buttons
      Insert: 'Afegeix',
      Delete: 'Esborra',
      Cancel: 'Cancel·la',
      OK: 'Ok',
      Back: 'Enrere',
      Remove: 'Elimina',
      More: 'Més',
      Update: 'Actualització',
      Style: 'Estil',
      // Font
      'Font Family': 'Família de fonts',
      'Font Size': 'Mida de font',
      // Colors
      Colors: 'Colors',
      Background: 'Fons',
      Text: 'Text',
      'HEX Color': 'Color hexadecimal',
      // Paragraphs
      'Paragraph Format': 'Format de paràgraf',
      Normal: 'Normal',
      Code: 'Codi',
      'Heading 1': 'Encapçalament 1',
      'Heading 2': 'Encapçalament 2',
      'Heading 3': 'Encapçalament 3',
      'Heading 4': 'Encapçalament 4',
      // Style
      'Paragraph Style': 'Estil de paràgraf',
      'Inline Style': 'Estil en línia',
      // Alignment
      Align: 'Alinea',
      'Align Left': 'Alinea a l’esquerra',
      'Align Center': 'Alinea al centre',
      'Align Right': 'Alinea a la dreta',
      'Align Justify': 'Justifica',
      None: 'Cap',
      // Lists
      'Ordered List': 'Llista ordenada',
      'Unordered List': 'Llista desordenada',
      // Indent
      'Decrease Indent': 'Redueix el sagnat',
      'Increase Indent': 'Augmenta el sagnat',
      // Links
      'Insert Link': 'Afegeix enllaç',
      'Open in new tab': 'Obre en una pestanya nova',
      'Open Link': 'Obre l’enllaç',
      'Edit Link': 'Edita l’enllaç',
      Unlink: 'Elimina l’enllaç',
      'Choose Link': 'Tria l’enllaç',
      // Images
      'Insert Image': 'Afegeix una imatge',
      'Upload Image': 'Carrega una imatge',
      'By URL': 'Per URL',
      Browse: 'Examina',
      'Drop image': 'Deixa anar la imatge',
      'or click': 'o fes clic a',
      'Manage Images': 'Administra imatges',
      Loading: 'S’està carregant',
      Deleting: 'S’està suprimint',
      Tags: 'Etiquetes',
      'Are you sure? Image will be deleted.': 'N’estàs segur? La imatge se suprimirà.',
      Replace: 'Canvia',
      Uploading: 'S’està pujant',
      'Loading image': 'S’està carregant la imatge',
      Display: 'Visualitza',
      Inline: 'En línia',
      'Break Text': 'Salta el text',
      'Alternative Text': 'Text alternatiu',
      'Change Size': 'Canvia la mida',
      Width: 'Amplada',
      Height: 'Alçària',
      'Something went wrong. Please try again.': 'Alguna cosa no ha anat bé. Si us plau, torna-ho a provar.',
      'Image Caption': 'Captura d’imatge',
      'Advanced Edit': 'Edició avançada',
      // Video
      'Insert Video': 'Afegeix vídeo',
      'Embedded Code': 'Codi incrustat',
      'Drop video': 'Deixa anar el vídeo',
      'Your browser does not support HTML5 video.': 'El teu navegador no és compatible amb vídeo html5.',
      'Upload Video': 'Puja un vídeo',
      // Tables
      'Insert Table': 'Afegeix una taula',
      'Table Header': 'Capçalera de la taula',
      'Remove Table': 'Elimina la taula',
      'Table Style': 'Estil de taula',
      'Horizontal Align': 'Alineació horitzontal',
      Row: 'Fila',
      'Insert row above': 'Afegeix fila abans',
      'Insert row below': 'Afegeix fila després',
      'Delete row': 'Elimina fila',
      Column: 'Columna',
      'Insert column before': 'Afegeix columna abans',
      'Insert column after': 'Afegeix columna després',
      'Delete column': 'Elimina columna',
      Cell: 'Cel·la',
      'Merge cells': 'Combina cel·les',
      'Horizontal split': 'Divisió horitzontal',
      'Vertical split': 'Divisió vertical',
      'Cell Background': 'Fons de la cel·la',
      'Vertical Align': 'Alineació vertical',
      Top: 'Part superior',
      Middle: 'Centre',
      Bottom: 'Part inferior',
      'Align Top': 'Alineació superior',
      'Align Middle': 'Alineació central',
      'Align Bottom': 'Alineació inferior',
      'Cell Style': 'Estil de cel·la',
      // Files
      'Upload File': 'Carrega un fitxer',
      'Drop file': 'Deixa anar el fitxer',
      // Emoticons
      Emoticons: 'Emoticones',
      'Grinning face': 'Cara somrient',
      'Grinning face with smiling eyes': 'Cara somrient amb ulls somrients',
      'Face with tears of joy': 'Cara amb llàgrimes d’alegria',
      'Smiling face with open mouth': 'Cara somrient amb la boca oberta',
      'Smiling face with open mouth and smiling eyes': 'Cara somrient amb la boca oberta i els ulls somrients',
      'Smiling face with open mouth and cold sweat': 'Cara somrient amb la boca oberta i suor freda',
      'Smiling face with open mouth and tightly-closed eyes': 'Cara somrient amb la boca oberta i els ulls tancats fent força',
      'Smiling face with halo': 'Cara somrient amb halo',
      'Smiling face with horns': 'Cara somrient amb banyes',
      'Winking face': 'Cara que fa l’ullet',
      'Smiling face with smiling eyes': 'Cara somrient amb ulls somrients',
      'Face savoring delicious food': 'Cara d’assaborir un menjar deliciós',
      'Relieved face': 'Cara d’alleujament',
      'Smiling face with heart-shaped eyes': 'Cara somrient amb els ulls en forma de cor',
      'Smiling face with sunglasses': 'Cara somrient amb ulleres de sol',
      'Smirking face': 'Cara amb somriure de satisfacció',
      'Neutral face': 'Cara neutra',
      'Expressionless face': 'Cara inexpressiva',
      'Unamused face': 'Cara avorrida',
      'Face with cold sweat': 'Cara amb suor freda',
      'Pensive face': 'Cara pensativa',
      'Confused face': 'Cara confusa',
      'Confounded face': 'Cara desconcertada',
      'Kissing face': 'Cara que fa un petó',
      'Face throwing a kiss': 'Cara que llança un petó',
      'Kissing face with smiling eyes': 'Cara fent un petó amb ulls somrients',
      'Kissing face with closed eyes': 'Cara fent un petó amb els ulls tancats',
      'Face with stuck out tongue': 'Cara amb la llengua fora',
      'Face with stuck out tongue and winking eye': 'Cara amb la llengua fora i fent l’ullet',
      'Face with stuck out tongue and tightly-closed eyes': 'Cara amb la llengua fora i els ulls tancats fent força',
      'Disappointed face': 'Cara de decepció',
      'Worried face': 'Cara de preocupació',
      'Angry face': 'Cara enfadada',
      'Pouting face': 'Cara que fa el petarrell',
      'Crying face': 'Cara plorant',
      'Persevering face': 'Cara de perseverança',
      'Face with look of triumph': 'Cara amb expressió de triomf',
      'Disappointed but relieved face': 'Cara decebuda, però alleujada',
      'Frowning face with open mouth': 'Cara amb la boca oberta i les celles arrufades',
      'Anguished face': 'Cara angoixada',
      'Fearful face': 'Cara esporuguida',
      'Weary face': 'Cara esgotada',
      'Sleepy face': 'Cara somnolent',
      'Tired face': 'Cara cansada',
      'Grimacing face': 'Cara fent una ganyota',
      'Loudly crying face': 'Cara plorant en veu alta',
      'Face with open mouth': 'Cara amb la boca oberta',
      'Hushed face': 'Cara callada',
      'Face with open mouth and cold sweat': 'Cara amb la boca oberta i suor freda',
      'Face screaming in fear': 'Cara cridant de por',
      'Astonished face': 'Cara de sorpresa',
      'Flushed face': 'Cara enrojolada',
      'Sleeping face': 'Cara adormida',
      'Dizzy face': 'Cara marejada',
      'Face without mouth': 'Cara sense boca',
      'Face with medical mask': 'Cara amb mascareta mèdica',
      // Line breaker
      Break: 'Salta',
      // Math
      Subscript: 'Subíndex',
      Superscript: 'Superíndex',
      // Full screen
      Fullscreen: 'Pantalla completa',
      // Horizontal line
      'Insert Horizontal Line': 'Afegeix línia horitzontal',
      // Clear formatting
      'Clear Formatting': 'Elimina el format',
      // Undo, redo
      Undo: 'Desfés',
      Redo: 'Refés',
      // Select all
      'Select All': 'Selecciona-ho tot',
      // Code view
      'Code View': 'Vista de codi',
      // Quote
      Quote: 'Citació',
      Increase: 'Augmenta',
      Decrease: 'Redueix',
      // Quick Insert
      'Quick Insert': 'Inserció ràpida',
      // Spcial Characters
      'Special Characters': 'Caràcters especials',
      Latin: 'Llatí',
      Greek: 'Grec',
      Cyrillic: 'Ciríl·lic',
      Punctuation: 'Puntuació',
      Currency: 'Moneda',
      Arrows: 'Fletxes',
      Math: 'Mates',
      Misc: 'Miscel·lània',
      // Print.
      Print: 'Impressió',
      // Spell Checker.
      'Spell Checker': 'Corrector ortogràfic',
      // Help
      Help: 'Ajuda',
      Shortcuts: 'Dreceres',
      'Inline Editor': 'Editor en línia',
      'Show the editor': 'Mostra l’editor',
      'Common actions': 'Accions comunes',
      Copy: 'Copia',
      Cut: 'Retalla',
      Paste: 'Enganxa',
      'Basic Formatting': 'Format bàsic',
      'Increase quote level': 'Augmenta el nivell de citació',
      'Decrease quote level': 'Redueix el nivell de citació',
      'Image / Video': 'Imatge / vídeo',
      'Resize larger': 'Fes més gran',
      'Resize smaller': 'Fes més petit',
      Table: 'Taula',
      'Select table cell': 'Selecciona una celdla',
      'Extend selection one cell': 'Amplia la selecció una cel·la',
      'Extend selection one row': 'Amplia la selecció una fila',
      Navigation: 'Navegació',
      'Focus popup / toolbar': 'Focus emergent / barra d’eines',
      'Return focus to previous position': 'Fes tornar el focus a la posició anterior',
      // Embed.ly
      'Embed URL': 'Incrusta URL',
      'Paste in a URL to embed': 'Enganxa un url per incrustar',
      // Word Paste.
      'The pasted content is coming from a Microsoft Word document. Do you want to keep the format or clean it up?': 'El contingut enganxat ve d’un document de Microsoft Word. Vols mantenir-ne el format?',
      Keep: 'Desa',
      Clean: 'Suprimeix',
      'Word Paste Detected': 'Paraula detectada',
      'Dashed Borders': 'Vores discontínues',
      'Alternate Rows': 'Files alternes',
      Highlighted: 'Ressaltada',
      Thick: 'Gruixuda',
      'Paste the URL of the video you want to insert.': 'Enganxa URL del vídeo que vols afegir. Compatible: Vimeo i Youtube.',
      'Paste in a video URL': 'URL del vídeo (Vimeo o Youtube).',
      'Number Group': 'No trencar',
      'More Text': 'Més text',
      'Text Color': 'Color de text',
      'Background Color': 'Color de fons',
      'More Paragraph': 'Més paràgraf',
      'More Rich': 'Més opcions',
      'More Misc': 'Més opcions',
      'Add blank': 'Afegeix buit',
      'Insert math expresion': 'Insereix expressió matemàtica',
      'Font size': 'Grandària de text',
      Default: 'Per defecte',
      'Lower Alpha': 'Alpha en minúscula',
      'Lower Greek': 'Gregas en minúscula',
      'Lower Roman': 'Romanes en minúscula',
      'Upper Alpha': 'Alpha majúscules',
      'Upper Roman': 'Romanes majúscules',
      Circle: 'Cercle',
      Square: 'Quadrat',
      Disc: 'Disc',
      'With Borders': 'Amb vores',
      'Insert Audio': 'Inserir àudio',
      'Upload Audio': 'Subir àudio',
      'Only icon play/stop': 'Només icona reproducir/parar',
      'Drop audio': 'Soltar àudio',
      'Paste in an audio URL': "Pegar una URL d'àudio"
    },
    direction: 'ltr'
  };
})();

(function () {
  var FE = FroalaEditor;
  // FE = FE && FE.hasOwnProperty('default') ? FE['default'] : FE;

  /**
   * Spanish
   */
  if (FE && FE.LANGUAGE && FE.LANGUAGE.es) {
    FE.LANGUAGE.es.translation['Type something'] = 'Escribir aquí';
    FE.LANGUAGE.es.translation.Default = 'Por defecto';
    FE.LANGUAGE.es.translation.Circle = 'Círculo';
    FE.LANGUAGE.es.translation.Disc = 'Disco';
    FE.LANGUAGE.es.translation.OK = 'OK';
    FE.LANGUAGE.es.translation['Something went wrong. Please try again.'] = 'Ha habido un problema. Por favor, vuelve a intentarlo.';
    FE.LANGUAGE.es.translation['Insert Video'] = 'Insertar vídeo';
    FE.LANGUAGE.es.translation['Paste in a video URL'] = 'Pegar una URL de un vídeo';
    FE.LANGUAGE.es.translation['Drop video'] = 'Soltar vídeo';
    FE.LANGUAGE.es.translation['Your browser does not support HTML5 video.'] = 'Su navegador no es compatible con vídeos HTML5.';
    FE.LANGUAGE.es.translation['Upload Video'] = 'Subir vídeo';
    FE.LANGUAGE.es.translation['Remove Table'] = 'Borra la tabla';
    FE.LANGUAGE.es.translation['Relieved face'] = 'Cara aliviada';
    FE.LANGUAGE.es.translation.Math = 'Matemáticas';
    FE.LANGUAGE.es.translation.Misc = 'Miscelánea';
    FE.LANGUAGE.es.translation['Image / Video'] = 'Imagen / vídeo';
    FE.LANGUAGE.es.translation.Table = 'Tabla';
    FE.LANGUAGE.es.translation['Select table cell'] = 'Celda de tabla seleccionada';
    FE.LANGUAGE.es.translation['Focus popup / toolbar'] = 'Foco / barra de herramientas';
    FE.LANGUAGE.es.translation['Return focus to previous position'] = 'Volver el foco a la posición anterior';
    FE.LANGUAGE.es.translation['Embed URL'] = 'URL insertada';
    FE.LANGUAGE.es.translation['Paste in a URL to embed'] = 'Pegar una URL para insertar';
    FE.LANGUAGE.es.translation['Dashed Borders'] = 'Bordes discontinuos';
    FE.LANGUAGE.es.translation['Alternate Rows'] = 'Filas alternativas';
    FE.LANGUAGE.es.translation.Highlighted = 'Destacada';
    FE.LANGUAGE.es.translation.Thick = 'Gruesa';
    FE.LANGUAGE.es.translation['Paste the URL of the video you want to insert.'] = 'Pegar URL del vídeo que quieres insertar. Compatible: Vimeo y Youtube.';
    FE.LANGUAGE.es.translation['Paste in a video URL'] = 'URL del vídeo (Vimeo o Youtube).';
    FE.LANGUAGE.es.translation['Number Group'] = 'No romper';
    FE.LANGUAGE.es.translation['More Text'] = 'Más texto';
    FE.LANGUAGE.es.translation['Text Color'] = 'Color texto';
    FE.LANGUAGE.es.translation['Background Color'] = 'Color fondo';
    FE.LANGUAGE.es.translation['More Paragraph'] = 'Más párrafo';
    FE.LANGUAGE.es.translation['More Rich'] = 'Más opciones';
    FE.LANGUAGE.es.translation['More Misc'] = 'Más opciones';
    FE.LANGUAGE.es.translation['Insert math expresion'] = 'Insertar expresión matemática';
    FE.LANGUAGE.es.translation['With Borders'] = 'Con bordes';
  }
})();
// # sourceMappingURL=es.js.map

(function () {
  var FE = FroalaEditor;
  // FE = FE && FE.hasOwnProperty('default') ? FE['default'] : FE;

  /**
   * Euskera
   */
  FE.LANGUAGE.eu = {
    translation: {
      // Place holder
      'Type something': 'Idatzi zerbait',
      // Basic formatting
      Bold: 'Letra lodia',
      Italic: 'It\xE1lica',
      Underline: 'Azpimarratua',
      Strikethrough: 'Ezabatua',
      // Main buttons
      Insert: 'Txertatu',
      Delete: 'Ezabatu',
      Cancel: 'Utzi',
      OK: 'Ok',
      Back: 'Atzera',
      Remove: 'Kendu',
      More: 'Gehiago',
      Update: 'Eguneratu',
      Style: 'Estiloa',
      // Font
      'Font Family': 'Letra familia',
      'Font Size': 'Letraren neurria',
      // Colors
      Colors: 'Koloreak',
      Background: 'Atzealdea',
      Text: 'Testua',
      'HEX Color': 'Kolore hamaseitarra',
      // Paragraphs
      'Paragraph Format': 'Paragrafo formatua',
      Normal: 'Normala',
      Code: 'Kodea',
      'Heading 1': '1. goiburua',
      'Heading 2': '2. goiburua',
      'Heading 3': '3. goiburua',
      'Heading 4': '4. goiburua',
      'Line Height': 'Lerroartea',
      // Style
      'Paragraph Style': 'Paragrafo estiloa',
      'Inline Style': 'Lerro estiloa',
      // Alignment
      Align: 'Lerrokatu',
      'Align Left': 'Lerrokatu ezkerrean',
      'Align Center': 'Lerrokatu erdian',
      'Align Right': 'Lerrokatu eskuinean',
      'Align Justify': 'Justifikatu',
      None: 'Batere ez',
      // Lists
      'Ordered List': 'Zerrenda ordenatua',
      'Unordered List': 'Zerrenda desordenatua',
      // Indent
      'Decrease Indent': 'Txikitu koska',
      'Increase Indent': 'Handitu koska',
      // Links
      'Insert Link': 'Txertatu esteka',
      'Open in new tab': 'Ireki beste erlaitz batean',
      'Open Link': 'Ireki esteka',
      'Edit Link': 'Editatu esteka',
      Unlink: 'Kendu esteka',
      'Choose Link': 'Aukeratu esteka',
      // Images
      'Insert Image': 'Txertatu irudia',
      'Upload Image': 'Kargatu irudia',
      'By URL': 'URL bidez',
      Browse: 'Arakatu',
      'Drop image': 'Askatu irudia',
      'or click': 'edo egin klik hemen:',
      'Manage Images': 'Administratu irudiak',
      Loading: 'Kargatzen',
      Deleting: 'Ezabatu',
      Tags: 'Etiketak',
      'Are you sure? Image will be deleted.': 'Ziur zaude? Irudia ezabatu egingo da.',
      Replace: 'Ordeztu',
      Uploading: 'Kargatu',
      'Loading image': 'Irudia kargatzen',
      Display: 'Erakutsi',
      Inline: 'Lerroan',
      'Break Text': 'Testu jauzia',
      'Alternative Text': 'Testu alternatiboa',
      'Change Size': 'Aldatu neurria',
      Width: 'Zabalera',
      Height: 'Altuera',
      'Something went wrong. Please try again.': 'Zerbait gaizki atera da. Mesedez, saiatu berriz.',
      'Image Caption': 'Pantaila irudia',
      'Advanced Edit': 'Edizio aurreratua',
      // Video
      'Insert Video': 'Txertatu bideoa',
      'Embedded Code': 'Kodea txertatuta',
      'Drop video': 'Askatu bideoa',
      'Your browser does not support HTML5 video.': 'Zure nabigatzailea ez da bateragarria html5 bideoarekin.',
      'Upload Video': 'Igo bideoa',
      // Tables
      'Insert Table': 'Txertatu taula',
      'Table Header': 'Taularen goiburua',
      'Remove Table': 'Kendu taula',
      'Table Style': 'Taula estiloa',
      'Horizontal Align': 'Lerrokatze horizontala',
      Row: 'Fila',
      'Insert row above': 'Txertatu errenkada aurretik',
      'Insert row below': 'Txertatu errenkada ondoren',
      'Delete row': 'Ezabatu errenkada',
      Column: 'Zutabea',
      'Insert column before': 'Txertatu zutabea aurretik',
      'Insert column after': 'Txertatu errenkada ondoren',
      'Delete column': 'Ezabatu zutabea',
      Cell: 'Gelaxka',
      'Merge cells': 'Konbinatu gelaxkak',
      'Horizontal split': 'Zatiketa horizontala',
      'Vertical split': 'Zatiketa bertikala',
      'Cell Background': 'Gelaxkaren atzealdea',
      'Vertical Align': 'Lerrokatze bertikala',
      Top: 'Goi aldea',
      Middle: 'Erdi aldea',
      Bottom: 'Behe aldea',
      'Align Top': 'Lerrokatu goiko aldean',
      'Align Middle': 'Lerrokatu erdian',
      'Align Bottom': 'Lerrokatu behean',
      'Cell Style': 'Gelaxka estiloa',
      // Files
      'Upload File': 'Igo fitxategia',
      'Drop file': 'Askatu fitxategia',
      // Emoticons
      Emoticons: 'Emotikonoak',
      'Grinning face': 'Aurpegia irribarrez',
      'Grinning face with smiling eyes': 'Aurpegia irribarrez, begi irribarretsuekin',
      'Face with tears of joy': 'Aurpegia pozaren pozez malkotan',
      'Smiling face with open mouth': 'Aurpegi irribarretsua, ahoa irekita',
      'Smiling face with open mouth and smiling eyes': 'Aurpegi irribarretsua, ahoa irekita eta begi irribarretsuekin',
      'Smiling face with open mouth and cold sweat': 'Aurpegi irribarretsua, ahoa irekita eta izerdi hotzarekin',
      'Smiling face with open mouth and tightly-closed eyes': 'Aurpegi irribarretsua, ahoa irekita eta begiak indarrez itxita',
      'Smiling face with halo': 'Aurpegi irribarretsua, argi koroarekin',
      'Smiling face with horns': 'Aurpegi irribarretsua, adarrekin',
      'Winking face': 'Aurpegiko keinua',
      'Smiling face with smiling eyes': 'Aurpegi irribarretsua, begi irribarretsuekin',
      'Face savoring delicious food': 'Janari gozagarria dastatzearen aurpegia',
      'Relieved face': 'Lasaitasun aurpegia',
      'Smiling face with heart-shaped eyes': 'Aurpegi irribarretsua, bihotz formako begiekin',
      'Smiling face with sunglasses': 'Aurpegi irribarretsua, eguzkitako betaurrekoekin',
      'Smirking face': 'Irribarre maltzurreko aurpegia',
      'Neutral face': 'Aurpegi neutrala',
      'Expressionless face': 'Espresiorik gabeko aurpegia',
      'Unamused face': 'Aspertu aurpegia',
      'Face with cold sweat': 'Aurpegia, izerdi hotzarekin',
      'Pensive face': 'Aurpegi pentsakorra',
      'Confused face': 'Aurpegi zalantzatia',
      'Confounded face': 'Aurpegi nahasia',
      'Kissing face': 'Aurpegia musu ematen',
      'Face throwing a kiss': 'Aurpegia musua botatzen',
      'Kissing face with smiling eyes': 'Aurpegia musua ematen, begi irribarretsuekin',
      'Kissing face with closed eyes': 'Aurpegia musua ematen, begiak itxita',
      'Face with stuck out tongue': 'Aurpegia mihia aterata',
      'Face with stuck out tongue and winking eye': 'Aurpegia mihia aterata eta begiarekin keinu egiten',
      'Face with stuck out tongue and tightly-closed eyes': 'Aurpegi mihia aterata eta begiak indarrez itxita',
      'Disappointed face': 'Desilusio aurpegia',
      'Worried face': 'Kezka aurpegia',
      'Angry face': 'Aurpegi haserretua',
      'Pouting face': 'Aurpegi txarra jarrita',
      'Crying face': 'Aurpegia negarrez',
      'Persevering face': 'Pertseberantzia aurpegia',
      'Face with look of triumph': 'Garaipen espresioa duen aurpegia',
      'Disappointed but relieved face': 'Desilusionatuta, baina aurpegia arinduta',
      'Frowning face with open mouth': 'Aurpegia, ahoa irekita eta bekozkoarekin',
      'Anguished face': 'Aurpegi larritua',
      'Fearful face': 'Aurpegi beldurtua',
      'Weary face': 'Aurpegi nekatua',
      'Sleepy face': 'Aurpegi logaletua',
      'Tired face': 'Aurpegi nekatua',
      'Grimacing face': 'Aurpegia keinu batekin',
      'Loudly crying face': 'Aurpegia ahots ozenez negarrez',
      'Face with open mouth': 'Aurpegia ahoa irekita',
      'Hushed face': 'Aurpegi isila',
      'Face with open mouth and cold sweat': 'Aurpegia ahoa irekita eta izerdi hotzarekin',
      'Face screaming in fear': 'Aurpegia beldurrez oihuka',
      'Astonished face': 'Aurpegi txunditua',
      'Flushed face': 'Aurpegi gorritua',
      'Sleeping face': 'Aurpegi lokartua',
      'Dizzy face': 'Aurpegi zorabiatua',
      'Face without mouth': 'Ahorik gabeko aurpegia',
      'Face with medical mask': 'Musuko medikoa duen aurpegia',
      // Line breaker
      Break: 'Etena',
      // Math
      Subscript: 'Azpiindizea',
      Superscript: 'Goi indizea',
      // Full screen
      Fullscreen: 'Pantaila osoa',
      // Horizontal line
      'Insert Horizontal Line': 'Txertatu lerro horizontala',
      // Clear formatting
      'Clear Formatting': 'Kendu formatua',
      // Undo, redo
      Undo: 'Desegin',
      Redo: 'Berregin',
      // Select all
      'Select All': 'Aukeratu dena',
      // Code view
      'Code View': 'Kode ikuspegia',
      // Quote
      Quote: 'Aipua',
      Increase: 'Handitu',
      Decrease: 'Murriztu',
      // Quick Insert
      'Quick Insert': 'Txertaketa bizkorra',
      // Spcial Characters
      'Special Characters': 'Karaktere bereziak',
      Latin: 'Latina',
      Greek: 'Greziera',
      Cyrillic: 'Zirilikoa',
      Punctuation: 'Puntuazioa',
      Currency: 'Moneta',
      Arrows: 'Geziak',
      Math: 'Mate',
      Misc: 'Nahas-mahasa',
      // Print.
      Print: 'Inprimaketa',
      // Spell Checker.
      'Spell Checker': 'Zuzentzaile ortografikoa',
      // Help
      Help: 'Laguntza',
      Shortcuts: 'Lasterbideak',
      'Inline Editor': 'Online editorea',
      'Show the editor': 'Erakutsi editorea',
      'Common actions': 'Ohiko ekintzak',
      Copy: 'Kopiatu',
      Cut: 'Ebaki',
      Paste: 'Itsatsi',
      'Basic Formatting': 'Oinarrizko formatua',
      'Increase quote level': 'Kotizazio maila igo',
      'Decrease quote level': 'Kotizazio maila jaitsi',
      'Image / Video': 'Irudia / bideoa',
      'Resize larger': 'Birdimentsionatu handiena',
      'Resize smaller': 'Birdimentsionatu txikiena',
      Table: 'Taula',
      'Select table cell': 'Aukeratu taulako gelaxka',
      'Extend selection one cell': 'Zabaldu gelaxka baten hautapena',
      'Extend selection one row': 'Zabaldu errenkada baten hautapena',
      Navigation: 'Nabigazioa',
      'Focus popup / toolbar': 'Focus popup / toolbar',
      'Return focus to previous position': 'Itzuli aurreko posiziora',
      // Embed.ly
      'Embed URL': 'Txertatutako URLa',
      'Paste in a URL to embed': 'Itsatsi txertatu beharreko URL batean',
      // Word Paste.
      'The pasted content is coming from a Microsoft Word document. Do you want to keep the format or clean it up?': 'Itsatsitako edukia Microsoft Word dokumentu batetik dator. Formatua gorde nahi duzu edo garbitu egin nahi duzu?',
      Keep: 'Gorde',
      Clean: 'Garbitu',
      'Word Paste Detected': 'Hitza detektatuta',
      'Dashed Borders': 'Ertz etenak',
      'Alternate Rows': 'Errenkada alternatiboak',
      Highlighted: 'Nabarmendua',
      Thick: 'Lodia',
      'Paste the URL of the video you want to insert.': 'Itsatsi txertatu nahi duzun bideoaren URLa. Bateragarria: Vimeo eta Youtube.',
      'Paste in a video URL': 'Bideoaren URLa (Vimeo edo Youtube).',
      'Number Group': 'Hausturarik gabe',
      'More Text': 'Testu gehiago',
      'Text Color': 'Testuaren kolorea',
      'Background Color': 'Atzealdeko kolorea',
      'More Paragraph': 'Paragrafo gehiago',
      'More Rich': 'Aukera gehiago',
      'More Misc': 'Aukera gehiago',
      'Add blank': 'Gehitu hutsunea',
      'Insert math expresion': 'Sartu adierazpen matematiko bat',
      'Font size': 'Testuaren tamaina',
      Default: 'Lehenetsia',
      'Lower Alpha': 'Alpha minuskula',
      'Lower Greek': 'Grekoa minuskula',
      'Lower Roman': 'Erromatarra minuskula ',
      'Upper Alpha': 'Alpha hizki larriak',
      'Upper Roman': 'Erromatarra hizki larriak',
      Circle: 'Zirculu',
      Square: 'Karratu',
      Disc: 'Diskoa',
      'With Borders': 'Mugak',
      'Insert Audio': 'Gehitu audioa',
      'Upload Audio': 'Erantsi audioa',
      'Only icon play/stop': 'Erreproduzitu/gelditu ikonoa soilik',
      'Drop audio': 'Erantsi audioa',
      'Paste in an audio URL': 'Itsatsi audio-url bat'
    },
    direction: 'ltr'
  };
})();
// # sourceMappingURL=es.js.map

(function () {
  var FE = FroalaEditor;
  // FE = FE && FE.hasOwnProperty('default') ? FE['default'] : FE;

  /**
   * Gallego
   */
  FE.LANGUAGE['gl'] = {
    translation: {
      // Place holder
      'Type something': 'Escribir algo',
      // Missing translations
      'Inline Class': 'Clase en liña',
      Single: 'Solteiro',
      Double: 'Doble',
      'More Misc': 'Máis diverso',
      'Download PDF': 'Descargar PDF',
      // Basic formatting
      Bold: 'Grosa',
      Italic: 'Cursiva',
      Underline: 'Subliñado',
      Strikethrough: 'Tachado',
      // Main buttons
      Insert: 'Inserir',
      Delete: 'Borrar',
      Cancel: 'Cancelar',
      OK: 'OK',
      Back: 'Detrás',
      Remove: 'Quitar',
      More: 'Máis',
      Update: 'Actualizar',
      Style: 'Estilo',
      // Font
      'Font Family': 'Familia tipográfica',
      'Font Size': 'Tamaño de letra',
      // Colors
      Colors: 'Cores',
      Background: 'Fondo',
      Text: 'Texto',
      'HEX Color': 'Cor hexadecimal',
      // Paragraphs
      'Paragraph Format': 'Formato de parágrafo',
      Normal: 'Normal',
      Code: 'C\xF3digo',
      'Heading 1': 'Encabezado 1',
      'Heading 2': 'Encabezado 2',
      'Heading 3': 'Encabezado 3',
      'Heading 4': 'Encabezado 4',
      'Line Height': 'Interlineado',
      // Style
      'Paragraph Style': 'Estilo de parágrafo',
      'Inline Style': 'Estilo en liña',
      // Alignment
      Align: 'Aliñar',
      'Align Left': 'Aliñar á esquerda',
      'Align Center': 'Aliñar ó centro',
      'Align Right': 'Aliñar á dereita',
      'Align Justify': 'Xustificar',
      None: 'Ningún',
      // Lists
      'Ordered List': 'Lista ordenada',
      'Unordered List': 'Lista non ordenada',
      // Indent
      'Decrease Indent': 'Reducir sangr\xEDa',
      'Increase Indent': 'Aumentar sangr\xEDa',
      // Links
      'Insert Link': 'Inserir ligazón',
      'Open in new tab': 'Abre en nova pestana',
      'Open Link': 'Abrir ligazón',
      'Edit Link': 'Editar enlace',
      Unlink: 'Quitar ligazón',
      'Choose Link': 'Elegir ligazón',
      // Images
      'Insert Image': 'Inserir imaxe',
      'Upload Image': 'Cargar imaxe',
      'By URL': 'Por URL',
      Browse: 'Examinar',
      'Drop image': 'Soltaa a imaxe',
      'or click': 'o haga clic en',
      'Manage Images': 'Xestionar imaxes',
      Loading: 'Cargando',
      Deleting: 'Borrado',
      Tags: 'Etiquetas',
      'Are you sure? Image will be deleted.': 'Estás seguro? La imaxe será eliminada.',
      Replace: 'Reemplazar',
      Uploading: 'Carga',
      'Loading image': 'Cargando imaxe',
      Display: 'Mostrar',
      Inline: 'En liña',
      'Break Text': 'Romper texto',
      'Alternative Text': 'Texto alternativo',
      'Change Size': 'Cambiar tama\xF1o',
      Width: 'Ancho',
      Height: 'Altura',
      'Something went wrong. Please try again.': 'Houbo un problema. Por favor intentao de novo.',
      'Image Caption': 'Captura de imaxe',
      'Advanced Edit': 'Edición avanzada',
      // Video
      'Insert Video': 'Incorporar vídeo',
      'Embedded Code': 'C\xF3digo incrustado',
      'Paste in a video URL': 'Pegar o URL dun vídeo',
      'Drop video': 'Soltar vídeo',
      'Your browser does not support HTML5 video.': 'O teu navegador non admite vídeos HTML5.',
      'Upload Video': 'Cargar vídeo',
      // Tables
      'Insert Table': 'Inserir taboa',
      'Table Header': 'Cabeceira da taboa',
      'Remove Table': 'Borra la taboa',
      'Table Style': 'Estilo da taboa',
      'Horizontal Align': 'Aliñar horizontal',
      Row: 'Fila',
      'Insert row above': 'Inserir fila antes',
      'Insert row below': 'Inserir fila despois',
      'Delete row': 'Borrar fila',
      Column: 'Columna',
      'Insert column before': 'Inserir columna antes',
      'Insert column after': 'Inserir columna despois',
      'Delete column': 'Eliminar columna',
      Cell: 'Célula',
      'Merge cells': 'Combinar células',
      'Horizontal split': 'Divisi\xF3n horizontal',
      'Vertical split': 'Divisi\xF3n vertical',
      'Cell Background': 'Fondo da célula',
      'Vertical Align': 'Aliñar vertical',
      Top: 'Cima',
      Middle: 'Medio',
      Bottom: 'Del fondo',
      'Align Top': 'Aliñar parte superior',
      'Align Middle': 'Aliñar media',
      'Align Bottom': 'Aliñar abajo',
      'Cell Style': 'Estilo de celda',
      // Files
      'Upload File': 'Subir ficheiro',
      'Drop file': 'Soltar ficheiro',
      // Emoticons
      Emoticons: 'Emoticonos',
      'Grinning face': 'Cara sonriendo',
      'Grinning face with smiling eyes': 'Cara sonriendo con ojos sonrientes',
      'Face with tears of joy': 'Cara con l\xE1grimas de alegr\xEDa',
      'Smiling face with open mouth': 'Cara sonriente con la boca abierta',
      'Smiling face with open mouth and smiling eyes': 'Cara sonriente con la boca abierta y los ojos sonrientes',
      'Smiling face with open mouth and cold sweat': 'Cara sonriente con la boca abierta y el sudor fr\xEDo',
      'Smiling face with open mouth and tightly-closed eyes': 'Cara sonriente con la boca abierta y los ojos fuertemente cerrados',
      'Smiling face with halo': 'Cara sonriente con halo',
      'Smiling face with horns': 'Cara sonriente con cuernos',
      'Winking face': 'Gui\xF1o de la cara',
      'Smiling face with smiling eyes': 'Cara sonriente con ojos sonrientes',
      'Face savoring delicious food': 'Cara de saborear una deliciosa comida',
      'Relieved face': 'Cara aliviada',
      'Smiling face with heart-shaped eyes': 'Cara sonriente con los ojos en forma de coraz\xF3n',
      'Smiling face with sunglasses': 'Cara sonriente con gafas de sol',
      'Smirking face': 'Sonriendo cara',
      'Neutral face': 'Cara neutral',
      'Expressionless face': 'Rostro inexpresivo',
      'Unamused face': 'Cara aburrida',
      'Face with cold sweat': 'Cara con sudor fr\xEDo',
      'Pensive face': 'Rostro pensativo',
      'Confused face': 'Cara confusa',
      'Confounded face': 'Cara aturdida',
      'Kissing face': 'Cara besando',
      'Face throwing a kiss': 'Cara lanzando un beso',
      'Kissing face with smiling eyes': 'Cara besando con ojos sonrientes',
      'Kissing face with closed eyes': 'Cara besando con los ojos cerrados',
      'Face with stuck out tongue': 'Cara con la lengua pegada',
      'Face with stuck out tongue and winking eye': 'Cara con la lengua pegada y el ojo parpadeante',
      'Face with stuck out tongue and tightly-closed eyes': 'Cara con la lengua pegada y los ojos fuertemente cerrados',
      'Disappointed face': 'Cara de decepcionado',
      'Worried face': 'Cara de preocupaci\xF3n',
      'Angry face': 'Cara enojada',
      'Pouting face': 'Que pone mala cara',
      'Crying face': 'Cara llorando',
      'Persevering face': 'Cara de perseverancia',
      'Face with look of triumph': 'Cara con expresi\xF3n de triunfo',
      'Disappointed but relieved face': 'Decepcionado pero el rostro aliviado',
      'Frowning face with open mouth': 'Cara con la boca abierta con el ce\xF1o fruncido',
      'Anguished face': 'Rostro angustiado',
      'Fearful face': 'Cara temerosa',
      'Weary face': 'Rostro cansado',
      'Sleepy face': 'Rostro somnoliento',
      'Tired face': 'Rostro cansado',
      'Grimacing face': 'Cara haciendo una mueca',
      'Loudly crying face': 'Cara llorando en voz alta',
      'Face with open mouth': 'Cara con la boca abierta',
      'Hushed face': 'Cara callada',
      'Face with open mouth and cold sweat': 'Cara con la boca abierta y el sudor frío',
      'Face screaming in fear': 'Cara gritando de miedo',
      'Astonished face': 'Cara asombrosa',
      'Flushed face': 'Cara enrojecida',
      'Sleeping face': 'Rostro dormido',
      'Dizzy face': 'Cara mareada',
      'Face without mouth': 'Cara sin boca',
      'Face with medical mask': 'Cara con la m\xE1scara m\xE9dica',
      // Line breaker
      Break: 'Romper',
      // Math
      Subscript: 'Sub\xEDndice',
      Superscript: 'Super\xEDndice',
      // Full screen
      Fullscreen: 'Pantalla completa',
      // Horizontal line
      'Insert Horizontal Line': 'Inserir liña horizontal',
      // Clear formatting
      'Clear Formatting': 'Quitar o formato',
      // Undo, redo
      Undo: 'Deshacer',
      Redo: 'Rehacer',
      // Select all
      'Select All': 'Seleccionar todo',
      // Code view
      'Code View': 'Vista de c\xF3digo',
      // Quote
      Quote: 'Cita',
      Increase: 'Aumentar',
      Decrease: 'Diminuír',
      // Quick Insert
      'Quick Insert': 'Inserci\xF3n r\xE1pida',
      // Spcial Characters
      'Special Characters': 'Caracteres especiales',
      Latin: 'Latín',
      Greek: 'Grego',
      Cyrillic: 'Cirílico',
      Punctuation: 'Puntuación',
      Currency: 'Moeda',
      Arrows: 'Frechas',
      Math: 'Matemáticas',
      Misc: 'Miscelánea',
      // Print.
      Print: 'Impresión',
      // Spell Checker.
      'Spell Checker': 'Corrector ortográfico',
      // Help
      Help: 'Axuda',
      Shortcuts: 'Atallos',
      'Inline Editor': 'Editor en liña',
      'Show the editor': 'Mostrar al editor',
      'Common actions': 'Acciones comunes',
      Copy: 'Copiar',
      Cut: 'Cortar',
      Paste: 'Pegar',
      'Basic Formatting': 'Formato básico',
      'Increase quote level': 'Aumentar el nivel de cotización',
      'Decrease quote level': 'Disminuir el nivel de cotización',
      'Image / Video': 'Imaxe / vídeo',
      'Resize larger': 'Redimensionar máis grande',
      'Resize smaller': 'Redimensionar máis pequeno',
      Table: 'Táboa',
      'Select table cell': 'Celda da táboa seleccionada',
      'Extend selection one cell': 'Amplía a selección nunha cela',
      'Extend selection one row': 'Amplía a selección nunha fila',
      Navigation: 'Navegación',
      'Focus popup / toolbar': 'Foco / barra de ferramientas',
      'Return focus to previous position': 'Volver el foco a la posición anterior',
      // Embed.ly
      'Embed URL': 'URL insertada',
      'Paste in a URL to embed': 'Pegar una URL para insertar',
      // Word Paste.
      'The pasted content is coming from a Microsoft Word document. Do you want to keep the format or clean it up?': 'El contenido pegado viene de un documento de Microsoft Word. ¿Quieres mantener el formato o limpiarlo?',
      Keep: 'Gardar',
      Clean: 'Limpar',
      'Word Paste Detected': 'Palabra detectada',
      'More Text': 'Máis texto',
      'Add blank': 'Añadir hueco',
      'More Paragraph': 'Máis párrafo',
      'Text Color': 'Cor texto',
      'Background Color': 'Cor fondo',
      'Insert math expresion': 'Inserir expresión matemática',
      'Number Group': 'Non romper',
      'More Rich': 'Máis opcións',
      'Font size': 'Tamaño do texto',
      Default: 'Por defecto',
      'Lower Alpha': 'Alpha en minúscula',
      'Lower Greek': 'Grego en minúscula',
      'Lower Roman': 'Romano en minúscula',
      'Upper Alpha': 'Alpha mayúsculas',
      'Upper Roman': 'Romano mayúscula',
      Circle: 'Círculo',
      Square: 'Cadrado',
      Disc: 'Disco',
      'Dashed Borders': 'Bordos discontinuos',
      'Alternate Rows': 'Filas alternativas',
      Highlighted: 'Destacada',
      Thick: 'Groso',
      'With Borders': 'Con bordes',
      'Insert Audio': 'Inserir audio',
      'Upload Audio': 'Subir audio',
      'Only icon play/stop': 'Só ícono de reproducir/parar',
      'Drop audio': 'Soltar un audio',
      'Paste in an audio URL': 'Pegar un URL de audio'
    },
    direction: 'ltr'
  };
})();

(function () {
  var FE = FroalaEditor;
  // FE = FE && FE.hasOwnProperty('default') ? FE['default'] : FE;

  /**
   * Valenciano
   */
  FE.LANGUAGE['vl'] = {
    translation: {
      // Place holder
      'Type something': 'Escriu alguna cosa',
      // Basic formatting
      Bold: 'Negreta',
      Italic: 'Itàlica',
      Underline: 'Subratllat',
      Strikethrough: 'Ratllat',
      // Main buttons
      Insert: 'Afegeix',
      Delete: 'Esborra',
      Cancel: 'Cancel·la',
      OK: 'Ok',
      Back: 'Enrere',
      Remove: 'Elimina',
      More: 'Més',
      Update: 'Actualització',
      Style: 'Estil',
      // Font
      'Font Family': 'Família de fonts',
      'Font Size': 'Mida de font',
      // Colors
      Colors: 'Colors',
      Background: 'Fons',
      Text: 'Text',
      'HEX Color': 'Color hexadecimal',
      // Paragraphs
      'Paragraph Format': 'Format de paràgraf',
      Normal: 'Normal',
      Code: 'Codi',
      'Heading 1': 'Encapçalament 1',
      'Heading 2': 'Encapçalament 2',
      'Heading 3': 'Encapçalament 3',
      'Heading 4': 'Encapçalament 4',
      // Style
      'Paragraph Style': 'Estil de paràgraf',
      'Inline Style': 'Estil en línia',
      // Alignment
      Align: 'Alinea',
      'Align Left': 'Alinea a l’esquerra',
      'Align Center': 'Alinea al centre',
      'Align Right': 'Alinea a la dreta',
      'Align Justify': 'Justifica',
      None: 'Cap',
      // Lists
      'Ordered List': 'Llista ordenada',
      'Unordered List': 'Llista desordenada',
      // Indent
      'Decrease Indent': 'Redueix el sagnat',
      'Increase Indent': 'Augmenta el sagnat',
      // Links
      'Insert Link': 'Afegeix enllaç',
      'Open in new tab': 'Obre en una pestanya nova',
      'Open Link': 'Obre l’enllaç',
      'Edit Link': 'Edita l’enllaç',
      Unlink: 'Elimina l’enllaç',
      'Choose Link': 'Tria l’enllaç',
      // Images
      'Insert Image': 'Afegeix una imatge',
      'Upload Image': 'Carrega una imatge',
      'By URL': 'Per URL',
      Browse: 'Examina',
      'Drop image': 'Deixa anar la imatge',
      'or click': 'o fes clic a',
      'Manage Images': 'Administra imatges',
      Loading: 'S’està carregant',
      Deleting: 'S’està suprimint',
      Tags: 'Etiquetes',
      'Are you sure? Image will be deleted.': 'N’estàs segur? La imatge se suprimirà.',
      Replace: 'Canvia',
      Uploading: 'S’està pujant',
      'Loading image': 'S’està carregant la imatge',
      Display: 'Visualitza',
      Inline: 'En línia',
      'Break Text': 'Salta el text',
      'Alternative Text': 'Text alternatiu',
      'Change Size': 'Canvia la mida',
      Width: 'Amplada',
      Height: 'Alçària',
      'Something went wrong. Please try again.': 'Alguna cosa no ha anat bé. Si us plau, torna-ho a provar.',
      'Image Caption': 'Captura d’imatge',
      'Advanced Edit': 'Edició avançada',
      // Video
      'Insert Video': 'Afegeix vídeo',
      'Embedded Code': 'Codi incrustat',
      'Drop video': 'Deixa anar el vídeo',
      'Your browser does not support HTML5 video.': 'El teu navegador no és compatible amb vídeo html5.',
      'Upload Video': 'Puja un vídeo',
      // Tables
      'Insert Table': 'Afegeix una taula',
      'Table Header': 'Capçalera de la taula',
      'Remove Table': 'Elimina la taula',
      'Table Style': 'Estil de taula',
      'Horizontal Align': 'Alineació horitzontal',
      Row: 'Fila',
      'Insert row above': 'Afegeix fila abans',
      'Insert row below': 'Afegeix fila després',
      'Delete row': 'Elimina fila',
      Column: 'Columna',
      'Insert column before': 'Afegeix columna abans',
      'Insert column after': 'Afegeix columna després',
      'Delete column': 'Elimina columna',
      Cell: 'Cel·la',
      'Merge cells': 'Combina cel·les',
      'Horizontal split': 'Divisió horitzontal',
      'Vertical split': 'Divisió vertical',
      'Cell Background': 'Fons de la cel·la',
      'Vertical Align': 'Alineació vertical',
      Top: 'Part superior',
      Middle: 'Centre',
      Bottom: 'Part inferior',
      'Align Top': 'Alineació superior',
      'Align Middle': 'Alineació central',
      'Align Bottom': 'Alineació inferior',
      'Cell Style': 'Estil de cel·la',
      // Files
      'Upload File': 'Carrega un fitxer',
      'Drop file': 'Deixa anar el fitxer',
      // Emoticons
      Emoticons: 'Emoticones',
      'Grinning face': 'Cara somrient',
      'Grinning face with smiling eyes': 'Cara somrient amb ulls somrients',
      'Face with tears of joy': 'Cara amb llàgrimes d’alegria',
      'Smiling face with open mouth': 'Cara somrient amb la boca oberta',
      'Smiling face with open mouth and smiling eyes': 'Cara somrient amb la boca oberta i els ulls somrients',
      'Smiling face with open mouth and cold sweat': 'Cara somrient amb la boca oberta i suor freda',
      'Smiling face with open mouth and tightly-closed eyes': 'Cara somrient amb la boca oberta i els ulls tancats fent força',
      'Smiling face with halo': 'Cara somrient amb halo',
      'Smiling face with horns': 'Cara somrient amb banyes',
      'Winking face': 'Cara que fa l’ullet',
      'Smiling face with smiling eyes': 'Cara somrient amb ulls somrients',
      'Face savoring delicious food': 'Cara d’assaborir un menjar deliciós',
      'Relieved face': 'Cara d’alleujament',
      'Smiling face with heart-shaped eyes': 'Cara somrient amb els ulls en forma de cor',
      'Smiling face with sunglasses': 'Cara somrient amb ulleres de sol',
      'Smirking face': 'Cara amb somriure de satisfacció',
      'Neutral face': 'Cara neutra',
      'Expressionless face': 'Cara inexpressiva',
      'Unamused face': 'Cara avorrida',
      'Face with cold sweat': 'Cara amb suor freda',
      'Pensive face': 'Cara pensativa',
      'Confused face': 'Cara confusa',
      'Confounded face': 'Cara desconcertada',
      'Kissing face': 'Cara que fa un petó',
      'Face throwing a kiss': 'Cara que llança un petó',
      'Kissing face with smiling eyes': 'Cara fent un petó amb ulls somrients',
      'Kissing face with closed eyes': 'Cara fent un petó amb els ulls tancats',
      'Face with stuck out tongue': 'Cara amb la llengua fora',
      'Face with stuck out tongue and winking eye': 'Cara amb la llengua fora i fent l’ullet',
      'Face with stuck out tongue and tightly-closed eyes': 'Cara amb la llengua fora i els ulls tancats fent força',
      'Disappointed face': 'Cara de decepció',
      'Worried face': 'Cara de preocupació',
      'Angry face': 'Cara enfadada',
      'Pouting face': 'Cara que fa el petarrell',
      'Crying face': 'Cara plorant',
      'Persevering face': 'Cara de perseverança',
      'Face with look of triumph': 'Cara amb expressió de triomf',
      'Disappointed but relieved face': 'Cara decebuda, però alleujada',
      'Frowning face with open mouth': 'Cara amb la boca oberta i les celles arrufades',
      'Anguished face': 'Cara angoixada',
      'Fearful face': 'Cara esporuguida',
      'Weary face': 'Cara esgotada',
      'Sleepy face': 'Cara somnolent',
      'Tired face': 'Cara cansada',
      'Grimacing face': 'Cara fent una ganyota',
      'Loudly crying face': 'Cara plorant en veu alta',
      'Face with open mouth': 'Cara amb la boca oberta',
      'Hushed face': 'Cara callada',
      'Face with open mouth and cold sweat': 'Cara amb la boca oberta i suor freda',
      'Face screaming in fear': 'Cara cridant de por',
      'Astonished face': 'Cara de sorpresa',
      'Flushed face': 'Cara enrojolada',
      'Sleeping face': 'Cara adormida',
      'Dizzy face': 'Cara marejada',
      'Face without mouth': 'Cara sense boca',
      'Face with medical mask': 'Cara amb mascareta mèdica',
      // Line breaker
      Break: 'Salta',
      // Math
      Subscript: 'Subíndex',
      Superscript: 'Superíndex',
      // Full screen
      Fullscreen: 'Pantalla completa',
      // Horizontal line
      'Insert Horizontal Line': 'Afegeix línia horitzontal',
      // Clear formatting
      'Clear Formatting': 'Elimina el format',
      // Undo, redo
      Undo: 'Desfés',
      Redo: 'Refés',
      // Select all
      'Select All': 'Selecciona-ho tot',
      // Code view
      'Code View': 'Vista de codi',
      // Quote
      Quote: 'Citació',
      Increase: 'Augmenta',
      Decrease: 'Redueix',
      // Quick Insert
      'Quick Insert': 'Inserció ràpida',
      // Spcial Characters
      'Special Characters': 'Caràcters especials',
      Latin: 'Llatí',
      Greek: 'Grec',
      Cyrillic: 'Ciríl·lic',
      Punctuation: 'Puntuació',
      Currency: 'Moneda',
      Arrows: 'Fletxes',
      Math: 'Mates',
      Misc: 'Miscel·lània',
      // Print.
      Print: 'Impressió',
      // Spell Checker.
      'Spell Checker': 'Corrector ortogràfic',
      // Help
      Help: 'Ajuda',
      Shortcuts: 'Dreceres',
      'Inline Editor': 'Editor en línia',
      'Show the editor': 'Mostra l’editor',
      'Common actions': 'Accions comunes',
      Copy: 'Copia',
      Cut: 'Retalla',
      Paste: 'Enganxa',
      'Basic Formatting': 'Format bàsic',
      'Increase quote level': 'Augmenta el nivell de citació',
      'Decrease quote level': 'Redueix el nivell de citació',
      'Image / Video': 'Imatge / vídeo',
      'Resize larger': 'Fes més gran',
      'Resize smaller': 'Fes més petit',
      Table: 'Taula',
      'Select table cell': 'Selecciona una celdla',
      'Extend selection one cell': 'Amplia la selecció una cel·la',
      'Extend selection one row': 'Amplia la selecció una fila',
      Navigation: 'Navegació',
      'Focus popup / toolbar': 'Focus emergent / barra d’eines',
      'Return focus to previous position': 'Fes tornar el focus a la posició anterior',
      // Embed.ly
      'Embed URL': 'Incrusta URL',
      'Paste in a URL to embed': 'Enganxa un url per incrustar',
      // Word Paste.
      'The pasted content is coming from a Microsoft Word document. Do you want to keep the format or clean it up?': 'El contingut enganxat ve d’un document de Microsoft Word. Vols mantenir-ne el format?',
      Keep: 'Desa',
      Clean: 'Suprimeix',
      'Word Paste Detected': 'Paraula detectada',
      'Dashed Borders': 'Vores discontínues',
      'Alternate Rows': 'Files alternes',
      Highlighted: 'Ressaltada',
      Thick: 'Gruixuda',
      'Paste the URL of the video you want to insert.': 'Enganxa URL del vídeo que vols afegir. Compatible: Vimeo i Youtube.',
      'Paste in a video URL': 'URL del vídeo (Vimeo o Youtube).',
      'Number Group': 'No trencar',
      'More Text': 'Més text',
      'Text Color': 'Color de text',
      'Background Color': 'Color de fons',
      'More Paragraph': 'Més paràgraf',
      'More Rich': 'Més opcions',
      'More Misc': 'Més opcions',
      'Add blank': 'Afegeix buit',
      'Insert math expresion': 'Insereix expressió matemàtica',
      'Font size': 'Grandària de text',
      Default: 'Per defecte',
      'Lower Alpha': 'Alpha en minúscula',
      'Lower Greek': 'Gregas en minúscula',
      'Lower Roman': 'Romanes en minúscula',
      'Upper Alpha': 'Alpha majúscules',
      'Upper Roman': 'Romanes majúscules',
      Circle: 'Cercle',
      Square: 'Quadrat',
      Disc: 'Disc',
      'With Borders': 'Amb vores',
      'Insert Audio': 'Inserir àudio',
      'Upload Audio': 'Subir àudio',
      'Only icon play/stop': 'Només icona reproducir/parar',
      'Drop audio': 'Soltar àudio',
      'Paste in an audio URL': "Pegar una URL d'àudio"
    },
    direction: 'ltr'
  };
})();

/**
 * External dependencies
 */
var MINT_TOOLBAR_FROALA_SHOW = 'mint-toolbar-froala--show';
function TextEditor(props) {
  var model = props.model,
    onlyText = props.onlyText,
    imageUploadUrl = props.imageUploadUrl,
    onModelChange = props.onModelChange,
    placeholderText = props.placeholderText,
    lang = props.lang,
    onEnterDown = props.onEnterDown,
    onBackAndEmpty = props.onBackAndEmpty,
    onInitialized = props.onInitialized,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    _props$typeToolbar = props.typeToolbar,
    typeToolbar = _props$typeToolbar === void 0 ? ITypeFroalaToolbar.MODE_ADVANCED : _props$typeToolbar,
    _props$scrollableCont = props.scrollableContainer,
    scrollableContainer = _props$scrollableCont === void 0 ? '#mint-lesson' : _props$scrollableCont,
    tooltips = props.tooltips,
    onChangeTooltips = props.onChangeTooltips;
  var tooltipsRef = useRef(tooltips || []);
  tooltipsRef.current = tooltips || [];
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useClassSpanBackgrou = useClassSpanBackgroundsEditor({}),
    onInitializedFroala = _useClassSpanBackgrou.onInitializedFroala;
  var buttonMathEnabled = props.buttonMathEnabled === true ? true : false;
  var buttonMintTooltipEnabled = props.buttonMintTooltipEnabled === true ? true : false;
  var toolbarButtons = getFroalaToolbar(onlyText ? ITypeFroalaToolbar.MODE_SIMPLE : typeToolbar, buttonMathEnabled, imageUploadUrl !== undefined, buttonMintTooltipEnabled);
  var quickIsertButtons = [buttonMathEnabled ? 'mathButtonQI' : '', imageUploadUrl && 'image', imageUploadUrl && 'video', 'table'];
  var config = {
    key: FROALA3_LECENSE_KEY,
    // charCounterMax: 1000,
    events: {
      focus: function focus(e, t) {},
      'paste.beforeCleanup': function pasteBeforeCleanup(e, t, n) {},
      initialized: function initialized() {
        // Esto en la 3.0.6 de froala no va, y en la 3.2.6 no funciana en froala en prod
        var editor = this;
        onInitialized && onInitialized(editor);
        onInitializedFroala(editor);
        // == Pongo un timeout pequeño porque sin este si veo en este punto que vale editor.events siempre me da undefined
        setTimeout(function () {
          // @ts-ignore
          if (editor.events) {
            // @ts-ignore
            editor.events.on('keydown', function (e, _editor, keypressEvent) {
              function _stopPropagation() {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
              }
              if ((e.which === 13 || e.which === 10) && !e.shiftKey) {
                // == Si esta definida la funcion onEnterDown se para la propagacion y se ejecuta
                if (onEnterDown) {
                  _stopPropagation();
                  onEnterDown();
                  return false;
                }
              } else {
                // == Si pulsa atras
                if (e.which === 8 && !e.shiftKey) {
                  if (isEmptyEditor(editor)) {
                    // == No hay nada escrito
                    if (onBackAndEmpty) {
                      _stopPropagation();
                      onBackAndEmpty(); // == He pulsado atras y estoy en blanco
                    }
                  }
                }
              }
            }, true);
            // @ts-ignore
            editor.events.on('focus', function (e, editor) {
              onFocus && onFocus();
            });
            // @ts-ignore
            editor.events.on('blur', function (e, editor) {
              onBlur && onBlur();
            });
            // == Para evitar que si se crea un párrafo detrás de un texto con negrita o cursiva el siguiente párrafo toma el formato.
            // @ts-ignore
            editor.events.on('paste.before', function (originalEvent) {
              // @ts-ignore
              if (editor && editor.format && editor.format.remove) {
                // Desactivo la negrita
                // @ts-ignore
                editor.format.remove('strong');
                // Desactivo la cursiva
                // @ts-ignore
                editor.format.remove('em');
              }
            });
          }
        }, 200);
      },
      'toolbar.show': function toolbarShow() {
        if (scrollableContainer) {
          var el = document.querySelector(scrollableContainer);
          if (el) {
            addClass(el, MINT_TOOLBAR_FROALA_SHOW);
          }
        }
      },
      'toolbar.hide': function toolbarHide() {
        if (scrollableContainer) {
          var el = document.querySelector(scrollableContainer);
          if (el) {
            removeClass(el, MINT_TOOLBAR_FROALA_SHOW);
          }
        }
      }
    },
    // == Subida de imagenes con froala
    imageUploadURL: imageUploadUrl,
    imageUploadMethod: 'POST',
    imageDefaultWidth: 0,
    videoUploadURL: imageUploadUrl,
    videoUploadMethod: 'POST',
    // == Fin subida de imagenes con froala
    fontSize: ['8', '9', '10', '11', '12', '14', '16', '18', '20', '24', '30', '32', '36', '48', '60', '72', '96'],
    immediateReactModelUpdate: false,
    keepFormatOnDelete: true,
    lineBreakerTags: ['embedly'],
    linkAlwaysBlank: true,
    linkEditButtons: ['linkEdit', 'linkRemove'],
    linkInsertButtons: ['linkBack', '|'],
    multiLine: true,
    // pasteDeniedTags: ["img", "iframe"], //"script" lo quito si no no funciona mathjax
    htmlAllowedEmptyTags: ['textarea', 'a', 'iframe', 'object', 'video', 'style', '.fa', '.fr-emoticon', '.fr-inner', 'path', 'line', 'hr', '.MathJax_SVG svg *'],
    pastePlain: false,
    placeholderText: placeholderText || t('Type something', {
      ns: 'editor'
    }),
    tabSpaces: 4,
    listAdvancedTypes: true,
    toolbarButtons: toolbarButtons,
    toolbarButtonsMD: toolbarButtons,
    toolbarButtonsSM: toolbarButtons,
    toolbarButtonsXS: toolbarButtons,
    toolbarInline: true,
    wordPasteModal: false,
    editorClass: 'brand--link',
    quickInsertEnabled: true,
    quickInsertButtons: quickIsertButtons,
    quickInsertTags: ['p', 'div'],
    videoInsertButtons: ['videoBack', '|', 'videoByURL', 'videoEmbed', imageUploadUrl && 'videoUpload'],
    videoAllowedProviders: ['youtube', 'vimeo'],
    videoDefaultDisplay: 'block',
    videoMaxSize: 1024 * 1024 * 520,
    videoResponsive: false,
    imageMaxSize: 1024 * 1024 * 4,
    imagePaste: false,
    charCounterCount: false,
    language: lang || 'es',
    scrollableContainer: scrollableContainer,
    pluginsEnabled: ['align', 'charCounter', 'codeBeautifier', 'codeView', 'colors', 'draggable', 'fontSize', 'image', 'link', 'lists', 'paragraphStyle', 'quickInsert', 'table', 'video', 'mathPluginv3'].concat(buttonMintTooltipEnabled ? ['mintTooltip'] : []),
    mintTooltipOptions: {
      getTooltips: function getTooltips() {
        return tooltipsRef.current;
      },
      onChangeTooltips: onChangeTooltips
    }
  };
  var handleModelChange = function handleModelChange(model) {
    onModelChange && onModelChange(model);
  };
  return /*#__PURE__*/React__default.createElement(FroalaEditorInput, {
    config: config,
    model: model,
    onModelChange: handleModelChange
  });
}

function TextHtml(props) {
  var mode = props.mode,
    text = props.text,
    placeholder = props.placeholder,
    lang = props.lang,
    textUpdated = props.textUpdated,
    onEnterDown = props.onEnterDown,
    onBackAndEmpty = props.onBackAndEmpty,
    onInitialized = props.onInitialized,
    _props$isTextUpdatedK = props.isTextUpdatedKeyEnter,
    isTextUpdatedKeyEnter = _props$isTextUpdatedK === void 0 ? false : _props$isTextUpdatedK,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$maxLength = props.maxLength,
    maxLength = _props$maxLength === void 0 ? undefined : _props$maxLength,
    _props$autofocus = props.autofocus,
    autofocus = _props$autofocus === void 0 ? false : _props$autofocus,
    _props$onClick = props.onClick,
    _onClick = _props$onClick === void 0 ? null : _props$onClick,
    _props$textAreaRows = props.textAreaRows,
    textAreaRows = _props$textAreaRows === void 0 ? undefined : _props$textAreaRows,
    _props$typeToolbar = props.typeToolbar,
    typeToolbar = _props$typeToolbar === void 0 ? ITypeFroalaToolbar.MODE_ADVANCED : _props$typeToolbar,
    scrollableContainer = props.scrollableContainer,
    tooltips = props.tooltips,
    onChangeTooltips = props.onChangeTooltips,
    additionalConfig = props.additionalConfig;
  var _useGeneral = useGeneral(),
    enableTextTooltips = _useGeneral.enableTextTooltips;
  var _useState = useState({
      text: text,
      focus: false
    }),
    state = _useState[0],
    dispatch = _useState[1];
  var debouncedSearch = useDebounce(state.text, 100); //== debouncedSearch va a tener el valor de state.text en el momento en que reaccionara internamente useDebounce y devolverá otro debouncedSearch
  useEffect(function () {
    // == Verifico que siga siendo igual que lo que hay ahora en el state.text, en caso de haber cambiado ya se invocará de nuevo al
    if (debouncedSearch === state.text) hasChangedPendingTextUpdated();
  }, [debouncedSearch]);
  function hasChangedPendingTextUpdated() {
    state.focus && textUpdated && textUpdated(state.text);
  }
  useEffect(function () {
    if (text !== state.text && !state.focus) {
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          text: text
        });
      });
    }
  }, [text]);
  function textUpdateLocal(newText) {
    if (newText !== state.text && state.focus) {
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          text: newText
        });
      });
    }
  }
  function onFocus() {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        focus: true
      });
    });
  }
  function onBlur() {
    // Se añade un delay porque en el caso de cambiar los titulos en el acordeon
    // demasiado rapido solo emitia el cambio el último
    setTimeout(function () {
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          focus: false
        });
      });
    }, 200);
  }
  var buttonMintTooltipEnabled = additionalConfig != null && additionalConfig.hideButtonTooltip ? false : enableTextTooltips;
  return mode === IModesTextHtml.MODE_TEXT_HTML_EDITOR ? /*#__PURE__*/React__default.createElement(TextEditor, {
    model: state.text,
    onModelChange: textUpdateLocal,
    placeholderText: placeholder,
    onEnterDown: onEnterDown,
    onBackAndEmpty: onBackAndEmpty,
    onInitialized: onInitialized,
    buttonMathEnabled: true,
    lang: lang,
    typeToolbar: typeToolbar,
    onFocus: onFocus,
    onBlur: onBlur,
    scrollableContainer: scrollableContainer,
    buttonMintTooltipEnabled: buttonMintTooltipEnabled,
    tooltips: tooltips,
    onChangeTooltips: onChangeTooltips
  }) : mode === IModesTextHtml.MODE_TEXT_HTML_TEXT_EDITOR ? /*#__PURE__*/React__default.createElement("div", {
    className: 'swiper-no-swiping'
  }, /*#__PURE__*/React__default.createElement(InputText, {
    placeholder: placeholder || '',
    textInput: state.text,
    onChange: function onChange(text) {
      return textUpdateLocal(text);
    },
    isTextUpdatedKeyEnter: isTextUpdatedKeyEnter,
    onClick: function onClick(event) {
      return _onClick ? _onClick(event) : function () {};
    },
    autofocus: autofocus || false,
    disabled: disabled,
    maxLength: maxLength,
    onFocus: onFocus,
    onBlur: onBlur,
    onEnterDown: onEnterDown
  })) : mode === IModesTextHtml.MODE_TEXT_HTML_TEXT_AREA_EDITOR ? /*#__PURE__*/React__default.createElement("div", {
    className: 'swiper-no-swiping'
  }, /*#__PURE__*/React__default.createElement(TextArea, {
    rows: textAreaRows,
    placeholder: placeholder || '',
    textInput: state.text,
    onChange: function onChange(text) {
      return textUpdateLocal(text);
    },
    isTextUpdatedKeyEnter: false,
    onFocus: onFocus,
    onBlur: onBlur,
    onEnterDown: onEnterDown
  })) : /*#__PURE__*/React__default.createElement(TextHtmlVisor, {
    text: text
  });
}

/**
 * Componente de Tabs modelo A.
 * Por defecto abre la tab 0
 */
var TabsModelA = /*#__PURE__*/function (_React$Component) {
  function TabsModelA(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.clickTab = _this.clickTab.bind(_this);
    _this.state = {
      idTabActive: _this.getNumTabs() > 0 ? 0 : null
    };
    return _this;
  }
  _inheritsLoose(TabsModelA, _React$Component);
  var _proto = TabsModelA.prototype;
  _proto.getNumTabs = function getNumTabs() {
    return this.props.children && this.props.children.length > 0 ? this.props.children.length : 0;
  };
  _proto.clickTab = function clickTab(e, index) {
    e.preventDefault();
    this.setState({
      idTabActive: index
    });
  };
  _proto.render = function render() {
    var _this2 = this;
    var idTabActive = this.state.idTabActive;
    var _this$props = this.props,
      children = _this$props.children,
      titleTabsList = _this$props.titleTabsList,
      classNameAdd = _this$props.classNameAdd;
    return /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-tabs-model-a ' + classNameAdd
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "mint-tabs-model-a__tabs-container"
    }, /*#__PURE__*/React__default.createElement("ul", {
      className: "mint-tabs-model-a__tabs"
    }, titleTabsList ? titleTabsList.map(function (titleTab, index) {
      return /*#__PURE__*/React__default.createElement("li", {
        className: 'mint-tabs-model-a__tab' + (idTabActive !== null && idTabActive === index ? ' mint-tabs-model-a__tab--active' : ''),
        key: index,
        onClick: function onClick(e) {
          return _this2.clickTab(e, index);
        }
      }, /*#__PURE__*/React__default.createElement("a", {
        href: ""
      }, titleTab));
    }) : '')), /*#__PURE__*/React__default.createElement("div", {
      className: "mint-tabs-model-a__content"
    }, children && children.length !== undefined ? children.map(function (childrenParcial, index) {
      return idTabActive !== null && idTabActive === index ? /*#__PURE__*/React__default.createElement("div", {
        className: "mint-tabs-model-a-children",
        key: index
      }, childrenParcial) : '';
    }) : children ?
    /*#__PURE__*/
    // Tengo un solo hijo y lo pinto
    React__default.createElement("div", {
      className: "mint-tabs-model-a-children"
    }, children) : ''));
  };
  return TabsModelA;
}(React__default.Component);
TabsModelA.propTypes = {
  // children: PropTypes.array.isRequired || PropTypes.object.isRequired, // == Listado de contenido de las distintas tabs, child es un array y en cada posicion es el contenido de esa pestaña
  titleTabsList: PropTypes.array.isRequired // == Listado de titulos, el titulo de la posicion 0 de este array corresponde a la primera pestaña
};

var TabsContentSettingsSidebar = /*#__PURE__*/function (_React$Component) {
  function TabsContentSettingsSidebar() {
    return _React$Component.apply(this, arguments) || this;
  }
  _inheritsLoose(TabsContentSettingsSidebar, _React$Component);
  var _proto = TabsContentSettingsSidebar.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      classNameAdd = _this$props.classNameAdd,
      t = _this$props.t;
    return /*#__PURE__*/React__default.createElement(TabsModelA, {
      titleTabsList: [t('Content', {
        ns: 'editor'
      }), t('Settings', {
        ns: 'editor'
      })],
      classNameAdd: classNameAdd
    }, children[0], children[1]);
  };
  return TabsContentSettingsSidebar;
}(React__default.Component);
TabsContentSettingsSidebar.propTypes = {
  children: PropTypes.array.isRequired
};

var PADDING_LAYOUT_VALUE_NOT_SET = '';
var PADDING_LAYOUT_OPTIONS = [{
  value: PADDING_LAYOUT_VALUE_NOT_SET,
  name: 'row_settings_padding_not_set'
},
//{ value: 'none', name: 'row_settings_padding_none' },
{
  value: '10px',
  name: '10px'
}, {
  value: '20px',
  name: '20px'
}, {
  value: '30px',
  name: '30px'
}, {
  value: '40px',
  name: '40px'
}, {
  value: '50px',
  name: '50px'
}, {
  value: '60px',
  name: '60px'
}, {
  value: '70px',
  name: '70px'
}, {
  value: '80px',
  name: '80px'
}, {
  value: '90px',
  name: '90px'
}, {
  value: '100px',
  name: '100px'
}];

function useTabSettingsSidebar(props) {
  var _layout$config2;
  var item = props.item,
    onChangeItem = props.onChangeItem,
    layoutPosition = props.layoutPosition,
    layout = props.layout,
    onChangeLayout = props.onChangeLayout;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    enablePopups = _useGeneral.enablePopups,
    enableRowColumnLayout = _useGeneral.enableRowColumnLayout,
    enableBackgroundGradient = _useGeneral.enableBackgroundGradient;
  var paddingSizes = [{
    value: 0,
    name: t('No padding', {
      ns: 'editor'
    })
  }, {
    value: 1,
    name: '10px'
  }, {
    value: 2,
    name: '20px'
  }, {
    value: 3,
    name: '30px'
  }, {
    value: 4,
    name: '40px'
  }, {
    value: 5,
    name: '50px'
  }, {
    value: 6,
    name: '60px'
  }, {
    value: 7,
    name: '70px'
  }, {
    value: 8,
    name: '80px'
  }, {
    value: 9,
    name: '90px'
  }, {
    value: 10,
    name: '100px'
  }];
  function getItemUpdatedSettingPaddingTop(item, valueSelected) {
    var itemUpdated = item;
    if (item && item.settings) itemUpdated.settings.paddingTop = Number(valueSelected);
    return itemUpdated;
  }
  function getItemUpdatedSettingPaddingBottom(item, valueSelected) {
    var itemUpdated = item;
    if (item && item.settings) itemUpdated.settings.paddingBottom = Number(valueSelected);
    return itemUpdated;
  }
  function getItemUpdatedSettingBackgroundColor(item, backgroundColor) {
    var itemUpdated = item;
    if (item && item.settings) itemUpdated.settings.backgroundColor = backgroundColor;
    return itemUpdated;
  }
  function getItemUpdatedSettingTeacherOnly(item, teacherOnly) {
    var itemUpdated = item;
    if (item && item.settings) itemUpdated.settings.teacherOnly = teacherOnly;
    return itemUpdated;
  }
  function getItemUpdatedSettingShowBorder(item, showBorder) {
    var itemUpdated = item;
    if (item && item.settings) itemUpdated.settings.showBorder = showBorder;
    return itemUpdated;
  }
  function getItemUpdatedSettingMediaWidth(item, mediaWidth) {
    var itemUpdated = item;
    if (item && item.settings) itemUpdated.settings.mediaWidth = mediaWidth;
    return itemUpdated;
  }
  function getItemUpdatedSettingAlignImages(item, alignImages) {
    var itemUpdated = item;
    if (item && item.settings) itemUpdated.settings.alignImages = alignImages;
    return itemUpdated;
  }
  function getItemUpdatedSettingZoomOnClick(item, zoomOnClick) {
    var itemUpdated = item;
    if (item && item.settings) itemUpdated.settings.zoomOnClick = zoomOnClick;
    return itemUpdated;
  }
  function getItemUpdatedSettingMintTitle(item, mintTitle) {
    var itemUpdated = item;
    if (item && item.settings) itemUpdated.settings.title = mintTitle;
    return itemUpdated;
  }
  function getItemUpdatedSettingItemBlockPopup(item, itemBlockPopup) {
    var itemUpdated = item;
    if (item && itemBlockPopup) itemUpdated.popup = itemBlockPopup;else if (item) delete itemUpdated.popup;
    return itemUpdated;
  }
  function getItemUpdatedSettingStepLabel(item, stepLabel) {
    var itemUpdated = item;
    if (item && item.settings) itemUpdated.settings.stepLabel = stepLabel;
    return itemUpdated;
  }
  function getItemUpdatedSettingAudios(item, audios) {
    var itemUpdated = item;
    if (item && item.settings) itemUpdated.settings.audios = audios;
    return itemUpdated;
  }
  function getItemUpdatedSettingHiddenContent(item, hiddenContent) {
    var itemUpdated = item;
    if (item && item.settings) itemUpdated.settings.hiddenContent = hiddenContent;
    return itemUpdated;
  }
  function getItemUpdatedSettingHiddenMultimedia(item, hiddenMultimedia) {
    var itemUpdated = item;
    if (item && item.settings) itemUpdated.settings.hiddenMultimedia = hiddenMultimedia;
    return itemUpdated;
  }
  function getItemUpdatedSettingImagePosition(item, imagePosition) {
    var itemUpdated = item;
    if (item && item.settings) itemUpdated.settings.imagePosition = imagePosition;
    return itemUpdated;
  }
  function getItemUpdatedSettingImageSize(item, imageSize) {
    var itemUpdated = item;
    if (item && item.settings) itemUpdated.settings.imageSize = imageSize;
    return itemUpdated;
  }
  function getValueItemIsShowBorder() {
    return getItemSettingIsShowBorder(item);
  }
  function getValueItemIsZoomOnClick() {
    return getItemSettingIsZoomOnClick(item);
  }
  function getValueItemMediaWidth() {
    return getItemSettingMediaWidth(item);
  }
  function getValueItemAlignImages() {
    return getItemSettingAlignImages(item);
  }
  function getValueItemMintTitle() {
    return getItemSettingMintTitle(item);
  }
  function getValueItemStepLabel() {
    return getItemSettingStepLabel(item);
  }
  function getValueItemAudios() {
    return getItemSettingAudios(item);
  }
  function getValueItemHiddenContent() {
    return getItemSettingHiddenContent(item);
  }
  function getValueItemHiddenMultimedia() {
    return getItemSettingHiddenMultimedia(item);
  }
  function getValueItemImagePosition() {
    return getItemSettingImagePosition(item);
  }
  function getValueItemImageSize() {
    return getItemSettingImageSize(item);
  }
  function onChangePaddingTop(valueSelected) {
    if (onChangeItem) {
      onChangeItem(getItemUpdatedSettingPaddingTop(item, valueSelected));
    }
  }
  function onChangePaddingBottom(valueSelected) {
    if (onChangeItem) {
      onChangeItem(getItemUpdatedSettingPaddingBottom(item, valueSelected));
    }
  }
  function onChangeMediaWidth(valueSelected) {
    if (onChangeItem) {
      onChangeItem(getItemUpdatedSettingMediaWidth(item, valueSelected));
    }
  }
  function onChangeAlignImages(valueSelected) {
    if (onChangeItem) {
      onChangeItem(getItemUpdatedSettingAlignImages(item, valueSelected));
    }
  }
  function onChangeBackgroundColor(backgroundColor) {
    if (onChangeItem) {
      onChangeItem(getItemUpdatedSettingBackgroundColor(item, backgroundColor));
    }
  }
  function onChangeTeacherOnly(teacherOnly) {
    if (onChangeItem) {
      onChangeItem(getItemUpdatedSettingTeacherOnly(item, teacherOnly));
    }
  }
  function onChangeShowBorder(showBorder) {
    if (onChangeItem) {
      onChangeItem(getItemUpdatedSettingShowBorder(item, showBorder));
    }
  }
  function onChangeZoomOnClick(zoomOnClick) {
    if (onChangeItem) {
      onChangeItem(getItemUpdatedSettingZoomOnClick(item, zoomOnClick));
    }
  }
  function onChangeMintTitle(mintTitle) {
    if (onChangeItem) {
      onChangeItem(getItemUpdatedSettingMintTitle(item, mintTitle));
    }
  }
  function onChangeStepLabel(stepLabel) {
    if (onChangeItem) {
      onChangeItem(getItemUpdatedSettingStepLabel(item, stepLabel));
    }
  }
  function onChangeAudios(audios) {
    if (onChangeItem) {
      onChangeItem(getItemUpdatedSettingAudios(item, audios));
    }
  }
  function onChangeHiddenContent(hiddenContent) {
    if (onChangeItem) {
      onChangeItem(getItemUpdatedSettingHiddenContent(item, hiddenContent));
    }
  }
  function onChangeHiddenMultimedia(hiddenMultimedia) {
    if (onChangeItem) {
      onChangeItem(getItemUpdatedSettingHiddenMultimedia(item, hiddenMultimedia));
    }
  }
  function onChangeImagePosition(valueSelected) {
    if (onChangeItem) {
      onChangeItem(getItemUpdatedSettingImagePosition(item, valueSelected));
    }
  }
  function onChangeImageSize(valueSelected) {
    if (onChangeItem) {
      onChangeItem(getItemUpdatedSettingImageSize(item, valueSelected));
    }
  }
  var getColumnWidth = function getColumnWidth() {
    var _column$config, _layout$config;
    if (!layout || !layoutPosition) return null;
    var row = layout.rows.find(function (r) {
      return r.guid === layoutPosition.rowGuid;
    });
    if (!row) return null;
    var column = row.columns.find(function (c) {
      return c.guid === layoutPosition.columnGuid;
    });
    return (column == null || (_column$config = column.config) == null ? void 0 : _column$config.width) || ((_layout$config = layout.config) == null ? void 0 : _layout$config.defaultColumnWidth);
  };
  var getColumnPaddingLeft = function getColumnPaddingLeft() {
    var _column$config2;
    if (!layout || !layoutPosition) return null;
    var row = layout.rows.find(function (r) {
      return r.guid === layoutPosition.rowGuid;
    });
    if (!row) return null;
    var column = row.columns.find(function (c) {
      return c.guid === layoutPosition.columnGuid;
    });
    return column == null || (_column$config2 = column.config) == null ? void 0 : _column$config2.paddingLeft;
  };
  var getColumnPaddingRight = function getColumnPaddingRight() {
    var _column$config3;
    if (!layout || !layoutPosition) return null;
    var row = layout.rows.find(function (r) {
      return r.guid === layoutPosition.rowGuid;
    });
    if (!row) return null;
    var column = row.columns.find(function (c) {
      return c.guid === layoutPosition.columnGuid;
    });
    return column == null || (_column$config3 = column.config) == null ? void 0 : _column$config3.paddingRight;
  };
  var columnWidth = getColumnWidth();
  var columnPaddingLeft = getColumnPaddingLeft();
  var columnPaddingRight = getColumnPaddingRight();
  var defaultColumnWidth = layout == null || (_layout$config2 = layout.config) == null ? void 0 : _layout$config2.defaultColumnWidth;
  var onChangeColumnWidth = function onChangeColumnWidth(width) {
    if (!layout || !layoutPosition || !onChangeLayout) return;
    var newLayout = _extends({}, layout, {
      rows: layout.rows.map(function (row) {
        if (row.guid === layoutPosition.rowGuid) {
          return _extends({}, row, {
            columns: row.columns.map(function (col) {
              if (col.guid === layoutPosition.columnGuid) {
                var newConfig = _extends({}, col.config);
                if (width === 'default-row-width-layout' || width === '') {
                  delete newConfig.width;
                } else {
                  newConfig.width = width;
                }
                return _extends({}, col, {
                  config: newConfig
                });
              }
              return col;
            })
          });
        }
        return row;
      })
    });
    onChangeLayout(newLayout);
  };
  var onChangeColumnPaddingLeft = function onChangeColumnPaddingLeft(paddingLeft) {
    if (!layout || !layoutPosition || !onChangeLayout) return;
    var newLayout = _extends({}, layout, {
      rows: layout.rows.map(function (row) {
        if (row.guid === layoutPosition.rowGuid) {
          return _extends({}, row, {
            columns: row.columns.map(function (col) {
              if (col.guid === layoutPosition.columnGuid) {
                var newConfig = _extends({}, col.config);
                if (paddingLeft === PADDING_LAYOUT_VALUE_NOT_SET) {
                  delete newConfig.paddingLeft;
                } else {
                  newConfig.paddingLeft = paddingLeft;
                }
                return _extends({}, col, {
                  config: newConfig
                });
              }
              return col;
            })
          });
        }
        return row;
      })
    });
    onChangeLayout(newLayout);
  };
  var onChangeColumnPaddingRight = function onChangeColumnPaddingRight(paddingRight) {
    if (!layout || !layoutPosition || !onChangeLayout) return;
    var newLayout = _extends({}, layout, {
      rows: layout.rows.map(function (row) {
        if (row.guid === layoutPosition.rowGuid) {
          return _extends({}, row, {
            columns: row.columns.map(function (col) {
              if (col.guid === layoutPosition.columnGuid) {
                var newConfig = _extends({}, col.config);
                if (paddingRight === PADDING_LAYOUT_VALUE_NOT_SET) {
                  delete newConfig.paddingRight;
                } else {
                  newConfig.paddingRight = paddingRight;
                }
                return _extends({}, col, {
                  config: newConfig
                });
              }
              return col;
            })
          });
        }
        return row;
      })
    });
    onChangeLayout(newLayout);
  };
  function onChangeItemBlockPopup(itemBlockPopup) {
    if (onChangeItem) {
      onChangeItem(getItemUpdatedSettingItemBlockPopup(item, itemBlockPopup));
    }
  }
  // Función para determinar si un item puede tener popup
  var canHavePopup = function canHavePopup(item) {
    // Lista de tipos de items que NO pueden tener popup
    var itemsWithoutPopup = [{
      type: 'text',
      family: 'impact',
      variant: 'teacher notes'
    }];
    // Verifica si el item actual está en la lista de items sin popup
    return !itemsWithoutPopup.some(function (restrictedItem) {
      return item.type === restrictedItem.type && item.family === restrictedItem.family && item.variant === restrictedItem.variant;
    });
  };
  return {
    t: t,
    paddingSizes: paddingSizes,
    columnWidth: columnWidth,
    columnPaddingLeft: columnPaddingLeft,
    columnPaddingRight: columnPaddingRight,
    defaultColumnWidth: defaultColumnWidth,
    getValueItemIsShowBorder: getValueItemIsShowBorder,
    getValueItemIsZoomOnClick: getValueItemIsZoomOnClick,
    getValueItemMediaWidth: getValueItemMediaWidth,
    getValueItemAlignImages: getValueItemAlignImages,
    getValueItemMintTitle: getValueItemMintTitle,
    getValueItemStepLabel: getValueItemStepLabel,
    getValueItemAudios: getValueItemAudios,
    getValueItemHiddenContent: getValueItemHiddenContent,
    getValueItemHiddenMultimedia: getValueItemHiddenMultimedia,
    getValueItemImagePosition: getValueItemImagePosition,
    getValueItemImageSize: getValueItemImageSize,
    onChangePaddingTop: onChangePaddingTop,
    onChangePaddingBottom: onChangePaddingBottom,
    onChangeMediaWidth: onChangeMediaWidth,
    onChangeAlignImages: onChangeAlignImages,
    onChangeBackgroundColor: onChangeBackgroundColor,
    onChangeTeacherOnly: onChangeTeacherOnly,
    onChangeShowBorder: onChangeShowBorder,
    onChangeZoomOnClick: onChangeZoomOnClick,
    onChangeMintTitle: onChangeMintTitle,
    onChangeStepLabel: onChangeStepLabel,
    onChangeAudios: onChangeAudios,
    onChangeHiddenContent: onChangeHiddenContent,
    onChangeHiddenMultimedia: onChangeHiddenMultimedia,
    onChangeImagePosition: onChangeImagePosition,
    onChangeImageSize: onChangeImageSize,
    onChangeColumnWidth: onChangeColumnWidth,
    onChangeColumnPaddingLeft: onChangeColumnPaddingLeft,
    onChangeColumnPaddingRight: onChangeColumnPaddingRight,
    onChangeItemBlockPopup: onChangeItemBlockPopup,
    enablePopups: enablePopups,
    enableRowColumnLayout: enableRowColumnLayout,
    enableBackgroundGradient: enableBackgroundGradient,
    canHavePopup: canHavePopup
  };
}

var SETTINGS_ALIGN_IMAGES$1 = {
  UNSPECIFIED: 'Unspecified',
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};
var SettingAlignImages = function SettingAlignImages(_ref) {
  var valueSelected = _ref.valueSelected,
    onChange = _ref.onChange,
    showOptionUnspecified = _ref.showOptionUnspecified;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var options = [].concat(showOptionUnspecified ? [{
    value: SETTINGS_ALIGN_IMAGES$1.UNSPECIFIED,
    name: t('Unspecified', {
      ns: 'editor'
    })
  }] : [], [{
    value: SETTINGS_ALIGN_IMAGES$1.LEFT,
    name: t('Left', {
      ns: 'editor'
    })
  }, {
    value: SETTINGS_ALIGN_IMAGES$1.CENTER,
    name: t('Center', {
      ns: 'editor'
    })
  }, {
    value: SETTINGS_ALIGN_IMAGES$1.RIGHT,
    name: t('Right', {
      ns: 'editor'
    })
  }]);
  return /*#__PURE__*/React__default.createElement(SettingsDropdown, {
    valueSelected: valueSelected,
    onChange: onChange,
    label: t('Image alignment', {
      ns: 'editor'
    })
  }, options);
};
SettingAlignImages.propTypes = {
  showOptionUnspecified: PropTypes.bool
};
SettingAlignImages.defaultProps = {
  showOptionUnspecified: true
};

var MAX_NUM_FAVORITE_COLORS = 16;
function useColorPicker(props) {
  var background = props.background,
    onChange = props.onChange,
    defaultBackground = props.defaultBackground;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    favoriteColors = _useGeneral.favoriteColors,
    configFavoriteColors = _useGeneral.configFavoriteColors;
  var _useState = useState({
      displayColorPicker: false,
      background: props.background,
      favoriteColors: favoriteColors
    }),
    state = _useState[0],
    dispatch = _useState[1];
  var debouncedChangeBackground = useDebounce(state.background, 1000); //== debouncedSearch va a tener el valor de state.text en el momento en que reaccionara internamente useDebounce y devolverá otro debouncedSearch
  useEffect(function () {
    // == Verifico que siga siendo igual que lo que hay ahora en el state.text, en caso de haber cambiado ya se invocará de nuevo al
    if (debouncedChangeBackground === state.background) {
      onChange(state.background);
    }
  }, [debouncedChangeBackground]);
  useEffect(function () {
    var sidebarContent = document.getElementById(MINT_ID_BLOCKS_SIDEBAR_CONTENT);
    if (sidebarContent) {
      if (state.displayColorPicker) {
        addClass(sidebarContent, MINT_BLOCKS_SIDEBAR_CONTENT_COLOR_PICKER_VISIBLE);
      } else {
        removeClass(sidebarContent, MINT_BLOCKS_SIDEBAR_CONTENT_COLOR_PICKER_VISIBLE);
      }
    }
  }, [state.displayColorPicker]);
  useEffect(function () {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        favoriteColors: favoriteColors
      });
    });
  }, [favoriteColors]);
  var styles = reactCSS({
    default: {
      color: {
        width: '28px',
        height: '28px',
        borderRadius: '3px',
        background: "" + state.background,
        boxShadow: '0px 0px 0px 1px rgba(0, 0, 0, 0.1)'
      },
      swatch: {
        padding: '.4em 1.2em',
        background: '#fff',
        borderRadius: '3px',
        display: 'inline-block',
        cursor: 'pointer',
        fontSize: '.9rem'
      },
      popover: {
        position: 'absolute',
        zIndex: '2'
      },
      cover: {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px'
      }
    }
  });
  useEffect(function () {
    if (background !== state.background) {
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          background: background
        });
      });
    }
  }, [background]);
  /**
   * Devuelve true si tiene valor de color de fondo
   */
  function hasBackgroundColor() {
    return state.background && state.background.length > 0;
  }
  function rgbaToHex(r, g, b, a) {
    var toHex = function toHex(value) {
      var hex = Math.round(value * 255).toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    };
    // Si alpha es 1 (opaco), devolvemos el formato hex de 6 dígitos
    if (a === 1) {
      return ['#', toHex(r / 255), toHex(g / 255), toHex(b / 255)].join('').toUpperCase();
    }
    // Si tiene transparencia, usamos el formato de 8 dígitos
    return ['#', toHex(r / 255), toHex(g / 255), toHex(b / 255), toHex(a)].join('').toUpperCase();
  }
  var handleChangeComplete = function handleChangeComplete(color) {
    var _color$rgb = color.rgb,
      r = _color$rgb.r,
      g = _color$rgb.g,
      b = _color$rgb.b,
      a = _color$rgb.a;
    var hexColor = rgbaToHex(r, g, b, a);
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        background: hexColor
      });
    });
  };
  function handleChangeCompletePicker(color) {
    handleChangeComplete(color);
    addNewFavoriteColor(state.background);
  }
  function handleClick() {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        displayColorPicker: !prevState.displayColorPicker
      });
    });
  }
  function handleClose() {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        displayColorPicker: false
      });
    });
  }
  function handleClear(e) {
    e.preventDefault();
    e.stopPropagation();
    // En lugar de enviar un color con alpha 0, enviamos una cadena vacía
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        background: ''
      });
    });
    onChange('');
  }
  function onChangeHexInput(value) {
    var colorHex = value;
    if (!colorHex.startsWith('#') && colorHex.length > 0) colorHex = '#' + colorHex;
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        background: colorHex
      });
    });
  }
  function onBlurInput() {
    addNewFavoriteColor(state.background);
  }
  function addNewFavoriteColor(newColor) {
    var newColors = state.favoriteColors;
    if (newColor.length > 0 && newColors.indexOf(newColor) < 0) {
      newColors.push(newColor);
      newColors = newColors.slice(Math.max(newColors.length - MAX_NUM_FAVORITE_COLORS, 0));
      ConfigGlobalSingleton.getInstance().setFavoriteColors(newColors);
      configFavoriteColors == null || configFavoriteColors.setFavoriteColors == null || configFavoriteColors.setFavoriteColors(newColors, function (colors) {
        // == Los que me manden en success son los que voy a poner por si en esa funcion hay algun tipo de logica yo persisto lo que me digan
        ConfigGlobalSingleton.getInstance().setFavoriteColors(colors);
      }, function (error) {});
    }
  }
  var handleInheritFromLayout = function handleInheritFromLayout() {
    onChange('default-row-background-layout');
  };
  var getDisplayedColor = function getDisplayedColor() {
    if (background === 'default-row-background-layout' && defaultBackground) {
      return t('editor:row_settings_default_background', {
        color: defaultBackground
      });
    }
    return background;
  };
  return {
    t: t,
    styles: styles,
    handleClick: handleClick,
    hasBackgroundColor: hasBackgroundColor,
    backgroundState: state.background,
    handleClear: handleClear,
    displayColorPicker: state.displayColorPicker,
    handleClose: handleClose,
    handleChangeCompletePicker: handleChangeCompletePicker,
    onChangeInput: onChangeHexInput,
    favoriteColors: state.favoriteColors,
    onBlurInput: onBlurInput,
    color: state.background,
    setColor: handleChangeComplete,
    showInheritOption: props.showInheritOption,
    defaultBackground: props.defaultBackground,
    handleInheritFromLayout: handleInheritFromLayout,
    displayedColor: getDisplayedColor()
  };
}

var ColorPicker = function ColorPicker(props) {
  var _useColorPicker = useColorPicker(props),
    t = _useColorPicker.t,
    styles = _useColorPicker.styles,
    handleClick = _useColorPicker.handleClick,
    hasBackgroundColor = _useColorPicker.hasBackgroundColor,
    displayedColor = _useColorPicker.displayedColor,
    handleClear = _useColorPicker.handleClear,
    displayColorPicker = _useColorPicker.displayColorPicker,
    handleClose = _useColorPicker.handleClose,
    handleChangeCompletePicker = _useColorPicker.handleChangeCompletePicker,
    onChangeInput = _useColorPicker.onChangeInput,
    onBlurInput = _useColorPicker.onBlurInput,
    favoriteColors = _useColorPicker.favoriteColors;
  var pickerRef = useRef(null);
  useEffect(function () {
    if (!displayColorPicker) return;
    function handleClickOutside(event) {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        handleClose();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [displayColorPicker, handleClose]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-color-picker'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "mint-color-picker__select form-select--primary" + (props.hideBorder ? ' mint-color-picker__select--no-border' : ''),
    style: styles.swatch
  }, /*#__PURE__*/React__default.createElement("div", {
    style: styles.color,
    onClick: handleClick
  }), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-color-picker__hex'
  }, /*#__PURE__*/React__default.createElement(InputText, {
    textInput: displayedColor || '',
    placeholder: displayedColor ? displayedColor : '#000000',
    onChange: onChangeInput,
    onBlur: onBlurInput
  }), !props.hideClear && hasBackgroundColor() ? /*#__PURE__*/React__default.createElement("a", {
    href: '',
    onClick: handleClear,
    className: 'mint-color-picker__clear'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-color-picker__clear-text'
  }, t('editor:clear_background'))) : '')), displayColorPicker ? /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-color-picker__picker',
    style: styles.popover,
    ref: pickerRef
  }, /*#__PURE__*/React__default.createElement(SketchPicker, {
    color: displayedColor,
    onChange: handleChangeCompletePicker,
    presetColors: favoriteColors,
    disableAlpha: false
  })) : null);
};

var DEFAULT_SOLID = '';
var DEFAULT_GRADIENT_FROM = '#FFFFFF';
var DEFAULT_GRADIENT_TO = '#000000';
function isGradient(bg) {
  return bg.startsWith('linear-gradient');
}
function parseGradient(bg) {
  var match = bg.match(/linear-gradient\(.*?,\s*(#[0-9A-Fa-f]{6,8}),\s*(#[0-9A-Fa-f]{6,8})\)/);
  return match ? {
    from: match[1],
    to: match[2]
  } : {
    from: DEFAULT_GRADIENT_FROM,
    to: DEFAULT_GRADIENT_TO
  };
}
function useBackgroundColorPicker(background, onChange, defaultBackground) {
  var _useState = useState(isGradient(background) ? 'gradient' : 'solid'),
    type = _useState[0],
    setTypeState = _useState[1];
  var _useState2 = useState(!isGradient(background) ? background : DEFAULT_SOLID),
    solid = _useState2[0],
    setSolidState = _useState2[1];
  var _useState3 = useState(isGradient(background) ? parseGradient(background) : {
      from: DEFAULT_GRADIENT_FROM,
      to: DEFAULT_GRADIENT_TO
    }),
    gradient = _useState3[0],
    setGradientState = _useState3[1];
  // Sincroniza el valor externo si cambia desde fuera
  useEffect(function () {
    setTypeState(isGradient(background) ? 'gradient' : 'solid');
    if (isGradient(background)) {
      setGradientState(parseGradient(background));
    } else {
      setSolidState(background);
    }
  }, [background]);
  var setType = function setType(newType) {
    setTypeState(newType);
    if (newType === 'solid') {
      onChange(solid);
    } else {
      onChange("linear-gradient(90deg, " + gradient.from + ", " + gradient.to + ")");
    }
  };
  var setSolid = function setSolid(color) {
    setSolidState(color);
    if (type === 'solid') onChange(color);
  };
  var setGradient = function setGradient(key, color) {
    var _extends2;
    var newGradient = _extends({}, gradient, (_extends2 = {}, _extends2[key] = color, _extends2));
    setGradientState(newGradient);
    if (type === 'gradient') onChange("linear-gradient(90deg, " + newGradient.from + ", " + newGradient.to + ")");
  };
  var clearSolidState = function clearSolidState() {
    setSolidState('');
  };
  var clearGradientState = function clearGradientState() {
    setGradientState({
      from: DEFAULT_GRADIENT_FROM,
      to: DEFAULT_GRADIENT_TO
    });
  };
  // Lógica para determinar los valores por defecto
  var defaultSolidBackground = defaultBackground || DEFAULT_SOLID;
  var defaultGradientFrom = DEFAULT_GRADIENT_FROM;
  var defaultGradientTo = DEFAULT_GRADIENT_TO;
  if (defaultBackground && defaultBackground.startsWith('linear-gradient')) {
    var parsedGradient = parseGradient(defaultBackground);
    defaultGradientFrom = parsedGradient.from;
    defaultGradientTo = parsedGradient.to;
  } else if (defaultBackground) {
    defaultSolidBackground = defaultBackground;
  }
  return {
    type: type,
    setType: setType,
    solid: solid,
    setSolid: setSolid,
    gradient: gradient,
    setGradient: setGradient,
    defaultSolidBackground: defaultSolidBackground,
    defaultGradientFrom: defaultGradientFrom,
    defaultGradientTo: defaultGradientTo,
    clearSolidState: clearSolidState,
    clearGradientState: clearGradientState
  };
}

var ColorTypeButton = function ColorTypeButton(_ref) {
  var active = _ref.active,
    onClick = _ref.onClick,
    icon = _ref.icon,
    text = _ref.text;
  return /*#__PURE__*/React__default.createElement("button", {
    type: 'button',
    className: "mint-color-type-button " + (active ? 'mint-color-type-button--active' : ''),
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'mint-color-type-button__icon'
  }, icon), /*#__PURE__*/React__default.createElement("span", {
    className: 'mint-color-type-button__text'
  }, text));
};

var _g$j;
function _extends$N() { _extends$N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }
var SvgFrame = function SvgFrame(props) {
  return /*#__PURE__*/createElement("svg", _extends$N({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$j || (_g$j = /*#__PURE__*/createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/createElement("path", {
    id: "Vector",
    d: "M19.5847 5.28122C18.163 3.88264 16.3597 2.93548 14.4013 2.5588C12.4429 2.18211 10.4169 2.39271 8.5778 3.16411C6.73877 3.93552 5.16878 5.23331 4.06514 6.89439C2.96151 8.55549 2.3735 10.5057 2.375 12.5C2.375 16.6925 4.9625 20.2109 9.125 21.6818C9.63403 21.8618 10.1788 21.917 10.7137 21.8429C11.2485 21.7687 11.7577 21.5673 12.1985 21.2555C12.6394 20.9438 12.999 20.5309 13.2472 20.0514C13.4954 19.5719 13.625 19.0399 13.625 18.5C13.625 18.2016 13.7435 17.9155 13.9545 17.7045C14.1655 17.4935 14.4517 17.375 14.75 17.375H19.0822C19.8479 17.3786 20.5918 17.1202 21.1903 16.6427C21.7889 16.1651 22.2062 15.4973 22.3729 14.75C22.5467 13.9838 22.6313 13.2002 22.625 12.4147C22.6158 11.0836 22.3423 9.76757 21.8203 8.54297C21.2984 7.31845 20.5385 6.20975 19.5847 5.28122ZM20.1791 14.2503C20.1232 14.499 19.984 14.7211 19.7844 14.8797C19.5849 15.0383 19.3371 15.1238 19.0822 15.1222H14.75C13.8549 15.1222 12.9964 15.4778 12.3635 16.1107C11.7306 16.7436 11.375 17.6021 11.375 18.4972C11.3748 18.677 11.3315 18.8543 11.2486 19.0139C11.1658 19.1735 11.0459 19.311 10.899 19.4148C10.7521 19.5185 10.5824 19.5856 10.4043 19.6103C10.2261 19.6349 10.0446 19.6165 9.875 19.5566C8.3141 19.0053 7.00157 18.0791 6.08 16.8791C5.12267 15.6212 4.61081 14.0807 4.625 12.5C4.6249 10.4255 5.44337 8.43467 6.90263 6.96015C8.36188 5.48562 10.3441 4.64646 12.4185 4.62497H12.5C14.5745 4.63342 16.5626 5.45672 18.0357 6.91737C19.5088 8.37804 20.349 10.3591 20.375 12.4334C20.3801 13.0458 20.3143 13.6568 20.1791 14.2541V14.2503ZM14 7.62497C14 7.92165 13.912 8.21169 13.7472 8.45837C13.5824 8.70504 13.3481 8.89727 13.0741 9.01082C12.7999 9.12429 12.4984 9.15407 12.2074 9.09617C11.9164 9.03827 11.6491 8.89539 11.4394 8.68562C11.2296 8.47584 11.0867 8.20862 11.0288 7.91761C10.971 7.62664 11.0007 7.32504 11.1142 7.05095C11.2277 6.77686 11.42 6.5426 11.6667 6.37777C11.9134 6.21295 12.2033 6.12498 12.5 6.12498C12.8978 6.12498 13.2793 6.28302 13.5607 6.56432C13.842 6.84562 14 7.22715 14 7.62497ZM9.875 9.87497C9.875 10.1717 9.78703 10.4617 9.62218 10.7084C9.4574 10.955 9.2231 11.1473 8.94905 11.2608C8.67493 11.3743 8.37335 11.4041 8.08235 11.3462C7.7914 11.2883 7.52413 11.1454 7.31435 10.9356C7.10457 10.7258 6.9617 10.4586 6.90383 10.1676C6.84595 9.87662 6.87566 9.57504 6.98918 9.30092C7.10272 9.02687 7.29498 8.79257 7.54165 8.62779C7.78832 8.46294 8.0783 8.37497 8.375 8.37497C8.7728 8.37497 9.15433 8.53299 9.43565 8.81432C9.71698 9.09564 9.875 9.47717 9.875 9.87497ZM9.875 15.125C9.875 15.4217 9.78703 15.7117 9.62218 15.9584C9.4574 16.205 9.2231 16.3973 8.94905 16.5108C8.67493 16.6243 8.37335 16.6541 8.08235 16.5962C7.7914 16.5383 7.52413 16.3954 7.31435 16.1856C7.10457 15.9758 6.9617 15.7086 6.90383 15.4176C6.84595 15.1266 6.87566 14.825 6.98918 14.5509C7.10272 14.2769 7.29498 14.0426 7.54165 13.8778C7.78832 13.7129 8.0783 13.625 8.375 13.625C8.7728 13.625 9.15433 13.783 9.43565 14.0643C9.71698 14.3456 9.875 14.7272 9.875 15.125ZM18.125 9.87497C18.125 10.1717 18.037 10.4617 17.8722 10.7084C17.7074 10.955 17.4731 11.1473 17.1991 11.2608C16.9249 11.3743 16.6234 11.4041 16.3324 11.3462C16.0414 11.2883 15.7741 11.1454 15.5644 10.9356C15.3546 10.7258 15.2117 10.4586 15.1538 10.1676C15.096 9.87662 15.1257 9.57504 15.2392 9.30092C15.3527 9.02687 15.545 8.79257 15.7917 8.62779C16.0384 8.46294 16.3283 8.37497 16.625 8.37497C17.0228 8.37497 17.4043 8.53299 17.6857 8.81432C17.967 9.09564 18.125 9.47717 18.125 9.87497Z",
    fill: "#333333"
  }))));
};

var _g$k;
function _extends$O() { _extends$O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }
var SvgGradient = function SvgGradient(props) {
  return /*#__PURE__*/createElement("svg", _extends$O({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$k || (_g$k = /*#__PURE__*/createElement("g", {
    id: "Gradient"
  }, /*#__PURE__*/createElement("path", {
    id: "Vector",
    d: "M2.375 10.625C2.375 10.3266 2.49353 10.0405 2.7045 9.8295C2.91548 9.61853 3.20163 9.5 3.5 9.5H10.625C10.9234 9.5 11.2095 9.61853 11.4205 9.8295C11.6315 10.0405 11.75 10.3266 11.75 10.625C11.75 10.9234 11.6315 11.2095 11.4205 11.4205C11.2095 11.6315 10.9234 11.75 10.625 11.75H3.5C3.20163 11.75 2.91548 11.6315 2.7045 11.4205C2.49353 11.2095 2.375 10.9234 2.375 10.625ZM21.5 9.5H14.375C14.0766 9.5 13.7905 9.61853 13.5795 9.8295C13.3685 10.0405 13.25 10.3266 13.25 10.625C13.25 10.9234 13.3685 11.2095 13.5795 11.4205C13.7905 11.6315 14.0766 11.75 14.375 11.75H21.5C21.7984 11.75 22.0845 11.6315 22.2955 11.4205C22.5065 11.2095 22.625 10.9234 22.625 10.625C22.625 10.3266 22.5065 10.0405 22.2955 9.8295C22.0845 9.61853 21.7984 9.5 21.5 9.5ZM6.875 13.25H3.5C3.20163 13.25 2.91548 13.3685 2.7045 13.5795C2.49353 13.7905 2.375 14.0766 2.375 14.375C2.375 14.6734 2.49353 14.9595 2.7045 15.1705C2.91548 15.3815 3.20163 15.5 3.5 15.5H6.875C7.17337 15.5 7.45952 15.3815 7.6705 15.1705C7.88147 14.9595 8 14.6734 8 14.375C8 14.0766 7.88147 13.7905 7.6705 13.5795C7.45952 13.3685 7.17337 13.25 6.875 13.25ZM21.5 13.25H18.125C17.8266 13.25 17.5405 13.3685 17.3295 13.5795C17.1185 13.7905 17 14.0766 17 14.375C17 14.6734 17.1185 14.9595 17.3295 15.1705C17.5405 15.3815 17.8266 15.5 18.125 15.5H21.5C21.7984 15.5 22.0845 15.3815 22.2955 15.1705C22.5065 14.9595 22.625 14.6734 22.625 14.375C22.625 14.0766 22.5065 13.7905 22.2955 13.5795C22.0845 13.3685 21.7984 13.25 21.5 13.25ZM9.5 14.375C9.5 14.6734 9.61853 14.9595 9.8295 15.1705C10.0405 15.3815 10.3266 15.5 10.625 15.5H14.375C14.6734 15.5 14.9595 15.3815 15.1705 15.1705C15.3815 14.9595 15.5 14.6734 15.5 14.375C15.5 14.0766 15.3815 13.7905 15.1705 13.5795C14.9595 13.3685 14.6734 13.25 14.375 13.25H10.625C10.3266 13.25 10.0405 13.3685 9.8295 13.5795C9.61853 13.7905 9.5 14.0766 9.5 14.375ZM5.375 17H3.5C3.20163 17 2.91548 17.1185 2.7045 17.3295C2.49353 17.5405 2.375 17.8266 2.375 18.125C2.375 18.4234 2.49353 18.7095 2.7045 18.9205C2.91548 19.1315 3.20163 19.25 3.5 19.25H5.375C5.67337 19.25 5.95952 19.1315 6.1705 18.9205C6.38147 18.7095 6.5 18.4234 6.5 18.125C6.5 17.8266 6.38147 17.5405 6.1705 17.3295C5.95952 17.1185 5.67337 17 5.375 17ZM10.625 17H9.125C8.82663 17 8.54048 17.1185 8.3295 17.3295C8.11853 17.5405 8 17.8266 8 18.125C8 18.4234 8.11853 18.7095 8.3295 18.9205C8.54048 19.1315 8.82663 19.25 9.125 19.25H10.625C10.9234 19.25 11.2095 19.1315 11.4205 18.9205C11.6315 18.7095 11.75 18.4234 11.75 18.125C11.75 17.8266 11.6315 17.5405 11.4205 17.3295C11.2095 17.1185 10.9234 17 10.625 17ZM15.875 17H14.375C14.0766 17 13.7905 17.1185 13.5795 17.3295C13.3685 17.5405 13.25 17.8266 13.25 18.125C13.25 18.4234 13.3685 18.7095 13.5795 18.9205C13.7905 19.1315 14.0766 19.25 14.375 19.25H15.875C16.1734 19.25 16.4595 19.1315 16.6705 18.9205C16.8815 18.7095 17 18.4234 17 18.125C17 17.8266 16.8815 17.5405 16.6705 17.3295C16.4595 17.1185 16.1734 17 15.875 17ZM21.5 17H19.625C19.3266 17 19.0405 17.1185 18.8295 17.3295C18.6185 17.5405 18.5 17.8266 18.5 18.125C18.5 18.4234 18.6185 18.7095 18.8295 18.9205C19.0405 19.1315 19.3266 19.25 19.625 19.25H21.5C21.7984 19.25 22.0845 19.1315 22.2955 18.9205C22.5065 18.7095 22.625 18.4234 22.625 18.125C22.625 17.8266 22.5065 17.5405 22.2955 17.3295C22.0845 17.1185 21.7984 17 21.5 17ZM3.5 8H21.5C21.7984 8 22.0845 7.88147 22.2955 7.6705C22.5065 7.45952 22.625 7.17337 22.625 6.875C22.625 6.57663 22.5065 6.29048 22.2955 6.0795C22.0845 5.86853 21.7984 5.75 21.5 5.75H3.5C3.20163 5.75 2.91548 5.86853 2.7045 6.0795C2.49353 6.29048 2.375 6.57663 2.375 6.875C2.375 7.17337 2.49353 7.45952 2.7045 7.6705C2.91548 7.88147 3.20163 8 3.5 8Z",
    fill: "#333333"
  }))));
};

var DisabledBackgroundGradientWarning = function DisabledBackgroundGradientWarning() {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-warning',
    style: {
      padding: '1rem',
      margin: '1rem 5%',
      backgroundColor: '#fff3cd',
      border: '1px solid #ffeeba',
      borderRadius: '8px'
    }
  }, /*#__PURE__*/React__default.createElement("p", null, t('warning_disable_background_gradient', {
    ns: 'editor'
  })));
};

var SettingBackgroundColor = function SettingBackgroundColor(_ref) {
  var background = _ref.background,
    onChange = _ref.onChange,
    defaultBackground = _ref.defaultBackground,
    _ref$enableBackground = _ref.enableBackgroundGradient,
    enableBackgroundGradient = _ref$enableBackground === void 0 ? false : _ref$enableBackground;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useBackgroundColorPi = useBackgroundColorPicker(background, function (background) {
      onChange(background);
    }, defaultBackground),
    type = _useBackgroundColorPi.type,
    setType = _useBackgroundColorPi.setType,
    solid = _useBackgroundColorPi.solid,
    setSolid = _useBackgroundColorPi.setSolid,
    gradient = _useBackgroundColorPi.gradient,
    setGradient = _useBackgroundColorPi.setGradient,
    defaultSolidBackground = _useBackgroundColorPi.defaultSolidBackground,
    defaultGradientFrom = _useBackgroundColorPi.defaultGradientFrom,
    defaultGradientTo = _useBackgroundColorPi.defaultGradientTo,
    clearSolidState = _useBackgroundColorPi.clearSolidState,
    clearGradientState = _useBackgroundColorPi.clearGradientState;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-background-color'
  }, /*#__PURE__*/React__default.createElement("label", {
    className: 'settings-item-label'
  }, t('Background Color', {
    ns: 'editor'
  })), enableBackgroundGradient && /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-background-color__type-tabs'
  }, /*#__PURE__*/React__default.createElement(ColorTypeButton, {
    active: type === 'solid',
    onClick: function onClick() {
      return setType('solid');
    },
    icon: /*#__PURE__*/React__default.createElement(SvgFrame, null),
    text: "S\xF3lido"
  }), /*#__PURE__*/React__default.createElement(ColorTypeButton, {
    active: type === 'gradient',
    onClick: function onClick() {
      return setType('gradient');
    },
    icon: /*#__PURE__*/React__default.createElement(SvgGradient, null),
    text: 'Degradado'
  })), type === 'solid' ? /*#__PURE__*/React__default.createElement(ColorPicker, {
    background: solid,
    defaultBackground: defaultSolidBackground,
    onChange: setSolid
  }) : enableBackgroundGradient ? /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-background-color__gradient-container'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-background-color__gradient-preview',
    style: {
      background: "linear-gradient(90deg, " + gradient.from + ", " + gradient.to + ")"
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-background-color__gradient-pickers form-select--primary',
    style: {
      display: 'flex',
      gap: 8,
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default.createElement(ColorPicker, {
    background: gradient.from,
    defaultBackground: defaultGradientFrom,
    onChange: function onChange(color) {
      return setGradient('from', color);
    },
    hideClear: true,
    hideBorder: true
  }), /*#__PURE__*/React__default.createElement(ColorPicker, {
    background: gradient.to,
    defaultBackground: defaultGradientTo,
    onChange: function onChange(color) {
      return setGradient('to', color);
    },
    hideClear: true,
    hideBorder: true
  }), /*#__PURE__*/React__default.createElement("a", {
    href: '#',
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      clearSolidState();
      clearGradientState();
      setType('solid');
      onChange('');
    },
    className: 'mint-color-picker__clear'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-color-picker__clear-text'
  }, t('editor:clear_background'))))) : /*#__PURE__*/React__default.createElement(DisabledBackgroundGradientWarning, null));
};

var SettingCheckbox = function SettingCheckbox(_ref) {
  var isChecked = _ref.isChecked,
    _onChange = _ref.onChange,
    label = _ref.label,
    text = _ref.text;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-checkbox'
  }, /*#__PURE__*/React__default.createElement("label", {
    className: 'settings-item-label'
  }, label), /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-checkbox-content'
  }, /*#__PURE__*/React__default.createElement("label", {
    className: 'settings-checkbox-content__label'
  }, /*#__PURE__*/React__default.createElement("input", {
    type: 'checkbox',
    checked: isChecked,
    onChange: function onChange(event) {
      return _onChange(event.target.checked);
    },
    className: 'settings-checkbox-content__input'
  }), text, /*#__PURE__*/React__default.createElement("span", {
    className: 'checkmark'
  }))));
};

var SETTINGS_IMAGE_WIDTH = {
  SMALL: '0',
  MEDIUM: '1',
  FULL_WIDTH: '2'
};
var SettingImageWidth = function SettingImageWidth(_ref) {
  var valueSelected = _ref.valueSelected,
    onChange = _ref.onChange;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var options = [{
    value: SETTINGS_IMAGE_WIDTH.SMALL,
    name: t('Small', {
      ns: 'editor'
    })
  }, {
    value: SETTINGS_IMAGE_WIDTH.MEDIUM,
    name: t('Medium', {
      ns: 'editor'
    })
  }, {
    value: SETTINGS_IMAGE_WIDTH.FULL_WIDTH,
    name: t('Full width', {
      ns: 'editor'
    })
  }];
  return /*#__PURE__*/React__default.createElement(SettingsDropdown, {
    valueSelected: valueSelected,
    onChange: onChange,
    label: t('Image width', {
      ns: 'editor'
    })
  }, options);
};
SettingImageWidth.propTypes = {
  showOptionUnspecified: PropTypes.bool
};
SettingImageWidth.defaultProps = {
  showOptionUnspecified: true
};

function SettingsStepLabel(_ref) {
  var stepLabel = _ref.stepLabel,
    onChange = _ref.onChange;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-step-label tab-settings-sidebar__item'
  }, /*#__PURE__*/React__default.createElement("label", {
    className: 'settings-item-label',
    title: t('help_step_number', {
      ns: 'editor'
    })
  }, t('Step Label', {
    ns: 'editor'
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-step-label_input'
  }, /*#__PURE__*/React__default.createElement(InputText, {
    textInput: stepLabel || '',
    onChange: onChange
  })));
}

function SettingZoomOnClick(_ref) {
  var isChecked = _ref.isChecked,
    _onChange = _ref.onChange;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-zoom-click'
  }, /*#__PURE__*/React__default.createElement("label", {
    className: 'settings-item-label'
  }, t('Zoom on Click', {
    ns: 'editor'
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-zoom-click-checkbox'
  }, /*#__PURE__*/React__default.createElement("label", {
    className: 'settings-zoom-click-checkbox__label'
  }, /*#__PURE__*/React__default.createElement("input", {
    type: 'checkbox',
    checked: isChecked,
    onChange: function onChange(event) {
      return _onChange(event.target.checked);
    },
    className: 'settings-zoom-click-checkbox__input'
  }), t('Enable zoom on image click', {
    ns: 'editor'
  }), /*#__PURE__*/React__default.createElement("span", {
    className: 'checkmark'
  }))));
}

var _path$t, _path2$b;
function _extends$P() { _extends$P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/createElement("svg", _extends$P({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$t || (_path$t = /*#__PURE__*/createElement("path", {
    d: "M13.5858 3.58579C14.3668 2.80474 15.6332 2.80474 16.4142 3.58579C17.1953 4.36683 17.1953 5.63316 16.4142 6.41421L15.6213 7.20711L12.7929 4.37868L13.5858 3.58579Z",
    fill: "#828282"
  })), _path2$b || (_path2$b = /*#__PURE__*/createElement("path", {
    d: "M11.3787 5.79289L3 14.1716V17H5.82842L14.2071 8.62132L11.3787 5.79289Z",
    fill: "#828282"
  })));
};

function useSettingWidth(props) {
  var width = props.width,
    onChange = props.onChange,
    defaultWidth = props.defaultWidth,
    widthOptions = props.widthOptions;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useState = useState(false),
    showCustomInput = _useState[0],
    setShowCustomInput = _useState[1];
  var _useState2 = useState(''),
    customValue = _useState2[0],
    setCustomValue = _useState2[1];
  var handleClickPredefined = function handleClickPredefined(value) {
    setShowCustomInput(false);
    setCustomValue('');
    if (width === value) {
      // == Si está pulsado se deselecciona
      onChange('');
    } else {
      onChange(value);
    }
  };
  var handleCustomWidth = function handleCustomWidth() {
    if (width === 'default-row-width-layout') {
      setCustomValue('');
    } else if (width && !widthOptions.includes(width)) {
      setCustomValue(width.replace('%', ''));
    } else {
      setCustomValue('');
    }
    setShowCustomInput(true);
  };
  var handleClear = function handleClear(e) {
    e.preventDefault();
    onChange('');
  };
  var handleInheritFromLayout = function handleInheritFromLayout() {
    onChange('default-row-width-layout');
  };
  var hasWidth = function hasWidth() {
    return width && width.length > 0;
  };
  var getDisplayedWidth = function getDisplayedWidth() {
    if (width === 'default-row-width-layout' && defaultWidth) {
      return t('editor:row_settings_default_width', {
        width: defaultWidth
      });
    }
    return width;
  };
  var handleCustomInputChange = function handleCustomInputChange(value) {
    var numericValue = value.replace(/[^0-9]/g, '');
    var num = parseInt(numericValue);
    if (numericValue === '') {
      setCustomValue('');
    } else if (!isNaN(num)) {
      if (num > 100) {
        setCustomValue('100');
      } else {
        setCustomValue(numericValue);
      }
    }
  };
  var handleCustomInputBlur = function handleCustomInputBlur() {
    setShowCustomInput(false);
    if (customValue === '') {
      if (width && !widthOptions.includes(width)) {
        onChange('');
      }
      return;
    }
    onChange(customValue + "%");
  };
  return {
    t: t,
    handleCustomWidth: handleCustomWidth,
    displayedWidth: getDisplayedWidth(),
    handleClear: handleClear,
    hasWidth: hasWidth,
    handleInheritFromLayout: handleInheritFromLayout,
    showCustomInput: showCustomInput,
    setShowCustomInput: setShowCustomInput,
    handleCustomInputChange: handleCustomInputChange,
    handleCustomInputBlur: handleCustomInputBlur,
    customValue: customValue,
    handleClickPredefined: handleClickPredefined
  };
}

var CustomWidthInput = /*#__PURE__*/forwardRef(function (props, ref) {
  var textInput = props.textInput,
    placeholder = props.placeholder,
    _onChange = props.onChange,
    onBlur = props.onBlur,
    onEnterPress = props.onEnterPress;
  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Enter' && onEnterPress) {
      onEnterPress();
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-custom-width-input'
  }, /*#__PURE__*/React__default.createElement("input", {
    ref: ref,
    type: 'text',
    value: textInput,
    placeholder: placeholder,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    onBlur: onBlur,
    onKeyDown: handleKeyDown
  }), /*#__PURE__*/React__default.createElement("span", {
    className: 'percent-symbol'
  }, "%"));
});

var EditIconWithCircle = function EditIconWithCircle() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'edit-icon-wrapper'
  }, /*#__PURE__*/React__default.createElement("svg", {
    className: 'circle',
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, /*#__PURE__*/React__default.createElement("circle", {
    cx: '10.0001',
    cy: '9.99961',
    r: '9.4'
  })), /*#__PURE__*/React__default.createElement(SvgPencil, {
    className: 'pencil-icon'
  }));
};

var SettingWidth = function SettingWidth(_ref) {
  var label = _ref.label,
    width = _ref.width,
    defaultWidth = _ref.defaultWidth,
    onChange = _ref.onChange,
    showInheritOption = _ref.showInheritOption,
    _ref$widthOptions = _ref.widthOptions,
    widthOptions = _ref$widthOptions === void 0 ? [{
      value: '25%',
      label: '25%'
    }, {
      value: '50%',
      label: '50%'
    }, {
      value: '75%',
      label: '75%'
    }, {
      value: '100%',
      label: '100%'
    }] : _ref$widthOptions,
    _ref$showCustomOption = _ref.showCustomOption,
    showCustomOption = _ref$showCustomOption === void 0 ? true : _ref$showCustomOption;
  var inputRef = useRef(null);
  var _useSettingWidth = useSettingWidth({
      width: width,
      defaultWidth: defaultWidth,
      showInheritOption: showInheritOption,
      onChange: onChange,
      widthOptions: widthOptions.map(function (opt) {
        return opt.value;
      })
    }),
    handleClickPredefined = _useSettingWidth.handleClickPredefined,
    handleCustomWidth = _useSettingWidth.handleCustomWidth,
    showCustomInput = _useSettingWidth.showCustomInput,
    handleCustomInputChange = _useSettingWidth.handleCustomInputChange,
    handleCustomInputBlur = _useSettingWidth.handleCustomInputBlur,
    customValue = _useSettingWidth.customValue;
  useEffect(function () {
    if (showCustomInput && inputRef.current) {
      inputRef.current.focus();
    }
  }, [showCustomInput]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-width'
  }, /*#__PURE__*/React__default.createElement("label", {
    className: 'settings-item-label'
  }, label), /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-item-width'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-item-width__buttons'
  }, widthOptions.map(function (option) {
    return /*#__PURE__*/React__default.createElement("button", {
      key: option.value,
      onClick: function onClick() {
        return handleClickPredefined(option.value);
      },
      className: !showCustomInput && width === option.value ? 'active' : ''
    }, option.label);
  }), showCustomOption && (showCustomInput ? /*#__PURE__*/React__default.createElement(CustomWidthInput, {
    ref: inputRef,
    textInput: customValue,
    placeholder: '',
    onChange: handleCustomInputChange,
    onBlur: handleCustomInputBlur,
    onEnterPress: handleCustomInputBlur
  }) : /*#__PURE__*/React__default.createElement("button", {
    onClick: handleCustomWidth,
    className: "mint-setting-width__custom-width-button " + (width && !widthOptions.map(function (opt) {
      return opt.value;
    }).includes(width) && width !== 'default-row-width-layout' ? 'active' : '')
  }, /*#__PURE__*/React__default.createElement("i", null, width && !widthOptions.map(function (opt) {
    return opt.value;
  }).includes(width) && width !== 'default-row-width-layout' ? width : ''), width && !widthOptions.map(function (opt) {
    return opt.value;
  }).includes(width) && width !== 'default-row-width-layout' && /*#__PURE__*/React__default.createElement(EditIconWithCircle, null), (!width || widthOptions.map(function (opt) {
    return opt.value;
  }).includes(width) || width === 'default-row-width-layout') && /*#__PURE__*/React__default.createElement(SvgPencil, null))))));
};

var SettingLayoutPadding = function SettingLayoutPadding(_ref) {
  var label = _ref.label,
    valueSelected = _ref.valueSelected,
    _onChange = _ref.onChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var paddingOptions = PADDING_LAYOUT_OPTIONS.map(function (option) {
    return {
      value: option.value,
      name: option.name.startsWith('row_settings_') ? t("editor:" + option.name) : option.name
    };
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-control'
  }, /*#__PURE__*/React__default.createElement(SettingsDropdown, {
    label: label,
    valueSelected: valueSelected,
    onChange: function onChange(value) {
      return _onChange(value);
    }
  }, paddingOptions));
};

function useSettingPopup(props) {
  var itemBlockPopup = props.itemBlockPopup,
    onChangeItemBlockPopup = props.onChangeItemBlockPopup,
    onShowPopupEditorFullscreen = props.onShowPopupEditorFullscreen;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useState = useState(itemBlockPopup !== undefined),
    isEnablePopup = _useState[0],
    setIsEnablePopup = _useState[1];
  var _useState2 = useState(itemBlockPopup == null ? void 0 : itemBlockPopup.buttonPosition),
    buttonPosition = _useState2[0],
    setButtonPosition = _useState2[1];
  var _useState3 = useState(itemBlockPopup == null ? void 0 : itemBlockPopup.triggerIcon),
    triggerIcon = _useState3[0],
    setTriggerIcon = _useState3[1];
  useEffect(function () {
    if (isEnablePopup && !buttonPosition) {
      setButtonPosition(IPopupButtonPosition.TOP_RIGHT);
    }
  }, [isEnablePopup]);
  useEffect(function () {
    if (isEnablePopup && !triggerIcon) {
      setTriggerIcon(IPopupTriggerIconType.ICON_LIGHT_BULB);
    }
  }, [isEnablePopup]);
  var onChangeIsEnablePopup = function onChangeIsEnablePopup(isChecked) {
    if (!isChecked && itemBlockPopup != null && itemBlockPopup.popup) {
      onChangeItemBlockPopup(undefined);
    }
    setIsEnablePopup(isChecked);
  };
  var onChangeButtonPosition = function onChangeButtonPosition(position) {
    setButtonPosition(position);
    if (itemBlockPopup != null && itemBlockPopup.popup) {
      onChangeItemBlockPopup({
        popup: itemBlockPopup.popup,
        buttonPosition: position,
        triggerIcon: itemBlockPopup.triggerIcon
      });
    }
  };
  var onChangeTriggerIcon = function onChangeTriggerIcon(icon) {
    setTriggerIcon(icon);
    if (itemBlockPopup != null && itemBlockPopup.popup) {
      onChangeItemBlockPopup({
        popup: itemBlockPopup.popup,
        buttonPosition: itemBlockPopup.buttonPosition,
        triggerIcon: icon
      });
    }
  };
  var onClickEditPopup = function onClickEditPopup() {
    onShowPopupEditorFullscreen(itemBlockPopup ? itemBlockPopup :
    // Si no existe itemblockPopup, se crea un nuevo popup, ya que si nunca se ha editado, no existe el itemblockPopup
    {
      popup: {
        guid: getGuid(),
        contents: []
      },
      buttonPosition: buttonPosition != null ? buttonPosition : IPopupButtonPosition.TOP_RIGHT,
      triggerIcon: triggerIcon != null ? triggerIcon : IPopupTriggerIconType.ICON_LIGHT_BULB
    }, onChangeItemBlockPopup);
  };
  return {
    t: t,
    isEnablePopup: isEnablePopup,
    onChangeIsEnablePopup: onChangeIsEnablePopup,
    buttonPosition: buttonPosition,
    onChangeButtonPosition: onChangeButtonPosition,
    onClickEditPopup: onClickEditPopup,
    triggerIcon: triggerIcon,
    onChangeTriggerIcon: onChangeTriggerIcon
  };
}

var PopupEnableControl = function PopupEnableControl(props) {
  var isEnablePopup = props.isEnablePopup,
    onChangeIsEnablePopup = props.onChangeIsEnablePopup;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-popup-enable-control'
  }, /*#__PURE__*/React__default.createElement("label", {
    className: 'settings-item-label'
  }, t('settings_popup_enable_control', {
    ns: 'editor'
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-popup-enable-control__radio'
  }, /*#__PURE__*/React__default.createElement("label", {
    className: 'mint-popup-enable-control__radio-label'
  }, /*#__PURE__*/React__default.createElement("input", {
    type: 'radio',
    name: 'zoomSetting',
    value: 'false',
    checked: isEnablePopup === false,
    onChange: function onChange() {
      return onChangeIsEnablePopup(false);
    },
    className: 'mint-popup-enable-control__radio-input'
  }), t('settings_popup_enable_control_not_include', {
    ns: 'editor'
  }), /*#__PURE__*/React__default.createElement("span", {
    className: 'mint-popup-enable-control__radio-mark'
  })), /*#__PURE__*/React__default.createElement("label", {
    className: 'mint-popup-enable-control__radio-label'
  }, /*#__PURE__*/React__default.createElement("input", {
    type: 'radio',
    name: 'zoomSetting',
    value: 'true',
    checked: isEnablePopup === true,
    onChange: function onChange() {
      return onChangeIsEnablePopup(true);
    },
    className: 'mint-popup-enable-control__radio-input'
  }), t('settings_popup_enable_control_include', {
    ns: 'editor'
  }), /*#__PURE__*/React__default.createElement("span", {
    className: 'mint-popup-enable-control__radio-mark'
  }))));
};

var POSITION_OPTIONS = [{
  value: IPopupButtonPosition.TOP_RIGHT,
  label: 'settings_popup_position_top_right'
}, {
  value: IPopupButtonPosition.TOP_LEFT,
  label: 'settings_popup_position_top_left'
}, {
  value: IPopupButtonPosition.BOTTOM_RIGHT,
  label: 'settings_popup_position_bottom_right'
}, {
  value: IPopupButtonPosition.BOTTOM_LEFT,
  label: 'settings_popup_position_bottom_left'
}];
var PopupButtonPosition = function PopupButtonPosition(_ref) {
  var position = _ref.position,
    _onChange = _ref.onChange;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var options = POSITION_OPTIONS.map(function (option) {
    return {
      value: option.value,
      name: t(option.label, {
        ns: 'editor'
      })
    };
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-popup-button-position'
  }, /*#__PURE__*/React__default.createElement(SettingsDropdown, {
    label: t('settings_popup_button_position', {
      ns: 'editor'
    }),
    valueSelected: position,
    onChange: function onChange(value) {
      return _onChange(value);
    }
  }, options));
};

var _excluded$2 = ["children", "extraclass", "modifier"];
var ModifiersIconTextButton;
(function (ModifiersIconTextButton) {
  ModifiersIconTextButton["PRIMARY"] = "primary";
  ModifiersIconTextButton["PRIMARY_ALL"] = "primary__all";
  ModifiersIconTextButton["PRIMARY_NO_BACKGROUND"] = "primary__no_background";
  ModifiersIconTextButton["PRIMARY_FIRST_BACK_WHITE"] = "primary__first_back_white";
})(ModifiersIconTextButton || (ModifiersIconTextButton = {}));
var IconTextButton = function IconTextButton(props) {
  var children = props.children,
    extraclass = props.extraclass,
    _props$modifier = props.modifier,
    modifier = _props$modifier === void 0 ? ModifiersIconTextButton.PRIMARY : _props$modifier,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$2); // == Le paso todos los props que venian excepto el modifier, extraclass y children
  return /*#__PURE__*/React__default.createElement("button", Object.assign({
    className: (extraclass || '') + " icon-text-button icon-text-button--" + modifier
  }, otherProps), children);
};

var TRIGGER_ICONS = [{
  type: IPopupTriggerIconType.ICON_LIGHT_BULB,
  Icon: SvgLightBulb
}, {
  type: IPopupTriggerIconType.ICON_PLUS,
  Icon: SvgPlusSm
}, {
  type: IPopupTriggerIconType.ICON_LIGHTNING_BOLT,
  Icon: SvgLightningBolt
}, {
  type: IPopupTriggerIconType.ICON_QUESTION_MARK_CIRCLE,
  Icon: SvgQuestionMarkCircle
}, {
  type: IPopupTriggerIconType.ICON_STAR,
  Icon: SvgStar
}, {
  type: IPopupTriggerIconType.ICON_HEART,
  Icon: SvgHeart
}, {
  type: IPopupTriggerIconType.ICON_LOCATION_MARKER,
  Icon: SvgLocationMarker
}, {
  type: IPopupTriggerIconType.ICON_SEARCH_CIRCLE,
  Icon: SvgSearchCircle
}, {
  type: IPopupTriggerIconType.ICON_EXCLAMATION_CIRCLE,
  Icon: SvgExclamationCircle
}];
var PopupTriggerButton = function PopupTriggerButton(_ref) {
  var triggerIcon = _ref.triggerIcon,
    onChangeTriggerIcon = _ref.onChangeTriggerIcon;
  var _useTranslation = useTranslation$1(),
    t = _useTranslation.t;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-popup-trigger'
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'mint-popup-trigger__title'
  }, t('popup_trigger_button_title', {
    ns: 'editor'
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-popup-trigger__icons'
  }, POPUP_TRIGGER_ICONS_ORDERED.map(function (type) {
    var icon = TRIGGER_ICONS.find(function (i) {
      return i.type === type;
    });
    if (!icon) return null;
    return /*#__PURE__*/React__default.createElement("button", {
      key: type,
      className: "mint-popup-trigger__icon-button " + (triggerIcon === type ? 'mint-popup-trigger__icon-button--active' : ''),
      onClick: function onClick() {
        return onChangeTriggerIcon(type);
      }
    }, /*#__PURE__*/React__default.createElement(icon.Icon, null));
  })));
};

var SettingPopup = function SettingPopup(props) {
  var _useSettingPopup = useSettingPopup(props),
    t = _useSettingPopup.t,
    isEnablePopup = _useSettingPopup.isEnablePopup,
    onChangeIsEnablePopup = _useSettingPopup.onChangeIsEnablePopup,
    buttonPosition = _useSettingPopup.buttonPosition,
    onChangeButtonPosition = _useSettingPopup.onChangeButtonPosition,
    onClickEditPopup = _useSettingPopup.onClickEditPopup,
    triggerIcon = _useSettingPopup.triggerIcon,
    onChangeTriggerIcon = _useSettingPopup.onChangeTriggerIcon;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'tab-settings-sidebar__content--full-width'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-settings-popup'
  }, /*#__PURE__*/React__default.createElement(PopupEnableControl, {
    isEnablePopup: isEnablePopup,
    onChangeIsEnablePopup: onChangeIsEnablePopup
  }), isEnablePopup && buttonPosition && triggerIcon && /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-settings-popup__wrapper-bottom'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-settings-popup__wrapper-bottom-content'
  }, /*#__PURE__*/React__default.createElement(PopupButtonPosition, {
    position: buttonPosition,
    onChange: onChangeButtonPosition
  }), /*#__PURE__*/React__default.createElement(PopupTriggerButton, {
    triggerIcon: triggerIcon,
    onChangeTriggerIcon: onChangeTriggerIcon
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-settings-popup__wrapper-bottom-button'
  }, /*#__PURE__*/React__default.createElement(IconTextButton, {
    onClick: onClickEditPopup,
    modifier: ModifiersIconTextButton.PRIMARY_FIRST_BACK_WHITE
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__icon'
  }, /*#__PURE__*/React__default.createElement(SvgPencil, null)), /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__text'
  }, t('settings_popup_edit_popup', {
    ns: 'editor'
  })))))));
};

var SETTING_PADDING_TOP = 'SETTING_PADDING_TOP';
var SETTING_PADDING_BUTTON = 'SETTING_PADDING_BUTTON';
var SETTING_BACKGROUND_COLOR = 'SETTING_BACKGROUND_COLOR';
var SETTING_SHOW_BORDER = 'SETTING_SHOW_BORDER';
var SETTING_ZOOM_ON_CLICK = 'SETTING_ZOOM_ON_CLICK';
var SETTING_IMAGE_WIDTH = 'SETTING_IMAGE_WIDTH';
var SETTING_ALIGN_IMAGES = 'SETTING_ALIGN_IMAGES';
var SETTING_STEP_LABEL = 'SETTING_STEP_LABEL';
var SETTING_IMAGE_SIZE = 'SETTING_IMAGE_SIZE';
var SETTING_IMAGE_POSITION = 'SETTING_IMAGE_POSITION';
var SETTING_TEACHER_ONLY = 'SETTING_TEACHER_ONLY';
var SETTING_COLUMN_WIDTH = 'SETTING_COLUMN_WIDTH';
var SETTING_COLUMN_PADDING_LEFT = 'SETTING_COLUMN_PADDING_LEFT';
var SETTING_COLUMN_PADDING_RIGHT = 'SETTING_COLUMN_PADDING_RIGHT';
var SETTING_POPUP = 'SETTING_POPUP';
var TabSettingsSidebar = function TabSettingsSidebar(props) {
  var listSettings = props.listSettings,
    backgroundColor = props.backgroundColor,
    paddingTop = props.paddingTop,
    paddingBottom = props.paddingBottom,
    _props$isTeacherOnly = props.isTeacherOnly,
    isTeacherOnly = _props$isTeacherOnly === void 0 ? false : _props$isTeacherOnly,
    optionsImageSizes = props.optionsImageSizes,
    onShowPopupEditorFullscreen = props.onShowPopupEditorFullscreen;
  var _useTabSettingsSideba = useTabSettingsSidebar(props),
    t = _useTabSettingsSideba.t,
    paddingSizes = _useTabSettingsSideba.paddingSizes,
    columnWidth = _useTabSettingsSideba.columnWidth,
    columnPaddingLeft = _useTabSettingsSideba.columnPaddingLeft,
    columnPaddingRight = _useTabSettingsSideba.columnPaddingRight,
    defaultColumnWidth = _useTabSettingsSideba.defaultColumnWidth,
    getValueItemIsShowBorder = _useTabSettingsSideba.getValueItemIsShowBorder,
    getValueItemIsZoomOnClick = _useTabSettingsSideba.getValueItemIsZoomOnClick,
    getValueItemMediaWidth = _useTabSettingsSideba.getValueItemMediaWidth,
    getValueItemAlignImages = _useTabSettingsSideba.getValueItemAlignImages,
    getValueItemStepLabel = _useTabSettingsSideba.getValueItemStepLabel,
    getValueItemImagePosition = _useTabSettingsSideba.getValueItemImagePosition,
    getValueItemImageSize = _useTabSettingsSideba.getValueItemImageSize,
    onChangePaddingTop = _useTabSettingsSideba.onChangePaddingTop,
    onChangePaddingBottom = _useTabSettingsSideba.onChangePaddingBottom,
    onChangeMediaWidth = _useTabSettingsSideba.onChangeMediaWidth,
    onChangeAlignImages = _useTabSettingsSideba.onChangeAlignImages,
    onChangeBackgroundColor = _useTabSettingsSideba.onChangeBackgroundColor,
    onChangeTeacherOnly = _useTabSettingsSideba.onChangeTeacherOnly,
    onChangeShowBorder = _useTabSettingsSideba.onChangeShowBorder,
    onChangeZoomOnClick = _useTabSettingsSideba.onChangeZoomOnClick,
    onChangeStepLabel = _useTabSettingsSideba.onChangeStepLabel,
    onChangeImagePosition = _useTabSettingsSideba.onChangeImagePosition,
    onChangeImageSize = _useTabSettingsSideba.onChangeImageSize,
    onChangeColumnWidth = _useTabSettingsSideba.onChangeColumnWidth,
    onChangeColumnPaddingLeft = _useTabSettingsSideba.onChangeColumnPaddingLeft,
    onChangeColumnPaddingRight = _useTabSettingsSideba.onChangeColumnPaddingRight,
    onChangeItemBlockPopup = _useTabSettingsSideba.onChangeItemBlockPopup,
    enablePopups = _useTabSettingsSideba.enablePopups,
    enableRowColumnLayout = _useTabSettingsSideba.enableRowColumnLayout,
    enableBackgroundGradient = _useTabSettingsSideba.enableBackgroundGradient,
    canHavePopup = _useTabSettingsSideba.canHavePopup;
  var settingsComponents = listSettings.map(function (setting, idx) {
    var _props$item;
    return setting === SETTING_PADDING_TOP ? /*#__PURE__*/React__default.createElement(SettingsDropdown, {
      key: "setting-control__" + idx,
      valueSelected: paddingTop,
      onChange: onChangePaddingTop,
      label: t('Padding Top', {
        ns: 'editor'
      })
    }, paddingSizes) : setting === SETTING_PADDING_BUTTON ? /*#__PURE__*/React__default.createElement(SettingsDropdown, {
      key: "setting-control__" + idx,
      valueSelected: paddingBottom,
      onChange: onChangePaddingBottom,
      label: t('Padding Bottom', {
        ns: 'editor'
      })
    }, paddingSizes) : setting === SETTING_BACKGROUND_COLOR ? /*#__PURE__*/React__default.createElement("div", {
      className: 'tab-settings-sidebar__content--full-width'
    }, /*#__PURE__*/React__default.createElement(SettingBackgroundColor, {
      key: setting,
      background: backgroundColor,
      onChange: onChangeBackgroundColor,
      enableBackgroundGradient: enableBackgroundGradient
    })) : setting === SETTING_TEACHER_ONLY ? /*#__PURE__*/React__default.createElement(SettingCheckbox, {
      key: setting,
      isChecked: isTeacherOnly,
      onChange: onChangeTeacherOnly,
      label: t('Visibility', {
        ns: 'editor'
      }),
      text: t('Teacher only', {
        ns: 'editor'
      })
    }) : setting === SETTING_SHOW_BORDER ? /*#__PURE__*/React__default.createElement(SettingCheckbox, {
      key: setting,
      isChecked: getValueItemIsShowBorder(),
      onChange: onChangeShowBorder,
      label: t('Border', {
        ns: 'editor'
      }),
      text: t('Show border', {
        ns: 'editor'
      })
    }) : setting === SETTING_ZOOM_ON_CLICK ? /*#__PURE__*/React__default.createElement(SettingZoomOnClick, {
      key: setting,
      isChecked: getValueItemIsZoomOnClick(),
      onChange: onChangeZoomOnClick
    }) : setting === SETTING_IMAGE_WIDTH ? /*#__PURE__*/React__default.createElement(SettingImageWidth, {
      key: setting,
      valueSelected: getValueItemMediaWidth(),
      onChange: onChangeMediaWidth
    }) : setting === SETTING_ALIGN_IMAGES ? /*#__PURE__*/React__default.createElement(SettingAlignImages, {
      key: setting,
      valueSelected: getValueItemAlignImages(),
      onChange: onChangeAlignImages,
      showOptionUnspecified: false
    }) : setting === SETTING_STEP_LABEL ? /*#__PURE__*/React__default.createElement(SettingsStepLabel, {
      key: setting,
      stepLabel: getValueItemStepLabel(),
      onChange: onChangeStepLabel
    }) : setting === SETTING_IMAGE_POSITION ? /*#__PURE__*/React__default.createElement(SettingImagePosition, {
      key: setting,
      valueSelected: getValueItemImagePosition(),
      onChange: onChangeImagePosition
    }) : setting === SETTING_IMAGE_SIZE ? /*#__PURE__*/React__default.createElement(SettingImageSize, {
      key: setting,
      valueSelected: getValueItemImageSize(),
      onChange: onChangeImageSize,
      optionsImageSizes: optionsImageSizes
    }) : setting === SETTING_COLUMN_WIDTH && enableRowColumnLayout ? /*#__PURE__*/React__default.createElement("div", {
      className: 'tab-settings-sidebar__content--full-width'
    }, /*#__PURE__*/React__default.createElement(SettingWidth, {
      key: setting,
      label: t('settings_column_width', {
        ns: 'editor'
      }),
      width: columnWidth || '',
      defaultWidth: defaultColumnWidth,
      onChange: function onChange(value) {
        if (onChangeColumnWidth) {
          onChangeColumnWidth(value);
        }
      },
      showInheritOption: true
    })) :
    //<SettingColumnWidth key={setting} valueSelected={getValueItemColumnWidth()} onChange={onChangeColumnWidth} />
    setting === SETTING_COLUMN_PADDING_LEFT && enableRowColumnLayout ? /*#__PURE__*/React__default.createElement(SettingLayoutPadding, {
      key: setting,
      label: t('editor:settings_column_padding_left'),
      valueSelected: columnPaddingLeft || '',
      onChange: function onChange(value) {
        if (onChangeColumnPaddingLeft) {
          onChangeColumnPaddingLeft(value);
        }
      }
    }) :
    //<SettingColumnPaddingLeft key={setting} valueSelected={getValueItemColumnPaddingLeft()} onChange={onChangeColumnPaddingLeft} />
    setting === SETTING_COLUMN_PADDING_RIGHT && enableRowColumnLayout ? /*#__PURE__*/React__default.createElement(SettingLayoutPadding, {
      key: setting,
      label: t('editor:settings_column_padding_right'),
      valueSelected: columnPaddingRight || '',
      onChange: function onChange(value) {
        if (onChangeColumnPaddingRight) {
          onChangeColumnPaddingRight(value);
        }
      }
    }) : setting === SETTING_POPUP && enablePopups && canHavePopup(props.item) ? /*#__PURE__*/React__default.createElement(SettingPopup, {
      key: setting,
      itemBlockPopup: (_props$item = props.item) == null ? void 0 : _props$item.popup,
      onShowPopupEditorFullscreen: onShowPopupEditorFullscreen,
      onChangeItemBlockPopup: onChangeItemBlockPopup
    }) :
    //<SettingColumnPaddingRight key={setting} valueSelected={getValueItemColumnPaddingRight()} onChange={onChangeColumnPaddingRight} />
    null;
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'tab-settings-sidebar'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'tab-settings-sidebar__content'
  }, settingsComponents));
};

var DEFAULT_SETTINGS = [SETTING_COLUMN_WIDTH, SETTING_PADDING_TOP, SETTING_PADDING_BUTTON, SETTING_COLUMN_PADDING_LEFT, SETTING_COLUMN_PADDING_RIGHT, SETTING_TEACHER_ONLY, SETTING_BACKGROUND_COLOR];
var DEFAULT_SETTINGS_END = [SETTING_POPUP];
function getSettingsTab(settingsAditional) {
  return [].concat(DEFAULT_SETTINGS, settingsAditional, DEFAULT_SETTINGS_END);
}
/**
 * Es el componente por defecto que va a tener casi todos los Itemblock en su componente TabsContentSettingsSidebar
 */
var TabsContentSettingsSidebarDefault = function TabsContentSettingsSidebarDefault(_ref) {
  var children = _ref.children,
    settingsAditional = _ref.settingsAditional,
    particularNameClassSection = _ref.particularNameClassSection,
    backgroundColor = _ref.backgroundColor,
    paddingTop = _ref.paddingTop,
    paddingBottom = _ref.paddingBottom,
    _ref$teacherOnly = _ref.teacherOnly,
    teacherOnly = _ref$teacherOnly === void 0 ? false : _ref$teacherOnly,
    item = _ref.item,
    onChangeItem = _ref.onChangeItem,
    classTabs = _ref.classTabs,
    optionsImageSizes = _ref.optionsImageSizes,
    t = _ref.t,
    layoutPosition = _ref.layoutPosition,
    layout = _ref.layout,
    onChangeLayout = _ref.onChangeLayout,
    onShowPopupEditorFullscreen = _ref.onShowPopupEditorFullscreen;
  var finalSettings = getSettingsTab(settingsAditional || []);
  return /*#__PURE__*/React__default.createElement(TabsContentSettingsSidebar, {
    t: t,
    classNameAdd: 'tabs-sidebar' + (hasData(particularNameClassSection) ? ' ' + particularNameClassSection + '__sidebar' : '')
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'children-content'
  }, /*#__PURE__*/React__default.createElement("section", {
    className: 'mint-tab-content-settings-sidebar ' + (classTabs || '')
  }, children)), /*#__PURE__*/React__default.createElement("div", {
    className: 'children-settings'
  }, /*#__PURE__*/React__default.createElement("section", {
    className: 'mint-tab-content-settings-sidebar'
  }, /*#__PURE__*/React__default.createElement(TabSettingsSidebar, {
    item: item,
    onChangeItem: onChangeItem,
    backgroundColor: backgroundColor,
    paddingTop: paddingTop,
    paddingBottom: paddingBottom,
    listSettings: finalSettings,
    isTeacherOnly: teacherOnly,
    optionsImageSizes: optionsImageSizes,
    layoutPosition: layoutPosition,
    layout: layout,
    onChangeLayout: onChangeLayout,
    onShowPopupEditorFullscreen: onShowPopupEditorFullscreen
  }))));
};

function TabsOnlySettingsSidebar(props) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var settingsAditional = props.settingsAditional,
    backgroundColor = props.backgroundColor,
    paddingTop = props.paddingTop,
    paddingBottom = props.paddingBottom,
    item = props.item,
    onChangeItem = props.onChangeItem,
    layoutPosition = props.layoutPosition,
    layout = props.layout,
    onChangeLayout = props.onChangeLayout,
    onShowPopupEditorFullscreen = props.onShowPopupEditorFullscreen;
  var defaultSettings = getSettingsTab([]);
  var finalSettings = settingsAditional ? defaultSettings.concat(settingsAditional) : defaultSettings;
  return /*#__PURE__*/React__default.createElement(TabsModelA, {
    titleTabsList: [t('Settings')]
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'children-settings'
  }, /*#__PURE__*/React__default.createElement("section", {
    className: 'mint-tab-content-settings-sidebar'
  }, /*#__PURE__*/React__default.createElement(TabSettingsSidebar, {
    item: item,
    onChangeItem: onChangeItem,
    backgroundColor: backgroundColor,
    paddingTop: paddingTop,
    paddingBottom: paddingBottom,
    listSettings: finalSettings,
    layoutPosition: layoutPosition,
    layout: layout,
    onChangeLayout: onChangeLayout,
    onShowPopupEditorFullscreen: onShowPopupEditorFullscreen
  }))));
}

var _excluded$3 = ["renderContent", "particularNameClassSection", "classTabs", "settingsAditional", "isOnlySettings", "item", "onChangeItem", "t", "layoutPosition", "layout", "onChangeLayout", "optionsImageSizes", "onShowPopupEditorFullscreen"];
var EditorSidebar = function EditorSidebar(_ref) {
  var renderContent = _ref.renderContent,
    particularNameClassSection = _ref.particularNameClassSection,
    classTabs = _ref.classTabs,
    settingsAditional = _ref.settingsAditional,
    _ref$isOnlySettings = _ref.isOnlySettings,
    isOnlySettings = _ref$isOnlySettings === void 0 ? false : _ref$isOnlySettings,
    item = _ref.item,
    onChangeItem = _ref.onChangeItem,
    t = _ref.t,
    layoutPosition = _ref.layoutPosition,
    layout = _ref.layout,
    onChangeLayout = _ref.onChangeLayout,
    optionsImageSizes = _ref.optionsImageSizes,
    onShowPopupEditorFullscreen = _ref.onShowPopupEditorFullscreen,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  var settings = item == null ? void 0 : item.settings;
  if (isOnlySettings) {
    return /*#__PURE__*/React__default.createElement(TabsOnlySettingsSidebar, {
      backgroundColor: (settings == null ? void 0 : settings.backgroundColor) || '',
      paddingTop: settings != null && settings.paddingTop ? Number(settings.paddingTop) : '',
      paddingBottom: settings != null && settings.paddingBottom ? Number(settings.paddingBottom) : '',
      item: item,
      onChangeItem: onChangeItem,
      layoutPosition: layoutPosition,
      layout: layout,
      onChangeLayout: onChangeLayout,
      settingsAditional: settingsAditional,
      onShowPopupEditorFullscreen: onShowPopupEditorFullscreen
    });
  }
  return /*#__PURE__*/React__default.createElement(TabsContentSettingsSidebarDefault, {
    particularNameClassSection: particularNameClassSection,
    backgroundColor: (settings == null ? void 0 : settings.backgroundColor) || '',
    paddingTop: settings != null && settings.paddingTop ? Number(settings.paddingTop) : '',
    paddingBottom: settings != null && settings.paddingBottom ? Number(settings.paddingBottom) : '',
    teacherOnly: (settings == null ? void 0 : settings.teacherOnly) || false,
    item: item,
    onChangeItem: onChangeItem,
    t: t,
    layoutPosition: layoutPosition,
    layout: layout,
    onChangeLayout: onChangeLayout,
    classTabs: classTabs,
    settingsAditional: settingsAditional,
    optionsImageSizes: optionsImageSizes,
    onShowPopupEditorFullscreen: onShowPopupEditorFullscreen
  }, renderContent == null ? void 0 : renderContent(_extends({
    item: item,
    onChangeItem: onChangeItem,
    t: t,
    layoutPosition: layoutPosition,
    layout: layout,
    onChangeLayout: onChangeLayout,
    onShowPopupEditorFullscreen: onShowPopupEditorFullscreen
  }, restProps)));
};

var DividerEditorSidebar = function DividerEditorSidebar(props) {
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    isOnlySettings: true
  }));
};

function useDividerEditor(props) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  return {
    t: t
  };
}

var BaseEditor = function BaseEditor(_ref) {
  var item = _ref.item,
    onChangeItem = _ref.onChangeItem,
    getTextHtml = _ref.getTextHtml,
    mode = _ref.mode,
    t = _ref.t,
    layoutPosition = _ref.layoutPosition,
    layout = _ref.layout,
    onChangeLayout = _ref.onChangeLayout,
    renderSidebar = _ref.renderSidebar,
    renderSidebarSettings = _ref.renderSidebarSettings,
    renderContent = _ref.renderContent,
    onShowPopupEditorFullscreen = _ref.onShowPopupEditorFullscreen;
  var sidebarProps = {
    item: item,
    onChangeItem: onChangeItem,
    getTextHtml: getTextHtml,
    t: t,
    layoutPosition: layoutPosition,
    layout: layout,
    onChangeLayout: onChangeLayout,
    onShowPopupEditorFullscreen: onShowPopupEditorFullscreen
  };
  var sidebarSettingsProps = {
    item: item,
    onChangeItem: onChangeItem,
    getTextHtml: getTextHtml,
    t: t,
    layoutPosition: layoutPosition,
    layout: layout,
    onChangeLayout: onChangeLayout,
    onShowPopupEditorFullscreen: onShowPopupEditorFullscreen
  };
  var contentProps = {
    item: item,
    getTextHtml: getTextHtml,
    mode: mode
  };
  return mode === IModesItemBlock.MODE_EDITOR_FLOATING_SIDEBAR ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, renderSidebar(sidebarProps)) : mode === IModesItemBlock.MODE_EDITOR_SETTINGS_SIDEBAR && renderSidebarSettings ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, renderSidebarSettings(sidebarSettingsProps)) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, renderContent(contentProps));
};

var DividerEditor = function DividerEditor(props) {
  var _useDividerEditor = useDividerEditor();
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(DividerEditorSidebar, Object.assign({}, sidebarProps));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(Divider, Object.assign({}, contentProps));
    }
  }));
};

var SpacingDividerEditorSidebar = function SpacingDividerEditorSidebar(props) {
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    isOnlySettings: true
  }));
};

function useSpacingDividerEditor(props) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  return {
    t: t
  };
}

var SpacingDividerEditor = function SpacingDividerEditor(props) {
  var _useSpacingDividerEdi = useSpacingDividerEditor();
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(SpacingDividerEditorSidebar, Object.assign({}, sidebarProps));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(SpacingDivider, Object.assign({}, contentProps));
    }
  }));
};

var ITypeMediaFunctionEditor;
(function (ITypeMediaFunctionEditor) {
  ITypeMediaFunctionEditor["IMAGE"] = "IMAGE";
  ITypeMediaFunctionEditor["VIDEO"] = "VIDEO";
  ITypeMediaFunctionEditor["AUDIO"] = "AUDIO";
  ITypeMediaFunctionEditor["EMBED"] = "EMBED";
})(ITypeMediaFunctionEditor || (ITypeMediaFunctionEditor = {}));

function useAsideEditorItemBlockList(props) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    pathAssets = _useGeneral.pathAssets,
    folderBlockDefault = _useGeneral.folderBlockDefault;
  return {
    t: t,
    pathAssets: pathAssets,
    folderBlockDefault: folderBlockDefault
  };
}

var _path$u;
function _extends$Q() { _extends$Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }
var SvgDownArrow = function SvgDownArrow(props) {
  return /*#__PURE__*/createElement("svg", _extends$Q({
    id: "Capa_1",
    enableBackground: "new 0 0 451.111 451.111",
    height: 512,
    viewBox: "0 0 451.111 451.111",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$u || (_path$u = /*#__PURE__*/createElement("path", {
    d: "m370.556 209.445-112.778 112.777v-322.222h-64.444v322.222l-112.778-112.777-48.333 48.333 193.333 193.333 193.333-193.333z"
  })));
};

var _path$v;
function _extends$R() { _extends$R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }
var SvgTrash$2 = function SvgTrash(props) {
  return /*#__PURE__*/createElement("svg", _extends$R({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$v || (_path$v = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2C8.62123 2 8.27497 2.214 8.10557 2.55279L7.38197 4H4C3.44772 4 3 4.44772 3 5C3 5.55228 3.44772 6 4 6L4 16C4 17.1046 4.89543 18 6 18H14C15.1046 18 16 17.1046 16 16V6C16.5523 6 17 5.55228 17 5C17 4.44772 16.5523 4 16 4H12.618L11.8944 2.55279C11.725 2.214 11.3788 2 11 2H9ZM7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8V14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14V8ZM12 7C11.4477 7 11 7.44772 11 8V14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14V8C13 7.44772 12.5523 7 12 7Z"
  })));
};

var _path$w;
function _extends$S() { _extends$S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }
var SvgUpArrow = function SvgUpArrow(props) {
  return /*#__PURE__*/createElement("svg", _extends$S({
    id: "Capa_1",
    enableBackground: "new 0 0 451.111 451.111",
    height: 512,
    viewBox: "0 0 451.111 451.111",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$w || (_path$w = /*#__PURE__*/createElement("path", {
    d: "m418.889 193.333-193.333-193.333-193.334 193.333 48.333 48.333 112.778-112.778v322.222h64.444v-322.221l112.778 112.778z"
  })));
};

var _path$x;
function _extends$T() { _extends$T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$T.apply(this, arguments); }
var SvgDragHandler = function SvgDragHandler(props) {
  return /*#__PURE__*/createElement("svg", _extends$T({
    viewBox: "0 0 24 24"
  }, props), _path$x || (_path$x = /*#__PURE__*/createElement("path", {
    d: "M11,18c0,1.1-0.9,2-2,2s-2-0.9-2-2s0.9-2,2-2S11,16.9,11,18z M9,10c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S10.1,10,9,10z  M9,4C7.9,4,7,4.9,7,6s0.9,2,2,2s2-0.9,2-2S10.1,4,9,4z M15,8c1.1,0,2-0.9,2-2s-0.9-2-2-2s-2,0.9-2,2S13.9,8,15,8z M15,10 c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S16.1,10,15,10z M15,16c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S16.1,16,15,16z"
  })));
};

/**
 * Componente que nos pone una envoltura con los botones de eliminar un item, añadir un item y reordenar item mediante drag&drop
 * Si algun children tiene la propiedad isDragDisabled={true} entonces ese elemento no se puede mover
 * Si algun children tiene la propiedad isDeletedDisabled={true} entonces ese elemento no se puede eliminar
 * Si algun children tiene la propiedad header entonces ese elemento tiene dicho header
 @param children PropTypes.array.isRequired, // Hay un children por cada item.items con el contenido visual de cada fila
 @param item PropTypes.any.isRequired, // Sus items están en item.items
 @param hasChangedItem: PropTypes.func, // Funcion que se le llamara enviando como ha quedado el item actualizado despues de la acción
 @param getSubitemToAdd // props opcional, este parametro es para pasarle una funcion que devuelve el subitem que queremos añadir a la lista de items cuando le demos a add item
 */
var AsideEditorItemBlockList = function AsideEditorItemBlockList(props) {
  var item = props.item,
    items = props.items,
    hasChangedItem = props.hasChangedItem,
    textButtonAdd = props.textButtonAdd,
    getSubitemToAdd = props.getSubitemToAdd,
    children = props.children;
  var _useAsideEditorItemBl = useAsideEditorItemBlockList(),
    t = _useAsideEditorItemBl.t,
    pathAssets = _useAsideEditorItemBl.pathAssets,
    folderBlockDefault = _useAsideEditorItemBl.folderBlockDefault;
  var _useState = useState({
      showControls: -1
    }),
    state = _useState[0],
    dispatch = _useState[1];
  function onClickAddItem(e) {
    e.preventDefault();
    e.stopPropagation();
    if (hasChangedItem) {
      var itemUpdated;
      if (getSubitemToAdd) {
        var subitem = getSubitemToAdd();
        itemUpdated = getItemUpdatedPushSubitem(item, subitem);
      } else {
        itemUpdated = getItemUpdatedPushFirstSubitem(item, pathAssets, folderBlockDefault);
      }
      hasChangedItem(itemUpdated);
    }
  }
  function onClickRemove(e, id) {
    e.preventDefault();
    e.stopPropagation();
    if (hasChangedItem) {
      hasChangedItem(getItemUpdatedRemoveSubitem(item, id));
    }
  }
  function onDragEnd(result) {
    if (!result.destination) return;
    if (result.destination.index === result.source.index) return;
    var posInitial = result.source.index;
    var posFinal = result.destination.index;
    hasMoveSubitem(posInitial, posFinal, items);
  }
  function handleControls(e, idx) {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        showControls: e === 'mouseenter' ? idx : -1
      });
    });
  }
  /**
   * Le paso los items y cual es la posicion y final del que tiene que mover, y el resultado lo pone en item.items
   * @param {*} posInitial
   * @param {*} posFinal
   * @param {*} items
   */
  function hasMoveSubitem(posInitial, posFinal, items) {
    if (hasChangedItem) {
      hasChangedItem(getItemUpdatedMoveSubitem(item, items, posInitial, posFinal));
    }
  }
  function getIndexSubitem(subItem, _items) {
    if (item && _items && _items.length > 0) {
      var index = _items.findIndex(function (element) {
        return element.id === subItem.id;
      });
      return index;
    } else return -1;
  }
  function onClickUp(subItem) {
    var indexItemsProps = getIndexSubitem(subItem, items);
    if (indexItemsProps >= 0) {
      var posFinalItemsProps = indexItemsProps - 1;
      if (!isDragDisabled(posFinalItemsProps)) {
        hasMoveSubitem(indexItemsProps, posFinalItemsProps, items); // hasMoveSubitem tiene que ser de los items dentro de item, es decir postFinalItemsItem
        scrollToElement(posFinalItemsProps);
      }
    }
  }
  function onClickDown(subItem) {
    var indexItemsProps = getIndexSubitem(subItem, items);
    if (indexItemsProps >= 0) {
      var posFinalItemsProps = indexItemsProps + 1;
      if (!isDragDisabled(posFinalItemsProps)) {
        // isDragDisabled tiene que ser el indice de los que estas visualizando, es decir los de items
        hasMoveSubitem(indexItemsProps, posFinalItemsProps, items);
        scrollToElement(posFinalItemsProps);
      }
    }
  }
  function getChildrenByIndex(index) {
    var toRet;
    if (children && children.length && children.length >= index) {
      toRet = children[index];
    }
    return toRet;
  }
  /**
   * Index tiene que ser el indice de los que estas visualizando, es decir los de items
   * @param {*} index
   * @returns
   */
  function isDragDisabled(index) {
    var myChild = getChildrenByIndex(index);
    if (myChild) {
      var _isDragDisabled2 = myChild && myChild.props && myChild.props.isDragDisabled && myChild.props.isDragDisabled === true;
      return _isDragDisabled2;
    } else return true; // si no existe devuelvo que tiene desabilitado el arrastrar
  }

  function getTitleSubitem(index) {
    var toRet = '';
    var myChild = getChildrenByIndex(index);
    if (myChild && myChild.props && myChild.props.header) {
      toRet = myChild.props.header;
    } else {
      toRet = t('Item de lista');
    }
    return toRet;
  }
  function scrollToElement(index) {
    var element = document.getElementById('process_' + item.id + '_' + index);
    if (element) element.scrollIntoView();
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    id: 'aside-editor-list-content'
  }, /*#__PURE__*/React__default.createElement(DragDropContext, {
    onDragEnd: onDragEnd,
    className: 'aside-editor-list'
  }, /*#__PURE__*/React__default.createElement(Droppable, {
    droppableId: 'droppable'
  }, function (provided) {
    return /*#__PURE__*/React__default.createElement("div", Object.assign({
      ref: provided.innerRef
    }, provided.droppableProps), item && items ? items.map(function (itemInside, index) {
      var myChild = children[index];
      var _isDragDisabled = isDragDisabled(index);
      var isDeletedDisabled = myChild && myChild.props && myChild.props.isDeletedDisabled && myChild.props.isDeletedDisabled === true;
      var otherProps = {};
      if (_isDragDisabled === true) {
        otherProps.isDragDisabled = true;
      }
      var paintOnlyChild = myChild && myChild.props && myChild.props.paintOnlyChild && myChild.props.paintOnlyChild === true;
      return /*#__PURE__*/React__default.createElement(Element$1, {
        name: 'edit-process-' + itemInside.id,
        key: 'toscroll-' + itemInside.id
      }, /*#__PURE__*/React__default.createElement(Draggable, Object.assign({
        draggableId: itemInside.id
      }, otherProps, {
        index: index,
        key: itemInside.id
      }), function (provided) {
        return /*#__PURE__*/React__default.createElement("div", Object.assign({
          id: 'process_' + item.id + '_' + index,
          key: itemInside.id,
          ref: provided.innerRef
        }, provided.draggableProps, {
          className: ''
        }), !paintOnlyChild ? /*#__PURE__*/React__default.createElement("div", {
          className: 'aside-editor-item-list',
          onMouseEnter: function onMouseEnter(e) {
            return handleControls(e.type, index);
          },
          onMouseLeave: function onMouseLeave(e) {
            return handleControls(e.type, index);
          }
        }, /*#__PURE__*/React__default.createElement("div", {
          className: 'aside-editor-item-list__content'
        }, myChild), /*#__PURE__*/React__default.createElement("div", Object.assign({
          className: "aside-editor-item-list__controls " + (state.showControls === index && 'aside-editor-item-list__controls--show')
        }, provided.dragHandleProps), !_isDragDisabled && /*#__PURE__*/React__default.createElement(SvgDragHandler, {
          className: 'aside-editor-item-list__drag-handler'
        }), /*#__PURE__*/React__default.createElement("span", {
          className: 'aside-editor-item-list__header-text'
        }, getTitleSubitem(index)), !_isDragDisabled && !isDragDisabled(index - 1) && /*#__PURE__*/React__default.createElement(Button, {
          onClick: function onClick(e) {
            return onClickUp(itemInside);
          },
          variant: 'icon'
        }, /*#__PURE__*/React__default.createElement(SvgUpArrow, null)), !_isDragDisabled && !isDragDisabled(index + 1) && /*#__PURE__*/React__default.createElement(Button, {
          onClick: function onClick(e) {
            return onClickDown(itemInside);
          },
          variant: 'icon'
        }, /*#__PURE__*/React__default.createElement(SvgDownArrow, null)), !isDeletedDisabled && onClickRemove && /*#__PURE__*/React__default.createElement(Button, {
          onClick: function onClick(e) {
            return onClickRemove(e, itemInside.id);
          },
          variant: 'icon'
        }, /*#__PURE__*/React__default.createElement(SvgTrash$2, null)))) : /*#__PURE__*/React__default.createElement("div", {
          className: 'aside-editor-item-list__child'
        }, myChild));
      }));
    }) : '', provided.placeholder);
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: 'aside-editor-item-list__add-button-wrapper'
  }, /*#__PURE__*/React__default.createElement(Button, {
    onClick: onClickAddItem
  }, textButtonAdd || t('Add item', {
    ns: 'editor'
  }))));
};

/**
 * Selectores para obtener partes del elemento subitem
 */
function getSubitemSettingAlignImage(subItem) {
  return subItem && subItem.settings && subItem.settings.hasOwnProperty('alignImage') ? subItem.settings.alignImage : SETTINGS_ALIGN_IMAGES.UNSPECIFIED;
}
function getSubitemSettingImageSize(subItem) {
  return subItem && subItem.settings && subItem.settings.hasOwnProperty('imageSize') ? subItem.settings.imageSize : Object.prototype.hasOwnProperty.call(subItem, 'variant') ? subItem.variant == 'hero' ? SETTINGS_IMAGE_SIZE.EXTRA_LARGE : SETTINGS_IMAGE_SIZE.MEDIUM : SETTINGS_IMAGE_SIZE.EXTRA_LARGE;
}

function useImageAltTextSettingSidebar(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function imageAltTextUpdatedIndex(subItemImage, text, index, indexContents) {
    onChangeImageAltTextUpdatedIndex(text, subItemImage, item, index, indexContents, onChangeItem);
  }
  function imageAltTextUpdated(subItemImage, text) {
    onChangeImageAltTextUpdated(text, subItemImage, item, onChangeItem);
  }
  return {
    t: t,
    imageAltTextUpdatedIndex: imageAltTextUpdatedIndex,
    imageAltTextUpdated: imageAltTextUpdated
  };
}

/**
 * Emboltura para que un children tenga los estilos similares a Text Edtor
 * @param props
 * @returns
 */
function TextEditorStyledWrapper(props) {
  var children = props.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'text-editor-styled-wrapper'
  }, children);
}

/**
 * Elemento para configurar el texto alternativo de una imagen en el sidebar, contiene El label y el campo para rellenar el texto alternativo
 * @param props
 * @returns
 */
function ImageAltTextSettingSidebar(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem,
    getTextHtml = props.getTextHtml,
    subItemImage = props.subItemImage,
    _props$index = props.index,
    index = _props$index === void 0 ? undefined : _props$index,
    _props$indexContents = props.indexContents,
    indexContents = _props$indexContents === void 0 ? undefined : _props$indexContents;
  var _useImageAltTextSetti = useImageAltTextSettingSidebar({
      item: item,
      onChangeItem: onChangeItem
    }),
    t = _useImageAltTextSetti.t,
    imageAltTextUpdatedIndex = _useImageAltTextSetti.imageAltTextUpdatedIndex,
    imageAltTextUpdated = _useImageAltTextSetti.imageAltTextUpdated;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", {
    className: 'label'
  }, t('image_alt_text', {
    ns: 'editor'
  })), /*#__PURE__*/React__default.createElement(TextEditorStyledWrapper, null, getTextHtml((subItemImage == null ? void 0 : subItemImage.alt) || '', function (text) {
    return index !== undefined ? imageAltTextUpdatedIndex(subItemImage, text, index, indexContents) : imageAltTextUpdated(subItemImage, text);
  }, item.id + '_image_alt_text', IModesTextHtml.MODE_TEXT_HTML_TEXT_EDITOR, t('Type something', {
    ns: 'editor'
  }))));
}

var CarouselEditorSidebar = function CarouselEditorSidebar(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    getMediaEditor = props.getMediaEditor,
    imageUpdatedIndex = props.imageUpdatedIndex,
    onChangeItem = props.onChangeItem,
    captionUpdatedIndex = props.captionUpdatedIndex,
    sizeImageUpdatedIndex = props.sizeImageUpdatedIndex;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var items = item && item.items ? item.items : [];
  var _useState = useState(null),
    itemState = _useState[0],
    setItemState = _useState[1];
  var optionsImageSizes = OPTIONS_IMAGE_SIZES;
  useEffect(function () {
    updateItemLocalState();
  }, []);
  useEffect(function () {
    updateItemLocalState();
  }, [item, item.items ? JSON.stringify(item.items) : null]);
  function updateItemLocalState() {
    if (item && items && itemState && itemState.items && JSON.stringify(items) !== JSON.stringify(itemState.items)) {
      // == Si son diferentes los items de dentro de item de items los actualizo
      setItemState(getItemUpdatedItems(item, items));
      notifyChangeItem();
    } else {
      if (JSON.stringify(item) !== JSON.stringify(itemState)) {
        setItemState(item);
      }
    }
  }
  function notifyChangeItem() {
    if (itemState) {
      if (onChangeItem) {
        onChangeItem(itemState);
      }
    }
  }
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_Interactive_Process',
    classTabs: 'mint-tab-content-settings-sidebar--nopadding',
    settingsAditional: [SETTING_ZOOM_ON_CLICK],
    renderContent: function renderContent() {
      return /*#__PURE__*/React__default.createElement(AsideEditorItemBlockList, {
        item: item,
        items: item.items,
        hasChangedItem: onChangeItem,
        textButtonAdd: t('Add Image', {
          ns: 'editor'
        })
      }, items ? items.map(function (itemInside, index) {
        var _itemInside$media, _itemInside$media2;
        var sizeImageItemInside = getSubitemSettingImageSize(itemInside);
        var subItemImage = itemInside == null || (_itemInside$media = itemInside.media) == null ? void 0 : _itemInside$media.image;
        return /*#__PURE__*/React__default.createElement("div", {
          className: 'mint__block-text',
          key: itemInside.id
        }, /*#__PURE__*/React__default.createElement("p", {
          className: 'label'
        }, t('Image', {
          ns: 'editor'
        })), getMediaEditor(item, itemInside == null || (_itemInside$media2 = itemInside.media) == null ? void 0 : _itemInside$media2.image, function (subItemImageUpdate) {
          return imageUpdatedIndex(subItemImageUpdate, index);
        }, [ITypeMediaFunctionEditor.IMAGE], {
          maxHeightPreview: '100px',
          maxWidthPreview: '100px'
        }), subItemImage && /*#__PURE__*/React__default.createElement(ImageAltTextSettingSidebar, {
          item: item,
          onChangeItem: onChangeItem,
          getTextHtml: getTextHtml,
          subItemImage: subItemImage,
          index: index
        }), /*#__PURE__*/React__default.createElement("p", {
          className: 'label'
        }, t('Caption', {
          ns: 'editor'
        })), getTextHtml(itemInside.caption || '', function (text) {
          return captionUpdatedIndex(text, index);
        }, item.id + '_caption', IModesTextHtml.MODE_TEXT_HTML_EDITOR), /*#__PURE__*/React__default.createElement(SettingImageSize, {
          valueSelected: sizeImageItemInside,
          onChange: function onChange(sizeImage) {
            return sizeImageUpdatedIndex(sizeImage, index);
          },
          optionsImageSizes: optionsImageSizes
        }));
      }) : '');
    }
  }));
};

function useCarouselEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function titleUpdatedIndex(text, index) {
    onTitleUpdatedIndex(text, item, index, undefined, onChangeItem);
  }
  function descriptionUpdatedIndex(text, index) {
    onDescriptionUpdatedIndex(text, item, index, undefined, onChangeItem);
  }
  function imageUpdatedIndex(subItemImageUpdate, index) {
    onChangeImageUpdatedIndex(subItemImageUpdate, item, index, undefined, onChangeItem);
  }
  function _onDeleteImageIndex(index) {
    onDeleteMediaIndex(item, index, undefined, onChangeItem);
  }
  function captionUpdatedIndex(text, index) {
    onCaptionUpdatedIndex(text, item, index, undefined, onChangeItem);
  }
  function sizeImageUpdatedIndex(sizeImage, index) {
    onSizeImageUpdatedIndex(sizeImage, item, index, undefined, onChangeItem);
  }
  return {
    t: t,
    titleUpdatedIndex: titleUpdatedIndex,
    imageUpdatedIndex: imageUpdatedIndex,
    descriptionUpdatedIndex: descriptionUpdatedIndex,
    sizeImageUpdatedIndex: sizeImageUpdatedIndex,
    captionUpdatedIndex: captionUpdatedIndex,
    onDeleteImageIndex: _onDeleteImageIndex
  };
}

var CarouselEditor = function CarouselEditor(props) {
  var item = props.item,
    getMediaEditor = props.getMediaEditor,
    onChangeItem = props.onChangeItem,
    getSrc = props.getSrc;
  var _useCarouselEditor = useCarouselEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    imageUpdatedIndex = _useCarouselEditor.imageUpdatedIndex,
    titleUpdatedIndex = _useCarouselEditor.titleUpdatedIndex,
    descriptionUpdatedIndex = _useCarouselEditor.descriptionUpdatedIndex,
    onDeleteImageIndex = _useCarouselEditor.onDeleteImageIndex,
    captionUpdatedIndex = _useCarouselEditor.captionUpdatedIndex,
    sizeImageUpdatedIndex = _useCarouselEditor.sizeImageUpdatedIndex;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(CarouselEditorSidebar, Object.assign({}, sidebarProps, {
        getMediaEditor: getMediaEditor,
        imageUpdatedIndex: imageUpdatedIndex,
        titleUpdatedIndex: titleUpdatedIndex,
        descriptionUpdatedIndex: descriptionUpdatedIndex,
        onDeleteImageIndex: onDeleteImageIndex,
        captionUpdatedIndex: captionUpdatedIndex,
        sizeImageUpdatedIndex: sizeImageUpdatedIndex
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(Carousel, Object.assign({}, contentProps, {
        getSrc: getSrc,
        captionUpdatedIndex: captionUpdatedIndex
      }));
    }
  }));
};

var GalleryColumnsEditorSidebar = function GalleryColumnsEditorSidebar(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    getMediaEditor = props.getMediaEditor,
    captionUpdatedIndex = props.captionUpdatedIndex,
    onChangeItem = props.onChangeItem,
    imageUpdatedIndex = props.imageUpdatedIndex;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var items = item && item.items ? item.items : [];
  var _useState = useState(getNumbersLabelCalculate(items)),
    setNumbersLabel = _useState[1]; // TODO: hacerlo en un hook
  useEffect(function () {
    setNumbersLabel(getNumbersLabelCalculate(items));
  }, [items]);
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_Image_Hero',
    classTabs: 'mint-tab-content-settings-sidebar--nopadding',
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(AsideEditorItemBlockList, {
        item: item,
        items: item.items,
        hasChangedItem: onChangeItem,
        textButtonAdd: t('Add Image', {
          ns: 'editor'
        })
      }, items ? items.map(function (itemInside, index) {
        var _itemInside$media, _itemInside$media2;
        var subItemImage = itemInside == null || (_itemInside$media = itemInside.media) == null ? void 0 : _itemInside$media.image;
        return /*#__PURE__*/React__default.createElement("div", {
          className: 'mint__block-text',
          key: itemInside.id
        }, /*#__PURE__*/React__default.createElement("p", {
          className: 'label'
        }, t('Image', {
          ns: 'editor'
        })), getMediaEditor(item, itemInside == null || (_itemInside$media2 = itemInside.media) == null ? void 0 : _itemInside$media2.image, function (subItemImageUpdate) {
          return imageUpdatedIndex(subItemImageUpdate, index);
        }, [ITypeMediaFunctionEditor.IMAGE], {
          maxHeightPreview: '100px',
          maxWidthPreview: '100px'
        }), subItemImage && /*#__PURE__*/React__default.createElement(ImageAltTextSettingSidebar, {
          item: item,
          onChangeItem: onChangeItem,
          getTextHtml: getTextHtml,
          subItemImage: subItemImage,
          index: index
        }), /*#__PURE__*/React__default.createElement("p", {
          className: 'label'
        }, t('Caption', {
          ns: 'editor'
        })), getTextHtml((itemInside == null ? void 0 : itemInside.caption) || '', function (text) {
          return captionUpdatedIndex(text, index);
        }, item.id + '_caption', IModesTextHtml.MODE_TEXT_HTML_EDITOR));
      }) : '');
    }
  }));
};

function useGalleryColumnsEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function captionUpdatedIndex(text, index) {
    onCaptionUpdatedIndex(text, item, index, undefined, onChangeItem);
  }
  function imageUpdatedIndex(subItemImageUpdate, index) {
    onChangeImageUpdatedIndex(subItemImageUpdate, item, index, undefined, onChangeItem);
  }
  return {
    t: t,
    captionUpdatedIndex: captionUpdatedIndex,
    imageUpdatedIndex: imageUpdatedIndex
  };
}

var GalleryColumnsEditor = function GalleryColumnsEditor(props) {
  var item = props.item,
    getMediaEditor = props.getMediaEditor,
    mode = props.mode,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? IVariantsGalleryColumns.twocol : _props$variant,
    onChangeItem = props.onChangeItem,
    getSrc = props.getSrc;
  var _useGalleryColumnsEdi = useGalleryColumnsEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    imageUpdatedIndex = _useGalleryColumnsEdi.imageUpdatedIndex,
    captionUpdatedIndex = _useGalleryColumnsEdi.captionUpdatedIndex;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(GalleryColumnsEditorSidebar, Object.assign({}, sidebarProps, {
        getMediaEditor: getMediaEditor,
        mode: mode,
        imageUpdatedIndex: imageUpdatedIndex,
        captionUpdatedIndex: captionUpdatedIndex
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(GalleryColumns, Object.assign({}, contentProps, {
        captionUpdatedIndex: captionUpdatedIndex,
        variant: variant,
        getSrc: getSrc
      }));
    }
  }));
};

var HeroEditorSidebar = function HeroEditorSidebar(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    getMediaEditor = props.getMediaEditor,
    captionUpdated = props.captionUpdated,
    onChangeItem = props.onChangeItem,
    imageUpdated = props.imageUpdated;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var items = item && item.items ? item.items : [];
  var subItem = item && item.items.length > 0 ? item.items[0] : null;
  var subItemImage = getItemImage(item);
  var _useState = useState(getNumbersLabelCalculate(items)),
    setNumbersLabel = _useState[1]; // TODO: hacerlo en un hook
  useEffect(function () {
    setNumbersLabel(getNumbersLabelCalculate(items));
  }, [items]);
  var optionsImageSizes = OPTIONS_IMAGE_SIZES;
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_Image_Hero',
    settingsAditional: [SETTING_IMAGE_SIZE],
    optionsImageSizes: optionsImageSizes,
    renderContent: function renderContent() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: 'mint__block-text'
      }, /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Image', {
        ns: 'editor'
      })), getMediaEditor(item, subItemImage, function (subItemImageUpdate) {
        if (isMediaImage(subItemImageUpdate)) imageUpdated(subItemImageUpdate);
      }, [ITypeMediaFunctionEditor.IMAGE], {
        maxHeightPreview: '100px',
        maxWidthPreview: '100px'
      }), subItemImage && /*#__PURE__*/React__default.createElement(ImageAltTextSettingSidebar, {
        item: item,
        onChangeItem: onChangeItem,
        getTextHtml: getTextHtml,
        subItemImage: subItemImage
      }), /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Caption', {
        ns: 'editor'
      })), getTextHtml((subItem == null ? void 0 : subItem.caption) || '', function (text) {
        return captionUpdated(text);
      }, item.id + '_caption', IModesTextHtml.MODE_TEXT_HTML_EDITOR));
    }
  }));
};

function useHeroEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function captionUpdated(text) {
    onCaptionUpdated(text, item, onChangeItem);
  }
  function imageUpdated(subItemImageUpdate) {
    onChangeImageUpdated(subItemImageUpdate, item, onChangeItem);
  }
  return {
    t: t,
    captionUpdated: captionUpdated,
    imageUpdated: imageUpdated
  };
}

var HeroEditor = function HeroEditor(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    getMediaEditor = props.getMediaEditor,
    mode = props.mode,
    onChangeItem = props.onChangeItem,
    getSrc = props.getSrc;
  var _useHeroEditor = useHeroEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    captionUpdated = _useHeroEditor.captionUpdated,
    imageUpdated = _useHeroEditor.imageUpdated;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(HeroEditorSidebar, Object.assign({}, sidebarProps, {
        getMediaEditor: getMediaEditor,
        mode: mode,
        imageUpdated: imageUpdated,
        captionUpdated: captionUpdated
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(ImageHero, Object.assign({}, contentProps, {
        item: item,
        getTextHtml: getTextHtml,
        captionUpdated: captionUpdated,
        mode: mode,
        getSrc: getSrc
      }));
    }
  }));
};

var TextAsideEditorSidebar = function TextAsideEditorSidebar(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    getMediaEditor = props.getMediaEditor,
    captionUpdated = props.captionUpdated,
    paragraphUpdated = props.paragraphUpdated,
    onChangeItem = props.onChangeItem,
    imageUpdated = props.imageUpdated;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var items = item && item.items ? item.items : [];
  var subItem = item && item.items.length > 0 ? item.items[0] : null;
  var subItemImage = getItemImage(item);
  var _useState = useState(getNumbersLabelCalculate(items)),
    setNumbersLabel = _useState[1]; // TODO: hacerlo en un hook
  useEffect(function () {
    setNumbersLabel(getNumbersLabelCalculate(items));
  }, [items]);
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_Image_Hero',
    settingsAditional: [SETTING_IMAGE_POSITION, SETTING_IMAGE_SIZE],
    renderContent: function renderContent() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: 'mint__block-text'
      }, /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Text', {
        ns: 'editor'
      })), getTextHtml((subItem == null ? void 0 : subItem.paragraph) || '', function (text) {
        return paragraphUpdated(text);
      }, item.id + '_paragraph', IModesTextHtml.MODE_TEXT_HTML_EDITOR), /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Image', {
        ns: 'editor'
      })), getMediaEditor(item, subItemImage, function (subItemImageUpdate) {
        if (isMediaImage(subItemImageUpdate)) imageUpdated(subItemImageUpdate);
      }, [ITypeMediaFunctionEditor.IMAGE], {
        maxHeightPreview: '100px',
        maxWidthPreview: '100px'
      }), subItemImage && /*#__PURE__*/React__default.createElement(ImageAltTextSettingSidebar, {
        item: item,
        onChangeItem: onChangeItem,
        getTextHtml: getTextHtml,
        subItemImage: subItemImage
      }), /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Caption', {
        ns: 'editor'
      })), getTextHtml((subItem == null ? void 0 : subItem.caption) || '', function (text) {
        return captionUpdated(text);
      }, item.id + '_caption', IModesTextHtml.MODE_TEXT_HTML_EDITOR));
    }
  }));
};

function useTextAsideEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function captionUpdated(text) {
    onCaptionUpdated(text, item, onChangeItem);
  }
  function paragraphUpdated(text) {
    onParagraphUpdated(text, item, onChangeItem);
  }
  function imageUpdated(subItemImageUpdate) {
    onChangeImageUpdated(subItemImageUpdate, item, onChangeItem);
  }
  return {
    t: t,
    captionUpdated: captionUpdated,
    imageUpdated: imageUpdated,
    paragraphUpdated: paragraphUpdated
  };
}

var TextAsideEditor = function TextAsideEditor(props) {
  var item = props.item,
    getMediaEditor = props.getMediaEditor,
    mode = props.mode,
    onChangeItem = props.onChangeItem,
    getSrc = props.getSrc;
  var _useHeroEditor = useTextAsideEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    captionUpdated = _useHeroEditor.captionUpdated,
    paragraphUpdated = _useHeroEditor.paragraphUpdated,
    imageUpdated = _useHeroEditor.imageUpdated;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(TextAsideEditorSidebar, Object.assign({}, sidebarProps, {
        getMediaEditor: getMediaEditor,
        mode: mode,
        imageUpdated: imageUpdated,
        captionUpdated: captionUpdated,
        paragraphUpdated: paragraphUpdated
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(ImageTextAside, Object.assign({}, contentProps, {
        captionUpdated: captionUpdated,
        paragraphUpdated: paragraphUpdated,
        mode: mode,
        getSrc: getSrc
      }));
    }
  }));
};

var TextOverlayEditorSidebar = function TextOverlayEditorSidebar(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    getMediaEditor = props.getMediaEditor,
    captionUpdated = props.captionUpdated,
    onChangeItem = props.onChangeItem,
    imageUpdated = props.imageUpdated;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var items = item && item.items ? item.items : [];
  var subItem = item && item.items.length > 0 ? item.items[0] : null;
  var subItemImage = getItemImage(item);
  var _useState = useState(getNumbersLabelCalculate(items)),
    setNumbersLabel = _useState[1]; // TODO: hacerlo en un hook
  useEffect(function () {
    setNumbersLabel(getNumbersLabelCalculate(items));
  }, [items]);
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_Image_Overlay',
    renderContent: function renderContent() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: 'mint__block-text'
      }, /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Image', {
        ns: 'editor'
      })), getMediaEditor(item, subItemImage, function (subItemImageUpdate) {
        if (isMediaImage(subItemImageUpdate)) imageUpdated(subItemImageUpdate);
      }, [ITypeMediaFunctionEditor.IMAGE], {
        maxHeightPreview: '100px',
        maxWidthPreview: '100px'
      }), subItemImage && /*#__PURE__*/React__default.createElement(ImageAltTextSettingSidebar, {
        item: item,
        onChangeItem: onChangeItem,
        getTextHtml: getTextHtml,
        subItemImage: subItemImage
      }), /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Caption', {
        ns: 'editor'
      })), getTextHtml((subItem == null ? void 0 : subItem.caption) || '', function (text) {
        return captionUpdated(text);
      }, item.id + '_caption', IModesTextHtml.MODE_TEXT_HTML_EDITOR));
    }
  }));
};

function useTextOverlayEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function captionUpdated(text) {
    onCaptionUpdated(text, item, onChangeItem);
  }
  function paragraphUpdated(text) {
    onParagraphUpdated(text, item, onChangeItem);
  }
  function imageUpdated(subItemImageUpdate) {
    onChangeImageUpdated(subItemImageUpdate, item, onChangeItem);
  }
  return {
    t: t,
    captionUpdated: captionUpdated,
    imageUpdated: imageUpdated,
    paragraphUpdated: paragraphUpdated
  };
}

var TextOverlayEditor = function TextOverlayEditor(props) {
  var item = props.item,
    getMediaEditor = props.getMediaEditor,
    mode = props.mode,
    onChangeItem = props.onChangeItem,
    getSrc = props.getSrc;
  var _useTextOverlayEditor = useTextOverlayEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    captionUpdated = _useTextOverlayEditor.captionUpdated,
    paragraphUpdated = _useTextOverlayEditor.paragraphUpdated,
    imageUpdated = _useTextOverlayEditor.imageUpdated;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(TextOverlayEditorSidebar, Object.assign({}, sidebarProps, {
        getMediaEditor: getMediaEditor,
        mode: mode,
        imageUpdated: imageUpdated,
        captionUpdated: captionUpdated,
        paragraphUpdated: paragraphUpdated
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(ImageTextOverlay, Object.assign({}, contentProps, {
        captionUpdated: captionUpdated,
        paragraphUpdated: paragraphUpdated,
        getSrc: getSrc
      }));
    }
  }));
};

var FullEditorSidebar = function FullEditorSidebar(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    getMediaEditor = props.getMediaEditor,
    captionUpdated = props.captionUpdated,
    onChangeItem = props.onChangeItem,
    imageUpdated = props.imageUpdated;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var items = item && item.items ? item.items : [];
  var subItem = item && item.items.length > 0 ? item.items[0] : null;
  var subItemImage = getItemImage(item);
  var _useState = useState(getNumbersLabelCalculate(items)),
    setNumbersLabel = _useState[1]; // TODO: hacerlo en un hook
  useEffect(function () {
    setNumbersLabel(getNumbersLabelCalculate(items));
  }, [items]);
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_Image_Hero',
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: 'mint__block-text mint__block-full'
      }, /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Image', {
        ns: 'editor'
      })), getMediaEditor(item, subItemImage, function (subItemImageUpdate) {
        if (isMediaImage(subItemImageUpdate)) {
          imageUpdated(subItemImageUpdate);
        }
      }, [ITypeMediaFunctionEditor.IMAGE], {
        maxHeightPreview: '100px',
        maxWidthPreview: '100px'
      }), subItemImage && /*#__PURE__*/React__default.createElement(ImageAltTextSettingSidebar, {
        item: item,
        onChangeItem: onChangeItem,
        getTextHtml: getTextHtml,
        subItemImage: subItemImage
      }), /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Caption', {
        ns: 'editor'
      })), getTextHtml((subItem == null ? void 0 : subItem.caption) || '', function (text) {
        return captionUpdated(text);
      }, item.id + '_caption', IModesTextHtml.MODE_TEXT_HTML_EDITOR));
    }
  }));
};

function useFullEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function captionUpdated(text) {
    onCaptionUpdated(text, item, onChangeItem);
  }
  function imageUpdated(subItemImageUpdate) {
    onChangeImageUpdated(subItemImageUpdate, item, onChangeItem);
  }
  return {
    t: t,
    captionUpdated: captionUpdated,
    imageUpdated: imageUpdated
  };
}

var HeroEditor$1 = function HeroEditor(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    getMediaEditor = props.getMediaEditor,
    mode = props.mode,
    onChangeItem = props.onChangeItem,
    getSrc = props.getSrc;
  var _useFullEditor = useFullEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    captionUpdated = _useFullEditor.captionUpdated,
    imageUpdated = _useFullEditor.imageUpdated,
    t = _useFullEditor.t;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(FullEditorSidebar, Object.assign({}, sidebarProps, {
        item: item,
        getTextHtml: getTextHtml,
        getMediaEditor: getMediaEditor,
        mode: mode,
        onChangeItem: onChangeItem,
        imageUpdated: imageUpdated,
        captionUpdated: captionUpdated,
        t: t
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(ImageFull, Object.assign({}, contentProps, {
        item: item,
        getTextHtml: getTextHtml,
        captionUpdated: captionUpdated,
        mode: mode,
        getSrc: getSrc
      }));
    }
  }));
};

function EnhancedSortableList(_ref) {
  var items = _ref.items,
    onReorder = _ref.onReorder,
    onDelete = _ref.onDelete,
    onAdd = _ref.onAdd,
    renderItem = _ref.renderItem,
    _ref$getItemTitle = _ref.getItemTitle,
    getItemTitle = _ref$getItemTitle === void 0 ? function () {
      return 'Item';
    } : _ref$getItemTitle,
    _ref$addButtonText = _ref.addButtonText,
    addButtonText = _ref$addButtonText === void 0 ? 'Añadir item' : _ref$addButtonText,
    _ref$isDragDisabled = _ref.isDragDisabled,
    isDragDisabled = _ref$isDragDisabled === void 0 ? function () {
      return false;
    } : _ref$isDragDisabled,
    _ref$isDeleteDisabled = _ref.isDeleteDisabled,
    isDeleteDisabled = _ref$isDeleteDisabled === void 0 ? function () {
      return false;
    } : _ref$isDeleteDisabled,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$alwaysShowContro = _ref.alwaysShowControls,
    alwaysShowControls = _ref$alwaysShowContro === void 0 ? false : _ref$alwaysShowContro,
    _ref$hideOrderArrows = _ref.hideOrderArrows,
    hideOrderArrows = _ref$hideOrderArrows === void 0 ? false : _ref$hideOrderArrows,
    _ref$idField = _ref.idField,
    idField = _ref$idField === void 0 ? 'id' : _ref$idField;
  var _useState = useState(-1),
    hoveredIndex = _useState[0],
    setHoveredIndex = _useState[1];
  var handleDragEnd = function handleDragEnd(result) {
    if (!result.destination) return;
    if (result.destination.index === result.source.index) return;
    var reorderedItems = Array.from(items);
    var _reorderedItems$splic = reorderedItems.splice(result.source.index, 1),
      removed = _reorderedItems$splic[0];
    reorderedItems.splice(result.destination.index, 0, removed);
    onReorder(reorderedItems);
  };
  var handleMoveItem = function handleMoveItem(fromIndex, toIndex) {
    if (toIndex < 0 || toIndex >= items.length) return;
    if (isDragDisabled(items[toIndex])) return;
    var newItems = Array.from(items);
    var _newItems$splice = newItems.splice(fromIndex, 1),
      removed = _newItems$splice[0];
    newItems.splice(toIndex, 0, removed);
    onReorder(newItems);
  };
  var getItemId = function getItemId(item) {
    return item[idField] || '';
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DragDropContext, {
    onDragEnd: handleDragEnd
  }, /*#__PURE__*/React__default.createElement(Droppable, {
    droppableId: 'droppable'
  }, function (provided) {
    return /*#__PURE__*/React__default.createElement("div", Object.assign({
      ref: provided.innerRef
    }, provided.droppableProps, {
      className: className
    }), items.map(function (item, index) {
      return /*#__PURE__*/React__default.createElement(Draggable, {
        key: getItemId(item),
        draggableId: getItemId(item),
        index: index,
        isDragDisabled: isDragDisabled(item)
      }, function (provided) {
        return /*#__PURE__*/React__default.createElement("div", Object.assign({
          ref: provided.innerRef
        }, provided.draggableProps, {
          onMouseEnter: function onMouseEnter() {
            return setHoveredIndex(index);
          },
          onMouseLeave: function onMouseLeave() {
            return setHoveredIndex(-1);
          },
          className: 'aside-editor-item-list'
        }), /*#__PURE__*/React__default.createElement("div", {
          className: 'aside-editor-item-list__content'
        }, renderItem(item, index)), /*#__PURE__*/React__default.createElement("div", {
          className: "aside-editor-item-list__controls " + (alwaysShowControls || hoveredIndex === index ? 'aside-editor-item-list__controls--show' : '')
        }, !isDragDisabled(item) && /*#__PURE__*/React__default.createElement("div", Object.assign({}, provided.dragHandleProps), /*#__PURE__*/React__default.createElement(SvgDragHandler, {
          className: 'aside-editor-item-list__drag-handler'
        })), /*#__PURE__*/React__default.createElement("span", {
          className: 'aside-editor-item-list__header-text'
        }, getItemTitle(item)), !isDragDisabled(item) && index > 0 && !isDragDisabled(items[index - 1]) && !hideOrderArrows && /*#__PURE__*/React__default.createElement(Button, {
          onClick: function onClick() {
            return handleMoveItem(index, index - 1);
          },
          variant: 'icon'
        }, /*#__PURE__*/React__default.createElement(SvgUpArrow, null)), !isDragDisabled(item) && index < items.length - 1 && !isDragDisabled(items[index + 1]) && !hideOrderArrows && /*#__PURE__*/React__default.createElement(Button, {
          onClick: function onClick() {
            return handleMoveItem(index, index + 1);
          },
          variant: 'icon'
        }, /*#__PURE__*/React__default.createElement(SvgDownArrow, null)), onDelete && !isDeleteDisabled(item) && /*#__PURE__*/React__default.createElement(Button, {
          onClick: function onClick() {
            return onDelete(item);
          },
          variant: 'icon'
        }, /*#__PURE__*/React__default.createElement(SvgTrash$2, null))));
      });
    }), provided.placeholder);
  })), onAdd && /*#__PURE__*/React__default.createElement("div", {
    className: 'aside-editor-item-list__add-button-wrapper'
  }, /*#__PURE__*/React__default.createElement(Button, {
    onClick: onAdd,
    className: 'button--secondary button--small'
  }, addButtonText)));
}

var BaseItemEditor = function BaseItemEditor(_ref) {
  var _itemInside$media, _itemInside$media2, _itemInside$media3, _itemInside$media4, _itemInside$media5, _itemInside$media6, _itemInside$media7;
  var itemInside = _ref.itemInside,
    item = _ref.item,
    index = _ref.index,
    getTextHtml = _ref.getTextHtml,
    getMediaEditor = _ref.getMediaEditor,
    titleUpdatedIndex = _ref.titleUpdatedIndex,
    descriptionUpdatedIndex = _ref.descriptionUpdatedIndex,
    captionUpdatedIndex = _ref.captionUpdatedIndex,
    mediaUpdatedIndex = _ref.mediaUpdatedIndex,
    alignImageUpdatedIndex = _ref.alignImageUpdatedIndex,
    sizeImageUpdatedIndex = _ref.sizeImageUpdatedIndex,
    onChangeItem = _ref.onChangeItem,
    onDeleteMediaIndex = _ref.onDeleteMediaIndex,
    t = _ref.t,
    optionsImageSizes = _ref.optionsImageSizes,
    indexContents = _ref.indexContents,
    _ref$showContents = _ref.showContents,
    showContents = _ref$showContents === void 0 ? false : _ref$showContents,
    _ref$showTitle = _ref.showTitle,
    showTitle = _ref$showTitle === void 0 ? true : _ref$showTitle,
    _ref$headerText = _ref.headerText,
    headerText = _ref$headerText === void 0 ? undefined : _ref$headerText,
    allowedMediaTypes = _ref.allowedMediaTypes,
    ItemEditorComponent = _ref.ItemEditorComponent;
  var alignImageItemInside = getSubitemSettingAlignImage(itemInside);
  var sizeImageItemInside = getSubitemSettingImageSize(itemInside);
  var subItemImage = itemInside == null || (_itemInside$media = itemInside.media) == null ? void 0 : _itemInside$media.image;
  var mediaContent = (itemInside == null || (_itemInside$media2 = itemInside.media) == null ? void 0 : _itemInside$media2.image) || (itemInside == null || (_itemInside$media3 = itemInside.media) == null ? void 0 : _itemInside$media3.video) || (itemInside == null || (_itemInside$media4 = itemInside.media) == null ? void 0 : _itemInside$media4.audio) || null;
  // Definimos commonProps con todas las props necesarias para el componente hijo
  var commonProps = {
    item: item,
    index: index,
    getTextHtml: getTextHtml,
    getMediaEditor: getMediaEditor,
    titleUpdatedIndex: titleUpdatedIndex,
    descriptionUpdatedIndex: descriptionUpdatedIndex,
    captionUpdatedIndex: captionUpdatedIndex,
    mediaUpdatedIndex: mediaUpdatedIndex,
    alignImageUpdatedIndex: alignImageUpdatedIndex,
    sizeImageUpdatedIndex: sizeImageUpdatedIndex,
    onChangeItem: onChangeItem,
    onDeleteMediaIndex: onDeleteMediaIndex,
    t: t,
    optionsImageSizes: optionsImageSizes,
    allowedMediaTypes: allowedMediaTypes
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint__block-text',
    key: itemInside.id
  }, /*#__PURE__*/React__default.createElement("p", {
    className: 'label'
  }, headerText || t('Item', {
    ns: 'editor'
  }) + ' # ' + ((indexContents || index) + 1)), showTitle && getTextHtml(itemInside.title, function (text) {
    return titleUpdatedIndex(text, index, indexContents);
  }, itemInside.id + '_title', IModesTextHtml.MODE_TEXT_HTML_EDITOR), /*#__PURE__*/React__default.createElement("p", {
    className: 'label'
  }, t('Description', {
    ns: 'editor'
  })), getTextHtml(itemInside.description, function (text) {
    return descriptionUpdatedIndex(text, index, indexContents);
  }, itemInside.id + '_description', IModesTextHtml.MODE_TEXT_HTML_EDITOR), /*#__PURE__*/React__default.createElement("p", {
    className: 'label'
  }, t('Media', {
    ns: 'editor'
  })), getMediaEditor(item, mediaContent, function (subItemMediaUpdate) {
    mediaUpdatedIndex(subItemMediaUpdate, index, indexContents);
  }, allowedMediaTypes, {
    maxHeightPreview: '100px',
    maxWidthPreview: '100px',
    onDeleteImage: function onDeleteImage() {
      return onDeleteMediaIndex(index, indexContents);
    },
    showDeleteButton: true
  }), subItemImage && /*#__PURE__*/React__default.createElement(ImageAltTextSettingSidebar, {
    item: item,
    onChangeItem: onChangeItem,
    getTextHtml: getTextHtml,
    subItemImage: subItemImage,
    index: index,
    indexContents: indexContents
  }), (itemInside == null || (_itemInside$media5 = itemInside.media) == null ? void 0 : _itemInside$media5.image) && /*#__PURE__*/React__default.createElement("p", {
    className: 'label'
  }, t('Caption', {
    ns: 'editor'
  })), (itemInside == null || (_itemInside$media6 = itemInside.media) == null ? void 0 : _itemInside$media6.image) && getTextHtml(itemInside.caption || '', function (text) {
    return captionUpdatedIndex(text, index, indexContents);
  }, itemInside.id + '_caption', IModesTextHtml.MODE_TEXT_HTML_EDITOR), (itemInside == null || (_itemInside$media7 = itemInside.media) == null ? void 0 : _itemInside$media7.image) && /*#__PURE__*/React__default.createElement("div", {
    className: 'aside-editor-item-list__image-conf'
  }, /*#__PURE__*/React__default.createElement(SettingAlignImages, {
    valueSelected: alignImageItemInside,
    onChange: function onChange(alignImage) {
      return alignImageUpdatedIndex(alignImage, index, indexContents);
    },
    showOptionUnspecified: true
  }), /*#__PURE__*/React__default.createElement(SettingImageSize, {
    valueSelected: sizeImageItemInside,
    onChange: function onChange(sizeImage) {
      return sizeImageUpdatedIndex(sizeImage, index, indexContents);
    },
    optionsImageSizes: optionsImageSizes
  })), showContents && /*#__PURE__*/React__default.createElement(EnhancedSortableList, {
    items: itemInside.contents || [],
    onReorder: function onReorder(itemsReordered) {
      if (onChangeItem) {
        var itemUpdated = item;
        itemUpdated.items[index].contents = itemsReordered;
        onChangeItem(itemUpdated);
      }
    },
    onDelete: function onDelete(itemDelete) {
      if (onChangeItem) {
        var itemUpdated = item;
        if (itemUpdated.items[index].contents) {
          // @ts-ignore itemUpdated no puede ser null
          itemUpdated.items[index].contents = itemUpdated.items[index].contents.filter(function (content) {
            return content.id !== itemDelete.id;
          });
          onChangeItem(itemUpdated);
        }
      }
    },
    onAdd: function onAdd() {
      if (onChangeItem) {
        var itemUpdated = item;
        if (itemUpdated) {
          var _itemUpdated$items$in;
          if (itemUpdated.items[index].contents === undefined) {
            itemUpdated.items[index].contents = [];
          }
          (_itemUpdated$items$in = itemUpdated.items[index].contents) == null || _itemUpdated$items$in.push({
            id: getGuid(),
            type: 'content',
            title: '',
            description: '',
            media: undefined,
            data: undefined
          });
        }
        onChangeItem(itemUpdated);
      }
    },
    renderItem: function renderItem(itemInsideContent, indexItemInsideContents) {
      return /*#__PURE__*/React__default.createElement(ItemEditorComponent, Object.assign({}, commonProps, {
        itemInside: itemInsideContent,
        indexContents: indexItemInsideContents,
        showContents: false,
        showTitle: false,
        headerText: t('additional_content_header', {
          ns: 'editor',
          number: indexItemInsideContents + 1
        })
      }));
    },
    getItemTitle: function getItemTitle(item) {
      return t('additional_content_item_title', {
        ns: 'editor'
      });
    },
    isDragDisabled: function isDragDisabled(item) {
      return false;
    },
    addButtonText: t('button_additional_content_add', {
      ns: 'editor'
    })
  }));
};

var _AccordionItemEditor = function AccordionItemEditor(props) {
  return /*#__PURE__*/React__default.createElement(BaseItemEditor, Object.assign({}, props, {
    allowedMediaTypes: [ITypeMediaFunctionEditor.AUDIO, ITypeMediaFunctionEditor.IMAGE, ITypeMediaFunctionEditor.VIDEO],
    ItemEditorComponent: _AccordionItemEditor
  }));
};

var AccordionEditorSidebar = function AccordionEditorSidebar(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    getMediaEditor = props.getMediaEditor,
    captionUpdatedIndex = props.captionUpdatedIndex,
    titleUpdatedIndex = props.titleUpdatedIndex,
    descriptionUpdatedIndex = props.descriptionUpdatedIndex,
    alignImageUpdatedIndex = props.alignImageUpdatedIndex,
    sizeImageUpdatedIndex = props.sizeImageUpdatedIndex,
    onChangeItem = props.onChangeItem,
    mediaUpdatedIndex = props.mediaUpdatedIndex,
    onDeleteMediaIndex = props.onDeleteMediaIndex,
    t = props.t;
  var optionsImageSizes = OPTIONS_IMAGE_SIZES;
  var showAdditionalContentsSubItemEditor = ConfigGlobalSingleton.getInstance().isShowAdditionalContentsSubItemEditor();
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_Image_Hero',
    classTabs: 'mint-tab-content-settings-sidebar--nopadding',
    settingsAditional: [SETTING_ALIGN_IMAGES],
    renderContent: function renderContent() {
      var _item$items;
      return /*#__PURE__*/React__default.createElement(AsideEditorItemBlockList, {
        item: item,
        items: item.items,
        hasChangedItem: onChangeItem,
        textButtonAdd: t('Add Item', {
          ns: 'editor'
        })
      }, (_item$items = item.items) == null ? void 0 : _item$items.map(function (itemInside, index) {
        return /*#__PURE__*/React__default.createElement(_AccordionItemEditor, {
          key: itemInside.id,
          itemInside: itemInside,
          item: item,
          index: index,
          getTextHtml: getTextHtml,
          getMediaEditor: getMediaEditor,
          titleUpdatedIndex: titleUpdatedIndex,
          descriptionUpdatedIndex: descriptionUpdatedIndex,
          captionUpdatedIndex: captionUpdatedIndex,
          mediaUpdatedIndex: mediaUpdatedIndex,
          alignImageUpdatedIndex: alignImageUpdatedIndex,
          sizeImageUpdatedIndex: sizeImageUpdatedIndex,
          onChangeItem: onChangeItem,
          onDeleteMediaIndex: onDeleteMediaIndex,
          optionsImageSizes: optionsImageSizes,
          t: t,
          showContents: showAdditionalContentsSubItemEditor && true
        });
      }));
    }
  }));
};

function useAccordionEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function captionUpdatedIndex(text, index, indexContents) {
    onCaptionUpdatedIndex(text, item, index, indexContents, onChangeItem);
  }
  function mediaUpdatedIndex(subItemMediaUpdate, index, indexContents) {
    onChangeMediaUpdatedIndex(subItemMediaUpdate, item, index, indexContents, onChangeItem, true);
  }
  function descriptionUpdatedIndex(text, index, indexContents) {
    onDescriptionUpdatedIndex(text, item, index, indexContents, onChangeItem);
  }
  function titleUpdatedIndex(text, index, indexContents) {
    onTitleUpdatedIndex(text, item, index, indexContents, onChangeItem);
  }
  function alignImageUpdatedIndex(alignImage, index, indexContents) {
    onAlignImageUpdatedIndex(alignImage, item, index, indexContents, onChangeItem);
  }
  function _onDeleteMediaIndex(index, indexContents) {
    onDeleteMediaIndex(item, index, indexContents, onChangeItem);
  }
  function sizeImageUpdatedIndex(sizeImage, index, indexContents) {
    onSizeImageUpdatedIndex(sizeImage, item, index, indexContents, onChangeItem);
  }
  return {
    t: t,
    captionUpdatedIndex: captionUpdatedIndex,
    descriptionUpdatedIndex: descriptionUpdatedIndex,
    mediaUpdatedIndex: mediaUpdatedIndex,
    titleUpdatedIndex: titleUpdatedIndex,
    alignImageUpdatedIndex: alignImageUpdatedIndex,
    sizeImageUpdatedIndex: sizeImageUpdatedIndex,
    onDeleteMediaIndex: _onDeleteMediaIndex
  };
}

var AccordionEditor = function AccordionEditor(props) {
  var item = props.item,
    getMediaEditor = props.getMediaEditor,
    mode = props.mode,
    onChangeItem = props.onChangeItem,
    getSrc = props.getSrc;
  var _useAccordionEditor = useAccordionEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    mediaUpdatedIndex = _useAccordionEditor.mediaUpdatedIndex,
    descriptionUpdatedIndex = _useAccordionEditor.descriptionUpdatedIndex,
    titleUpdatedIndex = _useAccordionEditor.titleUpdatedIndex,
    captionUpdatedIndex = _useAccordionEditor.captionUpdatedIndex,
    alignImageUpdatedIndex = _useAccordionEditor.alignImageUpdatedIndex,
    sizeImageUpdatedIndex = _useAccordionEditor.sizeImageUpdatedIndex,
    onDeleteMediaIndex = _useAccordionEditor.onDeleteMediaIndex;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(AccordionEditorSidebar, Object.assign({}, sidebarProps, {
        getMediaEditor: getMediaEditor,
        mode: mode,
        onDeleteMediaIndex: onDeleteMediaIndex,
        mediaUpdatedIndex: mediaUpdatedIndex,
        captionUpdatedIndex: captionUpdatedIndex,
        titleUpdatedIndex: titleUpdatedIndex,
        descriptionUpdatedIndex: descriptionUpdatedIndex,
        alignImageUpdatedIndex: alignImageUpdatedIndex,
        sizeImageUpdatedIndex: sizeImageUpdatedIndex
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(Accordion, Object.assign({}, contentProps, {
        titleUpdatedIndex: titleUpdatedIndex,
        descriptionUpdatedIndex: descriptionUpdatedIndex,
        captionUpdatedIndex: captionUpdatedIndex,
        getSrc: getSrc
      }));
    }
  }));
};

var _path$y;
function _extends$U() { _extends$U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$U.apply(this, arguments); }
var SvgDownArrow2 = function SvgDownArrow2(props) {
  return /*#__PURE__*/createElement("svg", _extends$U({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    width: 10,
    height: 6,
    viewBox: "0 0 10 6"
  }, props), _path$y || (_path$y = /*#__PURE__*/createElement("path", {
    d: "M5.000,6.000 L-0.000,1.134 L1.166,-0.002 L5.000,3.729 L8.833,-0.002 L10.000,1.134 L5.000,6.000 Z"
  })));
};

var DropdownMenu = function DropdownMenu(_ref) {
  var children = _ref.children,
    extraClass = _ref.extraClass,
    _ref$isList = _ref.isList,
    isList = _ref$isList === void 0 ? false : _ref$isList;
  var classContainer = 'author-block-more-options-menu ' + (extraClass || '');
  return /*#__PURE__*/React__default.createElement("div", {
    className: classContainer
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'author-block-more-options-menu-wrapper'
  }, isList ? /*#__PURE__*/React__default.createElement("ul", {
    className: 'author-block-more-options-menu-list'
  }, children) : /*#__PURE__*/React__default.createElement("div", {
    className: 'author-block-more-options-menu-content'
  }, children)));
};

function useLabeledGraphicsItemEditor(props) {
  var _itemToUpdate$media, _itemToUpdate$media2, _itemToUpdate$media3, _itemToUpdate$media4, _itemToUpdate$media5, _itemToUpdate$media6, _itemToUpdate$media7;
  var item = props.item,
    index = props.index,
    onItemUpdated = props.onItemUpdated,
    onMediaUpdated = props.onMediaUpdated;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useState = useState(false),
    showIcons = _useState[0],
    setShowIcons = _useState[1];
  var _useState2 = useState(item),
    itemToUpdate = _useState2[0],
    setItemToUpdate = _useState2[1];
  //const onChangeDebounced = debounce(onItemUpdated, 1000);
  var onIconClick = function onIconClick() {
    setShowIcons(!showIcons);
  };
  var updateItem = function updateItem(newItem) {
    setItemToUpdate(newItem);
    onItemUpdated && onItemUpdated(newItem, index); // onChangeDebounced(newItem, index);
  };

  var onIconSelect = function onIconSelect(icon) {
    setShowIcons(false);
    var newItem = _extends({}, itemToUpdate, {
      icon: icon
    });
    updateItem(newItem);
  };
  var onTextUpdated = function onTextUpdated(text) {
    var newItem = _extends({}, itemToUpdate, {
      title: text
    });
    updateItem(newItem);
  };
  var onDescriptionUpdated = function onDescriptionUpdated(text) {
    var newItem = _extends({}, itemToUpdate, {
      description: text
    });
    updateItem(newItem);
  };
  var closeSelectIcons = function closeSelectIcons() {
    setShowIcons(false);
  };
  function mediaUpdated(subItemMediaUpdate) {
    onMediaUpdated && onMediaUpdated(subItemMediaUpdate, index);
  }
  var mediaContent = itemToUpdate != null && (_itemToUpdate$media = itemToUpdate.media) != null && _itemToUpdate$media.image ? itemToUpdate == null || (_itemToUpdate$media2 = itemToUpdate.media) == null ? void 0 : _itemToUpdate$media2.image : itemToUpdate != null && (_itemToUpdate$media3 = itemToUpdate.media) != null && _itemToUpdate$media3.video ? itemToUpdate == null || (_itemToUpdate$media4 = itemToUpdate.media) == null ? void 0 : _itemToUpdate$media4.video : itemToUpdate != null && (_itemToUpdate$media5 = itemToUpdate.media) != null && _itemToUpdate$media5.audio ? itemToUpdate == null || (_itemToUpdate$media6 = itemToUpdate.media) == null ? void 0 : _itemToUpdate$media6.audio : null;
  return {
    t: t,
    itemToUpdate: itemToUpdate,
    onTextUpdated: onTextUpdated,
    onDescriptionUpdated: onDescriptionUpdated,
    mediaContent: mediaContent,
    mediaUpdated: mediaUpdated,
    onIconClick: onIconClick,
    onIconSelect: onIconSelect,
    showIcons: showIcons,
    closeSelectIcons: closeSelectIcons,
    subItemImage: itemToUpdate == null || (_itemToUpdate$media7 = itemToUpdate.media) == null ? void 0 : _itemToUpdate$media7.image
  };
}

var LabeledGraphicsItemEditor = function LabeledGraphicsItemEditor(props) {
  var getTextHtml = props.getTextHtml,
    getMediaEditor = props.getMediaEditor,
    index = props.index,
    onDeleteImageIndex = props.onDeleteImageIndex,
    itemParent = props.itemParent,
    onChangeItem = props.onChangeItem;
  var _useLabeledGraphicsIt = useLabeledGraphicsItemEditor(props),
    t = _useLabeledGraphicsIt.t,
    itemToUpdate = _useLabeledGraphicsIt.itemToUpdate,
    onTextUpdated = _useLabeledGraphicsIt.onTextUpdated,
    onDescriptionUpdated = _useLabeledGraphicsIt.onDescriptionUpdated,
    mediaContent = _useLabeledGraphicsIt.mediaContent,
    mediaUpdated = _useLabeledGraphicsIt.mediaUpdated,
    onIconClick = _useLabeledGraphicsIt.onIconClick,
    onIconSelect = _useLabeledGraphicsIt.onIconSelect,
    showIcons = _useLabeledGraphicsIt.showIcons,
    closeSelectIcons = _useLabeledGraphicsIt.closeSelectIcons,
    subItemImage = _useLabeledGraphicsIt.subItemImage;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'lesson__block-text',
    key: 'accordion-' + index
  }, /*#__PURE__*/React__default.createElement("p", {
    className: 'label'
  }, t('Title', {
    ns: 'editor'
  }) + ' # ' + (index + 1)), /*#__PURE__*/React__default.createElement("div", {
    className: 'lesson__block-title'
  }, getTextHtml(itemToUpdate.title, onTextUpdated, itemToUpdate.id + '_title', IModesTextHtml.MODE_TEXT_HTML_EDITOR, t('Enter a title...', {
    ns: 'editor'
  }), undefined, undefined, undefined, undefined, undefined, {
    hideButtonTooltip: true
  })), /*#__PURE__*/React__default.createElement("p", {
    className: 'label'
  }, t('Description', {
    ns: 'editor'
  })), getTextHtml(itemToUpdate.description, onDescriptionUpdated, itemToUpdate.id + '_description', IModesTextHtml.MODE_TEXT_HTML_EDITOR, t('Enter a description...', {
    ns: 'editor'
  }), undefined, undefined, undefined, undefined, undefined, {
    hideButtonTooltip: true
  }), /*#__PURE__*/React__default.createElement("p", {
    className: 'label'
  }, t('Media', {
    ns: 'editor'
  })), getMediaEditor(itemParent, mediaContent, function (subItemMediaUpdate) {
    return mediaUpdated(subItemMediaUpdate);
  }, [ITypeMediaFunctionEditor.IMAGE, ITypeMediaFunctionEditor.AUDIO], {
    onDeleteImage: function onDeleteImage() {
      return onDeleteImageIndex(index);
    }
  }), subItemImage && /*#__PURE__*/React__default.createElement(ImageAltTextSettingSidebar, {
    item: itemParent,
    onChangeItem: onChangeItem,
    getTextHtml: getTextHtml,
    subItemImage: subItemImage,
    index: index
  }), /*#__PURE__*/React__default.createElement("div", {
    className: 'labeled-graphics__icon-content'
  }, /*#__PURE__*/React__default.createElement("p", {
    className: 'label'
  }, t('Marker style', {
    ns: 'editor'
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'lesson__block-interactive-label-link ls-icon--' + itemToUpdate.icon,
    onClick: onIconClick
  }), showIcons && /*#__PURE__*/React__default.createElement(OutsideAlerter, {
    isActive: showIcons,
    handleClickOutside: closeSelectIcons,
    classListIgnoreClick: ['lesson__block-interactive-label-link']
  }, /*#__PURE__*/React__default.createElement(DropdownMenu, {
    extraClass: 'labeled-graphics-select-icons'
  }, Array(27).fill(1).map(function (x, i) {
    return i > 0 && /*#__PURE__*/React__default.createElement("div", {
      className: 'lesson__block-interactive-label-link ls-icon--' + (i < 10 ? '0' + i : i),
      key: 'icon-' + i,
      onClick: function onClick() {
        return onIconSelect(i < 10 ? '0' + i : i);
      }
    });
  })))));
};

function useLabeledGraphicsPreviewEditor(props) {
  var _props$mediaImage;
  var imgRef = useRef(null);
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    pathAssets = _useGeneral.pathAssets,
    folderBlockDefault = _useGeneral.folderBlockDefault;
  var _useState = useState({
      items: props.items,
      mediaImage: props.mediaImage,
      offsetPin: 17
    }),
    state = _useState[0],
    dispatch = _useState[1];
  useEffect(function () {
    var firstPin = document.getElementById('pin-0');
    if (firstPin !== null) {
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          offsetPin: firstPin.getBoundingClientRect().width / 2 - 4
        });
      });
    }
  }, []);
  useEffect(function () {
    if (state.items !== props.items) {
      // Actualizar si viene de fuera la nueva lista
      //console.log("Update props ITEMS in Preview");
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          items: props.items
        });
      });
    }
    if (!state.mediaImage || state.mediaImage.src && props.mediaImage && props.mediaImage.src && props.mediaImage.src !== state.mediaImage.src) {
      //console.log("UPDATE IMAGE ITEM LABELED GRAPHICS");
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          mediaImage: props.mediaImage
        });
      });
    }
  }, [props.items, props.mediaImage, (_props$mediaImage = props.mediaImage) == null ? void 0 : _props$mediaImage.src]);
  //Solo actualiza el estado si no es el padre en encargado de actualizar la lista
  function itemsChanged(items) {
    if (props.onItemsChanged) {
      props.onItemsChanged(state.items);
    } else {
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          items: items
        });
      });
    }
  }
  function onChangeImage(subItemImageUpdate) {
    if (props.onItemImageUpdated) {
      props.onItemImageUpdated(subItemImageUpdate);
    } else {
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          mediaImage: subItemImageUpdate
        });
      });
    }
  }
  //https://github.com/thenativeweb/wolkenkit-boards/blob/master/client/src/components/Draggable/index.js#L113
  function onDrop(event, node, index) {
    //console.log("onDrop: ");
    var clientRect = node.getBoundingClientRect(),
      parentRect = node.offsetParent.getBoundingClientRect();
    var draggingPosition = {
      x: clientRect.left - parentRect.left + state.offsetPin /*clientRect.width/2*/ /* + node.offsetParent.scrollLeft*/,
      y: clientRect.top - parentRect.top + state.offsetPin /*clientRect.height/2*/ /* + node.offsetParent.scrollTop*/
    };

    var draggingPositionRelative = {
      x: draggingPosition.x / parentRect.width * 100,
      y: draggingPosition.y / parentRect.height * 100
    };
    var _state = _extends({}, state),
      items = _state.items;
    var currentItems = items;
    if (currentItems[index].x != draggingPositionRelative.x && currentItems[index].y != draggingPositionRelative.y) {
      // Lo ha desplazado
      currentItems[index].x = draggingPositionRelative.x;
      currentItems[index].y = draggingPositionRelative.y;
      itemsChanged(currentItems);
    } else {
      //Solo ha seleccionado
      props.onItemSelect && props.onItemSelect(currentItems[index].id);
    }
  }
  function createNewItem(event) {
    //console.log("New Item");
    if (imgRef.current) {
      var parentRect = imgRef.current.getBoundingClientRect();
      var relativePositionX = event.clientX - parentRect.left,
        relativePositionY = event.clientY - parentRect.top;
      var clickPositionRelative = {
        x: relativePositionX / parentRect.width * 100,
        y: relativePositionY / parentRect.height * 100
      };
      var subItem = undefined;
      var item = props.item;
      if (item) {
        var _items = getItems({
          family: item.family,
          variant: item.variant
        }, pathAssets, folderBlockDefault); //TODO: pasarle los otros dos parametros a esta funcion
        subItem = _items[0];
      }
      var _state2 = _extends({}, state),
        items = _state2.items;
      if (subItem) {
        subItem.title = ''; //"Item "+(items.length+1);
        subItem.description = '';
        subItem.x = clickPositionRelative.x;
        subItem.y = clickPositionRelative.y;
        var currentItems = items;
        currentItems.push(subItem);
        itemsChanged(currentItems);
      }
    }
  }
  return {
    t: t,
    imgRef: imgRef,
    items: state.items,
    mediaImage: state.mediaImage,
    offsetPin: state.offsetPin,
    onDrop: onDrop,
    createNewItem: createNewItem,
    onChangeImage: onChangeImage
  };
}

var LabeledGraphicsPreviewEditor = function LabeledGraphicsPreviewEditor(props) {
  var itemOver = props.itemOver,
    itemSelected = props.itemSelected,
    getSrc = props.getSrc,
    getMediaEditor = props.getMediaEditor,
    onChangeItem = props.onChangeItem,
    getTextHtml = props.getTextHtml;
  var _useLabeledGraphicsPr = useLabeledGraphicsPreviewEditor(props),
    items = _useLabeledGraphicsPr.items,
    mediaImage = _useLabeledGraphicsPr.mediaImage,
    offsetPin = _useLabeledGraphicsPr.offsetPin,
    onDrop = _useLabeledGraphicsPr.onDrop,
    imgRef = _useLabeledGraphicsPr.imgRef,
    createNewItem = _useLabeledGraphicsPr.createNewItem,
    onChangeImage = _useLabeledGraphicsPr.onChangeImage;
  return /*#__PURE__*/React__default.createElement("section", {
    className: 'ItemBlocks_Interactive_Labeledgraphic',
    style: {
      paddingTop: '50px'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'lesson__block-interactive-label lesson__block-interactive-label--medium droppable'
  }, items && items.map(function (item, index) {
    var classBullet = classNames('lesson__block-interactive-label-link', 'ls-icon--' + item.icon, 'brand--border', 'lesson__block-interactive-label-link--show', {
      'labeled-graphics-item-over': itemOver === item.id || itemSelected == item.id
    });
    return /*#__PURE__*/React__default.createElement(Draggable$1, {
      bounds: 'parent',
      positionOffset: {
        x: -offsetPin,
        y: -offsetPin
      },
      position: {
        x: 0,
        y: 0
      },
      onStop: function onStop(e, _ref) {
        var node = _ref.node;
        return onDrop(e, node, index);
      },
      key: 'draggable-' + item.id
    }, /*#__PURE__*/React__default.createElement("div", {
      id: 'pin-' + index,
      className: classBullet,
      style: {
        top: item.y + '%',
        left: item.x + '%'
      },
      key: item.id
    }));
  }), mediaImage && mediaImage.src ? /*#__PURE__*/React__default.createElement(ImageWrapper, {
    showNoAlt: !mediaImage.alt
  }, /*#__PURE__*/React__default.createElement("img", {
    src: getSrc(mediaImage.src),
    ref: imgRef,
    onClick: createNewItem,
    alt: mediaImage.alt
  })) : ''), /*#__PURE__*/React__default.createElement("div", {
    className: 'labeled-graphics__preview__input-image'
  }, getMediaEditor(props.item, mediaImage, function (subItemImageUpdate) {
    if (isMediaImage(subItemImageUpdate)) onChangeImage(subItemImageUpdate);
  }, [ITypeMediaFunctionEditor.IMAGE], {
    onDeleteImage: function onDeleteImage() {
      return console.log('Delete image not allowed');
    }
  }), mediaImage && /*#__PURE__*/React__default.createElement(ImageAltTextSettingSidebar, {
    item: props.item,
    onChangeItem: onChangeItem,
    getTextHtml: getTextHtml,
    subItemImage: mediaImage
  })));
};
LabeledGraphicsPreviewEditor.propTypes = {
  mediaImage: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  items: PropTypes.array.isRequired
};

function useLabeledGraphicsCustomEditor(props) {
  var onChangeItem = props.onChangeItem,
    item = props.item,
    itemImageChanged = props.itemImageChanged;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useState = useState({
      itemSelected: '-1',
      itemOver: '-1',
      items: props.items
    }),
    state = _useState[0],
    dispatch = _useState[1];
  /**
   * Ha cambiado la lista de items
   * @param items
   */
  function onItemsChanged(items) {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        items: items
      });
    });
    onChangeItem && onChangeItem(_extends({}, item, {
      items: items
    }));
  }
  /**
   * Se actualiza un subitem, título, descripción, marker o image
   * @param newItem
   * @param index
   */
  function onItemUpdated(newItem, index) {
    var _state = _extends({}, state),
      items = _state.items;
    items[index] = newItem;
    onItemsChanged(items);
  }
  function onMediaUpdatedIndex(subItemImageUpdate, index) {
    onChangeMediaUpdatedIndex(subItemImageUpdate, item, index, undefined, onChangeItem, true);
  }
  function _onDeleteImageIndex(index) {
    onDeleteMediaIndex(item, index, undefined, onChangeItem);
  }
  function onItemImageUpdated(image) {
    itemImageChanged && itemImageChanged(image);
  }
  function onItemClick(itemId) {
    if (state.itemSelected === itemId) itemId = '-1';
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        itemSelected: itemId
      });
    });
  }
  function onItemOver(e, itemId) {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        itemOver: e === 'mouseenter' ? itemId : -1
      });
    });
  }
  function onClickRemove(e, item) {
    e.preventDefault();
    e.stopPropagation();
    var _state2 = _extends({}, state),
      items = _state2.items;
    var currentItems = items.filter(function (i) {
      return i.id != item.id;
    });
    onItemsChanged(currentItems);
  }
  function onDragEnd(result) {
    if (!result.destination) return;
    if (result.destination.index === result.source.index) return;
    var posInitial = result.source.index;
    var posFinal = result.destination.index;
    var _state3 = _extends({}, state),
      items = _state3.items;
    var currentItems = reorder(items, posInitial, posFinal);
    onItemsChanged(currentItems);
  }
  return {
    t: t,
    items: state.items,
    itemSelected: state.itemSelected,
    itemOver: state.itemOver,
    onDragEnd: onDragEnd,
    onItemOver: onItemOver,
    onItemClick: onItemClick,
    onItemUpdated: onItemUpdated,
    onItemsChanged: onItemsChanged,
    onItemImageUpdated: onItemImageUpdated,
    onClickRemove: onClickRemove,
    onMediaUpdatedIndex: onMediaUpdatedIndex,
    onDeleteImageIndex: _onDeleteImageIndex
  };
}

var LabeledGraphicsCustomEditor = function LabeledGraphicsCustomEditor(props) {
  var getTextHtml = props.getTextHtml,
    item = props.item,
    getSrc = props.getSrc,
    getMediaEditor = props.getMediaEditor,
    mediaImage = props.mediaImage,
    onChangeItem = props.onChangeItem;
  var _useLabeledGraphicsCu = useLabeledGraphicsCustomEditor(props),
    onDragEnd = _useLabeledGraphicsCu.onDragEnd,
    onItemOver = _useLabeledGraphicsCu.onItemOver,
    onItemClick = _useLabeledGraphicsCu.onItemClick,
    onItemUpdated = _useLabeledGraphicsCu.onItemUpdated,
    onItemsChanged = _useLabeledGraphicsCu.onItemsChanged,
    onItemImageUpdated = _useLabeledGraphicsCu.onItemImageUpdated,
    onClickRemove = _useLabeledGraphicsCu.onClickRemove,
    onMediaUpdatedIndex = _useLabeledGraphicsCu.onMediaUpdatedIndex,
    onDeleteImageIndex = _useLabeledGraphicsCu.onDeleteImageIndex,
    items = _useLabeledGraphicsCu.items,
    itemSelected = _useLabeledGraphicsCu.itemSelected,
    itemOver = _useLabeledGraphicsCu.itemOver,
    t = _useLabeledGraphicsCu.t;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'labeled-graphics__editor'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'labeled-graphics__editor-view',
    id: MINT_ID_BLOCKS_SIDEBAR_CONTENT
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'labeled-graphics__title'
  }, t('Markers', {
    ns: 'editor'
  })), /*#__PURE__*/React__default.createElement(DragDropContext, {
    onDragEnd: onDragEnd
  }, /*#__PURE__*/React__default.createElement(Droppable, {
    droppableId: 'labeled-graphics-droppable'
  }, function (provided) {
    return /*#__PURE__*/React__default.createElement("ul", Object.assign({
      ref: provided.innerRef
    }, provided.droppableProps, {
      className: 'labeled-graphics__list'
    }), items ? items.map(function (subItem, index) {
      var classNameItemContent = classNames('labeled-graphics__item', {
        'item-content--show': subItem.id === itemSelected
      });
      var classNameItemHeader = classNames('labeled-graphics__item__header', {
        'item-header--show-controls': subItem.id === itemOver
      });
      return /*#__PURE__*/React__default.createElement(Draggable, {
        draggableId: subItem.id,
        index: index,
        key: subItem.id
      }, function (provided) {
        return /*#__PURE__*/React__default.createElement("li", Object.assign({
          className: classNameItemContent,
          key: 'item-edit-' + subItem.id,
          ref: provided.innerRef
        }, provided.draggableProps, provided.dragHandleProps, {
          onMouseEnter: function onMouseEnter(e) {
            return onItemOver(e.type, subItem.id);
          },
          onMouseLeave: function onMouseLeave(e) {
            return onItemOver(e.type, subItem.id);
          }
        }), /*#__PURE__*/React__default.createElement("div", {
          className: classNameItemHeader,
          onClick: function onClick() {
            return onItemClick(subItem.id);
          }
        }, /*#__PURE__*/React__default.createElement(SvgDragHandler, {
          className: 'labeled-graphics__item__drag-handler'
        }), /*#__PURE__*/React__default.createElement("span", {
          className: 'labeled-graphics__item__title'
        }, getTextHtml(subItem.title || t('Item', {
          ns: 'editor'
        }) + " " + (index + 1), function () {}, subItem.id + '_title', IModesTextHtml.MODE_TEXT_HTML_VISOR)), /*#__PURE__*/React__default.createElement("div", {
          className: 'labeled-graphics__item__controls'
        }, /*#__PURE__*/React__default.createElement(Button, {
          onClick: function onClick(e) {
            return onClickRemove(e, subItem);
          }
        }, /*#__PURE__*/React__default.createElement(SvgTrash$2, null))), /*#__PURE__*/React__default.createElement(SvgDownArrow2, {
          className: 'labeled-graphics__item__down'
        })), /*#__PURE__*/React__default.createElement("div", {
          className: 'labeled-graphics__item__content'
        }, /*#__PURE__*/React__default.createElement(LabeledGraphicsItemEditor, {
          index: index,
          item: subItem,
          itemParent: item,
          onItemUpdated: onItemUpdated,
          onMediaUpdated: onMediaUpdatedIndex,
          getTextHtml: getTextHtml,
          getSrc: getSrc,
          getMediaEditor: getMediaEditor,
          onDeleteImageIndex: onDeleteImageIndex,
          onChangeItem: onChangeItem
        })));
      });
    }) : '', provided.placeholder);
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: 'labeled-graphics__preview-view'
  }, /*#__PURE__*/React__default.createElement(LabeledGraphicsPreviewEditor, {
    items: items,
    item: item,
    mediaImage: mediaImage,
    itemOver: itemOver,
    itemSelected: itemSelected,
    onItemsChanged: onItemsChanged,
    onItemSelect: onItemClick,
    onItemImageUpdated: onItemImageUpdated,
    getSrc: getSrc,
    getMediaEditor: getMediaEditor,
    onChangeItem: onChangeItem,
    getTextHtml: getTextHtml
  })));
};

var LabeledgraphicsSettings = function LabeledgraphicsSettings(props) {
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    isOnlySettings: true,
    settingsAditional: [SETTING_IMAGE_WIDTH]
  }));
};

function useLabeledGraphicEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function captionUpdated(text) {
    onCaptionUpdated(text, item, onChangeItem);
  }
  function imageUpdated(imageUpdate) {
    onChangeMediaImage(imageUpdate, item, onChangeItem);
  }
  return {
    t: t,
    captionUpdated: captionUpdated,
    imageUpdated: imageUpdated
  };
}

var LabeledGraphicEditor = function LabeledGraphicEditor(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    getMediaEditor = props.getMediaEditor,
    mode = props.mode,
    onChangeItem = props.onChangeItem,
    getSrc = props.getSrc;
  var _useLabeledGraphicEdi = useLabeledGraphicEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    imageUpdated = _useLabeledGraphicEdi.imageUpdated,
    t = _useLabeledGraphicEdi.t;
  var items = item.items;
  var mediaImage = item.media && item.media.image ? item.media.image : null;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(LabeledGraphicsCustomEditor, Object.assign({}, sidebarProps, {
        items: items,
        mediaImage: mediaImage,
        getSrc: getSrc,
        getMediaEditor: getMediaEditor,
        itemImageChanged: imageUpdated
      }));
    },
    renderSidebarSettings: function renderSidebarSettings(sidebarSettingsProps) {
      return /*#__PURE__*/React__default.createElement(LabeledgraphicsSettings, Object.assign({}, sidebarSettingsProps, {
        t: t
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(LabeledGraphic, Object.assign({}, contentProps, {
        item: item,
        getTextHtml: getTextHtml,
        getSrc: getSrc,
        mode: mode
      }));
    }
  }));
};

function ProcessEditorSidebarItem(_ref) {
  var _subItem$media, _subItem$media2;
  var item = _ref.item,
    subItem = _ref.subItem,
    indexFromItems = _ref.indexFromItems,
    indexFromOriginalItems = _ref.indexFromOriginalItems,
    titleUpdatedIndex = _ref.titleUpdatedIndex,
    descriptionUpdatedIndex = _ref.descriptionUpdatedIndex,
    captionUpdatedIndex = _ref.captionUpdatedIndex,
    imageUpdatedIndex = _ref.imageUpdatedIndex,
    t = _ref.t,
    onDeleteImageIndex = _ref.onDeleteImageIndex,
    getTextHtml = _ref.getTextHtml,
    getMediaEditor = _ref.getMediaEditor,
    onChangeItem = _ref.onChangeItem;
  var subItemImage = getItemImageIndex(item, indexFromOriginalItems);
  console.log('subItemImage', subItemImage);
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint__block-text',
    key: "process-item-id__" + subItem.id
  }, /*#__PURE__*/React__default.createElement("p", {
    className: 'label'
  }, t('Title', {
    ns: 'editor'
  }) + ' ' + (indexFromItems + 1)), getTextHtml(subItem.title, function (text) {
    return titleUpdatedIndex(text, indexFromOriginalItems);
  }, item.id + '_title', IModesTextHtml.MODE_TEXT_HTML_EDITOR), /*#__PURE__*/React__default.createElement("p", {
    className: 'label'
  }, t('Description', {
    ns: 'editor'
  })), getTextHtml(subItem.description, function (text) {
    return descriptionUpdatedIndex(text, indexFromOriginalItems);
  }, item.id + '_description', IModesTextHtml.MODE_TEXT_HTML_EDITOR), /*#__PURE__*/React__default.createElement("p", {
    className: 'label'
  }, t('Imagen', {
    ns: 'editor'
  })), getMediaEditor(item, getItemImageIndex(item, indexFromOriginalItems), function (subItemImageUpdate) {
    if (isMediaImage(subItemImageUpdate)) imageUpdatedIndex(subItemImageUpdate, indexFromOriginalItems);
  }, [ITypeMediaFunctionEditor.IMAGE], {
    maxHeightPreview: '100px',
    maxWidthPreview: '100px',
    onDeleteImage: function onDeleteImage() {
      return onDeleteImageIndex(indexFromOriginalItems);
    },
    showDeleteButton: true
  }), subItemImage && /*#__PURE__*/React__default.createElement(ImageAltTextSettingSidebar, {
    item: item,
    onChangeItem: onChangeItem,
    getTextHtml: getTextHtml,
    subItemImage: subItemImage,
    index: indexFromOriginalItems
  }), (subItem == null || (_subItem$media = subItem.media) == null ? void 0 : _subItem$media.image) && /*#__PURE__*/React__default.createElement("p", {
    className: 'label'
  }, t('Caption', {
    ns: 'editor'
  })), (subItem == null || (_subItem$media2 = subItem.media) == null ? void 0 : _subItem$media2.image) && getTextHtml(subItem.caption, function (text) {
    return captionUpdatedIndex(text, indexFromOriginalItems);
  }, item.id + '_caption', IModesTextHtml.MODE_TEXT_HTML_EDITOR));
}

var ProcessEditorSidebar = function ProcessEditorSidebar(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    getMediaEditor = props.getMediaEditor,
    onDeleteImageIndex = props.onDeleteImageIndex,
    titleUpdatedIndex = props.titleUpdatedIndex,
    descriptionUpdatedIndex = props.descriptionUpdatedIndex,
    captionUpdatedIndex = props.captionUpdatedIndex,
    imageUpdatedIndex = props.imageUpdatedIndex,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    pathAssets = _useGeneral.pathAssets,
    folderBlockDefault = _useGeneral.folderBlockDefault;
  var idsItemsItem = getIdsItems(item);
  var items = useMemo(function () {
    return getItemsReorderProcess(item);
  }, [item != null && item.items ? JSON.stringify(idsItemsItem) : null]);
  var _useState = useState(null),
    itemState = _useState[0],
    setItemState = _useState[1];
  useEffect(function () {
    updateItemLocalState();
  }, []);
  useEffect(function () {
    updateItemLocalState();
  }, [item, item.items ? JSON.stringify(item.items) : null]);
  function updateItemLocalState() {
    if (item && items && itemState && itemState.items && JSON.stringify(items) !== JSON.stringify(itemState.items)) {
      // == Si son diferentes los items de dentro de item de items los actualizo
      setItemState(getItemUpdatedItems(item, items));
      notifyChangeItem();
    } else {
      if (JSON.stringify(item) !== JSON.stringify(itemState)) {
        setItemState(item);
      }
    }
  }
  function getSubitemToAdd() {
    var subItemToRet = null;
    var item = itemState;
    if (item) {
      var _items = getItems({
        family: item.family,
        variant: item.variant
      }, pathAssets, folderBlockDefault);
      var itemsStep = _items.filter(function (itemInside) {
        return itemInside.type == 'step';
      });
      if (itemsStep && itemsStep.length > 0 && itemsStep[0]) {
        // Por petición de los editores, se requiere que esté vacío para agilizar
        subItemToRet = _extends({}, itemsStep[0], {
          description: '',
          title: ''
        });
        if (subItemToRet.media) delete subItemToRet.media;
      }
    }
    return subItemToRet;
  }
  function getIndexOriginalItem(itemId) {
    var _item$items;
    return item == null || (_item$items = item.items) == null ? void 0 : _item$items.findIndex(function (itemFind) {
      return itemFind.id === itemId;
    });
  }
  function notifyChangeItem() {
    if (itemState) {
      if (onChangeItem) {
        onChangeItem(itemState);
      }
    }
  }
  function getHeader(type) {
    if (type == 'step') {
      return t('Step', {
        ns: 'editor'
      });
    } else if (type == 'intro') {
      return t('Intro', {
        ns: 'editor'
      });
    } else if (type == 'summary') {
      return t('Summary', {
        ns: 'editor'
      });
    }
  }
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_Interactive_Process',
    classTabs: 'mint-tab-content-settings-sidebar--nopadding',
    settingsAditional: [SETTING_STEP_LABEL],
    renderContent: function renderContent() {
      return /*#__PURE__*/React__default.createElement(AsideEditorItemBlockList, {
        item: item,
        items: items,
        hasChangedItem: onChangeItem,
        textButtonAdd: t('Add Step', {
          ns: 'editor'
        }),
        getSubitemToAdd: getSubitemToAdd
      }, items ? items.map(function (itemInside, index) {
        return /*#__PURE__*/React__default.createElement(ProcessEditorSidebarItem, {
          key: 'process-' + index,
          item: item,
          isDragDisabled: itemInside.type == 'step' ? false : true,
          header: getHeader(itemInside.type),
          isDeletedDisabled: itemInside.type == 'step' ? false : true,
          subItem: itemInside,
          indexFromItems: index,
          indexFromOriginalItems: getIndexOriginalItem(itemInside.id),
          mode: IModesTextHtml.MODE_TEXT_HTML_EDITOR,
          titleUpdatedIndex: titleUpdatedIndex,
          descriptionUpdatedIndex: descriptionUpdatedIndex,
          captionUpdatedIndex: captionUpdatedIndex,
          imageUpdatedIndex: imageUpdatedIndex,
          onDeleteImageIndex: onDeleteImageIndex,
          getTextHtml: getTextHtml,
          getMediaEditor: getMediaEditor,
          onChangeItem: onChangeItem,
          t: t
        });
      }) : '');
    }
  }));
};

function useProcessEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function titleUpdatedIndex(text, index) {
    onTitleUpdatedIndex(text, item, index, undefined, onChangeItem);
  }
  function descriptionUpdatedIndex(text, index) {
    onDescriptionUpdatedIndex(text, item, index, undefined, onChangeItem);
  }
  function captionUpdatedIndex(text, index) {
    onCaptionUpdatedIndex(text, item, index, undefined, onChangeItem);
  }
  function imageUpdatedIndex(subItemImageUpdate, index) {
    onChangeImageUpdatedIndex(subItemImageUpdate, item, index, undefined, onChangeItem);
  }
  function _onDeleteImageIndex(index) {
    onDeleteMediaIndex(item, index, undefined, onChangeItem);
  }
  return {
    t: t,
    titleUpdatedIndex: titleUpdatedIndex,
    imageUpdatedIndex: imageUpdatedIndex,
    descriptionUpdatedIndex: descriptionUpdatedIndex,
    captionUpdatedIndex: captionUpdatedIndex,
    onDeleteImageIndex: _onDeleteImageIndex
  };
}

var ProcessEditor = function ProcessEditor(props) {
  var item = props.item,
    getMediaEditor = props.getMediaEditor,
    onChangeItem = props.onChangeItem,
    getSrc = props.getSrc;
  var _useProcessEditor = useProcessEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    imageUpdatedIndex = _useProcessEditor.imageUpdatedIndex,
    titleUpdatedIndex = _useProcessEditor.titleUpdatedIndex,
    descriptionUpdatedIndex = _useProcessEditor.descriptionUpdatedIndex,
    captionUpdatedIndex = _useProcessEditor.captionUpdatedIndex,
    onDeleteImageIndex = _useProcessEditor.onDeleteImageIndex;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(ProcessEditorSidebar, Object.assign({}, sidebarProps, {
        getMediaEditor: getMediaEditor,
        imageUpdatedIndex: imageUpdatedIndex,
        titleUpdatedIndex: titleUpdatedIndex,
        descriptionUpdatedIndex: descriptionUpdatedIndex,
        captionUpdatedIndex: captionUpdatedIndex,
        onDeleteImageIndex: onDeleteImageIndex
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(Process, Object.assign({}, contentProps, {
        getSrc: getSrc,
        titleUpdatedIndex: titleUpdatedIndex,
        descriptionUpdatedIndex: descriptionUpdatedIndex,
        captionUpdatedIndex: captionUpdatedIndex
      }));
    }
  }));
};

var _TabItemEditor = function TabItemEditor(props) {
  return /*#__PURE__*/React__default.createElement(BaseItemEditor, Object.assign({}, props, {
    allowedMediaTypes: [ITypeMediaFunctionEditor.AUDIO, ITypeMediaFunctionEditor.IMAGE, ITypeMediaFunctionEditor.VIDEO],
    ItemEditorComponent: _TabItemEditor
  }));
};

var TabsEditorSidebar = function TabsEditorSidebar(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    getMediaEditor = props.getMediaEditor,
    captionUpdatedIndex = props.captionUpdatedIndex,
    titleUpdatedIndex = props.titleUpdatedIndex,
    descriptionUpdatedIndex = props.descriptionUpdatedIndex,
    alignImageUpdatedIndex = props.alignImageUpdatedIndex,
    sizeImageUpdatedIndex = props.sizeImageUpdatedIndex,
    onChangeItem = props.onChangeItem,
    onDeleteMediaIndex = props.onDeleteMediaIndex,
    mediaUpdatedIndex = props.mediaUpdatedIndex;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var items = item && item.items ? item.items : [];
  var optionsImageSizes = OPTIONS_IMAGE_SIZES;
  var showAdditionalContentsSubItemEditor = ConfigGlobalSingleton.getInstance().isShowAdditionalContentsSubItemEditor();
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_Image_Hero',
    classTabs: 'mint-tab-content-settings-sidebar--nopadding',
    settingsAditional: [SETTING_ALIGN_IMAGES],
    renderContent: function renderContent() {
      return /*#__PURE__*/React__default.createElement(AsideEditorItemBlockList, {
        item: item,
        items: item.items,
        hasChangedItem: onChangeItem,
        textButtonAdd: t('Add Item', {
          ns: 'editor'
        })
      }, items ? items.map(function (itemInside, index) {
        return /*#__PURE__*/React__default.createElement(_TabItemEditor, {
          key: itemInside.id,
          itemInside: itemInside,
          item: item,
          index: index,
          getTextHtml: getTextHtml,
          getMediaEditor: getMediaEditor,
          titleUpdatedIndex: titleUpdatedIndex,
          descriptionUpdatedIndex: descriptionUpdatedIndex,
          captionUpdatedIndex: captionUpdatedIndex,
          mediaUpdatedIndex: mediaUpdatedIndex,
          alignImageUpdatedIndex: alignImageUpdatedIndex,
          sizeImageUpdatedIndex: sizeImageUpdatedIndex,
          onChangeItem: onChangeItem,
          onDeleteMediaIndex: onDeleteMediaIndex,
          t: t,
          optionsImageSizes: optionsImageSizes,
          showContents: showAdditionalContentsSubItemEditor && true
        });
      }) : '');
    }
  }));
};

function useTabsEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function captionUpdatedIndex(text, index, indexContents) {
    onCaptionUpdatedIndex(text, item, index, indexContents, onChangeItem);
  }
  function mediaUpdatedIndex(subItemMediaUpdate, index, indexContents) {
    onChangeMediaUpdatedIndex(subItemMediaUpdate, item, index, indexContents, onChangeItem, true);
  }
  function descriptionUpdatedIndex(text, index, indexContents) {
    onDescriptionUpdatedIndex(text, item, index, indexContents, onChangeItem);
  }
  function titleUpdatedIndex(text, index, indexContents) {
    onTitleUpdatedIndex(text, item, index, indexContents, onChangeItem);
  }
  function alignImageUpdatedIndex(alignImage, index, indexContents) {
    onAlignImageUpdatedIndex(alignImage, item, index, indexContents, onChangeItem);
  }
  function _onDeleteMediaIndex(index, indexContents) {
    onDeleteMediaIndex(item, index, indexContents, onChangeItem);
  }
  function sizeImageUpdatedIndex(sizeImage, index, indexContents) {
    onSizeImageUpdatedIndex(sizeImage, item, index, indexContents, onChangeItem);
  }
  return {
    t: t,
    captionUpdatedIndex: captionUpdatedIndex,
    descriptionUpdatedIndex: descriptionUpdatedIndex,
    mediaUpdatedIndex: mediaUpdatedIndex,
    titleUpdatedIndex: titleUpdatedIndex,
    alignImageUpdatedIndex: alignImageUpdatedIndex,
    sizeImageUpdatedIndex: sizeImageUpdatedIndex,
    onDeleteMediaIndex: _onDeleteMediaIndex
  };
}

var TabsEditor = function TabsEditor(props) {
  var item = props.item,
    getMediaEditor = props.getMediaEditor,
    mode = props.mode,
    onChangeItem = props.onChangeItem,
    getSrc = props.getSrc;
  var _useTabsEditor = useTabsEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    mediaUpdatedIndex = _useTabsEditor.mediaUpdatedIndex,
    descriptionUpdatedIndex = _useTabsEditor.descriptionUpdatedIndex,
    titleUpdatedIndex = _useTabsEditor.titleUpdatedIndex,
    captionUpdatedIndex = _useTabsEditor.captionUpdatedIndex,
    alignImageUpdatedIndex = _useTabsEditor.alignImageUpdatedIndex,
    sizeImageUpdatedIndex = _useTabsEditor.sizeImageUpdatedIndex,
    onDeleteMediaIndex = _useTabsEditor.onDeleteMediaIndex;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-tabs-editor'
  }, /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(TabsEditorSidebar, Object.assign({}, sidebarProps, {
        getMediaEditor: getMediaEditor,
        mode: mode,
        mediaUpdatedIndex: mediaUpdatedIndex,
        onDeleteMediaIndex: onDeleteMediaIndex,
        captionUpdatedIndex: captionUpdatedIndex,
        titleUpdatedIndex: titleUpdatedIndex,
        descriptionUpdatedIndex: descriptionUpdatedIndex,
        alignImageUpdatedIndex: alignImageUpdatedIndex,
        sizeImageUpdatedIndex: sizeImageUpdatedIndex
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(Tabs, Object.assign({}, contentProps, {
        descriptionUpdatedIndex: descriptionUpdatedIndex,
        captionUpdatedIndex: captionUpdatedIndex,
        titleUpdatedIndex: titleUpdatedIndex,
        getSrc: getSrc
      }));
    }
  })));
};

function TimelineEditorSidebarItem(_ref) {
  var item = _ref.item,
    subItem = _ref.subItem,
    indexFromItems = _ref.indexFromItems,
    indexFromOriginalItems = _ref.indexFromOriginalItems,
    titleUpdatedIndex = _ref.titleUpdatedIndex,
    descriptionUpdatedIndex = _ref.descriptionUpdatedIndex,
    imageUpdatedIndex = _ref.imageUpdatedIndex,
    t = _ref.t,
    onDeleteImageIndex = _ref.onDeleteImageIndex,
    getTextHtml = _ref.getTextHtml,
    getMediaEditor = _ref.getMediaEditor,
    onChangeItem = _ref.onChangeItem;
  var subItemImage = getItemImageIndex(item, indexFromOriginalItems);
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-time-sidebar-item mint__block-text',
    key: "timeline-item-id__" + subItem.id
  }, /*#__PURE__*/React__default.createElement("p", {
    className: 'label'
  }, t('Title', {
    ns: 'editor'
  }) + ' ' + (indexFromItems + 1)), getTextHtml(subItem.title, function (text) {
    return titleUpdatedIndex(text, indexFromOriginalItems);
  }, item.id + '_title', IModesTextHtml.MODE_TEXT_HTML_EDITOR), /*#__PURE__*/React__default.createElement("p", {
    className: 'label'
  }, t('Description', {
    ns: 'editor'
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-time-sidebar-item__description'
  }, getTextHtml(subItem.description, function (text) {
    return descriptionUpdatedIndex(text, indexFromOriginalItems);
  }, item.id + '_description', IModesTextHtml.MODE_TEXT_HTML_EDITOR)), /*#__PURE__*/React__default.createElement("p", {
    className: 'label'
  }, t('Imagen', {
    ns: 'editor'
  })), getMediaEditor(item, getItemImageIndex(item, indexFromOriginalItems), function (subItemImageUpdate) {
    if (isMediaImage(subItemImageUpdate)) imageUpdatedIndex(subItemImageUpdate, indexFromOriginalItems);
  }, [ITypeMediaFunctionEditor.IMAGE], {
    maxHeightPreview: '100px',
    maxWidthPreview: '100px',
    onDeleteImage: function onDeleteImage() {
      return onDeleteImageIndex(indexFromOriginalItems);
    },
    showDeleteButton: true
  }), subItemImage && /*#__PURE__*/React__default.createElement(ImageAltTextSettingSidebar, {
    item: item,
    onChangeItem: onChangeItem,
    getTextHtml: getTextHtml,
    subItemImage: subItemImage,
    index: indexFromOriginalItems
  }));
}

var _path$z;
function _extends$V() { _extends$V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$V.apply(this, arguments); }
var SvgChevronDown$1 = function SvgChevronDown(props) {
  return /*#__PURE__*/createElement("svg", _extends$V({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$z || (_path$z = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.293 7.293a1 1 0 0 1 1.414 0L10 10.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414z",
    fill: "#828282"
  })));
};

var _path$A;
function _extends$W() { _extends$W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$W.apply(this, arguments); }
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/createElement("svg", _extends$W({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$A || (_path$A = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.707 12.707a1 1 0 0 1-1.414 0L10 9.414l-3.293 3.293a1 1 0 0 1-1.414-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414z",
    fill: "#828282"
  })));
};

function useTimelineStartEndAccordion(props) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  function onClickHeader() {
    setIsOpen(function (prevState) {
      return !prevState;
    });
  }
  return {
    t: t,
    isOpen: isOpen,
    onClickHeader: onClickHeader
  };
}

function TimelineStartEndAccordion(props) {
  var headerTextComponent = props.headerTextComponent,
    contentComponent = props.contentComponent;
  var _useTimelineStartEndA = useTimelineStartEndAccordion(),
    onClickHeader = _useTimelineStartEndA.onClickHeader,
    isOpen = _useTimelineStartEndA.isOpen;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'timeline-start-end-accordion timeline-start-end-accordion--' + (isOpen ? 'show' : 'hidden')
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'timeline-start-end-accordion__wrap'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'timeline-start-end-accordion__header',
    onClick: onClickHeader
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'timeline-start-end-accordion__header-text'
  }, headerTextComponent)), /*#__PURE__*/React__default.createElement("div", {
    className: 'timeline-start-end-accordion__content'
  }, contentComponent)), /*#__PURE__*/React__default.createElement("div", {
    className: 'timeline-start-end-accordion__symbol',
    onClick: onClickHeader
  }, isOpen ? /*#__PURE__*/React__default.createElement(SvgChevronUp, null) : /*#__PURE__*/React__default.createElement(SvgChevronDown$1, null)));
}

function TimelineEditorSidebarItemStartEnd(_ref) {
  var item = _ref.item,
    subItem = _ref.subItem,
    indexFromOriginalItems = _ref.indexFromOriginalItems,
    titleUpdatedIndex = _ref.titleUpdatedIndex,
    getTextHtml = _ref.getTextHtml,
    titleLabel = _ref.titleLabel;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'timeline-sidebar-item-start-end'
  }, /*#__PURE__*/React__default.createElement(TimelineStartEndAccordion, {
    headerTextComponent: /*#__PURE__*/React__default.createElement("div", {
      className: 'timeline-sidebar-item-start-end__header'
    }, /*#__PURE__*/React__default.createElement("p", {
      className: 'label'
    }, titleLabel)),
    contentComponent: /*#__PURE__*/React__default.createElement("div", {
      className: 'timeline-sidebar-item-start-end__content'
    }, /*#__PURE__*/React__default.createElement("div", {
      className: 'mint__block-text',
      key: "timeline-item-id__" + subItem.id
    }, getTextHtml(subItem.title, function (text) {
      return titleUpdatedIndex(text, indexFromOriginalItems);
    }, item.id + '_title', IModesTextHtml.MODE_TEXT_HTML_TEXT_EDITOR)))
  }));
}

var TimelineEditorSidebar = function TimelineEditorSidebar(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    getMediaEditor = props.getMediaEditor,
    onDeleteImageIndex = props.onDeleteImageIndex,
    titleUpdatedIndex = props.titleUpdatedIndex,
    descriptionUpdatedIndex = props.descriptionUpdatedIndex,
    imageUpdatedIndex = props.imageUpdatedIndex,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    pathAssets = _useGeneral.pathAssets,
    folderBlockDefault = _useGeneral.folderBlockDefault;
  var idsItemsItem = getIdsItems(item);
  var items = useMemo(function () {
    return getItemsReorderTimeline(item);
  }, [item != null && item.items ? JSON.stringify(idsItemsItem) : null]);
  var _useState = useState(null),
    itemState = _useState[0],
    setItemState = _useState[1];
  useEffect(function () {
    updateItemLocalState();
  }, []);
  useEffect(function () {
    updateItemLocalState();
  }, [item, item.items ? JSON.stringify(item.items) : null]);
  function updateItemLocalState() {
    if (item && items && itemState && itemState.items && JSON.stringify(items) !== JSON.stringify(itemState.items)) {
      // == Si son diferentes los items de dentro de item de items los actualizo
      var itemUpdateItems = getItemUpdatedItems(item, items);
      setItemState(itemUpdateItems);
      notifyChangeItem(itemUpdateItems);
    } else {
      if (JSON.stringify(item) !== JSON.stringify(itemState)) {
        setItemState(item);
      }
    }
  }
  function getSubitemToAdd() {
    var subItemToRet = null;
    var item = itemState;
    if (item) {
      var _items = getItems({
        family: item.family,
        variant: item.variant
      }, pathAssets, folderBlockDefault);
      var itemsStep = _items.filter(function (itemInside) {
        return itemInside.type == 'step';
      });
      if (itemsStep && itemsStep.length > 0 && itemsStep[0]) {
        // Por petición de los editores, se requiere que esté vacío para agilizar
        subItemToRet = _extends({}, itemsStep[0], {
          description: '',
          title: ''
        });
        if (subItemToRet.media) delete subItemToRet.media;
      }
    }
    return subItemToRet;
  }
  function getIndexOriginalItem(itemId) {
    var _item$items;
    return item == null || (_item$items = item.items) == null ? void 0 : _item$items.findIndex(function (itemFind) {
      return itemFind.id === itemId;
    });
  }
  function notifyChangeItem(itemToNotify) {
    if (itemToNotify) {
      if (onChangeItem) {
        onChangeItem(itemToNotify);
      }
    }
  }
  function getHeader(type) {
    if (type == 'step') {
      return t('Step', {
        ns: 'editor'
      });
    } else if (type == 'start') {
      return t('timeline_title_start', {
        ns: 'editor'
      });
    } else if (type == 'end') {
      return t('timeline_title_end', {
        ns: 'editor'
      });
    } else return '';
  }
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_Interactive_Timeline',
    classTabs: 'mint-tab-content-settings-sidebar--nopadding',
    settingsAditional: [],
    renderContent: function renderContent() {
      return /*#__PURE__*/React__default.createElement(AsideEditorItemBlockList, {
        item: item,
        items: items,
        hasChangedItem: onChangeItem,
        textButtonAdd: t('Add Step', {
          ns: 'editor'
        }),
        getSubitemToAdd: getSubitemToAdd
      }, items ? items.map(function (itemInside, index) {
        return itemInside.type == 'step' ? /*#__PURE__*/React__default.createElement(TimelineEditorSidebarItem, {
          key: 'timeline-' + index,
          item: item,
          isDragDisabled: itemInside.type == 'step' ? false : true,
          header: getHeader(itemInside.type),
          isDeletedDisabled: itemInside.type == 'step' ? false : true,
          subItem: itemInside,
          indexFromItems: index,
          indexFromOriginalItems: getIndexOriginalItem(itemInside.id),
          mode: IModesTextHtml.MODE_TEXT_HTML_EDITOR,
          titleUpdatedIndex: titleUpdatedIndex,
          descriptionUpdatedIndex: descriptionUpdatedIndex,
          imageUpdatedIndex: imageUpdatedIndex,
          onDeleteImageIndex: onDeleteImageIndex,
          getTextHtml: getTextHtml,
          getMediaEditor: getMediaEditor,
          t: t,
          onChangeItem: onChangeItem
        }) : itemInside.type == 'start' || itemInside.type == 'end' ? /*#__PURE__*/React__default.createElement(TimelineEditorSidebarItemStartEnd, {
          key: 'timeline-' + index,
          item: item,
          isDragDisabled: true,
          isDeletedDisabled: true,
          paintOnlyChild: true,
          titleLabel: getHeader(itemInside.type),
          subItem: itemInside,
          indexFromItems: index,
          indexFromOriginalItems: getIndexOriginalItem(itemInside.id),
          mode: IModesTextHtml.MODE_TEXT_HTML_EDITOR,
          titleUpdatedIndex: titleUpdatedIndex,
          getTextHtml: getTextHtml,
          t: t
        }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
      }) : '');
    }
  }));
};

function useTimelineEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function titleUpdatedIndex(text, index) {
    onTitleUpdatedIndex(text, item, index, undefined, onChangeItem);
  }
  function descriptionUpdatedIndex(text, index) {
    onDescriptionUpdatedIndex(text, item, index, undefined, onChangeItem);
  }
  function imageUpdatedIndex(subItemImageUpdate, index) {
    onChangeImageUpdatedIndex(subItemImageUpdate, item, index, undefined, onChangeItem);
  }
  function _onDeleteImageIndex(index) {
    onDeleteMediaIndex(item, index, undefined, onChangeItem);
  }
  return {
    t: t,
    titleUpdatedIndex: titleUpdatedIndex,
    imageUpdatedIndex: imageUpdatedIndex,
    descriptionUpdatedIndex: descriptionUpdatedIndex,
    onDeleteImageIndex: _onDeleteImageIndex
  };
}

var TimelineEditor = function TimelineEditor(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    getMediaEditor = props.getMediaEditor,
    mode = props.mode,
    onChangeItem = props.onChangeItem,
    getSrc = props.getSrc;
  var _useTimelineEditor = useTimelineEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    imageUpdatedIndex = _useTimelineEditor.imageUpdatedIndex,
    titleUpdatedIndex = _useTimelineEditor.titleUpdatedIndex,
    descriptionUpdatedIndex = _useTimelineEditor.descriptionUpdatedIndex,
    onDeleteImageIndex = _useTimelineEditor.onDeleteImageIndex,
    t = _useTimelineEditor.t;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(TimelineEditorSidebar, Object.assign({}, sidebarProps, {
        item: item,
        getTextHtml: getTextHtml,
        getMediaEditor: getMediaEditor,
        onChangeItem: onChangeItem,
        imageUpdatedIndex: imageUpdatedIndex,
        titleUpdatedIndex: titleUpdatedIndex,
        descriptionUpdatedIndex: descriptionUpdatedIndex,
        onDeleteImageIndex: onDeleteImageIndex,
        t: t
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(Timeline, Object.assign({}, contentProps, {
        item: item,
        getTextHtml: getTextHtml,
        mode: mode,
        getSrc: getSrc,
        titleUpdatedIndex: titleUpdatedIndex,
        descriptionUpdatedIndex: descriptionUpdatedIndex
      }));
    }
  }));
};

var LemonadeEditorSidebar = function LemonadeEditorSidebar(props) {
  var item = props.item,
    _props$role = props.role,
    role = _props$role === void 0 ? roleTypes.STUDENT : _props$role,
    getLemonadeEditor = props.getLemonadeEditor,
    getTextHtml = props.getTextHtml,
    lemonadeUpdated = props.lemonadeUpdated,
    numberUpdatedIndex = props.numberUpdatedIndex,
    closeSidebar = props.closeSidebar;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var subItemLemonade = getItemLemonade(item);
  var items = item && item.items ? item.items : [];
  var firstSubItem = items && item.items && item.items.length > 0 ? item.items[0] : null;
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_Lemonade',
    renderContent: function renderContent() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: 'mint__block-editor-lemonade'
      }, getLemonadeEditor(item, subItemLemonade, function (lemonadeDateUpdated) {
        return lemonadeUpdated(lemonadeDateUpdated);
      }, closeSidebar), role === roleTypes.EDITORIAL && /*#__PURE__*/React__default.createElement("div", {
        className: 'mint__block-text'
      }, /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Index')), firstSubItem && getTextHtml(firstSubItem.number || '', function (text) {
        numberUpdatedIndex == null || numberUpdatedIndex(text, 0);
      }, item.id, IModesTextHtml.MODE_TEXT_HTML_TEXT_EDITOR, t('Index'), undefined, undefined, undefined)));
    }
  }));
};

function useLemonadeEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function lemonadeUpdated(subItemLemonadeUpdate) {
    onChangeLemonadeUpdated(subItemLemonadeUpdate, item, onChangeItem);
  }
  function numberUpdatedIndex(text, index) {
    onNumberUpdatedIndex(text, item, index, onChangeItem);
  }
  return {
    t: t,
    lemonadeUpdated: lemonadeUpdated,
    numberUpdatedIndex: numberUpdatedIndex
  };
}

var LemonadeEditor = function LemonadeEditor(props) {
  var item = props.item,
    getLemonadeEditor = props.getLemonadeEditor,
    mode = props.mode,
    onChangeItem = props.onChangeItem,
    role = props.role,
    closeSidebar = props.closeSidebar;
  var _useLemonadeEditor = useLemonadeEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    lemonadeUpdated = _useLemonadeEditor.lemonadeUpdated,
    numberUpdatedIndex = _useLemonadeEditor.numberUpdatedIndex,
    t = _useLemonadeEditor.t;
  var renderSidebar = function renderSidebar(sidebarProps) {
    return /*#__PURE__*/React__default.createElement(LemonadeEditorSidebar, Object.assign({}, sidebarProps, {
      getLemonadeEditor: getLemonadeEditor,
      mode: mode,
      lemonadeUpdated: lemonadeUpdated,
      numberUpdatedIndex: numberUpdatedIndex,
      role: role,
      closeSidebar: closeSidebar
    }));
  };
  var renderContent = function renderContent(contentProps) {
    var data = item && item.items && item.items.length > 0 ? item.items[0].data : null;
    return item.type === 'lemonade' && item.family === 'lemonade' && (item.variant === 'Lemonade content guid' || item.variant === 'Lemonade feedback content guid') ? /*#__PURE__*/React__default.createElement(SectionItemBlock, Object.assign({}, contentProps), /*#__PURE__*/React__default.createElement("div", {
      style: {
        background: '#efefef',
        padding: '20px'
      }
    }, /*#__PURE__*/React__default.createElement("p", null, t(item.variant === 'Lemonade feedback content guid' ? 'editor:empty_lemonade_feedback' : 'editor:empty_lemonade')))) : /*#__PURE__*/React__default.createElement(LemonadeQuestion$1, Object.assign({}, contentProps, {
      key: data == null ? void 0 : data.content_guid,
      item: item,
      role: role
    }));
  };
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: renderSidebar,
    renderContent: renderContent
  }));
};

var BulletedEditorSidebar = function BulletedEditorSidebar(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    paragraphUpdatedIndex = props.paragraphUpdatedIndex,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var items = item && item.items ? item.items : [];
  var _useState = useState(getNumbersLabelCalculate(items)),
    setNumbersLabel = _useState[1]; // TODO: hacerlo en un hook
  useEffect(function () {
    setNumbersLabel(getNumbersLabelCalculate(items));
  }, [items]);
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_List_Numered',
    classTabs: 'mint-tab-content-settings-sidebar--nopadding',
    renderContent: function renderContent() {
      return /*#__PURE__*/React__default.createElement(AsideEditorItemBlockList, {
        item: item,
        items: item.items,
        hasChangedItem: onChangeItem,
        textButtonAdd: t('Add Item', {
          ns: 'editor'
        })
      }, items ? items.map(function (itemInside, index) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: 'mint__block-text',
          key: itemInside.id
        }, /*#__PURE__*/React__default.createElement("p", {
          className: 'label'
        }, t('List item', {
          ns: 'editor'
        })), getTextHtml(itemInside.paragraph || '', function (text) {
          return paragraphUpdatedIndex && paragraphUpdatedIndex(text, index);
        }, item.id, IModesTextHtml.MODE_TEXT_HTML_EDITOR));
      }) : '');
    }
  }));
};

function useBulletedEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function paragraphUpdatedIndex(text, index) {
    onParagraphUpdatedIndex(text, item, index, onChangeItem);
  }
  return {
    t: t,
    paragraphUpdatedIndex: paragraphUpdatedIndex
  };
}

var BulletedEditor = function BulletedEditor(props) {
  var item = props.item,
    mode = props.mode,
    onChangeItem = props.onChangeItem,
    onDeleteItem = props.onDeleteItem;
  var _useBulletedEditor = useBulletedEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    paragraphUpdatedIndex = _useBulletedEditor.paragraphUpdatedIndex,
    t = _useBulletedEditor.t;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(BulletedEditorSidebar, Object.assign({}, sidebarProps, {
        mode: mode,
        onChangeItem: onChangeItem,
        paragraphUpdatedIndex: paragraphUpdatedIndex,
        t: t
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(Bulleted, Object.assign({}, contentProps, {
        paragraphUpdatedIndex: paragraphUpdatedIndex,
        onChangeItem: onChangeItem,
        onDeleteItem: onDeleteItem
      }));
    }
  }));
};

var NumeredEditorSidebar = function NumeredEditorSidebar(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    paragraphUpdatedIndex = props.paragraphUpdatedIndex,
    numberUpdatedIndex = props.numberUpdatedIndex,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var items = item && item.items ? item.items : [];
  var _useState = useState(getNumbersLabelCalculate(items)),
    numbersLabel = _useState[0],
    setNumbersLabel = _useState[1]; // TODO: hacerlo en un hook
  useEffect(function () {
    setNumbersLabel(getNumbersLabelCalculate(items));
  }, [items]);
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_List_Numered',
    classTabs: 'mint-tab-content-settings-sidebar--nopadding',
    renderContent: function renderContent() {
      return /*#__PURE__*/React__default.createElement(AsideEditorItemBlockList, {
        item: item,
        items: item.items,
        hasChangedItem: onChangeItem,
        textButtonAdd: t('Add Item', {
          ns: 'editor'
        })
      }, items ? items.map(function (itemInside, index) {
        var numberLabel = getNumerLabel(numbersLabel, index);
        return /*#__PURE__*/React__default.createElement("div", {
          className: 'mint__block-text',
          key: itemInside.id
        }, /*#__PURE__*/React__default.createElement("p", {
          className: 'label'
        }, t('List item', {
          ns: 'editor'
        })), /*#__PURE__*/React__default.createElement("p", {
          className: 'label'
        }, t('Index', {
          ns: 'editor'
        })), getTextHtml(itemInside.number || '', function (text) {
          numberUpdatedIndex == null || numberUpdatedIndex(text, index);
        }, item.id, IModesTextHtml.MODE_TEXT_HTML_TEXT_EDITOR, numberLabel), /*#__PURE__*/React__default.createElement("p", {
          className: 'label'
        }, t('Paragraph', {
          ns: 'editor'
        })), getTextHtml(itemInside.paragraph || '', function (text) {
          return paragraphUpdatedIndex && paragraphUpdatedIndex(text, index);
        }, item.id, IModesTextHtml.MODE_TEXT_HTML_EDITOR));
      }) : '');
    }
  }));
};

function useNumeredEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function paragraphUpdatedIndex(text, index) {
    onParagraphUpdatedIndex(text, item, index, onChangeItem);
  }
  function numberUpdatedIndex(text, index) {
    onNumberUpdatedIndex(text, item, index, onChangeItem);
  }
  return {
    t: t,
    paragraphUpdatedIndex: paragraphUpdatedIndex,
    numberUpdatedIndex: numberUpdatedIndex
  };
}

var NumeredEditor = function NumeredEditor(props) {
  var item = props.item,
    mode = props.mode,
    onChangeItem = props.onChangeItem,
    onDeleteItem = props.onDeleteItem;
  var _useNumeredEditor = useNumeredEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    paragraphUpdatedIndex = _useNumeredEditor.paragraphUpdatedIndex,
    numberUpdatedIndex = _useNumeredEditor.numberUpdatedIndex,
    t = _useNumeredEditor.t;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(NumeredEditorSidebar, Object.assign({}, sidebarProps, {
        mode: mode,
        numberUpdatedIndex: numberUpdatedIndex,
        paragraphUpdatedIndex: paragraphUpdatedIndex,
        t: t
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(Numered, Object.assign({}, contentProps, {
        paragraphUpdatedIndex: paragraphUpdatedIndex,
        mode: mode,
        onChangeItem: onChangeItem,
        onDeleteItem: onDeleteItem
      }));
    }
  }));
};

var AudioEditorSidebar = function AudioEditorSidebar(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    getMediaEditor = props.getMediaEditor,
    captionUpdated = props.captionUpdated,
    audioUpdated = props.audioUpdated;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var items = item && item.items ? item.items : [];
  var subItem = item && item.items.length > 0 ? item.items[0] : null;
  var subItemAudio = getItemAudio(item);
  var _useState = useState(getNumbersLabelCalculate(items)),
    setNumbersLabel = _useState[1]; // TODO: hacerlo en un hook
  useEffect(function () {
    setNumbersLabel(getNumbersLabelCalculate(items));
  }, [items]);
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_Image_Hero',
    renderContent: function renderContent() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: 'mint__block-text'
      }, /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Audio')), getMediaEditor(item, subItemAudio, function (subItemAudioUpdated) {
        if (isMediaAudio(subItemAudioUpdated)) audioUpdated(subItemAudioUpdated);
      }, [ITypeMediaFunctionEditor.AUDIO], null), /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Caption', {
        ns: 'editor'
      })), getTextHtml((subItem == null ? void 0 : subItem.caption) || '', function (text) {
        return captionUpdated(text);
      }, item.id + '_caption', IModesTextHtml.MODE_TEXT_HTML_EDITOR));
    }
  }));
};

function useAudioEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function captionUpdated(text) {
    onCaptionUpdated(text, item, onChangeItem);
  }
  function audioUpdated(subItemAudioUpdate) {
    onChangeAudioUpdated(subItemAudioUpdate, item, onChangeItem);
  }
  return {
    t: t,
    captionUpdated: captionUpdated,
    audioUpdated: audioUpdated
  };
}

var AudioEditor = function AudioEditor(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    getMediaEditor = props.getMediaEditor,
    mode = props.mode,
    onChangeItem = props.onChangeItem,
    getSrc = props.getSrc;
  var _useAudioEditor = useAudioEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    captionUpdated = _useAudioEditor.captionUpdated,
    audioUpdated = _useAudioEditor.audioUpdated;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(AudioEditorSidebar, Object.assign({}, sidebarProps, {
        getMediaEditor: getMediaEditor,
        mode: mode,
        audioUpdated: audioUpdated,
        captionUpdated: captionUpdated
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(Audio, Object.assign({}, contentProps, {
        item: item,
        getTextHtml: getTextHtml,
        captionUpdated: captionUpdated,
        mode: mode,
        getSrc: getSrc
      }));
    }
  }));
};

var _g$l;
function _extends$X() { _extends$X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$X.apply(this, arguments); }
var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/createElement("svg", _extends$X({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#fff"
  }, props), _g$l || (_g$l = /*#__PURE__*/createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 2
  }, /*#__PURE__*/createElement("circle", {
    cx: 22,
    cy: 22,
    r: 1
  }, /*#__PURE__*/createElement("animate", {
    attributeName: "r",
    begin: "0s",
    dur: "1.8s",
    values: "1; 20",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.165, 0.84, 0.44, 1",
    repeatCount: "indefinite"
  }), /*#__PURE__*/createElement("animate", {
    attributeName: "stroke-opacity",
    begin: "0s",
    dur: "1.8s",
    values: "1; 0",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.3, 0.61, 0.355, 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/createElement("circle", {
    cx: 22,
    cy: 22,
    r: 1
  }, /*#__PURE__*/createElement("animate", {
    attributeName: "r",
    begin: "-0.9s",
    dur: "1.8s",
    values: "1; 20",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.165, 0.84, 0.44, 1",
    repeatCount: "indefinite"
  }), /*#__PURE__*/createElement("animate", {
    attributeName: "stroke-opacity",
    begin: "-0.9s",
    dur: "1.8s",
    values: "1; 0",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.3, 0.61, 0.355, 1",
    repeatCount: "indefinite"
  })))));
};

var ThemesLoading;
(function (ThemesLoading) {
  ThemesLoading["LIGHT"] = "light";
  ThemesLoading["DARK"] = "dark";
})(ThemesLoading || (ThemesLoading = {}));
function Loading$7(_ref) {
  var text = _ref.text,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? ThemesLoading.LIGHT : _ref$theme;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "mint-loading mint-loading--" + theme
  }, /*#__PURE__*/React__default.createElement(SvgLoading, null), /*#__PURE__*/React__default.createElement("span", {
    className: 'mint-loading__text'
  }, text));
}

//https://metascraper-mint.oneclick.es/api
function getEmbedInfo(args) {
  fetch("" + args.pathApi + args.url, {
    method: args.methodApi,
    headers: new Headers({
      'Content-Type': 'application/json'
    })
  }).then(function (response) {
    if (!response.ok) {
      throw new Error("HTTP error! status: " + response.status);
    }
    return response.json();
  }).then(function (data) {
    if (data.success) {
      args.success(data.tile, data.thumbnail, data.src, data.providerUrl, data.provider, data.originalUrl, data.favicon, data.type, data.description);
    } else {
      args.error(data);
    }
  }).catch(function (error) {
    args.error(error);
  });
}
var embed = {
  getEmbedInfo: getEmbedInfo
};

function useEmbedEditor(_ref) {
  var _ref$initialUrl = _ref.initialUrl,
    initialUrl = _ref$initialUrl === void 0 ? '' : _ref$initialUrl,
    variant = _ref.variant,
    onEmbedUpdate = _ref.onEmbedUpdate;
  var _useGeneral = useGeneral(),
    pathEmbedApi = _useGeneral.pathEmbedApi;
  var _useState = useState(false),
    showEditUrl = _useState[0],
    setShowEditUrl = _useState[1];
  var _useState2 = useState(false),
    errorEditUrl = _useState2[0],
    setErrorEditUrl = _useState2[1];
  var _useState3 = useState(false),
    loading = _useState3[0],
    setLoading = _useState3[1];
  var _useState4 = useState(initialUrl),
    textEditUrl = _useState4[0],
    setTextEditUrl = _useState4[1];
  useEffect(function () {
    setTextEditUrl(initialUrl);
  }, [initialUrl]);
  function onUpdateUrlFrame(url, contentGuid, embedType) {
    if (url.length > 0) {
      if (isValidURL(url) && embedType !== 'htmlInteractive') {
        if (isURLYoutube(url) || isURLVimeo(url)) {
          setErrorEditUrl(false);
          setLoading(true);
          embed.getEmbedInfo({
            url: url,
            pathApi: pathEmbedApi,
            methodApi: 'GET',
            success: function success(title, thumbnail, src, providerUrl, provider, originalUrl, favicon, type, description) {
              onEmbedUpdate(title, thumbnail, src, providerUrl, provider, originalUrl, favicon, type, description, contentGuid);
              setLoading(false);
            },
            error: function error(_error) {
              setLoading(false);
              setErrorEditUrl(true);
              console.log(_error);
            }
          });
        } else setErrorEditUrl(true);
      } else {
        if (isIframe(url)) {
          onEmbedUpdate(undefined, undefined, url, undefined, undefined, url, undefined, 'iframe', undefined, contentGuid);
          onClickCloseChange();
          setErrorEditUrl(false);
        } else if (embedType === 'htmlInteractive') {
          onEmbedUpdate(undefined, undefined, url, undefined, undefined, url, undefined, embedType, undefined, contentGuid);
        } else {
          setErrorEditUrl(true);
        }
      }
    } else {
      setErrorEditUrl(true);
    }
  }
  function onChangeTextEditUrl(text) {
    var textFinal = text;
    if (variant === 'genially') {
      var iframeGenially = getIframeString(text);
      if (iframeGenially) textFinal = iframeGenially;
    }
    setTextEditUrl(textFinal);
    setErrorEditUrl(false);
  }
  function onClickChange() {
    setShowEditUrl(true);
    setTextEditUrl(initialUrl);
    setErrorEditUrl(false);
  }
  function onClickCloseChange() {
    setShowEditUrl(false);
  }
  function onEnterDown() {
    onUpdateUrlFrame(textEditUrl, undefined, undefined);
  }
  return {
    showEditUrl: showEditUrl,
    errorEditUrl: errorEditUrl,
    textEditUrl: textEditUrl,
    loading: loading,
    onUpdateUrlFrame: onUpdateUrlFrame,
    onChangeTextEditUrl: onChangeTextEditUrl,
    onClickChange: onClickChange,
    onClickCloseChange: onClickCloseChange,
    onEnterDown: onEnterDown,
    setShowEditUrl: setShowEditUrl
  };
}

function useEmbedEditorSidebar(props) {
  var _subItem$media, _subItem$media2;
  var item = props.item,
    embedUpdated = props.embedUpdated;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var subItem = item && item.items.length > 0 ? item.items[0] : null;
  var originalUrl = (subItem == null || (_subItem$media = subItem.media) == null || (_subItem$media = _subItem$media.embed) == null ? void 0 : _subItem$media.originalUrl) || '';
  var thumbnail = (subItem == null || (_subItem$media2 = subItem.media) == null || (_subItem$media2 = _subItem$media2.embed) == null ? void 0 : _subItem$media2.thumbnail) || null;
  var settings = (item == null ? void 0 : item.settings) || null;
  var embedEditor = useEmbedEditor({
    initialUrl: originalUrl,
    variant: item == null ? void 0 : item.variant,
    onEmbedUpdate: embedUpdated
  });
  return _extends({
    t: t,
    settings: settings,
    thumbnail: thumbnail,
    originalUrl: originalUrl
  }, embedEditor);
}

var EmbedEditorSidebar = function EmbedEditorSidebar(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    getMediaEditor = props.getMediaEditor,
    embedUpdated = props.embedUpdated,
    onChangeItem = props.onChangeItem;
  var _useEmbedEditorSideba = useEmbedEditorSidebar({
      item: item,
      onChangeItem: onChangeItem,
      embedUpdated: embedUpdated
    }),
    showEditUrl = _useEmbedEditorSideba.showEditUrl,
    originalUrl = _useEmbedEditorSideba.originalUrl,
    errorEditUrl = _useEmbedEditorSideba.errorEditUrl,
    onChangeTextEditUrl = _useEmbedEditorSideba.onChangeTextEditUrl,
    onEnterDown = _useEmbedEditorSideba.onEnterDown,
    textEditUrl = _useEmbedEditorSideba.textEditUrl,
    thumbnail = _useEmbedEditorSideba.thumbnail,
    onClickCloseChange = _useEmbedEditorSideba.onClickCloseChange,
    onClickChange = _useEmbedEditorSideba.onClickChange,
    t = _useEmbedEditorSideba.t,
    loading = _useEmbedEditorSideba.loading,
    onUpdateUrlFrame = _useEmbedEditorSideba.onUpdateUrlFrame,
    setShowEditUrl = _useEmbedEditorSideba.setShowEditUrl;
  var subItemEmbed = getItemEmbed(item);
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_Multimedia_Embed',
    settingsAditional: [SETTING_IMAGE_WIDTH, SETTING_SHOW_BORDER],
    renderContent: function renderContent() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: 'mint__block-text'
      }, /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Media', {
        ns: 'editor'
      })), getMediaEditor(item, subItemEmbed, function (_subItemEmbedUpdated) {
        if (isMediaEmbed(_subItemEmbedUpdated)) {
          var subItemEmbedUpdated = _subItemEmbedUpdated;
          onUpdateUrlFrame(subItemEmbedUpdated.src, subItemEmbedUpdated.content_guid, subItemEmbedUpdated.embedType);
          setShowEditUrl(false);
          /*embedUpdated(
          subItemEmbedUpdated.title,
          subItemEmbedUpdated.thumbnail,
          subItemEmbedUpdated.src,
          subItemEmbedUpdated.providerUrl,
          subItemEmbedUpdated.provider,
          subItemEmbedUpdated.originalUrl,
          subItemEmbedUpdated.favicon,
          subItemEmbedUpdated.embedType,
          subItemEmbedUpdated.description
          );*/
        }
      }, [ITypeMediaFunctionEditor.EMBED], null), showEditUrl ? loading ? /*#__PURE__*/React__default.createElement(Loading$7, {
        text: t('Loading', {
          ns: 'editor'
        }),
        theme: ThemesLoading.DARK
      }) : /*#__PURE__*/React__default.createElement("div", {
        className: 'mint-multimedia-embed-sidebar-edit-wrapper'
      }, /*#__PURE__*/React__default.createElement("div", {
        className: 'mint-multimedia-embed-sidebar-edit'
      }, getTextHtml(textEditUrl, function (text) {
        return onChangeTextEditUrl(text);
      }, item.id, IModesTextHtml.MODE_TEXT_HTML_TEXT_EDITOR, undefined, function () {
        onEnterDown();
      }, undefined, undefined, false), /*#__PURE__*/React__default.createElement("a", {
        onClick: onClickCloseChange,
        className: 'mint-multimedia-embed-sidebar-edit__close'
      }, /*#__PURE__*/React__default.createElement(SvgClose, null))), /*#__PURE__*/React__default.createElement("div", {
        className: 'mint-multimedia-embed-sidebar-edit__below-text-editor'
      }, errorEditUrl && /*#__PURE__*/React__default.createElement("div", {
        className: 'mint-multimedia-embed-sidebar-edit__error'
      }, t(item && item.variant === 'genially' ? 'embed_genially_error_not_valid' : 'embed_error_not_valid', {
        ns: 'editor'
      })), /*#__PURE__*/React__default.createElement("div", {
        className: 'mint-multimedia-embed-sidebar-edit__help'
      }, t('Press Enter to add', {
        ns: 'editor'
      })))) : /*#__PURE__*/React__default.createElement("div", {
        className: 'mint-multimedia-embed-sidebar-content'
      }, thumbnail && /*#__PURE__*/React__default.createElement("div", {
        className: 'mint-multimedia-embed-sidebar-content__thumbnail'
      }, /*#__PURE__*/React__default.createElement("img", {
        src: thumbnail
      })), /*#__PURE__*/React__default.createElement("div", {
        className: 'mint-multimedia-embed-sidebar-content__data'
      }, /*#__PURE__*/React__default.createElement("div", null, originalUrl)), /*#__PURE__*/React__default.createElement("div", {
        className: 'mint-multimedia-embed-sidebar-content__action'
      }, /*#__PURE__*/React__default.createElement("a", {
        className: 'mint-multimedia-embed-sidebar-content__action-link',
        onClick: onClickChange
      }, t('Change', {
        ns: 'editor'
      })))));
    }
  }));
};

function useEmbedEditor$1(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function embedUpdated(title, thumbnail, src, providerUrl, provider, originalUrl, favicon, embedType, description, contentGuid) {
    onEmbedUpdated(title, thumbnail, src, providerUrl, provider, originalUrl, favicon, embedType, description, item, onChangeItem, contentGuid);
  }
  return {
    t: t,
    embedUpdated: embedUpdated
  };
}

var EmbedEditor = function EmbedEditor(props) {
  var item = props.item,
    getMediaEditor = props.getMediaEditor,
    mode = props.mode,
    onChangeItem = props.onChangeItem,
    getSrc = props.getSrc,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className;
  var _useEmbedEditor = useEmbedEditor$1({
      item: item,
      onChangeItem: onChangeItem
    }),
    embedUpdated = _useEmbedEditor.embedUpdated,
    t = _useEmbedEditor.t;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(EmbedEditorSidebar, Object.assign({}, sidebarProps, {
        getMediaEditor: getMediaEditor,
        mode: mode,
        embedUpdated: embedUpdated,
        t: t
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(Embed, Object.assign({}, contentProps, {
        item: item,
        className: className,
        getSrc: getSrc
      }));
    }
  }));
};

function useVideoEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function captionUpdated(text) {
    onCaptionUpdated(text, item, onChangeItem);
  }
  function videoUpdated(subItemVideoUpdate) {
    onChangeVideoUpdated(subItemVideoUpdate, item, onChangeItem);
  }
  return {
    t: t,
    captionUpdated: captionUpdated,
    videoUpdated: videoUpdated
  };
}

var VideoEditorSidebar = function VideoEditorSidebar(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    getMediaEditor = props.getMediaEditor,
    captionUpdated = props.captionUpdated,
    videoUpdated = props.videoUpdated;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var items = item && item.items ? item.items : [];
  var subItem = item && item.items.length > 0 ? item.items[0] : null;
  var subItemVideo = getItemVideo(item);
  var _useState = useState(getNumbersLabelCalculate(items)),
    setNumbersLabel = _useState[1]; // TODO: hacerlo en un hook
  useEffect(function () {
    setNumbersLabel(getNumbersLabelCalculate(items));
  }, [items]);
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_Image_Hero',
    renderContent: function renderContent() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: 'mint__block-text'
      }, /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Video', {
        ns: 'editor'
      })), getMediaEditor(item, subItemVideo, function (subItemVideoUpdated) {
        if (isMediaVideo(subItemVideoUpdated)) videoUpdated(subItemVideoUpdated);
      }, [ITypeMediaFunctionEditor.VIDEO], null), /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Caption', {
        ns: 'editor'
      })), getTextHtml((subItem == null ? void 0 : subItem.caption) || '', function (text) {
        return captionUpdated(text);
      }, item.id + '_caption', IModesTextHtml.MODE_TEXT_HTML_EDITOR));
    }
  }));
};

var VideoEditor = function VideoEditor(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    getMediaEditor = props.getMediaEditor,
    mode = props.mode,
    onChangeItem = props.onChangeItem,
    getSrc = props.getSrc;
  var _useVideoEditor = useVideoEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    captionUpdated = _useVideoEditor.captionUpdated,
    videoUpdated = _useVideoEditor.videoUpdated,
    t = _useVideoEditor.t;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(VideoEditorSidebar, Object.assign({}, sidebarProps, {
        getMediaEditor: getMediaEditor,
        mode: mode,
        videoUpdated: videoUpdated,
        captionUpdated: captionUpdated,
        t: t
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(Video, Object.assign({}, contentProps, {
        item: item,
        getTextHtml: getTextHtml,
        captionUpdated: captionUpdated,
        mode: mode,
        getSrc: getSrc
      }));
    }
  }));
};

var NoteEditorSidebar = function NoteEditorSidebar(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    paragraphUpdated = props.paragraphUpdated,
    t = props.t;
  var subItem = item && item.items ? item.items[0] : undefined;
  var paragraph = subItem == null ? void 0 : subItem.paragraph;
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_Text_HeadingParagraph',
    renderContent: function renderContent() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: 'text-heading-paragraph'
      }, /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Text', {
        ns: 'editor'
      })), getTextHtml(paragraph || '', function (text) {
        return paragraphUpdated && paragraphUpdated(text);
      }, item.id + '_paragraph', IModesTextHtml.MODE_TEXT_HTML_EDITOR));
    }
  }));
};

function useNoteEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function paragraphUpdated(text) {
    onParagraphUpdated(text, item, onChangeItem);
  }
  return {
    t: t,
    paragraphUpdated: paragraphUpdated
  };
}

var NoteEditor = function NoteEditor(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    mode = props.mode,
    onChangeItem = props.onChangeItem;
  var _useNoteEditor = useNoteEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    paragraphUpdated = _useNoteEditor.paragraphUpdated,
    t = _useNoteEditor.t;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(NoteEditorSidebar, Object.assign({}, sidebarProps, {
        paragraphUpdated: paragraphUpdated,
        t: t,
        mode: mode
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(Note, Object.assign({}, contentProps, {
        item: item,
        getTextHtml: getTextHtml,
        paragraphUpdated: paragraphUpdated,
        mode: mode
      }));
    }
  }));
};

var TeacherNotesEditor = function TeacherNotesEditor(props) {
  var item = props.item,
    mode = props.mode,
    onChangeItem = props.onChangeItem;
  var _useNoteEditor = useNoteEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    paragraphUpdated = _useNoteEditor.paragraphUpdated,
    t = _useNoteEditor.t;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(NoteEditorSidebar, Object.assign({}, sidebarProps, {
        paragraphUpdated: paragraphUpdated,
        t: t,
        mode: mode
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(TeacherNotes, Object.assign({}, contentProps, {
        paragraphUpdated: paragraphUpdated,
        mode: mode
      }));
    }
  }));
};

var StatementASidebar = function StatementASidebar(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    paragraphUpdated = props.paragraphUpdated,
    t = props.t;
  var subItem = item && item.items ? item.items[0] : undefined;
  var paragraph = subItem == null ? void 0 : subItem.paragraph;
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_Text_HeadingParagraph',
    t: t,
    renderContent: function renderContent() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: 'mint__block-text mint__block-text__statementA'
      }, /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Text', {
        ns: 'editor'
      })), getTextHtml(paragraph || '', function (text) {
        return paragraphUpdated && paragraphUpdated(text);
      }, item.id + '_paragraph', IModesTextHtml.MODE_TEXT_HTML_EDITOR));
    }
  }));
};

function useStatementAEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function paragraphUpdated(text) {
    onParagraphUpdated(text, item, onChangeItem);
  }
  return {
    t: t,
    paragraphUpdated: paragraphUpdated
  };
}

var StatemenetAEditor = function StatemenetAEditor(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    mode = props.mode,
    onChangeItem = props.onChangeItem;
  var _useStatementAEditor = useStatementAEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    paragraphUpdated = _useStatementAEditor.paragraphUpdated,
    t = _useStatementAEditor.t;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(StatementASidebar, Object.assign({}, sidebarProps, {
        paragraphUpdated: paragraphUpdated,
        t: t,
        mode: mode
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(StatementA, Object.assign({}, contentProps, {
        item: item,
        getTextHtml: getTextHtml,
        paragraphUpdated: paragraphUpdated,
        mode: mode
      }));
    }
  }));
};

var StatementDSidebar = function StatementDSidebar(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    paragraphUpdated = props.paragraphUpdated,
    t = props.t;
  var subItem = item && item.items ? item.items[0] : undefined;
  var paragraph = subItem == null ? void 0 : subItem.paragraph;
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_Statement_StatementD',
    t: t,
    renderContent: function renderContent() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: 'mint__block-text mint__block-text__statementD'
      }, /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Text', {
        ns: 'editor'
      })), getTextHtml(paragraph || '', function (text) {
        return paragraphUpdated && paragraphUpdated(text);
      }, item.id + '_paragraph', IModesTextHtml.MODE_TEXT_HTML_EDITOR));
    }
  }));
};

function useStatementDEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function paragraphUpdated(text) {
    onParagraphUpdated(text, item, onChangeItem);
  }
  return {
    t: t,
    paragraphUpdated: paragraphUpdated
  };
}

var StatemenetDEditor = function StatemenetDEditor(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    mode = props.mode,
    onChangeItem = props.onChangeItem;
  var _useStatementAEditor = useStatementDEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    paragraphUpdated = _useStatementAEditor.paragraphUpdated,
    t = _useStatementAEditor.t;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(StatementDSidebar, Object.assign({}, sidebarProps, {
        paragraphUpdated: paragraphUpdated,
        t: t
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(StatementD, Object.assign({}, contentProps, {
        item: item,
        getTextHtml: getTextHtml,
        paragraphUpdated: paragraphUpdated,
        mode: mode
      }));
    }
  }));
};

var HeadingEditorSidebar = function HeadingEditorSidebar(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    headingUpdated = props.headingUpdated,
    t = props.t;
  var subItem = item && item.items ? item.items[0] : undefined;
  var heading = subItem == null ? void 0 : subItem.heading;
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_Text_HeadingParagraph',
    renderContent: function renderContent() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: 'text-heading-paragraph'
      }, /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Heading', {
        ns: 'editor'
      })), /*#__PURE__*/React__default.createElement("h2", {
        className: 'brand--first-all'
      }, getTextHtml(heading || '', function (text) {
        return headingUpdated && headingUpdated(text);
      }, item.id, IModesTextHtml.MODE_TEXT_HTML_EDITOR)));
    }
  }));
};

function useHeadingEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function headingUpdated(text) {
    onHeadingUpdated(text, item, onChangeItem);
  }
  return {
    t: t,
    headingUpdated: headingUpdated
  };
}

var HeadingEditor = function HeadingEditor(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    mode = props.mode,
    onChangeItem = props.onChangeItem;
  var _useHeadingEditor = useHeadingEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    headingUpdated = _useHeadingEditor.headingUpdated;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(HeadingEditorSidebar, Object.assign({}, sidebarProps, {
        headingUpdated: headingUpdated
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(Heading, Object.assign({}, contentProps, {
        item: item,
        getTextHtml: getTextHtml,
        headingUpdated: headingUpdated,
        mode: mode
      }));
    }
  }));
};

var HeadingParagraphEditorSidebar = function HeadingParagraphEditorSidebar(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    headingUpdated = props.headingUpdated,
    paragraphUpdated = props.paragraphUpdated,
    t = props.t;
  var subItem = item && item.items ? item.items[0] : undefined;
  var heading = subItem == null ? void 0 : subItem.heading;
  var paragraph = subItem == null ? void 0 : subItem.paragraph;
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_Text_HeadingParagraph',
    renderContent: function renderContent() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: 'text-heading-paragraph'
      }, /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Heading', {
        ns: 'editor'
      })), /*#__PURE__*/React__default.createElement("h2", {
        className: 'brand--first-all'
      }, getTextHtml(heading || '', function (text) {
        return headingUpdated && headingUpdated(text);
      }, item.id, IModesTextHtml.MODE_TEXT_HTML_EDITOR)), /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Paragraph', {
        ns: 'editor'
      })), getTextHtml(paragraph || '', function (text) {
        return paragraphUpdated && paragraphUpdated(text);
      }, item.id + '_paragraph', IModesTextHtml.MODE_TEXT_HTML_EDITOR));
    }
  }));
};

function useHeadingParagraphEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function paragraphUpdated(text) {
    onParagraphUpdated(text, item, onChangeItem);
  }
  function headingUpdated(text) {
    onHeadingUpdated(text, item, onChangeItem);
  }
  return {
    t: t,
    paragraphUpdated: paragraphUpdated,
    headingUpdated: headingUpdated
  };
}

var HeadingParagraphEditor = function HeadingParagraphEditor(props) {
  var item = props.item,
    mode = props.mode,
    onChangeItem = props.onChangeItem;
  var _useHeadingParagraphE = useHeadingParagraphEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    paragraphUpdated = _useHeadingParagraphE.paragraphUpdated,
    headingUpdated = _useHeadingParagraphE.headingUpdated;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(HeadingParagraphEditorSidebar, Object.assign({}, sidebarProps, {
        paragraphUpdated: paragraphUpdated,
        headingUpdated: headingUpdated
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(HeadingParagraph, Object.assign({}, contentProps, {
        paragraphUpdated: paragraphUpdated,
        headingUpdated: headingUpdated,
        mode: mode
      }));
    }
  }));
};

var ParagraphEditorSidebar = function ParagraphEditorSidebar(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    paragraphUpdated = props.paragraphUpdated,
    t = props.t;
  var subItem = item && item.items ? item.items[0] : undefined;
  var paragraph = subItem == null ? void 0 : subItem.paragraph;
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_Text_HeadingParagraph',
    renderContent: function renderContent() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: 'text-heading-paragraph'
      }, /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Paragraph', {
        ns: 'editor'
      })), getTextHtml(paragraph || '', function (text) {
        return paragraphUpdated && paragraphUpdated(text);
      }, item.id + '_paragraph', IModesTextHtml.MODE_TEXT_HTML_EDITOR));
    }
  }));
};

function useParagraphEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function paragraphUpdated(text) {
    onParagraphUpdated(text, item, onChangeItem);
  }
  return {
    t: t,
    paragraphUpdated: paragraphUpdated
  };
}

var ParagraphEditor = function ParagraphEditor(props) {
  var item = props.item,
    mode = props.mode,
    onChangeItem = props.onChangeItem;
  var _useParagraphEditor = useParagraphEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    paragraphUpdated = _useParagraphEditor.paragraphUpdated;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(ParagraphEditorSidebar, Object.assign({}, sidebarProps, {
        paragraphUpdated: paragraphUpdated
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(Paragraph, Object.assign({}, contentProps, {
        paragraphUpdated: paragraphUpdated,
        mode: mode
      }));
    }
  }));
};

var HeadingEditorSidebar$1 = function HeadingEditorSidebar(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    headingUpdated = props.headingUpdated,
    t = props.t;
  var subItem = item && item.items ? item.items[0] : undefined;
  var heading = subItem == null ? void 0 : subItem.heading;
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_Text_HeadingParagraph',
    renderContent: function renderContent() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: 'text-heading-paragraph'
      }, /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Subtitle', {
        ns: 'editor'
      })), /*#__PURE__*/React__default.createElement("h2", {
        className: 'brand--first-all'
      }, getTextHtml(heading || '', function (text) {
        return headingUpdated && headingUpdated(text);
      }, item.id, IModesTextHtml.MODE_TEXT_HTML_EDITOR)));
    }
  }));
};

function useSubheadingEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function headingUpdated(text) {
    onHeadingUpdated(text, item, onChangeItem);
  }
  return {
    t: t,
    headingUpdated: headingUpdated
  };
}

var SubheadingEditor = function SubheadingEditor(props) {
  var item = props.item,
    mode = props.mode,
    onChangeItem = props.onChangeItem;
  var _useSubheadingEditor = useSubheadingEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    headingUpdated = _useSubheadingEditor.headingUpdated,
    t = _useSubheadingEditor.t;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(HeadingEditorSidebar$1, Object.assign({}, sidebarProps, {
        headingUpdated: headingUpdated,
        t: t
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(Subheading, Object.assign({}, contentProps, {
        headingUpdated: headingUpdated,
        mode: mode
      }));
    }
  }));
};

var SubheadingParagraphEditorSidebar = function SubheadingParagraphEditorSidebar(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    paragraphUpdated = props.paragraphUpdated,
    headingUpdated = props.headingUpdated,
    t = props.t;
  var subItem = item && item.items ? item.items[0] : undefined;
  var heading = subItem == null ? void 0 : subItem.heading;
  var paragraph = subItem == null ? void 0 : subItem.paragraph;
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_Text_HeadingParagraph',
    renderContent: function renderContent() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: 'text-heading-paragraph'
      }, /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Subtitle', {
        ns: 'editor'
      })), /*#__PURE__*/React__default.createElement("h2", {
        className: 'brand--first-all'
      }, getTextHtml(heading || '', function (text) {
        return headingUpdated && headingUpdated(text);
      }, item.id, IModesTextHtml.MODE_TEXT_HTML_EDITOR)), /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Paragraph', {
        ns: 'editor'
      })), getTextHtml(paragraph || '', function (text) {
        return paragraphUpdated && paragraphUpdated(text);
      }, item.id + '_paragraph', IModesTextHtml.MODE_TEXT_HTML_EDITOR));
    }
  }));
};

function useSubheadingParagraphEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function paragraphUpdated(text) {
    onParagraphUpdated(text, item, onChangeItem);
  }
  function subheadingUpdated(text) {
    onHeadingUpdated(text, item, onChangeItem);
  }
  return {
    t: t,
    paragraphUpdated: paragraphUpdated,
    subheadingUpdated: subheadingUpdated
  };
}

var SubheadingParagraphEditor = function SubheadingParagraphEditor(props) {
  var item = props.item,
    mode = props.mode,
    onChangeItem = props.onChangeItem;
  var _useSubheadingParagra = useSubheadingParagraphEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    subheadingUpdated = _useSubheadingParagra.subheadingUpdated,
    paragraphUpdated = _useSubheadingParagra.paragraphUpdated;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(SubheadingParagraphEditorSidebar, Object.assign({}, sidebarProps, {
        headingUpdated: subheadingUpdated,
        paragraphUpdated: paragraphUpdated
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(SubheadingParagraph, Object.assign({}, contentProps, {
        headingUpdated: subheadingUpdated,
        paragraphUpdated: paragraphUpdated,
        mode: mode
      }));
    }
  }));
};

var TwoColumnEditorSidebar = function TwoColumnEditorSidebar(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    textColumnUpdated = props.textColumnUpdated,
    t = props.t;
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_Text_HeadingParagraph',
    renderContent: function renderContent(pr1) {
      var _item$items;
      return /*#__PURE__*/React__default.createElement("div", {
        className: 'mint__block-text'
      }, item == null || (_item$items = item.items) == null ? void 0 : _item$items.map(function (item, index) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: 'lesson__block-multicolumn-column',
          key: item.id
        }, item.paragraph && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("p", {
          className: 'label'
        }, t('Column', {
          ns: 'editor'
        }) + ' ' + (index + 1)), getTextHtml(item.paragraph, function (text) {
          return textColumnUpdated && textColumnUpdated(text, index);
        }, item.id, IModesTextHtml.MODE_TEXT_HTML_EDITOR)));
      }));
    }
  }));
};

function useTwoColumnEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function textColumnUpdated(text, index) {
    onTextColumnUpdated(index, text, item, onChangeItem);
  }
  return {
    t: t,
    textColumnUpdated: textColumnUpdated
  };
}

var TwoColumnEditor = function TwoColumnEditor(props) {
  var _useTwoColumnEditor = useTwoColumnEditor({
      item: props.item,
      onChangeItem: props.onChangeItem
    }),
    textColumnUpdated = _useTwoColumnEditor.textColumnUpdated;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(TwoColumnEditorSidebar, Object.assign({}, sidebarProps, {
        textColumnUpdated: textColumnUpdated
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(TwoColumn, Object.assign({}, contentProps, {
        textColumnUpdated: textColumnUpdated
      }));
    }
  }));
};

function useItemBlockEditor(props) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    getSrc = _useGeneral.getSrc,
    lang = _useGeneral.lang;
  function onChangeTooltips(tooltips) {
    props.onChangeItem && props.onChangeItem(_extends({}, props.item, {
      tooltips: tooltips
    }));
  }
  return {
    t: t,
    getSrc: getSrc,
    lang: lang,
    onChangeTooltips: onChangeTooltips
  };
}

var TextAsideEditorSidebar$1 = function TextAsideEditorSidebar(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    getMediaEditor = props.getMediaEditor,
    nameUpdated = props.nameUpdated,
    paragraphUpdated = props.paragraphUpdated,
    onChangeItem = props.onChangeItem,
    avatarUpdated = props.avatarUpdated;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var items = item && item.items ? item.items : [];
  var subItem = item && item.items.length > 0 ? item.items[0] : null;
  var subItemAvatar = getItemAvatar(item);
  var _useState = useState(getNumbersLabelCalculate(items)),
    setNumbersLabel = _useState[1]; // TODO: hacerlo en un hook
  useEffect(function () {
    setNumbersLabel(getNumbersLabelCalculate(items));
  }, [items]);
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_Image_Hero',
    renderContent: function renderContent() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: 'mint__block-text'
      }, /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Quote', {
        ns: 'editor'
      })), getTextHtml((subItem == null ? void 0 : subItem.paragraph) || '', function (text) {
        return paragraphUpdated(text);
      }, item.id + '_paragraph', IModesTextHtml.MODE_TEXT_HTML_EDITOR), /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Name', {
        ns: 'editor'
      })), getTextHtml((subItem == null ? void 0 : subItem.name) || '', function (text) {
        return nameUpdated(text);
      }, item.id + '_name', IModesTextHtml.MODE_TEXT_HTML_EDITOR), /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Avatar', {
        ns: 'editor'
      })), getMediaEditor(item, subItemAvatar, function (subItemImageUpdate) {
        if (isMediaImage(subItemImageUpdate)) avatarUpdated(subItemImageUpdate);
      }, [ITypeMediaFunctionEditor.IMAGE], {
        maxHeightPreview: '100px',
        maxWidthPreview: '100px'
      }), subItemAvatar && /*#__PURE__*/React__default.createElement(ImageAltTextSettingSidebar, {
        item: item,
        onChangeItem: onChangeItem,
        getTextHtml: getTextHtml,
        subItemImage: subItemAvatar
      }));
    }
  }));
};

function useQuoteAEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function nameUpdated(text) {
    onNameUpdated(text, item, onChangeItem);
  }
  function paragraphUpdated(text) {
    onParagraphUpdated(text, item, onChangeItem);
  }
  function avatarUpdated(subItemImageUpdate) {
    onChangeAvatarUpdated(subItemImageUpdate, item, onChangeItem);
  }
  return {
    t: t,
    nameUpdated: nameUpdated,
    avatarUpdated: avatarUpdated,
    paragraphUpdated: paragraphUpdated
  };
}

var QuoteAEditor = function QuoteAEditor(props) {
  var item = props.item,
    getMediaEditor = props.getMediaEditor,
    mode = props.mode,
    onChangeItem = props.onChangeItem,
    getSrc = props.getSrc;
  var _useQuoteAEditor = useQuoteAEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    nameUpdated = _useQuoteAEditor.nameUpdated,
    paragraphUpdated = _useQuoteAEditor.paragraphUpdated,
    avatarUpdated = _useQuoteAEditor.avatarUpdated;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(TextAsideEditorSidebar$1, Object.assign({}, sidebarProps, {
        getMediaEditor: getMediaEditor,
        mode: mode,
        avatarUpdated: avatarUpdated,
        nameUpdated: nameUpdated,
        paragraphUpdated: paragraphUpdated
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(QuoteA, Object.assign({}, contentProps, {
        nameUpdated: nameUpdated,
        paragraphUpdated: paragraphUpdated,
        mode: mode,
        getSrc: getSrc
      }));
    }
  }));
};

var ButtonEditorSidebar = function ButtonEditorSidebar(props) {
  var item = props.item,
    getTextHtml = props.getTextHtml,
    descriptionUpdated = props.descriptionUpdated,
    labelUpdated = props.labelUpdated,
    onChangeDestination = props.onChangeDestination,
    destinationExtrasUpdated = props.destinationExtrasUpdated;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var subItem = item && item.items ? item.items[0] : undefined;
  function onChangeDestinationLocal(valueSelected) {
    onChangeDestination(valueSelected);
  }
  function getDestinationOptions(listLessonsCourseSimply) {
    var destinationOptions = [];
    destinationOptions.push({
      value: '',
      name: '- ' + t('Select') + ' -'
    });
    destinationOptions.push({
      value: 'link',
      name: t('Link to a webpage')
    });
    destinationOptions.push({
      value: 'email',
      name: t('Send an email')
    });
    destinationOptions.push({
      value: 'exit-course',
      name: t('Exit the course')
    });
    /*if (listLessonsCourseSimply) {
      listLessonsCourseSimply.forEach(function (lesson, index) {
        destinationOptions.push({
          value: lesson.id,
          name: t("Lesson") + " " + (index + 1) + ". " + lesson.title
        })
      });
    }*/
    return destinationOptions;
  }
  var valueSelectedDestination = subItem ? subItem.destination : '';
  var destinationExtras = undefined;
  var placeholder = subItem && subItem.type == 'link' ? t('Enter link') : subItem && subItem.type == 'email' ? t('Enter email') : undefined;
  if (subItem && subItem.type == 'link' || subItem && subItem.type == 'email' || subItem && subItem.type == 'exit-course') {
    valueSelectedDestination = subItem ? subItem.type : '';
  }
  if (subItem && subItem.type == 'link' || subItem && subItem.type == 'email') {
    destinationExtras = subItem ? subItem.destination : '';
  }
  var destinationOptions = getDestinationOptions(); //getDestinationOptions(listLessonsCourseSimply)
  return /*#__PURE__*/React__default.createElement(EditorSidebar, Object.assign({}, props, {
    particularNameClassSection: 'ItemBlocks_interactive_button',
    classTabs: 'mint-tab-content-settings-sidebar',
    t: t,
    renderContent: function renderContent() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: 'mint__block-text'
      }, /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Label')), /*#__PURE__*/React__default.createElement(InputText, {
        textInput: subItem && subItem.label ? subItem.label : '',
        onChange: function onChange(text) {
          return labelUpdated(text);
        },
        placeholder: t('Label Button')
      }), /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Destination')), /*#__PURE__*/React__default.createElement(SettingsDropdown, {
        valueSelected: valueSelectedDestination,
        onChange: onChangeDestinationLocal,
        label: ''
      }, destinationOptions), destinationExtras != undefined ? /*#__PURE__*/React__default.createElement(InputText, {
        textInput: destinationExtras ? destinationExtras : '',
        onChange: function onChange(text) {
          return destinationExtrasUpdated(text);
        },
        placeholder: subItem && subItem.type == 'email' ? t('Email Destination') : t('Link Destination')
      }) : '', /*#__PURE__*/React__default.createElement("p", {
        className: 'label'
      }, t('Description')), getTextHtml(subItem && subItem.description ? subItem.description : '', function (text) {
        return descriptionUpdated(text);
      }, item.id + '_description', IModesTextHtml.MODE_TEXT_HTML_EDITOR));
    }
  }));
};

function useButtonEditor(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var BUTTON_TYPE_LINK = 'link';
  var BUTTON_TYPE_LESSON = 'lesson';
  var BUTTON_TYPE_EMAIL = 'email';
  var BUTTON_TYPE_EXIT_COURSE = 'exit-course';
  function captionUpdatedIndex(text, index) {
    onCaptionUpdatedIndex(text, item, index, undefined, onChangeItem);
  }
  function labelUpdated(text) {
    onLabelUpdatedIndex(text, item, 0, onChangeItem);
  }
  function imageUpdatedIndex(subItemImageUpdate, index) {
    onChangeImageUpdatedIndex(subItemImageUpdate, item, index, undefined, onChangeItem);
  }
  function descriptionUpdated(text) {
    onDescriptionUpdatedIndex(text, item, 0, undefined, onChangeItem);
  }
  function titleUpdatedIndex(text, index) {
    onTitleUpdatedIndex(text, item, index, undefined, onChangeItem);
  }
  function alignImageUpdatedIndex(alignImage, index) {
    onAlignImageUpdatedIndex(alignImage, item, index, undefined, onChangeItem);
  }
  function _onDeleteImageIndex(index) {
    onDeleteMediaIndex(item, index, undefined, onChangeItem);
  }
  function sizeImageUpdatedIndex(sizeImage, index) {
    onSizeImageUpdatedIndex(sizeImage, item, index, undefined, onChangeItem);
  }
  function getItemUpdatedDestinationAndTypeIndex(destination, type, index) {
    onItemUpdatedDestinationAndTypeIndex(item, destination, type, index, onChangeItem);
  }
  function buttonOnClick(e, subItem) {
    var type = subItem ? subItem.type : null;
    e.preventDefault();
    if (type) {
      if (type.valueOf() === BUTTON_TYPE_LINK) ; else if (type.valueOf() === BUTTON_TYPE_LESSON) ; else if (type.valueOf() === BUTTON_TYPE_EMAIL) ; else if (type.valueOf() === BUTTON_TYPE_EXIT_COURSE) ;
    }
  }
  function buttonOnChangeDestination(valueSelected) {
    if (!valueSelected || valueSelected.length == 0) {
      // No ha elegido opcion
      getItemUpdatedDestinationAndTypeIndex('', '', 0);
    } else {
      if (valueSelected == 'link' || valueSelected == 'email' || valueSelected == 'exit-course') {
        if (valueSelected == 'exit-course') {
          getItemUpdatedDestinationAndTypeIndex(valueSelected, valueSelected, 0);
        } else getItemUpdatedDestinationAndTypeIndex('', valueSelected, 0);
      } else {
        getItemUpdatedDestinationAndTypeIndex(valueSelected, 'lesson', 0);
      }
    }
  }
  function buttonDestinationExtrasUpdated(text) {
    onItemUpdatedDestinationIndex(item, text, 0, onChangeItem);
  }
  return {
    t: t,
    captionUpdatedIndex: captionUpdatedIndex,
    descriptionUpdated: descriptionUpdated,
    imageUpdatedIndex: imageUpdatedIndex,
    titleUpdatedIndex: titleUpdatedIndex,
    alignImageUpdatedIndex: alignImageUpdatedIndex,
    sizeImageUpdatedIndex: sizeImageUpdatedIndex,
    onDeleteImageIndex: _onDeleteImageIndex,
    BUTTON_TYPE_LINK: BUTTON_TYPE_LINK,
    BUTTON_TYPE_LESSON: BUTTON_TYPE_LESSON,
    BUTTON_TYPE_EMAIL: BUTTON_TYPE_EMAIL,
    BUTTON_TYPE_EXIT_COURSE: BUTTON_TYPE_EXIT_COURSE,
    onClickButton: buttonOnClick,
    labelUpdated: labelUpdated,
    onChangeDestination: buttonOnChangeDestination,
    buttonDestinationExtrasUpdated: buttonDestinationExtrasUpdated
  };
}

var ButtonEditor = function ButtonEditor(props) {
  var item = props.item,
    getMediaEditor = props.getMediaEditor,
    mode = props.mode,
    onChangeItem = props.onChangeItem,
    getSrc = props.getSrc;
  var _useButtonEditor = useButtonEditor({
      item: item,
      onChangeItem: onChangeItem
    }),
    imageUpdatedIndex = _useButtonEditor.imageUpdatedIndex,
    descriptionUpdated = _useButtonEditor.descriptionUpdated,
    titleUpdatedIndex = _useButtonEditor.titleUpdatedIndex,
    captionUpdatedIndex = _useButtonEditor.captionUpdatedIndex,
    alignImageUpdatedIndex = _useButtonEditor.alignImageUpdatedIndex,
    sizeImageUpdatedIndex = _useButtonEditor.sizeImageUpdatedIndex,
    onDeleteImageIndex = _useButtonEditor.onDeleteImageIndex,
    BUTTON_TYPE_LINK = _useButtonEditor.BUTTON_TYPE_LINK,
    BUTTON_TYPE_EMAIL = _useButtonEditor.BUTTON_TYPE_EMAIL,
    onClickButton = _useButtonEditor.onClickButton,
    labelUpdated = _useButtonEditor.labelUpdated,
    onChangeDestination = _useButtonEditor.onChangeDestination,
    buttonDestinationExtrasUpdated = _useButtonEditor.buttonDestinationExtrasUpdated;
  return /*#__PURE__*/React__default.createElement(BaseEditor, Object.assign({}, props, {
    renderSidebar: function renderSidebar(sidebarProps) {
      return /*#__PURE__*/React__default.createElement(ButtonEditorSidebar, Object.assign({}, sidebarProps, {
        getMediaEditor: getMediaEditor,
        mode: mode,
        onDeleteImageIndex: onDeleteImageIndex,
        imageUpdatedIndex: imageUpdatedIndex,
        captionUpdatedIndex: captionUpdatedIndex,
        titleUpdatedIndex: titleUpdatedIndex,
        descriptionUpdated: descriptionUpdated,
        alignImageUpdatedIndex: alignImageUpdatedIndex,
        sizeImageUpdatedIndex: sizeImageUpdatedIndex,
        button_type_link: BUTTON_TYPE_LINK,
        button_type_email: BUTTON_TYPE_EMAIL,
        onClickButton: onClickButton,
        labelUpdated: labelUpdated,
        onChangeDestination: onChangeDestination,
        destinationExtrasUpdated: buttonDestinationExtrasUpdated
      }));
    },
    renderContent: function renderContent(contentProps) {
      return /*#__PURE__*/React__default.createElement(Button$1, Object.assign({}, contentProps, {
        descriptionUpdated: descriptionUpdated,
        getSrc: getSrc
      }));
    }
  }));
};

function ItemBlockEditor(props) {
  var _props$item5, _props$item6, _props$item7;
  var _props$hideSectionIte = props.hideSectionItemBlock,
    hideSectionItemBlock = _props$hideSectionIte === void 0 ? false : _props$hideSectionIte,
    getComponentHead = props.getComponentHead,
    role = props.role,
    closeSidebar = props.closeSidebar;
  var _useItemBlockEditor = useItemBlockEditor(props),
    t = _useItemBlockEditor.t,
    getSrc = _useItemBlockEditor.getSrc,
    lang = _useItemBlockEditor.lang,
    onChangeTooltips = _useItemBlockEditor.onChangeTooltips;
  function getTextHtml(text, onChangeText, keyItem, mode, placeholder, onEnterDown, onBackAndEmpty, /** editor es el editor de froala por eso tiene puesto any */
  onInitialized, isTextUpdatedKeyEnter, onReady, additionalConfig) {
    return /*#__PURE__*/React__default.createElement(TextHtml, {
      text: text,
      placeholder: placeholder,
      mode: mode,
      textUpdated: onChangeText,
      onEnterDown: onEnterDown,
      onBackAndEmpty: onBackAndEmpty,
      onInitialized: onInitialized,
      lang: lang,
      isTextUpdatedKeyEnter: isTextUpdatedKeyEnter,
      typeToolbar: role === roleTypes.EDITORIAL ? ITypeFroalaToolbar.MODE_ADVANCED : ITypeFroalaToolbar.MODE_MEDIUM,
      scrollableContainer: props.mode === IModesItemBlock.MODE_EDITOR_FLOATING_SIDEBAR ? "#" + MINT_ID_BLOCKS_SIDEBAR_CONTENT : undefined,
      tooltips: props.item.tooltips,
      onChangeTooltips: onChangeTooltips,
      additionalConfig: additionalConfig
    });
  }
  function getMediaEditor(item, subItemImage, onChangeImage, types, extras) {
    return /*#__PURE__*/React__default.createElement("p", null, "Traer el de por defecto que sea el picker de mint");
  }
  function getLemonadeEditor(item, subItemLemonade, onChangeLemonade) {
    return /*#__PURE__*/React__default.createElement("p", null, "Poner aqui uno por defecto");
  }
  function getComponent(item) {
    var propsCommons = {
      // === Props comunes a varios Itemblocks
      item: item,
      onChangeItem: props.onChangeItem || function () {},
      onDeleteItem: props.onDeleteItem || function () {},
      getTextHtml: getTextHtml,
      getSrc: getSrc,
      getMediaEditor: props.getMediaEditor ? props.getMediaEditor : getMediaEditor,
      getLemonadeEditor: props.getLemonadeEditor ? props.getLemonadeEditor : getLemonadeEditor,
      mode: props.mode,
      t: t,
      layoutPosition: props.layoutPosition,
      layout: props.layout,
      onChangeLayout: props.onChangeLayout,
      onShowPopupEditorFullscreen: props.onShowPopupEditorFullscreen
    };
    var component;
    if (item.type === 'text' && item.family === 'text' && item.variant === 'heading paragraph') {
      component = /*#__PURE__*/React__default.createElement(HeadingParagraphEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'text' && item.family === 'text' && item.variant === 'heading') {
      component = /*#__PURE__*/React__default.createElement(HeadingEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'text' && item.family === 'text' && item.variant === 'subheading paragraph') {
      component = /*#__PURE__*/React__default.createElement(SubheadingParagraphEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'text' && item.family === 'text' && item.variant === 'subheading') {
      component = /*#__PURE__*/React__default.createElement(SubheadingEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'text' && item.family === 'text' && item.variant === 'paragraph') {
      component = /*#__PURE__*/React__default.createElement(ParagraphEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'text' && item.family === 'text' && item.variant === 'two column') {
      component = /*#__PURE__*/React__default.createElement(TwoColumnEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'list' && item.family === 'list' && item.variant === 'numbered') {
      component = /*#__PURE__*/React__default.createElement(NumeredEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'list' && item.family === 'list' && item.variant === 'bulleted') {
      component = /*#__PURE__*/React__default.createElement(BulletedEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'image' && item.family === 'image' && item.variant === 'hero') {
      component = /*#__PURE__*/React__default.createElement(HeroEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'image' && item.family === 'image' && item.variant === 'text aside') {
      component = /*#__PURE__*/React__default.createElement(TextAsideEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'image' && item.family === 'image' && item.variant === 'text overlay') {
      component = /*#__PURE__*/React__default.createElement(TextOverlayEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'image' && item.family === 'image' && item.variant === 'full') {
      component = /*#__PURE__*/React__default.createElement(HeroEditor$1, Object.assign({}, propsCommons));
    } else if (item.type === 'image' && item.family === 'gallery') {
      if (['two column', 'three column', 'four column'].indexOf(item.variant) > -1) {
        var variant = item.variant === 'four column' ? IVariantsGalleryColumns.fourcol : item.variant === 'three column' ? IVariantsGalleryColumns.threecol : IVariantsGalleryColumns.twocol;
        component = /*#__PURE__*/React__default.createElement(GalleryColumnsEditor, Object.assign({}, propsCommons, {
          variant: variant
        }));
      } else {
        // Carousel
        component = /*#__PURE__*/React__default.createElement(CarouselEditor, Object.assign({}, propsCommons));
      }
    } else if (item.type === 'interactive' && item.family === 'interactive-fullscreen' && item.variant === 'labeledgraphic') {
      component = /*#__PURE__*/React__default.createElement(LabeledGraphicEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'interactive' && item.family === 'interactive-fullscreen' && item.variant === 'process') {
      component = /*#__PURE__*/React__default.createElement(ProcessEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'interactive' && item.family === 'interactive-fullscreen' && item.variant === 'timeline') {
      component = /*#__PURE__*/React__default.createElement(TimelineEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'interactive' && item.family === 'interactive' && item.variant === 'accordion') {
      component = /*#__PURE__*/React__default.createElement(AccordionEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'interactive' && item.family === 'interactive' && item.variant === 'tabs') {
      component = /*#__PURE__*/React__default.createElement(TabsEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'interactive' && item.family === 'buttons' && item.variant === 'button') {
      component = /*#__PURE__*/React__default.createElement(ButtonEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'multimedia' && item.family === 'multimedia' && item.variant === 'video') {
      component = /*#__PURE__*/React__default.createElement(VideoEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'multimedia' && item.family === 'multimedia' && item.variant === 'audio') {
      component = /*#__PURE__*/React__default.createElement(AudioEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'multimedia' && item.family === 'multimedia' && item.variant === 'embed') {
      component = /*#__PURE__*/React__default.createElement(EmbedEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'divider' && item.family === 'divider' && item.variant === 'spacing divider') {
      component = /*#__PURE__*/React__default.createElement(SpacingDividerEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'divider' && item.family === 'divider' && item.variant === 'divider') {
      component = /*#__PURE__*/React__default.createElement(DividerEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'text' && item.family === 'impact' && item.variant === 'note') {
      component = /*#__PURE__*/React__default.createElement(NoteEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'text' && item.family === 'impact' && item.variant === 'teacher notes') {
      component = /*#__PURE__*/React__default.createElement(TeacherNotesEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'text' && item.family === 'impact' && item.variant === 'statementA') {
      component = /*#__PURE__*/React__default.createElement(StatemenetAEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'text' && item.family === 'impact' && item.variant === 'statementD') {
      component = /*#__PURE__*/React__default.createElement(StatemenetDEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'quote' && item.family === 'quote' && item.variant === 'a') {
      component = /*#__PURE__*/React__default.createElement(QuoteAEditor, Object.assign({}, propsCommons));
    } else if (item.type === 'provider' && item.family === 'provider') {
      component = /*#__PURE__*/React__default.createElement(EmbedEditor, Object.assign({}, propsCommons, {
        className: "mint-block-embed--" + item.variant
      }));
    } else if (item.type === 'lemonade' && item.family === 'lemonade') {
      component = /*#__PURE__*/React__default.createElement(LemonadeEditor, Object.assign({}, propsCommons, {
        role: role,
        closeSidebar: closeSidebar
      }));
    } else {
      var _props$item, _props$item2, _props$item3, _props$item4;
      component = /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", null, props == null || (_props$item = props.item) == null ? void 0 : _props$item.id), /*#__PURE__*/React__default.createElement("p", null, props == null || (_props$item2 = props.item) == null ? void 0 : _props$item2.type), /*#__PURE__*/React__default.createElement("p", null, props == null || (_props$item3 = props.item) == null ? void 0 : _props$item3.family), /*#__PURE__*/React__default.createElement("p", null, props == null || (_props$item4 = props.item) == null ? void 0 : _props$item4.variant));
    }
    if (props.mode === IModesItemBlock.MODE_EDITOR_FLOATING_SIDEBAR && role === roleTypes.TEACHER) return /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-block-edit--teacher'
    }, component);
    return component;
  }
  return hideSectionItemBlock ? getComponent(props.item) : /*#__PURE__*/React__default.createElement(ItemBlockPopupWrapper, {
    popup: props.item.popup,
    getTextHtml: getTextHtml
  }, /*#__PURE__*/React__default.createElement(SectionItemBlock, {
    paddingTop: props == null || (_props$item5 = props.item) == null || (_props$item5 = _props$item5.settings) == null ? void 0 : _props$item5.paddingTop,
    paddingBottom: props == null || (_props$item6 = props.item) == null || (_props$item6 = _props$item6.settings) == null ? void 0 : _props$item6.paddingBottom,
    backgroundColor: props == null || (_props$item7 = props.item) == null || (_props$item7 = _props$item7.settings) == null ? void 0 : _props$item7.backgroundColor
  }, getComponentHead && getComponentHead(props.item), getComponent(props.item)));
}

var ItemBlockCustomEditor = function ItemBlockCustomEditor(_ref) {
  var _ref$visible = _ref.visible,
    visible = _ref$visible === void 0 ? false : _ref$visible,
    item = _ref.item,
    role = _ref.role,
    t = _ref.t,
    onChangeItem = _ref.onChangeItem,
    onDeleteItem = _ref.onDeleteItem,
    onClose = _ref.onClose,
    getMediaEditor = _ref.getMediaEditor,
    getLemonadeEditor = _ref.getLemonadeEditor,
    mode = _ref.mode,
    onShowPopupEditorFullscreen = _ref.onShowPopupEditorFullscreen;
  return item ? /*#__PURE__*/React__default.createElement(FloatingFullscreen, {
    title: t(item.variant || item.type || 'NO TITLE', {
      ns: 'editor'
    }),
    visible: visible,
    onClose: onClose,
    container: 'mint-lesson'
  }, /*#__PURE__*/React__default.createElement(ItemBlockEditor, {
    item: item,
    mode: mode,
    onChangeItem: onChangeItem,
    onDeleteItem: onDeleteItem,
    hideSectionItemBlock: true,
    getMediaEditor: getMediaEditor,
    getLemonadeEditor: getLemonadeEditor,
    role: role,
    onShowPopupEditorFullscreen: onShowPopupEditorFullscreen
  })) : /*#__PURE__*/React__default.createElement("div", null);
};

var ItemBlockEditorSidebar = function ItemBlockEditorSidebar(_ref) {
  var visible = _ref.visible,
    t = _ref.t,
    onClose = _ref.onClose,
    item = _ref.item,
    mode = _ref.mode,
    onChangeItem = _ref.onChangeItem,
    onDeleteItem = _ref.onDeleteItem,
    getMediaEditor = _ref.getMediaEditor,
    getLemonadeEditor = _ref.getLemonadeEditor,
    closeSidebar = _ref.closeSidebar,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? roleTypes.STUDENT : _ref$role,
    layoutPosition = _ref.layoutPosition,
    layout = _ref.layout,
    onChangeLayout = _ref.onChangeLayout,
    onShowPopupEditorFullscreen = _ref.onShowPopupEditorFullscreen;
  return item ? /*#__PURE__*/React__default.createElement(FloatingSidebar, {
    title: t(item.family || 'NO TITLE', {
      ns: 'editor'
    }),
    visible: visible,
    onClose: onClose,
    container: 'mint-lesson'
  }, /*#__PURE__*/React__default.createElement(ItemBlockEditor, {
    item: item,
    mode: mode,
    onChangeItem: onChangeItem,
    onDeleteItem: onDeleteItem,
    hideSectionItemBlock: true,
    getMediaEditor: getMediaEditor,
    getLemonadeEditor: getLemonadeEditor,
    closeSidebar: closeSidebar,
    role: role,
    layoutPosition: layoutPosition,
    layout: layout,
    onChangeLayout: onChangeLayout,
    onShowPopupEditorFullscreen: onShowPopupEditorFullscreen
  })) : /*#__PURE__*/React__default.createElement("div", null);
};

var _path$B;
function _extends$Y() { _extends$Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Y.apply(this, arguments); }
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$Y({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$B || (_path$B = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.293 14.707a1 1 0 0 1 0-1.414L10.586 10 7.293 6.707a1 1 0 0 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0z",
    fill: "#BDBDBD"
  })));
};

function OptionIconText(props) {
  var icon = props.icon,
    text = props.text,
    isShowArrow = props.isShowArrow,
    _props$isDisabled = props.isDisabled,
    isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled,
    onClick = props.onClick;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'option-icon-text' + (isDisabled ? ' option-icon-text__disabled' : ''),
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'option-icon-text__icon'
  }, icon), /*#__PURE__*/React__default.createElement("div", {
    className: 'option-icon-text__text'
  }, text), isShowArrow && /*#__PURE__*/React__default.createElement("div", {
    className: 'option-icon-text__arrow'
  }, /*#__PURE__*/React__default.createElement(SvgChevronRight, null)));
}

var img$1 = "data:image/png;base64,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";

var img$2 = "data:image/png;base64,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";

var _path$C, _path2$c;
function _extends$Z() { _extends$Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Z.apply(this, arguments); }
var SvgIbiActivity = function SvgIbiActivity(props) {
  return /*#__PURE__*/createElement("svg", _extends$Z({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$C || (_path$C = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.171 4C9.583 2.835 10.694 2 12 2C13.305 2 14.416 2.835 14.828 4H17.5C18.163 4 18.798 4.263 19.267 4.732C19.736 5.201 20 5.837 20 6.5V19.5C20 20.881 18.88 22 17.5 22C14.808 22 9.191 22 6.5 22C5.119 22 4 20.881 4 19.5C4 16.449 4 9.551 4 6.5C4 5.837 4.263 5.201 4.732 4.732C5.201 4.263 5.837 4 6.5 4H9.171ZM10 6C10.552 6 11 5.552 11 5C11 4.448 11.448 4 12 4C12.551 4 13 4.448 13 5C13 5.552 13.447 6 14 6H17.5C17.632 6 17.759 6.052 17.853 6.146C17.947 6.24 18 6.367 18 6.5V19.5C18 19.776 17.776 20 17.5 20C14.808 20 9.191 20 6.5 20C6.223 20 6 19.776 6 19.5C6 16.449 6 9.551 6 6.5C6 6.367 6.052 6.24 6.146 6.146C6.24 6.052 6.367 6 6.5 6H10Z",
    fill: "#A39B93"
  })), _path2$c || (_path2$c = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7699 13.9517L14.1061 10.7221C14.408 10.426 14.8968 10.426 15.1987 10.7221C15.4998 11.019 15.4998 11.4996 15.1987 11.7964L11.3158 15.5629C11.0147 15.859 10.5259 15.859 10.224 15.5629L8.47643 13.8691C8.17452 13.573 8.17452 13.0916 8.47643 12.7955C8.77756 12.4994 9.26633 12.4994 9.56824 12.7955L10.7699 13.9517Z",
    fill: "#A39B93"
  })));
};

var _path$D;
function _extends$_() { _extends$_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$_.apply(this, arguments); }
var SvgIbiImage = function SvgIbiImage(props) {
  return /*#__PURE__*/createElement("svg", _extends$_({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$D || (_path$D = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5C4 4.44772 4.44772 4 5 4H19C19.5523 4 20 4.44772 20 5V12.5858L16.7071 9.29289C16.3166 8.90237 15.6834 8.90237 15.2929 9.29289L4.64909 19.9367C4.2699 19.7946 4 19.4288 4 19V5ZM5.00098 22H5H5.00098ZM5.00098 22H19C20.6569 22 22 20.6569 22 19V15.001C22 15.0003 22 14.9997 22 14.999V5C22 3.34315 20.6569 2 19 2H5C3.34315 2 2 3.34315 2 5V19C2 20.6565 3.3425 21.9994 4.9988 22M20 15.4142V19C20 19.5523 19.5523 20 19 20H7.41421L16 11.4142L20 15.4142ZM8.5 8C8.22386 8 8 8.22386 8 8.5C8 8.77614 8.22386 9 8.5 9C8.77614 9 9 8.77614 9 8.5C9 8.22386 8.77614 8 8.5 8ZM6 8.5C6 7.11929 7.11929 6 8.5 6C9.88071 6 11 7.11929 11 8.5C11 9.88071 9.88071 11 8.5 11C7.11929 11 6 9.88071 6 8.5Z",
    fill: "#A39B93"
  })));
};

var _path$E;
function _extends$$() { _extends$$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$$.apply(this, arguments); }
var SvgIbiList = function SvgIbiList(props) {
  return /*#__PURE__*/createElement("svg", _extends$$({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$E || (_path$E = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 17.5V17H1V16H4V20H1V19H3V18.5H2V17.5H3ZM3 8H2V5H1V4H3V8ZM2.8 11H1V10H4V10.9L2.2 13H4V14H1V13.1L2.8 11ZM8 5C7.44772 5 7 5.44772 7 6C7 6.55228 7.44772 7 8 7H21C21.5523 7 22 6.55228 22 6C22 5.44772 21.5523 5 21 5H8ZM8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H21C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11H8ZM7 18C7 17.4477 7.44772 17 8 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H8C7.44772 19 7 18.5523 7 18Z",
    fill: "#A39B93"
  })));
};

var _path$F;
function _extends$10() { _extends$10 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$10.apply(this, arguments); }
var SvgIbiText = function SvgIbiText(props) {
  return /*#__PURE__*/createElement("svg", _extends$10({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$F || (_path$F = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4528 2.10143C12.3091 2.03138 12.157 1.99886 12.0073 2.00003C11.8577 1.99886 11.7055 2.03138 11.5619 2.10143C11.3016 2.2284 11.1211 2.45342 11.0432 2.71033L4.10166 16.9426C3.85956 17.4389 4.0657 18.0376 4.56209 18.2797C5.05848 18.5218 5.65715 18.3157 5.89925 17.8193L8.1569 13.1904H15.8577L18.1154 17.8193C18.3575 18.3157 18.9562 18.5218 19.4526 18.2797C19.949 18.0376 20.1551 17.4389 19.913 16.9426L12.9715 2.71032C12.8936 2.45342 12.7131 2.2284 12.4528 2.10143ZM9.13237 11.1904L12.0073 5.2959L14.8823 11.1904H9.13237ZM4 20.0002C3.44772 20.0002 3 20.4479 3 21.0002C3 21.5525 3.44772 22.0002 4 22.0002H20C20.5523 22.0002 21 21.5525 21 21.0002C21 20.4479 20.5523 20.0002 20 20.0002H4Z",
    fill: "#A39B93"
  })));
};

var _path$G, _path2$d;
function _extends$11() { _extends$11 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$11.apply(this, arguments); }
var SvgIbiVideo = function SvgIbiVideo(props) {
  return /*#__PURE__*/createElement("svg", _extends$11({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$G || (_path$G = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z",
    fill: "#A39B93"
  })), _path2$d || (_path2$d = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52814 7.11833C9.8533 6.94431 10.2478 6.96338 10.5547 7.16795L16.5547 11.168C16.8329 11.3534 17 11.6656 17 12C17 12.3344 16.8329 12.6466 16.5547 12.8321L10.5547 16.8321C10.2478 17.0366 9.8533 17.0557 9.52814 16.8817C9.20298 16.7077 9 16.3688 9 16V8C9 7.63121 9.20298 7.29235 9.52814 7.11833ZM11 9.86852V14.1315L14.1972 12L11 9.86852Z",
    fill: "#A39B93"
  })));
};

var _g$m, _defs$3;
function _extends$12() { _extends$12 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$12.apply(this, arguments); }
var SvgIbiUpload = function SvgIbiUpload(props) {
  return /*#__PURE__*/createElement("svg", _extends$12({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$m || (_g$m = /*#__PURE__*/createElement("g", {
    clipPath: "url(#clip0_5159_11788)"
  }, /*#__PURE__*/createElement("path", {
    d: "M18.9322 9.6625C18.3372 6.42917 15.685 4 12.5 4C9.97222 4 7.775 5.5375 6.68222 7.7875C4.04556 8.0875 2 10.4792 2 13.375C2 16.4792 4.35278 19 7.25 19H18.625C21.04 19 23 16.9 23 14.3125C23 11.725 21.2072 9.83333 18.9322 9.6625ZM14.25 12.4375V16.1875H10.75V12.4375H8.125L12.1928 8.07917C12.3678 7.89167 12.64 7.89167 12.815 8.07917L16.875 12.4375H14.25Z",
    fill: "#A39B93"
  }))), _defs$3 || (_defs$3 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "clip0_5159_11788"
  }, /*#__PURE__*/createElement("rect", {
    width: 21,
    height: 15,
    fill: "white",
    transform: "translate(2 4)"
  })))));
};

function OptionsCreateFirstBlock(props) {
  var addItemBlock = props.addItemBlock,
    label = props.label;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-options-create-first-block'
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'mint-options-create-first-block__label'
  }, label), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-options-create-first-block__options'
  }, /*#__PURE__*/React__default.createElement(OptionIconText, {
    text: t('editor:text'),
    icon: /*#__PURE__*/React__default.createElement(SvgIbiText, null),
    onClick: function onClick() {
      return addItemBlock('text', 'text', 'heading paragraph');
    }
  }), /*#__PURE__*/React__default.createElement(OptionIconText, {
    text: t('editor:list'),
    icon: /*#__PURE__*/React__default.createElement(SvgIbiList, null),
    onClick: function onClick() {
      return addItemBlock('list', 'list', 'bulleted');
    }
  }), /*#__PURE__*/React__default.createElement(OptionIconText, {
    text: t('editor:image'),
    icon: /*#__PURE__*/React__default.createElement(SvgIbiImage, null),
    onClick: function onClick() {
      return addItemBlock('image', 'image', 'hero');
    }
  }), /*#__PURE__*/React__default.createElement(OptionIconText, {
    text: t('editor:lemonade'),
    icon: /*#__PURE__*/React__default.createElement(SvgIbiActivity, null),
    onClick: function onClick() {
      return addItemBlock('lemonade', 'lemonade', 'Lemonade content guid');
    }
  }), /*#__PURE__*/React__default.createElement(OptionIconText, {
    text: t('URL video', {
      ns: 'editor'
    }),
    icon: /*#__PURE__*/React__default.createElement(SvgIbiVideo, null),
    onClick: function onClick() {
      return addItemBlock('multimedia', 'multimedia', 'embed');
    }
  }), /*#__PURE__*/React__default.createElement(OptionIconText, {
    text: t('Upload video', {
      ns: 'editor'
    }),
    icon: /*#__PURE__*/React__default.createElement(SvgIbiUpload, null),
    onClick: function onClick() {
      return addItemBlock('multimedia', 'multimedia', 'video');
    }
  }), /*#__PURE__*/React__default.createElement(OptionIconText, {
    text: t('editor:genially'),
    icon: /*#__PURE__*/React__default.createElement("img", {
      src: img$2,
      alt: 'Genially'
    }),
    onClick: function onClick() {
      return addItemBlock('provider', 'provider', 'genially');
    }
  }), /*#__PURE__*/React__default.createElement(OptionIconText, {
    text: t('editor:edpuzzle'),
    icon: /*#__PURE__*/React__default.createElement("img", {
      src: img$1,
      alt: 'Edpuzzle'
    }),
    onClick: function onClick() {
      return addItemBlock('provider', 'provider', 'edpuzzle');
    }
  })));
}

function useFirstBlockWhenNoContent(onAddBlock) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  function onAddItemBlock(type, family, variant) {
    onAddBlock(type, family, variant);
  }
  return {
    t: t,
    onAddItemBlock: onAddItemBlock
  };
}

function FirstBlockWhenNoContent(props) {
  var show = props.show,
    role = props.role,
    label = props.label,
    onAddBlock = props.onAddBlock;
  var _useFirstBlockWhenNoC = useFirstBlockWhenNoContent(onAddBlock),
    onAddItemBlock = _useFirstBlockWhenNoC.onAddItemBlock;
  if (role !== roleTypes.TEACHER || !show) return null;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'first-block-when-no-content'
  }, /*#__PURE__*/React__default.createElement(OptionsCreateFirstBlock, {
    addItemBlock: onAddItemBlock,
    label: label
  }));
}

var _path$H;
function _extends$13() { _extends$13 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$13.apply(this, arguments); }
var SvgIbAccordion = function SvgIbAccordion(props) {
  return /*#__PURE__*/createElement("svg", _extends$13({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path$H || (_path$H = /*#__PURE__*/createElement("path", {
    d: "M21 18H2v2h19v-2zm-2-8v4H4v-4h15m1-2H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm1-4H2v2h19V4z"
  })));
};

var _path$I;
function _extends$14() { _extends$14 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$14.apply(this, arguments); }
var SvgIbAll = function SvgIbAll(props) {
  return /*#__PURE__*/createElement("svg", _extends$14({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16"
  }, props), _path$I || (_path$I = /*#__PURE__*/createElement("path", {
    d: "M12,16v-4h4v4H12z M12,6h4v4h-4V6z M12,0h4v4h-4V0z M6,12h4v4H6V12z M6,6h4v4H6V6z M6,0h4v4H6V0 z M0,12h4v4H0V12z M0,6h4v4H0V6z M0,0h4v4H0V0z"
  })));
};

var _path$J;
function _extends$15() { _extends$15 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$15.apply(this, arguments); }
var SvgIbFlashcards = function SvgIbFlashcards(props) {
  return /*#__PURE__*/createElement("svg", _extends$15({
    width: "15px",
    height: "18px",
    viewBox: "0 0 15 18"
  }, props), _path$J || (_path$J = /*#__PURE__*/createElement("path", {
    d: "M13.4,18H4.7c-0.9,0-1.6-0.7-1.6-1.6V4.9c0-0.9,0.7-1.6,1.6-1.6h8.7C14.3,3.3,15,4,15,4.9v11.5 C15,17.3,14.3,18,13.4,18z M13.4,4.9H4.7v11.5h8.7V4.9z M1.6,13.1H0V1.6C0,0.7,0.7,0,1.6,0h9.5v1.6H1.6V13.1z"
  })));
};

var _style, _path$K;
function _extends$16() { _extends$16 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$16.apply(this, arguments); }
var SvgIbGrafico = function SvgIbGrafico(props) {
  return /*#__PURE__*/createElement("svg", _extends$16({
    x: "0px",
    y: "0px",
    width: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/createElement("style", {
    type: "text/css"
  }, ".st0{fill:none;}")), _path$K || (_path$K = /*#__PURE__*/createElement("path", {
    d: "M19,7h-8v6h8V7z M21,3H3C1.9,3,1,3.9,1,5v14c0,1.1,0.9,2,2,2h18c1.1,0,2-0.9,2-2V5C23,3.9,22.1,3,21,3z M21,19H3V5h18V19z"
  })));
};

var _path$L;
function _extends$17() { _extends$17 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$17.apply(this, arguments); }
var SvgIbImagen = function SvgIbImagen(props) {
  return /*#__PURE__*/createElement("svg", _extends$17({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16"
  }, props), _path$L || (_path$L = /*#__PURE__*/createElement("path", {
    d: "M18,16H2c-1.1,0-2-0.9-2-2V2c0-1.1,0.9-2,2-2h16c1.1,0,2,0.9,2,2v12C20,15.1,19.1,16,18,16z M18,2H2v12h16V2 z M10,9l2-1l4,2.4V12H4V8l2-2L10,9z M14.5,7C13.7,7,13,6.3,13,5.5S13.7,4,14.5,4S16,4.7,16,5.5S15.3,7,14.5,7z"
  })));
};

var _path$M;
function _extends$18() { _extends$18 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$18.apply(this, arguments); }
var SvgIbLista = function SvgIbLista(props) {
  return /*#__PURE__*/createElement("svg", _extends$18({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18"
  }, props), _path$M || (_path$M = /*#__PURE__*/createElement("path", {
    d: "M16,2v14H2V2H16 M17.1,0H0.9C0.4,0,0,0.4,0,0.9v16.2C0,17.5,0.4,18,0.9,18h16.2c0.4,0,0.9-0.5,0.9-0.9V0.9 C18,0.4,17.5,0,17.1,0z M8,4h6v2H8V4z M8,8h6v2H8V8z M8,12h6v2H8V12z M4,4h2v2H4V4z M4,8h2v2H4V8z M4,12h2v2H4V12z"
  })));
};

var _path$N;
function _extends$19() { _extends$19 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$19.apply(this, arguments); }
var SvgIbSlider = function SvgIbSlider(props) {
  return /*#__PURE__*/createElement("svg", _extends$19({
    width: "20px",
    height: "20px",
    viewBox: "0 0 459 459"
  }, props), _path$N || (_path$N = /*#__PURE__*/createElement("path", {
    d: "M178.5,127.5v204l127.5-102L178.5,127.5z M408,0H51C23,0,0,23,0,51v357c0,28,23,51,51,51h357c28,0,51-23,51-51V51 C459,23,436,0,408,0z M408,408H51V51h357V408z"
  })));
};

var _path$O;
function _extends$1a() { _extends$1a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1a.apply(this, arguments); }
var SvgIbTabs = function SvgIbTabs(props) {
  return /*#__PURE__*/createElement("svg", _extends$1a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path$O || (_path$O = /*#__PURE__*/createElement("path", {
    d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h10v4h8v10z"
  })));
};

var _path$P;
function _extends$1b() { _extends$1b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1b.apply(this, arguments); }
var SvgIbTexto = function SvgIbTexto(props) {
  return /*#__PURE__*/createElement("svg", _extends$1b({
    width: "14px",
    height: "15px",
    viewBox: "0 0 14 15"
  }, props), _path$P || (_path$P = /*#__PURE__*/createElement("path", {
    d: "M0,15v-2h14v2H0z M9.5,8.8h-5L3.6,11H1.5L6.3,0h1.5l4.7,11h-2.1L9.5,8.8z M7,2L5.2,7h3.7L7,2z"
  })));
};

// TODO: Poner una interfaz con los tipos
var ItemBlocksShortcuts = function ItemBlocksShortcuts(_ref) {
  var addComponent = _ref.addComponent,
    showComponentsMenu = _ref.showComponentsMenu,
    translate = _ref.translate,
    hasItemBlocks = _ref.hasItemBlocks;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'block-shortcut'
  }, !hasItemBlocks && /*#__PURE__*/React__default.createElement("h5", {
    className: 'block-shortcut__title'
  }, translate('Add your first itemblock', {
    ns: 'editor'
  })), /*#__PURE__*/React__default.createElement("hr", {
    className: 'block-shortcut__divider'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: 'block-shortcut__button-list'
  }, /*#__PURE__*/React__default.createElement(IconTextButton, {
    onClick: showComponentsMenu,
    modifier: ModifiersIconTextButton.PRIMARY_ALL
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__icon'
  }, /*#__PURE__*/React__default.createElement(SvgIbAll, null)), /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__text'
  }, translate('All Blocks', {
    ns: 'editor'
  }))), /*#__PURE__*/React__default.createElement(IconTextButton, {
    onClick: function onClick() {
      return addComponent('text', 'text', 'heading');
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__icon'
  }, /*#__PURE__*/React__default.createElement(SvgIbTexto, null)), /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__text'
  }, translate('editor:Heading'))), /*#__PURE__*/React__default.createElement(IconTextButton, {
    onClick: function onClick() {
      return addComponent('text', 'text', 'paragraph');
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__icon'
  }, /*#__PURE__*/React__default.createElement(SvgIbTexto, null)), /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__text'
  }, translate('editor:Paragraph'))), /*#__PURE__*/React__default.createElement(IconTextButton, {
    onClick: function onClick() {
      return addComponent('image', 'image', 'hero');
    }
  }, ' ', /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__icon'
  }, /*#__PURE__*/React__default.createElement(SvgIbImagen, null)), /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__text'
  }, translate('editor:Image'))), /*#__PURE__*/React__default.createElement(IconTextButton, {
    onClick: function onClick() {
      return addComponent('lemonade', 'lemonade', 'Lemonade content guid');
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__icon'
  }, /*#__PURE__*/React__default.createElement(SvgIbFlashcards, null)), /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__text'
  }, translate('editor:Activity'))), /*#__PURE__*/React__default.createElement(IconTextButton, {
    onClick: function onClick() {
      return addComponent('interactive', 'interactive-fullscreen', 'labeledgraphic');
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__icon'
  }, /*#__PURE__*/React__default.createElement(SvgIbGrafico, null)), /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__text'
  }, translate('editor:Graphic'))), /*#__PURE__*/React__default.createElement(IconTextButton, {
    onClick: function onClick() {
      return addComponent('interactive', 'interactive-fullscreen', 'process');
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__icon'
  }, /*#__PURE__*/React__default.createElement(SvgIbSlider, null)), /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__text'
  }, translate('editor:Slider'))), /*#__PURE__*/React__default.createElement(IconTextButton, {
    onClick: function onClick() {
      return addComponent('list', 'list', 'bulleted');
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__icon'
  }, /*#__PURE__*/React__default.createElement(SvgIbLista, null)), /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__text'
  }, translate('editor:List'))), /*#__PURE__*/React__default.createElement(IconTextButton, {
    onClick: function onClick() {
      return addComponent('interactive', 'interactive', 'accordion');
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__icon'
  }, /*#__PURE__*/React__default.createElement(SvgIbAccordion, null)), /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__text'
  }, translate('editor:Accordion'))), /*#__PURE__*/React__default.createElement(IconTextButton, {
    onClick: function onClick() {
      return addComponent('text', 'impact', 'teacher notes');
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__icon'
  }, /*#__PURE__*/React__default.createElement(SvgIbTabs, null)), /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__text'
  }, translate('Teacher notes', {
    ns: 'editor'
  })))));
};

var PROPERTY_EDIT_TYPE_GROUP = 'editTypeGroup';
var EDIT_TYPE_GROUPS = {
  EDIT_TYPE_GROUP_TEXTS: 'EDIT_TYPE_GROUP_TEXTS',
  /**
    Paragraph
    Paragraph with heading
    Paragraph with subheading
    Heading
    Subheading
    Two column
    Statement A
    Statement B
    Statement C
    Statement D
    Note
  */
  EDIT_TYPE_GROUP_QUOTES: 'EDIT_TYPE_GROUP_QUOTES',
  /**
   Quote A
   Quote B
   Quote C
   Quote D
   Quote on image
   Quote carousel
  */
  EDIT_TYPE_GROUP_LISTS: 'EDIT_TYPE_GROUP_LISTS',
  /**
    Numbered list
    Checkbox list
    Bulleted list
   */
  EDIT_TYPE_GROUP_IMAGES: 'EDIT_TYPE_GROUP_IMAGES',
  /**
    Image centered
    Image full width
    Image & text
    Text on image
    Carousel
    Two column grid
    Three column grid
    Four column grid
   */
  EDIT_TYPE_GROUP_TABS_AND_OTHER: 'EDIT_TYPE_GROUP_TABS_AND_OTHER',
  /**
    Accordion
    Tabs
  */
  EDIT_TYPE_GROUP_BUTTONS: 'EDIT_TYPE_GROUP_BUTTONS',
  /**
    Button
    Button stack
   */
  EDIT_TYPE_GROUP_DIVIDER_AND_OTHER: 'EDIT_TYPE_GROUP_DIVIDER_AND_OTHER'
};
function getListItemBlock(data, translate) {
  var list = [];
  data.types.map(function (itemGroup) {
    return itemGroup.families.map(function (family) {
      return {
        id: family.name,
        blocks: family.variants ? family.variants.map(function (variant) {
          var _ref;
          return list.push(_extends({
            caption: translate(variant.name)
          }, variant.customEditor && {
            customEditor: true
          }, variant[PROPERTY_EDIT_TYPE_GROUP] && (_ref = {}, _ref[PROPERTY_EDIT_TYPE_GROUP] = variant[PROPERTY_EDIT_TYPE_GROUP], _ref), {
            identity: {
              type: itemGroup.name,
              family: variant.familyName ? variant.familyName : family.name,
              variant: variant.key
            }
          }));
        }) : []
      };
    });
  });
  return list;
}
function findItemBlock(listItemBlock, type, family, variant) {
  return listItemBlock.find(function (item) {
    return item && item.identity && item.identity.type === type && item.identity.family === family && item.identity.variant === variant;
  });
}
var getEditTypeList = function getEditTypeList(item, translate) {
  var listItemBlock = getListItemBlock(blockList, translate);
  var itemBlockFind = item ? findItemBlock(listItemBlock, item.type, item.family, item.variant) : null;
  var editTypeList = itemBlockFind && itemBlockFind[PROPERTY_EDIT_TYPE_GROUP] ? listItemBlock.filter(function (item) {
    return item && item[PROPERTY_EDIT_TYPE_GROUP] && item[PROPERTY_EDIT_TYPE_GROUP] === itemBlockFind[PROPERTY_EDIT_TYPE_GROUP];
  }) : [];
  return editTypeList;
};
function getItemBlockChangeType(item, type, family, variant, translate, pathAssets, folderBlockDefault) {
  var listItemBlock = getListItemBlock(blockList, translate);
  var itemBlockFind = item ? findItemBlock(listItemBlock, item.type, item.family, item.variant) : null;
  var itemUpdated = item;
  if (itemUpdated && itemBlockFind) {
    // == Casos genericos
    itemUpdated.caption = itemBlockFind.caption;
    itemUpdated.type = type;
    itemUpdated.family = family;
    itemUpdated.variant = variant;
    // == Casos particulares
    if (type === 'text' && family === 'text' && variant === 'two column' && !(itemUpdated && itemUpdated.items && itemUpdated.items.length >= 2)) {
      // == Voy a convertirlo en un Two column pero no tenemos al menos dos items, por lo que se los creo
      var itemBlockDataDefault = findItemBlock(listItemBlock, type, family, variant);
      if (itemBlockDataDefault) {
        var itemDefault = getJsonDefault(type, family, variant, pathAssets, folderBlockDefault);
        // const itemDefault = getJsonDefault(itemBlockDataDefault);
        if (itemDefault && itemDefault.items && itemDefault.items.length >= 2) {
          if (!itemUpdated.items) itemUpdated.items = [];
          if (itemUpdated.items.length === 0) {
            // == Le creo 2 columnas
            itemUpdated.items.push(itemDefault.items[0]);
            itemUpdated.items.push(itemDefault.items[1]);
          } else if (itemUpdated.items.length === 1) {
            // == Le creo 1 columna al final
            itemUpdated.items.push(itemDefault.items[1]); // == Le pongo la segunda columna por defecto como nueva columna
          }
        }
      }
    }
  }

  return itemUpdated;
}

var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26;
var blockList = {
  types: /*#__PURE__*/[{
    name: 'text',
    families: [{
      name: 'text',
      variants: [(_ref = {
        name: 'Paragraph',
        key: 'paragraph',
        image: 'text_paragraph@2x.png'
      }, _ref[PROPERTY_EDIT_TYPE_GROUP] = EDIT_TYPE_GROUPS.EDIT_TYPE_GROUP_TEXTS, _ref), (_ref2 = {
        name: 'Paragraph with Heading',
        key: 'heading paragraph',
        image: 'text_paragraph_heading@2x.png'
      }, _ref2[PROPERTY_EDIT_TYPE_GROUP] = EDIT_TYPE_GROUPS.EDIT_TYPE_GROUP_TEXTS, _ref2), (_ref3 = {
        name: 'Paragraph with Subheading',
        key: 'subheading paragraph',
        image: 'text_paragraph_subheading@2x.png'
      }, _ref3[PROPERTY_EDIT_TYPE_GROUP] = EDIT_TYPE_GROUPS.EDIT_TYPE_GROUP_TEXTS, _ref3), (_ref4 = {
        name: 'Heading',
        key: 'heading',
        image: 'text_heading@2x.png'
      }, _ref4[PROPERTY_EDIT_TYPE_GROUP] = EDIT_TYPE_GROUPS.EDIT_TYPE_GROUP_TEXTS, _ref4.settings = {
        paddingBottom: 0
      }, _ref4), (_ref5 = {
        name: 'Subheading',
        key: 'subheading',
        image: 'text_subheading@2x.png'
      }, _ref5[PROPERTY_EDIT_TYPE_GROUP] = EDIT_TYPE_GROUPS.EDIT_TYPE_GROUP_TEXTS, _ref5.settings = {
        paddingBottom: 0
      }, _ref5), (_ref6 = {
        name: 'Two column',
        key: 'two column',
        image: 'text_2column@2x.png'
      }, _ref6[PROPERTY_EDIT_TYPE_GROUP] = EDIT_TYPE_GROUPS.EDIT_TYPE_GROUP_TEXTS, _ref6)],
      placeholder: 'textPlaceholder'
    }, {
      name: 'impact',
      variants: [(_ref7 = {
        name: 'Teacher notes',
        key: 'teacher notes',
        image: 'statement_teacher_notes@2x.png'
      }, _ref7[PROPERTY_EDIT_TYPE_GROUP] = EDIT_TYPE_GROUPS.EDIT_TYPE_GROUP_TEXTS, _ref7), (_ref8 = {
        name: 'Note',
        key: 'note',
        image: 'statement_note@2x.png'
      }, _ref8[PROPERTY_EDIT_TYPE_GROUP] = EDIT_TYPE_GROUPS.EDIT_TYPE_GROUP_TEXTS, _ref8), (_ref9 = {
        name: 'Statement A',
        key: 'statementA',
        image: 'statement_A@2x.png'
      }, _ref9[PROPERTY_EDIT_TYPE_GROUP] = EDIT_TYPE_GROUPS.EDIT_TYPE_GROUP_TEXTS, _ref9), (_ref10 = {
        name: 'Statement D',
        key: 'statementD',
        image: 'statement_D@2x.png'
      }, _ref10[PROPERTY_EDIT_TYPE_GROUP] = EDIT_TYPE_GROUPS.EDIT_TYPE_GROUP_TEXTS, _ref10)],
      placeholder: 'impactPlaceholder'
    }]
  }, {
    name: 'quote',
    families: [{
      name: 'quote',
      variants: [(_ref11 = {
        name: 'Quote A',
        key: 'a',
        image: 'quote_A@2x.png'
      }, _ref11[PROPERTY_EDIT_TYPE_GROUP] = EDIT_TYPE_GROUPS.EDIT_TYPE_GROUP_QUOTES, _ref11)],
      placeholder: 'quotePlaceholder'
    }]
  }, {
    name: 'list',
    families: [{
      name: 'list',
      variants: [(_ref12 = {
        name: 'Numbered list',
        key: 'numbered',
        image: 'list_numbered@2x.png'
      }, _ref12[PROPERTY_EDIT_TYPE_GROUP] = EDIT_TYPE_GROUPS.EDIT_TYPE_GROUP_LISTS, _ref12), (_ref13 = {
        name: 'Bulleted list',
        key: 'bulleted',
        image: 'list_bulleted@2x.png'
      }, _ref13[PROPERTY_EDIT_TYPE_GROUP] = EDIT_TYPE_GROUPS.EDIT_TYPE_GROUP_LISTS, _ref13)],
      placeholder: 'listPlaceholder'
    }]
  }, {
    name: 'image',
    families: [{
      name: 'image',
      variants: [(_ref14 = {
        name: 'Image centered',
        key: 'hero',
        image: 'image_centered@2x.png'
      }, _ref14[PROPERTY_EDIT_TYPE_GROUP] = EDIT_TYPE_GROUPS.EDIT_TYPE_GROUP_IMAGES, _ref14), (_ref15 = {
        name: 'Image full width',
        key: 'full',
        image: 'image_full_width@2x.png'
      }, _ref15[PROPERTY_EDIT_TYPE_GROUP] = EDIT_TYPE_GROUPS.EDIT_TYPE_GROUP_IMAGES, _ref15), (_ref16 = {
        name: 'Image & text',
        key: 'text aside',
        image: 'image_image_and_text@2x.png'
      }, _ref16[PROPERTY_EDIT_TYPE_GROUP] = EDIT_TYPE_GROUPS.EDIT_TYPE_GROUP_IMAGES, _ref16), (_ref17 = {
        name: 'Text on image',
        key: 'text overlay',
        image: 'image_text_on_image@2x.png'
      }, _ref17[PROPERTY_EDIT_TYPE_GROUP] = EDIT_TYPE_GROUPS.EDIT_TYPE_GROUP_IMAGES, _ref17)],
      settings: {
        zoomOnClick: true,
        opacity: 0.2,
        opacityColor: '#000000'
      },
      placeholder: 'imagePlaceholder'
    }, {
      name: 'gallery',
      variants: [(_ref18 = {
        name: 'Carousel',
        key: 'centered',
        image: 'gallery_carousel@2x.png'
      }, _ref18[PROPERTY_EDIT_TYPE_GROUP] = EDIT_TYPE_GROUPS.EDIT_TYPE_GROUP_IMAGES, _ref18), (_ref19 = {
        name: 'Two column grid',
        key: 'two column',
        image: 'gallery_two_column_grid@2x.png'
      }, _ref19[PROPERTY_EDIT_TYPE_GROUP] = EDIT_TYPE_GROUPS.EDIT_TYPE_GROUP_IMAGES, _ref19), (_ref20 = {
        name: 'Three column grid',
        key: 'three column',
        image: 'gallery_three_column_grid@2x.png'
      }, _ref20[PROPERTY_EDIT_TYPE_GROUP] = EDIT_TYPE_GROUPS.EDIT_TYPE_GROUP_IMAGES, _ref20), (_ref21 = {
        name: 'Four column grid',
        key: 'four column',
        image: 'gallery_four_column_grid@2x.png'
      }, _ref21[PROPERTY_EDIT_TYPE_GROUP] = EDIT_TYPE_GROUPS.EDIT_TYPE_GROUP_IMAGES, _ref21)],
      settings: {
        zoomOnClick: true
      },
      placeholder: 'galleryPlaceholder'
    }]
  }, {
    name: 'multimedia',
    families: [{
      name: 'multimedia',
      variants: [{
        name: 'Audio',
        key: 'audio',
        image: 'multimedia_audio@2x.png'
      }, {
        name: 'Video',
        key: 'video',
        image: 'multimedia_video@2x.png'
      }, {
        name: 'Embed',
        key: 'embed',
        image: 'multimedia_embed_v2@2x.png'
      }
      /* {
        name: 'Attachment',
        key: 'attachment',
        image: 'multimedia_attachment@2x.png',
      },
      {
        name: 'Code snippet',
        key: 'code',
        image: 'text_code_snippet@2x.png',
      }, */],

      placeholder: 'multimediaPlaceholder'
    }]
  }, {
    name: 'interactive',
    grouped: true,
    families: [{
      name: 'interactive',
      exclusive: true,
      variants: [(_ref22 = {
        name: 'Accordion',
        key: 'accordion',
        image: 'interactive_accordion@2x.png'
      }, _ref22[PROPERTY_EDIT_TYPE_GROUP] = EDIT_TYPE_GROUPS.EDIT_TYPE_GROUP_TABS_AND_OTHER, _ref22), (_ref23 = {
        name: 'Tabs',
        key: 'tabs',
        image: 'interactive_tabs@2x.png'
      }, _ref23[PROPERTY_EDIT_TYPE_GROUP] = EDIT_TYPE_GROUPS.EDIT_TYPE_GROUP_TABS_AND_OTHER, _ref23)],
      settings: {
        zoomOnClick: true
      },
      placeholder: 'interactivePlaceholder'
    }, {
      name: 'interactive-fullscreen',
      exclusive: true,
      variants: [{
        name: 'Labeled Graphic',
        key: 'labeledgraphic',
        image: 'interactive_labeledgraphic@2x.png',
        settings: {
          backgroundColor: '#ffffff'
        },
        customEditor: true,
        showSettingsEditor: true
      }, {
        name: 'Slider',
        key: 'process',
        image: 'interactive_process@2x.png'
      }, {
        name: 'Timeline',
        key: 'timeline',
        image: 'interactive_timeline@2x.png'
      }],
      settings: {
        zoomOnClick: true,
        mediaWidth: '1',
        backgroundColor: '#f5f5f5'
      },
      placeholder: 'fullscreenInteractivePlaceholder',
      mediaPlaceholder: 'interactiveMediaPlaceholder'
    }, {
      name: 'buttons',
      exclusive: true,
      variants: [(_ref24 = {
        name: 'Button',
        key: 'button',
        image: 'interactive_text_button@2x.png'
      }, _ref24[PROPERTY_EDIT_TYPE_GROUP] = EDIT_TYPE_GROUPS.EDIT_TYPE_GROUP_BUTTONS, _ref24)],
      placeholder: 'interactivePlaceholder'
    }]
  }, {
    name: 'divider',
    families: [{
      name: 'divider',
      variants: [(_ref25 = {
        name: 'Divider',
        key: 'divider',
        image: 'divider@2x.png',
        content: false
      }, _ref25[PROPERTY_EDIT_TYPE_GROUP] = EDIT_TYPE_GROUPS.EDIT_TYPE_GROUP_DIVIDER_AND_OTHER, _ref25), (_ref26 = {
        name: 'Spacer',
        key: 'spacing divider',
        image: 'spacer@2x.png',
        content: false
      }, _ref26[PROPERTY_EDIT_TYPE_GROUP] = EDIT_TYPE_GROUPS.EDIT_TYPE_GROUP_DIVIDER_AND_OTHER, _ref26)],
      placeholder: null
    }]
  },  {
    name: 'lemonade',
    hideInsideMenuCreate: true,
    // == Lo oculto porque lo he puesto como una opcion directa que se define en CreateBlockSidebar y que puede tener condicionales ahí, igual he añadido Actividades de Feedback
    families: [{
      name: 'lemonade',
      variants: [{
        name: 'Multiple choice standard',
        key: 'Lemonade content guid',
        customEditor: false,
        image: 'lemonade_multiple_choice_single.png'
      }]
    }, {
      name: 'lemonade',
      variants: [{
        name: 'Multiple choice standard',
        key: 'Lemonade feedback content guid',
        customEditor: false,
        image: 'lemonade_multiple_choice_single.png'
      }]
    }]
  } ,  undefined,
  /* {
    name: 'blockTemplates',
    families: [
      {
        name: 'blockTemplates',
        variants: [],
      },
    ],
  }, */
  {
    name: 'provider',
    hideInsideMenuCreate: true,
    families: [{
      name: 'provider',
      variants: [{
        name: 'Edpuzzle',
        key: 'edpuzzle',
        image: 'interactive_process@2x.png'
      }, {
        name: 'Genially',
        key: 'genially',
        image: 'interactive_process@2x.png'
      }, {
        name: 'Actividades de Feedback',
        key: 'feedback',
        image: 'interactive_process@2x.png'
      }]
    }]
  }, {
    name: 'pending',
    hideInsideMenuCreate: true,
    families: [{
      name: 'pending',
      variants: [{
        name: 'Pending',
        key: 'pending',
        hideControlsEditor: true
      }]
    }]
  }].filter(function (x) {
    return x !== undefined;
  })
};

// TODO: llevar esto a un fichero de config
var URL_BASE = ASSETS_DEFAULT_DOMAIN;
var ASSETS_SRC_URI = URL_BASE + '/mintcontent/assets/'; // Mint path
var BLOCK_THUMBNAILS = ASSETS_SRC_URI + 'blocks'; // Mint Path
var PROPERTY_HIDE_INSIDE_MENU_CREATE = 'hideInsideMenuCreate';

// TODO añadir path al servidor donde están los bloques
var imagePath = function imagePath(path) {
  return BLOCK_THUMBNAILS + "/" + path;
};
function flatten(list) {
  return list.reduce(function (acc, next) {
    return acc.concat(next);
  }, []);
}
function createGetBlockList(data, translate) {
  return flatten(data.types.map(function (itemGroup) {
    return flatten(itemGroup.families.map(function (family) {
      return {
        id: family.name,
        blocks: family.variants ? family.variants.map(function (variant) {
          return _extends({
            caption: translate(variant.name, {
              ns: 'editor'
            }),
            src: imagePath(variant.image)
          }, variant.customEditor && {
            customEditor: true
          }, variant.showSettingsEditor && {
            showSettingsEditor: true
          }, variant.hideControlsEditor && {
            hideControlsEditor: true
          }, {
            identity: {
              type: itemGroup.name,
              family: variant.familyName || family.name,
              variant: variant.key
            }
          });
        }) : []
      };
    }));
  }));
}

// Une las variantes cuando se indica que hay que agrupar en la familia, para el menu lateral
function createGetBlockListExclusive(data, translate) {
  var memo = null;

  // == Oculto aquellos tipos que tiene la propiedad hideInsideMenuCreate a true
  var typesFilter = data.types.filter(function (type) {
    return !(Object.prototype.hasOwnProperty.call(type, PROPERTY_HIDE_INSIDE_MENU_CREATE) && type[PROPERTY_HIDE_INSIDE_MENU_CREATE]);
  });
  memo = flatten(typesFilter.map(function (itemGroup) {
    if (itemGroup.grouped) {
      itemGroup.families = [{
        name: itemGroup.name,
        variants: flatten(itemGroup.families.map(function (family) {
          return family.variants.map(function (variant) {
            return _extends({
              familyName: family.name
            }, variant);
          });
        }))
      }];
    }
    return flatten(itemGroup.families.map(function (family) {
      return {
        id: family.name,
        blocks: family.variants ? family.variants.map(function (variant) {
          return _extends({
            caption: translate(variant.name, {
              ns: 'editor'
            }),
            src: imagePath(variant.image)
          }, variant.customEditor && {
            customEditor: true
          }, variant.showSettingsEditor && {
            showSettingsEditor: true
          }, variant.hideControlsEditor && {
            hideControlsEditor: false
          }, {
            identity: {
              type: itemGroup.name,
              family: variant.familyName ? variant.familyName : family.name,
              // == Cuando agrupamos varios porque tenga el valor itemGroup.grouped le ponemos como nuevo atributo a variant la familyName para luego distinguir de que familia era
              variant: variant.key
            }
          });
        }) : []
      };
    }));
  }));
  return memo;
}
function createFlattenBlockList(blockList) {
  var memo = flatten(blockList.map(function (itemGroup) {
    return itemGroup.blocks;
  }));
  return memo;
}
var getBlockList = function getBlockList(translate) {
  return createGetBlockList(blockList, translate);
};
var getBlockListExclusive = function getBlockListExclusive(translate) {
  return createGetBlockListExclusive(blockList, translate);
};
var getFlattenBlockList = function getFlattenBlockList(translate) {
  return createFlattenBlockList(getBlockList(translate));
};
var findItemBlock$1 = function findItemBlock(type, family, variant, translate) {
  return getFlattenBlockList(translate).find(function (item) {
    return item && item.identity && item.identity.type === type && item.identity.family === family && item.identity.variant === variant;
  });
};
var isCustomEditor = function isCustomEditor(item, translate) {
  var itemBlockFind = item ? findItemBlock$1(item.type, item.family, item.variant, translate) : null;
  return itemBlockFind && itemBlockFind.customEditor || item.variant && item.variant.indexOf('labeledgraphic') !== -1;
};
var isShowSettingsEditor = function isShowSettingsEditor(item, translate) {
  var itemBlockFind = item ? findItemBlock$1(item.type, item.family, item.variant, translate) : null;
  return itemBlockFind && itemBlockFind.showSettingsEditor;
};

function usePostEditor(props) {
  var post = props.post,
    onChangePost = props.onChangePost,
    onScrollItem = props.onScrollItem,
    openCustomEditor = props.openCustomEditor,
    openSidebarEditItem = props.openSidebarEditItem,
    openSidebarCreateItem = props.openSidebarCreateItem,
    closeSidebarCreateItem = props.closeSidebarCreateItem,
    prepareOnChangeItem = props.prepareOnChangeItem,
    prepareAddItem = props.prepareAddItem,
    openSidebarGeneric = props.openSidebarGeneric,
    closeSidebarGeneric = props.closeSidebarGeneric;
  var toastRef = useRef(null);
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    pathAssets = _useGeneral.pathAssets,
    folderBlockDefault = _useGeneral.folderBlockDefault,
    eventsEditor = _useGeneral.eventsEditor,
    styleTypeItemBlockOptions = _useGeneral.styleTypeItemBlockOptions,
    enableRowColumnLayout = _useGeneral.enableRowColumnLayout,
    backgroundVisor = _useGeneral.backgroundVisor,
    showSettingsActivity = _useGeneral.showSettingsActivity;
  // const [itemsLocal, setItemsLocal] = useState<IItemBlock[]>(getItemsProps());
  var _useState = useState({
      itemsLocal: getItemsProps(),
      layoutLocal: getLayoutProps(),
      pendingOnChangePost: false,
      pendingAudiosOnChangePost: false,
      audiosPendingOnChangePost: []
    }),
    state = _useState[0],
    dispatch = _useState[1];
  var _useState2 = useState(undefined),
    showControlsRow = _useState2[0],
    setShowControlsRow = _useState2[1];
  var _useState3 = useState(undefined);
  var stateRef = useRef(state); // == Lo almaceno asi para acceder con metodos asincronos
  stateRef.current = state;
  // Efecto para cambios en items
  useEffect(function () {
    var propsItemsString = JSON.stringify(getItemsProps());
    var itemsStateString = JSON.stringify(state.itemsLocal);
    if (propsItemsString !== itemsStateString) {
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          itemsLocal: getItemsProps(),
          pendingOnChangePost: false,
          pendingAudiosOnChangePost: false
        });
      });
    }
  }, [getItemsProps()]);
  // Efecto para cambios en layout
  useEffect(function () {
    var propsLayoutString = JSON.stringify(getLayoutProps());
    var layoutStateString = JSON.stringify(state.layoutLocal);
    if (propsLayoutString !== layoutStateString) {
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          layoutLocal: getLayoutProps(),
          pendingOnChangePost: false,
          pendingAudiosOnChangePost: false
        });
      });
    }
  }, [getLayoutProps()]);
  useEffect(function () {
    state.pendingOnChangePost && onChangePost && onChangePost(_extends({}, post, {
      items: state.itemsLocal,
      layout: state.layoutLocal
    }, state.pendingAudiosOnChangePost && {
      audios: state.audiosPendingOnChangePost
    }));
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        pendingOnChangePost: false,
        pendingAudiosOnChangePost: false,
        audiosPendingOnChangePost: undefined
      });
    });
  }, [state.pendingOnChangePost]);
  useEffect(function () {
    /*   console.log('Ha cambiado el array de items local');
    let newAudios: IAudioItemBlocks[] | undefined = undefined;
    let pendingAudiosOnChangePost: boolean = false;
    if (post.audios) {
      newAudios = [];
      for (let index = 0; index < post.audios.length; index++) {
        const audio = post.audios[index];
        if (audio.blocks.length > 0) {
          const blockBegin = audio.blocks[0];
          const blockEnd = audio.blocks[audio.blocks.length - 1];
          const indexItemsLocalBegin = state.itemsLocal.findIndex(itemLocal => itemLocal.id === blockBegin);
          const indexItemsLocalEnd = state.itemsLocal.findIndex(itemLocal => itemLocal.id === blockEnd);
          let newBlocks: string[] = [];
          if (indexItemsLocalBegin >= 0 && indexItemsLocalEnd >= 0) {
            newBlocks = getItemsLocalArrayId().slice(indexItemsLocalBegin, indexItemsLocalEnd + 1); // == Le sumo uno porque en slice: "The last index is non-inclusive"
          }
          let hasChangedBlocks = false;
          if (JSON.stringify(audio.blocks) == JSON.stringify(newBlocks)) {
            // == Son los mismos bloques, no ha cambiado nada
          } else {
            // == Cambiado los bloques asociados al audio
            hasChangedBlocks = true;
            pendingAudiosOnChangePost = true;
            if (newBlocks.length === 0) {
              showToastAudioEmptyBlocks();
            }
          }
          if (hasData(audio.src)) {
            // == Si tiene un src asociado, entonces actualizo los bloques
            newAudios.push({
              ...audio,
              blocks: newBlocks,
            });
          } else {
            // == No tiene un src asociado, entonces elimino el audio entero
            if (newBlocks.length === 0) {
              // == No lo añado a los nuevos audios porque no tiene bloques ni src
            } else {
              newAudios.push({
                ...audio,
                blocks: newBlocks,
              });
            }
          }
        } else {
          newAudios.push(audio);
        }
      }
    }
    dispatch(prevState => ({
      ...prevState,
      itemsLocal: newList,
      pendingOnChangePost: true,
      pendingAudiosOnChangePost: resultVerify.pendingAudiosOnChangePost,
      audiosPendingOnChangePost: resultVerify.newAudios,
    }));*/
  }, [JSON.stringify(getItemsLocalArrayId())]);
  function getItemsLocalArrayId() {
    return state.itemsLocal.map(function (itemLocal) {
      return itemLocal.id;
    });
  }
  function onAddItemBlock(type, family, variant) {
    function doAction(subItem) {
      var newItem = getJsonDefault(type, family, variant, pathAssets, folderBlockDefault);
      if ((variant === 'Lemonade content guid' || variant === 'Lemonade feedback content guid') && subItem) {
        newItem = getItemUpdatedSubItemLemonade(newItem, subItem);
      }
      prepareAddItem && prepareAddItem(newItem, post);
      dispatch(function (prevState) {
        var newList = [].concat(prevState.itemsLocal, [newItem]);
        var resultVerify = verifyAudiosPost(newList);
        return _extends({}, prevState, {
          itemsLocal: newList,
          layoutLocal: enableRowColumnLayout ? updateLayoutWithNewItem(prevState.layoutLocal, newList || [], newItem, {}) : undefined,
          pendingOnChangePost: true,
          pendingAudiosOnChangePost: resultVerify.pendingAudiosOnChangePost,
          audiosPendingOnChangePost: resultVerify.newAudios
        });
      });
    }
    if (eventsEditor && eventsEditor.onCreateItemBlock) {
      eventsEditor.onCreateItemBlock({
        type: type,
        family: family,
        variant: variant
      }, doAction);
    } else doAction();
  }
  function getItemsProps() {
    return (post == null ? void 0 : post.items) || [];
  }
  function getLayoutProps() {
    return (post == null ? void 0 : post.layout) || undefined;
  }
  function onChangeItem(itemUpdate) {
    prepareOnChangeItem && prepareOnChangeItem(itemUpdate, post);
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        itemsLocal: prevState.itemsLocal.map(function (item) {
          return item.id === itemUpdate.id ? itemUpdate : item;
        }),
        pendingOnChangePost: true,
        pendingAudiosOnChangePost: false
      });
    });
  }
  function onChangeLayout(layout) {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        layoutLocal: layout,
        pendingOnChangePost: true
      });
    });
  }
  function onUp(item, layoutPosition) {
    var items = state.itemsLocal;
    if (items && items.length > 0) {
      var index = items.findIndex(function (element) {
        return element.id === item.id;
      });
      var element = items[index];
      if (element && index > 0) {
        // == Puedo subir aquellos cuyo elemento no sea el primero
        //  const resultVerify = verifyAudiosPost(item);
        var newList = [].concat(items);
        var movingItem = element;
        prepareOnChangeItem && prepareOnChangeItem(movingItem, post); // == Preparo el item que se va a mover
        newList.splice(index, 1);
        newList.splice(index - 1, 0, movingItem);
        prepareOnChangeItem && prepareOnChangeItem(newList[index], post); // == Preparo el item por el que se ha cambiado
        var resultVerify = verifyAudiosPost(newList);
        dispatch(function (prevState) {
          return _extends({}, prevState, {
            itemsLocal: newList,
            layoutLocal: enableRowColumnLayout ? getLayoutWithItemUp(prevState.layoutLocal, newList || [], item, layoutPosition) : prevState.layoutLocal,
            pendingOnChangePost: true,
            pendingAudiosOnChangePost: resultVerify.pendingAudiosOnChangePost,
            audiosPendingOnChangePost: resultVerify.newAudios
          });
        });
        // hacer scroll hacia el elemento
        setTimeout(function () {
          return onScrollItem && onScrollItem(movingItem.id);
        }, 100);
      }
    }
  }
  function onDown(item, layoutPosition) {
    var items = state.itemsLocal;
    if (items && items.length > 0) {
      var index = items.findIndex(function (element) {
        return element.id === item.id;
      });
      var element = items[index];
      if (element && index <= items.length - 2 && index >= 0) {
        // le resto 2 porque si el array es de 3 solo voy a poder bajar los que sean menores o iguales que 1, que es el penultimo elemento
        //  const resultVerify = verifyAudiosPost(item);
        var newList = [].concat(items);
        var movingItem = element;
        prepareOnChangeItem && prepareOnChangeItem(movingItem, post); // == Preparo el item que se va a mover
        newList.splice(index, 1);
        newList.splice(index + 1, 0, movingItem);
        prepareOnChangeItem && prepareOnChangeItem(newList[index], post); // == Preparo el item por el que se ha cambiado
        var resultVerify = verifyAudiosPost(newList);
        dispatch(function (prevState) {
          return _extends({}, prevState, {
            itemsLocal: newList,
            layoutLocal: enableRowColumnLayout ? getLayoutWithItemDown(prevState.layoutLocal, newList || [], item, layoutPosition) : prevState.layoutLocal,
            pendingOnChangePost: true,
            pendingAudiosOnChangePost: resultVerify.pendingAudiosOnChangePost,
            audiosPendingOnChangePost: resultVerify.newAudios
          });
        });
        // hacer scroll hacia el elemento
        setTimeout(function () {
          return onScrollItem && onScrollItem(movingItem.id);
        }, 100);
      }
    }
  }
  function onDuplicate(item, layoutPosition) {
    function doAction(subItem) {
      var items = state.itemsLocal;
      if (items && items.length > 0) {
        var _idItemCreateAfter = item.id;
        var index = items.findIndex(function (element) {
          return element.id === _idItemCreateAfter;
        });
        var element = items[index];
        if (element && index >= 0) {
          // 1. Duplicar el item
          var newList = [].concat(items);
          var itemInsert = getItemCopy(item);
          if (item.type === 'lemonade' && item.family === 'lemonade' && subItem) itemInsert = getItemUpdatedSubItemLemonade(itemInsert, subItem);
          newList.splice(index + 1, 0, itemInsert);
          // 2. Actualizar el layout solo si existe layoutPosition
          var newLayout = state.layoutLocal;
          if (newLayout && layoutPosition) {
            var rowIndex = newLayout.rows.findIndex(function (row) {
              return row.guid === layoutPosition.rowGuid;
            });
            if (rowIndex !== -1) {
              var row = newLayout.rows[rowIndex];
              var columnIndex = row.columns.findIndex(function (col) {
                return col.guid === layoutPosition.columnGuid;
              });
              if (columnIndex !== -1) {
                // Crear nueva columna con el item duplicado
                var newColumn = createNewColumn(itemInsert.id);
                // Actualizar el layout con la nueva columna
                newLayout = _extends({}, newLayout, {
                  rows: [].concat(newLayout.rows.slice(0, rowIndex), [_extends({}, row, {
                    columns: [].concat(row.columns.slice(0, columnIndex + 1), [newColumn], row.columns.slice(columnIndex + 1))
                  })], newLayout.rows.slice(rowIndex + 1))
                });
              }
            }
          }
          // 3. Preparar onChange para los items que cambiaron de posición
          for (var i = index + 1; i < newList.length; i++) {
            prepareOnChangeItem && prepareOnChangeItem(newList[i], post);
          }
          var resultVerify = verifyAudiosPost(newList);
          dispatch(function (prevState) {
            return _extends({}, prevState, {
              itemsLocal: newList,
              layoutLocal: layoutPosition ? newLayout : prevState.layoutLocal,
              pendingOnChangePost: true,
              pendingAudiosOnChangePost: resultVerify.pendingAudiosOnChangePost,
              audiosPendingOnChangePost: resultVerify.newAudios
            });
          });
          // 4. Hacer scroll hacia el elemento duplicado
          setTimeout(function () {
            return onScrollItem && onScrollItem(itemInsert.id);
          }, 100);
        }
      }
    }
    if (eventsEditor && eventsEditor.onDuplicateItemBlock) {
      eventsEditor.onDuplicateItemBlock(item, doAction);
    } else doAction();
  }
  function showButtonUndo(itemDelete, layoutPosition) {
    var items = state.itemsLocal;
    var paramsCreateItem = null;
    if (layoutPosition) {
      paramsCreateItem = {
        layoutPosition: layoutPosition
      };
    } else {
      // == Primero guardo donde debe de ir el elemento cuando le de a deshacer
      var index = items.findIndex(function (itemState) {
        return itemDelete.id === itemState.id;
      });
      if (index > 0) {
        // == Si es mayor que 0 tiene un elemento previo, miro la id de elemento previo para cuando le de a deshacer crearlo despues de dicho elemento
        var elementAfter = items[index - 1];
        if (elementAfter) {
          paramsCreateItem = {
            idItemCreateAfter: elementAfter.id
          };
        }
      } else {
        // Si el indice 0 el elemento es el primero de la lista, si deshacemos hay que situarlo de nuevo en el top de la lista
        paramsCreateItem = {
          createItemTop: true
        };
      }
    }
    // == Muestro el toast
    var idToast = null;
    if (toastRef && toastRef.current) {
      // @ts-ignore
      toastRef.current.showToastTextButton({
        text: t('Removed block', {
          ns: 'editor'
        }),
        textButton: t('Undo', {
          ns: 'editor'
        }),
        handleAction: function handleAction() {
          // == Cuando pulse en deshacer vuelvo a poner el elemento donde estaba
          addItemBlockByItemParam(itemDelete, paramsCreateItem, true);
          // @ts-ignore
          if (idToast) toastRef.current.removeToast(idToast);
        },
        setToastId: function setToastId(id) {
          idToast = id;
        }
      });
    }
  }
  function onDeleteItem(item, layoutPosition) {
    showButtonUndo(item, layoutPosition);
    dispatch(function (prevState) {
      var indexToDelete = prevState.itemsLocal.findIndex(function (itemState) {
        return item.id === itemState.id;
      });
      var newList = prevState.itemsLocal.filter(function (itemState) {
        return item.id !== itemState.id;
      });
      // Prepare onChange for all items that changed position
      for (var i = indexToDelete; i < newList.length; i++) {
        prepareOnChangeItem && prepareOnChangeItem(newList[i], post);
      }
      // Actualizar el layout si existe layoutPosition
      var newLayout = prevState.layoutLocal;
      if (newLayout && layoutPosition) {
        var rowIndex = newLayout.rows.findIndex(function (row) {
          return row.guid === layoutPosition.rowGuid;
        });
        if (rowIndex !== -1) {
          var row = newLayout.rows[rowIndex];
          // Eliminar la columna del layout
          var newColumns = row.columns.filter(function (col) {
            return col.guid !== layoutPosition.columnGuid;
          });
          // Si la fila se queda sin columnas, la eliminamos
          if (newColumns.length === 0) {
            newLayout = _extends({}, newLayout, {
              rows: newLayout.rows.filter(function (r) {
                return r.guid !== layoutPosition.rowGuid;
              })
            });
          } else {
            // Si aún tiene columnas, actualizamos la fila
            newLayout = _extends({}, newLayout, {
              rows: [].concat(newLayout.rows.slice(0, rowIndex), [_extends({}, row, {
                columns: newColumns
              })], newLayout.rows.slice(rowIndex + 1))
            });
          }
        }
      }
      var resultVerify = verifyAudiosPost(newList);
      return _extends({}, prevState, {
        itemsLocal: newList,
        layoutLocal: newLayout,
        pendingOnChangePost: true,
        pendingAudiosOnChangePost: resultVerify.pendingAudiosOnChangePost,
        audiosPendingOnChangePost: resultVerify.newAudios
      });
    });
  }
  function onDeleteRow(row) {
    showButtonUndoRow(row);
    dispatch(function (prevState) {
      // Obtener los IDs de los items a eliminar
      var itemIdsToDelete = row.columns.map(function (column) {
        return column.itemId;
      });
      // Filtrar los items que no están en la row a eliminar
      var newItemsList = prevState.itemsLocal.filter(function (item) {
        return !itemIdsToDelete.includes(item.id);
      });
      // Preparar los items que cambiaron de posición
      var indexFirstDeleted = Math.min.apply(Math, itemIdsToDelete.map(function (id) {
        return prevState.itemsLocal.findIndex(function (item) {
          return item.id === id;
        });
      }));
      // Prepare onChange para todos los items que cambiaron de posición
      for (var i = indexFirstDeleted; i < newItemsList.length; i++) {
        prepareOnChangeItem && prepareOnChangeItem(newItemsList[i], post);
      }
      // Actualizar el layout eliminando la row
      var newLayout = prevState.layoutLocal ? _extends({}, prevState.layoutLocal, {
        rows: prevState.layoutLocal.rows.filter(function (r) {
          return r.guid !== row.guid;
        })
      }) : undefined;
      var resultVerify = verifyAudiosPost(newItemsList);
      return _extends({}, prevState, {
        itemsLocal: newItemsList,
        layoutLocal: newLayout,
        pendingOnChangePost: true,
        pendingAudiosOnChangePost: resultVerify.pendingAudiosOnChangePost,
        audiosPendingOnChangePost: resultVerify.newAudios
      });
    });
  }
  function onAudioItem(item) {
    console.log('TODO: onAudioItem');
  }
  function verifyAudiosPost(newsItemsLocal) {
    var newAudios = undefined;
    var pendingAudiosOnChangePost = false;
    var actualItemsLocalArrayId = getItemsLocalArrayId();
    var newsItemsLocalArrayId = newsItemsLocal.map(function (itemLocal) {
      return itemLocal.id;
    });
    if (JSON.stringify(actualItemsLocalArrayId) != JSON.stringify(newsItemsLocalArrayId)) {
      if (post.audios) {
        newAudios = [];
        var _loop = function _loop() {
          var audio = post.audios[index];
          if (audio.blocks.length > 0) {
            var blockBegin = audio.blocks[0];
            var blockEnd = audio.blocks[audio.blocks.length - 1];
            var indexNewsItemsLocalBegin = newsItemsLocal.findIndex(function (itemLocal) {
              return itemLocal.id === blockBegin;
            });
            var indexsNewItemsLocalEnd = newsItemsLocal.findIndex(function (itemLocal) {
              return itemLocal.id === blockEnd;
            });
            var newBlocks = [];
            if (indexNewsItemsLocalBegin >= 0 && indexsNewItemsLocalEnd >= 0 && indexNewsItemsLocalBegin <= indexsNewItemsLocalEnd) {
              // == Verifico tambien con  indexNewsItemsLocalBegin <= indexsNewItemsLocalEnd que al mover no hayamos puesto el begin mas grande que el end
              newBlocks = newsItemsLocalArrayId.slice(indexNewsItemsLocalBegin, indexsNewItemsLocalEnd + 1); // == Le sumo uno porque en slice: "The last index is non-inclusive"
            }
            if (JSON.stringify(audio.blocks) == JSON.stringify(newBlocks)) ; else {
              pendingAudiosOnChangePost = true;
              if (newBlocks.length === 0) {
                showToastAudioEmptyBlocks();
              }
            }
            if (hasData(audio.src)) {
              // == Si tiene un src asociado, entonces actualizo los bloques
              newAudios.push(_extends({}, audio, {
                blocks: newBlocks
              }));
            } else {
              // == No tiene un src asociado, entonces elimino el audio entero
              if (newBlocks.length === 0) ; else {
                newAudios.push(_extends({}, audio, {
                  blocks: newBlocks
                }));
              }
            }
          } else {
            newAudios.push(audio);
          }
        };
        for (var index = 0; index < post.audios.length; index++) {
          _loop();
        }
      }
    }
    return {
      newAudios: newAudios,
      pendingAudiosOnChangePost: pendingAudiosOnChangePost
    };
  }
  function showToastAudioEmptyBlocks() {
    // == Muestro el toast
    var idToast = null;
    if (toastRef && toastRef.current) {
      // @ts-ignore
      toastRef.current.showToastInfo({
        text: t('editor:item_delete_audio_empty_blocks'),
        handleOnClose: function handleOnClose() {
          // @ts-ignore
          if (idToast) toastRef.current.removeToast(idToast);
        },
        setToastId: function setToastId(id) {
          idToast = id;
        }
      });
    }
  }
  function updateLayoutWithNewItem(currentLayout, items, newItem, paramsCreateItem) {
    var layoutPosition = paramsCreateItem == null ? void 0 : paramsCreateItem.layoutPosition;
    // Si no hay layout, creamos uno nuevo
    if (!currentLayout) {
      return createNewLayout(items.map(function (item) {
        return createNewRow([createNewColumn(item.id)]);
      }));
    }
    // Si hay layout y tenemos layoutPosition
    if (layoutPosition) {
      var newLayout = _extends({}, currentLayout);
      var rowIndex = newLayout.rows.findIndex(function (row) {
        return row.guid === layoutPosition.rowGuid;
      });
      // Si no encontramos la fila por guid, usamos el índice guardado
      if (rowIndex === -1 && layoutPosition.rowIndex !== undefined) {
        // Crear nueva fila en la posición original usando el guid proporcionado
        var newRow = createNewRow([], layoutPosition.rowGuid);
        // Insertar la fila en su posición original
        var insertRowIndex = Math.min(layoutPosition.rowIndex, newLayout.rows.length);
        newLayout.rows.splice(insertRowIndex, 0, newRow);
        // Actualizar rowIndex para usar esta nueva fila
        rowIndex = insertRowIndex;
      }
      if (rowIndex !== -1) {
        var row = _extends({}, newLayout.rows[rowIndex]);
        // Si es createItemTop, insertamos al principio de la fila
        if (paramsCreateItem != null && paramsCreateItem.createItemTop) {
          var newColumns = [].concat(row.columns);
          newColumns.unshift(createNewColumn(newItem.id));
          row.columns = newColumns;
          newLayout.rows[rowIndex] = row;
          return newLayout;
        }
        // Si no es createItemTop, intentamos restaurar en la posición original
        var columnIndex = row.columns.findIndex(function (col) {
          return col.guid === layoutPosition.columnGuid;
        });
        if (columnIndex !== -1) {
          var _newColumns = [].concat(row.columns);
          _newColumns.splice(columnIndex + 1, 0, createNewColumn(newItem.id));
          row.columns = _newColumns;
          newLayout.rows[rowIndex] = row;
          return newLayout;
        } else {
          // Si no encontramos la columna, intentamos restaurar en la posición original
          var _newColumns2 = [].concat(row.columns);
          var insertIndex = layoutPosition.columnIndex !== undefined ? Math.min(layoutPosition.columnIndex, row.columns.length) : row.columns.length;
          _newColumns2.splice(insertIndex, 0, createNewColumn(newItem.id, layoutPosition.columnGuid));
          row.columns = _newColumns2;
          newLayout.rows[rowIndex] = row;
          return newLayout;
        }
      }
    } else if (paramsCreateItem != null && paramsCreateItem.guidRowCreateAfter) {
      // == Se añade una nueva row a continuación de la row con guid dada por paramsCreateItem.guidRowCreateAfter y apunta esa row en la primera columna al newItem
      var _newLayout = _extends({}, currentLayout);
      var _rowIndex = _newLayout.rows.findIndex(function (row) {
        return row.guid === paramsCreateItem.guidRowCreateAfter;
      });
      if (_rowIndex !== -1) {
        // Crear nueva fila con el nuevo item
        var _newRow = createNewRow([createNewColumn(newItem.id)]);
        // Insertar la nueva fila después de la fila especificada
        _newLayout.rows.splice(_rowIndex + 1, 0, _newRow);
        console.log('newLayout', _newLayout);
        return _newLayout;
      }
    } else if (paramsCreateItem != null && paramsCreateItem.guidRowCreateTop) {
      // == Se añade una nueva row al principio de la lista y apunta esa row en la primera columna al newItem
      var _newLayout2 = _extends({}, currentLayout);
      var _newRow2 = createNewRow([createNewColumn(newItem.id)]);
      _newLayout2.rows.unshift(_newRow2);
      return _newLayout2;
    }
    // Si no hay layoutPosition o no se encontró la posición específica
    return _extends({}, currentLayout, {
      rows: [].concat(currentLayout.rows, [createNewRow([createNewColumn(newItem.id)])])
    });
  }
  /**
   * Añade el item pasado por parametro al final de la lista o despues de un elemento indicado
   * @param {object} item - item de tipo itemblock
   */
  function addItemBlockByItemParam(newItem, paramsCreateItem, ignoreOpenSidebarCreateItem, closeSidebarAfterAddItem // Si es true, cierra la sidebar de crear item
  ) {
    if (ignoreOpenSidebarCreateItem === void 0) {
      ignoreOpenSidebarCreateItem = false;
    }
    if (closeSidebarAfterAddItem === void 0) {
      closeSidebarAfterAddItem = false;
    }
    var idItemCreateAfter = null;
    var createItemTop = false;
    var afterCreateSetNewItem = false;
    if (paramsCreateItem) {
      if (paramsCreateItem.idItemCreateAfter) idItemCreateAfter = paramsCreateItem.idItemCreateAfter;
      if (paramsCreateItem.createItemTop) createItemTop = paramsCreateItem.createItemTop;
      if (paramsCreateItem.afterCreateSetNewItem) afterCreateSetNewItem = paramsCreateItem.afterCreateSetNewItem;
    }
    if (newItem) {
      var items = stateRef.current.itemsLocal;
      // Primero miro la variable createItemTop si es true se crea arriba en otro caso miro idItemCreateAfter para ver donde se crea
      var itemList = null;
      if (createItemTop) {
        itemList = [newItem].concat(items);
      } else {
        // si existe un idItemCreateAfter
        // se añade el nuevo item debajo de este
        // caso contrario se añade al final
        if (idItemCreateAfter) {
          itemList = function (idx) {
            return [].concat(items.slice(0, idx), [newItem], items.slice(idx));
          }(items.findIndex(function (i) {
            return i.id === idItemCreateAfter;
          }) + 1);
        } else {
          itemList = [].concat(items, [newItem]);
        }
      }
      var indexToInsert = itemList.findIndex(function (item) {
        return item.id === newItem.id;
      });
      // Prepare onChange for all items that changed position
      for (var i = indexToInsert; i < itemList.length; i++) {
        prepareOnChangeItem && prepareOnChangeItem(itemList[i], post);
      }
      var resultVerify = verifyAudiosPost(itemList);
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          itemsLocal: itemList,
          layoutLocal: enableRowColumnLayout ? updateLayoutWithNewItem(prevState.layoutLocal, itemList || [], newItem, paramsCreateItem) : prevState.layoutLocal,
          pendingOnChangePost: true,
          pendingAudiosOnChangePost: resultVerify.pendingAudiosOnChangePost,
          audiosPendingOnChangePost: resultVerify.newAudios
        });
      });
      if (closeSidebarAfterAddItem) {
        closeSidebarCreateItem();
      } else {
        if (!ignoreOpenSidebarCreateItem) {
          var _paramsCreateItem = afterCreateSetNewItem && newItem ? {
            idItemCreateAfter: newItem.id,
            afterCreateSetNewItem: true
          } : null;
          // == Actualizo el metodo algunos props de la sidebar abierta
          openSidebarCreateItem(function (type, family, variant) {
            return addItemBlockByItem(type, family, variant, _paramsCreateItem);
          });
        }
      }
      if (newItem.id)
        // hacer scroll hacia el nuevo elemento
        setTimeout(function () {
          return onScrollItem(newItem.id);
        }, 100);
    }
  }
  /**
   * Añade un itemblock al final de la lista o despues de un elemento indicado
   * @param {object} item - item de tipo itemblock
   */
  function addItemBlockByItem(type, family, variant, paramsCreateItem, ignoreOpenSidebarCreateItem, closeSidebarAfterAddItem // Si es true, cierra la sidebar de crear item
  ) {
    if (ignoreOpenSidebarCreateItem === void 0) {
      ignoreOpenSidebarCreateItem = false;
    }
    function doAction(subItem) {
      var itemBlockData = findItemBlock$1(type, family, variant, t);
      if (itemBlockData) {
        var newItem = getJsonDefault(type, family, variant, pathAssets, folderBlockDefault);
        if ((variant === 'Lemonade content guid' || variant === 'Lemonade feedback content guid') && subItem) {
          newItem = getItemUpdatedSubItemLemonade(newItem, subItem);
        }
        prepareAddItem && prepareAddItem(newItem, post);
        addItemBlockByItemParam(newItem, paramsCreateItem, ignoreOpenSidebarCreateItem, closeSidebarAfterAddItem);
      }
    }
    if (eventsEditor && eventsEditor.onCreateItemBlock) {
      eventsEditor.onCreateItemBlock({
        type: type,
        family: family,
        variant: variant
      }, doAction);
    } else doAction();
  }
  function onEditItem(_ref) {
    var item = _ref.item,
      layoutPosition = _ref.layoutPosition,
      layoutGuid = _ref.layoutGuid,
      onChangeLayout = _ref.onChangeLayout;
    if (isCustomEditor(item, t)) {
      openCustomEditor(item, post.guid, onChangeItem, onDeleteItem);
    } else {
      openSidebarEditItem(item, post.guid, onChangeItem, onDeleteItem, undefined, layoutPosition, layoutGuid, onChangeLayout);
    }
  }
  function onAddTop(type, family, variant, layoutPosition, rowCreateTop, closeSidebarAfterAddItem // Si es true, cierra la sidebar de crear item
  ) {
    var paramsCreateItem = {
      createItemTop: true,
      afterCreateSetNewItem: true,
      layoutPosition: layoutPosition,
      guidRowCreateTop: rowCreateTop == null ? void 0 : rowCreateTop.guid
    };
    if (type && family && variant) {
      // ya se indica que tipo de bloque crear
      addItemBlockByItem(type, family, variant, paramsCreateItem, true, closeSidebarAfterAddItem);
    } else {
      openSidebarCreateItem(function (_type, _family, _variant) {
        return addItemBlockByItem(_type, _family, _variant, paramsCreateItem, undefined, closeSidebarAfterAddItem);
      });
    }
  }
  function onAddBottom(itemCreateAfter, type, family, variant, layoutPosition, rowCreateAfter, closeSidebarAfterAddItem // Si es true, cierra la sidebar de crear item
  ) {
    var paramsCreateItem = {
      idItemCreateAfter: itemCreateAfter ? itemCreateAfter.id : undefined,
      afterCreateSetNewItem: true,
      layoutPosition: layoutPosition,
      guidRowCreateAfter: rowCreateAfter == null ? void 0 : rowCreateAfter.guid
    };
    if (type && family && variant) {
      // ya se indica que tipo de bloque crear
      addItemBlockByItem(type, family, variant, paramsCreateItem, true, closeSidebarAfterAddItem);
    } else {
      openSidebarCreateItem(function (_type, _family, _variant) {
        return addItemBlockByItem(_type, _family, _variant, paramsCreateItem, undefined, closeSidebarAfterAddItem);
      });
    }
  }
  function onSettings(_ref2) {
    var item = _ref2.item,
      layoutPosition = _ref2.layoutPosition,
      layoutGuid = _ref2.layoutGuid,
      onChangeLayout = _ref2.onChangeLayout;
    openSidebarEditItem(item, post.guid, onChangeItem, onDeleteItem, true, layoutPosition, layoutGuid, onChangeLayout);
  }
  function onSettingsActivity(_ref3) {
    var item = _ref3.item,
      onChangeItem = _ref3.onChangeItem,
      layoutPosition = _ref3.layoutPosition,
      layoutGuid = _ref3.layoutGuid;
    // Llamar a la función del hook padre para abrir el sidebar de configuración de actividad
    if (props.onSettingsActivity) {
      props.onSettingsActivity({
        item: item,
        onChangeItem: onChangeItem,
        layoutPosition: layoutPosition,
        layoutGuid: layoutGuid
      });
    }
  }
  function onEditTypeCompatible(item) {
    var compatibleBlocks = editTypeList(item, t);
    if (compatibleBlocks) {
      openSidebarGeneric(function (type, family, variant) {
        var identity = {
          type: type,
          family: family,
          variant: variant
        };
        onChangeTypeItemBlock(item, identity, t);
        closeSidebarGeneric();
      }, compatibleBlocks, t('editor:option_item_block_change_type'), true, true, true, true);
    }
  }
  function onShowComponentsMenu() {
    var paramsCreateItem = null;
    openSidebarCreateItem(function (type, family, variant) {
      return addItemBlockByItem(type, family, variant, paramsCreateItem);
    });
  }
  function isVisibleSettingsItemBlock(item, translate) {
    return isShowSettingsEditor(item, translate);
  }
  function isVisibleSettingsActivityItemBlock(item) {
    if (!item || !item.type) {
      return false;
    }
    if (item.type !== 'lemonade') {
      return false;
    }
    var NON_QUESTION_TYPES = ['Lemonade content guid', 'Lemonade feedback content guid', 'Rating', 'Adaptative choice', 'Emotions choise - standard'];
    if (NON_QUESTION_TYPES.includes(item.variant)) {
      return false;
    }
    return showSettingsActivity;
  }
  function editTypeList(item, translate) {
    return getEditTypeList(item, translate);
  }
  function onChangeTypeItemBlock(item, identity, translate) {
    if (identity) {
      var itemUpdated = getItemBlockChangeType(item, identity.type, identity.family, identity.variant, translate, pathAssets, folderBlockDefault);
      if (itemUpdated) {
        onChangeItem(itemUpdated);
      }
    }
  }
  function showButtonUndoRow(rowDelete) {
    var _state$layoutLocal$ro, _state$layoutLocal;
    // Guardamos los items y sus posiciones originales
    var itemsWithPositions = rowDelete.columns.map(function (column) {
      var item = state.itemsLocal.find(function (item) {
        return item.id === column.itemId;
      });
      var index = item ? state.itemsLocal.findIndex(function (i) {
        return i.id === item.id;
      }) : -1;
      return {
        item: item,
        index: index
      };
    }).filter(function (entry) {
      return entry.item !== undefined && entry.index !== -1;
    });
    // Guardar la posición original de la row
    var rowIndex = (_state$layoutLocal$ro = (_state$layoutLocal = state.layoutLocal) == null ? void 0 : _state$layoutLocal.rows.findIndex(function (r) {
      return r.guid === rowDelete.guid;
    })) != null ? _state$layoutLocal$ro : -1;
    var idToast = null;
    if (toastRef && toastRef.current) {
      // @ts-ignore
      toastRef.current.showToastTextButton({
        text: t('Removed row', {
          ns: 'editor'
        }),
        textButton: t('Undo', {
          ns: 'editor'
        }),
        handleAction: function handleAction() {
          dispatch(function (prevState) {
            var newLayout = prevState.layoutLocal ? _extends({}, prevState.layoutLocal, {
              rows: [].concat(prevState.layoutLocal.rows.slice(0, rowIndex), [rowDelete], prevState.layoutLocal.rows.slice(rowIndex))
            }) : undefined;
            // Restaurar items en sus posiciones originales
            var newItems = [].concat(prevState.itemsLocal);
            itemsWithPositions.forEach(function (_ref4) {
              var item = _ref4.item,
                index = _ref4.index;
              newItems.splice(index, 0, item);
            });
            return _extends({}, prevState, {
              itemsLocal: newItems,
              layoutLocal: newLayout,
              pendingOnChangePost: true
            });
          });
          // @ts-ignore
          if (idToast) toastRef.current.removeToast(idToast);
        },
        setToastId: function setToastId(id) {
          idToast = id;
        }
      });
    }
  }
  function onDuplicateRow(row) {
    dispatch(function (prevState) {
      var _prevState$layoutLoca, _prevState$layoutLoca2, _duplicatedItems$;
      // 1. Encontrar el índice del último item de la row actual
      var lastItemIndex = Math.max.apply(Math, row.columns.map(function (column) {
        return prevState.itemsLocal.findIndex(function (item) {
          return item.id === column.itemId;
        });
      }));
      // 2. Duplicar los items con nuevos IDs
      var newItems = [].concat(prevState.itemsLocal);
      var newItemsMap = new Map();
      var duplicatedItems = row.columns.map(function (column) {
        var originalItem = prevState.itemsLocal.find(function (item) {
          return item.id === column.itemId;
        });
        if (!originalItem) return null;
        var newItem = getItemCopy(originalItem);
        newItemsMap.set(originalItem.id, newItem.id);
        return newItem;
      }).filter(function (item) {
        return item !== null;
      });
      // 3. Insertar los items duplicados después del último item de la row original
      newItems.splice.apply(newItems, [lastItemIndex + 1, 0].concat(duplicatedItems));
      // 4. Crear nueva row con nuevo guid
      var newRow = createNewRow(row.columns.map(function (column) {
        return createNewColumn(newItemsMap.get(column.itemId));
      }));
      // 5. Insertar la nueva row después de la original
      var rowIndex = (_prevState$layoutLoca = (_prevState$layoutLoca2 = prevState.layoutLocal) == null ? void 0 : _prevState$layoutLoca2.rows.findIndex(function (r) {
        return r.guid === row.guid;
      })) != null ? _prevState$layoutLoca : -1;
      var newLayout = prevState.layoutLocal ? _extends({}, prevState.layoutLocal, {
        rows: [].concat(prevState.layoutLocal.rows.slice(0, rowIndex + 1), [newRow], prevState.layoutLocal.rows.slice(rowIndex + 1))
      }) : undefined;
      // 6. Preparar onChange para los nuevos items
      duplicatedItems.forEach(function (item, index) {
        prepareOnChangeItem && prepareOnChangeItem(item, post);
      });
      var resultVerify = verifyAudiosPost(newItems);
      // 7. Hacer scroll al primer item duplicado
      if ((_duplicatedItems$ = duplicatedItems[0]) != null && _duplicatedItems$.id) {
        setTimeout(function () {
          return onScrollItem(duplicatedItems[0].id);
        }, 100);
      }
      return _extends({}, prevState, {
        itemsLocal: newItems,
        layoutLocal: newLayout,
        pendingOnChangePost: true,
        pendingAudiosOnChangePost: resultVerify.pendingAudiosOnChangePost,
        audiosPendingOnChangePost: resultVerify.newAudios
      });
    });
  }
  function onUpRow(row) {
    dispatch(function (prevState) {
      var _prevState$layoutLoca3, _prevState$layoutLoca4;
      // 1. Encontrar el índice de la row actual
      var rowIndex = (_prevState$layoutLoca3 = (_prevState$layoutLoca4 = prevState.layoutLocal) == null ? void 0 : _prevState$layoutLoca4.rows.findIndex(function (r) {
        return r.guid === row.guid;
      })) != null ? _prevState$layoutLoca3 : -1;
      // Si es la primera row o no hay layout, no hacemos nada
      if (rowIndex <= 0 || !prevState.layoutLocal) return prevState;
      // 2. Obtener los items de ambas rows
      var currentRowItems = row.columns.map(function (col) {
        return prevState.itemsLocal.find(function (item) {
          return item.id === col.itemId;
        });
      }).filter(function (item) {
        return item !== null;
      });
      var previousRow = prevState.layoutLocal.rows[rowIndex - 1];
      var previousRowItems = previousRow.columns.map(function (col) {
        return prevState.itemsLocal.find(function (item) {
          return item.id === col.itemId;
        });
      }).filter(function (item) {
        return item !== null;
      });
      // 3. Crear nueva lista de items
      var newItems = [].concat(prevState.itemsLocal);
      // Encontrar el índice del primer item de cada row
      var currentFirstIndex = Math.min.apply(Math, currentRowItems.map(function (item) {
        return newItems.findIndex(function (i) {
          return i.id === item.id;
        });
      }));
      // Mover los items de la row actual hacia arriba
      currentRowItems.forEach(function (item) {
        var oldIndex = newItems.findIndex(function (i) {
          return i.id === item.id;
        });
        var newIndex = oldIndex - previousRowItems.length;
        newItems.splice(oldIndex, 1);
        newItems.splice(newIndex, 0, item);
      });
      // 4. Actualizar el layout intercambiando las rows
      var newLayout = _extends({}, prevState.layoutLocal, {
        rows: [].concat(prevState.layoutLocal.rows.slice(0, rowIndex - 1), [row, previousRow], prevState.layoutLocal.rows.slice(rowIndex + 1))
      });
      // 5. Preparar onChange para los items que cambiaron de posición
      [].concat(currentRowItems, previousRowItems).forEach(function (item) {
        prepareOnChangeItem && prepareOnChangeItem(item, post);
      });
      var resultVerify = verifyAudiosPost(newItems);
      return _extends({}, prevState, {
        itemsLocal: newItems,
        layoutLocal: newLayout,
        pendingOnChangePost: true,
        pendingAudiosOnChangePost: resultVerify.pendingAudiosOnChangePost,
        audiosPendingOnChangePost: resultVerify.newAudios
      });
    });
  }
  function onDownRow(row) {
    dispatch(function (prevState) {
      var _prevState$layoutLoca5, _prevState$layoutLoca6;
      // 1. Encontrar el índice de la row actual
      var rowIndex = (_prevState$layoutLoca5 = (_prevState$layoutLoca6 = prevState.layoutLocal) == null ? void 0 : _prevState$layoutLoca6.rows.findIndex(function (r) {
        return r.guid === row.guid;
      })) != null ? _prevState$layoutLoca5 : -1;
      // Si es la última row o no hay layout, no hacemos nada
      if (rowIndex === -1 || !prevState.layoutLocal || rowIndex >= prevState.layoutLocal.rows.length - 1) {
        return prevState;
      }
      // 2. Obtener los items de ambas rows
      var currentRowItems = row.columns.map(function (col) {
        return prevState.itemsLocal.find(function (item) {
          return item.id === col.itemId;
        });
      }).filter(function (item) {
        return item !== null;
      });
      var nextRow = prevState.layoutLocal.rows[rowIndex + 1];
      var nextRowItems = nextRow.columns.map(function (col) {
        return prevState.itemsLocal.find(function (item) {
          return item.id === col.itemId;
        });
      }).filter(function (item) {
        return item !== null;
      });
      // 3. Crear nueva lista de items
      var newItems = [].concat(prevState.itemsLocal);
      // Encontrar el índice del primer item de la row actual
      var currentFirstIndex = Math.min.apply(Math, currentRowItems.map(function (item) {
        return newItems.findIndex(function (i) {
          return i.id === item.id;
        });
      }));
      // Mover los items de la row actual hacia abajo
      currentRowItems.forEach(function (item) {
        var oldIndex = newItems.findIndex(function (i) {
          return i.id === item.id;
        });
        var newIndex = oldIndex + nextRowItems.length;
        newItems.splice(oldIndex, 1);
        newItems.splice(newIndex, 0, item);
      });
      // 4. Actualizar el layout intercambiando las rows
      var newLayout = _extends({}, prevState.layoutLocal, {
        rows: [].concat(prevState.layoutLocal.rows.slice(0, rowIndex), [nextRow, row], prevState.layoutLocal.rows.slice(rowIndex + 2))
      });
      // 5. Preparar onChange para los items que cambiaron de posición
      for (var i = currentFirstIndex; i < newItems.length; i++) {
        prepareOnChangeItem && prepareOnChangeItem(newItems[i], post);
      }
      var resultVerify = verifyAudiosPost(newItems);
      return _extends({}, prevState, {
        itemsLocal: newItems,
        layoutLocal: newLayout,
        pendingOnChangePost: true,
        pendingAudiosOnChangePost: resultVerify.pendingAudiosOnChangePost,
        audiosPendingOnChangePost: resultVerify.newAudios
      });
    });
  }
  function getLayoutWithItemUp(currentLayout, items, item, layoutPosition) {
    // Si no hay layout o no hay layoutPosition, retornamos el layout actual sin cambios
    if (!currentLayout || !layoutPosition) {
      return currentLayout;
    }
    var rowIndex = currentLayout.rows.findIndex(function (row) {
      return row.guid === layoutPosition.rowGuid;
    });
    // Si es la primera fila o no encontramos la fila, retornamos sin cambios
    if (rowIndex <= 0) {
      return currentLayout;
    }
    var currentRow = currentLayout.rows[rowIndex];
    var targetRow = currentLayout.rows[rowIndex - 1];
    // Encontrar el item en la fila actual
    var columnIndex = currentRow.columns.findIndex(function (col) {
      return col.guid === layoutPosition.columnGuid;
    });
    if (columnIndex === -1) {
      return currentLayout;
    }
    // Crear nuevo layout
    var newLayout = _extends({}, currentLayout);
    // Eliminar la columna de la fila actual
    var newCurrentColumns = currentRow.columns.filter(function (col) {
      return col.guid !== layoutPosition.columnGuid;
    });
    // Crear nueva columna en la fila superior
    var newTargetColumns = [].concat(targetRow.columns);
    // Intentar mantener una posición similar en la fila superior
    var targetColumnIndex = Math.min(columnIndex, newTargetColumns.length);
    newTargetColumns.splice(targetColumnIndex, 0, {
      guid: getGuid(),
      itemId: item.id
    });
    // Actualizar filas
    newLayout.rows = [].concat(newLayout.rows.slice(0, rowIndex - 1), [_extends({}, targetRow, {
      columns: newTargetColumns
    }), _extends({}, currentRow, {
      columns: newCurrentColumns
    })], newLayout.rows.slice(rowIndex + 1));
    // Si la fila actual se queda sin columnas, la eliminamos
    if (newCurrentColumns.length === 0) {
      newLayout.rows = newLayout.rows.filter(function (_, idx) {
        return idx !== rowIndex;
      });
    }
    return newLayout;
  }
  function getLayoutWithItemDown(currentLayout, items, item, layoutPosition) {
    // Si no hay layout o no hay layoutPosition, retornamos el layout actual sin cambios
    if (!currentLayout || !layoutPosition) {
      return currentLayout;
    }
    var rowIndex = currentLayout.rows.findIndex(function (row) {
      return row.guid === layoutPosition.rowGuid;
    });
    // Si es la última fila o no encontramos la fila, retornamos sin cambios
    if (rowIndex === -1 || rowIndex >= currentLayout.rows.length - 1) {
      return currentLayout;
    }
    var currentRow = currentLayout.rows[rowIndex];
    var targetRow = currentLayout.rows[rowIndex + 1];
    // Encontrar el item en la fila actual
    var columnIndex = currentRow.columns.findIndex(function (col) {
      return col.guid === layoutPosition.columnGuid;
    });
    if (columnIndex === -1) {
      return currentLayout;
    }
    // Crear nuevo layout
    var newLayout = _extends({}, currentLayout);
    // Eliminar la columna de la fila actual
    var newCurrentColumns = currentRow.columns.filter(function (col) {
      return col.guid !== layoutPosition.columnGuid;
    });
    // Crear nueva columna en la fila inferior
    var newTargetColumns = [].concat(targetRow.columns);
    // Intentar mantener una posición similar en la fila inferior
    var targetColumnIndex = Math.min(columnIndex, newTargetColumns.length);
    newTargetColumns.splice(targetColumnIndex, 0, {
      guid: getGuid(),
      itemId: item.id
    });
    // Actualizar filas
    newLayout.rows = [].concat(newLayout.rows.slice(0, rowIndex), [_extends({}, currentRow, {
      columns: newCurrentColumns
    }), _extends({}, targetRow, {
      columns: newTargetColumns
    })], newLayout.rows.slice(rowIndex + 2));
    // Si la fila actual se queda sin columnas, la eliminamos
    if (newCurrentColumns.length === 0) {
      newLayout.rows = newLayout.rows.filter(function (_, idx) {
        return idx !== rowIndex;
      });
    }
    return newLayout;
  }
  function onLeft(item, layoutPosition) {
    if (!layoutPosition || !state.layoutLocal) return;
    var rowIndex = state.layoutLocal.rows.findIndex(function (row) {
      return row.guid === layoutPosition.rowGuid;
    });
    if (rowIndex === -1) return;
    var row = state.layoutLocal.rows[rowIndex];
    var columnIndex = row.columns.findIndex(function (col) {
      return col.guid === layoutPosition.columnGuid;
    });
    // Si es la primera columna o no encontramos la columna, no hacemos nada
    if (columnIndex <= 0) return;
    dispatch(function (prevState) {
      if (!prevState.layoutLocal) return prevState;
      // Crear nuevo layout
      var newLayout = _extends({}, prevState.layoutLocal);
      var currentRow = _extends({}, newLayout.rows[rowIndex]);
      var newColumns = [].concat(currentRow.columns);
      // Intercambiar columnas
      var temp = newColumns[columnIndex];
      newColumns[columnIndex] = newColumns[columnIndex - 1];
      newColumns[columnIndex - 1] = temp;
      // Actualizar la fila con las columnas reordenadas
      currentRow.columns = newColumns;
      newLayout.rows = [].concat(newLayout.rows.slice(0, rowIndex), [currentRow], newLayout.rows.slice(rowIndex + 1));
      // Preparar onChange para los items que cambiaron de posición
      var items = [].concat(prevState.itemsLocal);
      prepareOnChangeItem && prepareOnChangeItem(items[columnIndex], post);
      prepareOnChangeItem && prepareOnChangeItem(items[columnIndex - 1], post);
      return _extends({}, prevState, {
        layoutLocal: newLayout,
        pendingOnChangePost: true
      });
    });
    // hacer scroll hacia el elemento
    setTimeout(function () {
      return onScrollItem && onScrollItem(item.id);
    }, 100);
  }
  function onRight(item, layoutPosition) {
    if (!layoutPosition || !state.layoutLocal) return;
    var rowIndex = state.layoutLocal.rows.findIndex(function (row) {
      return row.guid === layoutPosition.rowGuid;
    });
    if (rowIndex === -1) return;
    var row = state.layoutLocal.rows[rowIndex];
    var columnIndex = row.columns.findIndex(function (col) {
      return col.guid === layoutPosition.columnGuid;
    });
    // Si es la última columna o no encontramos la columna, no hacemos nada
    if (columnIndex === -1 || columnIndex >= row.columns.length - 1) return;
    dispatch(function (prevState) {
      if (!prevState.layoutLocal) return prevState;
      // Crear nuevo layout
      var newLayout = _extends({}, prevState.layoutLocal);
      var currentRow = _extends({}, newLayout.rows[rowIndex]);
      var newColumns = [].concat(currentRow.columns);
      // Intercambiar columnas
      var temp = newColumns[columnIndex];
      newColumns[columnIndex] = newColumns[columnIndex + 1];
      newColumns[columnIndex + 1] = temp;
      // Actualizar la fila con las columnas reordenadas
      currentRow.columns = newColumns;
      newLayout.rows = [].concat(newLayout.rows.slice(0, rowIndex), [currentRow], newLayout.rows.slice(rowIndex + 1));
      // Preparar onChange para los items que cambiaron de posición
      var items = [].concat(prevState.itemsLocal);
      prepareOnChangeItem && prepareOnChangeItem(items[columnIndex], post);
      prepareOnChangeItem && prepareOnChangeItem(items[columnIndex + 1], post);
      return _extends({}, prevState, {
        layoutLocal: newLayout,
        pendingOnChangePost: true
      });
    });
    // hacer scroll hacia el elemento
    setTimeout(function () {
      return onScrollItem && onScrollItem(item.id);
    }, 100);
  }
  return {
    t: t,
    items: state.itemsLocal,
    layout: state.layoutLocal,
    onAddItemBlock: onAddItemBlock,
    onChangeItem: onChangeItem,
    onEditItem: onEditItem,
    onAddTop: onAddTop,
    onAddBottom: onAddBottom,
    onShowComponentsMenu: onShowComponentsMenu,
    onUp: onUp,
    onSettings: onSettings,
    onSettingsActivity: onSettingsActivity,
    onEditTypeCompatible: onEditTypeCompatible,
    onDown: onDown,
    onLeft: onLeft,
    onRight: onRight,
    onDuplicate: onDuplicate,
    onDeleteRow: onDeleteRow,
    onDeleteItem: onDeleteItem,
    onAudioItem: onAudioItem,
    onChangeTypeItemBlock: onChangeTypeItemBlock,
    editTypeList: editTypeList,
    toastRef: toastRef,
    isVisibleSettingsItemBlock: isVisibleSettingsItemBlock,
    isVisibleSettingsActivityItemBlock: isVisibleSettingsActivityItemBlock,
    styleTypeItemBlockOptions: styleTypeItemBlockOptions,
    onDuplicateRow: onDuplicateRow,
    onUpRow: onUpRow,
    onDownRow: onDownRow,
    showControlsRow: showControlsRow,
    setShowControlsRow: setShowControlsRow,
    backgroundVisor: backgroundVisor,
    onChangeLayout: onChangeLayout
  };
}

function useWrapperItemBlockOptions(props) {
  var onAddTop = props.onAddTop,
    onAddBottom = props.onAddBottom;
  var _useState = useState(false),
    controls = _useState[0],
    showControls = _useState[1];
  var _useState2 = useState(false),
    showButtonPlus = _useState2[0],
    setShowButtonPlus = _useState2[1];
  // tenemos que sincronizar el visible o no del popover con acciones de este componente
  var _useState3 = useState(false),
    isVisibleShortcutTop = _useState3[0],
    setIsVisibleShortcutTop = _useState3[1];
  var _useState4 = useState(false),
    isVisibleShortcutBottom = _useState4[0],
    setIsVisibleShortcutBottom = _useState4[1];
  function onAddItemBlockTop(type, family, variant) {
    setIsVisibleShortcutTop(false);
    onAddTop(type, family, variant);
  }
  function onAddItemBlockBottom(type, family, variant) {
    setIsVisibleShortcutBottom(false);
    onAddBottom(type, family, variant);
  }
  // Manejadores de eventos para MouseEnter, MouseLeave y MouseOver
  var handleMouseEnter = function handleMouseEnter(event) {
    showControls(true);
    setShowButtonPlus(true);
  };
  var handleMouseLeave = function handleMouseLeave(event) {
    showControls(false);
    setShowButtonPlus(false);
    // setIsVisibleShortcutTop(false);
    // setIsVisibleShortcutBottom(false);
  };

  var handleMouseOver = function handleMouseOver(event) {
    showControls(true);
    setShowButtonPlus(true);
  };
  return {
    isVisibleShortcutBottom: isVisibleShortcutBottom,
    setIsVisibleShortcutBottom: setIsVisibleShortcutBottom,
    onAddItemBlockBottom: onAddItemBlockBottom,
    showButtonPlus: showButtonPlus,
    isVisibleShortcutTop: isVisibleShortcutTop,
    setIsVisibleShortcutTop: setIsVisibleShortcutTop,
    onAddItemBlockTop: onAddItemBlockTop,
    controls: controls,
    handleMouseEnter: handleMouseEnter,
    handleMouseLeave: handleMouseLeave,
    handleMouseOver: handleMouseOver
  };
}

var Popover = function Popover(_ref) {
  var elementAction = _ref.elementAction,
    children = _ref.children,
    onVisible = _ref.onVisible,
    _ref$isVisible = _ref.isVisible,
    isVisible = _ref$isVisible === void 0 ? false : _ref$isVisible,
    _ref$showArrow = _ref.showArrow,
    showArrow = _ref$showArrow === void 0 ? false : _ref$showArrow,
    _ref$showCloseButton = _ref.showCloseButton,
    showCloseButton = _ref$showCloseButton === void 0 ? false : _ref$showCloseButton;
  var _useState = useState(null),
    referenceElement = _useState[0],
    setReferenceElement = _useState[1];
  var _useState2 = useState(null),
    popperElement = _useState2[0],
    setPopperElement = _useState2[1];
  var _useState3 = useState(null),
    arrowElement = _useState3[0],
    setArrowElement = _useState3[1];
  var _useState4 = useState(isVisible),
    visible = _useState4[0],
    setVisible = _useState4[1]; // damos soporte (opcional) para que el estado sea controlado por un ente externo
  var refPopover = useRef(null);
  var closePopover = useCallback(function () {
    setVisible(false);
    onVisible && onVisible(!visible);
  }, []);
  var mintLessonEditorEl = document.querySelector('.mint-lesson-editor');
  useOnClickOutside(refPopover, closePopover);
  useEffect(function () {
    setVisible(isVisible);
  }, [isVisible]);
  var _usePopper = usePopper(referenceElement, popperElement, {
      placement: 'bottom',
      modifiers: [{
        name: 'arrow',
        options: {
          element: arrowElement
        }
      }, {
        name: 'offset',
        options: {
          offset: [0, 7]
        }
      }]
    }),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes;
  function onClickAction() {
    if (!visible) {
      setVisible(!visible);
      onVisible && onVisible(!visible);
    }
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: 'popover-action',
    ref: setReferenceElement,
    onClick: onClickAction
  }, elementAction || /*#__PURE__*/React__default.createElement("button", {
    type: 'button'
  }, "Show popover")), visible && mintLessonEditorEl && /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React__default.createElement("div", Object.assign({
    className: 'popover-container',
    ref: setPopperElement,
    style: styles.popper
  }, attributes.popper), showCloseButton && /*#__PURE__*/React__default.createElement("button", {
    className: 'popover__close',
    onClick: closePopover
  }, /*#__PURE__*/React__default.createElement(SvgClose, null)), /*#__PURE__*/React__default.createElement("div", {
    className: 'popover-inner',
    ref: refPopover
  }, children), /*#__PURE__*/React__default.createElement("div", {
    ref: setArrowElement,
    style: _extends({}, styles.arrow, {
      top: 0
    }),
    className: showArrow ? 'popover-arrow' : ''
  })), mintLessonEditorEl));
};

function OptionsItemBlockButton(props) {
  var children = props.children,
    _props$isActive = props.isActive,
    isActive = _props$isActive === void 0 ? false : _props$isActive;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-options-item-block-button' + (isActive ? ' mint-options-item-block-button--active' : '')
  }, children);
}

var _path$Q;
function _extends$1c() { _extends$1c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1c.apply(this, arguments); }
var SvgSolidPlus = function SvgSolidPlus(props) {
  return /*#__PURE__*/createElement("svg", _extends$1c({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$Q || (_path$Q = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2.102a.7.7 0 0 1 .7.7v3.5h3.5a.7.7 0 1 1 0 1.4H7.7v3.5a.7.7 0 1 1-1.4 0v-3.5H2.8a.7.7 0 1 1 0-1.4h3.5v-3.5a.7.7 0 0 1 .7-.7z",
    fill: "#fff"
  })));
};

function useOptionsItemBlock(props) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var initialRef = null;
  var refDropdown = useRef(initialRef);
  var _useState = useState({
      isOpenMenu: false
    }),
    state = _useState[0];
  function onClickMenu() {}
  function closeMenu() {
    try {
      if (refDropdown && refDropdown.current) refDropdown.current.toggle();
    } catch (error) {}
  }
  return {
    t: t,
    onClickMenu: onClickMenu,
    isOpenMenu: state.isOpenMenu,
    refDropdown: refDropdown,
    closeMenu: closeMenu
  };
}

var _path$R;
function _extends$1d() { _extends$1d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1d.apply(this, arguments); }
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/createElement("svg", _extends$1d({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$R || (_path$R = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2C4.55228 2 5 2.44772 5 3V5.10125C6.27009 3.80489 8.04052 3 10 3C13.0494 3 15.641 4.94932 16.6014 7.66675C16.7855 8.18747 16.5126 8.75879 15.9918 8.94284C15.4711 9.12689 14.8998 8.85396 14.7157 8.33325C14.0289 6.38991 12.1755 5 10 5C8.36507 5 6.91204 5.78502 5.99935 7H9C9.55228 7 10 7.44772 10 8C10 8.55228 9.55228 9 9 9H4C3.44772 9 3 8.55228 3 8V3C3 2.44772 3.44772 2 4 2ZM4.00817 11.0572C4.52888 10.8731 5.1002 11.146 5.28425 11.6668C5.97112 13.6101 7.82453 15 10 15C11.6349 15 13.088 14.215 14.0006 13L11 13C10.4477 13 10 12.5523 10 12C10 11.4477 10.4477 11 11 11H16C16.2652 11 16.5196 11.1054 16.7071 11.2929C16.8946 11.4804 17 11.7348 17 12V17C17 17.5523 16.5523 18 16 18C15.4477 18 15 17.5523 15 17V14.8987C13.7299 16.1951 11.9595 17 10 17C6.95059 17 4.35905 15.0507 3.39857 12.3332C3.21452 11.8125 3.48745 11.2412 4.00817 11.0572Z",
    fill: "#828282"
  })));
};

var _path$S, _path2$e, _path3$5, _path4$3;
function _extends$1e() { _extends$1e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1e.apply(this, arguments); }
var SvgSortAscending = function SvgSortAscending(props) {
  return /*#__PURE__*/createElement("svg", _extends$1e({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$S || (_path$S = /*#__PURE__*/createElement("path", {
    d: "M3 3C2.44772 3 2 3.44772 2 4C2 4.55228 2.44772 5 3 5H14C14.5523 5 15 4.55228 15 4C15 3.44772 14.5523 3 14 3H3Z",
    fill: "#828282"
  })), _path2$e || (_path2$e = /*#__PURE__*/createElement("path", {
    d: "M3 7C2.44772 7 2 7.44772 2 8C2 8.55228 2.44772 9 3 9H8C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7H3Z",
    fill: "#828282"
  })), _path3$5 || (_path3$5 = /*#__PURE__*/createElement("path", {
    d: "M3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H7C7.55228 13 8 12.5523 8 12C8 11.4477 7.55228 11 7 11H3Z",
    fill: "#828282"
  })), _path4$3 || (_path4$3 = /*#__PURE__*/createElement("path", {
    d: "M13 16C13 16.5523 13.4477 17 14 17C14.5523 17 15 16.5523 15 16L15 10.4142L16.2929 11.7071C16.6834 12.0976 17.3166 12.0976 17.7071 11.7071C18.0976 11.3166 18.0976 10.6834 17.7071 10.2929L14.7071 7.29289C14.5196 7.10536 14.2652 7 14 7C13.7348 7 13.4804 7.10536 13.2929 7.29289L10.2929 10.2929C9.90237 10.6834 9.90237 11.3166 10.2929 11.7071C10.6834 12.0976 11.3166 12.0976 11.7071 11.7071L13 10.4142L13 16Z",
    fill: "#828282"
  })));
};

var _path$T, _path2$f, _path3$6, _path4$4;
function _extends$1f() { _extends$1f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1f.apply(this, arguments); }
var SvgSortDescending = function SvgSortDescending(props) {
  return /*#__PURE__*/createElement("svg", _extends$1f({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$T || (_path$T = /*#__PURE__*/createElement("path", {
    d: "M3 3C2.44772 3 2 3.44772 2 4C2 4.55228 2.44772 5 3 5H14C14.5523 5 15 4.55228 15 4C15 3.44772 14.5523 3 14 3H3Z",
    fill: "#828282"
  })), _path2$f || (_path2$f = /*#__PURE__*/createElement("path", {
    d: "M3 7C2.44772 7 2 7.44772 2 8C2 8.55228 2.44772 9 3 9H10C10.5523 9 11 8.55228 11 8C11 7.44772 10.5523 7 10 7H3Z",
    fill: "#828282"
  })), _path3$6 || (_path3$6 = /*#__PURE__*/createElement("path", {
    d: "M3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H7C7.55228 13 8 12.5523 8 12C8 11.4477 7.55228 11 7 11H3Z",
    fill: "#828282"
  })), _path4$4 || (_path4$4 = /*#__PURE__*/createElement("path", {
    d: "M15 8C15 7.44772 14.5523 7 14 7C13.4477 7 13 7.44771 13 8L13 13.5858L11.7071 12.2929C11.3166 11.9024 10.6834 11.9024 10.2929 12.2929C9.90237 12.6834 9.90237 13.3166 10.2929 13.7071L13.2929 16.7071C13.4804 16.8946 13.7348 17 14 17C14.2652 17 14.5196 16.8946 14.7071 16.7071L17.7071 13.7071C18.0976 13.3166 18.0976 12.6834 17.7071 12.2929C17.3166 11.9024 16.6834 11.9024 16.2929 12.2929L15 13.5858L15 8Z",
    fill: "#828282"
  })));
};

var _path$U, _path2$g;
function _extends$1g() { _extends$1g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1g.apply(this, arguments); }
var SvgDocumentDuplicate = function SvgDocumentDuplicate(props) {
  return /*#__PURE__*/createElement("svg", _extends$1g({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$U || (_path$U = /*#__PURE__*/createElement("path", {
    d: "M9 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V6.414A2 2 0 0 0 16.414 5L14 2.586A2 2 0 0 0 12.586 2H9z",
    fill: "#828282"
  })), _path2$g || (_path2$g = /*#__PURE__*/createElement("path", {
    d: "M3 8a2 2 0 0 1 2-2v10h8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8z",
    fill: "#828282"
  })));
};

var _path$V;
function _extends$1h() { _extends$1h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1h.apply(this, arguments); }
var SvgTrashV2 = function SvgTrashV2(props) {
  return /*#__PURE__*/createElement("svg", _extends$1h({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$V || (_path$V = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2a1 1 0 0 0-.894.553L7.382 4H4a1 1 0 0 0 0 2v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6a1 1 0 1 0 0-2h-3.382l-.724-1.447A1 1 0 0 0 11 2H9zM7 8a1 1 0 0 1 2 0v6a1 1 0 1 1-2 0V8zm5-1a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0V8a1 1 0 0 0-1-1z",
    fill: "#828282"
  })));
};

var _path$W;
function _extends$1i() { _extends$1i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1i.apply(this, arguments); }
var SvgCog = function SvgCog(props) {
  return /*#__PURE__*/createElement("svg", _extends$1i({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$W || (_path$W = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 0 1-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 0 1 .947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 0 1 2.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 0 1 2.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 0 1 .947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 0 1-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 0 1-2.287-.947zM10 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
    fill: "#828282"
  })));
};

function OptionsItemBlock(props) {
  var onSettings = props.onSettings,
    onEdit = props.onEdit,
    onUp = props.onUp,
    onDown = props.onDown,
    onDuplicate = props.onDuplicate,
    onDelete = props.onDelete,
    _props$upEnable = props.upEnable,
    upEnable = _props$upEnable === void 0 ? true : _props$upEnable,
    _props$downEnable = props.downEnable,
    downEnable = _props$downEnable === void 0 ? true : _props$downEnable,
    _props$isSecondary = props.isSecondary,
    isSecondary = _props$isSecondary === void 0 ? false : _props$isSecondary,
    selectedType = props.selectedType,
    onChangeType = props.onChangeType,
    types = props.types;
  var _useOptionsItemBlock = useOptionsItemBlock(),
    t = _useOptionsItemBlock.t,
    isOpenMenu = _useOptionsItemBlock.isOpenMenu,
    refDropdown = _useOptionsItemBlock.refDropdown,
    closeMenu = _useOptionsItemBlock.closeMenu;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-options-item-block' + (isSecondary ? ' mint-options-item-block--secondary' : '')
  }, /*#__PURE__*/React__default.createElement(Dropdown, {
    position: 'right',
    title: /*#__PURE__*/React__default.createElement(OptionsItemBlockButton, {
      isActive: isOpenMenu
    }, /*#__PURE__*/React__default.createElement(SvgDragHandler, null)),
    buttonVariant: 'tertiary',
    wrapperClassName: 'mint-dropdown__wrapper',
    menuClassName: 'mint-dropdown__menu',
    buttonClassName: 'mint-dropdown__button',
    ref: refDropdown
  }, onSettings && /*#__PURE__*/React__default.createElement(Dropdown.Item, {
    onClick: function onClick(e) {
      closeMenu();
      onSettings();
    },
    key: 'option_item_block_settings'
  }, /*#__PURE__*/React__default.createElement(OptionIconText, {
    text: t('editor:option_item_block_settings'),
    icon: /*#__PURE__*/React__default.createElement(SvgCog, null)
  })), types && types.length > 0 && /*#__PURE__*/React__default.createElement(Dropdown.Item, {
    key: 'option_item_block_change_type'
  }, /*#__PURE__*/React__default.createElement(OptionIconText, {
    text: t('editor:option_item_block_change_type'),
    icon: /*#__PURE__*/React__default.createElement(SvgRefresh, null),
    isShowArrow: true
  }), /*#__PURE__*/React__default.createElement(Dropdown.Submenu, {
    position: 'right'
  }, types.map(function (item) {
    return /*#__PURE__*/React__default.createElement(Dropdown.Item, {
      key: item.caption,
      onClick: function onClick() {
        closeMenu();
        onChangeType && onChangeType(item.identity);
      },
      isActive: selectedType && item && item.identity && selectedType.type === item.identity.type && selectedType.family === item.identity.family && selectedType.variant === item.identity.variant
    }, t(item.caption, {
      ns: 'editor'
    }));
  }))), onEdit && /*#__PURE__*/React__default.createElement(Dropdown.Item, {
    onClick: function onClick(e) {
      closeMenu();
      onEdit();
    },
    key: 'option_item_block_edit'
  }, /*#__PURE__*/React__default.createElement(OptionIconText, {
    text: t('editor:option_item_block_edit'),
    icon: /*#__PURE__*/React__default.createElement(SvgPencil, null)
  })), onUp && /*#__PURE__*/React__default.createElement(Dropdown.Item, {
    onClick: function onClick(e) {
      closeMenu();
      onUp();
    },
    key: 'option_item_block_move_up',
    className: !upEnable ? 'mint-dropdown__item--disabled' : ''
  }, /*#__PURE__*/React__default.createElement(OptionIconText, {
    text: t('editor:option_item_block_move_up'),
    icon: /*#__PURE__*/React__default.createElement(SvgSortAscending, null),
    isDisabled: !upEnable
  })), onDown && /*#__PURE__*/React__default.createElement(Dropdown.Item, {
    onClick: function onClick(e) {
      closeMenu();
      onDown();
    },
    key: 'option_item_block_move_down',
    className: !downEnable ? 'mint-dropdown__item--disabled' : ''
  }, /*#__PURE__*/React__default.createElement(OptionIconText, {
    text: t('editor:option_item_block_move_down'),
    icon: /*#__PURE__*/React__default.createElement(SvgSortDescending, null),
    isDisabled: !downEnable
  })), onDuplicate && /*#__PURE__*/React__default.createElement(Dropdown.Item, {
    onClick: function onClick(e) {
      closeMenu();
      onDuplicate();
    },
    key: 'option_item_block_duplicate'
  }, /*#__PURE__*/React__default.createElement(OptionIconText, {
    text: t('editor:option_item_block_duplicate'),
    icon: /*#__PURE__*/React__default.createElement(SvgDocumentDuplicate, null)
  })), onDelete && /*#__PURE__*/React__default.createElement(Dropdown.Item, {
    onClick: function onClick(e) {
      closeMenu();
      onDelete();
    },
    key: 'option_item_block_delete'
  }, /*#__PURE__*/React__default.createElement(OptionIconText, {
    text: t('editor:option_item_block_delete'),
    icon: /*#__PURE__*/React__default.createElement(SvgTrashV2, null)
  }))));
}

function WrapperItemBlockOptionsInline(props) {
  var item = props.item,
    children = props.children,
    onUp = props.onUp,
    onDown = props.onDown,
    onDuplicate = props.onDuplicate,
    onDelete = props.onDelete,
    onEdit = props.onEdit,
    onAudio = props.onAudio,
    onSettings = props.onSettings,
    onAddBottom = props.onAddBottom,
    _props$firstElement = props.firstElement,
    firstElement = _props$firstElement === void 0 ? false : _props$firstElement,
    _props$lastElement = props.lastElement,
    lastElement = _props$lastElement === void 0 ? false : _props$lastElement,
    editTypeList = props.editTypeList,
    _onChangeType = props.onChangeType,
    t = props.t,
    _props$shortcutInline = props.shortcutInline,
    shortcutInline = _props$shortcutInline === void 0 ? false : _props$shortcutInline;
  var _useWrapperItemBlockO = useWrapperItemBlockOptions(props),
    isVisibleShortcutBottom = _useWrapperItemBlockO.isVisibleShortcutBottom,
    setIsVisibleShortcutBottom = _useWrapperItemBlockO.setIsVisibleShortcutBottom,
    onAddItemBlockBottom = _useWrapperItemBlockO.onAddItemBlockBottom,
    controls = _useWrapperItemBlockO.controls,
    handleMouseLeave = _useWrapperItemBlockO.handleMouseLeave,
    handleMouseEnter = _useWrapperItemBlockO.handleMouseEnter,
    handleMouseOver = _useWrapperItemBlockO.handleMouseOver;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'item-block-editor',
    onMouseLeave: handleMouseLeave,
    onMouseEnter: handleMouseEnter,
    onMouseOver: handleMouseOver
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "item-block-editor__controls-wrapper " + (controls ? 'item-block-editor__controls-wrapper--show' : '')
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'item-block-editor__left-controls'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'item-block-editor__options-item'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'item-block-editor__plus'
  }, shortcutInline ? /*#__PURE__*/React__default.createElement(Popover, {
    elementAction: /*#__PURE__*/React__default.createElement(OptionsItemBlockButton, null, /*#__PURE__*/React__default.createElement(SvgSolidPlus, null)),
    isVisible: isVisibleShortcutBottom,
    onVisible: setIsVisibleShortcutBottom,
    showCloseButton: true
  }, /*#__PURE__*/React__default.createElement(OptionsCreateFirstBlock, {
    addItemBlock: onAddItemBlockBottom,
    label: t('Add an item block', {
      ns: 'editor'
    })
  })) : /*#__PURE__*/React__default.createElement(OptionsItemBlockButton, null, /*#__PURE__*/React__default.createElement(SvgSolidPlus, {
    onClick: function onClick() {
      return onAddBottom();
    }
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: 'item-block-editor__options'
  }, /*#__PURE__*/React__default.createElement(OptionsItemBlock, {
    onSettings: onSettings,
    onEdit: onEdit,
    onUp: onUp,
    onDown: onDown,
    onDuplicate: onDuplicate,
    onDelete: onDelete,
    onAudio: onAudio,
    upEnable: !firstElement,
    downEnable: !lastElement,
    isSecondary: true,
    selectedType: {
      type: item.type,
      family: item.family,
      variant: item.variant
    },
    onChangeType: function onChangeType(value) {
      _onChangeType && _onChangeType(value);
    },
    types: editTypeList
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: 'item-block-editor__right-controls'
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'item-block-editor__children'
  }, children, controls && /*#__PURE__*/React__default.createElement("div", {
    className: 'item-block-editor__overlay'
  })));
}

var _path$X, _path2$h;
function _extends$1j() { _extends$1j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1j.apply(this, arguments); }
var SvgMicrophone$1 = function SvgMicrophone(props) {
  return /*#__PURE__*/createElement("svg", _extends$1j({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$X || (_path$X = /*#__PURE__*/createElement("path", {
    d: "M7 4C7 2.34315 8.34315 1 10 1C11.6569 1 13 2.34315 13 4V8C13 9.65685 11.6569 11 10 11C8.34315 11 7 9.65685 7 8V4Z"
  })), _path2$h || (_path2$h = /*#__PURE__*/createElement("path", {
    d: "M11 14.9291C14.3923 14.4439 17 11.5265 17 8C17 7.44772 16.5523 7 16 7C15.4477 7 15 7.44772 15 8C15 10.7614 12.7614 13 10 13C7.23858 13 5 10.7614 5 8C5 7.44772 4.55228 7 4 7C3.44772 7 3 7.44772 3 8C3 11.5265 5.60771 14.4439 9 14.9291V17H6C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19H14C14.5523 19 15 18.5523 15 18C15 17.4477 14.5523 17 14 17H11V14.9291Z"
  })));
};

var _path$Y;
function _extends$1k() { _extends$1k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1k.apply(this, arguments); }
var SvgArrowSmLeft = function SvgArrowSmLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$1k({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$Y || (_path$Y = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70711 14.7071C9.31658 15.0976 8.68342 15.0976 8.29289 14.7071L4.29289 10.7071C3.90237 10.3166 3.90237 9.68342 4.29289 9.29289L8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289C10.0976 5.68342 10.0976 6.31658 9.70711 6.70711L7.41421 9L15 9C15.5523 9 16 9.44772 16 10C16 10.5523 15.5523 11 15 11H7.41421L9.70711 13.2929C10.0976 13.6834 10.0976 14.3166 9.70711 14.7071Z",
    fill: "#828282"
  })));
};

var _path$Z;
function _extends$1l() { _extends$1l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1l.apply(this, arguments); }
var SvgArrowSmRight = function SvgArrowSmRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$1l({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$Z || (_path$Z = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2929 5.29289C10.6834 4.90237 11.3166 4.90237 11.7071 5.29289L15.7071 9.29289C16.0976 9.68342 16.0976 10.3166 15.7071 10.7071L11.7071 14.7071C11.3166 15.0976 10.6834 15.0976 10.2929 14.7071C9.90237 14.3166 9.90237 13.6834 10.2929 13.2929L12.5858 11L5 11C4.44772 11 4 10.5523 4 10C4 9.44772 4.44772 9 5 9H12.5858L10.2929 6.70711C9.90237 6.31658 9.90237 5.68342 10.2929 5.29289Z",
    fill: "#828282"
  })));
};

function useEditOptions(props) {
  var onChangePdfPages = props.onChangePdfPages;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useState = useState({
      pdfPages: props.pdfPages
    }),
    state = _useState[0],
    dispatch = _useState[1];
  var debouncedChangePdfPages = useDebounce(state.pdfPages, 1500); //== debouncedSearch va a tener el valor de state.text en el momento en que reaccionara internamente useDebounce y devolverá otro debouncedSearch
  useEffect(function () {
    // == Verifico que siga siendo igual que lo que hay ahora en el state.text, en caso de haber cambiado ya se invocará de nuevo al
    if (debouncedChangePdfPages === state.pdfPages) {
      onChangePdfPages && onChangePdfPages(state.pdfPages || undefined);
    }
  }, [debouncedChangePdfPages]);
  function onChangePdfPagesState(value) {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        pdfPages: value
      });
    });
  }
  return {
    t: t,
    pdfPagesState: state.pdfPages,
    onChangePdfPagesState: onChangePdfPagesState
  };
}

function EditOptions(props) {
  var onEdit = props.onEdit,
    onUp = props.onUp,
    onDown = props.onDown,
    onLeft = props.onLeft,
    onRight = props.onRight,
    onDuplicate = props.onDuplicate,
    onDelete = props.onDelete,
    onAudios = props.onAudios,
    onChangePdfPages = props.onChangePdfPages,
    _props$upEnable = props.upEnable,
    upEnable = _props$upEnable === void 0 ? true : _props$upEnable,
    _props$downEnable = props.downEnable,
    downEnable = _props$downEnable === void 0 ? true : _props$downEnable,
    _props$leftEnable = props.leftEnable,
    leftEnable = _props$leftEnable === void 0 ? true : _props$leftEnable,
    _props$rightEnable = props.rightEnable,
    rightEnable = _props$rightEnable === void 0 ? true : _props$rightEnable,
    _props$isSecondary = props.isSecondary,
    isSecondary = _props$isSecondary === void 0 ? false : _props$isSecondary;
  var hasAnyOption = onEdit || onUp && upEnable || onDown && downEnable || onLeft && leftEnable || onRight && rightEnable || onDuplicate || onDelete || onAudios || onChangePdfPages;
  var _useEditOptions = useEditOptions(props),
    pdfPagesState = _useEditOptions.pdfPagesState,
    onChangePdfPagesState = _useEditOptions.onChangePdfPagesState,
    t = _useEditOptions.t;
  if (!hasAnyOption) return null;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-edit-options' + (isSecondary ? ' mint-edit-options--secondary' : '')
  }, onEdit && /*#__PURE__*/React__default.createElement("button", {
    className: 'mint-edit-option__item',
    onClick: onEdit,
    title: t('editor:item_option_title_edit')
  }, /*#__PURE__*/React__default.createElement(SvgPencil, null)), (onUp && upEnable || onDown && downEnable) && onEdit && /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-edit-option__separator'
  }), onUp && upEnable && /*#__PURE__*/React__default.createElement("button", {
    className: 'mint-edit-option__item',
    onClick: onUp,
    title: t('editor:item_option_title_up')
  }, /*#__PURE__*/React__default.createElement(SvgSortAscending, null)), onDown && downEnable && /*#__PURE__*/React__default.createElement("button", {
    className: 'mint-edit-option__item',
    onClick: onDown,
    title: t('editor:item_option_title_down')
  }, /*#__PURE__*/React__default.createElement(SvgSortDescending, null)), (onLeft && leftEnable || onRight && rightEnable) && /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-edit-option__separator'
  }), onLeft && leftEnable && /*#__PURE__*/React__default.createElement("button", {
    className: 'mint-edit-option__item',
    onClick: onLeft,
    title: t('editor:item_option_title_left')
  }, /*#__PURE__*/React__default.createElement(SvgArrowSmLeft, null)), onRight && rightEnable && /*#__PURE__*/React__default.createElement("button", {
    className: 'mint-edit-option__item',
    onClick: onRight,
    title: t('editor:item_option_title_right')
  }, /*#__PURE__*/React__default.createElement(SvgArrowSmRight, null)), onDuplicate && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-edit-option__separator'
  }), /*#__PURE__*/React__default.createElement("button", {
    className: 'mint-edit-option__item',
    onClick: onDuplicate,
    title: t('editor:item_option_title_duplicate')
  }, /*#__PURE__*/React__default.createElement(SvgDocumentDuplicate, null))), onDelete && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-edit-option__separator'
  }), /*#__PURE__*/React__default.createElement("button", {
    className: 'mint-edit-option__item',
    onClick: onDelete,
    title: t('editor:item_option_title_delete')
  }, /*#__PURE__*/React__default.createElement(SvgTrash$2, null))), onAudios && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-edit-option__separator'
  }), /*#__PURE__*/React__default.createElement("button", {
    className: 'mint-edit-option__item',
    onClick: onAudios,
    title: t('editor:item_option_title_audios')
  }, /*#__PURE__*/React__default.createElement(SvgMicrophone$1, null))), onChangePdfPages && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-edit-option__separator'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-edit-option__pdf-pages'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-edit-option__pdf-pages-separator'
  }), /*#__PURE__*/React__default.createElement("label", {
    className: 'mint-edit-option__pdf-pages-label'
  }, t('editor:label_pdf_pages_post')), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-edit-option__input-pdf-pages'
  }, /*#__PURE__*/React__default.createElement(InputText, {
    textInput: pdfPagesState || '',
    onChange: onChangePdfPagesState
  })))));
}

var _excluded$4 = ["modifier"];
var ModifiersPlusButton;
(function (ModifiersPlusButton) {
  ModifiersPlusButton["PRIMARY"] = "primary";
})(ModifiersPlusButton || (ModifiersPlusButton = {}));
var PlusButton = function PlusButton(props) {
  var _props$modifier = props.modifier,
    modifier = _props$modifier === void 0 ? ModifiersPlusButton.PRIMARY : _props$modifier,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$4); // == Le paso todos los props que venian excepto modifier
  return /*#__PURE__*/React__default.createElement("button", Object.assign({
    className: "plus-icon plus-icon--" + modifier
  }, otherProps), /*#__PURE__*/React__default.createElement(SvgAdd, null));
};

// TODO: Poner una interfaz con los tipos
var ItemBlocksShortcutsInline = function ItemBlocksShortcutsInline(_ref) {
  var addItemBlock = _ref.addItemBlock,
    translate = _ref.translate;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'block-shortcut-inline'
  }, /*#__PURE__*/React__default.createElement("h5", {
    className: 'block-shortcut-inline__title'
  }, translate('Add an item block', {
    ns: 'editor'
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'block-shortcut-inline__button-list'
  }, /*#__PURE__*/React__default.createElement(IconTextButton, {
    onClick: function onClick() {
      return addItemBlock('text', 'text', 'heading paragraph');
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__icon'
  }, /*#__PURE__*/React__default.createElement(SvgIbiText, null)), /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__text'
  }, translate('editor:text'))), /*#__PURE__*/React__default.createElement(IconTextButton, {
    onClick: function onClick() {
      return addItemBlock('list', 'list', 'bulleted');
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__icon'
  }, /*#__PURE__*/React__default.createElement(SvgIbiList, null)), /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__text'
  }, translate('editor:list'))), /*#__PURE__*/React__default.createElement(IconTextButton, {
    onClick: function onClick() {
      return addItemBlock('image', 'image', 'hero');
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__icon'
  }, /*#__PURE__*/React__default.createElement(SvgIbiImage, null)), /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__text'
  }, translate('editor:image'))), /*#__PURE__*/React__default.createElement(IconTextButton, {
    onClick: function onClick() {
      return addItemBlock('lemonade', 'lemonade', 'Lemonade content guid');
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__icon'
  }, /*#__PURE__*/React__default.createElement(SvgIbiActivity, null)), /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__text'
  }, translate('editor:lemonade'))), /*#__PURE__*/React__default.createElement(IconTextButton, {
    onClick: function onClick() {
      return addItemBlock('multimedia', 'multimedia', 'embed');
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__icon'
  }, /*#__PURE__*/React__default.createElement(SvgIbiVideo, null)), /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__text'
  }, translate('URL video', {
    ns: 'editor'
  }))), /*#__PURE__*/React__default.createElement(IconTextButton, {
    onClick: function onClick() {
      return addItemBlock('multimedia', 'multimedia', 'video');
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__icon'
  }, /*#__PURE__*/React__default.createElement(SvgIbiUpload, null)), /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__text'
  }, translate('Upload video', {
    ns: 'editor'
  }))), /*#__PURE__*/React__default.createElement(IconTextButton, {
    onClick: function onClick() {
      return addItemBlock('provider', 'provider', 'genially');
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__icon'
  }, /*#__PURE__*/React__default.createElement("img", {
    src: img$2,
    alt: 'Genially'
  })), /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__text'
  }, translate('editor:genially'))), /*#__PURE__*/React__default.createElement(IconTextButton, {
    onClick: function onClick() {
      return addItemBlock('provider', 'provider', 'edpuzzle');
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__icon'
  }, /*#__PURE__*/React__default.createElement("img", {
    src: img$1,
    alt: 'Edpuzzle'
  })), /*#__PURE__*/React__default.createElement("span", {
    className: 'icon-text-button__text'
  }, translate('editor:edpuzzle')))));
};

function WrapperItemBlockOptionsDefault(props) {
  var item = props.item,
    children = props.children,
    onUp = props.onUp,
    onDown = props.onDown,
    onDuplicate = props.onDuplicate,
    onDelete = props.onDelete,
    onEdit = props.onEdit,
    onSettings = props.onSettings,
    onAddTop = props.onAddTop,
    onAddBottom = props.onAddBottom,
    _props$firstElement = props.firstElement,
    firstElement = _props$firstElement === void 0 ? false : _props$firstElement,
    _props$lastElement = props.lastElement,
    lastElement = _props$lastElement === void 0 ? false : _props$lastElement,
    _props$showBelowPlus = props.showBelowPlus,
    showBelowPlus = _props$showBelowPlus === void 0 ? false : _props$showBelowPlus,
    editTypeList = props.editTypeList,
    onChangeType = props.onChangeType,
    t = props.t,
    _props$shortcutInline = props.shortcutInline,
    shortcutInline = _props$shortcutInline === void 0 ? false : _props$shortcutInline,
    settingsButtonText = props.settingsButtonText;
  var _useWrapperItemBlockO = useWrapperItemBlockOptions(props),
    isVisibleShortcutBottom = _useWrapperItemBlockO.isVisibleShortcutBottom,
    setIsVisibleShortcutBottom = _useWrapperItemBlockO.setIsVisibleShortcutBottom,
    onAddItemBlockBottom = _useWrapperItemBlockO.onAddItemBlockBottom,
    showButtonPlus = _useWrapperItemBlockO.showButtonPlus,
    isVisibleShortcutTop = _useWrapperItemBlockO.isVisibleShortcutTop,
    setIsVisibleShortcutTop = _useWrapperItemBlockO.setIsVisibleShortcutTop,
    onAddItemBlockTop = _useWrapperItemBlockO.onAddItemBlockTop,
    controls = _useWrapperItemBlockO.controls,
    handleMouseEnter = _useWrapperItemBlockO.handleMouseEnter,
    handleMouseLeave = _useWrapperItemBlockO.handleMouseLeave,
    handleMouseOver = _useWrapperItemBlockO.handleMouseOver;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "item-block-editor",
    onMouseLeave: handleMouseLeave,
    onMouseEnter: handleMouseEnter,
    onMouseOver: handleMouseOver
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "item-block-editor__controls-wrapper " + (controls ? 'item-block-editor__controls-wrapper--show' : '')
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'item-block-editor__left-controls'
  }, /*#__PURE__*/React__default.createElement(FormSelect, {
    selected: JSON.stringify({
      type: item.type,
      family: item.family,
      variant: item.variant
    }),
    onChange: function onChange(e) {
      var parseValue = JSON.parse(e.currentTarget.value);
      parseValue && onChangeType && onChangeType(parseValue);
    }
  }, editTypeList ? editTypeList.map(function (item) {
    return {
      name: t && t(item.caption, {
        ns: 'editor'
      }),
      value: JSON.stringify(item.identity)
    };
  }) : []), onSettings && /*#__PURE__*/React__default.createElement(Button, {
    onClick: onSettings
  }, settingsButtonText)), /*#__PURE__*/React__default.createElement("div", {
    className: 'item-block-editor__right-controls'
  }, /*#__PURE__*/React__default.createElement(EditOptions, {
    onEdit: onEdit,
    onUp: onUp,
    onDown: onDown,
    onDuplicate: onDuplicate,
    onDelete: onDelete,
    upEnable: !firstElement,
    downEnable: !lastElement,
    isSecondary: true
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: 'item-block-editor__children-wrapper'
  }, firstElement && /*#__PURE__*/React__default.createElement("div", {
    className: "item-block-editor__button-plus item-block-editor__button-plus-top " + (showButtonPlus ? 'item-block-editor__button-plus--show' : '')
  }, shortcutInline ? /*#__PURE__*/React__default.createElement(Popover, {
    elementAction: /*#__PURE__*/React__default.createElement(PlusButton, null),
    isVisible: isVisibleShortcutTop,
    onVisible: setIsVisibleShortcutTop,
    showCloseButton: true
  }, /*#__PURE__*/React__default.createElement(ItemBlocksShortcutsInline, {
    translate: t,
    addItemBlock: onAddItemBlockTop
  })) : /*#__PURE__*/React__default.createElement(PlusButton, {
    onClick: function onClick() {
      return onAddTop();
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'item-block-editor__children'
  }, children), showBelowPlus && /*#__PURE__*/React__default.createElement("div", {
    className: "item-block-editor__button-plus item-block-editor__button-plus-bottom " + (showButtonPlus ? 'item-block-editor__button-plus--show' : '')
  }, shortcutInline ? /*#__PURE__*/React__default.createElement(Popover, {
    elementAction: /*#__PURE__*/React__default.createElement(PlusButton, null),
    isVisible: isVisibleShortcutBottom,
    onVisible: setIsVisibleShortcutBottom,
    showCloseButton: true
  }, /*#__PURE__*/React__default.createElement(ItemBlocksShortcutsInline, {
    translate: t,
    addItemBlock: onAddItemBlockBottom
  })) : /*#__PURE__*/React__default.createElement(PlusButton, {
    onClick: function onClick() {
      return onAddBottom();
    }
  }))));
}

function WrapperItemBlockOptions(props) {
  var _props$styleType = props.styleType,
    styleType = _props$styleType === void 0 ? IStyleTypesItemBlockOptions.DEFAULT : _props$styleType;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, styleType === IStyleTypesItemBlockOptions.INLINE ? /*#__PURE__*/React__default.createElement(WrapperItemBlockOptionsInline, Object.assign({}, props)) : /*#__PURE__*/React__default.createElement(WrapperItemBlockOptionsDefault, Object.assign({}, props)));
}

var PostItemEditor = function PostItemEditor(_ref) {
  var item = _ref.item,
    index = _ref.index,
    items = _ref.items,
    role = _ref.role,
    t = _ref.t,
    styleTypeItemBlockOptions = _ref.styleTypeItemBlockOptions,
    _onUp = _ref.onUp,
    _onDown = _ref.onDown,
    _onDuplicate = _ref.onDuplicate,
    onDeleteItem = _ref.onDeleteItem,
    onAudioItem = _ref.onAudioItem,
    _onAddBottom = _ref.onAddBottom,
    onAddTop = _ref.onAddTop,
    _onEditItem = _ref.onEditItem,
    onSettings = _ref.onSettings,
    onChangeTypeItemBlock = _ref.onChangeTypeItemBlock,
    onChangeItem = _ref.onChangeItem,
    getMediaEditor = _ref.getMediaEditor,
    getComponentHead = _ref.getComponentHead,
    isVisibleSettingsItemBlock = _ref.isVisibleSettingsItemBlock,
    editTypeList = _ref.editTypeList,
    onShowPopupEditorFullscreen = _ref.onShowPopupEditorFullscreen;
  return /*#__PURE__*/React__default.createElement(WrapperItemBlockOptions, {
    item: item,
    key: item.id,
    firstElement: index === 0,
    lastElement: index === items.length - 1,
    showBelowPlus: role !== roleTypes.EDITORIAL || role === roleTypes.EDITORIAL && index !== items.length - 1,
    onUp: function onUp() {
      return _onUp(item);
    },
    onDown: function onDown() {
      return _onDown(item);
    },
    onDuplicate: function onDuplicate() {
      return _onDuplicate(item);
    },
    onDelete: function onDelete() {
      return onDeleteItem(item);
    },
    onAudio: function onAudio() {
      return onAudioItem(item);
    },
    onAddBottom: function onAddBottom(type, family, variant) {
      return _onAddBottom(item, type, family, variant);
    },
    onAddTop: onAddTop,
    onEdit: function onEdit() {
      return _onEditItem(item);
    },
    onSettings: isVisibleSettingsItemBlock(item, t) ? function () {
      return onSettings(item);
    } : undefined,
    editTypeList: editTypeList(item, t),
    onChangeType: function onChangeType(type) {
      return onChangeTypeItemBlock(item, type, t);
    },
    t: t,
    shortcutInline: role === roleTypes.TEACHER,
    settingsButtonText: t('editor:Settings'),
    styleType: styleTypeItemBlockOptions
  }, /*#__PURE__*/React__default.createElement(Element$1, {
    name: item.id,
    key: 'toscroll-' + item.id
  }, /*#__PURE__*/React__default.createElement(ItemBlockEditor, {
    item: item,
    key: item.id,
    onChangeItem: onChangeItem,
    onDeleteItem: onDeleteItem,
    mode: IModesItemBlock.MODE_EDITOR,
    getMediaEditor: getMediaEditor,
    getComponentHead: getComponentHead,
    role: role,
    onEditItem: function onEditItem(rowItem, index) {
      return _onEditItem(rowItem);
    } /** TODO, ver el index */,
    onShowPopupEditorFullscreen: onShowPopupEditorFullscreen
  })));
};

function useWrapperRowOptions(props) {
  var onAddTop = props.onAddTop,
    onAddBottom = props.onAddBottom,
    showControls = props.showControls,
    setShowControls = props.setShowControls,
    onChangeShowOptionsRow = props.onChangeShowOptionsRow;
  var _useState = useState(false),
    showOptionsIcon = _useState[0],
    setShowOptionsIcon = _useState[1];
  var _useState2 = useState(false),
    showButtonPlus = _useState2[0],
    setShowButtonPlus = _useState2[1];
  // tenemos que sincronizar el visible o no del popover con acciones de este componente
  var _useState3 = useState(false),
    isVisibleShortcutTop = _useState3[0],
    setIsVisibleShortcutTop = _useState3[1];
  var _useState4 = useState(false),
    isVisibleShortcutBottom = _useState4[0],
    setIsVisibleShortcutBottom = _useState4[1];
  useEffect(function () {
    if (onChangeShowOptionsRow) {
      onChangeShowOptionsRow(showControls);
    }
  }, [showControls]);
  useEffect(function () {
    // == Tambien voy a notificar cuando el icono de opciones se muestra o no
    if (onChangeShowOptionsRow) {
      onChangeShowOptionsRow(showOptionsIcon);
    }
  }, [showOptionsIcon]);
  var handleClickOutside = function handleClickOutside(event) {
    setShowControls(false);
    setShowButtonPlus(false);
    setShowOptionsIcon(false);
  };
  function onAddItemBlockTop(type, family, variant) {
    setIsVisibleShortcutTop(false);
    onAddTop(type, family, variant);
  }
  function onAddItemBlockBottom(type, family, variant) {
    setIsVisibleShortcutBottom(false);
    onAddBottom(type, family, variant);
  }
  // Manejadores de eventos para MouseEnter, MouseLeave y MouseOver
  var handleMouseEnter = function handleMouseEnter(event) {
    setShowButtonPlus(!showControls);
    setShowOptionsIcon(true);
  };
  var handleMouseLeave = function handleMouseLeave(event) {
    if (showControls) {
      setShowButtonPlus(true);
    } else {
      setShowButtonPlus(false);
    }
    setShowOptionsIcon(false);
  };
  var handleMouseOver = function handleMouseOver(event) {
    setShowButtonPlus(!showControls);
  };
  var handleMouseLeaveOptionsIcon = function handleMouseLeaveOptionsIcon(event) {
    setShowOptionsIcon(false);
  };
  var handleMouseEnterOptionsIcon = function handleMouseEnterOptionsIcon(event) {
    setShowOptionsIcon(true);
  };
  var handleMouseOverOptionsIcon = function handleMouseOverOptionsIcon(event) {
    setShowOptionsIcon(true);
  };
  var handleOptionsIconClick = function handleOptionsIconClick(event) {
    event.stopPropagation();
    setShowControls(!showControls);
    setShowButtonPlus(!showControls);
  };
  return {
    isVisibleShortcutBottom: isVisibleShortcutBottom,
    setIsVisibleShortcutBottom: setIsVisibleShortcutBottom,
    onAddItemBlockBottom: onAddItemBlockBottom,
    showButtonPlus: showButtonPlus,
    isVisibleShortcutTop: isVisibleShortcutTop,
    setIsVisibleShortcutTop: setIsVisibleShortcutTop,
    onAddItemBlockTop: onAddItemBlockTop,
    handleMouseEnter: handleMouseEnter,
    handleMouseLeave: handleMouseLeave,
    handleMouseOver: handleMouseOver,
    handleOptionsIconClick: handleOptionsIconClick,
    showOptionsIcon: showOptionsIcon,
    handleOutsideClick: handleClickOutside,
    handleMouseLeaveOptionsIcon: handleMouseLeaveOptionsIcon,
    handleMouseEnterOptionsIcon: handleMouseEnterOptionsIcon,
    handleMouseOverOptionsIcon: handleMouseOverOptionsIcon
  };
}

function WrapperRowOptions(props) {
  var children = props.children,
    onUp = props.onUp,
    onDown = props.onDown,
    onDuplicate = props.onDuplicate,
    onDelete = props.onDelete,
    onEdit = props.onEdit,
    onSettings = props.onSettings,
    onAddTop = props.onAddTop,
    onAddBottom = props.onAddBottom,
    _props$firstElement = props.firstElement,
    firstElement = _props$firstElement === void 0 ? false : _props$firstElement,
    _props$lastElement = props.lastElement,
    lastElement = _props$lastElement === void 0 ? false : _props$lastElement,
    _props$showBelowPlus = props.showBelowPlus,
    showBelowPlus = _props$showBelowPlus === void 0 ? false : _props$showBelowPlus,
    t = props.t,
    _props$shortcutInline = props.shortcutInline,
    shortcutInline = _props$shortcutInline === void 0 ? false : _props$shortcutInline,
    settingsButtonText = props.settingsButtonText,
    _props$showControls = props.showControls,
    showControls = _props$showControls === void 0 ? false : _props$showControls;
  var _useWrapperRowOptions = useWrapperRowOptions(props),
    isVisibleShortcutBottom = _useWrapperRowOptions.isVisibleShortcutBottom,
    setIsVisibleShortcutBottom = _useWrapperRowOptions.setIsVisibleShortcutBottom,
    onAddItemBlockBottom = _useWrapperRowOptions.onAddItemBlockBottom,
    showButtonPlus = _useWrapperRowOptions.showButtonPlus,
    isVisibleShortcutTop = _useWrapperRowOptions.isVisibleShortcutTop,
    setIsVisibleShortcutTop = _useWrapperRowOptions.setIsVisibleShortcutTop,
    onAddItemBlockTop = _useWrapperRowOptions.onAddItemBlockTop,
    handleMouseEnter = _useWrapperRowOptions.handleMouseEnter,
    handleMouseLeave = _useWrapperRowOptions.handleMouseLeave,
    handleMouseOver = _useWrapperRowOptions.handleMouseOver,
    handleOptionsIconClick = _useWrapperRowOptions.handleOptionsIconClick,
    showOptionsIcon = _useWrapperRowOptions.showOptionsIcon,
    handleOutsideClick = _useWrapperRowOptions.handleOutsideClick,
    handleMouseLeaveOptionsIcon = _useWrapperRowOptions.handleMouseLeaveOptionsIcon,
    handleMouseEnterOptionsIcon = _useWrapperRowOptions.handleMouseEnterOptionsIcon,
    handleMouseOverOptionsIcon = _useWrapperRowOptions.handleMouseOverOptionsIcon;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "mint-wrapper-row-options item-block-editor " + (showControls ? 'item-block-editor--row-active' : ''),
    onMouseLeave: handleMouseLeave,
    onMouseEnter: handleMouseEnter,
    onMouseOver: handleMouseOver
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "item-block-editor__row-options-icon " + (showOptionsIcon ? 'visible' : ''),
    onClick: handleOptionsIconClick,
    onMouseLeave: handleMouseLeaveOptionsIcon,
    onMouseEnter: handleMouseEnterOptionsIcon,
    onMouseOver: handleMouseOverOptionsIcon,
    title: t('editor:row_settings_title')
  }, /*#__PURE__*/React__default.createElement(SvgMenuV2, null)), /*#__PURE__*/React__default.createElement("div", {
    className: "item-block-editor__controls-wrapper " + (showControls ? 'item-block-editor__controls-wrapper--show' : ''),
    style: {
      justifyContent: 'right',
      gap: '16px',
      top: '-74px',
      right: '-18px'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'item-block-editor__left-controls'
  }, onSettings && /*#__PURE__*/React__default.createElement(Button, {
    onClick: onSettings
  }, settingsButtonText)), /*#__PURE__*/React__default.createElement(OutsideAlerter, {
    isActive: showControls,
    handleClickOutside: handleOutsideClick,
    // Ignorar los clicks en los elementos que se muestran en el sidebar de la derecha
    classListIgnoreClick: ['form-select__select', 'tabs-sidebar', 'mint-row-post-sidebar', 'tab-settings-sidebar', 'mint-tab-content-settings-sidebar', 'item-block-editor__row-options-icon']
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'item-block-editor__right-controls'
  }, /*#__PURE__*/React__default.createElement(EditOptions, {
    onEdit: onEdit,
    onUp: onUp,
    onDown: onDown,
    onDuplicate: onDuplicate,
    onDelete: onDelete,
    upEnable: !firstElement,
    downEnable: !lastElement,
    isSecondary: true
  })))), firstElement && /*#__PURE__*/React__default.createElement("div", {
    className: "item-block-editor__button-plus item-block-editor__button-plus-top " + (showButtonPlus ? 'item-block-editor__button-plus--show' : '')
  }, shortcutInline ? /*#__PURE__*/React__default.createElement(Popover, {
    elementAction: /*#__PURE__*/React__default.createElement(PlusButton, null),
    isVisible: isVisibleShortcutTop,
    onVisible: setIsVisibleShortcutTop,
    showCloseButton: true
  }, /*#__PURE__*/React__default.createElement(ItemBlocksShortcutsInline, {
    translate: t,
    addItemBlock: onAddItemBlockTop
  })) : /*#__PURE__*/React__default.createElement(PlusButton, {
    onClick: function onClick() {
      return onAddTop();
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'item-block-editor__children'
  }, children, showBelowPlus && /*#__PURE__*/React__default.createElement("div", {
    className: "item-block-editor__button-plus item-block-editor__button-plus-bottom " + (showButtonPlus ? 'item-block-editor__button-plus--show' : '')
  }, shortcutInline ? /*#__PURE__*/React__default.createElement(Popover, {
    elementAction: /*#__PURE__*/React__default.createElement(PlusButton, null),
    isVisible: isVisibleShortcutBottom,
    onVisible: setIsVisibleShortcutBottom,
    showCloseButton: true
  }, /*#__PURE__*/React__default.createElement(ItemBlocksShortcutsInline, {
    translate: t,
    addItemBlock: onAddItemBlockBottom
  })) : /*#__PURE__*/React__default.createElement(PlusButton, {
    onClick: function onClick() {
      return onAddBottom();
    }
  }))));
}

function useWrapperItemBlockColumnOptions(props) {
  var onAddLeft = props.onAddLeft,
    onAddRight = props.onAddRight,
    _props$canShowControl = props.canShowControls,
    canShowControls = _props$canShowControl === void 0 ? true : _props$canShowControl,
    _props$canShowButtonP = props.canShowButtonPlus,
    canShowButtonPlus = _props$canShowButtonP === void 0 ? true : _props$canShowButtonP,
    onChangeShowOptionsItemBlockColumn = props.onChangeShowOptionsItemBlockColumn;
  var _useState = useState(false),
    controls = _useState[0],
    showControls = _useState[1];
  var _useState2 = useState(false),
    showButtonPlus = _useState2[0],
    setShowButtonPlus = _useState2[1];
  // tenemos que sincronizar el visible o no del popover con acciones de este componente
  var _useState3 = useState(false),
    isVisibleShortcutLeft = _useState3[0],
    setIsVisibleShortcutLeft = _useState3[1];
  var _useState4 = useState(false),
    isVisibleShortcutRight = _useState4[0],
    setIsVisibleShortcutRight = _useState4[1];
  useEffect(function () {
    if (onChangeShowOptionsItemBlockColumn) {
      onChangeShowOptionsItemBlockColumn(controls);
    }
  }, [controls]);
  /*useEffect(() => {
    if (canShowControls === undefined || canShowButtonPlus === false) {
      showControls(false);
    }
  }, [canShowControls]);
     useEffect(() => {
    if (canShowButtonPlus === undefined || canShowButtonPlus === false) {
      setShowButtonPlus(false);
    }
  }, [canShowButtonPlus]);*/
  function onAddItemBlockLeft(type, family, variant) {
    setIsVisibleShortcutLeft(false);
    onAddLeft(type, family, variant);
  }
  function onAddItemBlockRight(type, family, variant) {
    setIsVisibleShortcutRight(false);
    onAddRight(type, family, variant);
  }
  // Manejadores de eventos para MouseEnter, MouseLeave y MouseOver
  var handleMouseEnter = function handleMouseEnter(event) {
    showControlsIfAllowed(true);
    setShowButtonPlusIfAllowed(true);
  };
  var handleMouseLeave = function handleMouseLeave(event) {
    showControlsIfAllowed(false);
    setShowButtonPlusIfAllowed(false);
    // setIsVisibleShortcutLeft(false);
    // setIsVisibleShortcutRight(false);
  };

  var handleMouseOver = function handleMouseOver(event) {
    showControlsIfAllowed(true);
    setShowButtonPlusIfAllowed(true);
  };
  var showControlsIfAllowed = function showControlsIfAllowed(show) {
    if (canShowControls !== undefined && canShowControls === true && show === true) {
      showControls(true);
    } else {
      showControls(false);
    }
  };
  var setShowButtonPlusIfAllowed = function setShowButtonPlusIfAllowed(show) {
    if (canShowButtonPlus !== undefined && canShowButtonPlus === true && show === true) {
      setShowButtonPlus(true);
    } else {
      setShowButtonPlus(false);
    }
  };
  return {
    isVisibleShortcutRight: isVisibleShortcutRight,
    setIsVisibleShortcutRight: setIsVisibleShortcutRight,
    onAddItemBlockRight: onAddItemBlockRight,
    showButtonPlus: showButtonPlus,
    isVisibleShortcutLeft: isVisibleShortcutLeft,
    setIsVisibleShortcutLeft: setIsVisibleShortcutLeft,
    onAddItemBlockLeft: onAddItemBlockLeft,
    controls: controls,
    handleMouseEnter: handleMouseEnter,
    handleMouseLeave: handleMouseLeave,
    handleMouseOver: handleMouseOver
  };
}

var _path$_, _path2$i;
function _extends$1m() { _extends$1m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1m.apply(this, arguments); }
var SvgSettings2 = function SvgSettings2(props) {
  return /*#__PURE__*/createElement("svg", _extends$1m({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$_ || (_path$_ = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83333 2.5C3.99238 2.5 2.5 3.99238 2.5 5.83333C2.5 7.67428 3.99238 9.16667 5.83333 9.16667C7.38882 9.16667 8.69546 8.10123 9.06328 6.66032C9.09715 6.66451 9.13166 6.66667 9.16667 6.66667H16.6667C17.1269 6.66667 17.5 6.29357 17.5 5.83333C17.5 5.3731 17.1269 5 16.6667 5H9.16667C9.13166 5 9.09715 5.00216 9.06328 5.00635C8.69546 3.56544 7.38882 2.5 5.83333 2.5ZM4.16667 5.83333C4.16667 4.91286 4.91286 4.16667 5.83333 4.16667C6.75381 4.16667 7.5 4.91286 7.5 5.83333C7.5 6.75381 6.75381 7.5 5.83333 7.5C4.91286 7.5 4.16667 6.75381 4.16667 5.83333Z",
    fill: "#828282"
  })), _path2$i || (_path2$i = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 14.1667C3.33333 13.7064 3.70643 13.3333 4.16667 13.3333H10.9383C11.3084 11.8956 12.6135 10.8333 14.1667 10.8333C16.0076 10.8333 17.5 12.3257 17.5 14.1667C17.5 16.0076 16.0076 17.5 14.1667 17.5C12.6135 17.5 11.3084 16.4377 10.9383 15H4.16667C3.70643 15 3.33333 14.6269 3.33333 14.1667ZM14.1667 15.8333C13.2462 15.8333 12.5 15.0871 12.5 14.1667C12.5 13.2462 13.2462 12.5 14.1667 12.5C15.0871 12.5 15.8333 13.2462 15.8333 14.1667C15.8333 15.0871 15.0871 15.8333 14.1667 15.8333Z",
    fill: "#828282"
  })));
};

function useEditColumnOptions(props) {
  _objectDestructuringEmpty(props);
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useState = useState({});
  return {
    t: t
  };
}

function EditColumnOptions(props) {
  var onEdit = props.onEdit,
    onUp = props.onUp,
    onDown = props.onDown,
    onLeft = props.onLeft,
    onRight = props.onRight,
    onDuplicate = props.onDuplicate,
    onSettingsActivity = props.onSettingsActivity,
    onDelete = props.onDelete,
    onEditTypeCompatible = props.onEditTypeCompatible,
    _props$upEnable = props.upEnable,
    upEnable = _props$upEnable === void 0 ? true : _props$upEnable,
    _props$downEnable = props.downEnable,
    downEnable = _props$downEnable === void 0 ? true : _props$downEnable,
    _props$leftEnable = props.leftEnable,
    leftEnable = _props$leftEnable === void 0 ? true : _props$leftEnable,
    _props$rightEnable = props.rightEnable,
    rightEnable = _props$rightEnable === void 0 ? true : _props$rightEnable,
    _props$isSecondary = props.isSecondary,
    isSecondary = _props$isSecondary === void 0 ? false : _props$isSecondary,
    _props$canAddColumns = props.canAddColumns,
    canAddColumns = _props$canAddColumns === void 0 ? true : _props$canAddColumns;
  var hasAnyOption = onEdit || onUp && upEnable || onDown && downEnable || onLeft && leftEnable || onRight && rightEnable || onDuplicate || onSettingsActivity || onDelete;
  var _useEditColumnOptions = useEditColumnOptions(props),
    t = _useEditColumnOptions.t;
  if (!hasAnyOption) return null;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-edit-column-options' + (isSecondary ? ' mint-edit-column-options--secondary' : '')
  }, onEdit && /*#__PURE__*/React__default.createElement("button", {
    className: 'mint-edit-column-options__item',
    onClick: onEdit,
    title: t('editor:item_option_title_edit')
  }, /*#__PURE__*/React__default.createElement(SvgPencil, null)), (onUp && upEnable || onDown && downEnable) && /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-edit-column-options__separator'
  }), onUp && upEnable && /*#__PURE__*/React__default.createElement("button", {
    className: 'mint-edit-column-options__item',
    onClick: onUp,
    title: t('editor:item_option_title_up')
  }, /*#__PURE__*/React__default.createElement(SvgSortAscending, null)), onDown && downEnable && /*#__PURE__*/React__default.createElement("button", {
    className: 'mint-edit-column-options__item',
    onClick: onDown,
    title: t('editor:item_option_title_down')
  }, /*#__PURE__*/React__default.createElement(SvgSortDescending, null)), (onLeft && leftEnable || onRight && rightEnable) && /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-edit-column-options__separator'
  }), onLeft && leftEnable && /*#__PURE__*/React__default.createElement("button", {
    className: 'mint-edit-column-options__item',
    onClick: onLeft,
    title: t('editor:item_option_title_left')
  }, /*#__PURE__*/React__default.createElement(SvgArrowSmLeft, null)), onRight && rightEnable && /*#__PURE__*/React__default.createElement("button", {
    className: 'mint-edit-column-options__item',
    onClick: onRight,
    title: t('editor:item_option_title_right')
  }, /*#__PURE__*/React__default.createElement(SvgArrowSmRight, null)), onEditTypeCompatible && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-edit-column-options__separator'
  }), /*#__PURE__*/React__default.createElement("button", {
    className: 'mint-edit-column-options__item',
    onClick: onEditTypeCompatible,
    title: t('editor:item_option_title_edit_type_compatible')
  }, /*#__PURE__*/React__default.createElement(SvgRefresh, null))), onDuplicate && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-edit-column-options__separator'
  }), /*#__PURE__*/React__default.createElement("button", {
    className: "mint-edit-column-options__item " + (canAddColumns ? '' : 'mint-edit-column-options__item--disabled'),
    onClick: onDuplicate,
    title: t('editor:item_option_title_duplicate'),
    disabled: !canAddColumns
  }, /*#__PURE__*/React__default.createElement(SvgDocumentDuplicate, null))), onSettingsActivity && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-edit-column-options__separator'
  }), /*#__PURE__*/React__default.createElement("button", {
    className: 'mint-edit-column-options__item',
    onClick: onSettingsActivity,
    title: t('editor:item_option_title_settings')
  }, /*#__PURE__*/React__default.createElement(SvgSettings2, null))), onDelete && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-edit-column-options__separator'
  }), /*#__PURE__*/React__default.createElement("button", {
    className: 'mint-edit-column-options__item',
    onClick: onDelete,
    title: t('editor:item_option_title_delete')
  }, /*#__PURE__*/React__default.createElement(SvgTrash$2, null)), ' '));
}

function WrapperItemBlockColumnOptions(props) {
  var children = props.children,
    onUp = props.onUp,
    onDown = props.onDown,
    onLeft = props.onLeft,
    onRight = props.onRight,
    onDuplicate = props.onDuplicate,
    onSettingsActivity = props.onSettingsActivity,
    onDelete = props.onDelete,
    onEdit = props.onEdit,
    onSettings = props.onSettings,
    onAddLeft = props.onAddLeft,
    onAddRight = props.onAddRight,
    onEditTypeCompatible = props.onEditTypeCompatible,
    _props$showLeftPlus = props.showLeftPlus,
    showLeftPlus = _props$showLeftPlus === void 0 ? false : _props$showLeftPlus,
    _props$showRightPlus = props.showRightPlus,
    showRightPlus = _props$showRightPlus === void 0 ? false : _props$showRightPlus,
    _props$showMoveUp = props.showMoveUp,
    showMoveUp = _props$showMoveUp === void 0 ? false : _props$showMoveUp,
    _props$showMoveDown = props.showMoveDown,
    showMoveDown = _props$showMoveDown === void 0 ? false : _props$showMoveDown,
    _props$showMoveLeft = props.showMoveLeft,
    showMoveLeft = _props$showMoveLeft === void 0 ? false : _props$showMoveLeft,
    _props$showMoveRight = props.showMoveRight,
    showMoveRight = _props$showMoveRight === void 0 ? false : _props$showMoveRight,
    editTypeList = props.editTypeList,
    t = props.t,
    _props$shortcutInline = props.shortcutInline,
    shortcutInline = _props$shortcutInline === void 0 ? false : _props$shortcutInline,
    settingsButtonText = props.settingsButtonText,
    _props$canAddColumns = props.canAddColumns,
    canAddColumns = _props$canAddColumns === void 0 ? false : _props$canAddColumns;
  var _useWrapperItemBlockC = useWrapperItemBlockColumnOptions(props),
    isVisibleShortcutRight = _useWrapperItemBlockC.isVisibleShortcutRight,
    setIsVisibleShortcutRight = _useWrapperItemBlockC.setIsVisibleShortcutRight,
    onAddItemBlockRight = _useWrapperItemBlockC.onAddItemBlockRight,
    showButtonPlus = _useWrapperItemBlockC.showButtonPlus,
    isVisibleShortcutLeft = _useWrapperItemBlockC.isVisibleShortcutLeft,
    setIsVisibleShortcutLeft = _useWrapperItemBlockC.setIsVisibleShortcutLeft,
    onAddItemBlockLeft = _useWrapperItemBlockC.onAddItemBlockLeft,
    controls = _useWrapperItemBlockC.controls,
    handleMouseEnter = _useWrapperItemBlockC.handleMouseEnter,
    handleMouseLeave = _useWrapperItemBlockC.handleMouseLeave,
    handleMouseOver = _useWrapperItemBlockC.handleMouseOver;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "item-block-editor item-block-editor--horizontal " + (controls ? 'wrapper-item-block-column-options--active' : ''),
    onMouseLeave: handleMouseLeave,
    onMouseEnter: handleMouseEnter,
    onMouseOver: handleMouseOver
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "item-block-editor__controls-wrapper " + (controls ? 'item-block-editor__controls-wrapper--show' : ''),
    style: {
      justifyContent: 'right',
      gap: '16px',
      top: '-74px',
      right: '-18px'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'item-block-editor__left-controls'
  }, onSettings && /*#__PURE__*/React__default.createElement(Button, {
    onClick: onSettings
  }, settingsButtonText)), /*#__PURE__*/React__default.createElement("div", {
    className: 'item-block-editor__right-controls'
  }, /*#__PURE__*/React__default.createElement(EditColumnOptions, {
    onEdit: onEdit,
    onUp: onUp,
    onDown: onDown,
    onLeft: onLeft,
    onRight: onRight,
    onEditTypeCompatible: editTypeList && editTypeList.length > 0 ? onEditTypeCompatible : undefined,
    onDuplicate: onDuplicate,
    onDelete: onDelete,
    upEnable: showMoveUp,
    downEnable: showMoveDown,
    leftEnable: showMoveLeft,
    rightEnable: showMoveRight,
    isSecondary: true,
    canAddColumns: canAddColumns,
    onSettingsActivity: onSettingsActivity
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: 'item-block-editor__children-wrapper'
  }, showLeftPlus && /*#__PURE__*/React__default.createElement("div", {
    className: "item-block-editor__button-plus item-block-editor__button-plus--left " + (showButtonPlus ? 'item-block-editor__button-plus--show' : '') + " " + (!canAddColumns ? 'item-block-editor__button-plus--disabled' : '') + "\n            "
  }, shortcutInline ? /*#__PURE__*/React__default.createElement(Popover, {
    elementAction: /*#__PURE__*/React__default.createElement(PlusButton, null),
    isVisible: isVisibleShortcutLeft,
    onVisible: setIsVisibleShortcutLeft,
    showCloseButton: true
  }, /*#__PURE__*/React__default.createElement(ItemBlocksShortcutsInline, {
    translate: t,
    addItemBlock: onAddItemBlockLeft
  })) : /*#__PURE__*/React__default.createElement(PlusButton, {
    onClick: function onClick() {
      return onAddLeft();
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'item-block-editor__children'
  }, children), showRightPlus && /*#__PURE__*/React__default.createElement("div", {
    className: "item-block-editor__button-plus item-block-editor__button-plus--right " + (showButtonPlus ? 'item-block-editor__button-plus--show' : '') + " " + (!canAddColumns ? 'item-block-editor__button-plus--disabled' : '')
  }, shortcutInline ? /*#__PURE__*/React__default.createElement(Popover, {
    elementAction: /*#__PURE__*/React__default.createElement(PlusButton, null),
    isVisible: isVisibleShortcutRight,
    onVisible: setIsVisibleShortcutRight,
    showCloseButton: true
  }, /*#__PURE__*/React__default.createElement(ItemBlocksShortcutsInline, {
    translate: t,
    addItemBlock: onAddItemBlockRight
  })) : /*#__PURE__*/React__default.createElement(PlusButton, {
    onClick: function onClick() {
      return onAddRight();
    }
  }))));
}

var PostColumnItemEditor = function PostColumnItemEditor(_ref) {
  var item = _ref.item,
    showLeftPlus = _ref.showLeftPlus,
    showRightPlus = _ref.showRightPlus,
    showMoveLeft = _ref.showMoveLeft,
    showMoveRight = _ref.showMoveRight,
    role = _ref.role,
    t = _ref.t,
    _onUp = _ref.onUp,
    _onDown = _ref.onDown,
    _onLeft = _ref.onLeft,
    _onRight = _ref.onRight,
    _onDuplicate = _ref.onDuplicate,
    onDeleteItem = _ref.onDeleteItem,
    _onAddRight = _ref.onAddRight,
    onAddLeft = _ref.onAddLeft,
    _onEditItem = _ref.onEditItem,
    _onEditTypeCompatible = _ref.onEditTypeCompatible,
    onSettings = _ref.onSettings,
    onSettingsActivity = _ref.onSettingsActivity,
    onChangeTypeItemBlock = _ref.onChangeTypeItemBlock,
    onChangeItem = _ref.onChangeItem,
    getMediaEditor = _ref.getMediaEditor,
    getComponentHead = _ref.getComponentHead,
    isVisibleSettingsItemBlock = _ref.isVisibleSettingsItemBlock,
    isVisibleSettingsActivityItemBlock = _ref.isVisibleSettingsActivityItemBlock,
    editTypeList = _ref.editTypeList,
    canShowControls = _ref.canShowControls,
    canShowButtonPlus = _ref.canShowButtonPlus,
    canAddColumns = _ref.canAddColumns,
    onChangeShowOptionsItemBlockColumn = _ref.onChangeShowOptionsItemBlockColumn,
    onShowPopupEditorFullscreen = _ref.onShowPopupEditorFullscreen;
  return /*#__PURE__*/React__default.createElement(WrapperItemBlockColumnOptions, {
    item: item,
    key: item.id,
    showLeftPlus: showLeftPlus,
    showRightPlus: showRightPlus,
    showMoveUp: /*showMoveUp*/false,
    showMoveDown: /*showMoveDown*/false,
    showMoveLeft: showMoveLeft,
    showMoveRight: showMoveRight,
    onUp: function onUp() {
      return _onUp(item);
    },
    onDown: function onDown() {
      return _onDown(item);
    },
    onLeft: function onLeft() {
      return _onLeft(item);
    },
    onRight: function onRight() {
      return _onRight(item);
    },
    onDuplicate: function onDuplicate() {
      return _onDuplicate(item);
    },
    onDelete: function onDelete() {
      return onDeleteItem(item);
    },
    onAddRight: function onAddRight(type, family, variant) {
      return _onAddRight(item, type, family, variant);
    },
    onAddLeft: onAddLeft,
    onEdit: function onEdit() {
      return _onEditItem(item);
    },
    onEditTypeCompatible: function onEditTypeCompatible() {
      return _onEditTypeCompatible(item);
    },
    onSettings: isVisibleSettingsItemBlock(item, t) ? function () {
      return onSettings(item);
    } : undefined,
    onSettingsActivity: isVisibleSettingsActivityItemBlock(item) ? function () {
      return onSettingsActivity(item);
    } : undefined,
    editTypeList: editTypeList(item, t),
    onChangeType: function onChangeType(type) {
      return onChangeTypeItemBlock(item, type, t);
    },
    t: t,
    shortcutInline: role === roleTypes.TEACHER,
    settingsButtonText: t('editor:Settings'),
    canShowControls: canShowControls,
    canShowButtonPlus: canShowButtonPlus,
    canAddColumns: canAddColumns,
    onChangeShowOptionsItemBlockColumn: onChangeShowOptionsItemBlockColumn
  }, /*#__PURE__*/React__default.createElement(Element$1, {
    name: item.id,
    key: 'toscroll-' + item.id
  }, /*#__PURE__*/React__default.createElement(ItemBlockEditor, {
    item: item,
    key: item.id,
    onChangeItem: onChangeItem,
    onDeleteItem: onDeleteItem,
    mode: IModesItemBlock.MODE_EDITOR,
    getMediaEditor: getMediaEditor,
    getComponentHead: getComponentHead,
    role: role,
    onEditItem: function onEditItem(rowItem, index) {
      return _onEditItem(rowItem);
    } /** TODO, ver el index */,
    onShowPopupEditorFullscreen: onShowPopupEditorFullscreen
  })));
};

function PostEditor(props) {
  var _post$layout;
  var post = props.post,
    getMediaEditor = props.getMediaEditor,
    getComponentBelowItems = props.getComponentBelowItems,
    getComponentHead = props.getComponentHead,
    role = props.role,
    onShowRowMenu = props.onShowRowMenu,
    _onChangeShowOptionsItemBlockColumn = props.onChangeShowOptionsItemBlockColumn,
    _onChangeShowOptionsRow = props.onChangeShowOptionsRow,
    onShowPopupEditorFullscreen = props.onShowPopupEditorFullscreen;
  var _usePostEditor = usePostEditor(_extends({}, props, {
      onSettingsActivity: props.onSettingsActivity
    })),
    t = _usePostEditor.t,
    items = _usePostEditor.items,
    onAddItemBlock = _usePostEditor.onAddItemBlock,
    onChangeItem = _usePostEditor.onChangeItem,
    _onUp = _usePostEditor.onUp,
    _onDown = _usePostEditor.onDown,
    _onLeft = _usePostEditor.onLeft,
    _onRight = _usePostEditor.onRight,
    _onDuplicate = _usePostEditor.onDuplicate,
    toastRef = _usePostEditor.toastRef,
    _onDeleteItem = _usePostEditor.onDeleteItem,
    onDeleteRow = _usePostEditor.onDeleteRow,
    onAudioItem = _usePostEditor.onAudioItem,
    _onEditItem = _usePostEditor.onEditItem,
    _onSettings = _usePostEditor.onSettings,
    _onSettingsActivity = _usePostEditor.onSettingsActivity,
    onEditTypeCompatible = _usePostEditor.onEditTypeCompatible,
    isVisibleSettingsItemBlock = _usePostEditor.isVisibleSettingsItemBlock,
    isVisibleSettingsActivityItemBlock = _usePostEditor.isVisibleSettingsActivityItemBlock,
    _onAddTop = _usePostEditor.onAddTop,
    _onAddBottom = _usePostEditor.onAddBottom,
    onShowComponentsMenu = _usePostEditor.onShowComponentsMenu,
    onChangeTypeItemBlock = _usePostEditor.onChangeTypeItemBlock,
    editTypeList = _usePostEditor.editTypeList,
    styleTypeItemBlockOptions = _usePostEditor.styleTypeItemBlockOptions,
    onDuplicateRow = _usePostEditor.onDuplicateRow,
    onUpRow = _usePostEditor.onUpRow,
    onDownRow = _usePostEditor.onDownRow,
    showControlsRow = _usePostEditor.showControlsRow,
    setShowControlsRow = _usePostEditor.setShowControlsRow,
    onChangeLayout = _usePostEditor.onChangeLayout;
  var background = (_post$layout = post.layout) == null || (_post$layout = _post$layout.config) == null ? void 0 : _post$layout.background;
  return /*#__PURE__*/React__default.createElement(BackgroundWrapper, {
    className: 'mint-post mint-post--edit',
    backgroundImage: background == null ? void 0 : background.backgroundImage,
    backgroundColor: background == null ? void 0 : background.backgroundColor,
    overlayOpacity: background == null ? void 0 : background.overlayOpacity,
    overlayColor: background == null ? void 0 : background.overlayColor,
    fixed: true
  }, post.layout ? post.layout.rows.map(function (row, indexRow) {
    return /*#__PURE__*/React__default.createElement(WrapperRowOptions, {
      key: row.guid,
      onUp: function onUp() {
        return onUpRow(row);
      },
      onDown: function onDown() {
        return onDownRow(row);
      },
      onDuplicate: function onDuplicate() {
        return onDuplicateRow(row);
      },
      onDelete: function onDelete() {
        return onDeleteRow(row);
      },
      onEdit: function onEdit() {
        var _post$layout2;
        return onShowRowMenu(((_post$layout2 = post.layout) == null ? void 0 : _post$layout2.guid) || '', row.guid);
      },
      onAudio: function onAudio() {
        return console.log('onAudio');
      },
      onAddTop: function onAddTop(type, family, variant) {
        return _onAddTop(type, family, variant, undefined, row);
      },
      onAddBottom: function onAddBottom(type, family, variant) {
        return _onAddBottom(undefined, type, family, variant, undefined, row);
      },
      settingsButtonText: t('editor:Settings'),
      firstElement: indexRow === 0,
      // @ts-ignore Pongo el ignore porque aqui va a tener valor post.layout.rows.length ya que si no hay elementos ni itera en el bucle
      lastElement: indexRow === post.layout.rows.length - 1,
      showBelowPlus: role !== roleTypes.EDITORIAL ||
      // @ts-ignore Pongo el ignore porque aqui va a tener valor post.layout.rows.length ya que si no hay elementos ni itera en el bucle
      role === roleTypes.EDITORIAL && indexRow !== post.layout.rows.length - 1,
      t: t,
      shortcutInline: role === roleTypes.TEACHER,
      showControls: showControlsRow && showControlsRow.guid === row.guid ? true : false,
      setShowControls: function setShowControls(show) {
        return setShowControlsRow(show ? row : undefined);
      },
      onChangeShowOptionsRow: function onChangeShowOptionsRow(show) {
        var _post$layout3;
        return _onChangeShowOptionsRow(show, row, ((_post$layout3 = post.layout) == null ? void 0 : _post$layout3.guid) || '');
      }
    }, /*#__PURE__*/React__default.createElement(PostRow, {
      row: row,
      layout: post.layout
    }, row.columns.map(function (column, indexColumn) {
      var itemBlock = items.find(function (item) {
        return item.id === column.itemId;
      });
      return itemBlock ? /*#__PURE__*/React__default.createElement(PostColumn, {
        key: column.guid,
        column: column,
        layout: post.layout,
        row: row
      }, /*#__PURE__*/React__default.createElement(PostColumnItemEditor, {
        item: itemBlock,
        showLeftPlus: indexColumn === 0,
        showRightPlus: true,
        showMoveLeft: indexColumn > 0,
        showMoveRight: indexColumn < row.columns.length - 1,
        showMoveUp: indexRow > 0,
        showMoveDown: indexRow < post.layout.rows.length - 1,
        role: role,
        t: t,
        onUp: function onUp(item) {
          return _onUp(item, {
            rowGuid: row.guid,
            columnGuid: column.guid,
            rowIndex: indexRow,
            columnIndex: indexColumn
          });
        },
        onDown: function onDown(item) {
          return _onDown(item, {
            rowGuid: row.guid,
            columnGuid: column.guid,
            rowIndex: indexRow,
            columnIndex: indexColumn
          });
        },
        onLeft: function onLeft(item) {
          return _onLeft(item, {
            rowGuid: row.guid,
            columnGuid: column.guid
          });
        },
        onRight: function onRight(item) {
          return _onRight(item, {
            rowGuid: row.guid,
            columnGuid: column.guid
          });
        },
        onDuplicate: function onDuplicate(item) {
          return _onDuplicate(item, {
            rowGuid: row.guid,
            columnGuid: column.guid
          });
        },
        onDeleteItem: function onDeleteItem(item) {
          return _onDeleteItem(item, {
            rowGuid: row.guid,
            columnGuid: column.guid,
            rowIndex: indexRow,
            columnIndex: indexColumn
          });
        },
        onAddRight: function onAddRight(item, type, family, variant) {
          return _onAddBottom(item, type, family, variant, {
            rowGuid: row.guid,
            columnGuid: column.guid
          }, undefined, true);
        },
        onAddLeft: function onAddLeft(type, family, variant) {
          return _onAddTop(type, family, variant, {
            rowGuid: row.guid,
            columnGuid: column.guid
          }, undefined, true);
        },
        onEditItem: function onEditItem(item) {
          _onEditItem({
            item: item,
            layoutPosition: {
              rowGuid: row.guid,
              columnGuid: column.guid,
              rowIndex: indexRow,
              columnIndex: indexColumn
            },
            layoutGuid: post.layout.guid,
            onChangeLayout: onChangeLayout
          });
        },
        onSettings: function onSettings(item) {
          _onSettings({
            item: item,
            layoutPosition: {
              rowGuid: row.guid,
              columnGuid: column.guid,
              rowIndex: indexRow,
              columnIndex: indexColumn
            },
            layoutGuid: post.layout.guid,
            onChangeLayout: onChangeLayout
          });
        },
        onSettingsActivity: function onSettingsActivity(item) {
          _onSettingsActivity({
            item: item,
            onChangeItem: onChangeItem,
            layoutPosition: {
              rowGuid: row.guid,
              columnGuid: column.guid,
              rowIndex: indexRow,
              columnIndex: indexColumn
            },
            layoutGuid: post.layout.guid
          });
        },
        onEditTypeCompatible: onEditTypeCompatible,
        onChangeTypeItemBlock: onChangeTypeItemBlock,
        onChangeItem: onChangeItem,
        getMediaEditor: getMediaEditor,
        getComponentHead: getComponentHead,
        isVisibleSettingsItemBlock: isVisibleSettingsItemBlock,
        isVisibleSettingsActivityItemBlock: isVisibleSettingsActivityItemBlock,
        editTypeList: editTypeList,
        layoutPosition: {
          rowGuid: row.guid,
          columnGuid: column.guid
        },
        canShowControls: showControlsRow === undefined ? true : false,
        canShowButtonPlus: showControlsRow === undefined ? true : false,
        canAddColumns: row.columns.length < MAX_COLUMNS_ALLOWED,
        onChangeShowOptionsItemBlockColumn: function onChangeShowOptionsItemBlockColumn(show) {
          _onChangeShowOptionsItemBlockColumn(show, itemBlock, {
            rowGuid: row.guid,
            columnGuid: column.guid
          });
        },
        onShowPopupEditorFullscreen: onShowPopupEditorFullscreen
      })) : null;
    })));
  }) : items.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(PostItemEditor, {
      key: item.id,
      item: item,
      index: index,
      items: items,
      role: role,
      t: t,
      styleTypeItemBlockOptions: styleTypeItemBlockOptions,
      onUp: _onUp,
      onDown: _onDown,
      onDuplicate: _onDuplicate,
      onDeleteItem: _onDeleteItem,
      onAudioItem: onAudioItem,
      onAddBottom: _onAddBottom,
      onAddTop: _onAddTop,
      onEditItem: function onEditItem(item) {
        _onEditItem({
          item: item
        });
      },
      onSettings: function onSettings(item) {
        _onSettings({
          item: item
        });
      },
      onChangeTypeItemBlock: onChangeTypeItemBlock,
      onChangeItem: onChangeItem,
      getMediaEditor: getMediaEditor,
      getComponentHead: getComponentHead,
      isVisibleSettingsItemBlock: isVisibleSettingsItemBlock,
      editTypeList: editTypeList,
      onShowPopupEditorFullscreen: onShowPopupEditorFullscreen
    });
  }), getComponentBelowItems && getComponentBelowItems(true), /*#__PURE__*/React__default.createElement(FirstBlockWhenNoContent, {
    role: role,
    show: items.length === 0,
    label: t('Add your first block', {
      ns: 'editor'
    }),
    onAddBlock: _onAddTop
  }), role === roleTypes.EDITORIAL && /*#__PURE__*/React__default.createElement(ItemBlocksShortcuts, {
    addComponent: onAddItemBlock,
    showComponentsMenu: onShowComponentsMenu,
    translate: t,
    hasItemBlocks: items.length > 0
  }), /*#__PURE__*/React__default.createElement(WrapperToastBottom, null, /*#__PURE__*/React__default.createElement(WithToastForwardRef, {
    ref: toastRef
  })));
}

function PostsEditorEmpty(props) {
  var onAddClick = props.onAddClick;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-posts-editor lesson'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: 'float-button'
  }, /*#__PURE__*/React__default.createElement(Button, {
    onClick: onAddClick
  }, /*#__PURE__*/React__default.createElement(SvgAdd, null))));
}

var MATHLIVE_SCRIPT_ID = 'mathliveScriptId';
var mathLiveUrl = '//unpkg.com/mathlive@0.94.8/dist/mathlive.min.js';
var useMathLive = function useMathLive() {
  var _useState = useState(false),
    mathLiveReady = _useState[0],
    setReady = _useState[1];
  var onLoadDone = useCallback(function () {
    // eslint-disable-next-line
    (function retry(times) {
      !window.MathLive ? setTimeout(function () {
        return retry();
      }, 200) : setReady(true);
    })();
  }, [setReady]);
  var loadScript = useCallback(function (url, id) {
    if (!document.getElementById(id)) {
      var script = document.createElement('script');
      script.src = url;
      script.id = id;
      script.async = true;
      script.addEventListener('load', onLoadDone);
      document.body.appendChild(script);
    } else {
      onLoadDone();
    }
  }, [onLoadDone]);
  useEffect(function () {
    loadScript(mathLiveUrl, MATHLIVE_SCRIPT_ID);
  }, []);
  return {
    mathLiveReady: mathLiveReady
  };
};

var IModesLessonEditor;
(function (IModesLessonEditor) {
  IModesLessonEditor["MODE_EDIT_ALL"] = "MODE_EDIT_ALL";
  IModesLessonEditor["MODE_EDIT_ONLY_ONE"] = "MODE_EDIT_ONLY_ONE";
})(IModesLessonEditor || (IModesLessonEditor = {}));

function emptyPost(version) {
  return _extends({
    guid: getGuid(),
    items: []
  }, version && {
    version: version
  });
}
var IPostUtils = {
  emptyPost: emptyPost
};

/**
 * Contiene la logica de los posibles modos de edicion de una Leccion
 * @param props
 * @returns
 */
function useModesLessonEditor(props) {
  var modeLessonEditor = props.modeLessonEditor,
    onDeletePost = props.onDeletePost,
    posts = props.posts,
    role = props.role,
    isSinglePost = props.isSinglePost;
  var _useState = useState(null),
    postGuidEdit = _useState[0],
    setPostGuidEdit = _useState[1];
  useEffect(function () {
    // == Si cambia el array de post y tenia yo alguno en edicion miro a ver si se hubiera eliminado y ya no estuviera
    if (postGuidEdit && !posts.find(function (post) {
      return post.guid === postGuidEdit;
    })) {
      setPostGuidEdit(null);
    }
  }, [posts.length]);
  function isShowButtonOpenEditionPost(post) {
    if (modeLessonEditor === IModesLessonEditor.MODE_EDIT_ONLY_ONE) {
      // == Se muestra el boton de abir edicion si no estoy editando ningun post
      if (!postGuidEdit) {
        return true;
      } else return false;
    } else return false;
  }
  function isShowButtonCloseEditionPost(post) {
    if (modeLessonEditor === IModesLessonEditor.MODE_EDIT_ONLY_ONE) {
      // == Se muestra el boton de cerrar si estoy editando este post
      if (postGuidEdit === post.guid) {
        return true;
      } else return false;
    } else return false;
  }
  function onOpenEditionPost(post) {
    setPostGuidEdit(post.guid);
  }
  function onCloseEditionPost(post) {
    setPostGuidEdit(null);
    if (modeLessonEditor === IModesLessonEditor.MODE_EDIT_ONLY_ONE) {
      if (post.items && post.items.length > 0 || hasData(post.teacher_notes)) ; else {
        // == Si no tiene items creados cuando cierra el post lo elimino
        onDeletePost(post, false);
      }
    }
  }
  function isModePostEditor(post) {
    if (modeLessonEditor === IModesLessonEditor.MODE_EDIT_ONLY_ONE && postGuidEdit !== post.guid) {
      return false;
    } else return true;
  }
  function isShowButtonAddPost() {
    if (isSinglePost) return false;
    if (!canSeePostOptions(role)) return false;
    if (modeLessonEditor === IModesLessonEditor.MODE_EDIT_ONLY_ONE) {
      if (postGuidEdit) {
        return false;
      } else return true;
    } else return true;
  }
  return {
    isShowButtonOpenEditionPost: isShowButtonOpenEditionPost,
    isShowButtonCloseEditionPost: isShowButtonCloseEditionPost,
    onOpenEditionPost: onOpenEditionPost,
    onCloseEditionPost: onCloseEditionPost,
    isModePostEditor: isModePostEditor,
    isShowButtonAddPost: isShowButtonAddPost(),
    setPostGuidEdit: setPostGuidEdit
  };
}

var IActionOnChange;
(function (IActionOnChange) {
  IActionOnChange["DEFAULT"] = "";
  IActionOnChange["REMOVE_HAS_CHANGES"] = "removeHasChanges";
})(IActionOnChange || (IActionOnChange = {}));

function useLessonEditor(props) {
  var _state$sidebarEditIte, _state$sidebarEditIte2, _state$sidebarEditIte3, _state$sidebarEditIte4, _state$sidebarEditIte5, _state$sidebarCreateI, _state$sidebarEditIte6, _state$sidebarCreateI2, _state$sidebarCreateI3, _state$sidebarCreateI4, _state$sidebarCreateI5, _state$sidebarCreateI6, _state$sidebarCreateI7, _state$sidebarCreateI8, _state$sidebarCreateI9, _state$sidebarAudiosP, _state$sidebarAudiosP2, _state$sidebarAudiosP3, _state$sidebarEditPos, _state$sidebarEditPos2, _state$sidebarEditPos3, _state$sidebarEditPos4, _state$sidebarEditPos5, _state$sidebarEditPos6, _state$sidebarEditPos7, _state$sidebarPopupEd, _state$sidebarPopupEd2, _state$sidebarPopupEd3, _state$sidebarSetting, _state$sidebarSetting2, _state$sidebarSetting3, _state$sidebarSetting4, _state$sidebarSetting5, _state$sidebarSetting6, _state$customEditor, _state$customEditor2, _state$customEditor3;
  var lesson = props.lesson,
    onChangeLesson = props.onChangeLesson,
    _props$modeLessonEdit = props.modeLessonEditor,
    modeLessonEditor = _props$modeLessonEdit === void 0 ? IModesLessonEditor.MODE_EDIT_ONLY_ONE : _props$modeLessonEdit,
    role = props.role;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    isSinglePost = _useGeneral.isSinglePost,
    backgroundVisor = _useGeneral.backgroundVisor,
    version = _useGeneral.version,
    uiStyles = _useGeneral.uiStyles;
  useMathLive();
  var toastRef = useRef(null);
  var _useState = useState({
      posts: getPostsProps(),
      pendingOnChangePosts: false,
      sidebarEditItem: {
        menuVisible: false,
        item: null,
        postGuid: null,
        isMenuSettings: false,
        onChangeItem: undefined,
        onDeleteItem: undefined,
        layoutPosition: undefined,
        layoutGuid: undefined,
        onChangeLayout: undefined
      },
      sidebarCreateItem: {
        isOpen: false,
        blockList: undefined,
        onSelect: undefined,
        onClickNewTemplateBlock: undefined,
        close: function close() {},
        title: undefined,
        hideEdpuzzle: undefined,
        hideGenially: undefined,
        hideActivity: undefined,
        hideFeedbackActivity: undefined
      },
      sidebarAudiosPost: {
        menuVisible: false,
        postGuid: null,
        onChangePost: onChangePost
      },
      sidebarEditPostRow: {
        menuVisible: false,
        layoutGuid: null,
        rowGuid: null,
        onChangePostRow: onChangePostRow
      },
      sidebarEditPostLayout: {
        menuVisible: false,
        layoutGuid: null,
        onChangePostLayout: onChangePostLayout
      },
      sidebarPopupEditorFullscreen: {
        menuVisible: false,
        itemBlockPopup: null,
        onChangeItemBlockPopup: undefined
      },
      sidebarSettingsActivity: {
        menuVisible: false,
        item: null,
        onChangeItem: undefined,
        layoutPosition: undefined,
        layoutGuid: undefined,
        onChangeLayout: undefined
      },
      customEditor: {
        isVisible: false,
        item: null,
        postGuid: null,
        onChangeItem: undefined,
        onDeleteItem: undefined
      },
      confirmDialog: {
        isVisible: false
      },
      itemBlocksShowingOptions: [],
      rowsShowingOptions: []
    }),
    state = _useState[0],
    dispatch = _useState[1];
  var _useModesLessonEditor = useModesLessonEditor({
      modeLessonEditor: modeLessonEditor,
      onDeletePost: _onDeletePost,
      posts: state.posts,
      role: role,
      isSinglePost: isSinglePost
    }),
    isShowButtonOpenEditionPost = _useModesLessonEditor.isShowButtonOpenEditionPost,
    isShowButtonCloseEditionPost = _useModesLessonEditor.isShowButtonCloseEditionPost,
    onOpenEditionPost = _useModesLessonEditor.onOpenEditionPost,
    onCloseEditionPost = _useModesLessonEditor.onCloseEditionPost,
    isModePostEditor = _useModesLessonEditor.isModePostEditor,
    isShowButtonAddPost = _useModesLessonEditor.isShowButtonAddPost,
    setPostGuidEdit = _useModesLessonEditor.setPostGuidEdit;
  var stateRef = useRef(state); // == Lo almaceno asi para acceder con metodos asincronos
  stateRef.current = state;
  var scrollTypeToItem = {
    delay: 0,
    smooth: 'easeInOutQuint',
    offset: -100
  }; // == -100 es para que se vea un poco de arriba donde estan los botones de subir y bajar...
  useEffect(function () {
    state.pendingOnChangePosts && onChangePosts && onChangePosts(state.posts);
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        pendingOnChangePosts: false
      });
    });
  }, [state.pendingOnChangePosts]);
  useEffect(function () {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        posts: getPostsProps()
      });
    });
  }, [lesson]);
  function onChangePosts(postsUpdate) {
    onChangeLesson && onChangeLesson(_extends({}, lesson, {
      items: postsUpdate
    }), IActionOnChange.DEFAULT);
  }
  function getPostsProps() {
    return lesson && lesson.items ? lesson.items : [];
  }
  function onAddClick() {
    // Crear un post
    var emptyPost = IPostUtils.emptyPost(version);
    setPostGuidEdit(emptyPost.guid); // == Cuando creo un post lo pongo en modo edicion
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        posts: [].concat(prevState.posts, [emptyPost]),
        pendingOnChangePosts: true
      });
    });
  }
  function onChangePost(postUpdate) {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        posts: prevState.posts.map(function (post) {
          return post.guid === postUpdate.guid ? postUpdate : post;
        }),
        pendingOnChangePosts: true
      });
    });
  }
  function onChangePostRow(rowUpdate, layoutGuid) {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        posts: prevState.posts.map(function (post) {
          var _post$layout;
          // Si este post tiene el layout que buscamos
          if (((_post$layout = post.layout) == null ? void 0 : _post$layout.guid) === layoutGuid) {
            return _extends({}, post, {
              layout: _extends({}, post.layout, {
                rows: post.layout.rows.map(function (row) {
                  return (
                    // Actualizamos la fila que coincide con el guid
                    row.guid === rowUpdate.guid ? rowUpdate : row
                  );
                })
              })
            });
          }
          return post;
        }),
        pendingOnChangePosts: true
      });
    });
  }
  function onChangePostLayout(layoutUpdate) {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        posts: prevState.posts.map(function (post) {
          var _post$layout2;
          return ((_post$layout2 = post.layout) == null ? void 0 : _post$layout2.guid) === layoutUpdate.guid ? _extends({}, post, {
            layout: layoutUpdate
          }) : post;
        }),
        pendingOnChangePosts: true
      });
    });
  }
  function isEmpty() {
    if (state.posts && state.posts.length > 0) {
      // == Hay elementos
      return false;
    } else return true;
  }
  function openSidebarEditItem(item, postGuid, onChangeItem, onDeleteItem, isMenuSettings, layoutPosition, layoutGuid, onChangeLayout) {
    if (isMenuSettings === void 0) {
      isMenuSettings = false;
    }
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        sidebarEditItem: {
          menuVisible: true,
          item: item,
          postGuid: postGuid,
          isMenuSettings: isMenuSettings,
          onChangeItem: onChangeItem,
          onDeleteItem: onDeleteItem,
          layoutPosition: layoutPosition,
          layoutGuid: layoutGuid,
          onChangeLayout: onChangeLayout
        }
      });
    });
  }
  function onSettingsActivity(_ref) {
    var item = _ref.item,
      onChangeItem = _ref.onChangeItem,
      layoutPosition = _ref.layoutPosition,
      layoutGuid = _ref.layoutGuid;
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        sidebarSettingsActivity: {
          menuVisible: true,
          item: item,
          onChangeItem: onChangeItem,
          layoutPosition: layoutPosition,
          layoutGuid: layoutGuid
        }
      });
    });
  }
  function openCustomEditor(item, postGuid, onChangeItem, onDeleteItem) {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        customEditor: {
          isVisible: true,
          item: item,
          postGuid: postGuid,
          onChangeItem: onChangeItem,
          onDeleteItem: onDeleteItem
        }
      });
    });
  }
  function closeSidebarEditItem() {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        sidebarEditItem: {
          menuVisible: false,
          item: null,
          postGuid: null,
          isMenuSettings: false,
          onChangeItem: function onChangeItem(itemUpdate) {},
          onDeleteItem: function onDeleteItem(item) {},
          layoutPosition: undefined,
          layoutGuid: undefined,
          onChangeLayout: undefined
        }
      });
    });
  }
  function closeSidebarAudiosPost() {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        sidebarAudiosPost: {
          menuVisible: false,
          post: null,
          onChangePost: undefined
        }
      });
    });
  }
  function closeSidebarEditPostRow() {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        sidebarEditPostRow: {
          menuVisible: false,
          layoutGuid: null,
          rowGuid: null,
          onChangePostRow: undefined
        }
      });
    });
  }
  function closeSidebarPopupEditorFullscreen() {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        sidebarPopupEditorFullscreen: _extends({}, prevState.sidebarPopupEditorFullscreen, {
          menuVisible: false
        })
      });
    });
  }
  function closeSidebarEditPostLayout() {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        sidebarEditPostLayout: {
          menuVisible: false,
          layoutGuid: null,
          onChangePostLayout: undefined
        }
      });
    });
  }
  function closeSidebarSettingsActivity() {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        sidebarSettingsActivity: {
          menuVisible: false,
          item: null,
          onChangeItem: undefined,
          layoutPosition: undefined,
          layoutGuid: undefined
        }
      });
    });
  }
  function closeCustomEditor() {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        customEditor: {
          isVisible: false,
          item: null,
          postGuid: null,
          onChangeItem: function onChangeItem(itemUpdate) {},
          onDeleteItem: function onDeleteItem(item) {}
        }
      });
    });
  }
  function getAllItemBlocks() {
    return getBlockListExclusive(t);
  }
  function openSidebarGeneric(onSelected, filterBlocks, title, hideEdpuzzle, hideGenially, hideActivity, hideFeedbackActivity) {
    var fullBlockList = getAllItemBlocks();
    if (filterBlocks) {
      // Filtramos la lista completa para mantener solo los bloques compatibles
      var compatibleIds = new Set(filterBlocks.map(function (b) {
        return b.identity.type + "_" + b.identity.family + "_" + b.identity.variant;
      }));
      var filteredBlocks = fullBlockList.map(function (group) {
        return _extends({}, group, {
          blocks: group.blocks.filter(function (block) {
            return compatibleIds.has(block.identity.type + "_" + block.identity.family + "_" + block.identity.variant);
          })
        });
      }).filter(function (group) {
        return group.blocks.length > 0;
      });
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          sidebarCreateItem: {
            isOpen: true,
            blockList: filteredBlocks,
            onSelect: onSelected,
            close: closeSidebarCreateItem,
            title: title,
            hideEdpuzzle: hideEdpuzzle,
            hideGenially: hideGenially,
            hideActivity: hideActivity,
            hideFeedbackActivity: hideFeedbackActivity
          }
        });
      });
    } else {
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          sidebarCreateItem: {
            isOpen: true,
            blockList: fullBlockList,
            onSelect: onSelected,
            close: closeSidebarCreateItem,
            title: title,
            hideEdpuzzle: hideEdpuzzle,
            hideGenially: hideGenially,
            hideActivity: hideActivity,
            hideFeedbackActivity: hideFeedbackActivity
          }
        });
      });
    }
  }
  function openSidebarCreateItem(onSelected) {
    openSidebarGeneric(onSelected);
  }
  function closeSidebarGeneric() {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        sidebarCreateItem: {
          isOpen: false,
          blockList: undefined,
          onSelect: undefined,
          onClickNewTemplateBlock: undefined,
          close: function close() {},
          title: undefined,
          hideEdpuzzle: undefined,
          hideGenially: undefined,
          hideActivity: undefined,
          hideFeedbackActivity: undefined
        }
      });
    });
  }
  function closeSidebarCreateItem() {
    closeSidebarGeneric();
  }
  /* function getPostByGuid(postGuid: string): IPost {
    return stateRef.current.posts.find((post) => post.guid === postGuid);
  } */
  function onSCrollItem(itemId) {
    scroller.scrollTo(itemId, scrollTypeToItem);
  }
  function onSCrollPost(postGuid) {
    scroller.scrollTo(postGuid, scrollTypeToItem);
  }
  function onUpPost(post) {
    var posts = state.posts;
    if (posts && posts.length > 0) {
      var index = posts.findIndex(function (element) {
        return element.guid === post.guid;
      });
      var element = posts[index];
      if (element && index > 0) {
        // == Puedo subir aquellos cuyo elemento no sea el primero
        var newList = [].concat(posts);
        var movingItem = element;
        newList.splice(index, 1);
        newList.splice(index - 1, 0, movingItem);
        dispatch(function (prevState) {
          return _extends({}, prevState, {
            posts: newList,
            pendingOnChangePosts: true
          });
        });
        // hacer scroll hacia el elemento
        setTimeout(function () {
          return onSCrollPost && onSCrollPost(movingItem.guid);
        }, 100);
      }
    }
  }
  function onDownPost(post) {
    var posts = state.posts;
    if (posts && posts.length > 0) {
      var index = posts.findIndex(function (element) {
        return element.guid === post.guid;
      });
      var element = posts[index];
      if (element && index <= posts.length - 2 && index >= 0) {
        // le resto 2 porque si el array es de 3 solo voy a poder bajar los que sean menores o iguales que 1, que es el penultimo elemento
        var newList = [].concat(posts);
        var movingItem = element;
        newList.splice(index, 1);
        newList.splice(index + 1, 0, movingItem);
        dispatch(function (prevState) {
          return _extends({}, prevState, {
            posts: newList,
            pendingOnChangePosts: true
          });
        });
        // hacer scroll hacia el elemento
        setTimeout(function () {
          return onSCrollPost && onSCrollPost(movingItem.guid);
        }, 100);
      }
    }
  }
  function onDuplicatePost(post) {
    var posts = state.posts;
    if (posts && posts.length > 0) {
      var _idPostCreateAfter = post.guid;
      var index = posts.findIndex(function (element) {
        return element.guid === _idPostCreateAfter;
      });
      var element = posts[index];
      if (element && index >= 0) {
        var newList = [].concat(posts);
        var postInsert = getPostCopy(post);
        newList.splice(index + 1, 0, postInsert);
        dispatch(function (prevState) {
          return _extends({}, prevState, {
            posts: newList,
            pendingOnChangePosts: true
          });
        });
        // hacer scroll hacia el elemento
        setTimeout(function () {
          return onSCrollPost && onSCrollPost(postInsert.guid);
        }, 100);
      }
    }
  }
  function onChangePdfPages(post, newPdfPages) {
    onChangePost && onChangePost(_extends({}, post, {
      pdfPages: newPdfPages
    }));
  }
  /**
   * Añade el item pasado por parametro al final de la lista o despues de un elemento indicado
   * @param {object} item - item de tipo itemblock
   */
  function addPostByParam(newPost, paramsCreatePost) {
    var idPostCreateAfter = null;
    var createPostTop = false;
    if (paramsCreatePost) {
      if (paramsCreatePost.idPostCreateAfter) idPostCreateAfter = paramsCreatePost.idPostCreateAfter;
      if (paramsCreatePost.createPostTop) createPostTop = paramsCreatePost.createPostTop;
    }
    if (newPost) {
      var posts = stateRef.current.posts;
      // Primero miro la variable createPostTop si es true se crea arriba en otro caso miro idPostCreateAfter para ver donde se crea
      var itemList = null;
      if (createPostTop) {
        itemList = [newPost].concat(posts);
      } else {
        // si existe un idPostCreateAfter
        // se añade el nuevo item debajo de este
        // caso contrario se añade al final
        if (idPostCreateAfter) {
          itemList = function (idx) {
            return [].concat(posts.slice(0, idx), [newPost], posts.slice(idx));
          }(posts.findIndex(function (i) {
            return i.guid === idPostCreateAfter;
          }) + 1);
        } else {
          itemList = [].concat(posts, [newPost]);
        }
      }
      dispatch(function (prevState) {
        return _extends({}, prevState, {
          posts: itemList,
          pendingOnChangePosts: true
        });
      });
      setPostGuidEdit(newPost.guid);
      if (newPost.guid)
        // hacer scroll hacia el nuevo elemento
        setTimeout(function () {
          return onSCrollPost(newPost.guid);
        }, 100);
    }
  }
  function showButtonUndo(postDelete) {
    var posts = state.posts;
    // == Primero guardo donde debe de ir el elemento cuando le de a deshacer
    var index = posts.findIndex(function (postState) {
      return postDelete.guid === postState.guid;
    });
    var paramsCreatePost = null;
    if (index > 0) {
      // == Si es mayor que 0 tiene un elemento previo, miro la id de elemento previo para cuando le de a deshacer crearlo despues de dicho elemento
      var elementAfter = posts[index - 1];
      if (elementAfter) {
        paramsCreatePost = {
          idPostCreateAfter: elementAfter.guid
        };
      }
    } else {
      // Si el indice 0 el elemento es el primero de la lista, si deshacemos hay que situarlo de nuevo en el top de la lista
      paramsCreatePost = {
        createPostTop: true
      };
    }
    // == Muestro el toast
    var idToast = null;
    if (toastRef && toastRef.current) {
      // @ts-ignore
      toastRef.current.showToastTextButton({
        text: t('Removed post'),
        textButton: t('Undo'),
        handleAction: function handleAction() {
          // == Cuando pulse en deshacer vuelvo a poner el elemento donde estaba
          addPostByParam(postDelete, paramsCreatePost);
          // @ts-ignore
          if (idToast) toastRef.current.removeToast(idToast);
        },
        setToastId: function setToastId(id) {
          idToast = id;
        }
      });
    }
  }
  function _onDeletePost(post, callButtonUndo) {
    if (callButtonUndo === void 0) {
      callButtonUndo = false;
    }
    callButtonUndo && showButtonUndo(post);
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        posts: prevState.posts.filter(function (postState) {
          return post.guid !== postState.guid;
        }),
        pendingOnChangePosts: true
      });
    });
  }
  function onDeleteLayoutPost(post) {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        confirmDialog: {
          isVisible: true,
          title: t('editor:delete_layout_confirmation_title'),
          message: t('editor:delete_layout_confirmation_message'),
          confirmText: t('editor:delete_layout_confirmation_button'),
          cancelText: t('editor:Cancel'),
          onConfirm: function onConfirm() {
            var emptyPost = IPostUtils.emptyPost(version);
            dispatch(function (prevState) {
              return _extends({}, prevState, {
                posts: prevState.posts.map(function (postState) {
                  return postState.guid === post.guid ? emptyPost : postState;
                }),
                pendingOnChangePosts: true,
                confirmDialog: {
                  isVisible: false
                }
              });
            });
          }
        }
      });
    });
  }
  function onShowAudiosMenu(post) {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        sidebarAudiosPost: {
          menuVisible: true,
          postGuid: post.guid,
          onChangePost: onChangePost
        }
      });
    });
  }
  function onShowRowMenu(layoutGuid, rowGuid) {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        sidebarEditPostRow: {
          menuVisible: true,
          layoutGuid: layoutGuid,
          rowGuid: rowGuid,
          onChangePostRow: onChangePostRow
        }
      });
    });
  }
  function onEditLayoutPost(post) {
    dispatch(function (prevState) {
      var _post$layout$guid, _post$layout3;
      return _extends({}, prevState, {
        sidebarEditPostLayout: {
          menuVisible: true,
          layoutGuid: (_post$layout$guid = (_post$layout3 = post.layout) == null ? void 0 : _post$layout3.guid) != null ? _post$layout$guid : null,
          onChangePostLayout: onChangePostLayout
        }
      });
    });
  }
  function onShowPopupEditorFullscreen(itemBlockPopup, _onChangeItemBlockPopup) {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        sidebarPopupEditorFullscreen: _extends({}, prevState.sidebarPopupEditorFullscreen, {
          menuVisible: true,
          itemBlockPopup: itemBlockPopup,
          onChangeItemBlockPopup: function onChangeItemBlockPopup(newItemBlockPopup) {
            // Actualizamos el estado interno
            dispatch(function (prevState) {
              return _extends({}, prevState, {
                sidebarPopupEditorFullscreen: _extends({}, prevState.sidebarPopupEditorFullscreen, {
                  itemBlockPopup: newItemBlockPopup
                })
              });
            });
            // Llamamos al callback original
            _onChangeItemBlockPopup(newItemBlockPopup);
          }
        })
      });
    });
  }
  function canMoveDuplicateDeletePost() {
    var canMoveDuplicateDeletePost = false;
    if (isSinglePost) {
      if (state.posts.length > 1) {
        // == Dejo editar porque hay mas de un post
        canMoveDuplicateDeletePost = true;
      } else {
        // == No dejo editar porque hay un solo post
        canMoveDuplicateDeletePost = false;
      }
    } else canMoveDuplicateDeletePost = true;
    return canMoveDuplicateDeletePost;
  }
  function getLayoutByGuid(layoutGuid) {
    // Buscamos en todos los posts el layout que coincida con el guid
    for (var _iterator = _createForOfIteratorHelperLoose(state.posts), _step; !(_step = _iterator()).done;) {
      var _post$layout4;
      var post = _step.value;
      if (((_post$layout4 = post.layout) == null ? void 0 : _post$layout4.guid) === layoutGuid) {
        return post.layout;
      }
    }
    return undefined;
  }
  function getRowByGuid(rowGuid) {
    // Buscar en todos los posts
    for (var _iterator2 = _createForOfIteratorHelperLoose(state.posts), _step2; !(_step2 = _iterator2()).done;) {
      var post = _step2.value;
      if (post.layout) {
        // Buscar en las filas del layout
        var row = post.layout.rows.find(function (row) {
          return row.guid === rowGuid;
        });
        if (row) return row;
      }
    }
    return undefined;
  }
  function canSeePostLayoutOptions() {
    return state.itemBlocksShowingOptions.length === 0 && state.rowsShowingOptions.length === 0;
  }
  function onChangeShowOptionsItemBlockColumn(show, itemBlock, layoutPosition) {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        itemBlocksShowingOptions: show ? [].concat(prevState.itemBlocksShowingOptions, [{
          itemBlockId: itemBlock.id,
          layoutPosition: layoutPosition
        }]) : prevState.itemBlocksShowingOptions.filter(function (item) {
          return item.itemBlockId !== itemBlock.id;
        })
      });
    });
  }
  function onChangeShowOptionsRow(show, row, layoutGuid) {
    dispatch(function (prevState) {
      return _extends({}, prevState, {
        rowsShowingOptions: show ? [].concat(prevState.rowsShowingOptions, [{
          rowGuid: row.guid,
          layoutGuid: layoutGuid
        }]) : prevState.rowsShowingOptions.filter(function (item) {
          return item.rowGuid !== row.guid;
        })
      });
    });
  }
  function getItemBlockById(id) {
    var post = state.posts.find(function (post) {
      return post.items.find(function (item) {
        return item.id === id;
      });
    });
    var itemBlock = post == null ? void 0 : post.items.find(function (item) {
      return item.id === id;
    });
    return itemBlock;
  }
  return {
    t: t,
    isEmptyPosts: isEmpty(),
    onAddClick: onAddClick,
    posts: state.posts,
    onChangePost: onChangePost,
    sidebarEditItem: {
      isVisible: ((_state$sidebarEditIte = state.sidebarEditItem) == null ? void 0 : _state$sidebarEditIte.menuVisible) && ((_state$sidebarEditIte2 = state.sidebarEditItem) == null ? void 0 : _state$sidebarEditIte2.item) !== null,
      item: getItemBlockById((_state$sidebarEditIte3 = state.sidebarEditItem) == null || (_state$sidebarEditIte3 = _state$sidebarEditIte3.item) == null ? void 0 : _state$sidebarEditIte3.id) || ((_state$sidebarEditIte4 = state.sidebarEditItem) == null ? void 0 : _state$sidebarEditIte4.item),
      mode: (_state$sidebarEditIte5 = state.sidebarEditItem) != null && _state$sidebarEditIte5.isMenuSettings ? IModesItemBlock.MODE_EDITOR_SETTINGS_SIDEBAR : IModesItemBlock.MODE_EDITOR_FLOATING_SIDEBAR,
      onClose: closeSidebarEditItem,
      onChangeItem: state.sidebarEditItem.onChangeItem,
      onDeleteItem: state.sidebarEditItem.onDeleteItem,
      layoutPosition: state.sidebarEditItem.layoutPosition,
      layout: state.sidebarEditItem.layoutGuid ? getLayoutByGuid(state.sidebarEditItem.layoutGuid) : undefined,
      onChangeLayout: state.sidebarEditItem.onChangeLayout
    },
    sidebarCreateItem: {
      isOpen: ((_state$sidebarCreateI = state.sidebarCreateItem) == null ? void 0 : _state$sidebarCreateI.isOpen) && !((_state$sidebarEditIte6 = state.sidebarEditItem) != null && _state$sidebarEditIte6.menuVisible),
      close: (_state$sidebarCreateI2 = state.sidebarCreateItem) == null ? void 0 : _state$sidebarCreateI2.close,
      blockList: (_state$sidebarCreateI3 = state.sidebarCreateItem) == null ? void 0 : _state$sidebarCreateI3.blockList,
      onSelect: (_state$sidebarCreateI4 = state.sidebarCreateItem) == null ? void 0 : _state$sidebarCreateI4.onSelect,
      onClickNewTemplateBlock: function onClickNewTemplateBlock() {
        return console.log('TODO:');
      },
      title: (_state$sidebarCreateI5 = state.sidebarCreateItem) == null ? void 0 : _state$sidebarCreateI5.title,
      hideEdpuzzle: (_state$sidebarCreateI6 = state.sidebarCreateItem) == null ? void 0 : _state$sidebarCreateI6.hideEdpuzzle,
      hideGenially: (_state$sidebarCreateI7 = state.sidebarCreateItem) == null ? void 0 : _state$sidebarCreateI7.hideGenially,
      hideActivity: (_state$sidebarCreateI8 = state.sidebarCreateItem) == null ? void 0 : _state$sidebarCreateI8.hideActivity,
      hideFeedbackActivity: (_state$sidebarCreateI9 = state.sidebarCreateItem) == null ? void 0 : _state$sidebarCreateI9.hideFeedbackActivity
    },
    sidebarAudiosPost: {
      isVisible: ((_state$sidebarAudiosP = state.sidebarAudiosPost) == null ? void 0 : _state$sidebarAudiosP.menuVisible) && ((_state$sidebarAudiosP2 = state.sidebarAudiosPost) == null ? void 0 : _state$sidebarAudiosP2.postGuid) !== undefined,
      postGuid: (_state$sidebarAudiosP3 = state.sidebarAudiosPost) == null ? void 0 : _state$sidebarAudiosP3.postGuid,
      onClose: closeSidebarAudiosPost,
      onChangePost: state.sidebarAudiosPost.onChangePost
    },
    sidebarEditPostRow: {
      isVisible: ((_state$sidebarEditPos = state.sidebarEditPostRow) == null ? void 0 : _state$sidebarEditPos.menuVisible) && ((_state$sidebarEditPos2 = state.sidebarEditPostRow) == null ? void 0 : _state$sidebarEditPos2.rowGuid) !== undefined,
      layoutGuid: (_state$sidebarEditPos3 = state.sidebarEditPostRow) == null ? void 0 : _state$sidebarEditPos3.layoutGuid,
      rowGuid: (_state$sidebarEditPos4 = state.sidebarEditPostRow) == null ? void 0 : _state$sidebarEditPos4.rowGuid,
      onClose: closeSidebarEditPostRow,
      onChangePostRow: state.sidebarEditPostRow.onChangePostRow
    },
    sidebarEditPostLayout: {
      isVisible: ((_state$sidebarEditPos5 = state.sidebarEditPostLayout) == null ? void 0 : _state$sidebarEditPos5.menuVisible) && ((_state$sidebarEditPos6 = state.sidebarEditPostLayout) == null ? void 0 : _state$sidebarEditPos6.layoutGuid) !== undefined,
      layoutGuid: (_state$sidebarEditPos7 = state.sidebarEditPostLayout) == null ? void 0 : _state$sidebarEditPos7.layoutGuid,
      onClose: closeSidebarEditPostLayout,
      onChangePostLayout: state.sidebarEditPostLayout.onChangePostLayout
    },
    sidebarPopupEditorFullscreen: {
      isVisible: ((_state$sidebarPopupEd = state.sidebarPopupEditorFullscreen) == null ? void 0 : _state$sidebarPopupEd.menuVisible) && ((_state$sidebarPopupEd2 = state.sidebarPopupEditorFullscreen) == null ? void 0 : _state$sidebarPopupEd2.itemBlockPopup) !== null,
      itemBlockPopup: (_state$sidebarPopupEd3 = state.sidebarPopupEditorFullscreen) == null ? void 0 : _state$sidebarPopupEd3.itemBlockPopup,
      onClose: closeSidebarPopupEditorFullscreen,
      onChangeItemBlockPopup: state.sidebarPopupEditorFullscreen.onChangeItemBlockPopup
    },
    sidebarSettingsActivity: {
      isVisible: ((_state$sidebarSetting = state.sidebarSettingsActivity) == null ? void 0 : _state$sidebarSetting.menuVisible) && ((_state$sidebarSetting2 = state.sidebarSettingsActivity) == null ? void 0 : _state$sidebarSetting2.item) !== null,
      item: (_state$sidebarSetting3 = state.sidebarSettingsActivity) == null ? void 0 : _state$sidebarSetting3.item,
      onChangeItem: (_state$sidebarSetting4 = state.sidebarSettingsActivity) == null ? void 0 : _state$sidebarSetting4.onChangeItem,
      layoutPosition: (_state$sidebarSetting5 = state.sidebarSettingsActivity) == null ? void 0 : _state$sidebarSetting5.layoutPosition,
      layoutGuid: (_state$sidebarSetting6 = state.sidebarSettingsActivity) == null ? void 0 : _state$sidebarSetting6.layoutGuid,
      onClose: closeSidebarSettingsActivity
    },
    customEditor: {
      isVisible: ((_state$customEditor = state.customEditor) == null ? void 0 : _state$customEditor.isVisible) && ((_state$customEditor2 = state.customEditor) == null ? void 0 : _state$customEditor2.item) !== null,
      item: (_state$customEditor3 = state.customEditor) == null ? void 0 : _state$customEditor3.item,
      onClose: closeCustomEditor,
      onChangeItem: state.customEditor.onChangeItem,
      onDeleteItem: state.customEditor.onDeleteItem
    },
    onSCrollItem: onSCrollItem,
    onSCrollPost: onSCrollPost,
    openSidebarEditItem: openSidebarEditItem,
    openCustomEditor: openCustomEditor,
    closeSidebarEditItem: closeSidebarEditItem,
    openSidebarCreateItem: openSidebarCreateItem,
    closeSidebarCreateItem: closeSidebarCreateItem,
    isShowButtonOpenEditionPost: isShowButtonOpenEditionPost,
    isShowButtonCloseEditionPost: isShowButtonCloseEditionPost,
    onOpenEditionPost: onOpenEditionPost,
    onCloseEditionPost: onCloseEditionPost,
    isModePostEditor: isModePostEditor,
    isShowButtonAddPost: isShowButtonAddPost,
    onUpPost: onUpPost,
    onDownPost: onDownPost,
    onDuplicatePost: onDuplicatePost,
    onDeletePost: function onDeletePost(post) {
      return _onDeletePost(post, true);
    },
    onChangePdfPages: onChangePdfPages,
    onShowAudiosMenu: onShowAudiosMenu,
    onShowRowMenu: onShowRowMenu,
    onEditLayoutPost: onEditLayoutPost,
    onSettingsActivity: onSettingsActivity,
    onShowPopupEditorFullscreen: onShowPopupEditorFullscreen,
    toastRef: toastRef,
    sidebarAudiosPostPost: state.sidebarAudiosPost.postGuid && state.posts.find(function (post) {
      return post.guid === state.sidebarAudiosPost.postGuid;
    }) ? state.posts.find(function (post) {
      return post.guid === state.sidebarAudiosPost.postGuid;
    }) : undefined,
    shouldShowWarning: isSinglePost && state.posts.length > 1,
    canMoveDuplicateDeletePost: canMoveDuplicateDeletePost(),
    getRowByGuid: getRowByGuid,
    getLayoutByGuid: getLayoutByGuid,
    backgroundVisor: backgroundVisor,
    openSidebarGeneric: openSidebarGeneric,
    closeSidebarGeneric: closeSidebarGeneric,
    onDeleteLayoutPost: onDeleteLayoutPost,
    confirmDialog: state.confirmDialog,
    closeConfirmDialog: function closeConfirmDialog() {
      return dispatch(function (prevState) {
        return _extends({}, prevState, {
          confirmDialog: {
            isVisible: false
          }
        });
      });
    },
    onChangeShowOptionsItemBlockColumn: onChangeShowOptionsItemBlockColumn,
    canShowPostLayoutOptions: canSeePostLayoutOptions(),
    onChangeShowOptionsRow: onChangeShowOptionsRow,
    uiStyles: uiStyles
  };
}

function useWrapperPostLayoutOptions(props) {
  var canShowControls = props.canShowControls;
  var _useState = useState(false),
    controls = _useState[0],
    showControls = _useState[1];
  useEffect(function () {
    if (canShowControls !== undefined && canShowControls === false && controls === true) {
      showControls(false);
    }
  }, [canShowControls]);
  // Manejadores de eventos para MouseEnter, MouseLeave y MouseOver
  var handleMouseEnter = function handleMouseEnter(event) {
    showControlsIfAllowed(true);
  };
  var handleMouseLeave = function handleMouseLeave(event) {
    showControlsIfAllowed(false);
  };
  var handleMouseOver = function handleMouseOver(event) {
    showControlsIfAllowed(true);
  };
  var showControlsIfAllowed = function showControlsIfAllowed(show) {
    if (canShowControls !== undefined && canShowControls === true && show === true) {
      showControls(true);
    } else {
      showControls(false);
    }
  };
  return {
    controls: controls,
    handleMouseEnter: handleMouseEnter,
    handleMouseLeave: handleMouseLeave,
    handleMouseOver: handleMouseOver
  };
}

function WrapperPostLayoutOptions(props) {
  var children = props.children,
    onDelete = props.onDelete,
    onEdit = props.onEdit;
  var _useWrapperPostLayout = useWrapperPostLayoutOptions(props),
    controls = _useWrapperPostLayout.controls,
    handleMouseEnter = _useWrapperPostLayout.handleMouseEnter,
    handleMouseLeave = _useWrapperPostLayout.handleMouseLeave,
    handleMouseOver = _useWrapperPostLayout.handleMouseOver;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'wrapper-post-layout-options'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "item-block-editor " + (controls ? 'wrapper-post-layout-options--active' : ''),
    onMouseLeave: handleMouseLeave,
    onMouseEnter: handleMouseEnter,
    onMouseOver: handleMouseOver
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "item-block-editor__controls-wrapper " + (controls ? 'item-block-editor__controls-wrapper--show' : ''),
    style: {
      justifyContent: 'right',
      gap: '16px',
      top: '-44px',
      right: '-50px'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'item-block-editor__left-controls'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: 'item-block-editor__right-controls'
  }, /*#__PURE__*/React__default.createElement(EditOptions, {
    onEdit: onEdit,
    onDelete: onDelete,
    isSecondary: true
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: 'wrapper-post-layout-options__content'
  }, children)));
}

function WrapperPostOptions(_ref) {
  var children = _ref.children,
    onUp = _ref.onUp,
    onDown = _ref.onDown,
    onDuplicate = _ref.onDuplicate,
    onDelete = _ref.onDelete,
    onAudios = _ref.onAudios,
    _ref$enablePostOption = _ref.enablePostOptions,
    enablePostOptions = _ref$enablePostOption === void 0 ? true : _ref$enablePostOption,
    pdfPages = _ref.pdfPages,
    onChangePdfPages = _ref.onChangePdfPages,
    onDeleteLayout = _ref.onDeleteLayout,
    onEditLayout = _ref.onEditLayout,
    canShowPostLayoutOptions = _ref.canShowPostLayoutOptions,
    enableRowColumnLayout = _ref.enableRowColumnLayout;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'wrapper-post-editor'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "wrapper-post-editor__controls-wrapper wrapper-post-editor__controls-wrapper--show"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'wrapper-post-editor__left-controls'
  }, enablePostOptions && /*#__PURE__*/React__default.createElement(EditOptions, {
    onUp: onUp,
    onDown: onDown,
    onDuplicate: onDuplicate,
    onDelete: onDelete,
    onAudios: onAudios,
    isSecondary: false,
    pdfPages: pdfPages,
    onChangePdfPages: onChangePdfPages
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'wrapper-post-editor__right-controls'
  })), enableRowColumnLayout && /*#__PURE__*/React__default.createElement(WrapperPostLayoutOptions, {
    onDelete: onDeleteLayout,
    onEdit: onEditLayout,
    canShowControls: canShowPostLayoutOptions
  }, children), !enableRowColumnLayout && children);
}

function WrapperPostModesLessonEditor(props) {
  var showButtonOpenEdition = props.showButtonOpenEdition,
    showButtonCloseEdition = props.showButtonCloseEdition,
    onOpenEdition = props.onOpenEdition,
    onCloseEdition = props.onCloseEdition,
    isModePostEditor = props.isModePostEditor,
    componentPostEditor = props.componentPostEditor,
    componentPost = props.componentPost,
    _props$enablePostOpti = props.enablePostOptions,
    enablePostOptions = _props$enablePostOpti === void 0 ? true : _props$enablePostOpti,
    pdfPages = props.pdfPages,
    onChangePdfPages = props.onChangePdfPages,
    onUp = props.onUp,
    onDown = props.onDown,
    onDuplicate = props.onDuplicate,
    onDelete = props.onDelete,
    onAudios = props.onAudios,
    onDeleteLayout = props.onDeleteLayout,
    onEditLayout = props.onEditLayout,
    canShowPostLayoutOptions = props.canShowPostLayoutOptions;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    enableRowColumnLayout = _useGeneral.enableRowColumnLayout;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-wrapper-post'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-wrapper-post__buttons'
  }, showButtonOpenEdition && /*#__PURE__*/React__default.createElement(Button, {
    onClick: onOpenEdition
  }, t('editor:button_edit_post')), showButtonCloseEdition && /*#__PURE__*/React__default.createElement(Button, {
    onClick: onCloseEdition
  }, t('editor:button_close_edit_post'))), isModePostEditor ? /*#__PURE__*/React__default.createElement(WrapperPostOptions, {
    onUp: onUp,
    onDown: onDown,
    onDuplicate: onDuplicate,
    onDelete: onDelete,
    onAudios: onAudios,
    enablePostOptions: enablePostOptions,
    pdfPages: pdfPages,
    onChangePdfPages: onChangePdfPages,
    onDeleteLayout: onDeleteLayout,
    onEditLayout: onEditLayout,
    canShowPostLayoutOptions: canShowPostLayoutOptions,
    enableRowColumnLayout: enableRowColumnLayout
  }, componentPostEditor) : componentPost);
}

var SinglePostWarning = function SinglePostWarning() {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-warning',
    style: {
      padding: '1rem',
      margin: '1rem 5%',
      backgroundColor: '#fff3cd',
      border: '1px solid #ffeeba',
      borderRadius: '8px'
    }
  }, /*#__PURE__*/React__default.createElement("p", null, t('warning_single_post_mode', {
    ns: 'editor'
  })));
};

function useRowPostSidebar(props) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    enableBackgroundGradient = _useGeneral.enableBackgroundGradient;
  var _useState = useState({});
  return {
    t: t,
    enableBackgroundGradient: enableBackgroundGradient
  };
}

var RowPostSidebar = function RowPostSidebar(props) {
  var _layout$config14, _row$config6, _row$config7, _row$config8, _row$config9, _layout$config15;
  var visible = props.visible,
    onClose = props.onClose,
    layout = props.layout,
    row = props.row,
    onChangePostRow = props.onChangePostRow;
  var _useRowPostSidebar = useRowPostSidebar(),
    t = _useRowPostSidebar.t,
    enableBackgroundGradient = _useRowPostSidebar.enableBackgroundGradient;
  var layoutGuid = layout.guid;
  var breakpointOptions = [{
    value: BREAKPOINT_SMALL,
    name: t('editor:row_settings_breakpoint_small')
  }, {
    value: BREAKPOINT_DEFAULT,
    name: t('editor:row_settings_breakpoint_medium')
  }, {
    value: BREAKPOINT_LARGE,
    name: t('editor:row_settings_breakpoint_large')
  }];
  var alignHorizontalOptions = [{
    value: 'left',
    name: t('editor:row_settings_align_left')
  }, {
    value: 'center',
    name: t('editor:row_settings_align_center')
  }, {
    value: 'right',
    name: t('editor:row_settings_align_right')
  }, {
    value: 'space-between',
    name: t('editor:row_settings_align_space_between')
  }, {
    value: 'space-around',
    name: t('editor:row_settings_align_space_around')
  }];
  var alignVerticalOptions = [{
    value: 'top',
    name: t('editor:row_settings_align_top')
  }, {
    value: 'center',
    name: t('editor:row_settings_align_center')
  }, {
    value: 'bottom',
    name: t('editor:row_settings_align_bottom')
  }, {
    value: 'stretch',
    name: t('editor:row_settings_align_stretch')
  }];
  var paddingOptions = [{
    value: '',
    name: t('editor:row_settings_padding_not_set')
  },
  //{ value: 'none', name: t('editor:row_settings_padding_none') }, // Quito por ahora esta opcion, esta es la opcion en la que el usuario ha indicado explicitamente que no quiere margen, y en el config se guardara config.paddingXXXX = 'none' en este caso si el layout tuviera un valor heradado de margen, no se aplicaria porque ya se le ha dicho explicitamente que no quiere margen.
  {
    value: '10px',
    name: '10px'
  }, {
    value: '20px',
    name: '20px'
  }, {
    value: '30px',
    name: '30px'
  }, {
    value: '40px',
    name: '40px'
  }, {
    value: '50px',
    name: '50px'
  }, {
    value: '60px',
    name: '60px'
  }, {
    value: '70px',
    name: '70px'
  }, {
    value: '80px',
    name: '80px'
  }, {
    value: '90px',
    name: '90px'
  }, {
    value: '100px',
    name: '100px'
  }];
  var handleChange = function handleChange(changes) {
    if ('width' in changes) {
      var newConfig = _extends({}, row.config);
      if (changes.width === '' || changes.width === 'default-row-width-layout') {
        delete newConfig.width;
      } else {
        newConfig.width = changes.width;
      }
      onChangePostRow(_extends({}, row, {
        config: newConfig
      }), layoutGuid);
      return;
    }
    if ('gap' in changes) {
      var _newConfig = _extends({}, row.config);
      if (changes.gap === '' || changes.gap === 'default-row-gap-layout') {
        delete _newConfig.gap;
      } else {
        _newConfig.gap = changes.gap;
      }
      onChangePostRow(_extends({}, row, {
        config: _newConfig
      }), layoutGuid);
      return;
    }
    if ('background' in changes) {
      var _newConfig2 = _extends({}, row.config);
      if (changes.background === '' || changes.background === 'default-row-background-layout') {
        delete _newConfig2.background;
      } else {
        _newConfig2.background = changes.background;
      }
      onChangePostRow(_extends({}, row, {
        config: _newConfig2
      }), layoutGuid);
      return;
    }
    if ('alignHorizontal' in changes) {
      var _newConfig3 = _extends({}, row.config);
      if (changes.alignHorizontal === '' || changes.alignHorizontal === 'default-row-horizontal-layout') {
        delete _newConfig3.alignHorizontal;
      } else {
        _newConfig3.alignHorizontal = changes.alignHorizontal;
      }
      onChangePostRow(_extends({}, row, {
        config: _newConfig3
      }), layoutGuid);
      return;
    }
    if ('alignVertical' in changes) {
      var _newConfig4 = _extends({}, row.config);
      if (changes.alignVertical === '' || changes.alignVertical === 'default-row-vertical-layout') {
        delete _newConfig4.alignVertical;
      } else {
        _newConfig4.alignVertical = changes.alignVertical;
      }
      onChangePostRow(_extends({}, row, {
        config: _newConfig4
      }), layoutGuid);
      return;
    }
    if ('paddingTop' in changes) {
      var _newConfig5 = _extends({}, row.config);
      var paddingValue = changes.paddingTop;
      if (paddingValue === PADDING_LAYOUT_VALUE_NOT_SET) {
        delete _newConfig5.paddingTop;
      } else {
        _newConfig5.paddingTop = paddingValue;
      }
      onChangePostRow(_extends({}, row, {
        config: _newConfig5
      }), layoutGuid);
      return;
    }
    if ('paddingBottom' in changes) {
      var _newConfig6 = _extends({}, row.config);
      var _paddingValue = changes.paddingBottom;
      if (_paddingValue === PADDING_LAYOUT_VALUE_NOT_SET) {
        delete _newConfig6.paddingBottom;
      } else {
        _newConfig6.paddingBottom = _paddingValue;
      }
      onChangePostRow(_extends({}, row, {
        config: _newConfig6
      }), layoutGuid);
      return;
    }
    if ('paddingLeft' in changes) {
      var _newConfig7 = _extends({}, row.config);
      var _paddingValue2 = changes.paddingLeft;
      if (_paddingValue2 === PADDING_LAYOUT_VALUE_NOT_SET) {
        delete _newConfig7.paddingLeft;
      } else {
        _newConfig7.paddingLeft = _paddingValue2;
      }
      onChangePostRow(_extends({}, row, {
        config: _newConfig7
      }), layoutGuid);
      return;
    }
    if ('paddingRight' in changes) {
      var _newConfig8 = _extends({}, row.config);
      var _paddingValue3 = changes.paddingRight;
      if (_paddingValue3 === PADDING_LAYOUT_VALUE_NOT_SET) {
        delete _newConfig8.paddingRight;
      } else {
        _newConfig8.paddingRight = _paddingValue3;
      }
      onChangePostRow(_extends({}, row, {
        config: _newConfig8
      }), layoutGuid);
      return;
    }
    onChangePostRow(_extends({}, row, {
      config: _extends({}, row.config, changes)
    }), layoutGuid);
  };
  var getSelectedWidth = function getSelectedWidth() {
    var _row$config, _layout$config5;
    if ((_row$config = row.config) != null && _row$config.width) {
      return row.config.width;
    }
    if (layout != null && (_layout$config5 = layout.config) != null && _layout$config5.defaultRowWidth) {
      return 'default-row-width-layout';
    }
    return '';
  };
  var getSelectedBackground = function getSelectedBackground() {
    var _row$config5, _layout$config13;
    if ((_row$config5 = row.config) != null && _row$config5.background) {
      return row.config.background;
    }
    if (layout != null && (_layout$config13 = layout.config) != null && _layout$config13.defaultRowBackground) {
      return 'default-row-background-layout';
    }
    return '';
  };
  return /*#__PURE__*/React__default.createElement(FloatingSidebar, {
    title: t('editor:row_settings_title'),
    visible: visible,
    onClose: onClose,
    container: 'mint-lesson'
  }, /*#__PURE__*/React__default.createElement(TabsModelA, {
    titleTabsList: [t('editor:row_settings_settings_tab')],
    classNameAdd: 'tabs-sidebar mint-row-post-sidebar'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'tab-settings-sidebar'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'tab-settings-sidebar__content mint-tab-content-settings-sidebar'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'tab-settings-sidebar__content--full-width'
  }, /*#__PURE__*/React__default.createElement(SettingWidth, {
    label: t('editor:row_settings_width'),
    width: getSelectedWidth(),
    onChange: function onChange(value) {
      return handleChange({
        width: value
      });
    },
    defaultWidth: layout == null || (_layout$config14 = layout.config) == null ? void 0 : _layout$config14.defaultRowWidth,
    showInheritOption: true
  })), /*#__PURE__*/React__default.createElement(SettingLayoutPadding, {
    label: t('editor:row_settings_padding_top'),
    valueSelected: ((_row$config6 = row.config) == null ? void 0 : _row$config6.paddingTop) || '',
    onChange: function onChange(value) {
      return handleChange({
        paddingTop: value
      });
    }
  }), /*#__PURE__*/React__default.createElement(SettingLayoutPadding, {
    label: t('editor:row_settings_padding_bottom'),
    valueSelected: ((_row$config7 = row.config) == null ? void 0 : _row$config7.paddingBottom) || '',
    onChange: function onChange(value) {
      return handleChange({
        paddingBottom: value
      });
    }
  }), /*#__PURE__*/React__default.createElement(SettingLayoutPadding, {
    label: t('editor:row_settings_padding_left'),
    valueSelected: ((_row$config8 = row.config) == null ? void 0 : _row$config8.paddingLeft) || '',
    onChange: function onChange(value) {
      return handleChange({
        paddingLeft: value
      });
    }
  }), /*#__PURE__*/React__default.createElement(SettingLayoutPadding, {
    label: t('editor:row_settings_padding_right'),
    valueSelected: ((_row$config9 = row.config) == null ? void 0 : _row$config9.paddingRight) || '',
    onChange: function onChange(value) {
      return handleChange({
        paddingRight: value
      });
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-control'
  }, /*#__PURE__*/React__default.createElement(SettingBackgroundColor, {
    background: getSelectedBackground(),
    onChange: function onChange(value) {
      return handleChange({
        background: value
      });
    },
    defaultBackground: layout == null || (_layout$config15 = layout.config) == null ? void 0 : _layout$config15.defaultRowBackground,
    showInheritOption: true,
    enableBackgroundGradient: enableBackgroundGradient
  }))))));
};

var AsideMenuButton = function AsideMenuButton(props) {
  var children = props.children,
    _props$modifier = props.modifier,
    modifier = _props$modifier === void 0 ? 'primary' : _props$modifier,
    _props$selected = props.selected,
    selected = _props$selected === void 0 ? false : _props$selected;
  var childProps = _extends({}, props);
  delete childProps.translate;
  return /*#__PURE__*/React__default.createElement("button", _extends({
    className: "aside-menu-button aside-menu-button--" + modifier + " " + (selected && 'selected')
  }, childProps), /*#__PURE__*/React__default.createElement("div", {
    className: "aside-menu-button__selected"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "aside-menu-button__content"
  }, children));
};

var _path$$, _path2$j;
function _extends$1n() { _extends$1n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1n.apply(this, arguments); }
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/createElement("svg", _extends$1n({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24
  }, props), _path$$ || (_path$$ = /*#__PURE__*/createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2$j || (_path2$j = /*#__PURE__*/createElement("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
  })));
};

var _path$10, _path2$k;
function _extends$1o() { _extends$1o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1o.apply(this, arguments); }
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/createElement("svg", _extends$1o({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24
  }, props), _path$10 || (_path$10 = /*#__PURE__*/createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2$k || (_path2$k = /*#__PURE__*/createElement("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
  })));
};

var _image;
function _extends$1p() { _extends$1p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1p.apply(this, arguments); }
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/createElement("svg", _extends$1p({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    width: 10,
    height: 5,
    viewBox: "0 0 10 5"
  }, props), _image || (_image = /*#__PURE__*/createElement("image", {
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAFBAMAAACOSmBbAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAElBMVEUAAABFaDBFaDBFaDBFaDAAAACyGpInAAAABHRSTlMAiJcBFbIA6QAAAAFiS0dEAIgFHUgAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAiSURBVAjXYxBxcXFxYmAEksoMDCIuTgYMQA6QycAgZMAAAEEoA4dK9iYLAAAAAElFTkSuQmCC",
    width: 10,
    height: 5
  })));
};

var FilterDropdown = /*#__PURE__*/function (_Component) {
  function FilterDropdown(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.state = {
      listOpen: false,
      headerTitle: _this.props.title
    };
    _this.closeMenu = _this.closeMenu.bind(_this);
    return _this;
  }
  _inheritsLoose(FilterDropdown, _Component);
  var _proto = FilterDropdown.prototype;
  _proto.toggleList = function toggleList() {
    var _this2 = this;
    this.setState(function (prevState) {
      return {
        listOpen: !prevState.listOpen
      };
    }, function () {
      document.addEventListener('click', _this2.closeMenu);
    });
  };
  _proto.selectOption = function selectOption(title, key) {
    this.setState(function (prevState) {
      return {
        listOpen: !prevState.listOpen
      };
    });
    this.setState({
      headerTitle: title
    });
    this.props.onChange && this.props.onChange(key);
  };
  _proto.closeMenu = function closeMenu() {
    var _this3 = this;
    this.setState({
      listOpen: false
    }, function () {
      document.removeEventListener('click', _this3.closeMenu);
    });
  };
  _proto.render = function render() {
    var _this4 = this;
    var list = this.props.list;
    var _this$state = this.state,
      listOpen = _this$state.listOpen,
      headerTitle = _this$state.headerTitle;
    return /*#__PURE__*/React__default.createElement("div", {
      className: "filter-dd-wrapper"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "filter-dd-header",
      onClick: function onClick() {
        return _this4.toggleList();
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "filter-dd-header-title"
    }, headerTitle, /*#__PURE__*/React__default.createElement(SvgArrowDown, null))), /*#__PURE__*/React__default.createElement("ul", {
      className: "filter-dd-list",
      style: {
        display: listOpen ? 'block' : 'none'
      }
    }, list.map(function (item) {
      return /*#__PURE__*/React__default.createElement("li", {
        className: "filter-dd-list-item",
        key: item.id,
        onClick: function onClick() {
          return _this4.selectOption(item.title, item.key);
        }
      }, item.icon && /*#__PURE__*/React__default.createElement("img", {
        src: item.icon
      }), item.title);
    })));
  };
  return FilterDropdown;
}(Component);
FilterDropdown.propTypes = {
  title: PropTypes.string,
  onChange: PropTypes.func,
  list: PropTypes.array
};

var _g$n, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends$1q() { _extends$1q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1q.apply(this, arguments); }
var Svg013Search = function Svg013Search(props) {
  return /*#__PURE__*/createElement("svg", _extends$1q({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve"
  }, props), _g$n || (_g$n = /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M508.874,478.708L360.142,329.976c28.21-34.827,45.191-79.103,45.191-127.309c0-111.75-90.917-202.667-202.667-202.667    S0,90.917,0,202.667s90.917,202.667,202.667,202.667c48.206,0,92.482-16.982,127.309-45.191l148.732,148.732    c4.167,4.165,10.919,4.165,15.086,0l15.081-15.082C513.04,489.627,513.04,482.873,508.874,478.708z M202.667,362.667    c-88.229,0-160-71.771-160-160s71.771-160,160-160s160,71.771,160,160S290.896,362.667,202.667,362.667z"
  })))), _g2 || (_g2 = /*#__PURE__*/createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/createElement("g", null)));
};

var SearchInput = /*#__PURE__*/function (_Component) {
  function SearchInput(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.handleChange = function (event) {
      _this.props.getValue(event.target.value);
    };
    _this.state = {
      value: ''
    };
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }
  _inheritsLoose(SearchInput, _Component);
  var _proto = SearchInput.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      type = _this$props.type,
      placeholder = _this$props.placeholder,
      text = _this$props.text;
    return /*#__PURE__*/React__default.createElement("div", {
      className: "search-input-wrapper"
    }, /*#__PURE__*/React__default.createElement("input", {
      className: "search-input",
      type: type,
      placeholder: placeholder,
      onChange: this.handleChange,
      defaultValue: text
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "search-input-icon"
    }, /*#__PURE__*/React__default.createElement(Svg013Search, null)));
  };
  return SearchInput;
}(Component);

// TODO: llevarlo a un fichero
var URL_BASE$1 = window.conf && window.conf.URL_BASE || 'http://localhost:8081'; // "https://mint.oneclick.es";
var IMAGES_SRC_URI = URL_BASE$1 + '/mintcontent'; // Rise path change

var Container = /*#__PURE__*/posed.div({
  exit: {
    x: -660,
    transition: {
      duration: 200,
      ease: 'circIn'
    }
  },
  enter: {
    x: 0,
    delayChildren: 150,
    staggerChildren: 50,
    transition: {
      duration: 350,
      ease: 'circOut'
    }
  }
});
var BlockTemplatesMenu = function BlockTemplatesMenu(_ref) {
  var onClickNewTemplateBlock = _ref.onClickNewTemplateBlock,
    onClickTemplateBlock = _ref.onClickTemplateBlock;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var OPTIONS_SORT = {
    RECENT: 'RECENT',
    TITLE: 'TITLE'
  };
  var OPTIONS_AUTHOR = {
    ALL: 'ALL'
  };
  var AUTHOR_OPTION_ALL = {
    id: 0,
    title: t('All Authors'),
    selected: true,
    key: OPTIONS_AUTHOR.ALL
  };
  // const dispatch = useDispatch();
  // const templates = useSelector((state) => getBlockTemplates(state));
  var _useState = useState([]),
    templatesFilter = _useState[0],
    setTemplatesFilter = _useState[1];
  var _useState2 = useState(OPTIONS_AUTHOR.ALL),
    authorFilter = _useState2[0],
    setAuthorFilter = _useState2[1];
  var _useState3 = useState(OPTIONS_SORT.RECENT),
    sortFilter = _useState3[0],
    setSortFilter = _useState3[1];
  var _useState4 = useState(''),
    search = _useState4[0],
    setSearch = _useState4[1];
  var _useState5 = useState([AUTHOR_OPTION_ALL]),
    authorList = _useState5[0];
  var _useState6 = useState({
      isVisible: false,
      template: null
    }),
    setShowPopupEditName = _useState6[1];

  // TODO: QUITADO
  /* 
  useEffect(() => {
    dispatch(sendAction(fetchBlockTemplates(null)));
  }, []); */

  // TODO: QUITADO
  /* useEffect(() => {
    setTemplatesFilter(getTemplatesFilter());
    setAuthorList(getAuthorList());
  }, [templates]); */

  useEffect(function () {
    setTemplatesFilter(getTemplatesFilter());
  }, [search, authorFilter, sortFilter]);
  function getTemplatesFilter() {
    var toRet = [];
    /* if (templates) {
      toRet = templates.filter((template) => canShowTemplate(template));
      // == Lo ordeno
      if (sortFilter === OPTIONS_SORT.RECENT) {
        toRet.sort((a, b) =>
          new Date(a.createdAt).getTime() > new Date(b.createdAt).getTime()
            ? -1
            : new Date(b.createdAt).getTime() > new Date(a.createdAt).getTime()
            ? 1
            : 0
        );
      } else if (sortFilter === OPTIONS_SORT.TITLE) {
        toRet.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true, ignorePunctuation: true }));
      }
    } */
    // TODO: QUITADO
    return toRet;
  }
  function onClickTemplate(template) {
    onClickTemplateBlock && onClickTemplateBlock(template);
  }
  var createTemplateBlock = function createTemplateBlock() {
    onClickNewTemplateBlock && onClickNewTemplateBlock();
  };
  var sortList = [{
    id: 0,
    title: t('More recent'),
    selected: true,
    key: OPTIONS_SORT.RECENT
  }, {
    id: 1,
    title: t('Title'),
    selected: false,
    key: OPTIONS_SORT.TITLE
  }];
  function getSearchValue(value) {
    setSearch(value);
  }
  function onChangeAuthorFilter(key) {
    setAuthorFilter(key);
  }
  function onChangeSortFilter(key) {
    setSortFilter(key);
  }
  function onEdit(e, template) {
    e.stopPropagation();
    e.preventDefault();
    setShowPopupEditName({
      isVisible: true,
      template: template
    });
  }
  function onDelete(e, template) {
    e.stopPropagation();
    e.preventDefault();
    // TODO: QUITADO dispatch(sendAction(deleteBlockTemplates(template.id)));
  }
  return /*#__PURE__*/React__default.createElement(Container, {
    className: "block-templates-menu",
    pose: 'enter'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "block-templates-menu__header"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "block-templates-menu__search-input"
  }, /*#__PURE__*/React__default.createElement(SearchInput, {
    placeholder: t('Search') + '...',
    text: "",
    getValue: getSearchValue
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "block-templates-menu__filter"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "block-templates-menu__filter-label"
  }, t('Author') + ':'), /*#__PURE__*/React__default.createElement("span", {
    className: "block-templates-menu__filter-menu"
  }, /*#__PURE__*/React__default.createElement(FilterDropdown, {
    title: authorList.find(function (element) {
      return element.selected;
    }).title,
    list: authorList,
    onChange: onChangeAuthorFilter
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "block-templates-menu__filter"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "block-templates-menu__filter-label"
  }, t('Sort by') + ':'), /*#__PURE__*/React__default.createElement("span", {
    className: "block-templates-menu__filter-menu"
  }, /*#__PURE__*/React__default.createElement(FilterDropdown, {
    title: sortList.find(function (element) {
      return element.selected;
    }).title,
    list: sortList,
    onChange: onChangeSortFilter
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "block-templates-menu__content"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "block-template-list"
  }, templatesFilter.map(function (template) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "block-template-list__item",
      onClick: function onClick() {
        return onClickTemplate(template);
      },
      key: template.id
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "block-template-list__item-name"
    }, template.name), /*#__PURE__*/React__default.createElement("div", {
      className: "block-template-list__item-image"
    }, /*#__PURE__*/React__default.createElement("img", {
      src: IMAGES_SRC_URI + '/' + template.thumbnailAssetKey,
      alt: template.name
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "block-template-list__actions"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "block-template-list__actions-edit",
      onClick: function onClick(e) {
        return onEdit(e, template);
      }
    }, /*#__PURE__*/React__default.createElement(SvgEdit, null)), /*#__PURE__*/React__default.createElement("div", {
      className: "block-template-list__actions-delete",
      onClick: function onClick(e) {
        return onDelete(e);
      }
    }, /*#__PURE__*/React__default.createElement(SvgDelete, null))));
  }), templatesFilter.length === 0 && /*#__PURE__*/React__default.createElement("div", {
    className: "block-template-menu__no-templates"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "block-template-menu__no-templates-text"
  }, t('There are no template blocks')), /*#__PURE__*/React__default.createElement("div", {
    className: "block-templates-menu__new-button"
  }, /*#__PURE__*/React__default.createElement(Button, {
    onClick: createTemplateBlock
  }, t('New template')))), templatesFilter.length !== 0 && /*#__PURE__*/React__default.createElement("div", {
    className: "block-templates-menu__new-button"
  }, /*#__PURE__*/React__default.createElement(Button, {
    onClick: createTemplateBlock
  }, t('New template'))))));
};

var Container$1 = /*#__PURE__*/posed.div({
  hidden: {
    x: -310,
    transition: {
      duration: 300,
      ease: 'circIn'
    }
  },
  visible: {
    x: 0,
    delayChildren: 150,
    staggerChildren: 50,
    transition: {
      duration: 350,
      ease: 'circOut'
    }
  }
});
var Item = /*#__PURE__*/posed.li({
  hidden: {
    x: -20,
    opacity: 0
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 150,
      type: 'spring',
      stiffness: 200
    }
  }
});
var CollectionsMenu = function CollectionsMenu(_ref) {
  var open = _ref.open,
    closeMenu = _ref.closeMenu,
    title = _ref.title,
    children = _ref.children;
  var _useGeneral = useGeneral();
  return /*#__PURE__*/React__default.createElement(Container$1, {
    className: "collections-menu",
    pose: open ? 'visible' : 'hidden'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "collections-menu__header"
  }, /*#__PURE__*/React__default.createElement("h6", {
    className: "collections-menu__title"
  }, title), /*#__PURE__*/React__default.createElement("button", {
    className: "collections-menu__close",
    onClick: closeMenu
  }, /*#__PURE__*/React__default.createElement(SvgClose, null))), /*#__PURE__*/React__default.createElement("ul", {
    className: "collections-menu__list-container"
  }, children.map(function (Link, idx) {
    return /*#__PURE__*/React__default.createElement(Item, {
      key: "group__" + idx,
      className: "collections-menu__list-item"
    }, Link);
  })));
};

var ItemBlockPreview = function ItemBlockPreview(props) {
  var children = props.children,
    _props$modifier = props.modifier,
    modifier = _props$modifier === void 0 ? 'primary' : _props$modifier,
    _props$title = props.title,
    title = _props$title === void 0 ? '' : _props$title;
  return /*#__PURE__*/React__default.createElement("button", _extends({
    className: "item-block-preview item-block-preview--" + modifier
  }, props), !!title && /*#__PURE__*/React__default.createElement("h6", {
    className: "item-block-preview__title"
  }, title), /*#__PURE__*/React__default.createElement("div", {
    className: "item-block-preview__img"
  }, children));
};

var Container$2 = /*#__PURE__*/posed.div({
  exit: {
    x: -660,
    transition: {
      duration: 200,
      ease: 'circIn'
    }
  },
  enter: {
    x: 0,
    delayChildren: 150,
    staggerChildren: 50,
    transition: {
      duration: 350,
      ease: 'circOut'
    }
  }
});
var Item$1 = /*#__PURE__*/posed.li({
  exit: {
    x: -50,
    y: -80,
    rotate: 15,
    opacity: 0
  },
  enter: {
    x: 0,
    y: 0,
    rotate: 0,
    opacity: 1,
    transition: {
      default: {
        duration: 450,
        type: 'spring',
        stiffness: 60
      }
    }
  }
});
var VariantsMenu = function VariantsMenu(_ref) {
  var isOpen = _ref.isOpen,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement(Container$2, {
    className: "variants-menu",
    pose: children.length > 0 ? 'enter' : 'exit'
  }, isOpen && /*#__PURE__*/React__default.createElement("ul", {
    className: "variants-menu__list-container"
  }, /*#__PURE__*/React__default.createElement(PoseGroup, null, children.map(function (Link, i) {
    return /*#__PURE__*/React__default.createElement(Item$1, {
      i: i,
      className: "variants-menu__list-item",
      key: "itemblock__" + Link.key
    }, Link);
  }))));
};

function CreateBlockSidebar(props) {
  var isOpen = props.isOpen,
    close = props.close,
    blockList = props.blockList,
    onSelect = props.onSelect,
    onClickNewTemplateBlock = props.onClickNewTemplateBlock,
    title = props.title,
    hideEdpuzzle = props.hideEdpuzzle,
    hideGenially = props.hideGenially,
    hideActivity = props.hideActivity,
    hideFeedbackActivity = props.hideFeedbackActivity;
  var _useState = useState(-1),
    collection = _useState[0],
    setCollection = _useState[1];
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    canCreateFeedbackActivities = _useGeneral.canCreateFeedbackActivities;
  useEffect(function () {
    if (!isOpen) {
      setCollection(-1);
    }
  }, [isOpen]);
  var closeMenu = function closeMenu() {
    close();
    setCollection(-1);
  };
  function _onClickTemplateBlock(templateBlock) {
    // == Creamos el componente Pending
    onSelect && onSelect('pending', 'pending', 'pending', true, function (itemCreated, lessonUpdated) {
      // == Aqui nos notifican cuando se ha creado el item nuevo
      // == Notificamos al servidor que se quiere insertar un bloque template
      // TODO: Adaptar esto
      /*  dispatch(sendAction(insertBlockTemplate({
      "blockTemplateId": templateBlock.id,
      "lesson": lessonUpdated,
      "pendingItemId": itemCreated.id
      }))) */
    });
  }
  var _onClickNewTemplateBlock = function _onClickNewTemplateBlock() {
    closeMenu();
    onClickNewTemplateBlock && onClickNewTemplateBlock();
  };
  var addItemBlock = function addItemBlock(itemBlock) {
    if (itemBlock != null && itemBlock.identity && onSelect) {
      onSelect(itemBlock.identity.type, itemBlock.identity.family, itemBlock.identity.variant);
      // closeMenu(); // Comentado como en el original
    }
  };

  function isShowBlockTemplates() {
    return collection && blockList[collection] && blockList[collection].id === 'blockTemplates';
  }
  if (!blockList) return null;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'create-block-sidebar'
  }, /*#__PURE__*/React__default.createElement(CollectionsMenu, {
    open: isOpen,
    closeMenu: closeMenu,
    title: title || t('editor:create_block_collection_menu_title')
  }, blockList.map(function (group, idx) {
    return /*#__PURE__*/React__default.createElement(AsideMenuButton, {
      selected: idx === collection,
      key: group.id,
      onClick: function onClick() {
        return setCollection(idx);
      }
    }, t(group.id, {
      ns: 'editor'
    }));
  }), !hideActivity && /*#__PURE__*/React__default.createElement(AsideMenuButton, {
    selected: false,
    onClick: function onClick() {
      return addItemBlock({
        identity: {
          type: 'lemonade',
          family: 'lemonade',
          variant: 'Lemonade content guid'
        }
      });
    }
  }, t('editor:lemonade')), !hideFeedbackActivity && canCreateFeedbackActivities && /*#__PURE__*/React__default.createElement(AsideMenuButton, {
    selected: false,
    onClick: function onClick() {
      return addItemBlock({
        identity: {
          type: 'lemonade',
          family: 'lemonade',
          variant: 'Lemonade feedback content guid'
        }
      });
    }
  }, t('editor:feedback_activity')), !hideEdpuzzle && /*#__PURE__*/React__default.createElement(AsideMenuButton, {
    selected: false,
    onClick: function onClick() {
      return addItemBlock({
        identity: {
          type: 'provider',
          family: 'provider',
          variant: 'edpuzzle'
        }
      });
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: img$1,
    alt: 'Edpuzzle'
  }), " edpuzzle"), !hideGenially && /*#__PURE__*/React__default.createElement(AsideMenuButton, {
    selected: false,
    onClick: function onClick() {
      return addItemBlock({
        identity: {
          type: 'provider',
          family: 'provider',
          variant: 'genially'
        }
      });
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: img$2,
    alt: 'Genially'
  }), " genially")), !isShowBlockTemplates() ? /*#__PURE__*/React__default.createElement(VariantsMenu, {
    isOpen: isOpen
  }, collection === -1 ? [] : blockList[collection].blocks.map(function (itemBlock) {
    return /*#__PURE__*/React__default.createElement(ItemBlockPreview, {
      key: itemBlock.caption,
      title: itemBlock.caption,
      onClick: function onClick() {
        return addItemBlock(itemBlock);
      }
    }, /*#__PURE__*/React__default.createElement("img", {
      src: itemBlock.src,
      alt: itemBlock.caption
    }));
  })) : isOpen && /*#__PURE__*/React__default.createElement(BlockTemplatesMenu, {
    onClickNewTemplateBlock: _onClickNewTemplateBlock,
    onClickTemplateBlock: _onClickTemplateBlock
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "create-block-sidebar__background " + (isOpen && 'create-block-sidebar__background--opened'),
    onClick: function onClick() {
      return closeMenu();
    }
  }));
}

var _path$11;
function _extends$1r() { _extends$1r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1r.apply(this, arguments); }
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/createElement("svg", _extends$1r({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$11 || (_path$11 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 17C11.45 17 11 16.55 11 16V12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12V16C13 16.55 12.55 17 12 17ZM11 7V9H13V7H11Z"
  })));
};

function ConfirmDialog(props) {
  var title = props.title,
    message = props.message,
    confirmText = props.confirmText,
    cancelText = props.cancelText,
    onConfirm = props.onConfirm,
    onCancel = props.onCancel;
  return /*#__PURE__*/React__default.createElement(Dialog, {
    isOpen: true,
    onClose: undefined
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-confirm-dialog'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-confirm-dialog__container'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-confirm-dialog__header'
  }, /*#__PURE__*/React__default.createElement(SvgInfo, {
    className: 'mint-confirm-dialog__icon'
  }), /*#__PURE__*/React__default.createElement("h2", {
    className: 'mint-confirm-dialog__title'
  }, title)), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-confirm-dialog__content'
  }, /*#__PURE__*/React__default.createElement("p", {
    className: 'mint-confirm-dialog__message'
  }, message))), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-confirm-dialog__buttons'
  }, onCancel && /*#__PURE__*/React__default.createElement(Button, {
    onClick: onCancel,
    variant: 'secondary'
  }, cancelText), /*#__PURE__*/React__default.createElement(Button, {
    onClick: onConfirm,
    variant: 'primary'
  }, confirmText))));
}

function useLayoutPostSidebar(props) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    enableBackgroundGradient = _useGeneral.enableBackgroundGradient;
  var _useState = useState({});
  return {
    t: t,
    enableBackgroundGradient: enableBackgroundGradient
  };
}

var ImageSrcType;
(function (ImageSrcType) {
  ImageSrcType["POST_BACKGROUND"] = "POST_BACKGROUND";
})(ImageSrcType || (ImageSrcType = {}));

var LayoutPostSidebar = function LayoutPostSidebar(props) {
  var _layout$config5, _layout$config6, _layout$config7;
  var visible = props.visible,
    onClose = props.onClose,
    layout = props.layout,
    onChangePostLayout = props.onChangePostLayout,
    getImageSrcEditor = props.getImageSrcEditor;
  var _useLayoutPostSidebar = useLayoutPostSidebar(),
    t = _useLayoutPostSidebar.t,
    enableBackgroundGradient = _useLayoutPostSidebar.enableBackgroundGradient;
  var handleWidthUpdate = function handleWidthUpdate(width) {
    var newConfig = _extends({}, layout.config);
    // Si el ancho está vacío o es el valor por defecto, eliminamos la propiedad
    if (width === '' || width === 'default-row-width-layout') {
      delete newConfig.defaultRowWidth;
    } else {
      // Si hay un nuevo ancho, lo establecemos
      newConfig.defaultRowWidth = width;
    }
    onChangePostLayout(_extends({}, layout, {
      config: newConfig
    }));
  };
  var handleBackgroundImageUpdate = function handleBackgroundImageUpdate(src) {
    var _layout$config;
    var newConfig = _extends({}, (_layout$config = layout.config) != null ? _layout$config : {});
    if (!src) {
      // Si la imagen está vacía, eliminamos la imagen del background
      if (newConfig.background) {
        delete newConfig.background.backgroundImage;
        // Si no hay backgroundColor, eliminamos todo el background
        if (!newConfig.background.backgroundColor) {
          delete newConfig.background;
        }
      }
    } else {
      // Si hay una nueva imagen, la establecemos
      newConfig.background = _extends({}, newConfig.background || {}, {
        backgroundImage: src
      });
      // Eliminamos el backgroundColor si existe
      if (newConfig.background.backgroundColor) {
        delete newConfig.background.backgroundColor;
      }
    }
    onChangePostLayout(_extends({}, layout, {
      config: newConfig
    }));
  };
  var handleBackgroundColorUpdate = function handleBackgroundColorUpdate(color) {
    var _layout$config2;
    var newConfig = _extends({}, (_layout$config2 = layout.config) != null ? _layout$config2 : {});
    if (!color) {
      // Si el color está vacío, eliminamos el backgroundColor
      if (newConfig.background) {
        delete newConfig.background.backgroundColor;
        // Si no hay backgroundImage, eliminamos todo el background
        if (!newConfig.background.backgroundImage) {
          delete newConfig.background;
        }
      }
    } else {
      // Si hay un nuevo color, lo establecemos
      newConfig.background = _extends({}, newConfig.background || {}, {
        backgroundColor: color
      });
      // Eliminamos la imagen si existe
      if (newConfig.background.backgroundImage) {
        delete newConfig.background.backgroundImage;
      }
    }
    onChangePostLayout(_extends({}, layout, {
      config: newConfig
    }));
  };
  var getSelectedWidth = function getSelectedWidth() {
    var _layout$config3;
    if ((_layout$config3 = layout.config) != null && _layout$config3.defaultRowWidth) {
      return layout.config.defaultRowWidth;
    }
    return '';
  };
  var getSelectedBackground = function getSelectedBackground() {
    var _layout$config4;
    if ((_layout$config4 = layout.config) != null && (_layout$config4 = _layout$config4.background) != null && _layout$config4.backgroundColor) {
      return layout.config.background.backgroundColor;
    }
    return '';
  };
  return /*#__PURE__*/React__default.createElement(FloatingSidebar, {
    title: t('editor:layout_post_sidebar_title'),
    visible: visible,
    onClose: onClose,
    container: 'mint-lesson'
  }, /*#__PURE__*/React__default.createElement(TabsModelA, {
    titleTabsList: [t('editor:row_settings_settings_tab')],
    classNameAdd: 'tabs-sidebar mint-row-post-sidebar'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'tab-settings-sidebar'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'tab-settings-sidebar__content mint-tab-content-settings-sidebar'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'tab-settings-sidebar__content--full-width'
  }, /*#__PURE__*/React__default.createElement(SettingWidth, {
    label: t('editor:layout_post_sidebar_setting_width'),
    width: getSelectedWidth(),
    onChange: handleWidthUpdate,
    defaultWidth: layout == null || (_layout$config5 = layout.config) == null ? void 0 : _layout$config5.defaultRowWidth,
    showInheritOption: true,
    showCustomOption: false,
    widthOptions: [{
      value: '50%',
      label: 'S (50%)'
    }, {
      value: '75%',
      label: 'M (75%)'
    }, {
      value: '100%',
      label: 'L (100%)'
    }]
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'tab-settings-sidebar__content--full-width'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-control'
  }, /*#__PURE__*/React__default.createElement(SettingBackgroundColor, {
    background: getSelectedBackground(),
    onChange: handleBackgroundColorUpdate,
    defaultBackground: layout == null || (_layout$config6 = layout.config) == null ? void 0 : _layout$config6.defaultRowBackground,
    showInheritOption: true,
    enableBackgroundGradient: enableBackgroundGradient
  }))), getImageSrcEditor && /*#__PURE__*/React__default.createElement("div", {
    className: 'tab-settings-sidebar__content--full-width'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-control'
  }, /*#__PURE__*/React__default.createElement("p", {
    className: 'label'
  }, t('Image', {
    ns: 'editor'
  })), getImageSrcEditor(((_layout$config7 = layout.config) == null || (_layout$config7 = _layout$config7.background) == null ? void 0 : _layout$config7.backgroundImage) || '', handleBackgroundImageUpdate, ImageSrcType.POST_BACKGROUND)))))));
};

function usePopupEditorFullscreen(props) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    getSrc = _useGeneral.getSrc;
  var _useState = useState({});
  return {
    t: t,
    getSrc: getSrc
  };
}

var PopupHeader = function PopupHeader(_ref) {
  var content = _ref.content,
    onChangeContent = _ref.onChangeContent,
    getTextHtml = _ref.getTextHtml;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-popup-content-header'
  }, getTextHtml && getTextHtml(content.text, function (newText) {
    onChangeContent(_extends({}, content, {
      text: newText
    }));
  }, "popup-header-" + content.guid, IModesTextHtml.MODE_TEXT_HTML_EDITOR, undefined, undefined, undefined, undefined, undefined, undefined, {
    hideButtonTooltip: true
  }));
};

var PopupText = function PopupText(_ref) {
  var content = _ref.content,
    onChangeContent = _ref.onChangeContent,
    getTextHtml = _ref.getTextHtml;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-popup-content-text'
  }, getTextHtml(content.text, function (newText) {
    onChangeContent(_extends({}, content, {
      text: newText
    }));
  }, "popup-text-" + content.guid, IModesTextHtml.MODE_TEXT_HTML_EDITOR, undefined, undefined, undefined, undefined, undefined, undefined, {
    hideButtonTooltip: true
  }));
};

var PopupMediaImage = function PopupMediaImage(_ref) {
  var _content$media, _content$media2, _content$media3, _content$media4;
  var content = _ref.content,
    onChangeContent = _ref.onChangeContent,
    getMediaEditor = _ref.getMediaEditor,
    getTextHtml = _ref.getTextHtml;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-popup-content-media-image'
  }, getMediaEditor(getTemporalItemBlockFromImage(content == null || (_content$media = content.media) == null ? void 0 : _content$media.image), content == null || (_content$media2 = content.media) == null ? void 0 : _content$media2.image, function (subItemImageUpdate) {
    return onChangeContent(_extends({}, content, {
      media: {
        //Elimino los media que existiera ...content.media,
        image: subItemImageUpdate
      },
      caption: ''
    }));
  }, [ITypeMediaFunctionEditor.IMAGE], {
    onDeleteImage: function onDeleteImage() {
      onChangeContent(_extends({}, content, {
        media: {},
        caption: ''
      }));
    }
  }), (content == null || (_content$media3 = content.media) == null ? void 0 : _content$media3.image) && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", {
    className: 'mint-popup-media__label brand--second'
  }, t('image_alt_text', {
    ns: 'editor'
  })), /*#__PURE__*/React__default.createElement(TextEditorStyledWrapper, null, getTextHtml(content.media.image.alt || '', function (text) {
    var image = content.media.image;
    onChangeContent(_extends({}, content, {
      media: _extends({}, content.media, {
        image: _extends({}, image, {
          alt: text
        })
      }),
      caption: ''
    }));
  }, 'popup-image-alt-text-' + (content == null || (_content$media4 = content.media) == null || (_content$media4 = _content$media4.image) == null ? void 0 : _content$media4.content_guid), IModesTextHtml.MODE_TEXT_HTML_TEXT_EDITOR, t('Type something', {
    ns: 'editor'
  })))), (content == null ? void 0 : content.media.image) && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", {
    className: 'mint-popup-media__label brand--second'
  }, t('image_caption', {
    ns: 'editor'
  })), /*#__PURE__*/React__default.createElement(TextEditorStyledWrapper, null, getTextHtml(content.caption || '', function (text) {
    onChangeContent(_extends({}, content, {
      caption: text
    }));
  }, 'popup-image-caption-' + content.guid, IModesTextHtml.MODE_TEXT_HTML_EDITOR, undefined, undefined, undefined, undefined, undefined, undefined, {
    hideButtonTooltip: true
  }))));
};

var PopupMediaVideo = function PopupMediaVideo(_ref) {
  var _content$media, _content$media2;
  var content = _ref.content,
    onChangeContent = _ref.onChangeContent,
    getMediaEditor = _ref.getMediaEditor,
    getTextHtml = _ref.getTextHtml;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-popup-content-media-video'
  }, getMediaEditor(getTemporalItemBlockFromVideo((_content$media = content.media) == null ? void 0 : _content$media.video), (_content$media2 = content.media) == null ? void 0 : _content$media2.video, function (newMedia) {
    onChangeContent(_extends({}, content, {
      media: {
        //Elimino los media que existiera ...content.media,
        video: newMedia
      },
      caption: ''
    }));
  }, [ITypeMediaFunctionEditor.VIDEO], {
    onDeleteImage: function onDeleteImage() {
      onChangeContent(_extends({}, content, {
        media: {},
        caption: ''
      }));
    }
  }), (content == null ? void 0 : content.media.video) && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", {
    className: 'mint-popup-media__label brand--second'
  }, t('video_caption', {
    ns: 'editor'
  })), /*#__PURE__*/React__default.createElement(TextEditorStyledWrapper, null, getTextHtml(content.caption || '', function (text) {
    onChangeContent(_extends({}, content, {
      caption: text
    }));
  }, 'popup-video-' + content.guid, IModesTextHtml.MODE_TEXT_HTML_EDITOR, undefined, undefined, undefined, undefined, undefined, undefined, {
    hideButtonTooltip: true
  }))));
};

var _g$o;
function _extends$1s() { _extends$1s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1s.apply(this, arguments); }
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/createElement("svg", _extends$1s({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$o || (_g$o = /*#__PURE__*/createElement("g", {
    id: "Icon/Solid/link"
  }, /*#__PURE__*/createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/createElement("path", {
    d: "M12.5858 4.58579C13.3668 3.80474 14.6331 3.80474 15.4142 4.58579C16.1952 5.36684 16.1952 6.63316 15.4142 7.41421L12.4142 10.4142C11.6331 11.1953 10.3668 11.1953 9.58577 10.4142C9.19524 10.0237 8.56208 10.0237 8.17156 10.4142C7.78103 10.8047 7.78103 11.4379 8.17156 11.8284C9.73365 13.3905 12.2663 13.3905 13.8284 11.8284L16.8284 8.82843C18.3905 7.26633 18.3905 4.73367 16.8284 3.17157C15.2663 1.60948 12.7337 1.60948 11.1716 3.17157L9.67156 4.67157C9.28103 5.0621 9.28103 5.69526 9.67156 6.08579C10.0621 6.47631 10.6952 6.47631 11.0858 6.08579L12.5858 4.58579Z",
    fill: "#828282"
  }), /*#__PURE__*/createElement("path", {
    d: "M7.58579 9.58579C8.36683 8.80474 9.63316 8.80474 10.4142 9.58579C10.8047 9.97631 11.4379 9.97631 11.8284 9.58579C12.219 9.19526 12.219 8.5621 11.8284 8.17157C10.2663 6.60948 7.73367 6.60948 6.17157 8.17157L3.17157 11.1716C1.60948 12.7337 1.60948 15.2663 3.17157 16.8284C4.73367 18.3905 7.26633 18.3905 8.82843 16.8284L10.3284 15.3284C10.719 14.9379 10.719 14.3047 10.3284 13.9142C9.9379 13.5237 9.30474 13.5237 8.91421 13.9142L7.41421 15.4142C6.63316 16.1953 5.36684 16.1953 4.58579 15.4142C3.80474 14.6332 3.80474 13.3668 4.58579 12.5858L7.58579 9.58579Z",
    fill: "#828282"
  })))));
};

var PopupMediaEmbed = function PopupMediaEmbed(_ref) {
  var _content$media, _content$media2, _content$media3;
  var content = _ref.content,
    onChangeContent = _ref.onChangeContent,
    getMediaEditor = _ref.getMediaEditor,
    getTextHtml = _ref.getTextHtml;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _React$useState = React__default.useState(true),
    forceShowEdit = _React$useState[0];
  var embedEditor = useEmbedEditor({
    initialUrl: ((_content$media = content.media) == null || (_content$media = _content$media.embed) == null ? void 0 : _content$media.originalUrl) || '',
    variant: 'embed',
    onEmbedUpdate: function onEmbedUpdate(title, thumbnail, src, providerUrl, provider, originalUrl, favicon, embedType, description, contentGuid) {
      onChangeContent(_extends({}, content, {
        media: {
          embed: {
            title: title,
            thumbnail: thumbnail,
            src: src,
            providerUrl: providerUrl,
            provider: provider,
            originalUrl: originalUrl,
            favicon: favicon,
            embedType: embedType,
            description: description,
            content_guid: contentGuid
          }
        },
        caption: ''
      }));
    }
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-popup-content-media-embed'
  }, getMediaEditor(getTemporalItemBlockFromEmbed((_content$media2 = content.media) == null ? void 0 : _content$media2.embed), (_content$media3 = content.media) == null ? void 0 : _content$media3.embed, function (newMedia) {
    onChangeContent(_extends({}, content, {
      media: {
        //Elimino los media que existiera ...content.media,
        embed: newMedia
      },
      caption: ''
    }));
  }, [ITypeMediaFunctionEditor.EMBED], {
    onDeleteImage: function onDeleteImage() {
      onChangeContent(_extends({}, content, {
        media: {},
        caption: ''
      }));
    }
  }), embedEditor.showEditUrl || forceShowEdit ? embedEditor.loading ? /*#__PURE__*/React__default.createElement(Loading$7, {
    text: t('Loading', {
      ns: 'editor'
    }),
    theme: ThemesLoading.DARK
  }) : /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-multimedia-embed-sidebar-edit-wrapper'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-multimedia-embed-sidebar-edit-wrapper__title'
  }, t('popup_media_embed_edit_url_title', {
    ns: 'editor'
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "mint-multimedia-embed-sidebar-edit \n              " + (embedEditor.errorEditUrl ? 'mint-multimedia-embed-sidebar-edit--error' : '') + "\n              "
  }, /*#__PURE__*/React__default.createElement(SvgLink, {
    className: 'link-icon'
  }), getTextHtml(embedEditor.textEditUrl, function (text) {
    return embedEditor.onChangeTextEditUrl(text);
  }, 'popup-embed', IModesTextHtml.MODE_TEXT_HTML_TEXT_EDITOR, 'http://...', undefined, undefined, undefined, false), /*#__PURE__*/React__default.createElement("div", {
    className: "mint-multimedia-embed-sidebar-edit__button-add " + (!embedEditor.errorEditUrl ? 'mint-multimedia-embed-sidebar-edit__button-add--active' : 'mint-multimedia-embed-sidebar-edit__button-add--disabled'),
    onClick: function onClick() {
      if (!embedEditor.errorEditUrl && embedEditor.textEditUrl && embedEditor.textEditUrl.length > 0) {
        // Si hay URL válida, procesar el embed
        embedEditor.onEnterDown();
      } else {
        // Si no hay URL, borrar el embed existente
        onChangeContent(_extends({}, content, {
          media: {},
          caption: ''
        }));
      }
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'mint-multimedia-embed-sidebar-edit__button-add-text'
  }, t('embed_button_add', {
    ns: 'editor'
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-multimedia-embed-sidebar-edit__below-text-editor'
  }, embedEditor.errorEditUrl && /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-multimedia-embed-sidebar-edit__error'
  }, t('embed_error_not_valid', {
    ns: 'editor'
  })))) : null);
};

var PopupMediaAudio = function PopupMediaAudio(_ref) {
  var _content$media, _content$media2;
  var content = _ref.content,
    onChangeContent = _ref.onChangeContent,
    getMediaEditor = _ref.getMediaEditor,
    getTextHtml = _ref.getTextHtml;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-popup-content-media-audio'
  }, getMediaEditor(getTemporalItemBlockFromAudio((_content$media = content.media) == null ? void 0 : _content$media.audio), (_content$media2 = content.media) == null ? void 0 : _content$media2.audio, function (newMedia) {
    onChangeContent(_extends({}, content, {
      media: {
        //Elimino los media que existiera ...content.media,
        audio: newMedia
      },
      caption: ''
    }));
  }, [ITypeMediaFunctionEditor.AUDIO], {
    onDeleteImage: function onDeleteImage() {
      onChangeContent(_extends({}, content, {
        media: {},
        caption: ''
      }));
    }
  }), (content == null ? void 0 : content.media.audio) && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", {
    className: 'mint-popup-media__label brand--second'
  }, t('audio_caption', {
    ns: 'editor'
  })), /*#__PURE__*/React__default.createElement(TextEditorStyledWrapper, null, getTextHtml(content.caption || '', function (text) {
    onChangeContent(_extends({}, content, {
      caption: text
    }));
  }, 'popup-audio-caption-' + content.guid, IModesTextHtml.MODE_TEXT_HTML_EDITOR, undefined, undefined, undefined, undefined, undefined, undefined, {
    hideButtonTooltip: true
  }))));
};

var _g$p;
function _extends$1t() { _extends$1t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1t.apply(this, arguments); }
var SvgPhotograph = function SvgPhotograph(props) {
  return /*#__PURE__*/createElement("svg", _extends$1t({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$p || (_g$p = /*#__PURE__*/createElement("g", {
    id: "Icon/Solid/photograph"
  }, /*#__PURE__*/createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3C2.89543 3 2 3.89543 2 5V15C2 16.1046 2.89543 17 4 17H16C17.1046 17 18 16.1046 18 15V5C18 3.89543 17.1046 3 16 3H4ZM16 15H4L8 7L11 13L13 9L16 15Z",
    fill: "#4F4FFF"
  }))));
};

var _g$q;
function _extends$1u() { _extends$1u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1u.apply(this, arguments); }
var SvgVideoCamera = function SvgVideoCamera(props) {
  return /*#__PURE__*/createElement("svg", _extends$1u({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$q || (_g$q = /*#__PURE__*/createElement("g", {
    id: "Icon/Solid/video-camera"
  }, /*#__PURE__*/createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/createElement("path", {
    d: "M2 6C2 4.89543 2.89543 4 4 4H10C11.1046 4 12 4.89543 12 6V14C12 15.1046 11.1046 16 10 16H4C2.89543 16 2 15.1046 2 14V6Z",
    fill: "#828282"
  }), /*#__PURE__*/createElement("path", {
    d: "M14.5528 7.10557C14.214 7.27497 14 7.62123 14 8V12C14 12.3788 14.214 12.725 14.5528 12.8944L16.5528 13.8944C16.8628 14.0494 17.2309 14.0329 17.5257 13.8507C17.8205 13.6684 18 13.3466 18 13V7C18 6.65342 17.8205 6.33156 17.5257 6.14935C17.2309 5.96714 16.8628 5.95058 16.5528 6.10557L14.5528 7.10557Z",
    fill: "#828282"
  })))));
};

var MediaSelectorTab = function MediaSelectorTab(_ref) {
  var icon = _ref.icon,
    label = _ref.label,
    isActive = _ref.isActive,
    onClick = _ref.onClick;
  return /*#__PURE__*/React__default.createElement("button", {
    className: "mint-media-selector-tab " + (isActive ? 'mint-media-selector-tab--active' : ''),
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'mint-media-selector-tab__icon'
  }, icon), /*#__PURE__*/React__default.createElement("span", {
    className: 'mint-media-selector-tab__label'
  }, label));
};

var PopupMediaSelector = function PopupMediaSelector(_ref) {
  var content = _ref.content,
    onChangeContent = _ref.onChangeContent,
    getMediaEditor = _ref.getMediaEditor,
    getSrc = _ref.getSrc,
    getTextHtml = _ref.getTextHtml;
  var getInitialType = function getInitialType() {
    var _content$media, _content$media2, _content$media3, _content$media4;
    if ((_content$media = content.media) != null && _content$media.image) return 'image';
    if ((_content$media2 = content.media) != null && _content$media2.video) return 'video';
    if ((_content$media3 = content.media) != null && _content$media3.embed) return 'embed';
    if ((_content$media4 = content.media) != null && _content$media4.audio) return 'audio';
    return 'image'; // default fallback
  };

  var _React$useState = React__default.useState(getInitialType()),
    selectedType = _React$useState[0],
    setSelectedType = _React$useState[1];
  var renderMediaComponent = function renderMediaComponent() {
    switch (selectedType) {
      case 'image':
        return /*#__PURE__*/React__default.createElement(PopupMediaImage, {
          content: content,
          onChangeContent: onChangeContent,
          getMediaEditor: getMediaEditor,
          getSrc: getSrc,
          getTextHtml: getTextHtml
        });
      case 'video':
        return /*#__PURE__*/React__default.createElement(PopupMediaVideo, {
          content: content,
          onChangeContent: onChangeContent,
          getMediaEditor: getMediaEditor,
          getSrc: getSrc,
          getTextHtml: getTextHtml
        });
      case 'embed':
        return /*#__PURE__*/React__default.createElement(PopupMediaEmbed, {
          content: content,
          onChangeContent: onChangeContent,
          getMediaEditor: getMediaEditor,
          getTextHtml: getTextHtml
        });
      case 'audio':
        return /*#__PURE__*/React__default.createElement(PopupMediaAudio, {
          content: content,
          onChangeContent: onChangeContent,
          getMediaEditor: getMediaEditor,
          getSrc: getSrc,
          getTextHtml: getTextHtml
        });
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-popup-media-selector'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-popup-media-selector__tabs'
  }, /*#__PURE__*/React__default.createElement(MediaSelectorTab, {
    icon: /*#__PURE__*/React__default.createElement(SvgPhotograph, null),
    label: 'Imagen',
    isActive: selectedType === 'image',
    onClick: function onClick() {
      return setSelectedType('image');
    }
  }), /*#__PURE__*/React__default.createElement(MediaSelectorTab, {
    icon: /*#__PURE__*/React__default.createElement(SvgVideoCamera, null),
    label: 'Video',
    isActive: selectedType === 'video',
    onClick: function onClick() {
      return setSelectedType('video');
    }
  }), /*#__PURE__*/React__default.createElement(MediaSelectorTab, {
    icon: /*#__PURE__*/React__default.createElement(SvgLink, null),
    label: 'Embebido',
    isActive: selectedType === 'embed',
    onClick: function onClick() {
      return setSelectedType('embed');
    }
  }), /*#__PURE__*/React__default.createElement(MediaSelectorTab, {
    icon: /*#__PURE__*/React__default.createElement(SvgMicrophone, null),
    label: 'Audio',
    isActive: selectedType === 'audio',
    onClick: function onClick() {
      return setSelectedType('audio');
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-popup-media-selector__content'
  }, renderMediaComponent()));
};

var PopupEditorContent = function PopupEditorContent(_ref) {
  var content = _ref.content,
    onChangeContent = _ref.onChangeContent,
    getTextHtml = _ref.getTextHtml,
    getMediaEditor = _ref.getMediaEditor,
    getSrc = _ref.getSrc;
  var renderContent = function renderContent() {
    switch (content.type) {
      case IPopupContentType.HEADER:
        return /*#__PURE__*/React__default.createElement(PopupHeader, {
          content: content,
          onChangeContent: onChangeContent,
          getTextHtml: getTextHtml
        });
      case IPopupContentType.TEXT:
        return /*#__PURE__*/React__default.createElement(PopupText, {
          content: content,
          onChangeContent: onChangeContent,
          getTextHtml: getTextHtml
        });
      case IPopupContentType.MEDIA:
        return /*#__PURE__*/React__default.createElement(PopupMediaSelector, {
          content: content,
          onChangeContent: onChangeContent,
          getMediaEditor: getMediaEditor,
          getSrc: getSrc,
          getTextHtml: getTextHtml
        });
      default:
        return null;
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "mint-popup-editor-content " + (content.type === IPopupContentType.MEDIA ? 'mint-popup-editor-content--no-border' : '')
  }, renderContent());
};

var WidthSelectorOption = function WidthSelectorOption(_ref) {
  var label = _ref.label,
    isActive = _ref.isActive,
    onClick = _ref.onClick;
  return /*#__PURE__*/React__default.createElement("button", {
    className: "mint-width-selector-option " + (isActive ? 'mint-width-selector-option--active' : ''),
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'mint-width-selector-option__label'
  }, label));
};

var PopupWidth = function PopupWidth(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? DEFAULT_POPUP_WIDTH : _ref$width,
    onChangeWidth = _ref.onChangeWidth;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-popup-width'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-popup-width__label-container'
  }, /*#__PURE__*/React__default.createElement("label", {
    className: 'mint-popup-width__label brand--first'
  }, t('popup_editor_width', {
    ns: 'editor'
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-popup-width__label-help'
  }, /*#__PURE__*/React__default.createElement(TooltipWrapper, {
    componentButton: /*#__PURE__*/React__default.createElement(SvgInformationCircle, null),
    componentTooltip: /*#__PURE__*/React__default.createElement(TooltipContent, {
      text: t('popup_editor_width_help', {
        ns: 'editor'
      })
    }),
    openPortal: false
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-popup-width__options'
  }, /*#__PURE__*/React__default.createElement(WidthSelectorOption, {
    label: 'S (600px)',
    isActive: width === '600px',
    onClick: function onClick() {
      onChangeWidth('600px');
    }
  }), /*#__PURE__*/React__default.createElement(WidthSelectorOption, {
    label: 'M (800px)',
    isActive: width === '800px',
    onClick: function onClick() {
      onChangeWidth('800px');
    }
  }), /*#__PURE__*/React__default.createElement(WidthSelectorOption, {
    label: 'L (1200px)',
    isActive: width === '1200px',
    onClick: function onClick() {
      onChangeWidth('1200px');
    }
  })));
};

var PopupEditorFullscreen = function PopupEditorFullscreen(props) {
  var visible = props.visible,
    onClose = props.onClose,
    itemBlockPopup = props.itemBlockPopup,
    onChangeItemBlockPopup = props.onChangeItemBlockPopup,
    getTextHtml = props.getTextHtml,
    getMediaEditor = props.getMediaEditor;
  var _usePopupEditorFullsc = usePopupEditorFullscreen(),
    t = _usePopupEditorFullsc.t,
    getSrc = _usePopupEditorFullsc.getSrc;
  React__default.useEffect(function () {
    var _itemBlockPopup$popup;
    // Si no hay contenidos, agregamos la estructura por defecto
    if (!((_itemBlockPopup$popup = itemBlockPopup.popup) != null && (_itemBlockPopup$popup = _itemBlockPopup$popup.contents) != null && _itemBlockPopup$popup.length)) {
      onChangeItemBlockPopup(_extends({}, itemBlockPopup, {
        popup: _extends({}, itemBlockPopup.popup, {
          contents: [{
            guid: getGuid(),
            type: IPopupContentType.HEADER,
            text: ''
          }, {
            guid: getGuid(),
            type: IPopupContentType.TEXT,
            text: ''
          }, {
            guid: getGuid(),
            type: IPopupContentType.MEDIA,
            media: {
              image: undefined,
              video: undefined,
              audio: undefined,
              embed: undefined
            }
          }]
        })
      }));
    }
  }, []);
  return /*#__PURE__*/React__default.createElement(FloatingFullscreen, {
    title: t('popup_editor_title', {
      ns: 'editor'
    }),
    visible: visible,
    onClose: onClose,
    container: 'mint-lesson',
    classAdd: 'mint-popup-editor-fullscreen'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-popup-editor-fullscreen__editor-container'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-popup-editor-fullscreen__editor'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-popup-editor__width'
  }, /*#__PURE__*/React__default.createElement(PopupWidth, {
    width: itemBlockPopup.popup.width,
    onChangeWidth: function onChangeWidth(width) {
      onChangeItemBlockPopup(_extends({}, itemBlockPopup, {
        popup: _extends({}, itemBlockPopup.popup, {
          width: width
        })
      }));
    }
  })), /*#__PURE__*/React__default.createElement(EnhancedSortableList, {
    idField: 'guid',
    items: itemBlockPopup.popup.contents,
    alwaysShowControls: true,
    hideOrderArrows: true,
    getItemTitle: function getItemTitle(item) {
      return item.type === IPopupContentType.HEADER ? t('popup_editor_content_header', {
        ns: 'editor'
      }) : item.type === IPopupContentType.TEXT ? t('popup_editor_content_text', {
        ns: 'editor'
      }) : t('popup_editor_content_type_block', {
        ns: 'editor'
      });
    },
    onReorder: function onReorder(itemsReordered) {
      onChangeItemBlockPopup(_extends({}, itemBlockPopup, {
        popup: _extends({}, itemBlockPopup.popup, {
          contents: itemsReordered
        })
      }));
    },
    /*onDelete={itemDelete => {
    onChangeItemBlockPopup({
    ...itemBlockPopup,
    popup: {
      ...itemBlockPopup.popup,
      contents: itemBlockPopup.popup.contents.filter(content => content.guid !== itemDelete.guid),
    },
    });
    }}*/
    renderItem: function renderItem(item, index) {
      return /*#__PURE__*/React__default.createElement(PopupEditorContent, {
        content: item,
        onChangeContent: function onChangeContent(updatedContent) {
          var newContents = [].concat(itemBlockPopup.popup.contents);
          newContents[index] = updatedContent;
          onChangeItemBlockPopup(_extends({}, itemBlockPopup, {
            popup: _extends({}, itemBlockPopup.popup, {
              contents: newContents
            })
          }));
        },
        getTextHtml: getTextHtml,
        getMediaEditor: getMediaEditor,
        getSrc: getSrc
      });
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-popup-editor-fullscreen__preview'
  }, /*#__PURE__*/React__default.createElement(ItemBlockPopupContent, {
    itemBlockPopup: itemBlockPopup,
    isVisor: false,
    onClose: function onClose() {},
    getTextHtml: getTextHtml
  }))));
};

/**
 * Contiene la logica de los posibles modos de edicion de una Leccion
 * @param props
 * @returns
 */
function useSettingsActivitySidebar(props) {
  var item = props.item,
    onChangeItem = props.onChangeItem;
  var _useState = useState(item.isCountForNote || false),
    isCountForNote = _useState[0],
    setIsCountForNote = _useState[1];
  var _useState2 = useState(item.attemptsNumber || ''),
    attemptsNumber = _useState2[0],
    setAttemptsNumber = _useState2[1];
  useEffect(function () {
    setIsCountForNote(item.isCountForNote || false);
    setAttemptsNumber(item.attemptsNumber || '');
  }, [item.isCountForNote, item.attemptsNumber]);
  var onChangeAttempts = function onChangeAttempts(value) {
    var numValue = parseInt(value);
    if (value === '') {
      setAttemptsNumber(value);
      onAttemptsNumberUpdated(numValue, item, onChangeItem);
    } else if (!isNaN(numValue) && numValue >= 1 && numValue <= 10) {
      setAttemptsNumber(value);
      onAttemptsNumberUpdated(numValue, item, onChangeItem);
    }
    // Si no cumple las condiciones, mantener el valor anterior
  };

  var onChangeCountForNote = function onChangeCountForNote(value) {
    setIsCountForNote(value);
    onCountForNoteUpdated(value, item, onChangeItem);
  };
  return {
    onChangeAttempts: onChangeAttempts,
    isCountForNote: isCountForNote,
    attemptsNumber: attemptsNumber,
    onChangeCountForNote: onChangeCountForNote
  };
}

var ToggleSwitch = /*#__PURE__*/React__default.memo(function (_ref) {
  var isChecked = _ref.isChecked,
    onChange = _ref.onChange,
    text = _ref.text,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  var handleToggle = useCallback(function () {
    if (!disabled) {
      onChange(!isChecked);
    }
  }, [disabled, onChange, isChecked]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "toggle-switch " + className
  }, /*#__PURE__*/React__default.createElement("label", {
    className: 'toggle-switch__label'
  }, /*#__PURE__*/React__default.createElement("input", {
    type: 'checkbox',
    checked: isChecked,
    onChange: handleToggle,
    disabled: disabled,
    className: 'toggle-switch__input'
  }), /*#__PURE__*/React__default.createElement("span", {
    className: 'toggle-switch__slider'
  }), /*#__PURE__*/React__default.createElement("span", {
    className: 'toggle-switch__text'
  }, text)));
});
ToggleSwitch.displayName = 'ToggleSwitch';

var EvaluationSection = function EvaluationSection(_ref) {
  var isCountForNote = _ref.isCountForNote,
    onCountForNoteChange = _ref.onCountForNoteChange,
    t = _ref.t;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-activity-sidebar__section'
  }, /*#__PURE__*/React__default.createElement("h5", {
    className: 'settings-activity-sidebar__subsection-title'
  }, t('editor:settings_evaluation_title')), /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-activity-sidebar__toggle-group'
  }, /*#__PURE__*/React__default.createElement(ToggleSwitch, {
    isChecked: isCountForNote,
    onChange: onCountForNoteChange,
    text: t('editor:settings_count_for_note')
  })));
};

var AttemptsSection = function AttemptsSection(_ref) {
  var attemptsNumber = _ref.attemptsNumber,
    onAttemptsChange = _ref.onAttemptsChange,
    t = _ref.t;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-activity-sidebar__section'
  }, /*#__PURE__*/React__default.createElement("h5", {
    className: 'settings-activity-sidebar__subsection-title'
  }, t('editor:settings_attempts_title')), /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-activity-sidebar__setting-group'
  }, /*#__PURE__*/React__default.createElement("input", {
    type: 'number',
    value: attemptsNumber,
    onChange: onAttemptsChange,
    maxLength: 1,
    placeholder: '1',
    className: 'settings-activity-sidebar__input'
  })));
};

var useTagsDropdown = function useTagsDropdown(_ref) {
  var item = _ref.item,
    onChangeItem = _ref.onChangeItem;
  var _useState = useState(item.intelligenceTag || ''),
    selectedTag = _useState[0],
    setSelectedTag = _useState[1];
  useEffect(function () {
    setSelectedTag(item.intelligenceTag || '');
  }, [item == null ? void 0 : item.intelligenceTag]);
  var _useState2 = useState(false),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var dropdownRef = useRef(null);
  var handleTagChange = function handleTagChange(value) {
    setSelectedTag(value);
    setIsOpen(false);
    // Guardar el valor usando el servicio
    onIntelligenceTagUpdated(value, item, onChangeItem);
  };
  var toggleDropdown = function toggleDropdown() {
    setIsOpen(!isOpen);
  };
  var handleClickOutside = function handleClickOutside(event) {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };
  useEffect(function () {
    document.addEventListener('mousedown', handleClickOutside);
    var handleKeyDown = function handleKeyDown(event) {
      if (event.key === 'Escape' && isOpen) {
        setIsOpen(false);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen]);
  return {
    selectedTag: selectedTag,
    isOpen: isOpen,
    dropdownRef: dropdownRef,
    handleTagChange: handleTagChange,
    toggleDropdown: toggleDropdown
  };
};

var TagsSection = function TagsSection(_ref) {
  var _tagOptions$find;
  var item = _ref.item,
    onChangeItem = _ref.onChangeItem,
    t = _ref.t;
  var _useTagsDropdown = useTagsDropdown({
      item: item,
      onChangeItem: onChangeItem
    }),
    selectedTag = _useTagsDropdown.selectedTag,
    isOpen = _useTagsDropdown.isOpen,
    dropdownRef = _useTagsDropdown.dropdownRef,
    handleTagChange = _useTagsDropdown.handleTagChange,
    toggleDropdown = _useTagsDropdown.toggleDropdown;
  var tagOptions = [{
    name: t('editor:exercise'),
    value: 'exercise'
  }, {
    name: t('editor:verification'),
    value: 'verification'
  }, {
    name: t('editor:practice'),
    value: 'practice'
  }];
  var selectedTagName = selectedTag ? (_tagOptions$find = tagOptions.find(function (option) {
    return option.value === selectedTag;
  })) == null ? void 0 : _tagOptions$find.name : t('editor:select');
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-activity-sidebar__section'
  }, /*#__PURE__*/React__default.createElement("h5", {
    className: 'settings-activity-sidebar__subsection-title'
  }, t('editor:intelligence_tag_title')), /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-activity-sidebar__setting-group'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'custom-dropdown',
    ref: dropdownRef
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'custom-dropdown__input',
    onClick: toggleDropdown
  }, /*#__PURE__*/React__default.createElement("span", {
    className: 'custom-dropdown__selected'
  }, selectedTagName), /*#__PURE__*/React__default.createElement("div", {
    className: 'custom-dropdown__arrow'
  })), isOpen && /*#__PURE__*/React__default.createElement("div", {
    className: 'custom-dropdown__menu'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-dropdown__option " + (!selectedTag ? 'custom-dropdown__option--selected' : ''),
    onClick: function onClick() {
      return handleTagChange('');
    }
  }, t('editor:select')), tagOptions.map(function (option) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: option.value,
      className: "custom-dropdown__option " + (selectedTag === option.value ? 'custom-dropdown__option--selected' : ''),
      onClick: function onClick() {
        return handleTagChange(option.value);
      }
    }, option.name);
  })))));
};

var SettingsActivitySidebar = function SettingsActivitySidebar(_ref) {
  var item = _ref.item,
    onChangeItem = _ref.onChangeItem,
    visible = _ref.visible,
    onClose = _ref.onClose;
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    showSettingsActivityIntelligeTag = _useGeneral.showSettingsActivityIntelligeTag;
  var _useSettingsActivityS = useSettingsActivitySidebar({
      item: item,
      onChangeItem: onChangeItem,
      visible: visible,
      onClose: onClose
    }),
    onChangeCountForNote = _useSettingsActivityS.onChangeCountForNote,
    isCountForNote = _useSettingsActivityS.isCountForNote,
    attemptsNumber = _useSettingsActivityS.attemptsNumber,
    onChangeAttempts = _useSettingsActivityS.onChangeAttempts;
  var isManualScoring = isItemLemonadeManualScoring(item);
  var handleCountForNoteChange = function handleCountForNoteChange(checked) {
    onChangeCountForNote(checked);
  };
  var handleAttemptsChange = function handleAttemptsChange(e) {
    onChangeAttempts(e.target.value);
  };
  return /*#__PURE__*/React__default.createElement(FloatingSidebar, {
    title: t('editor:item_option_title_settings'),
    visible: visible,
    onClose: onClose,
    container: 'mint-lesson'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-activity-sidebar'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-activity-sidebar__content'
  }, isManualScoring ? /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-activity-sidebar__manual-scoring'
  }, /*#__PURE__*/React__default.createElement(EvaluationSection, {
    isCountForNote: isCountForNote,
    onCountForNoteChange: handleCountForNoteChange,
    t: t
  })) : /*#__PURE__*/React__default.createElement("div", {
    className: 'settings-activity-sidebar__automatic-scoring'
  }, /*#__PURE__*/React__default.createElement(EvaluationSection, {
    isCountForNote: isCountForNote,
    onCountForNoteChange: handleCountForNoteChange,
    t: t
  }), /*#__PURE__*/React__default.createElement(AttemptsSection, {
    attemptsNumber: attemptsNumber,
    onAttemptsChange: handleAttemptsChange,
    t: t
  }), showSettingsActivityIntelligeTag && /*#__PURE__*/React__default.createElement(TagsSection, {
    item: item,
    onChangeItem: onChangeItem,
    t: t
  })))));
};

var LessonEditor = function LessonEditor(props) {
  var lesson = props.lesson,
    onChangeLesson = props.onChangeLesson,
    mode = props.mode,
    getMediaEditor = props.getMediaEditor,
    getTextHtml = props.getTextHtml,
    getImageSrcEditor = props.getImageSrcEditor,
    getLemonadeEditor = props.getLemonadeEditor,
    getComponentBelowItemsPost = props.getComponentBelowItemsPost,
    getComponentHead = props.getComponentHead,
    prepareOnChangeItem = props.prepareOnChangeItem,
    prepareAddItem = props.prepareAddItem,
    role = props.role,
    _props$showOptionPdfP = props.showOptionPdfPages,
    showOptionPdfPages = _props$showOptionPdfP === void 0 ? true : _props$showOptionPdfP,
    _props$showOptionAudi = props.showOptionAudiosPost,
    showOptionAudiosPost = _props$showOptionAudi === void 0 ? true : _props$showOptionAudi;
  var _useLessonEditor = useLessonEditor({
      lesson: lesson,
      onChangeLesson: onChangeLesson,
      modeLessonEditor: mode,
      role: role
    }),
    t = _useLessonEditor.t,
    posts = _useLessonEditor.posts,
    isEmptyPosts = _useLessonEditor.isEmptyPosts,
    onAddClick = _useLessonEditor.onAddClick,
    onChangePost = _useLessonEditor.onChangePost,
    sidebarEditItem = _useLessonEditor.sidebarEditItem,
    sidebarCreateItem = _useLessonEditor.sidebarCreateItem,
    sidebarAudiosPost = _useLessonEditor.sidebarAudiosPost,
    customEditor = _useLessonEditor.customEditor,
    onSCrollItem = _useLessonEditor.onSCrollItem,
    openSidebarEditItem = _useLessonEditor.openSidebarEditItem,
    openCustomEditor = _useLessonEditor.openCustomEditor,
    closeSidebarEditItem = _useLessonEditor.closeSidebarEditItem,
    openSidebarCreateItem = _useLessonEditor.openSidebarCreateItem,
    closeSidebarCreateItem = _useLessonEditor.closeSidebarCreateItem,
    isShowButtonOpenEditionPost = _useLessonEditor.isShowButtonOpenEditionPost,
    isShowButtonCloseEditionPost = _useLessonEditor.isShowButtonCloseEditionPost,
    onOpenEditionPost = _useLessonEditor.onOpenEditionPost,
    onCloseEditionPost = _useLessonEditor.onCloseEditionPost,
    isModePostEditor = _useLessonEditor.isModePostEditor,
    isShowButtonAddPost = _useLessonEditor.isShowButtonAddPost,
    onUpPost = _useLessonEditor.onUpPost,
    onDownPost = _useLessonEditor.onDownPost,
    onDuplicatePost = _useLessonEditor.onDuplicatePost,
    onDeletePost = _useLessonEditor.onDeletePost,
    onDeleteLayoutPost = _useLessonEditor.onDeleteLayoutPost,
    onEditLayoutPost = _useLessonEditor.onEditLayoutPost,
    onShowAudiosMenu = _useLessonEditor.onShowAudiosMenu,
    onShowRowMenu = _useLessonEditor.onShowRowMenu,
    onChangePdfPages = _useLessonEditor.onChangePdfPages,
    toastRef = _useLessonEditor.toastRef,
    sidebarAudiosPostPost = _useLessonEditor.sidebarAudiosPostPost,
    sidebarEditPostRow = _useLessonEditor.sidebarEditPostRow,
    sidebarEditPostLayout = _useLessonEditor.sidebarEditPostLayout,
    sidebarPopupEditorFullscreen = _useLessonEditor.sidebarPopupEditorFullscreen,
    sidebarSettingsActivity = _useLessonEditor.sidebarSettingsActivity,
    onShowPopupEditorFullscreen = _useLessonEditor.onShowPopupEditorFullscreen,
    shouldShowWarning = _useLessonEditor.shouldShowWarning,
    canMoveDuplicateDeletePost = _useLessonEditor.canMoveDuplicateDeletePost,
    getRowByGuid = _useLessonEditor.getRowByGuid,
    getLayoutByGuid = _useLessonEditor.getLayoutByGuid,
    openSidebarGeneric = _useLessonEditor.openSidebarGeneric,
    closeSidebarGeneric = _useLessonEditor.closeSidebarGeneric,
    confirmDialog = _useLessonEditor.confirmDialog,
    closeConfirmDialog = _useLessonEditor.closeConfirmDialog,
    canShowPostLayoutOptions = _useLessonEditor.canShowPostLayoutOptions,
    onChangeShowOptionsItemBlockColumn = _useLessonEditor.onChangeShowOptionsItemBlockColumn,
    onChangeShowOptionsRow = _useLessonEditor.onChangeShowOptionsRow,
    uiStyles = _useLessonEditor.uiStyles,
    onSettingsActivity = _useLessonEditor.onSettingsActivity;
  var _useTokenStyles = useTokenStyles(uiStyles),
    tokenStyles = _useTokenStyles.tokenStyles;
  return /*#__PURE__*/React__default.createElement(I18nProvider, null, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-lesson brand--second mint-lesson-editor',
    id: 'mint-lesson',
    style: tokenStyles
  }, shouldShowWarning && /*#__PURE__*/React__default.createElement(SinglePostWarning, null), isEmptyPosts ? /*#__PURE__*/React__default.createElement(PostsEditorEmpty, {
    onAddClick: onAddClick
  }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-posts-editor lesson'
  }, posts && /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-posts-editor__content'
  }, posts.map(function (post, index) {
    return /*#__PURE__*/React__default.createElement(WrapperPostModesLessonEditor, {
      key: post.guid,
      showButtonOpenEdition: isShowButtonOpenEditionPost(post),
      showButtonCloseEdition: isShowButtonCloseEditionPost(post),
      onOpenEdition: function onOpenEdition() {
        return onOpenEditionPost(post);
      },
      onCloseEdition: function onCloseEdition() {
        return onCloseEditionPost(post);
      },
      isModePostEditor: isModePostEditor(post),
      onUp: canMoveDuplicateDeletePost && index > 0 ? function () {
        return onUpPost(post);
      } : undefined,
      onDown: canMoveDuplicateDeletePost && index < posts.length - 1 ? function () {
        return onDownPost(post);
      } : undefined,
      onDuplicate: canMoveDuplicateDeletePost ? function () {
        return onDuplicatePost(post);
      } : undefined,
      onDelete: canMoveDuplicateDeletePost ? function () {
        return onDeletePost(post);
      } : undefined,
      onAudios: showOptionAudiosPost ? function () {
        return onShowAudiosMenu(post);
      } : undefined,
      onDeleteLayout: function onDeleteLayout() {
        onDeleteLayoutPost(post);
      },
      onEditLayout: function onEditLayout() {
        return onEditLayoutPost(post);
      },
      enablePostOptions: canSeePostOptions(role),
      pdfPages: post.pdfPages,
      onChangePdfPages: showOptionPdfPages ? function (newPdfPages) {
        return onChangePdfPages(post, newPdfPages);
      } : undefined,
      componentPostEditor: /*#__PURE__*/React__default.createElement(Element$1, {
        name: post.guid,
        key: 'toscroll-' + post.guid
      }, /*#__PURE__*/React__default.createElement(PostEditor, {
        post: post,
        onChangePost: onChangePost,
        onScrollItem: onSCrollItem,
        openSidebarEditItem: openSidebarEditItem,
        openSidebarGeneric: openSidebarGeneric,
        closeSidebarGeneric: closeSidebarGeneric,
        openCustomEditor: openCustomEditor,
        closeSidebarEditItem: closeSidebarEditItem,
        openSidebarCreateItem: openSidebarCreateItem,
        closeSidebarCreateItem: closeSidebarCreateItem,
        getMediaEditor: getMediaEditor,
        getComponentBelowItems: function getComponentBelowItems(isVisible) {
          return getComponentBelowItemsPost ? getComponentBelowItemsPost(post, onChangePost, isModePostEditor(post), isVisible) : null;
        },
        getComponentHead: getComponentHead,
        prepareOnChangeItem: prepareOnChangeItem,
        prepareAddItem: prepareAddItem,
        role: role,
        onShowRowMenu: onShowRowMenu,
        onChangeShowOptionsItemBlockColumn: onChangeShowOptionsItemBlockColumn,
        onChangeShowOptionsRow: onChangeShowOptionsRow,
        onShowPopupEditorFullscreen: onShowPopupEditorFullscreen,
        onSettingsActivity: onSettingsActivity
      })),
      componentPost: /*#__PURE__*/React__default.createElement(Post, {
        post: post,
        getComponentBelowItems: function getComponentBelowItems(isVisible) {
          return getComponentBelowItemsPost ? getComponentBelowItemsPost(post, onChangePost, isModePostEditor(post), isVisible) : null;
        },
        role: role
      }),
      canShowPostLayoutOptions: canShowPostLayoutOptions
    });
  }))), /*#__PURE__*/React__default.createElement(ItemBlockEditorSidebar, {
    t: t,
    visible: sidebarEditItem.isVisible,
    item: sidebarEditItem.item,
    mode: sidebarEditItem.mode,
    onClose: sidebarEditItem.onClose,
    onChangeItem: sidebarEditItem.onChangeItem,
    onDeleteItem: sidebarEditItem.onDeleteItem,
    layoutPosition: sidebarEditItem.layoutPosition,
    layout: sidebarEditItem.layout,
    onChangeLayout: sidebarEditItem.onChangeLayout,
    getMediaEditor: getMediaEditor,
    getLemonadeEditor: getLemonadeEditor,
    closeSidebar: closeSidebarEditItem,
    role: role,
    onShowPopupEditorFullscreen: onShowPopupEditorFullscreen
  }), /*#__PURE__*/React__default.createElement(CreateBlockSidebar, {
    isOpen: sidebarCreateItem.isOpen,
    close: sidebarCreateItem.close,
    blockList: sidebarCreateItem.blockList,
    onSelect: sidebarCreateItem.onSelect,
    onClickNewTemplateBlock: sidebarCreateItem.onClickNewTemplateBlock,
    title: sidebarCreateItem.title,
    hideEdpuzzle: sidebarCreateItem.hideEdpuzzle,
    hideGenially: sidebarCreateItem.hideGenially,
    hideActivity: sidebarCreateItem.hideActivity,
    hideFeedbackActivity: sidebarCreateItem.hideFeedbackActivity
  }), sidebarAudiosPostPost && /*#__PURE__*/React__default.createElement(AudiosPostSidebar, {
    visible: sidebarAudiosPost.isVisible,
    onClose: sidebarAudiosPost.onClose,
    post: sidebarAudiosPostPost,
    onChangePost: sidebarAudiosPost.onChangePost
  }), sidebarEditPostRow && sidebarEditPostRow.rowGuid && sidebarEditPostRow.layoutGuid && /*#__PURE__*/React__default.createElement(RowPostSidebar, {
    visible: sidebarEditPostRow.isVisible,
    onClose: sidebarEditPostRow.onClose,
    layout: getLayoutByGuid(sidebarEditPostRow.layoutGuid),
    row: getRowByGuid(sidebarEditPostRow.rowGuid),
    onChangePostRow: sidebarEditPostRow.onChangePostRow
  }), sidebarEditPostLayout && sidebarEditPostLayout.layoutGuid && /*#__PURE__*/React__default.createElement(LayoutPostSidebar, {
    visible: sidebarEditPostLayout.isVisible,
    onClose: sidebarEditPostLayout.onClose,
    layout: getLayoutByGuid(sidebarEditPostLayout.layoutGuid),
    onChangePostLayout: sidebarEditPostLayout.onChangePostLayout,
    getImageSrcEditor: getImageSrcEditor
  }), sidebarSettingsActivity && sidebarSettingsActivity.item && /*#__PURE__*/React__default.createElement(SettingsActivitySidebar, {
    item: sidebarSettingsActivity.item,
    onChangeItem: sidebarSettingsActivity.onChangeItem,
    visible: sidebarSettingsActivity.isVisible,
    onClose: sidebarSettingsActivity.onClose
  }), sidebarPopupEditorFullscreen.isVisible && sidebarPopupEditorFullscreen.itemBlockPopup && sidebarPopupEditorFullscreen.onChangeItemBlockPopup && /*#__PURE__*/React__default.createElement(PopupEditorFullscreen, {
    visible: sidebarPopupEditorFullscreen.isVisible,
    onClose: sidebarPopupEditorFullscreen.onClose,
    itemBlockPopup: sidebarPopupEditorFullscreen.itemBlockPopup,
    onChangeItemBlockPopup: function onChangeItemBlockPopup(itemBlockPopup) {
      sidebarPopupEditorFullscreen.onChangeItemBlockPopup && sidebarPopupEditorFullscreen.onChangeItemBlockPopup(itemBlockPopup);
    },
    getTextHtml: getTextHtml,
    getMediaEditor: getMediaEditor
  }), /*#__PURE__*/React__default.createElement(ItemBlockCustomEditor, {
    t: t,
    visible: customEditor.isVisible,
    item: customEditor.item,
    onChangeItem: customEditor.onChangeItem,
    onDeleteItem: customEditor.onDeleteItem,
    onClose: customEditor.onClose,
    getMediaEditor: getMediaEditor,
    getLemonadeEditor: getLemonadeEditor,
    role: role,
    mode: IModesItemBlock.MODE_EDITOR_FLOATING_SIDEBAR,
    onShowPopupEditorFullscreen: onShowPopupEditorFullscreen
  }), isShowButtonAddPost && /*#__PURE__*/React__default.createElement("div", {
    className: 'float-button'
  }, /*#__PURE__*/React__default.createElement(Button, {
    onClick: onAddClick
  }, /*#__PURE__*/React__default.createElement(SvgAdd, null)))), /*#__PURE__*/React__default.createElement(WrapperToastBottom, null, /*#__PURE__*/React__default.createElement(WithToastForwardRef, {
    ref: toastRef
  })), confirmDialog.isVisible && confirmDialog.title && confirmDialog.message && /*#__PURE__*/React__default.createElement(ConfirmDialog, {
    title: confirmDialog.title,
    message: confirmDialog.message,
    confirmText: confirmDialog.confirmText || '',
    cancelText: confirmDialog.cancelText || '',
    onConfirm: confirmDialog.onConfirm || function () {},
    onCancel: closeConfirmDialog
  })));
};

var ITypeContentEditor;
(function (ITypeContentEditor) {
  ITypeContentEditor["IMAGE"] = "IMAGE";
  ITypeContentEditor["VIDEO"] = "VIDEO";
  ITypeContentEditor["AUDIO"] = "AUDIO";
  ITypeContentEditor["LEMONADE"] = "LEMONADE";
  ITypeContentEditor["EMBED"] = "EMBED";
})(ITypeContentEditor || (ITypeContentEditor = {}));

function useJsonEditor(props) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var _useState = useState(true),
    isValidJson = _useState[0],
    setIsValidJson = _useState[1];
  var _useState2 = useState(true),
    isEmptyJson = _useState2[0],
    setIsEmptyJson = _useState2[1];
  var onChangeJson = props.onChangeJson,
    onInvalidJson = props.onInvalidJson,
    onIsEmptyJson = props.onIsEmptyJson,
    json = props.json;
  function _onChangeJson(jsonStringUpdated) {
    if (jsonStringUpdated !== null && jsonStringUpdated.trim().length === 0) {
      setIsEmptyJson(true);
      onIsEmptyJson();
    } else {
      setIsEmptyJson(false);
      try {
        var obj = JSON.parse(jsonStringUpdated);
        onChangeJson(obj);
        setIsValidJson(true);
      } catch (error) {
        setIsValidJson(false);
        onInvalidJson(jsonStringUpdated);
      }
    }
  }
  return {
    t: t,
    _json: json ? JSON.stringify(json, undefined, 2) : '',
    _onChangeJson: _onChangeJson,
    isValidJson: isValidJson,
    isEmptyJson: isEmptyJson
  };
}

function JsonEditor(props) {
  var placeholder = props.placeholder,
    _props$isTextUpdatedK = props.isTextUpdatedKeyEnter,
    isTextUpdatedKeyEnter = _props$isTextUpdatedK === void 0 ? false : _props$isTextUpdatedK;
  var _useJsonEditor = useJsonEditor(_extends({}, props)),
    t = _useJsonEditor.t,
    isValidJson = _useJsonEditor.isValidJson,
    isEmptyJson = _useJsonEditor.isEmptyJson,
    _onChangeJson = _useJsonEditor._onChangeJson,
    _json = _useJsonEditor._json;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-json-editor mint-json-editor--' + (!isEmptyJson ? isValidJson ? 'valid' : 'invalid' : '')
  }, /*#__PURE__*/React__default.createElement(TextArea, {
    placeholder: placeholder || '',
    textInput: _json,
    onChange: _onChangeJson,
    isTextUpdatedKeyEnter: isTextUpdatedKeyEnter
  }), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-json-editor__valid-text'
  }, !isEmptyJson ? isValidJson ? t('Validado y guardado!') : t('Invalido, no guardado') : ''));
}

var ASSISTANT_DEFAULT = {
  text: '',
  status: '',
  audio: ''
};
function useAssistantEditor(props) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t;
  var onChangePost = props.onChangePost,
    post = props.post;
  function isEqualsAssistantContent(assistantJson1, assistantJson2) {
    var isEquals = false;
    try {
      isEquals = JSON.stringify(assistantJson1) === JSON.stringify(assistantJson2);
    } catch (error) {}
    return isEquals;
  }
  function onChangeAssistant(assistantUpdate) {
    !isEqualsAssistantContent(ASSISTANT_DEFAULT, assistantUpdate) && onChangePost && onChangePost(_extends({}, post, {
      assistent: assistantUpdate
    }));
  }
  function onInvalidJsonAssistant(jsonString) {
    // == Si queremos hacer algo cuando sea invalido
  }
  function onIsEmptyJsonAssistant() {
    onChangePost && onChangePost(_extends({}, post, {
      assistent: null
    }));
  }
  return {
    t: t,
    assistant: post.assistent || ASSISTANT_DEFAULT,
    onChangeAssistant: onChangeAssistant,
    onInvalidJsonAssistant: onInvalidJsonAssistant,
    onIsEmptyJsonAssistant: onIsEmptyJsonAssistant
  };
}

function AssistantEditor(props) {
  var _useAssistantEditor = useAssistantEditor(_extends({}, props)),
    t = _useAssistantEditor.t,
    assistant = _useAssistantEditor.assistant,
    onChangeAssistant = _useAssistantEditor.onChangeAssistant,
    onInvalidJsonAssistant = _useAssistantEditor.onInvalidJsonAssistant,
    onIsEmptyJsonAssistant = _useAssistantEditor.onIsEmptyJsonAssistant;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-assistant-editor'
  }, /*#__PURE__*/React__default.createElement("p", {
    className: 'label'
  }, t('Assistant')), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-assistant-editor__textarea'
  }, /*#__PURE__*/React__default.createElement(JsonEditor, {
    json: assistant,
    onChangeJson: onChangeAssistant,
    onInvalidJson: onInvalidJsonAssistant,
    onIsEmptyJson: onIsEmptyJsonAssistant
  })));
}

function useContentEditor(props) {
  var _useGeneral = useGeneral(),
    t = _useGeneral.t,
    getSrc = _useGeneral.getSrc;
  var subItemContent = props.subItemContent,
    handleGetContent = props.handleGetContent,
    onChangeContent = props.onChangeContent,
    allowedTypes = props.allowedTypes;
  var _useState = useState(getDefaultContentGuid()),
    contentGuid = _useState[0],
    setContentGuid = _useState[1];
  var _useState2 = useState(null),
    errorSave = _useState2[0],
    setErrorSave = _useState2[1];
  useEffect(function () {
    setErrorSave(null);
  }, [contentGuid]);
  useEffect(function () {
    setContentGuid(getDefaultContentGuid());
  }, [JSON.stringify(subItemContent)]);
  function getDefaultContentGuid() {
    if (subItemContent && subItemContent.content_guid) {
      return subItemContent.content_guid;
    } else return '';
  }
  function onSave() {
    if (handleGetContent) {
      handleGetContent(contentGuid, allowedTypes, function (data) {
        onChangeContent(_extends({}, data));
      }, function (error) {
        setErrorSave(error);
      });
    }
  }
  function onChangeGuid(text) {
    setContentGuid(text);
  }
  return {
    t: t,
    onSave: onSave,
    guid: contentGuid,
    onChangeGuid: onChangeGuid,
    errorSave: errorSave,
    getSrc: getSrc
  };
}

var ContentEditor = function ContentEditor(props) {
  var onDeleteImage = props.onDeleteImage,
    buttonBottom = props.buttonBottom,
    subItemContent = props.subItemContent;
  var _useContentEditor = useContentEditor(_extends({}, props)),
    t = _useContentEditor.t,
    onSave = _useContentEditor.onSave,
    guid = _useContentEditor.guid,
    onChangeGuid = _useContentEditor.onChangeGuid,
    errorSave = _useContentEditor.errorSave,
    getSrc = _useContentEditor.getSrc;
  var renderPreview = function renderPreview() {
    if (!subItemContent) return null;
    if (isMediaImage(subItemContent) || isMediaAudio(subItemContent) || isMediaVideo(subItemContent) || isMediaEmbed(subItemContent)) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: 'mint-content-editor__preview'
      }, isMediaAudio(subItemContent) && /*#__PURE__*/React__default.createElement(MediaAudio, {
        audio: subItemContent,
        key: subItemContent.key,
        getSrc: getSrc
      }), isMediaImage(subItemContent) && /*#__PURE__*/React__default.createElement(MediaImage, {
        image: subItemContent,
        alt: subItemContent.alt || '',
        key: subItemContent.key,
        enableZoomOnClick: true,
        getSrc: getSrc,
        mode: IModesItemBlock.MODE_VISOR
      }), isMediaVideo(subItemContent) && /*#__PURE__*/React__default.createElement(MediaVideo, {
        video: subItemContent,
        key: subItemContent.key,
        getSrc: getSrc
      }), isMediaEmbed(subItemContent) && /*#__PURE__*/React__default.createElement(MediaEmbed, {
        embed: subItemContent,
        key: subItemContent.key,
        showMetaData: true,
        getSrc: getSrc
      }));
    } else {
      return null;
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-content-editor'
  }, renderPreview(), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-content-editor__input-buttons'
  }, /*#__PURE__*/React__default.createElement(InputText, {
    textInput: guid,
    onChange: onChangeGuid,
    placeholder: t('Media content GUID')
  }), errorSave && /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-content-editor__error'
  }, errorSave), /*#__PURE__*/React__default.createElement(Button, {
    onClick: onSave
  }, /*#__PURE__*/React__default.createElement(SvgCheck, {
    className: 'icon icon-check'
  })), onDeleteImage && /*#__PURE__*/React__default.createElement(Button, {
    onClick: onDeleteImage
  }, /*#__PURE__*/React__default.createElement(SvgTrash$2, null))), buttonBottom && /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-content-editor__button_bottom'
  }, /*#__PURE__*/React__default.createElement(Button, {
    onClick: buttonBottom.onClick
  }, buttonBottom.text)));
};

function useInitializationEditor(props) {
  var config = props.config,
    eventsEditor = props.eventsEditor,
    eventsVisor = props.eventsVisor;
  useInitializationVisor({
    config: config,
    eventsVisor: eventsVisor
  });
  useEffect(function () {
    console.log('Init editor');
    var configFavoriteColors = ConfigGlobalSingleton.getInstance().getConfigFavoriteColors();
    if (configFavoriteColors) {
      // == Hago aqui una unica llamada pidiendo los colores favoritos y me los guardo para posteriormente usarlos en cualquier parte de la aplicacion
      // == La otra opción era hacer una llamada cada vez que me hacen falta los colores, pero puede ser que cuando se los pida no me los devuelva en ese momento, ya seria delegar la responsabilidad al host para que sea él el que haga una unica llamada, persistirlos en su state, y pasarmelos, por tanto voy mejor con esta opción, de hacer yo una unica llamada
      if (configFavoriteColors.getFavoriteColors !== undefined) {
        configFavoriteColors.getFavoriteColors(function (colors) {
          ConfigGlobalSingleton.getInstance().setFavoriteColors(colors);
        }, function (error) {});
      }
    }
    if (config.assetsEditorApi !== ConfigGlobalSingleton.getInstance().getAssetsEditorApi()) ConfigGlobalSingleton.getInstance().setAssetsEditorApi(config == null ? void 0 : config.assetsEditorApi);
    if (config.styleTypeItemBlockOptions !== ConfigGlobalSingleton.getInstance().getStyleTypeItemBlockOptions()) ConfigGlobalSingleton.getInstance().setStyleTypeItemBlockOptions((config == null ? void 0 : config.styleTypeItemBlockOptions) || IStyleTypesItemBlockOptions.DEFAULT);
  }, []);
  useEffect(function () {
    if ((config == null ? void 0 : config.folderBlockDefault) !== ConfigGlobalSingleton.getInstance().getFolderBlockDefault()) ConfigGlobalSingleton.getInstance().setFolderBlockDefault(config == null ? void 0 : config.folderBlockDefault);
  }, [config == null ? void 0 : config.folderBlockDefault]);
  useEffect(function () {
    if ((config == null ? void 0 : config.version) !== ConfigGlobalSingleton.getInstance().getVersion()) ConfigGlobalSingleton.getInstance().setVersion(config == null ? void 0 : config.version);
  }, [config == null ? void 0 : config.version]);
  useEffect(function () {
    if ((config == null ? void 0 : config.addClassSpanBackgroundsEditor) !== ConfigGlobalSingleton.getInstance().getAddClassSpanBackgroundsEditor()) ConfigGlobalSingleton.getInstance().setAddClassSpanBackgroundsEditor(config == null ? void 0 : config.addClassSpanBackgroundsEditor);
  }, [config == null ? void 0 : config.addClassSpanBackgroundsEditor]);
  useEffect(function () {
    if (eventsEditor) ConfigGlobalSingleton.getInstance().setEventsEditor(eventsEditor);
  }, [eventsEditor]);
  useEffect(function () {
    if ((config == null ? void 0 : config.showAdditionalContentsSubItemEditor) !== ConfigGlobalSingleton.getInstance().isShowAdditionalContentsSubItemEditor()) ConfigGlobalSingleton.getInstance().setShowAdditionalContentsSubItemEditor((config == null ? void 0 : config.showAdditionalContentsSubItemEditor) || false);
  }, [config == null ? void 0 : config.showAdditionalContentsSubItemEditor]);
  useEffect(function () {
    if ((config == null ? void 0 : config.canCreateFeedbackActivities) !== ConfigGlobalSingleton.getInstance().isCanCreateFeedbackActivities()) ConfigGlobalSingleton.getInstance().setCanCreateFeedbackActivities((config == null ? void 0 : config.canCreateFeedbackActivities) || false);
  }, [config == null ? void 0 : config.canCreateFeedbackActivities]);
  useEffect(function () {
    if ((config == null ? void 0 : config.showSettingsActivity) !== ConfigGlobalSingleton.getInstance().isShowSettingsActivity()) ConfigGlobalSingleton.getInstance().setShowSettingsActivity((config == null ? void 0 : config.showSettingsActivity) || false);
  }, [config == null ? void 0 : config.showSettingsActivity]);
  useEffect(function () {
    if ((config == null ? void 0 : config.showSettingsActivityIntelligeTag) !== ConfigGlobalSingleton.getInstance().isShowSettingsActivityIntelligeTag()) ConfigGlobalSingleton.getInstance().setShowSettingsActivityIntelligeTag((config == null ? void 0 : config.showSettingsActivityIntelligeTag) || false);
  }, [config == null ? void 0 : config.showSettingsActivityIntelligeTag]);
  return {};
}

function useLessonEditorPlusV1(props) {
  var _config$handles;
  var config = props.config,
    eventsVisor = props.eventsVisor,
    eventsEditor = props.eventsEditor,
    lesson = props.lesson,
    onChangeLesson = props.onChangeLesson;
  useInitializationEditor({
    config: config,
    eventsVisor: eventsVisor,
    eventsEditor: eventsEditor
  });
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var enableHasChangeItem = config && Object.prototype.hasOwnProperty.call(config, 'enableHasChangeItem') ? config.enableHasChangeItem : true;
  function prepareOnChangeItem(item, post) {
    if (enableHasChangeItem) {
      item.has_change = true;
    }
  }
  function prepareAddItem(item, post) {
    if (enableHasChangeItem) {
      item.has_change = true;
    }
  }
  function removeHasChanges() {
    removeHasChangesLesson(lesson);
    onChangeLesson(lesson, IActionOnChange.REMOVE_HAS_CHANGES);
  }
  function overwriteTranslationsByLang(lang, translations) {
    var _getConfig;
    (_getConfig = getConfig()) == null || _getConfig.overwriteTranslationsByLang(lang, translations);
  }
  return {
    handleGetContent: config == null || (_config$handles = config.handles) == null ? void 0 : _config$handles.getContent,
    t: t,
    lang: (config == null ? void 0 : config.lang) || 'en',
    prepareOnChangeItem: prepareOnChangeItem,
    prepareAddItem: prepareAddItem,
    removeHasChanges: removeHasChanges,
    overwriteTranslationsByLang: overwriteTranslationsByLang
  };
}

// LessonEditor al estilo Tangenire
var LessonEditorPlusV1 = /*#__PURE__*/forwardRef(function (props, ref) {
  var _config$showAssistant;
  // == TODO: Quiza en un futuro desde la inicializacion que se diga como queremos que sea la forma en que obtengamos la imagen si esta o la de coger la imagen de disco
  var config = props.config,
    eventsEditor = props.eventsEditor,
    eventsVisor = props.eventsVisor,
    getAssistantVisor = props.getAssistantVisor,
    getComponentHead = props.getComponentHead,
    _props$role = props.role,
    role = _props$role === void 0 ? roleTypes.STUDENT : _props$role,
    lesson = props.lesson,
    onChangeLesson = props.onChangeLesson;
  var showAssistantEditor = (_config$showAssistant = config.showAssistantEditor) != null ? _config$showAssistant : true; // Asigna el valor de config.showAssistantEditor a showAssistantEditor si es que config.showAssistantEditor no es null ni undefined. Si config.showAssistantEditor es null o undefined, entonces showAssistantEditor tomará el valor de true.
  var _useLessonEditorPlusV = useLessonEditorPlusV1({
      lesson: lesson,
      onChangeLesson: onChangeLesson,
      config: config,
      eventsEditor: eventsEditor,
      eventsVisor: eventsVisor
    }),
    handleGetContent = _useLessonEditorPlusV.handleGetContent,
    t = _useLessonEditorPlusV.t,
    lang = _useLessonEditorPlusV.lang,
    prepareOnChangeItem = _useLessonEditorPlusV.prepareOnChangeItem,
    prepareAddItem = _useLessonEditorPlusV.prepareAddItem,
    removeHasChanges = _useLessonEditorPlusV.removeHasChanges,
    overwriteTranslationsByLang = _useLessonEditorPlusV.overwriteTranslationsByLang;
  function getMediaEditor(item, subItemMedia, onChangeMedia, types, extras) {
    return /*#__PURE__*/React__default.createElement(ContentEditor, {
      item: item,
      subItemContent: subItemMedia,
      onChangeContent: onChangeMedia,
      handleGetContent: handleGetContent,
      allowedTypes: getAllowedTypesContentEditor(types),
      onDeleteImage: extras == null ? void 0 : extras.onDeleteImage
    });
  }
  function getImageSrcEditor(src, onUpdate, type) {
    var _backgroundItem$media;
    // Crear item ficticio para el background
    var backgroundItem = {
      id: 'background',
      type: 'background',
      family: 'background',
      variant: 'default',
      settings: {},
      items: [],
      media: {
        image: {
          key: 'background',
          src: src || '',
          thumbnail: src || '',
          originalUrl: src || '',
          type: ITypeSubItemMedia.IMAGE,
          content_guid: ''
        }
      }
    };
    var handleBackgroundImageUpdate = function handleBackgroundImageUpdate(mediaUpdate) {
      if (isMediaImage(mediaUpdate)) {
        onUpdate(mediaUpdate.src);
      }
    };
    return /*#__PURE__*/React__default.createElement(ContentEditor, {
      item: backgroundItem,
      subItemContent: (_backgroundItem$media = backgroundItem.media) == null ? void 0 : _backgroundItem$media.image,
      onChangeContent: handleBackgroundImageUpdate,
      handleGetContent: handleGetContent,
      allowedTypes: getAllowedTypesContentEditor([ITypeMediaFunctionEditor.IMAGE])
    });
  }
  function getAllowedTypesContentEditor(typesMediaEditor) {
    var allowedTypes = [];
    for (var index = 0; index < typesMediaEditor.length; index++) {
      var type = typesMediaEditor[index];
      if (type === ITypeMediaFunctionEditor.IMAGE && allowedTypes.indexOf(ITypeContentEditor.IMAGE) < 0) allowedTypes.push(ITypeContentEditor.IMAGE);
      if (type === ITypeMediaFunctionEditor.AUDIO && allowedTypes.indexOf(ITypeContentEditor.AUDIO) < 0) allowedTypes.push(ITypeContentEditor.AUDIO);
      if (type === ITypeMediaFunctionEditor.VIDEO && allowedTypes.indexOf(ITypeContentEditor.VIDEO) < 0) allowedTypes.push(ITypeContentEditor.VIDEO);
      if (type === ITypeMediaFunctionEditor.EMBED && allowedTypes.indexOf(ITypeContentEditor.EMBED) < 0) allowedTypes.push(ITypeContentEditor.EMBED);
    }
    return allowedTypes;
  }
  function getLemonadeEditor(item, subItemLemonade, onChangeLemonade) {
    var _config$buttonSidebar;
    return /*#__PURE__*/React__default.createElement(ContentEditor, {
      item: item,
      subItemContent: subItemLemonade,
      onChangeContent: onChangeLemonade,
      handleGetContent: handleGetContent,
      allowedTypes: [ITypeContentEditor.LEMONADE],
      buttonBottom: config != null && (_config$buttonSidebar = config.buttonSidebarLemonadeEditor) != null && _config$buttonSidebar.onClick ? {
        text: config.buttonSidebarLemonadeEditor.text,
        onClick: function onClick() {
          var _config$buttonSidebar2;
          return config == null || (_config$buttonSidebar2 = config.buttonSidebarLemonadeEditor) == null ? void 0 : _config$buttonSidebar2.onClick(item, subItemLemonade);
        }
      } : undefined
    });
  }
  function getTextHtml(text, onChangeText, keyItem, mode, placeholder, onEnterDown, onBackAndEmpty, /** editor es el editor de froala por eso tiene puesto any */
  onInitialized, isTextUpdatedKeyEnter, onReady, additionalConfig) {
    return /*#__PURE__*/React__default.createElement(TextHtml, {
      text: text,
      placeholder: placeholder || t('Type something', {
        ns: 'editor'
      }),
      mode: mode,
      textUpdated: onChangeText,
      onEnterDown: onEnterDown,
      onBackAndEmpty: onBackAndEmpty,
      onInitialized: onInitialized,
      lang: lang,
      typeToolbar: role === roleTypes.EDITORIAL ? ITypeFroalaToolbar.MODE_ADVANCED : ITypeFroalaToolbar.MODE_MEDIUM,
      additionalConfig: additionalConfig
    });
  }
  function getComponentBelowItemsPost(post, onChangePost, isModePostEditor, isVisible) {
    function onChangeNote(noteUpdate) {
      onChangePost && onChangePost(_extends({}, post, {
        teacher_notes: noteUpdate
      }));
    }
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, canSeeTeacherNotesEditor(role) && post.teacher_notes /* || isModePostEditor */ &&
    /*#__PURE__*/
    // vamos a dejar de dar soporte a estas notas ocultandolas si no estaban ya configuradas
    React__default.createElement(PostTeacherNotes, {
      note: post.teacher_notes,
      onChangeNote: onChangeNote,
      getTextHtml: getTextHtml,
      modeTextHtml: isModePostEditor ? IModesTextHtml.MODE_TEXT_HTML_EDITOR : IModesTextHtml.MODE_TEXT_HTML_VISOR
    }), isModePostEditor ? showAssistantEditor && canSeeAssistantEditor(role) && /*#__PURE__*/React__default.createElement(AssistantEditor, {
      post: post,
      onChangePost: onChangePost,
      isModePostEditor: isModePostEditor,
      getTextHtml: getTextHtml
    }) : canSeeAssistantVisor(role) && post.assistent && getAssistantVisor && getAssistantVisor(post, isVisible));
  }
  // Exponer los metodos para la instancia del componente
  useImperativeHandle(ref, function () {
    return {
      removeHasChanges: removeHasChanges,
      overwriteTranslationsByLang: overwriteTranslationsByLang
    };
  });
  return /*#__PURE__*/React__default.createElement(LessonEditor, {
    lesson: props.lesson,
    onChangeLesson: props.onChangeLesson,
    getMediaEditor: props.getMediaEditor || getMediaEditor,
    getLemonadeEditor: props.getLemonadeEditor || getLemonadeEditor,
    getImageSrcEditor: props.getImageSrcEditor || getImageSrcEditor,
    getComponentBelowItemsPost: getComponentBelowItemsPost,
    getComponentHead: getComponentHead,
    prepareOnChangeItem: prepareOnChangeItem,
    prepareAddItem: prepareAddItem,
    role: role,
    mode: IModesLessonEditor.MODE_EDIT_ALL,
    showOptionPdfPages: config.showOptionPdfPages,
    showOptionAudiosPost: config.showOptionAudiosPost,
    getTextHtml: getTextHtml
  });
});

var useLessonEditorPlusV1Lib = function useLessonEditorPlusV1Lib() {
  var myComponenteRef = useRef(null);
  var MintLessonEditorPlusV1Component = useCallback(function (props) {
    return /*#__PURE__*/React__default.createElement(LessonEditorPlusV1, Object.assign({
      ref: myComponenteRef
    }, props));
  }, []);
  var api = {
    removeHasChanges: removeHasChanges,
    overwriteTranslationsByLang: overwriteTranslationsByLang
  };
  function removeHasChanges() {
    if (myComponenteRef.current) {
      myComponenteRef.current.removeHasChanges();
    }
  }
  function overwriteTranslationsByLang(lang, translations) {
    if (myComponenteRef.current) {
      myComponenteRef.current.overwriteTranslationsByLang(lang, translations);
    }
  }
  return {
    MintLessonEditorPlusV1: MintLessonEditorPlusV1Component,
    api: api
  };
};

function useMintUnit(props) {
  var config = props.config,
    eventsVisor = props.eventsVisor;
  useInitializationVisor({
    config: config,
    eventsVisor: eventsVisor
  });
  return {};
}

function MintUnit(props) {
  useMintUnit(props);
  return /*#__PURE__*/React__default.createElement(Unit, {
    unit: props.unit,
    lessonActive: props.lessonActive,
    getComponentBelowItemsPostLesson: props.getComponentBelowItemsPostLesson,
    getComponentHeadLesson: props.getComponentHeadLesson,
    getComponentFooterLesson: props.getComponentFooterLesson,
    getComponentEmptyPostLesson: props.getComponentEmptyPostLesson,
    onChangeLessonActive: props.onChangeLessonActive,
    role: props.role,
    configSelectionCoords: props.config.selectionCoords,
    configHighlights: props.config.highlights
  });
}

function useMintUnitPlusV1(props) {
  var config = props.config,
    eventsVisor = props.eventsVisor,
    role = props.role,
    getAssistantVisorLesson = props.getAssistantVisorLesson;
  useInitializationVisor({
    config: config,
    eventsVisor: eventsVisor
  });
  var _usePlusV = usePlusV1({
      role: role,
      getAssistantVisorLesson: getAssistantVisorLesson,
      config: config
    }),
    getComponentBelowItemsPostLesson = _usePlusV.getComponentBelowItemsPostLesson;
  return {
    getComponentBelowItemsPostLesson: getComponentBelowItemsPostLesson
  };
}

function MintUnitPlusV1(props) {
  var _useMintUnitPlusV = useMintUnitPlusV1(props),
    getComponentBelowItemsPostLesson = _useMintUnitPlusV.getComponentBelowItemsPostLesson;
  function getComponentRightHeader() {
    return props.onCloseHeader && /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-unit-plus-v1__header-close'
    }, /*#__PURE__*/React__default.createElement(Button, {
      onClick: props.onCloseHeader,
      variant: 'icon'
    }, /*#__PURE__*/React__default.createElement(SvgClose, null)));
  }
  return /*#__PURE__*/React__default.createElement(Unit, {
    unit: props.unit,
    lessonActive: props.lessonActive,
    getComponentBelowItemsPostLesson: getComponentBelowItemsPostLesson,
    getComponentHeadLesson: props.getComponentHeadLesson,
    getComponentFooterLesson: props.getComponentFooterLesson,
    getComponentEmptyPostLesson: props.getComponentEmptyPostLesson,
    onChangeLessonActive: props.onChangeLessonActive,
    role: props.role,
    componentRightHeader: getComponentRightHeader(),
    configSelectionCoords: props.config.selectionCoords,
    configHighlights: props.config.highlights
  });
}

function useMintLessonVisor(props) {
  var config = props.config,
    eventsVisor = props.eventsVisor;
  useInitializationVisor({
    config: config,
    eventsVisor: eventsVisor
  });
  return {};
}

function MintLessonVisor(props) {
  useMintLessonVisor(props);
  return /*#__PURE__*/React__default.createElement(LessonVisor, {
    lesson: props.lesson,
    role: props.role
  });
}

var FooterLms = function FooterLms(_ref) {
  var data = _ref.data,
    onClickButton = _ref.onClickButton,
    textButton = _ref.textButton;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-footer-lms ' + CLASS_NO_SELECT
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-footer-lms__counters'
  }, data.map(function (d) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-footer-lms__counters-col',
      key: d.label
    }, /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-footer-lms__counters-number'
    }, d.count), /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-footer-lms__counters-progress'
    }, /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-footer-lms__counters-progress-bar brand--background',
      style: {
        width: d.percent + "%"
      }
    })), /*#__PURE__*/React__default.createElement("div", {
      className: 'mint-footer-lms__counters-label'
    }, d.label));
  })), /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-footer-lms__button'
  }, /*#__PURE__*/React__default.createElement(Button, {
    className: 'brand--background',
    onClick: onClickButton,
    variant: 'small'
  }, textButton)));
};

var HeaderLms = function HeaderLms(_ref) {
  var mainTitleTab = _ref.mainTitleTab,
    alternativeTitleTab = _ref.alternativeTitleTab,
    children = _ref.children;
  var ref = useRef(null);
  var refAlternative = useRef(null);
  var _useState = useState(0),
    tabActive = _useState[0],
    setTabActibe = _useState[1];
  function showMainContent() {
    var _ref$current, _refAlternative$curre;
    setTabActibe(0);
    if (!children) return;
    var next = ref == null || (_ref$current = ref.current) == null ? void 0 : _ref$current.nextSibling;
    if (next) {
      next.style.display = 'block';
    }
    if (refAlternative != null && (_refAlternative$curre = refAlternative.current) != null && _refAlternative$curre.style) refAlternative.current.style.display = 'none';
  }
  function showAlternativeContent() {
    var _ref$current2, _refAlternative$curre2;
    setTabActibe(1);
    if (!children) return;
    var next = ref == null || (_ref$current2 = ref.current) == null ? void 0 : _ref$current2.nextSibling;
    if (next) {
      next.style.display = 'none';
    }
    if (refAlternative != null && (_refAlternative$curre2 = refAlternative.current) != null && _refAlternative$curre2.style) refAlternative.current.style.display = 'block';
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-header-lms ' + CLASS_NO_SELECT,
    ref: ref
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-header-lms__actions'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'mint-header-lms__actions-tabs'
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "mint-header-lms__actions-tabs__tab " + (tabActive === 0 && 'brand--background'),
    type: 'button',
    onClick: showMainContent
  }, mainTitleTab), /*#__PURE__*/React__default.createElement("button", {
    className: "mint-header-lms__actions-tabs__tab " + (tabActive === 1 && 'brand--background'),
    type: 'button',
    onClick: showAlternativeContent
  }, alternativeTitleTab))), /*#__PURE__*/React__default.createElement("div", {
    ref: refAlternative,
    className: 'mint-header-lms__alternative-view'
  }, children));
};

function useLessonVisorPlusV1(props) {
  var config = props.config,
    eventsVisor = props.eventsVisor;
  useInitializationVisor({
    config: config,
    eventsVisor: eventsVisor
  });
  function overwriteTranslationsByLang(lang, translations) {
    var _getConfig;
    (_getConfig = getConfig()) == null || _getConfig.overwriteTranslationsByLang(lang, translations);
  }
  return {
    overwriteTranslationsByLang: overwriteTranslationsByLang
  };
}

// LessonVisor al estilo Tangenire
var LessonVisorPlusV1 = /*#__PURE__*/forwardRef(function (props, ref) {
  // == TODO: Quiza en un futuro desde la inicializacion que se diga como queremos que sea la forma en que obtengamos la imagen si esta o la de coger la imagen de disco
  var config = props.config,
    eventsVisor = props.eventsVisor,
    lesson = props.lesson,
    getAssistantVisor = props.getAssistantVisor,
    getComponentHead = props.getComponentHead,
    getComponentFooter = props.getComponentFooter,
    getComponentEmptyPost = props.getComponentEmptyPost,
    _props$role = props.role,
    role = _props$role === void 0 ? roleTypes.STUDENT : _props$role;
  var _useLessonVisorPlusV = useLessonVisorPlusV1({
      config: config,
      eventsVisor: eventsVisor
    }),
    overwriteTranslationsByLang = _useLessonVisorPlusV.overwriteTranslationsByLang;
  function getTextHtml(text) {
    return /*#__PURE__*/React__default.createElement(TextHtmlVisor, {
      text: text
    });
  }
  function getComponentBelowItemsPost(post, onChangePost, isModePostEditor, isVisible) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, canSeeTeacherNotesVisor(role) && post.teacher_notes && /*#__PURE__*/React__default.createElement(PostTeacherNotes, {
      note: post.teacher_notes,
      getTextHtml: getTextHtml,
      modeTextHtml: isModePostEditor ? IModesTextHtml.MODE_TEXT_HTML_EDITOR : IModesTextHtml.MODE_TEXT_HTML_VISOR
    }), canSeeAssistantVisor(role) && post.assistent && getAssistantVisor && getAssistantVisor(post, isVisible));
  }
  // Exponer los metodos para la instancia del componente
  useImperativeHandle(ref, function () {
    return {
      overwriteTranslationsByLang: overwriteTranslationsByLang
    };
  });
  return (
    /*#__PURE__*/
    // TODO: este I18nProvider no puede ir dentro del LessonVisor porque se usan cadenas para el highlighter antes de ser inicializado
    React__default.createElement(I18nProvider, null, /*#__PURE__*/React__default.createElement(LessonVisor, {
      lesson: lesson,
      getComponentBelowItemsPost: getComponentBelowItemsPost,
      getComponentHead: getComponentHead,
      getComponentFooter: getComponentFooter,
      getComponentEmptyPost: getComponentEmptyPost,
      role: role,
      configSelectionCoords: config.selectionCoords,
      configHighlights: config.highlights
    }))
  );
});

var useLessonVisorPlusV1Lib = function useLessonVisorPlusV1Lib() {
  var myComponenteRef = useRef(null);
  var MintLessonVisorPlusV1Component = useCallback(function (props) {
    return /*#__PURE__*/React__default.createElement(LessonVisorPlusV1, Object.assign({
      ref: myComponenteRef
    }, props));
  }, []);
  var api = {
    overwriteTranslationsByLang: overwriteTranslationsByLang
  };
  function overwriteTranslationsByLang(lang, translations) {
    if (myComponenteRef.current) {
      myComponenteRef.current.overwriteTranslationsByLang(lang, translations);
    }
  }
  return {
    MintLessonVisorPlusV1: MintLessonVisorPlusV1Component,
    api: api
  };
};

var NAME_PARAM_PATH_JSON = 'data';
/**
 * Devuelve cual es la ruta del fichero json
 * @return Devuelve null si no lo encuentra dicho parametro en la url
 * Ejemplo http://localhost:3003/?id=55&data=jsonUnitTangerine.json => aqui devolveria "jsonUnitTangerine.json"
 */
function getPathJsonDataFromURLSearch() {
  var queryParams = new URLSearchParams(window.location.search);
  var jsonDataParam = queryParams.get(NAME_PARAM_PATH_JSON);
  return jsonDataParam;
}
/**
 * Obtiene el objeto con la información de dicho json y lo devuelve invocando a la función callBack pasada por parametro. Si no lo encuentra en el callBack devolverá null
 * @param pathJson Ruta del fichero json por ejemplo "jsonUnitTangerine.json"
 */
function getJsonFromPath(pathJson, callBack) {
  var jsonDataToRet = null;
  if (pathJson) {
    // == 1) Intento cargar el fichero json con require
    try {
      var jsonData = require(pathJson); //require('../../_dummy/jsonUnitTangerine.json');
      if (jsonData) {
        jsonDataToRet = jsonData;
        callBack(jsonDataToRet);
      }
    } catch (error) {
      console.log('No se puede leer el fichero ', pathJson);
    }
    // == 2) Intento cargar el fichero json con fetch
    if (!jsonDataToRet) {
      fetch(pathJson).then(function (response) {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      }).then(function (jsonData) {
        if (jsonData) jsonDataToRet = jsonData;
        callBack(jsonDataToRet);
      }).catch(function (error) {
        // console.log('No se puede leer el fichero ', pathJson);
        callBack(jsonDataToRet);
      });
    }
  }
}

ignoreSomeErrorAndWarning();
printMintVersion();

export { FooterLms, HeaderLms, IActionOnChange, IMathRenderEngine, IStyleTypesItemBlockOptions, ITypeContentEditor, ITypeMediaFunctionEditor, LANGS_SUPPORT, CoursePlusV1 as MintCoursePlusV1, LessonEditor as MintLessonEditor, LessonEditorPlusV1 as MintLessonEditorPlusV1, MintLessonVisor, LessonVisorPlusV1 as MintLessonVisorPlusV1, MintUnit, MintUnitPlusV1, TypesOfLessonCoursePage, TypesOfMainPage, getAudioFromTangerine, getCourseFromTangerine, getCourseOrUnitFromTangerine, getEmbedFromTangerine, getImageFromTangerine, getJsonFromPath, getLemonadeFromTangerine, getPathJsonDataFromURLSearch, getPostsFromTangerine, getPostsToTangerine, getSrcParam, getSrcParamTangerine, getUnitFromTangerine, getVideoFromTangerine, i18nMint, roleTypes, useLessonEditorPlusV1Lib as useMintLessonEditorPlusV1Lib, useLessonVisorPlusV1Lib as useMintLessonVisorPlusV1Lib };
//# sourceMappingURL=react-mint-editor.esm.js.map
